'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var fs = _interopDefault(require('fs'));
var path = _interopDefault(require('path'));

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */

// HTTP Status Code
var HTTP_STATUS = {
  OK: '200',
  NOT_MODIFIED: '304'
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var get$1 = function get$1(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get$1(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



var set$1 = function set$1(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set$1(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */
var _requestPromise = require('request-promise');

/**
 * Isomorphic Http Promise Requests Class
 * 
 */

var Http = function () {
  function Http() {
    classCallCheck(this, Http);
  }

  createClass(Http, null, [{
    key: 'request',

    /**
     * Request
     * @param   {String}  method
     * @param   {String}  url
     * @param   {Object}  [data]
     * @return  {Promise}
     */
    value: function request(method, url, data, files, useMultipartFormData, showHeader) {
      if (typeof window !== 'undefined' && window.XMLHttpRequest) {
        return Http.xmlHttpRequest(method, url, data);
      }
      return Http.requestPromise(method, url, data, files, useMultipartFormData, showHeader);
    }

    /**
     * XmlHttpRequest request
     * @param   {String}  method
     * @param   {String}  url
     * @param   {Object}  [data]
     * @return  {Promise}
     */

  }, {
    key: 'xmlHttpRequest',
    value: function xmlHttpRequest(method, url, data) {
      return new Promise(function (resolve, reject) {
        var request = new window.XMLHttpRequest();
        request.open(method, url);
        request.onload = function () {
          try {
            var response = JSON.parse(request.response);

            if (request.status.toString() === HTTP_STATUS.OK) {
              resolve(response);
            } else {
              reject(new Error({
                body: response,
                status: request.status
              }));
            }
          } catch (e) {
            reject(new Error({
              body: request.responseText,
              status: request.status
            }));
          }
        };
        request.setRequestHeader('Content-Type', 'application/json');
        request.setRequestHeader('Accept', 'application/json');
        request.send(JSON.stringify(data));
      });
    }

    /**
     * Request Promise
     * @param   {String}  method The HTTP method name (e.g. 'GET').
     * @param   {String}  url A full URL string.
     * @param   {Object}  [data] A mapping of request parameters where a key
     *   is the parameter name and its value is a string or an object
     *   which can be JSON-encoded.
     * @param   {Object}  [files] An optional mapping of file names to ReadStream
     *   objects. These files will be attached to the request.
     * @param   {Boolean} [useMultipartFormData] An optional flag to call with
     *   multipart/form-data.
     * @return  {Promise}
     */

  }, {
    key: 'requestPromise',
    value: function requestPromise(method, url, data, files) {
      var useMultipartFormData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var showHeader = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

      var options = {
        method: method,
        uri: url,
        json: !useMultipartFormData,
        headers: { 'User-Agent': 'fbbizsdk-nodejs-v' + FacebookAdsApi.SDK_VERSION },
        body: Object,
        resolveWithFullResponse: showHeader
      };
      // Prevent null or undefined input
      // because it can be merged with the files argument later
      if (!data) {
        data = {};
      }

      options.body = data;

      // Handle file attachments if provided
      if (useMultipartFormData || files && Object.keys(files).length > 0) {
        // Use formData instead of body (required by the request-promise library)
        options.formData = Object.assign(data, files);
        delete options.body;
      }

      return _requestPromise(options).catch(function (response) {
        throw response;
      });
    }
  }]);
  return Http;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 */

// request-promise error types
var REQUEST_ERROR = 'RequestError';
var STATUS_CODE_ERROR = 'StatusCodeError';

function FacebookError(error) {
  this.name = 'FacebookError';
  this.message = error.message;
  this.stack = new Error().stack;
}
FacebookError.prototype = Object.create(Error.prototype);
FacebookError.prototype.constructor = FacebookError;

/**
 * Raised when an api request fails.
 */
var FacebookRequestError = function (_FacebookError) {
  inherits(FacebookRequestError, _FacebookError);

  /**
   * @param  {[Object}  response
   * @param  {String}   method
   * @param  {String}   url
   * @param  {Object}   data
   */
  function FacebookRequestError(response, method, url, data) {
    classCallCheck(this, FacebookRequestError);

    var errorResponse = constructErrorResponse(response);

    var _this = possibleConstructorReturn(this, (FacebookRequestError.__proto__ || Object.getPrototypeOf(FacebookRequestError)).call(this, errorResponse));

    _this.name = 'FacebookRequestError';
    _this.message = errorResponse.message;
    _this.status = errorResponse.status;
    _this.response = errorResponse.body;
    _this.headers = errorResponse.headers;
    _this.method = method;
    _this.url = url;
    if (data) {
      _this.data = data;
    }
    return _this;
  }

  return FacebookRequestError;
}(FacebookError);

/**
 * Error response has several structures depended on called APIs or errors.
 * This method contructs and formats the response into the same structure for
 * creating a FacebookRequestError object.
 */
function constructErrorResponse(response) {
  var body = void 0;
  var message = void 0;
  var status = void 0;
  var headers = void 0;

  // Batch request error contains code and body fields
  var isBatchResponse = response.code && response.body;

  if (isBatchResponse) {
    // Handle batch response
    body = typeof response.body === 'string' ? JSON.parse(response.body) : response.body;
    status = response.code;
    message = body.error.message;
    headers = response.headers;
  } else {
    // Handle single response
    if (response.name === STATUS_CODE_ERROR) {
      // Handle when we can get response error code
      body = response.error ? response.error : response;
      body = typeof body === 'string' ? JSON.parse(body) : body;
      // Construct an error message from subfields in body.error
      message = body.error.error_user_msg ? body.error.error_user_title + ': ' + body.error.error_user_msg : body.error.message;
      status = response.statusCode;
      if (response.response) {
        headers = response.response.headers;
      }
    } else if (response.name === REQUEST_ERROR) {
      // Handle network errors e.g. timeout, destination unreachable
      body = { error: response.error };
      // An error message is in the response already
      message = response.message;
      // Network errors have no status code
      status = null;
    }
  }

  return { body: body, message: message, status: status, headers: headers };
}

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */
var CrashReporter = function () {
  function CrashReporter() {
    classCallCheck(this, CrashReporter);

    this._active = true;
  }

  createClass(CrashReporter, null, [{
    key: 'enable',
    value: function enable() {
      var _this = this;

      if (this._instance == undefined || this._instance == null) {
        this._instance = new this();
        process.on('uncaughtException', function (err) {
          if (_this._instance._active && err instanceof Error) {
            var params = privateMethods.parseParam(err);
            if (params != null) {
              console.log('CrashReporter: SDK crash detected!');
              privateMethods.processUncaughtException(err, params);
              return;
            }
          }
          console.log('CrashReporter: No SDK crash detected or crash reporter is disabled!');
          throw err;
        });
      }
    }
  }, {
    key: 'disable',
    value: function disable() {
      if (this._instance == undefined || this._instance == null) {
        return;
      }
      this._instance._active = false;
    }
  }]);
  return CrashReporter;
}();

var privateMethods = {
  processUncaughtException: function processUncaughtException(err, params) {
    FacebookAdsApi.getDefaultApi().getAppID().then(function (data) {
      if (data["data"] !== undefined && data['data']['app_id'] !== undefined) {
        var appID = data['data']['app_id'];

        console.log("active uncaughtException : " + appID);
        var url = [FacebookAdsApi.GRAPH, FacebookAdsApi.VERSION, appID, 'instruments'].join('/');

        Http.request('POST', url, params).then(function (response) {
          console.log('Successfully sent crash report.');
        }).catch(function (response) {
          console.log('Failed to send crash report.');
        }).then(function () {
          throw err;
        });
      }
    }).catch(function (error) {
      console.log("Not be able to find appID, fail to send report to server.");
      throw err;
    });
  },
  parseParam: function parseParam(err) {
    var stack = err.stack.split('\n');
    var params = {};

    if (stack.length == 0) {
      return null;
    }

    var fln = stack[0].split(':');
    params['reason'] = fln[0];
    params['callstack'] = stack;
    params['platform'] = process.version;

    for (var i = 0; i < stack.length; i++) {
      if (stack[i].includes('facebook-nodejs-business-sdk')) {
        return { 'bizsdk_crash_report': params };
      }
    }
    return null;
  }
};

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */
/**
 * Facebook Ads API
 */

var FacebookAdsApi = function () {
  createClass(FacebookAdsApi, null, [{
    key: 'VERSION',
    get: function get() {
      return 'v16.0';
    }
  }, {
    key: 'SDK_VERSION',
    get: function get() {
      return '16.0.2';
    }
  }, {
    key: 'GRAPH',
    get: function get() {
      return 'https://graph.facebook.com';
    }
  }, {
    key: 'GRAPH_VIDEO',
    get: function get() {
      return 'https://graph-video.facebook.com';
    }

    /**
     * @param {String} accessToken
     * @param {String} [locale]
     */

  }]);

  function FacebookAdsApi(accessToken) {
    var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
    var crash_log = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    classCallCheck(this, FacebookAdsApi);

    if (!accessToken) {
      throw new Error('Access token required');
    }
    this.accessToken = accessToken;
    this.locale = locale;
    this._debug = false;
    this._showHeader = false;
    if (crash_log) {
      CrashReporter.enable();
    }
  }

  /**
   * Instantiate an API and store it as the default
   * @param  {String} accessToken
   * @param  {String} [locale]
   * @return {FacebookAdsApi}
   */


  createClass(FacebookAdsApi, [{
    key: 'getAppID',
    value: function getAppID() {
      var url = [FacebookAdsApi.GRAPH, FacebookAdsApi.VERSION, 'debug_token'].join('/');
      var params = {};
      params['access_token'] = this.accessToken;
      params['input_token'] = this.accessToken;
      params['fields'] = 'app_id';
      url += '?' + FacebookAdsApi._encodeParams(params);

      return Http.request('GET', url, {}, {}, false);
    }
  }, {
    key: 'setDebug',
    value: function setDebug(flag) {
      this._debug = flag;
      return this;
    }
  }, {
    key: 'setShowHeader',
    value: function setShowHeader(flag) {
      this._showHeader = flag;
      return this;
    }

    /**
     * Http Request
     * @param  {String} method
     * @param  {String} path
     * @param  {Object} [params]
     * @param  {Object} [files]
     * @return {Promise}
     */

  }, {
    key: 'call',
    value: function call(method, path$$1) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var files = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var _this = this;

      var useMultipartFormData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var urlOverride = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

      var url = void 0;
      var data = {};
      if (method === 'POST' || method === 'PUT') {
        data = params;
        params = {};
      }
      var domain = urlOverride || FacebookAdsApi.GRAPH;
      if (typeof path$$1 !== 'string' && !(path$$1 instanceof String)) {
        url = [domain, FacebookAdsApi.VERSION].concat(toConsumableArray(path$$1)).join('/');
        params['access_token'] = this.accessToken;
        url += '?' + FacebookAdsApi._encodeParams(params);
      } else {
        url = path$$1;
      }
      var strUrl = url;
      return Http.request(method, strUrl, data, files, useMultipartFormData, this._showHeader).then(function (response) {
        if (_this._showHeader) {
          response.body['headers'] = response.headers;
          response = response.body;
        }

        if (_this._debug) {
          console.log('200 ' + method + ' ' + url + ' ' + (Object.keys(data).length > 0 ? JSON.stringify(data) : ""));
          console.log('Response: ' + (response ? JSON.stringify(response) : ""));
        }
        return Promise.resolve(response);
      }).catch(function (response) {
        if (_this._debug) {
          console.log(response.statusCode + ' ' + method + ' ' + url + '\n            ' + (Object.keys(data).length > 0 ? JSON.stringify(data) : ''));
        }
        throw new FacebookRequestError(response, method, url, data);
      });
    }
  }], [{
    key: 'init',
    value: function init(accessToken) {
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
      var crash_log = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var api = new this(accessToken, locale, crash_log);
      this.setDefaultApi(api);
      return api;
    }
  }, {
    key: 'setDefaultApi',
    value: function setDefaultApi(api) {
      this._defaultApi = api;
    }
  }, {
    key: 'getDefaultApi',
    value: function getDefaultApi() {
      return this._defaultApi;
    }
  }, {
    key: '_encodeParams',
    value: function _encodeParams(params) {
      return Object.keys(params).map(function (key) {
        var param = params[key];
        if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'object') {
          param = param ? JSON.stringify(param) : '';
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(param);
      }).join('&');
    }
  }]);
  return FacebookAdsApi;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */
/**
 * Represents an API request
 */

var APIRequest = function () {

  /**
   * @param {string} nodeId The node id to perform the api call.
   * @param {string} method The HTTP method of the call.
   * @param {string} endpoint The edge of the api call.
   */
  function APIRequest(nodeId, method, endpoint) {
    classCallCheck(this, APIRequest);

    this._nodeId = nodeId;
    this._method = method;
    this._endpoint = endpoint.replace('/', '');
    this._path = [nodeId, this.endpoint];
    this._fields = [];
    this._fileParams = Object.create(null);
    this._params = Object.create(null);
    this._fileCounter = 0;
  }

  /**
   * Getter function for node ID
   * @return {string} Node ID
   */


  createClass(APIRequest, [{
    key: 'addFile',


    /**
     * @param {string} filePath Path to file attached to the request
     * @return {APIReqeust} APIRequest instance
     */
    value: function addFile(filePath) {
      var fileKey = 'source' + this._fileCounter;
      var stats = fs.lstatSync(filePath);

      if (!stats.isFile()) {
        throw Error('Cannot find file ' + filePath + '!');
      }

      this._fileParams[fileKey] = filePath;
      this._fileCounter += 1;

      return this;
    }

    /**
     * @param {string[]} filePaths Array of paths to files attached to the request
     * @return {APIRequest} APIRequest instance
     */

  }, {
    key: 'addFiles',
    value: function addFiles(filePaths) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = filePaths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var filePath = _step.value;

          this.addFile(filePath);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this;
    }

    /**
     * @param {string} field Requested field
     * @return {APIReqeust} APIRequest instance
     */

  }, {
    key: 'addField',
    value: function addField(field) {
      if (!this._fields.includes(field)) {
        this._fields.push(field);
      }

      return this;
    }

    /**
     * @param {string[]} fields Array of requested fields
     * @return {APIRequest} APIRequest instance
     */

  }, {
    key: 'addFields',
    value: function addFields(fields) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = fields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var field = _step2.value;

          this.addField(field);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return this;
    }

    /**
     * @param {string} key Param key
     * @param {*} value Param value
     * @return {APIRequest} APIRequest instance
     */

  }, {
    key: 'addParam',
    value: function addParam(key, value) {
      this._params[key] = value;

      return this;
    }

    /**
     * @param {Object} params An object containing param keys and values
     * @return {APIRequest} APIRequest instance
     */

  }, {
    key: 'addParams',
    value: function addParams(params) {
      this._params = params;

      return this;
    }
  }, {
    key: 'nodeId',
    get: function get() {
      return this._nodeId;
    }

    /**
     * Getter function for HTTP method e.g. GET, POST
     * @return {string} HTTP method
     */

  }, {
    key: 'method',
    get: function get() {
      return this._method;
    }

    /**
     * Getter function for the edge of the API call
     * @return {string} Endpoint edge
     */

  }, {
    key: 'endpoint',
    get: function get() {
      return this._endpoint;
    }

    /**
     * Getter function for path tokens
     * @return {Array<string>} Array of path tokens
     */

  }, {
    key: 'path',
    get: function get() {
      return this._path;
    }

    /**
     * Getter function for requested fields
     * @return {Array<string>} Array of request fields
     */

  }, {
    key: 'fields',
    get: function get() {
      return this._fields;
    }

    /**
     * Getter function for API params
     * @return {Object} Object containing API Params
     */

  }, {
    key: 'params',
    get: function get() {
      // Deep cloning when object value is not a function
      return JSON.parse(JSON.stringify(this._params));
    }

    /**
     * Getter function for API fileparams
     * @return {Object} Object containing API fileParams
     */

  }, {
    key: 'fileParams',
    get: function get() {
      // Deep cloning when object value is not a function
      return JSON.parse(JSON.stringify(this._fileParams));
    }
  }]);
  return APIRequest;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */

/**
 * Encapsulates an http response from Facebook's Graph API.
 */

var APIResponse = function () {
  function APIResponse(response, call) {
    classCallCheck(this, APIResponse);

    response.body = JSON.parse(response.body);
    this._body = response.body;
    this._httpStatus = response.code;
    this._headers = response.headers;
    this._call = call;
    this._response = response;
  }

  /**
   * @return {Object} The response body
   */


  createClass(APIResponse, [{
    key: 'body',
    get: function get() {
      return this._body;
    }
  }, {
    key: 'headers',
    get: function get() {
      return this._headers;
    }
  }, {
    key: 'etag',
    get: function get() {
      return this._headers['ETag'];
    }
  }, {
    key: 'status',
    get: function get() {
      return this._httpStatus;
    }
  }, {
    key: 'isSuccess',
    get: function get() {
      var body = this._body;

      if ('error' in body) {
        return false;
      } else if (Object.keys(body).length !== 0) {
        if ('success' in body) {
          return body['success'];
        }
        return !('Service Unavailable' in body);
      } else if (this._httpStatus === HTTP_STATUS.NOT_MODIFIED) {
        // ETag Hit
        return true;
      } else if (this._httpStatus === HTTP_STATUS.OK) {
        // HTTP OK
        return true;
      } else {
        // Something else
        return false;
      }
    }
  }, {
    key: 'error',
    get: function get() {
      if (this.isSuccess) {
        return null;
      }

      return new FacebookRequestError(this._response, this._call.method, this._call.relativeUrl, this._call.body);
    }
  }]);
  return APIResponse;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */
/**
 * Facebook Ads API Batch
 */

var FacebookAdsApiBatch = function () {

  /**
   * @param {FacebookAdsApi} api
   * @param {Function} successCallback
   * @param {Function} failureCallback
   */
  function FacebookAdsApiBatch(api, successCallback, failureCallback) {
    classCallCheck(this, FacebookAdsApiBatch);

    this._api = api;
    this._files = [];
    this._batch = [];
    this._requests = [];
    this._successCallbacks = [];
    this._failureCallbacks = [];

    if (successCallback != null) {
      this._successCallbacks.push(successCallback);
    }

    if (failureCallback != null) {
      this._failureCallbacks.push(failureCallback);
    }
  }

  /**
   * Adds a call to the batch.
   * @param  {string} method The HTTP method name (e.g. 'GET').
   * @param  {string[]|string} relativePath An array of path tokens or
   *   a relative URL string. An array will be translated to a url as follows:
   *     <graph url>/<tuple[0]>/<tuple[1]>...
   *   It will be assumed that if the path is not a string, it will be iterable.
   * @param  {Object} [params] A mapping of request parameters
   *   where a key is the parameter name and its value is a string or an object
   *   which can be JSON-encoded.
   * @param {Object} [files] An optional mapping of file names to binary open
   *   file objects. These files will be attached to the request.
   * @param {Function} [successCallback] A callback function which will be
   *   called with the response of this call if the call succeeded.
   * @param {Function} [failureCallback] A callback function which will be
   *   called with the response of this call if the call failed.
   * @param {APIRequest} [request] The APIRequest object
   * @return {Object} An object describing the call
   */


  createClass(FacebookAdsApiBatch, [{
    key: 'add',
    value: function add(method, relativePath, params, files, successCallback, failureCallback, request) {
      // Construct a relaitveUrl from relateivePath by assuming that
      // relativePath can only be a string or an array of strings
      var relativeUrl = typeof relativePath === 'string' ? relativePath : relativePath.join('/');

      // Contruct key-value pairs from params for GET querystring or POST body
      if (params != null) {
        var keyVals = [];

        for (var key in params) {
          var value = params[key];
          if (_typeof(params[key]) === 'object' && !(params[key] instanceof Date)) {
            value = JSON.stringify(value);
          }
          keyVals.push(key + '=' + value);
        }

        if (method === 'GET') {
          relativeUrl += '?' + keyVals.join('&');
        } else {
          var body = keyVals.join('&');
        }

        if (params && params['name']) {
          var name = params['name'];
        }
      }

      // Handle attached files
      if (files != null) {
        var attachedFiles = Object.keys(files).join(',');
      }

      // A Call object that will be used in a batch request
      var call = {
        method: method,
        relative_url: relativeUrl,
        body: body,
        name: name,
        attachedFiles: attachedFiles
      };

      this._batch.push(call);
      this._files.push(files);
      this._successCallbacks.push(successCallback);
      this._failureCallbacks.push(failureCallback);
      if (request !== undefined) {
        this._requests.push(request);
      }

      return call;
    }

    /**
     * Interface to add a APIRequest to the batch.
     * @param  {APIRequest} request The APIRequest object to add
     * @param  {Function} [successCallback] A callback function which
     *   will be called with response of this call if the call succeeded.
     * @param  {Function} [failureCallback] A callback function which
     *   will be called with the FacebookResponse of this call if the call failed.
     * @return {Object} An object describing the call
     */

  }, {
    key: 'addRequest',
    value: function addRequest(request, successCallback, failureCallback) {
      var updatedParams = request.params;
      updatedParams['fields'] = request.fields.join();

      return this.add(request.method, request.path, updatedParams, request.fileParams, successCallback, failureCallback, request);
    }

    /**
     * Makes a batch call to the api associated with this object.
     * For each individual call response, calls the success or failure callback
     * function if they were specified.
     * Note: Does not explicitly raise exceptions. Individual exceptions won't
     * be thrown for each call that fails. The success and failure callback
     * functions corresponding to a call should handle its success or failure.
     * @return {FacebookAdsApiBatch|None} If some of the calls have failed,
     *   returns a new FacebookAdsApiBatch object with those calls.
     *   Otherwise, returns None.
     */

  }, {
    key: 'execute',
    value: function execute() {
      var _this = this;

      if (this._batch.length < 1) {
        return;
      }

      var method = 'POST';
      var path$$1 = []; // request to root domain for a batch request
      var params = {
        batch: this._batch
      };

      // Call to the batch endpoint (WIP)
      return this._api.call(method, path$$1, params).then(function (responses) {
        // Keep track of batch indices that need to retry
        var retryIndices = [];

        // Check each response
        for (var index = 0; index < responses.length; index++) {
          var response = responses[index];

          if (response != null) {
            var apiResponse = new APIResponse(response, _this._batch[index]);

            // Call the success callback if provided
            if (apiResponse.isSuccess) {
              if (_this._successCallbacks[index]) {
                _this._successCallbacks[index](apiResponse);
              }
            } else {
              // Call the failure callback if provided
              if (_this._failureCallbacks[index]) {
                _this._failureCallbacks[index](apiResponse);
              }
            }
          } else {
            // Do not get response, so, we keep track of the index to retry
            retryIndices.push(index);
          }
        }

        // Create and return new batch if we need to retry
        if (retryIndices.length > 0) {
          // Create a new batch from retry indices in the current batch
          var newBatch = new FacebookAdsApiBatch(_this._api);

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = retryIndices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _index = _step.value;

              newBatch._files.push(_this._files[_index]);
              newBatch._batch.push(_this._batch[_index]);
              newBatch._successCallbacks.push(_this._successCallbacks[_index]);
              newBatch._failureCallbacks.push(_this._failureCallbacks[_index]);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return newBatch;
        }

        // No retry
        return null;
      }).catch(function (error) {
        throw error;
      });
    }
  }]);
  return FacebookAdsApiBatch;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Abstract Object
 * Manages object data fields and provides matching properties
 *
 * 
 * @format
 */
var AbstractObject = function () {
  createClass(AbstractObject, null, [{
    key: 'Fields',

    // This is a Flow workaround for setting `this[field]` in the set() function.
    get: function get() {
      return Object.freeze({});
    }
  }]);

  function AbstractObject() {
    var _this = this;

    classCallCheck(this, AbstractObject);

    this._data = {};
    if (this.constructor.Fields === undefined) {
      throw new Error('A "Fields" frozen object must be defined in the object class');
    }
    var fields = this.constructor.Fields;
    this._fields = Object.keys(fields);
    this._fields.forEach(function (field) {
      _this._defineProperty(field);
    });
  }

  /**
   * Define data getter and setter field
   * @param {String} field
   */


  createClass(AbstractObject, [{
    key: '_defineProperty',
    value: function _defineProperty(field) {
      var _this2 = this;

      Object.defineProperty(this, field, {
        get: function get() {
          return _this2._data[field];
        },
        set: function set(value) {
          _this2._data[field] = value;
        },
        enumerable: true
      });
    }

    /**
     * Set data field
     * @param {String} field
     * @param {Mixed} value
     * @return this
     */

  }, {
    key: 'set',
    value: function set(field, value) {
      if (this._fields.indexOf(field) < 0) {
        this._defineProperty(field);
      }
      this[field] = value;
      return this;
    }

    /**
     * Set multiple data fields
     * @param {Object} data
     * @return this
     */

  }, {
    key: 'setData',
    value: function setData(data) {
      var _this3 = this;

      Object.keys(data).forEach(function (key) {
        _this3.set(key, data[key]);
      });
      return this;
    }

    /**
     * Export object data
     * @return {Object}
     */

  }, {
    key: 'exportData',
    value: function exportData() {
      return this._data;
    }
  }]);
  return AbstractObject;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */
var Utils = function () {
  function Utils() {
    classCallCheck(this, Utils);
  }

  createClass(Utils, null, [{
    key: 'normalizeEndpoint',
    value: function normalizeEndpoint(str) {
      return str.replace(/^\/|\/$/g, '');
    }
  }, {
    key: 'removePreceedingSlash',
    value: function removePreceedingSlash(str) {
      return str.length && str[0] === '/' ? str.slice(1) : str;
    }
  }]);
  return Utils;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Cursor
 * Iterates over edge objects and controls pagination
 * 
 * @format
 */
var Cursor = function (_Array) {
  inherits(Cursor, _Array);

  /**
   * @param  {Object} sourceObject
   * @param  {Object} targetClass
   * @param  {Object} [params]
   * @param  {String} [endpoint]
   */
  function Cursor(sourceObject, targetClass, params, endpoint) {
    classCallCheck(this, Cursor);

    var _this = possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this));

    var next = [sourceObject.getId()];
    if (endpoint) {
      next.push(Utils.normalizeEndpoint(endpoint));
    } else {
      throw new Error('No endpoint specified for the target edge.');
    }
    _this._api = sourceObject.getApi();
    _this._targetClass = targetClass;
    _this.paging = { next: next };

    _this.clear = function () {
      _this.length = 0;
    };

    _this.set = function (array) {
      _this.clear();
      _this.push.apply(_this, toConsumableArray(array));
    };

    _this.next = function () {
      if (!_this.hasNext()) {
        return Promise.reject(new RangeError('end of pagination'));
      }
      return _this._loadPage(_this.paging.next);
    };

    _this.hasNext = function () {
      return Boolean(_this.paging) && Boolean(_this.paging.next);
    };

    _this.previous = function () {
      if (!_this.hasPrevious()) {
        return Promise.reject(new RangeError('start of pagination'));
      }
      return _this._loadPage(_this.paging.previous);
    };

    _this.hasPrevious = function () {
      return Boolean(_this.paging) && Boolean(_this.paging.previous);
    };

    _this._loadPage = function (path$$1) {
      var promise = new Promise(function (resolve, reject) {
        _this._api.call('GET', path$$1, params).then(function (response) {
          var objects = _this._buildObjectsFromResponse(response);
          _this.set(objects);
          _this.paging = response.paging;
          _this.summary = response.summary;
          resolve(_this);
        }).catch(reject);
      });
      if (params) {
        params = undefined;
      }
      return promise;
    };

    _this._buildObjectsFromResponse = function (response) {
      return response.data.map(function (item) {
        var That = _this._targetClass;
        if (That.name === 'AbstractObject') {
          var result = new That();
          result.setData(item);
          return result;
        }
        return new That(item && item.id ? item.id : null, item, undefined, _this._api);
      });
    };
    return _this;
  }

  return Cursor;
}(Array);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * @format
 * 
 */
/**
 * Abstract Crud Object
 * Facebook Object basic persistence functions
 * @extends AbstractObject
 * 
 */
var AbstractCrudObject = function (_AbstractObject) {
  inherits(AbstractCrudObject, _AbstractObject);

  /**
   * @param  {Object} data
   * @param  {String} parentId
   * @param  {FacebookAdApi} [api]
   */
  function AbstractCrudObject() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parentId = arguments[2];
    var api = arguments[3];
    classCallCheck(this, AbstractCrudObject);

    var _this = possibleConstructorReturn(this, (AbstractCrudObject.__proto__ || Object.getPrototypeOf(AbstractCrudObject)).call(this));

    _this._parentId = parentId;
    _this._api = api || FacebookAdsApi.getDefaultApi();
    if (id) {
      data.id = id;
    }
    if (data) {
      get$1(AbstractCrudObject.prototype.__proto__ || Object.getPrototypeOf(AbstractCrudObject.prototype), 'setData', _this).call(_this, data);
    }
    return _this;
  }

  /**
   * Define data getter and setter recording changes
   * @param {String} field
   */


  createClass(AbstractCrudObject, [{
    key: '_defineProperty',
    value: function _defineProperty(field) {
      var _this2 = this;

      if (this._changes === undefined) {
        this._changes = {};
      }
      Object.defineProperty(this, field, {
        get: function get() {
          return _this2._data[field];
        },
        set: function set(value) {
          _this2._changes[field] = value;
          _this2._data[field] = value;
        },
        enumerable: true
      });
    }

    /**
     * Set object data as if it were read from the server. Wipes related changes
     * @param {Object} data
     * @return this
     */

  }, {
    key: 'setData',
    value: function setData(data) {
      var _this3 = this;

      get$1(AbstractCrudObject.prototype.__proto__ || Object.getPrototypeOf(AbstractCrudObject.prototype), 'setData', this).call(this, data);
      Object.keys(data).forEach(function (key) {
        delete _this3._changes[key];
      });
      return this;
    }

    /**
     * Export changed object data
     * @return {Object}
     */

  }, {
    key: 'exportData',
    value: function exportData() {
      return this._changes;
    }

    /**
     * Export object data
     * @return {Object}
     */

  }, {
    key: 'exportAllData',
    value: function exportAllData() {
      return this._data;
    }

    /**
     * Clear change history
     * @return this
     */

  }, {
    key: 'clearHistory',
    value: function clearHistory() {
      this._changes = {};
      return this;
    }

    /**
     * @throws {Error} if object has no id
     * @return {String}
     */

  }, {
    key: 'getId',
    value: function getId() {
      if (!this.id) {
        throw new Error(this.constructor.name + ' Id not defined');
      }
      return this.id;
    }

    /**
     * @throws {Error} if object has no parent id
     * @return {String}
     */

  }, {
    key: 'getParentId',
    value: function getParentId() {
      if (!this._parentId) {
        throw new Error(this.constructor.name + ' parentId not defined');
      }
      return this._parentId;
    }

    /**
     * @return {String}
     */

  }, {
    key: 'getNodePath',
    value: function getNodePath() {
      return this.getId();
    }

    /**
     * Return object API instance
     * @throws {Error} if object doesn't hold an API
     * @return {FacebookAdsApi}
     */

  }, {
    key: 'getApi',
    value: function getApi() {
      var api = this._api;
      if (!api) {
        throw new Error(this.constructor.name + ' does not yet have an\n        associated api object.\n Did you forget to\n        instantiate an API session with:\n        "FacebookAdsApi.init"?');
      }
      return api;
    }

    /**
     * Read object data
     * @param   {Array}   [fields]
     * @param   {Object}  [params]
     * @return  {Promise}
     */

  }, {
    key: 'read',
    value: function read(fields) {
      var _this4 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var api = this.getApi();
      var path$$1 = [this.getNodePath()];
      if (fields) {
        params['fields'] = fields.join(',');
      }
      return new Promise(function (resolve, reject) {
        api.call('GET', path$$1, params).then(function (data) {
          return resolve(_this4.setData(data));
        }).catch(reject);
      });
    }

    /**
     * Update object
     * @param   {Object}  [params]
     * @return  {Promise}
     */

  }, {
    key: 'update',
    value: function update() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var api = this.getApi();
      var path$$1 = [this.getNodePath()];
      params = Object.assign(params, this.exportData());
      return new Promise(function (resolve, reject) {
        api.call('POST', path$$1, params).then(function (data) {
          return resolve(data);
        }).catch(reject);
      });
    }

    /**
     * Delete object
     * @param   {Object}  [params]
     * @return  {Promise}
     */

  }, {
    key: 'delete',
    value: function _delete() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var api = this.getApi();
      var path$$1 = [this.getNodePath()];
      params = Object.assign(params, this.exportData());
      return new Promise(function (resolve, reject) {
        api.call('DELETE', path$$1, params).then(function (data) {
          return resolve(data);
        }).catch(reject);
      });
    }

    /**
     * Initialize Cursor to paginate on edges
     * @param  {Object}  targetClass
     * @param  {Array}   [fields]
     * @param  {Object}  [params]
     * @param  {Boolean} [fetchFirstPage]
     * @param  {String}  [endpoint]
     * @return {Cursor}
     */

  }, {
    key: 'getEdge',
    value: function getEdge(targetClass, fields) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var fetchFirstPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var endpoint = arguments[4];

      if (params == null) {
        params = {};
      }
      if (fields) {
        params['fields'] = fields.join(',');
      }
      var sourceObject = this;
      var cursor = new Cursor(sourceObject, targetClass, params, endpoint);
      if (fetchFirstPage) {
        return cursor.next();
      }
      return cursor;
    }

    /**
     * Create edge object
     * @param   {String}  [endpoint]
     * @param   {Array}  [fields]
     * @param   {Object}  [params]
     * @param   {Function} [targetClassConstructor]
     * @return  {Promise}
     */

  }, {
    key: 'createEdge',
    value: function createEdge(endpoint, fields) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var _this5 = this;

      var targetClassConstructor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var pathOverride = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      if (params == null) {
        params = {};
      }
      if (fields && fields.length > 0) {
        params['fields'] = fields.join(',');
      }
      var api = this.getApi();
      var path$$1 = pathOverride != null ? pathOverride : [this.getNodePath(), Utils.removePreceedingSlash(endpoint)];
      params = Object.assign(params, this.exportData());
      return new Promise(function (resolve, reject) {
        api.call('POST', path$$1, params).then(function (data) {
          resolve(
          /* eslint new-cap: "off" */
          targetClassConstructor === null ? _this5.setData(data) : new targetClassConstructor(data.id, data));
        }).catch(reject);
      });
    }

    /**
     * Delete edge object
     * @param   {String}  [endpoint]
     * @param   {Object}  [params]
     * @return  {Promise}
     */

  }, {
    key: 'deleteEdge',
    value: function deleteEdge(endpoint) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var api = this.getApi();
      var path$$1 = [this.getNodePath(), Utils.removePreceedingSlash(endpoint)];
      params = Object.assign(params, this.exportData());
      return new Promise(function (resolve, reject) {
        api.call('DELETE', path$$1, params).then(function (data) {
          return resolve(data);
        }).catch(reject);
      });
    }

    /**
     * Read Objects by Ids
     * @param  {Array}          ids
     * @param  {Array}          [fields]
     * @param  {Object}         [params]
     * @param  {FacebookAdsApi} [api]
     * @return {Promise}
     */

  }], [{
    key: 'getByIds',
    value: function getByIds(ids, fields) {
      var _this6 = this;

      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var api = arguments[3];

      api = api || FacebookAdsApi.getDefaultApi();
      if (fields) {
        params['fields'] = fields.join(',');
      }
      params['ids'] = ids.join(',');
      return new Promise(function (resolve, reject) {
        return api.call('GET', [''], params).then(function (response) {
          var result = [];
          for (var id in response) {
            var data = response[id];
            var That = _this6;
            var object = new That(data);
            result.push(object);
          }
          resolve(result);
        }).catch(reject);
      });
    }
  }]);
  return AbstractCrudObject;
}(AbstractObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * Type of delivery for a purchase event.
 */

var DeliveryCategory = Object.freeze({

  /**
  * Customer needs to enter the store to get the purchased product.
  */
  IN_STORE: 'in_store',

  /**
  * Customer picks up their order by driving to a store and waiting inside their vehicle.
  */
  CURBSIDE: 'curbside',

  /**
  * Purchase is delivered to the customer's home.
  */
  HOME_DELIVERY: 'home_delivery'
});

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

var sha256 = require('js-sha256');
var currency_codes = require('currency-codes');
var country_codes = require('iso-3166-1');

var PHONE_NUMBER_IGNORE_CHAR_SET = /[\-@#<>'",; ]|\(|\)|\+|[a-z]/g;
var PHONE_NUMBER_DROP_PREFIX_ZEROS = /^\+?0{0,2}/;
var US_PHONE_NUMBER_REGEX = /^1\(?\d{3}\)?\d{7}$/;
var INTL_PHONE_NUMBER_REGEX = /^\d{1,4}\(?\d{2,3}\)?\d{4,}$/;
var SHA256_REGEX = /^[a-f0-9]{64}$/;
var MD5_REGEX = /^[a-f0-9]{32}$/;

/**
 * ServerSideUtils contains the Utility modules used for sending Conversions API Events
 */

var ServerSideUtils = function () {
  function ServerSideUtils() {
    classCallCheck(this, ServerSideUtils);
  }

  createClass(ServerSideUtils, null, [{
    key: 'normalizeAndHash',

    /**
     * Normalizes and hashes the input given the field name.
     * @param  {String} [input] Value to be normalized. eg: `foo@bar.com` for email input.
     * @param  {String} [field] Key(Type) of Value to be normalized eg: 'em' for email field.
     * @return {String} Normalized and hashed value for the string.
     */
    value: function normalizeAndHash(input, field) {
      if (field == null || input == null) {
        return null;
      }

      var normalized_input = input.trim().toLowerCase();

      if (normalized_input.length === 0) {
        return null;
      }

      if (normalized_input.match(SHA256_REGEX) || normalized_input.match(MD5_REGEX)) {
        return normalized_input;
      }

      switch (field) {
        case 'country':
          normalized_input = ServerSideUtils.normalizeCountry(normalized_input);
          break;
        case 'ct':
          normalized_input = ServerSideUtils.normalizeCity(normalized_input);
          break;
        case 'em':
          normalized_input = ServerSideUtils.normalizeEmail(normalized_input);
          break;
        case 'ge':
          normalized_input = ServerSideUtils.normalizeGender(normalized_input);
          break;
        case 'ph':
          normalized_input = ServerSideUtils.normalizePhone(normalized_input);
          break;
        case 'st':
          normalized_input = ServerSideUtils.normalizeState(normalized_input);
          break;
        case 'zp':
          normalized_input = ServerSideUtils.normalizeZip(normalized_input);
          break;
        case 'f5first':
        case 'f5last':
          normalized_input = ServerSideUtils.normalizeF5NameField(normalized_input);
          break;
        case 'fi':
          normalized_input = normalized_input.charAt(0);
          break;
        case 'dobd':
          normalized_input = ServerSideUtils.normalizeDobd(normalized_input);
          break;
        case 'dobm':
          normalized_input = ServerSideUtils.normalizeDobm(normalized_input);
          break;
        case 'doby':
          normalized_input = ServerSideUtils.normalizeDoby(normalized_input);
          break;
      }

      // Hashing the normalized input with SHA 256
      var hashed_input = ServerSideUtils.toSHA256(normalized_input);
      return hashed_input;
    }

    /**
     * Normalizes the given country token and returns acceptable two letter ISO country code
     * @param  {String} [country] country value to be normalized.
     * @return {String} Normalized ISO country code.
     */

  }, {
    key: 'normalizeCountry',
    value: function normalizeCountry(country) {
      if (!country_codes.whereAlpha2(country)) {
        throw new Error("Invalid country code: '" + country + "'. Please follow ISO 3166-1 2-letter standard for representing country. eg: US");
      }

      return country;
    }

    /**
     * Normalizes the given city and returns acceptable city value
     * @param  {String} [city] city value to be normalized.
     * @return {String} Normalized city value.
     */

  }, {
    key: 'normalizeCity',
    value: function normalizeCity(city) {
      city = city.replace(/[0-9\s().-]/g, '');
      return city;
    }

    /**
     * Normalizes the given currency string and returns acceptable three letter  ISO code
     * @param  {String} [currency] country value to be normalized.
     * @return {String} Normalized ISO currency code.
     */

  }, {
    key: 'normalizeCurrency',
    value: function normalizeCurrency(currency) {
      currency = currency.trim().toLowerCase();

      // Retain only alpha characters bounded for ISO code.
      currency = currency.replace(/[^a-zA-Z]/g, '');

      if (!currency_codes.codes().includes(currency.toUpperCase())) {
        throw new Error("Invalid format for currency:'" + currency + "'.Please follow ISO 4217 3-letter standard for representing currency. Eg: usd");
      }

      return currency;
    }

    /**
     * Normalizes the given delivery category value and returns a valid string.
     * @param  {String} [input] delivery_category input to be validated.
     * @return {String} Valid delivery_category value.
     */

  }, {
    key: 'normalizeDeliveryCategory',
    value: function normalizeDeliveryCategory(input) {

      var delivery_category = input.trim().toLowerCase();

      if (!Object.values(DeliveryCategory).includes(delivery_category)) {
        throw new Error("Invalid delivery_category passed: " + input + ". Allowed values are one of " + Object.values(DeliveryCategory).join(','));
      }

      return delivery_category;
    }

    /**
     * Normalizes the given email to RFC 822 standard and returns acceptable email value
     * @param  {String} [email] email value to be normalized.
     * @return {String} Normalized email value.
     */

  }, {
    key: 'normalizeEmail',
    value: function normalizeEmail(email) {
      // RFC 2822 REGEX approximation
      var EMAIL_RE = /^[\w!#\$%&'\*\+\/\=\?\^`\{\|\}~\-]+(:?\.[\w!#\$%&'\*\+\/\=\?\^`\{\|\}~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/i;

      if (!EMAIL_RE.test(email)) {
        throw new Error("Invalid email format for the passed email:'" + email + "'.Please check the passed email format.");
      }

      return email;
    }

    /**
     * Normalizes the given gender and returns acceptable('f' or 'm') gender value
     * @param  {String} [gender] gender value to be normalized.
     * @return {String} Normalized gender value.
     */

  }, {
    key: 'normalizeGender',
    value: function normalizeGender(gender) {
      gender = gender.replace(/[^a-z]/g, '');

      if (gender === 'female' || gender === 'f') {
        gender = 'f';
      } else if (gender === 'male' || gender === 'm') {
        gender = 'm';
      } else {
        return null;
      }

      return gender;
    }

    /**
    * Normalizes the 5 character name field.
    * @param  {String} [name] name value to be normalized.
    * @return {String} Normalized 5 character {first,last}name field value.
    */

  }, {
    key: 'normalizeF5NameField',
    value: function normalizeF5NameField(name) {

      return name.length <= 5 ? name : name.substring(0, 5);
    }

    /**
     * Normalizes the given phone and returns acceptable phone value
     * @param  {String} [phone_number] phone number value to be normalized.
     * @return {String} Normalized phone number value.
     */

  }, {
    key: 'normalizePhone',
    value: function normalizePhone(phone_number) {
      // Remove common characters occuring as part of the phone numbers.
      phone_number = phone_number.replace(PHONE_NUMBER_IGNORE_CHAR_SET, '');

      if (ServerSideUtils.isInternationalPhoneNumber(phone_number)) {
        phone_number = phone_number.replace(PHONE_NUMBER_DROP_PREFIX_ZEROS, '');
      }

      if (phone_number.length < 7 || phone_number.length > 15) {
        throw new Error("Invalid phone number format for the passed phone number:'" + phone_number + "'.Please check the passed phone number format.");
      }

      return phone_number;
    }

    /**
     * Normalizes the given state and returns acceptable city value
     * @param  {String} [state] state value to be normalized.
     * @return {String} Normalized state value.
     */

  }, {
    key: 'normalizeState',
    value: function normalizeState(state) {
      state = state.replace(/[0-9\s().-]/g, '');
      return state;
    }

    /**
     * Normalizes the given zip/postal code and returns acceptable zip code value
     * @param  {String} [zip] zip value to be normalized.
     * @return {String} Normalized zip code value.
     */

  }, {
    key: 'normalizeZip',
    value: function normalizeZip(zip) {
      zip = zip.replace(/[\s]/g, '');

      // If the zip code '-', we retain just the first part alone.
      zip = zip.split('-', 1)[0];

      if (zip.length < 2) {
        return null;
      }

      return zip;
    }

    /**
     * Normalizes the given date of birth day
     * @param  {String} [dobd] value to be normalized.
     * @return {String} Normalized value.
     */

  }, {
    key: 'normalizeDobd',
    value: function normalizeDobd(dobd) {
      if (dobd.length === 1) {
        dobd = '0' + dobd;
      }

      var dobd_int = parseInt(dobd);
      if (dobd_int < 1 || dobd_int > 31) {
        throw new Error("Invalid format for dobd:'" + dobd + "'.Please use 'DD' format for dobd.");
      }

      return dobd;
    }

    /**
     * Normalizes the given date of birth month
     * @param  {String} [dobm] value to be normalized.
     * @return {String} Normalized value.
     */

  }, {
    key: 'normalizeDobm',
    value: function normalizeDobm(dobm) {
      if (dobm.length === 1) {
        dobm = '0' + dobm;
      }

      var dobm_int = parseInt(dobm);
      if (dobm_int < 1 || dobm_int > 12) {
        throw new Error("Invalid format for dobm:'" + dobm + "'.Please use 'MM' format for dobm.");
      }

      return dobm;
    }

    /**
     * Normalizes the given date of birth year
     * @param  {String} [doby] value to be normalized.
     * @return {String} Normalized value.
     */

  }, {
    key: 'normalizeDoby',
    value: function normalizeDoby(doby) {
      if (!doby.match(/^[0-9]{4}$/)) {
        throw new Error("Invalid format for doby:'" + doby + "'.Please use 'YYYY' format for doby.");
      }

      return doby;
    }

    /**
     * Boolean method which checks if a given number is represented in international format
     * @param  {String} phone_number that has to be tested.
     * @return {Boolean} value if a number is represented international format
     */

  }, {
    key: 'isInternationalPhoneNumber',
    value: function isInternationalPhoneNumber(phone_number) {
      // strip up to 2 leading 0s and +
      phone_number = phone_number.replace(PHONE_NUMBER_DROP_PREFIX_ZEROS, '');

      if (phone_number.startsWith('0')) {
        return false;
      }

      if (phone_number.startsWith('1')) {
        return US_PHONE_NUMBER_REGEX.test(phone_number);
      }

      return INTL_PHONE_NUMBER_REGEX.test(phone_number);
    }

    /**
     * Calculates the SHA 256 hash of a given non-null string.
     * @param  {String} [input] String to be hashed
     * @return {String} SHA 256 Hash of the string
     */

  }, {
    key: 'toSHA256',
    value: function toSHA256(input) {
      if (input === null) return input;

      return sha256(input);
    }
  }]);
  return ServerSideUtils;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * Content is part of the Custom Data Parameters of a Conversions API Event Request. Content can be used to set the item/product details added in the Custom Data.
 * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data#contents}
 */

var Content = function () {

	/**
  * @param {String} id Product Id of the Item.
  * @param {Number} quantity Quantity of the Item.
  * @param {Number} item_price Price per unit of the content/product.
  * @param {String} title Title of the listed Item.
  * @param {String} description Product description used for the item.
  * @param {String} brand Brand of the item.
  * @param {String} category Category of the Item.
  * @param {String} delivery_category The type of delivery for a purchase event
  */
	function Content(id, quantity, item_price, title, description, brand, category, delivery_category) {
		classCallCheck(this, Content);


		this._id = id;
		this._quantity = quantity;
		this._item_price = item_price;
		this._title = title;
		this._description = description;
		this._brand = brand;
		this._category = category;
		this._delivery_category = delivery_category;
	}

	/**
  * Gets the Product Id of the Item.
  * A string representing the unique Id for the product.
  * Example: XYZ.
  */


	createClass(Content, [{
		key: 'setId',


		/**
  * Sets the Product Id of the Item.
  * @param id is a string representing the unique id for the product.
  * Example: XYZ.
  */
		value: function setId(id) {
			this._id = id;
			return this;
		}

		/**
   * Gets the quantity of the Item.
   * The number/quantity of the content that is being involved in the customer interaction.
   * Example: 5
   */

	}, {
		key: 'setQuantity',


		/**
  * Sets the quantity of the Content/Item.
  * @param {Number} quantity The number/quantity of the product that is being involved in the customer interaction.
  * Example: 5
  */
		value: function setQuantity(quantity) {
			this._quantity = quantity;
			return this;
		}

		/**
   * Gets the item price for the Product.
   * The item_price or price per unit of the product.
   * Example: '123.45'
   */

	}, {
		key: 'setItemPrice',


		/**
  * Sets the item price for the Content.
  * @param {Number} item_price The item_price or price per unit of the product.
  * Example: '123.45'
  */
		value: function setItemPrice(item_price) {
			this._item_price = item_price;
			return this;
		}

		/**
   * Gets the Title of the listed Item.
   * A string representing the Title for the product.
   */

	}, {
		key: 'setTitle',


		/**
  * Sets the Title of the Item.
  * @param title is a string representing listed title for the product.
  */
		value: function setTitle(title) {
			this._title = title;
			return this;
		}

		/**
   * Gets the Description of the listed Item.
   * A string representing the Description for the product.
   */

	}, {
		key: 'setDescription',


		/**
  * Sets the Product Description of the Item.
  * @param description is a string representing the description for the product.
  */
		value: function setDescription(description) {
			this._description = description;
			return this;
		}

		/**
   * Gets the Brand of the listed Item.
   * A string representing the Brand for the product.
   */

	}, {
		key: 'setBrand',


		/**
   * Sets the Brand of the Product.
   * @param brand is a string representing the Brand for the product.
   */
		value: function setBrand(brand) {
			this._brand = brand;
			return this;
		}

		/**
   * Gets the Category of the listed Item.
   * A string representing the Category for the product.
   */

	}, {
		key: 'setCategory',


		/**
   * Sets the Category of the Product.
   * @param category is a string representing the Category for the product.
   */
		value: function setCategory(category) {
			this._category = category;
			return this;
		}

		/**
   * Gets the delivery category.
   */

	}, {
		key: 'setDeliveryCategory',


		/**
   * Sets the type of delivery for a purchase event.
   * @param {String} delivery_category The delivery category.
   */
		value: function setDeliveryCategory(delivery_category) {
			this._delivery_category = delivery_category;
			return this;
		}

		/**
   * Returns the normalized payload for the Content.
   * @returns {Object} normalized Content payload.
   */

	}, {
		key: 'normalize',
		value: function normalize() {
			var content = {};

			if (this.id) {
				content['id'] = this.id;
			}

			if (this.quantity) {
				content['quantity'] = this.quantity;
			}

			if (this.item_price) {
				content['item_price'] = this.item_price;
			}

			if (this.title) {
				content['title'] = this.title;
			}

			if (this.description) {
				content['description'] = this.description;
			}

			if (this.brand) {
				content['brand'] = this.brand;
			}

			if (this.category) {
				content['category'] = this.category;
			}

			if (this.delivery_category) {
				content['delivery_category'] = ServerSideUtils.normalizeDeliveryCategory(this.delivery_category);
			}

			return content;
		}
	}, {
		key: 'id',
		get: function get() {
			return this._id;
		}

		/**
   * Sets the Product Id of the Item.
   * @param id A string representing the unique Id for the product.
   * Example: XYZ.
   */
		,
		set: function set(id) {
			this._id = id;
		}
	}, {
		key: 'quantity',
		get: function get() {
			return this._quantity;
		}

		/**
   * Sets the quantity of the Item.
   * @param quantity The number/quantity of the product that is being involved in the customer interaction.
   * Example: 5
   */
		,
		set: function set(quantity) {
			this._quantity = quantity;
		}
	}, {
		key: 'item_price',
		get: function get() {
			return this._item_price;
		}

		/**
   * Sets the item price for the Content.
   * @param item_price The item_price or price per unit of the product.
   * Example: '123.45'
   */
		,
		set: function set(item_price) {
			this._item_price = item_price;
		}
	}, {
		key: 'title',
		get: function get() {
			return this._title;
		}

		/**
   * Sets the Title of the listed Item.
   * @param title A string representing the Title for the product.
   */
		,
		set: function set(title) {
			this._title = title;
		}
	}, {
		key: 'description',
		get: function get() {
			return this._description;
		}

		/**
   * Sets the Description of the listed Item.
   * @param description A string representing the Description for the product.
   */
		,
		set: function set(description) {
			this._description = description;
		}
	}, {
		key: 'brand',
		get: function get() {
			return this._brand;
		}

		/**
   * Sets the Brand of the listed Item.
   * @param brand A string representing the Brand for the product.
   */
		,
		set: function set(brand) {
			this._brand = brand;
		}
	}, {
		key: 'category',
		get: function get() {
			return this._category;
		}

		/**
   * Sets the Category of the listed Item.
   * @param category A string representing the Category for the product.
   */
		,
		set: function set(category) {
			this._category = category;
		}
	}, {
		key: 'delivery_category',
		get: function get() {
			return this._delivery_category;
		}

		/**
   * Sets the type of delivery for a purchase event.
   * @param delivery_category The delivery category.
   */
		,
		set: function set(delivery_category) {
			this._delivery_category = delivery_category;
		}
	}]);
	return Content;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * CustomData represents the Custom Data Parameters of a Conversions API Event Request. Use these parameters to send additional data we can use for ads delivery optimization.
 * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data}
 */

var CustomData = function () {

	/**
  * @param {Number} value value of the item Eg: 123.45
  * @param {String} currency currency involved in the transaction Eg: usd
  * @param {String} content_name name of the Content Eg: lettuce
  * @param {String} content_category category of the content Eg: grocery
  * @param {Array<String>} content_ids list of content unique ids involved in the event
  * @param {Array<Content>} contents Array of Content Objects. Use {Content} class to define a content.
  * @param {String} content_type Type of the Content group or Product SKU
  * @param {String} order_id Unique id representing the order
  * @param {Number} predicted_ltv Predicted LifeTime Value for the customer involved in the event
  * @param {Number} num_items Number of items involved
  * @param {String} search_string query string used for the Search event
  * @param {String} status Status of the registration in Registration event
  * @param {String} item_number The item number
  * @param {String} delivery_category The type of delivery for a purchase event
  * @param {Object} custom_properties Custom Properties to be added to the Custom Data
  */
	function CustomData(value, currency, content_name, content_category, content_ids, contents, content_type, order_id, predicted_ltv, num_items, search_string, status, item_number, delivery_category, custom_properties) {
		classCallCheck(this, CustomData);


		this._value = value;
		this._currency = currency;
		this._content_name = content_name;
		this._content_category = content_category;
		this._content_ids = content_ids;
		this._contents = contents;
		this._content_type = content_type;
		this._order_id = order_id;
		this._predicted_ltv = predicted_ltv;
		this._num_items = num_items;
		this._search_string = search_string;
		this._status = status;
		this._item_number = item_number;
		this._delivery_category = delivery_category;
		this._custom_properties = custom_properties;
	}

	/**
  * Gets the value of the custom data.
  * A numeric value associated with this event. This could be a monetary value or a value in some other metric.
  * Example: 142.54.
  */


	createClass(CustomData, [{
		key: 'setValue',


		/**
   * Sets the value of the custom data.
   * @param {Number} value A numeric value associated with this event. This could be a monetary value or a value in some other metric.
   * Example: 142.54.
   */
		value: function setValue(value) {
			this._value = value;
			return this;
		}

		/**
   * Gets the currency for the custom data.
   * The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
   * Example: 'usd'
   */

	}, {
		key: 'setCurrency',


		/**
   * Sets the currency for the custom data.
   * @param {String} currency The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
   * Example: 'usd'
   */
		value: function setCurrency(currency) {
			this._currency = currency;
			return this;
		}

		/**
   * Gets the content name for the custom data. The name of the page or product associated with the event.
   * The name of the page or product associated with the event.
   * Example: 'lettuce'
   */

	}, {
		key: 'setContentName',


		/**
   * Sets the content name for the custom data.
   * @param content_name The name of the page or product associated with the event.
   * Example: 'lettuce'
   */
		value: function setContentName(content_name) {
			this._content_name = content_name;
			return this;
		}

		/**
   * Gets the content category for the custom data.
   * The category of the content associated with the event.
   * Example: 'grocery'
   */

	}, {
		key: 'setContentCategory',


		/**
   * Sets the content_category for the custom data.
   * @param content_category The category of the content associated with the event.
   * Example: 'grocery'
   */
		value: function setContentCategory(content_category) {
			this._content_category = content_category;
			return this;
		}

		/**
   * Gets the content_ids for the custom data.
   * The content IDs associated with the event, such as product SKUs for items in an AddToCart, represented as Array of string.
   * If content_type is a product, then your content IDs must be an array with a single string value. Otherwise, this array can contain any number of string values.
   * Example: ['ABC123', 'XYZ789']
   */

	}, {
		key: 'setContentIds',


		/**
   * Sets the content_ids for the custom data.
   * @param {Array} content_ids The content IDs associated with the event, such as product SKUs for items in an AddToCart, represented as Array of string.
   * If content_type is a product, then your content IDs must be an array with a single string value. Otherwise, this array can contain any number of string values.
   * Example: ['ABC123', 'XYZ789']
   */
		value: function setContentIds(content_ids) {
			this._content_ids = content_ids;
			return this;
		}

		/**
   * Gets the contents for the custom data.
   * An array of Content objects that contain the product IDs associated with the event plus information about the products. id, quantity, and item_price are available fields.
   * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
   */

	}, {
		key: 'setContents',


		/**
   * Sets the contents for the custom data.
   * @param {Array<Content>} contents An array of Content objects that contain the product IDs associated with the event plus information about the products. id, quantity, and item_price are available fields.
   * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
   */
		value: function setContents(contents) {
			this._contents = contents;
			return this;
		}

		/**
   * Gets the content type for the custom data.
   * A String equal to either product or product_group. Set to product if the keys you send content_ids or contents represent products.
   * Set to product_group if the keys you send in content_ids represent product groups.
   */

	}, {
		key: 'setContentType',


		/**
   * Sets the content type for the custom data.
   * @param {String} content_type A string equal to either product or product_group. Set to product if the keys you send content_ids or contents represent products.
   * Set to product_group if the keys you send in content_ids represent product groups.
   */
		value: function setContentType(content_type) {
			this._content_type = content_type;
			return this;
		}

		/**
   * Gets the order id for the custom data.
   * order_id is the order ID for this transaction as a String.
   * Example: 'order1234'
   */

	}, {
		key: 'setOrderId',


		/**
   * Sets the order_id for the custom data.
   * @param {String} order_id The order ID for this transaction as a String.
   * Example: 'order1234'
   */
		value: function setOrderId(order_id) {
			this._order_id = order_id;
			return this;
		}

		/**
   * Gets the predicted LifeTimeValue for the (user) in custom data.
   * The predicted lifetime value of a conversion event, as a String.
   * Example: '432.12'
   */

	}, {
		key: 'setPredictedLtv',


		/**
   * Sets the predicted LifeTimeValue for the custom data.
   * @param {Number} predicted_ltv The predicted lifetime value of a conversion event, as a String.
   * Example: '432.12'
   */
		value: function setPredictedLtv(predicted_ltv) {
			this._predicted_ltv = predicted_ltv;
			return this;
		}

		/**
   * Gets the number of items for the custom data.
   * The number of items that a user tries to buy during checkout. Use only with InitiateCheckout type events.
   * Example: 5
   */

	}, {
		key: 'setNumItems',


		/**
   * Sets the number of items for the custom data.
   * @param {Number} num_items The number of items that a user tries to buy during checkout. Use only with InitiateCheckout type events.
   * Example: 5
   */
		value: function setNumItems(num_items) {
			this._num_items = num_items;
			return this;
		}

		/**
   * Gets the search string for the custom data.
   * A search query made by a user.Use only with Search events.
   * Eg: 'lettuce'
   */

	}, {
		key: 'setSearchString',


		/**
   * Sets the search string for the custom data.
   * @param search_string A search query made by a user.Use only with Search events.
   * Eg: 'lettuce'
   */
		value: function setSearchString(search_string) {
			this._search_string = search_string;
			return this;
		}

		/**
   * Gets the item number.
   */

	}, {
		key: 'setItemNumber',


		/**
   * Sets the item number.
   * @param {String} item_number The item number.
   */
		value: function setItemNumber(item_number) {
			this._item_number = item_number;
			return this;
		}

		/**
   * Gets the delivery category.
   */

	}, {
		key: 'setDeliveryCategory',


		/**
   * Sets the type of delivery for a purchase event.
   * @param {String} delivery_category The delivery category.
   */
		value: function setDeliveryCategory(delivery_category) {
			this._delivery_category = delivery_category;
			return this;
		}

		/**
   * Gets the custom properties to be included in the Custom Data.
   * If our predefined object properties don't suit your needs, you can include your own, custom properties. Custom properties can be used with both standard and custom events, and can help you further define custom audiences.
   * This behavior is the same for Conversions API and Facebook Pixel.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data#custom-properties}
   * Eg: '{ 'warehouse_location' : 'washington', 'package_size' : 'L'}'
   */

	}, {
		key: 'setCustomProperties',


		/**
   * Sets the search string for the custom data.
   * @param custom_properties A custom properties property bag to be included in the Custom Data.
   * If our predefined object properties don't suit your needs, you can include your own, custom properties. Custom properties can be used with both standard and custom events, and can help you further define custom audiences.
   * This behavior is the same for Conversions API and Facebook Pixel.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data#custom-properties}
   * Eg: '{ 'warehouse_location' : 'washington', 'package_size' : 'L'}'
   * * @returns {Object} custom_properties property bag.
   */
		value: function setCustomProperties(custom_properties) {
			this._custom_properties = custom_properties;
			return this;
		}

		/**
   * Gets the status of the registration event.
   * Status of the registration event, as a String.Use only with CompleteRegistration events.
   */

	}, {
		key: 'setStatus',


		/**
   * Sets the status of the registration event.
   * @param {String} status Status of the registration event, as a String. Use only with CompleteRegistration events.
   */
		value: function setStatus(status) {
			this._status = status;
			return this;
		}

		/**
   * Adds the custom property (key, value) to the custom property bag.
   * @param {string} key The Key for the property to be added.
   * @param {string} value The Value for the property to be added.
   */

	}, {
		key: 'add_custom_property',
		value: function add_custom_property(key, value) {

			if (this.custom_properties == null) {
				this.custom_properties = {};
			}

			this.custom_properties[key] = value;
		}

		/**
   * Returns the normalized payload for the custom_data.
   * @returns {Object} normalized custom_data payload.
   */

	}, {
		key: 'normalize',
		value: function normalize() {
			var customData = {};

			var parsedValue = Number.parseFloat(this.value);
			if (!Number.isNaN(parsedValue)) {
				customData['value'] = parsedValue;
			}

			if (this.currency) {
				customData['currency'] = ServerSideUtils.normalizeCurrency(this.currency);
			}

			if (this.content_name) {
				customData['content_name'] = this.content_name;
			}

			if (this.content_category) {
				customData['content_category'] = this.content_category;
			}

			if (this.content_ids) {
				customData['content_ids'] = this.content_ids;
			}

			if (this.contents) {
				var normalized_contents = [];

				for (var i = 0; i < this.contents.length; i++) {
					var content = this.contents[i];
					var normalized_content = content.normalize.call(content);
					normalized_contents.push(normalized_content);
				}

				customData['contents'] = normalized_contents;
			}

			if (this.content_type) {
				customData['content_type'] = this.content_type;
			}

			if (this.order_id) {
				customData['order_id'] = this.order_id;
			}

			if (this.predicted_ltv) {
				customData['predicted_ltv'] = this.predicted_ltv;
			}

			if (this.num_items) {
				customData['num_items'] = this.num_items;
			}

			if (this.search_string) {
				customData['search_string'] = this.search_string;
			}

			if (this.status) {
				customData['status'] = this.status;
			}

			if (this.item_number) {
				customData['item_number'] = this.item_number;
			}

			if (this.delivery_category) {
				customData['delivery_category'] = ServerSideUtils.normalizeDeliveryCategory(this.delivery_category);
			}

			if (this.custom_properties) {
				for (var key in this.custom_properties) {
					if (customData.hasOwnProperty(key)) {
						throw new Error('Duplicate key in custom_properties:"' + key + '". Please make sure the keys defined in the custom_properties are not already available in standard custom_data property list.');
					}

					customData[key] = this.custom_properties[key];
				}
			}

			return customData;
		}
	}, {
		key: 'value',
		get: function get() {
			return this._value;
		}

		/**
   * Sets the value of the custom data.
   * @param value A numeric value associated with this event. This could be a monetary value or a value in some other metric.
   * Example: 142.54.
   */
		,
		set: function set(value) {
			this._value = value;
		}
	}, {
		key: 'currency',
		get: function get() {
			return this._currency;
		}

		/**
   * Sets the currency for the custom data.
   * @param currency The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
   * Example: 'usd'
   */
		,
		set: function set(currency) {
			this._currency = currency;
		}
	}, {
		key: 'content_name',
		get: function get() {
			return this._content_name;
		}

		/**
   * Sets the content name for the custom data.
   * @param content_name The name of the page or product associated with the event.
   * Example: 'lettuce'
   */
		,
		set: function set(content_name) {
			this._content_name = content_name;
		}
	}, {
		key: 'content_category',
		get: function get() {
			return this._content_category;
		}

		/**
   * Sets the content_category for the custom data.
   * @param content_category The category of the content associated with the event.
   * Example: 'grocery'
   */
		,
		set: function set(content_category) {
			this._content_category = content_category;
		}
	}, {
		key: 'content_ids',
		get: function get() {
			return this._content_ids;
		}

		/**
   * Sets the content_ids for the custom data.
   * @param content_ids The content IDs associated with the event, such as product SKUs for items in an AddToCart, represented as Array of string.
   * If content_type is a product, then your content IDs must be an array with a single string value. Otherwise, this array can contain any number of string values.
   * Example: ['ABC123', 'XYZ789']
   */
		,
		set: function set(content_ids) {
			this._content_ids = content_ids;
		}
	}, {
		key: 'contents',
		get: function get() {
			return this._contents;
		}

		/**
   * Sets the contents for the custom data.
   * @param contents An array of Content objects that contain the product IDs associated with the event plus information about the products. id, quantity, and item_price are available fields.
   * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
   */
		,
		set: function set(contents) {
			this._contents = contents;
		}
	}, {
		key: 'content_type',
		get: function get() {
			return this._content_type;
		}

		/**
   * Sets the content type for the custom data.
   * A String equal to either product or product_group. Set to product if the keys you send content_ids or contents represent products.
   * Set to product_group if the keys you send in content_ids represent product groups.
   */
		,
		set: function set(content_type) {
			this._content_type = content_type;
		}
	}, {
		key: 'order_id',
		get: function get() {
			return this._order_id;
		}

		/**
   * Sets the order_id for the custom data.
   * @param order_id The order ID for this transaction as a String.
   * Example: 'order1234'
   */
		,
		set: function set(order_id) {
			this._order_id = order_id;
		}
	}, {
		key: 'predicted_ltv',
		get: function get() {
			return this._predicted_ltv;
		}

		/**
   * Sets the predicted LifeTimeValue for the custom data.
   * @param predicted_ltv The predicted lifetime value of a conversion event, as a String.
   * Example: '432.12'
   */
		,
		set: function set(predicted_ltv) {
			this._predicted_ltv = predicted_ltv;
		}
	}, {
		key: 'num_items',
		get: function get() {
			return this._num_items;
		}

		/**
   * Sets the number of items for the custom data.
   * @param num_items The number of items that a user tries to buy during checkout. Use only with InitiateCheckout type events.
   * Example: 5
   */
		,
		set: function set(num_items) {
			this._num_items = num_items;
		}
	}, {
		key: 'search_string',
		get: function get() {
			return this._search_string;
		}

		/**
   * Sets the search string for the custom data.
   * @param {Number} search_string A search query made by a user.Use only with Search events.
   * Eg: 'lettuce'
   */
		,
		set: function set(search_string) {
			this._search_string = search_string;
		}
	}, {
		key: 'item_number',
		get: function get() {
			return this._item_number;
		}

		/**
   * Sets the item number.
   * @param item_number The item number.
   */
		,
		set: function set(item_number) {
			this._item_number = item_number;
		}
	}, {
		key: 'delivery_category',
		get: function get() {
			return this._delivery_category;
		}

		/**
   * Sets the type of delivery for a purchase event.
   * @param delivery_category The delivery category.
   */
		,
		set: function set(delivery_category) {
			this._delivery_category = delivery_category;
		}
	}, {
		key: 'custom_properties',
		get: function get() {
			return this._custom_properties;
		}

		/**
   * Sets the custom properties to be included in the Custom Data.
   * If our predefined object properties don't suit your needs, you can include your own, custom properties. Custom properties can be used with both standard and custom events, and can help you further define custom audiences.
   * This behavior is the same for Conversions API and Facebook Pixel.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/custom-data#custom-properties}
   * @param {Object} custom_properties custom properties property bag to be included in the Custom Data. Eg: '{ 'warehouse_location' : 'washington', 'package_size' : 'L'}'
   */
		,
		set: function set(custom_properties) {
			this._custom_properties = custom_properties;
		}
	}, {
		key: 'status',
		get: function get() {
			return this._status;
		}

		/**
   * Sets the status of the registration event.
   * @param status Status of the registration event, as a String.Use only with CompleteRegistration events.
   */
		,
		set: function set(status) {
			this._status = status;
		}
	}]);
	return CustomData;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdActivity
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdActivity = function (_AbstractCrudObject) {
  inherits(AdActivity, _AbstractCrudObject);

  function AdActivity() {
    classCallCheck(this, AdActivity);
    return possibleConstructorReturn(this, (AdActivity.__proto__ || Object.getPrototypeOf(AdActivity)).apply(this, arguments));
  }

  createClass(AdActivity, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actor_id: 'actor_id',
        actor_name: 'actor_name',
        application_id: 'application_id',
        application_name: 'application_name',
        date_time_in_timezone: 'date_time_in_timezone',
        event_time: 'event_time',
        event_type: 'event_type',
        extra_data: 'extra_data',
        object_id: 'object_id',
        object_name: 'object_name',
        object_type: 'object_type',
        translated_event_type: 'translated_event_type'
      });
    }
  }, {
    key: 'EventType',
    get: function get() {
      return Object.freeze({
        account_spending_limit_reached: 'account_spending_limit_reached',
        ad_account_add_user_to_role: 'ad_account_add_user_to_role',
        ad_account_billing_charge: 'ad_account_billing_charge',
        ad_account_billing_charge_failed: 'ad_account_billing_charge_failed',
        ad_account_billing_chargeback: 'ad_account_billing_chargeback',
        ad_account_billing_chargeback_reversal: 'ad_account_billing_chargeback_reversal',
        ad_account_billing_decline: 'ad_account_billing_decline',
        ad_account_billing_refund: 'ad_account_billing_refund',
        ad_account_remove_spend_limit: 'ad_account_remove_spend_limit',
        ad_account_remove_user_from_role: 'ad_account_remove_user_from_role',
        ad_account_reset_spend_limit: 'ad_account_reset_spend_limit',
        ad_account_set_business_information: 'ad_account_set_business_information',
        ad_account_update_spend_limit: 'ad_account_update_spend_limit',
        ad_account_update_status: 'ad_account_update_status',
        ad_review_approved: 'ad_review_approved',
        ad_review_declined: 'ad_review_declined',
        add_funding_source: 'add_funding_source',
        add_images: 'add_images',
        billing_event: 'billing_event',
        campaign_ended: 'campaign_ended',
        campaign_spending_limit_reached: 'campaign_spending_limit_reached',
        conversion_event_updated: 'conversion_event_updated',
        create_ad: 'create_ad',
        create_ad_set: 'create_ad_set',
        create_audience: 'create_audience',
        create_campaign_group: 'create_campaign_group',
        create_campaign_legacy: 'create_campaign_legacy',
        delete_audience: 'delete_audience',
        delete_images: 'delete_images',
        di_ad_set_learning_stage_exit: 'di_ad_set_learning_stage_exit',
        edit_and_update_ad_creative: 'edit_and_update_ad_creative',
        edit_images: 'edit_images',
        first_delivery_event: 'first_delivery_event',
        funding_event_initiated: 'funding_event_initiated',
        funding_event_successful: 'funding_event_successful',
        lifetime_budget_spent: 'lifetime_budget_spent',
        merge_campaigns: 'merge_campaigns',
        receive_audience: 'receive_audience',
        remove_funding_source: 'remove_funding_source',
        remove_shared_audience: 'remove_shared_audience',
        share_audience: 'share_audience',
        unknown: 'unknown',
        unshare_audience: 'unshare_audience',
        update_ad_bid_info: 'update_ad_bid_info',
        update_ad_bid_type: 'update_ad_bid_type',
        update_ad_creative: 'update_ad_creative',
        update_ad_friendly_name: 'update_ad_friendly_name',
        update_ad_labels: 'update_ad_labels',
        update_ad_run_status: 'update_ad_run_status',
        update_ad_run_status_to_be_set_after_review: 'update_ad_run_status_to_be_set_after_review',
        update_ad_set_ad_keywords: 'update_ad_set_ad_keywords',
        update_ad_set_bid_adjustments: 'update_ad_set_bid_adjustments',
        update_ad_set_bid_strategy: 'update_ad_set_bid_strategy',
        update_ad_set_bidding: 'update_ad_set_bidding',
        update_ad_set_budget: 'update_ad_set_budget',
        update_ad_set_duration: 'update_ad_set_duration',
        update_ad_set_learning_stage_status: 'update_ad_set_learning_stage_status',
        update_ad_set_min_spend_target: 'update_ad_set_min_spend_target',
        update_ad_set_name: 'update_ad_set_name',
        update_ad_set_optimization_goal: 'update_ad_set_optimization_goal',
        update_ad_set_run_status: 'update_ad_set_run_status',
        update_ad_set_spend_cap: 'update_ad_set_spend_cap',
        update_ad_set_target_spec: 'update_ad_set_target_spec',
        update_ad_targets_spec: 'update_ad_targets_spec',
        update_adgroup_stop_delivery: 'update_adgroup_stop_delivery',
        update_audience: 'update_audience',
        update_campaign_ad_scheduling: 'update_campaign_ad_scheduling',
        update_campaign_budget: 'update_campaign_budget',
        update_campaign_budget_optimization_toggling_status: 'update_campaign_budget_optimization_toggling_status',
        update_campaign_delivery_type: 'update_campaign_delivery_type',
        update_campaign_group_ad_scheduling: 'update_campaign_group_ad_scheduling',
        update_campaign_group_delivery_type: 'update_campaign_group_delivery_type',
        update_campaign_group_spend_cap: 'update_campaign_group_spend_cap',
        update_campaign_name: 'update_campaign_name',
        update_campaign_run_status: 'update_campaign_run_status',
        update_campaign_schedule: 'update_campaign_schedule',
        update_delivery_type_cross_level_shift: 'update_delivery_type_cross_level_shift'
      });
    }
  }, {
    key: 'Category',
    get: function get() {
      return Object.freeze({
        account: 'ACCOUNT',
        ad: 'AD',
        ad_keywords: 'AD_KEYWORDS',
        ad_set: 'AD_SET',
        audience: 'AUDIENCE',
        bid: 'BID',
        budget: 'BUDGET',
        campaign: 'CAMPAIGN',
        date: 'DATE',
        status: 'STATUS',
        targeting: 'TARGETING'
      });
    }
  }, {
    key: 'DataSource',
    get: function get() {
      return Object.freeze({
        calypso: 'CALYPSO',
        tao: 'TAO',
        tao_ad_account: 'TAO_AD_ACCOUNT',
        tao_ad_status: 'TAO_AD_STATUS'
      });
    }
  }]);
  return AdActivity;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdPlacePageSet
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdPlacePageSet = function (_AbstractCrudObject) {
  inherits(AdPlacePageSet, _AbstractCrudObject);

  function AdPlacePageSet() {
    classCallCheck(this, AdPlacePageSet);
    return possibleConstructorReturn(this, (AdPlacePageSet.__proto__ || Object.getPrototypeOf(AdPlacePageSet)).apply(this, arguments));
  }

  createClass(AdPlacePageSet, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        id: 'id',
        location_types: 'location_types',
        name: 'name',
        pages_count: 'pages_count',
        parent_page: 'parent_page'
      });
    }
  }, {
    key: 'LocationTypes',
    get: function get() {
      return Object.freeze({
        home: 'home',
        recent: 'recent'
      });
    }
  }, {
    key: 'TargetedAreaType',
    get: function get() {
      return Object.freeze({
        custom_radius: 'CUSTOM_RADIUS',
        marketing_area: 'MARKETING_AREA',
        none: 'NONE'
      });
    }
  }]);
  return AdPlacePageSet;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeInsights
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeInsights = function (_AbstractCrudObject) {
  inherits(AdCreativeInsights, _AbstractCrudObject);

  function AdCreativeInsights() {
    classCallCheck(this, AdCreativeInsights);
    return possibleConstructorReturn(this, (AdCreativeInsights.__proto__ || Object.getPrototypeOf(AdCreativeInsights)).apply(this, arguments));
  }

  createClass(AdCreativeInsights, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        aesthetics: 'aesthetics'
      });
    }
  }]);
  return AdCreativeInsights;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdPreview
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdPreview = function (_AbstractCrudObject) {
  inherits(AdPreview, _AbstractCrudObject);

  function AdPreview() {
    classCallCheck(this, AdPreview);
    return possibleConstructorReturn(this, (AdPreview.__proto__ || Object.getPrototypeOf(AdPreview)).apply(this, arguments));
  }

  createClass(AdPreview, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        body: 'body'
      });
    }
  }, {
    key: 'AdFormat',
    get: function get() {
      return Object.freeze({
        audience_network_instream_video: 'AUDIENCE_NETWORK_INSTREAM_VIDEO',
        audience_network_instream_video_mobile: 'AUDIENCE_NETWORK_INSTREAM_VIDEO_MOBILE',
        audience_network_outstream_video: 'AUDIENCE_NETWORK_OUTSTREAM_VIDEO',
        audience_network_rewarded_video: 'AUDIENCE_NETWORK_REWARDED_VIDEO',
        biz_disco_feed_mobile: 'BIZ_DISCO_FEED_MOBILE',
        desktop_feed_standard: 'DESKTOP_FEED_STANDARD',
        facebook_reels_banner: 'FACEBOOK_REELS_BANNER',
        facebook_reels_banner_desktop: 'FACEBOOK_REELS_BANNER_DESKTOP',
        facebook_reels_mobile: 'FACEBOOK_REELS_MOBILE',
        facebook_reels_postloop: 'FACEBOOK_REELS_POSTLOOP',
        facebook_reels_sticker: 'FACEBOOK_REELS_STICKER',
        facebook_story_mobile: 'FACEBOOK_STORY_MOBILE',
        facebook_story_sticker_mobile: 'FACEBOOK_STORY_STICKER_MOBILE',
        instagram_explore_contextual: 'INSTAGRAM_EXPLORE_CONTEXTUAL',
        instagram_explore_grid_home: 'INSTAGRAM_EXPLORE_GRID_HOME',
        instagram_explore_immersive: 'INSTAGRAM_EXPLORE_IMMERSIVE',
        instagram_feed_web: 'INSTAGRAM_FEED_WEB',
        instagram_feed_web_m_site: 'INSTAGRAM_FEED_WEB_M_SITE',
        instagram_profile_feed: 'INSTAGRAM_PROFILE_FEED',
        instagram_reels: 'INSTAGRAM_REELS',
        instagram_reels_overlay: 'INSTAGRAM_REELS_OVERLAY',
        instagram_search_chain: 'INSTAGRAM_SEARCH_CHAIN',
        instagram_search_grid: 'INSTAGRAM_SEARCH_GRID',
        instagram_shop: 'INSTAGRAM_SHOP',
        instagram_standard: 'INSTAGRAM_STANDARD',
        instagram_story: 'INSTAGRAM_STORY',
        instagram_story_web: 'INSTAGRAM_STORY_WEB',
        instagram_story_web_m_site: 'INSTAGRAM_STORY_WEB_M_SITE',
        instant_article_recirculation_ad: 'INSTANT_ARTICLE_RECIRCULATION_AD',
        instant_article_standard: 'INSTANT_ARTICLE_STANDARD',
        instream_banner_desktop: 'INSTREAM_BANNER_DESKTOP',
        instream_banner_mobile: 'INSTREAM_BANNER_MOBILE',
        instream_video_desktop: 'INSTREAM_VIDEO_DESKTOP',
        instream_video_image: 'INSTREAM_VIDEO_IMAGE',
        instream_video_mobile: 'INSTREAM_VIDEO_MOBILE',
        job_browser_desktop: 'JOB_BROWSER_DESKTOP',
        job_browser_mobile: 'JOB_BROWSER_MOBILE',
        marketplace_mobile: 'MARKETPLACE_MOBILE',
        messenger_mobile_inbox_media: 'MESSENGER_MOBILE_INBOX_MEDIA',
        messenger_mobile_story_media: 'MESSENGER_MOBILE_STORY_MEDIA',
        mobile_banner: 'MOBILE_BANNER',
        mobile_feed_basic: 'MOBILE_FEED_BASIC',
        mobile_feed_standard: 'MOBILE_FEED_STANDARD',
        mobile_fullwidth: 'MOBILE_FULLWIDTH',
        mobile_interstitial: 'MOBILE_INTERSTITIAL',
        mobile_medium_rectangle: 'MOBILE_MEDIUM_RECTANGLE',
        mobile_native: 'MOBILE_NATIVE',
        right_column_standard: 'RIGHT_COLUMN_STANDARD',
        suggested_video_desktop: 'SUGGESTED_VIDEO_DESKTOP',
        suggested_video_mobile: 'SUGGESTED_VIDEO_MOBILE',
        watch_feed_home: 'WATCH_FEED_HOME',
        watch_feed_mobile: 'WATCH_FEED_MOBILE'
      });
    }
  }, {
    key: 'RenderType',
    get: function get() {
      return Object.freeze({
        fallback: 'FALLBACK'
      });
    }
  }]);
  return AdPreview;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreative
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreative = function (_AbstractCrudObject) {
  inherits(AdCreative, _AbstractCrudObject);

  function AdCreative() {
    classCallCheck(this, AdCreative);
    return possibleConstructorReturn(this, (AdCreative.__proto__ || Object.getPrototypeOf(AdCreative)).apply(this, arguments));
  }

  createClass(AdCreative, [{
    key: 'createAdLabel',
    value: function createAdLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adlabels', fields, params, AdCreative, pathOverride);
    }
  }, {
    key: 'getCreativeInsights',
    value: function getCreativeInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCreativeInsights, fields, params, fetchFirstPage, '/creative_insights');
    }
  }, {
    key: 'getPreviews',
    value: function getPreviews(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdPreview, fields, params, fetchFirstPage, '/previews');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdCreative.prototype.__proto__ || Object.getPrototypeOf(AdCreative.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdCreative.prototype.__proto__ || Object.getPrototypeOf(AdCreative.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        actor_id: 'actor_id',
        adlabels: 'adlabels',
        applink_treatment: 'applink_treatment',
        asset_feed_spec: 'asset_feed_spec',
        authorization_category: 'authorization_category',
        auto_update: 'auto_update',
        body: 'body',
        branded_content_sponsor_page_id: 'branded_content_sponsor_page_id',
        bundle_folder_id: 'bundle_folder_id',
        call_to_action_type: 'call_to_action_type',
        categorization_criteria: 'categorization_criteria',
        category_media_source: 'category_media_source',
        collaborative_ads_lsb_image_bank_id: 'collaborative_ads_lsb_image_bank_id',
        degrees_of_freedom_spec: 'degrees_of_freedom_spec',
        destination_set_id: 'destination_set_id',
        dynamic_ad_voice: 'dynamic_ad_voice',
        effective_authorization_category: 'effective_authorization_category',
        effective_instagram_media_id: 'effective_instagram_media_id',
        effective_instagram_story_id: 'effective_instagram_story_id',
        effective_object_story_id: 'effective_object_story_id',
        enable_direct_install: 'enable_direct_install',
        enable_launch_instant_app: 'enable_launch_instant_app',
        id: 'id',
        image_crops: 'image_crops',
        image_hash: 'image_hash',
        image_url: 'image_url',
        instagram_actor_id: 'instagram_actor_id',
        instagram_permalink_url: 'instagram_permalink_url',
        instagram_story_id: 'instagram_story_id',
        instagram_user_id: 'instagram_user_id',
        interactive_components_spec: 'interactive_components_spec',
        link_deep_link_url: 'link_deep_link_url',
        link_destination_display_url: 'link_destination_display_url',
        link_og_id: 'link_og_id',
        link_url: 'link_url',
        messenger_sponsored_message: 'messenger_sponsored_message',
        name: 'name',
        object_id: 'object_id',
        object_store_url: 'object_store_url',
        object_story_id: 'object_story_id',
        object_story_spec: 'object_story_spec',
        object_type: 'object_type',
        object_url: 'object_url',
        omnichannel_link_spec: 'omnichannel_link_spec',
        place_page_set_id: 'place_page_set_id',
        platform_customizations: 'platform_customizations',
        playable_asset_id: 'playable_asset_id',
        portrait_customizations: 'portrait_customizations',
        product_set_id: 'product_set_id',
        recommender_settings: 'recommender_settings',
        source_instagram_media_id: 'source_instagram_media_id',
        status: 'status',
        template_url: 'template_url',
        template_url_spec: 'template_url_spec',
        thumbnail_id: 'thumbnail_id',
        thumbnail_url: 'thumbnail_url',
        title: 'title',
        url_tags: 'url_tags',
        use_page_actor_override: 'use_page_actor_override',
        video_id: 'video_id'
      });
    }
  }, {
    key: 'CallToActionType',
    get: function get() {
      return Object.freeze({
        add_to_cart: 'ADD_TO_CART',
        apply_now: 'APPLY_NOW',
        audio_call: 'AUDIO_CALL',
        book_travel: 'BOOK_TRAVEL',
        buy: 'BUY',
        buy_now: 'BUY_NOW',
        buy_tickets: 'BUY_TICKETS',
        call: 'CALL',
        call_me: 'CALL_ME',
        call_now: 'CALL_NOW',
        contact: 'CONTACT',
        contact_us: 'CONTACT_US',
        donate: 'DONATE',
        donate_now: 'DONATE_NOW',
        download: 'DOWNLOAD',
        event_rsvp: 'EVENT_RSVP',
        find_a_group: 'FIND_A_GROUP',
        find_your_groups: 'FIND_YOUR_GROUPS',
        follow_news_storyline: 'FOLLOW_NEWS_STORYLINE',
        follow_page: 'FOLLOW_PAGE',
        follow_user: 'FOLLOW_USER',
        get_directions: 'GET_DIRECTIONS',
        get_offer: 'GET_OFFER',
        get_offer_view: 'GET_OFFER_VIEW',
        get_quote: 'GET_QUOTE',
        get_showtimes: 'GET_SHOWTIMES',
        get_started: 'GET_STARTED',
        install_app: 'INSTALL_APP',
        install_mobile_app: 'INSTALL_MOBILE_APP',
        learn_more: 'LEARN_MORE',
        like_page: 'LIKE_PAGE',
        listen_music: 'LISTEN_MUSIC',
        listen_now: 'LISTEN_NOW',
        message_page: 'MESSAGE_PAGE',
        mobile_download: 'MOBILE_DOWNLOAD',
        moments: 'MOMENTS',
        no_button: 'NO_BUTTON',
        open_instant_app: 'OPEN_INSTANT_APP',
        open_link: 'OPEN_LINK',
        order_now: 'ORDER_NOW',
        pay_to_access: 'PAY_TO_ACCESS',
        play_game: 'PLAY_GAME',
        play_game_on_facebook: 'PLAY_GAME_ON_FACEBOOK',
        purchase_gift_cards: 'PURCHASE_GIFT_CARDS',
        raise_money: 'RAISE_MONEY',
        record_now: 'RECORD_NOW',
        refer_friends: 'REFER_FRIENDS',
        request_time: 'REQUEST_TIME',
        say_thanks: 'SAY_THANKS',
        see_more: 'SEE_MORE',
        sell_now: 'SELL_NOW',
        send_a_gift: 'SEND_A_GIFT',
        send_gift_money: 'SEND_GIFT_MONEY',
        send_updates: 'SEND_UPDATES',
        share: 'SHARE',
        shop_now: 'SHOP_NOW',
        sign_up: 'SIGN_UP',
        sotto_subscribe: 'SOTTO_SUBSCRIBE',
        start_order: 'START_ORDER',
        subscribe: 'SUBSCRIBE',
        swipe_up_product: 'SWIPE_UP_PRODUCT',
        swipe_up_shop: 'SWIPE_UP_SHOP',
        update_app: 'UPDATE_APP',
        use_app: 'USE_APP',
        use_mobile_app: 'USE_MOBILE_APP',
        video_annotation: 'VIDEO_ANNOTATION',
        video_call: 'VIDEO_CALL',
        visit_pages_feed: 'VISIT_PAGES_FEED',
        watch_more: 'WATCH_MORE',
        watch_video: 'WATCH_VIDEO',
        whatsapp_message: 'WHATSAPP_MESSAGE',
        woodhenge_support: 'WOODHENGE_SUPPORT'
      });
    }
  }, {
    key: 'ObjectType',
    get: function get() {
      return Object.freeze({
        application: 'APPLICATION',
        domain: 'DOMAIN',
        event: 'EVENT',
        invalid: 'INVALID',
        offer: 'OFFER',
        page: 'PAGE',
        photo: 'PHOTO',
        post_deleted: 'POST_DELETED',
        privacy_check_fail: 'PRIVACY_CHECK_FAIL',
        share: 'SHARE',
        status: 'STATUS',
        store_item: 'STORE_ITEM',
        video: 'VIDEO'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        deleted: 'DELETED',
        in_process: 'IN_PROCESS',
        with_issues: 'WITH_ISSUES'
      });
    }
  }, {
    key: 'ApplinkTreatment',
    get: function get() {
      return Object.freeze({
        automatic: 'automatic',
        deeplink_with_appstore_fallback: 'deeplink_with_appstore_fallback',
        deeplink_with_web_fallback: 'deeplink_with_web_fallback',
        web_only: 'web_only'
      });
    }
  }, {
    key: 'AuthorizationCategory',
    get: function get() {
      return Object.freeze({
        none: 'NONE',
        political: 'POLITICAL'
      });
    }
  }, {
    key: 'CategorizationCriteria',
    get: function get() {
      return Object.freeze({
        brand: 'brand',
        category: 'category',
        product_type: 'product_type'
      });
    }
  }, {
    key: 'CategoryMediaSource',
    get: function get() {
      return Object.freeze({
        category: 'CATEGORY',
        mixed: 'MIXED',
        products_collage: 'PRODUCTS_COLLAGE',
        products_slideshow: 'PRODUCTS_SLIDESHOW'
      });
    }
  }, {
    key: 'DynamicAdVoice',
    get: function get() {
      return Object.freeze({
        dynamic: 'DYNAMIC',
        story_owner: 'STORY_OWNER'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        any: 'ANY'
      });
    }
  }]);
  return AdCreative;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleHistory
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleHistory = function (_AbstractCrudObject) {
  inherits(AdRuleHistory, _AbstractCrudObject);

  function AdRuleHistory() {
    classCallCheck(this, AdRuleHistory);
    return possibleConstructorReturn(this, (AdRuleHistory.__proto__ || Object.getPrototypeOf(AdRuleHistory)).apply(this, arguments));
  }

  createClass(AdRuleHistory, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        evaluation_spec: 'evaluation_spec',
        exception_code: 'exception_code',
        exception_message: 'exception_message',
        execution_spec: 'execution_spec',
        is_manual: 'is_manual',
        results: 'results',
        schedule_spec: 'schedule_spec',
        timestamp: 'timestamp'
      });
    }
  }, {
    key: 'Action',
    get: function get() {
      return Object.freeze({
        budget_not_redistributed: 'BUDGET_NOT_REDISTRIBUTED',
        changed_bid: 'CHANGED_BID',
        changed_budget: 'CHANGED_BUDGET',
        email: 'EMAIL',
        enable_autoflow: 'ENABLE_AUTOFLOW',
        endpoint_pinged: 'ENDPOINT_PINGED',
        error: 'ERROR',
        facebook_notification_sent: 'FACEBOOK_NOTIFICATION_SENT',
        message_sent: 'MESSAGE_SENT',
        not_changed: 'NOT_CHANGED',
        paused: 'PAUSED',
        unpaused: 'UNPAUSED'
      });
    }
  }]);
  return AdRuleHistory;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRule = function (_AbstractCrudObject) {
  inherits(AdRule, _AbstractCrudObject);

  function AdRule() {
    classCallCheck(this, AdRule);
    return possibleConstructorReturn(this, (AdRule.__proto__ || Object.getPrototypeOf(AdRule)).apply(this, arguments));
  }

  createClass(AdRule, [{
    key: 'createExecute',
    value: function createExecute(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/execute', fields, params, null, pathOverride);
    }
  }, {
    key: 'getHistory',
    value: function getHistory(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdRuleHistory, fields, params, fetchFirstPage, '/history');
    }
  }, {
    key: 'createPreview',
    value: function createPreview(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/preview', fields, params, AdRule, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdRule.prototype.__proto__ || Object.getPrototypeOf(AdRule.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdRule.prototype.__proto__ || Object.getPrototypeOf(AdRule.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        created_by: 'created_by',
        created_time: 'created_time',
        evaluation_spec: 'evaluation_spec',
        execution_spec: 'execution_spec',
        id: 'id',
        name: 'name',
        schedule_spec: 'schedule_spec',
        status: 'status',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        deleted: 'DELETED',
        disabled: 'DISABLED',
        enabled: 'ENABLED',
        has_issues: 'HAS_ISSUES'
      });
    }
  }, {
    key: 'UiCreationSource',
    get: function get() {
      return Object.freeze({
        am_account_overview_recommendations: 'AM_ACCOUNT_OVERVIEW_RECOMMENDATIONS',
        am_activity_history_table: 'AM_ACTIVITY_HISTORY_TABLE',
        am_ad_object_name_card: 'AM_AD_OBJECT_NAME_CARD',
        am_amfe_l3_recommendation: 'AM_AMFE_L3_RECOMMENDATION',
        am_auto_apply_widget: 'AM_AUTO_APPLY_WIDGET',
        am_editor_card: 'AM_EDITOR_CARD',
        am_info_card: 'AM_INFO_CARD',
        am_name_cell_dropdown: 'AM_NAME_CELL_DROPDOWN',
        am_performance_summary: 'AM_PERFORMANCE_SUMMARY',
        am_rule_landing_page_banner: 'AM_RULE_LANDING_PAGE_BANNER',
        am_toolbar_create_rule_dropdown: 'AM_TOOLBAR_CREATE_RULE_DROPDOWN',
        pe_campaign_structure_menu: 'PE_CAMPAIGN_STRUCTURE_MENU',
        pe_editor_card: 'PE_EDITOR_CARD',
        pe_info_card: 'PE_INFO_CARD',
        pe_toolbar_create_rule_dropdown: 'PE_TOOLBAR_CREATE_RULE_DROPDOWN',
        rules_management_page_action_dropdown: 'RULES_MANAGEMENT_PAGE_ACTION_DROPDOWN',
        rules_management_page_rule_group: 'RULES_MANAGEMENT_PAGE_RULE_GROUP',
        rules_management_page_rule_name: 'RULES_MANAGEMENT_PAGE_RULE_NAME',
        rules_management_page_top_nav: 'RULES_MANAGEMENT_PAGE_TOP_NAV',
        rules_view_active_rules_dialog: 'RULES_VIEW_ACTIVE_RULES_DIALOG',
        rule_creation_success_dialog: 'RULE_CREATION_SUCCESS_DIALOG',
        rule_syd_redirect: 'RULE_SYD_REDIRECT',
        rule_templates_dialog: 'RULE_TEMPLATES_DIALOG'
      });
    }
  }]);
  return AdRule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsInsights
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsInsights = function (_AbstractCrudObject) {
  inherits(AdsInsights, _AbstractCrudObject);

  function AdsInsights() {
    classCallCheck(this, AdsInsights);
    return possibleConstructorReturn(this, (AdsInsights.__proto__ || Object.getPrototypeOf(AdsInsights)).apply(this, arguments));
  }

  createClass(AdsInsights, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_currency: 'account_currency',
        account_id: 'account_id',
        account_name: 'account_name',
        action_values: 'action_values',
        actions: 'actions',
        ad_bid_value: 'ad_bid_value',
        ad_click_actions: 'ad_click_actions',
        ad_id: 'ad_id',
        ad_impression_actions: 'ad_impression_actions',
        ad_name: 'ad_name',
        adset_bid_value: 'adset_bid_value',
        adset_end: 'adset_end',
        adset_id: 'adset_id',
        adset_name: 'adset_name',
        adset_start: 'adset_start',
        age_targeting: 'age_targeting',
        attribution_setting: 'attribution_setting',
        auction_bid: 'auction_bid',
        auction_competitiveness: 'auction_competitiveness',
        auction_max_competitor_bid: 'auction_max_competitor_bid',
        buying_type: 'buying_type',
        campaign_id: 'campaign_id',
        campaign_name: 'campaign_name',
        canvas_avg_view_percent: 'canvas_avg_view_percent',
        canvas_avg_view_time: 'canvas_avg_view_time',
        catalog_segment_actions: 'catalog_segment_actions',
        catalog_segment_value: 'catalog_segment_value',
        catalog_segment_value_mobile_purchase_roas: 'catalog_segment_value_mobile_purchase_roas',
        catalog_segment_value_omni_purchase_roas: 'catalog_segment_value_omni_purchase_roas',
        catalog_segment_value_website_purchase_roas: 'catalog_segment_value_website_purchase_roas',
        clicks: 'clicks',
        conversion_rate_ranking: 'conversion_rate_ranking',
        conversion_values: 'conversion_values',
        conversions: 'conversions',
        converted_product_quantity: 'converted_product_quantity',
        converted_product_value: 'converted_product_value',
        cost_per_15_sec_video_view: 'cost_per_15_sec_video_view',
        cost_per_2_sec_continuous_video_view: 'cost_per_2_sec_continuous_video_view',
        cost_per_action_type: 'cost_per_action_type',
        cost_per_ad_click: 'cost_per_ad_click',
        cost_per_conversion: 'cost_per_conversion',
        cost_per_dda_countby_convs: 'cost_per_dda_countby_convs',
        cost_per_estimated_ad_recallers: 'cost_per_estimated_ad_recallers',
        cost_per_inline_link_click: 'cost_per_inline_link_click',
        cost_per_inline_post_engagement: 'cost_per_inline_post_engagement',
        cost_per_one_thousand_ad_impression: 'cost_per_one_thousand_ad_impression',
        cost_per_outbound_click: 'cost_per_outbound_click',
        cost_per_thruplay: 'cost_per_thruplay',
        cost_per_unique_action_type: 'cost_per_unique_action_type',
        cost_per_unique_click: 'cost_per_unique_click',
        cost_per_unique_conversion: 'cost_per_unique_conversion',
        cost_per_unique_inline_link_click: 'cost_per_unique_inline_link_click',
        cost_per_unique_outbound_click: 'cost_per_unique_outbound_click',
        cpc: 'cpc',
        cpm: 'cpm',
        cpp: 'cpp',
        created_time: 'created_time',
        ctr: 'ctr',
        date_start: 'date_start',
        date_stop: 'date_stop',
        dda_countby_convs: 'dda_countby_convs',
        dda_results: 'dda_results',
        engagement_rate_ranking: 'engagement_rate_ranking',
        estimated_ad_recall_rate: 'estimated_ad_recall_rate',
        estimated_ad_recall_rate_lower_bound: 'estimated_ad_recall_rate_lower_bound',
        estimated_ad_recall_rate_upper_bound: 'estimated_ad_recall_rate_upper_bound',
        estimated_ad_recallers: 'estimated_ad_recallers',
        estimated_ad_recallers_lower_bound: 'estimated_ad_recallers_lower_bound',
        estimated_ad_recallers_upper_bound: 'estimated_ad_recallers_upper_bound',
        frequency: 'frequency',
        full_view_impressions: 'full_view_impressions',
        full_view_reach: 'full_view_reach',
        gender_targeting: 'gender_targeting',
        impressions: 'impressions',
        inline_link_click_ctr: 'inline_link_click_ctr',
        inline_link_clicks: 'inline_link_clicks',
        inline_post_engagement: 'inline_post_engagement',
        instant_experience_clicks_to_open: 'instant_experience_clicks_to_open',
        instant_experience_clicks_to_start: 'instant_experience_clicks_to_start',
        instant_experience_outbound_clicks: 'instant_experience_outbound_clicks',
        interactive_component_tap: 'interactive_component_tap',
        labels: 'labels',
        location: 'location',
        mobile_app_purchase_roas: 'mobile_app_purchase_roas',
        objective: 'objective',
        optimization_goal: 'optimization_goal',
        outbound_clicks: 'outbound_clicks',
        outbound_clicks_ctr: 'outbound_clicks_ctr',
        place_page_name: 'place_page_name',
        purchase_roas: 'purchase_roas',
        qualifying_question_qualify_answer_rate: 'qualifying_question_qualify_answer_rate',
        quality_ranking: 'quality_ranking',
        quality_score_ectr: 'quality_score_ectr',
        quality_score_ecvr: 'quality_score_ecvr',
        quality_score_organic: 'quality_score_organic',
        reach: 'reach',
        social_spend: 'social_spend',
        spend: 'spend',
        total_postbacks: 'total_postbacks',
        total_postbacks_detailed: 'total_postbacks_detailed',
        unique_actions: 'unique_actions',
        unique_clicks: 'unique_clicks',
        unique_conversions: 'unique_conversions',
        unique_ctr: 'unique_ctr',
        unique_inline_link_click_ctr: 'unique_inline_link_click_ctr',
        unique_inline_link_clicks: 'unique_inline_link_clicks',
        unique_link_clicks_ctr: 'unique_link_clicks_ctr',
        unique_outbound_clicks: 'unique_outbound_clicks',
        unique_outbound_clicks_ctr: 'unique_outbound_clicks_ctr',
        unique_video_continuous_2_sec_watched_actions: 'unique_video_continuous_2_sec_watched_actions',
        unique_video_view_15_sec: 'unique_video_view_15_sec',
        updated_time: 'updated_time',
        video_15_sec_watched_actions: 'video_15_sec_watched_actions',
        video_30_sec_watched_actions: 'video_30_sec_watched_actions',
        video_avg_time_watched_actions: 'video_avg_time_watched_actions',
        video_continuous_2_sec_watched_actions: 'video_continuous_2_sec_watched_actions',
        video_p100_watched_actions: 'video_p100_watched_actions',
        video_p25_watched_actions: 'video_p25_watched_actions',
        video_p50_watched_actions: 'video_p50_watched_actions',
        video_p75_watched_actions: 'video_p75_watched_actions',
        video_p95_watched_actions: 'video_p95_watched_actions',
        video_play_actions: 'video_play_actions',
        video_play_curve_actions: 'video_play_curve_actions',
        video_play_retention_0_to_15s_actions: 'video_play_retention_0_to_15s_actions',
        video_play_retention_20_to_60s_actions: 'video_play_retention_20_to_60s_actions',
        video_play_retention_graph_actions: 'video_play_retention_graph_actions',
        video_thruplay_watched_actions: 'video_thruplay_watched_actions',
        video_time_watched_actions: 'video_time_watched_actions',
        website_ctr: 'website_ctr',
        website_purchase_roas: 'website_purchase_roas',
        wish_bid: 'wish_bid'
      });
    }
  }, {
    key: 'ActionAttributionWindows',
    get: function get() {
      return Object.freeze({
        value_1d_click: '1d_click',
        value_1d_view: '1d_view',
        value_28d_click: '28d_click',
        value_28d_view: '28d_view',
        value_7d_click: '7d_click',
        value_7d_view: '7d_view',
        dda: 'dda',
        default: 'default',
        skan_click: 'skan_click',
        skan_view: 'skan_view'
      });
    }
  }, {
    key: 'ActionBreakdowns',
    get: function get() {
      return Object.freeze({
        action_canvas_component_name: 'action_canvas_component_name',
        action_carousel_card_id: 'action_carousel_card_id',
        action_carousel_card_name: 'action_carousel_card_name',
        action_destination: 'action_destination',
        action_device: 'action_device',
        action_reaction: 'action_reaction',
        action_target_id: 'action_target_id',
        action_type: 'action_type',
        action_video_sound: 'action_video_sound',
        action_video_type: 'action_video_type'
      });
    }
  }, {
    key: 'ActionReportTime',
    get: function get() {
      return Object.freeze({
        conversion: 'conversion',
        impression: 'impression',
        mixed: 'mixed'
      });
    }
  }, {
    key: 'Breakdowns',
    get: function get() {
      return Object.freeze({
        ad_format_asset: 'ad_format_asset',
        age: 'age',
        app_id: 'app_id',
        body_asset: 'body_asset',
        call_to_action_asset: 'call_to_action_asset',
        country: 'country',
        description_asset: 'description_asset',
        device_platform: 'device_platform',
        dma: 'dma',
        frequency_value: 'frequency_value',
        gender: 'gender',
        hourly_stats_aggregated_by_advertiser_time_zone: 'hourly_stats_aggregated_by_advertiser_time_zone',
        hourly_stats_aggregated_by_audience_time_zone: 'hourly_stats_aggregated_by_audience_time_zone',
        image_asset: 'image_asset',
        impression_device: 'impression_device',
        is_conversion_id_modeled: 'is_conversion_id_modeled',
        link_url_asset: 'link_url_asset',
        mmm: 'mmm',
        place_page_id: 'place_page_id',
        platform_position: 'platform_position',
        product_id: 'product_id',
        publisher_platform: 'publisher_platform',
        region: 'region',
        skan_campaign_id: 'skan_campaign_id',
        skan_conversion_id: 'skan_conversion_id',
        title_asset: 'title_asset',
        video_asset: 'video_asset'
      });
    }
  }, {
    key: 'DatePreset',
    get: function get() {
      return Object.freeze({
        data_maximum: 'data_maximum',
        last_14d: 'last_14d',
        last_28d: 'last_28d',
        last_30d: 'last_30d',
        last_3d: 'last_3d',
        last_7d: 'last_7d',
        last_90d: 'last_90d',
        last_month: 'last_month',
        last_quarter: 'last_quarter',
        last_week_mon_sun: 'last_week_mon_sun',
        last_week_sun_sat: 'last_week_sun_sat',
        last_year: 'last_year',
        maximum: 'maximum',
        this_month: 'this_month',
        this_quarter: 'this_quarter',
        this_week_mon_today: 'this_week_mon_today',
        this_week_sun_today: 'this_week_sun_today',
        this_year: 'this_year',
        today: 'today',
        yesterday: 'yesterday'
      });
    }
  }, {
    key: 'Level',
    get: function get() {
      return Object.freeze({
        account: 'account',
        ad: 'ad',
        adset: 'adset',
        campaign: 'campaign'
      });
    }
  }, {
    key: 'SummaryActionBreakdowns',
    get: function get() {
      return Object.freeze({
        action_canvas_component_name: 'action_canvas_component_name',
        action_carousel_card_id: 'action_carousel_card_id',
        action_carousel_card_name: 'action_carousel_card_name',
        action_destination: 'action_destination',
        action_device: 'action_device',
        action_reaction: 'action_reaction',
        action_target_id: 'action_target_id',
        action_type: 'action_type',
        action_video_sound: 'action_video_sound',
        action_video_type: 'action_video_type'
      });
    }
  }]);
  return AdsInsights;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdReportRun
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdReportRun = function (_AbstractCrudObject) {
  inherits(AdReportRun, _AbstractCrudObject);
  createClass(AdReportRun, [{
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsInsights, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        async_percent_completion: 'async_percent_completion',
        async_status: 'async_status',
        date_start: 'date_start',
        date_stop: 'date_stop',
        emails: 'emails',
        friendly_name: 'friendly_name',
        id: 'id',
        is_bookmarked: 'is_bookmarked',
        is_running: 'is_running',
        schedule_id: 'schedule_id',
        time_completed: 'time_completed',
        time_ref: 'time_ref'
      });
    }
  }]);

  function AdReportRun() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var parentId = arguments[2];
    var api = arguments[3];
    classCallCheck(this, AdReportRun);

    var _this = possibleConstructorReturn(this, (AdReportRun.__proto__ || Object.getPrototypeOf(AdReportRun)).call(this));

    _this.id = data.report_run_id;
    return _this;
  }

  return AdReportRun;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Lead
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Lead = function (_AbstractCrudObject) {
  inherits(Lead, _AbstractCrudObject);

  function Lead() {
    classCallCheck(this, Lead);
    return possibleConstructorReturn(this, (Lead.__proto__ || Object.getPrototypeOf(Lead)).apply(this, arguments));
  }

  createClass(Lead, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Lead.prototype.__proto__ || Object.getPrototypeOf(Lead.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_id: 'ad_id',
        ad_name: 'ad_name',
        adset_id: 'adset_id',
        adset_name: 'adset_name',
        campaign_id: 'campaign_id',
        campaign_name: 'campaign_name',
        created_time: 'created_time',
        custom_disclaimer_responses: 'custom_disclaimer_responses',
        field_data: 'field_data',
        form_id: 'form_id',
        home_listing: 'home_listing',
        id: 'id',
        is_organic: 'is_organic',
        partner_name: 'partner_name',
        platform: 'platform',
        post: 'post',
        retailer_item_id: 'retailer_item_id',
        vehicle: 'vehicle'
      });
    }
  }]);
  return Lead;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingSentenceLine
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingSentenceLine = function (_AbstractCrudObject) {
  inherits(TargetingSentenceLine, _AbstractCrudObject);

  function TargetingSentenceLine() {
    classCallCheck(this, TargetingSentenceLine);
    return possibleConstructorReturn(this, (TargetingSentenceLine.__proto__ || Object.getPrototypeOf(TargetingSentenceLine)).apply(this, arguments));
  }

  createClass(TargetingSentenceLine, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        params: 'params',
        targetingsentencelines: 'targetingsentencelines'
      });
    }
  }]);
  return TargetingSentenceLine;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Ad
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Ad = function (_AbstractCrudObject) {
  inherits(Ad, _AbstractCrudObject);

  function Ad() {
    classCallCheck(this, Ad);
    return possibleConstructorReturn(this, (Ad.__proto__ || Object.getPrototypeOf(Ad)).apply(this, arguments));
  }

  createClass(Ad, [{
    key: 'getAdCreatives',
    value: function getAdCreatives(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCreative, fields, params, fetchFirstPage, '/adcreatives');
    }
  }, {
    key: 'createAdLabel',
    value: function createAdLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adlabels', fields, params, Ad, pathOverride);
    }
  }, {
    key: 'getAdRulesGoverned',
    value: function getAdRulesGoverned(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdRule, fields, params, fetchFirstPage, '/adrules_governed');
    }
  }, {
    key: 'getCopies',
    value: function getCopies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/copies');
    }
  }, {
    key: 'createCopy',
    value: function createCopy(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/copies', fields, params, Ad, pathOverride);
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsInsights, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getInsightsAsync',
    value: function getInsightsAsync(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/insights', fields, params, AdReportRun, pathOverride);
    }
  }, {
    key: 'getLeads',
    value: function getLeads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Lead, fields, params, fetchFirstPage, '/leads');
    }
  }, {
    key: 'getPreviews',
    value: function getPreviews(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdPreview, fields, params, fetchFirstPage, '/previews');
    }
  }, {
    key: 'getTargetingSentenceLines',
    value: function getTargetingSentenceLines(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(TargetingSentenceLine, fields, params, fetchFirstPage, '/targetingsentencelines');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Ad.prototype.__proto__ || Object.getPrototypeOf(Ad.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Ad.prototype.__proto__ || Object.getPrototypeOf(Ad.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        ad_review_feedback: 'ad_review_feedback',
        adlabels: 'adlabels',
        adset: 'adset',
        adset_id: 'adset_id',
        bid_amount: 'bid_amount',
        bid_info: 'bid_info',
        bid_type: 'bid_type',
        campaign: 'campaign',
        campaign_id: 'campaign_id',
        configured_status: 'configured_status',
        conversion_domain: 'conversion_domain',
        conversion_specs: 'conversion_specs',
        created_time: 'created_time',
        creative: 'creative',
        demolink_hash: 'demolink_hash',
        display_sequence: 'display_sequence',
        effective_status: 'effective_status',
        engagement_audience: 'engagement_audience',
        failed_delivery_checks: 'failed_delivery_checks',
        id: 'id',
        issues_info: 'issues_info',
        last_updated_by_app_id: 'last_updated_by_app_id',
        name: 'name',
        preview_shareable_link: 'preview_shareable_link',
        priority: 'priority',
        recommendations: 'recommendations',
        source_ad: 'source_ad',
        source_ad_id: 'source_ad_id',
        status: 'status',
        targeting: 'targeting',
        tracking_and_conversion_with_defaults: 'tracking_and_conversion_with_defaults',
        tracking_specs: 'tracking_specs',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'BidType',
    get: function get() {
      return Object.freeze({
        absolute_ocpm: 'ABSOLUTE_OCPM',
        cpa: 'CPA',
        cpc: 'CPC',
        cpm: 'CPM',
        multi_premium: 'MULTI_PREMIUM'
      });
    }
  }, {
    key: 'ConfiguredStatus',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        paused: 'PAUSED'
      });
    }
  }, {
    key: 'EffectiveStatus',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        adset_paused: 'ADSET_PAUSED',
        archived: 'ARCHIVED',
        campaign_paused: 'CAMPAIGN_PAUSED',
        deleted: 'DELETED',
        disapproved: 'DISAPPROVED',
        in_process: 'IN_PROCESS',
        paused: 'PAUSED',
        pending_billing_info: 'PENDING_BILLING_INFO',
        pending_review: 'PENDING_REVIEW',
        preapproved: 'PREAPPROVED',
        with_issues: 'WITH_ISSUES'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        paused: 'PAUSED'
      });
    }
  }, {
    key: 'DatePreset',
    get: function get() {
      return Object.freeze({
        data_maximum: 'data_maximum',
        last_14d: 'last_14d',
        last_28d: 'last_28d',
        last_30d: 'last_30d',
        last_3d: 'last_3d',
        last_7d: 'last_7d',
        last_90d: 'last_90d',
        last_month: 'last_month',
        last_quarter: 'last_quarter',
        last_week_mon_sun: 'last_week_mon_sun',
        last_week_sun_sat: 'last_week_sun_sat',
        last_year: 'last_year',
        maximum: 'maximum',
        this_month: 'this_month',
        this_quarter: 'this_quarter',
        this_week_mon_today: 'this_week_mon_today',
        this_week_sun_today: 'this_week_sun_today',
        this_year: 'this_year',
        today: 'today',
        yesterday: 'yesterday'
      });
    }
  }, {
    key: 'ExecutionOptions',
    get: function get() {
      return Object.freeze({
        include_recommendations: 'include_recommendations',
        synchronous_ad_review: 'synchronous_ad_review',
        validate_only: 'validate_only'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        any: 'ANY'
      });
    }
  }, {
    key: 'StatusOption',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        inherited_from_source: 'INHERITED_FROM_SOURCE',
        paused: 'PAUSED'
      });
    }
  }]);
  return Ad;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAsyncRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAsyncRequest = function (_AbstractCrudObject) {
  inherits(AdAsyncRequest, _AbstractCrudObject);

  function AdAsyncRequest() {
    classCallCheck(this, AdAsyncRequest);
    return possibleConstructorReturn(this, (AdAsyncRequest.__proto__ || Object.getPrototypeOf(AdAsyncRequest)).apply(this, arguments));
  }

  createClass(AdAsyncRequest, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdAsyncRequest.prototype.__proto__ || Object.getPrototypeOf(AdAsyncRequest.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        async_request_set: 'async_request_set',
        created_time: 'created_time',
        id: 'id',
        input: 'input',
        result: 'result',
        scope_object_id: 'scope_object_id',
        status: 'status',
        type: 'type',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'Statuses',
    get: function get() {
      return Object.freeze({
        canceled: 'CANCELED',
        canceled_dependency: 'CANCELED_DEPENDENCY',
        error: 'ERROR',
        error_conflicts: 'ERROR_CONFLICTS',
        error_dependency: 'ERROR_DEPENDENCY',
        initial: 'INITIAL',
        in_progress: 'IN_PROGRESS',
        pending_dependency: 'PENDING_DEPENDENCY',
        process_by_ad_async_engine: 'PROCESS_BY_AD_ASYNC_ENGINE',
        process_by_event_processor: 'PROCESS_BY_EVENT_PROCESSOR',
        success: 'SUCCESS',
        user_canceled: 'USER_CANCELED',
        user_canceled_dependency: 'USER_CANCELED_DEPENDENCY'
      });
    }
  }]);
  return AdAsyncRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignDeliveryEstimate
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignDeliveryEstimate = function (_AbstractCrudObject) {
  inherits(AdCampaignDeliveryEstimate, _AbstractCrudObject);

  function AdCampaignDeliveryEstimate() {
    classCallCheck(this, AdCampaignDeliveryEstimate);
    return possibleConstructorReturn(this, (AdCampaignDeliveryEstimate.__proto__ || Object.getPrototypeOf(AdCampaignDeliveryEstimate)).apply(this, arguments));
  }

  createClass(AdCampaignDeliveryEstimate, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        daily_outcomes_curve: 'daily_outcomes_curve',
        estimate_dau: 'estimate_dau',
        estimate_mau_lower_bound: 'estimate_mau_lower_bound',
        estimate_mau_upper_bound: 'estimate_mau_upper_bound',
        estimate_ready: 'estimate_ready',
        targeting_optimization_types: 'targeting_optimization_types'
      });
    }
  }, {
    key: 'OptimizationGoal',
    get: function get() {
      return Object.freeze({
        ad_recall_lift: 'AD_RECALL_LIFT',
        app_installs: 'APP_INSTALLS',
        app_installs_and_offsite_conversions: 'APP_INSTALLS_AND_OFFSITE_CONVERSIONS',
        conversations: 'CONVERSATIONS',
        derived_events: 'DERIVED_EVENTS',
        engaged_users: 'ENGAGED_USERS',
        event_responses: 'EVENT_RESPONSES',
        impressions: 'IMPRESSIONS',
        in_app_value: 'IN_APP_VALUE',
        landing_page_views: 'LANDING_PAGE_VIEWS',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        messaging_appointment_conversion: 'MESSAGING_APPOINTMENT_CONVERSION',
        messaging_purchase_conversion: 'MESSAGING_PURCHASE_CONVERSION',
        none: 'NONE',
        offsite_conversions: 'OFFSITE_CONVERSIONS',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        quality_call: 'QUALITY_CALL',
        quality_lead: 'QUALITY_LEAD',
        reach: 'REACH',
        thruplay: 'THRUPLAY',
        value: 'VALUE',
        visit_instagram_profile: 'VISIT_INSTAGRAM_PROFILE'
      });
    }
  }]);
  return AdCampaignDeliveryEstimate;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdSet
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdSet = function (_AbstractCrudObject) {
  inherits(AdSet, _AbstractCrudObject);

  function AdSet() {
    classCallCheck(this, AdSet);
    return possibleConstructorReturn(this, (AdSet.__proto__ || Object.getPrototypeOf(AdSet)).apply(this, arguments));
  }

  createClass(AdSet, [{
    key: 'getActivities',
    value: function getActivities(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdActivity, fields, params, fetchFirstPage, '/activities');
    }
  }, {
    key: 'getAdStudies',
    value: function getAdStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudy, fields, params, fetchFirstPage, '/ad_studies');
    }
  }, {
    key: 'getAdCreatives',
    value: function getAdCreatives(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCreative, fields, params, fetchFirstPage, '/adcreatives');
    }
  }, {
    key: 'deleteAdLabels',
    value: function deleteAdLabels() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdSet.prototype.__proto__ || Object.getPrototypeOf(AdSet.prototype), 'deleteEdge', this).call(this, '/adlabels', params);
    }
  }, {
    key: 'createAdLabel',
    value: function createAdLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adlabels', fields, params, AdSet, pathOverride);
    }
  }, {
    key: 'getAdRulesGoverned',
    value: function getAdRulesGoverned(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdRule, fields, params, fetchFirstPage, '/adrules_governed');
    }
  }, {
    key: 'getAds',
    value: function getAds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/ads');
    }
  }, {
    key: 'getAsyncAdRequests',
    value: function getAsyncAdRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAsyncRequest, fields, params, fetchFirstPage, '/asyncadrequests');
    }
  }, {
    key: 'getCopies',
    value: function getCopies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/copies');
    }
  }, {
    key: 'createCopy',
    value: function createCopy(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/copies', fields, params, AdSet, pathOverride);
    }
  }, {
    key: 'getDeliveryEstimate',
    value: function getDeliveryEstimate(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCampaignDeliveryEstimate, fields, params, fetchFirstPage, '/delivery_estimate');
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsInsights, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getInsightsAsync',
    value: function getInsightsAsync(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/insights', fields, params, AdReportRun, pathOverride);
    }
  }, {
    key: 'getTargetingSentenceLines',
    value: function getTargetingSentenceLines(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(TargetingSentenceLine, fields, params, fetchFirstPage, '/targetingsentencelines');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdSet.prototype.__proto__ || Object.getPrototypeOf(AdSet.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdSet.prototype.__proto__ || Object.getPrototypeOf(AdSet.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        adlabels: 'adlabels',
        adset_schedule: 'adset_schedule',
        asset_feed_id: 'asset_feed_id',
        attribution_spec: 'attribution_spec',
        bid_adjustments: 'bid_adjustments',
        bid_amount: 'bid_amount',
        bid_constraints: 'bid_constraints',
        bid_info: 'bid_info',
        bid_strategy: 'bid_strategy',
        billing_event: 'billing_event',
        budget_remaining: 'budget_remaining',
        campaign: 'campaign',
        campaign_attribution: 'campaign_attribution',
        campaign_id: 'campaign_id',
        configured_status: 'configured_status',
        created_time: 'created_time',
        creative_sequence: 'creative_sequence',
        daily_budget: 'daily_budget',
        daily_min_spend_target: 'daily_min_spend_target',
        daily_spend_cap: 'daily_spend_cap',
        destination_type: 'destination_type',
        effective_status: 'effective_status',
        end_time: 'end_time',
        existing_customer_budget_percentage: 'existing_customer_budget_percentage',
        frequency_control_specs: 'frequency_control_specs',
        full_funnel_exploration_mode: 'full_funnel_exploration_mode',
        id: 'id',
        instagram_actor_id: 'instagram_actor_id',
        is_dynamic_creative: 'is_dynamic_creative',
        issues_info: 'issues_info',
        learning_stage_info: 'learning_stage_info',
        lifetime_budget: 'lifetime_budget',
        lifetime_imps: 'lifetime_imps',
        lifetime_min_spend_target: 'lifetime_min_spend_target',
        lifetime_spend_cap: 'lifetime_spend_cap',
        multi_optimization_goal_weight: 'multi_optimization_goal_weight',
        name: 'name',
        optimization_goal: 'optimization_goal',
        optimization_sub_event: 'optimization_sub_event',
        pacing_type: 'pacing_type',
        promoted_object: 'promoted_object',
        recommendations: 'recommendations',
        recurring_budget_semantics: 'recurring_budget_semantics',
        review_feedback: 'review_feedback',
        rf_prediction_id: 'rf_prediction_id',
        source_adset: 'source_adset',
        source_adset_id: 'source_adset_id',
        start_time: 'start_time',
        status: 'status',
        targeting: 'targeting',
        targeting_optimization_types: 'targeting_optimization_types',
        time_based_ad_rotation_id_blocks: 'time_based_ad_rotation_id_blocks',
        time_based_ad_rotation_intervals: 'time_based_ad_rotation_intervals',
        updated_time: 'updated_time',
        use_new_app_click: 'use_new_app_click'
      });
    }
  }, {
    key: 'BidStrategy',
    get: function get() {
      return Object.freeze({
        cost_cap: 'COST_CAP',
        lowest_cost_without_cap: 'LOWEST_COST_WITHOUT_CAP',
        lowest_cost_with_bid_cap: 'LOWEST_COST_WITH_BID_CAP'
      });
    }
  }, {
    key: 'BillingEvent',
    get: function get() {
      return Object.freeze({
        app_installs: 'APP_INSTALLS',
        clicks: 'CLICKS',
        impressions: 'IMPRESSIONS',
        link_clicks: 'LINK_CLICKS',
        listing_interaction: 'LISTING_INTERACTION',
        none: 'NONE',
        offer_claims: 'OFFER_CLAIMS',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        purchase: 'PURCHASE',
        thruplay: 'THRUPLAY'
      });
    }
  }, {
    key: 'ConfiguredStatus',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        paused: 'PAUSED'
      });
    }
  }, {
    key: 'EffectiveStatus',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        campaign_paused: 'CAMPAIGN_PAUSED',
        deleted: 'DELETED',
        in_process: 'IN_PROCESS',
        paused: 'PAUSED',
        with_issues: 'WITH_ISSUES'
      });
    }
  }, {
    key: 'OptimizationGoal',
    get: function get() {
      return Object.freeze({
        ad_recall_lift: 'AD_RECALL_LIFT',
        app_installs: 'APP_INSTALLS',
        app_installs_and_offsite_conversions: 'APP_INSTALLS_AND_OFFSITE_CONVERSIONS',
        conversations: 'CONVERSATIONS',
        derived_events: 'DERIVED_EVENTS',
        engaged_users: 'ENGAGED_USERS',
        event_responses: 'EVENT_RESPONSES',
        impressions: 'IMPRESSIONS',
        in_app_value: 'IN_APP_VALUE',
        landing_page_views: 'LANDING_PAGE_VIEWS',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        messaging_appointment_conversion: 'MESSAGING_APPOINTMENT_CONVERSION',
        messaging_purchase_conversion: 'MESSAGING_PURCHASE_CONVERSION',
        none: 'NONE',
        offsite_conversions: 'OFFSITE_CONVERSIONS',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        quality_call: 'QUALITY_CALL',
        quality_lead: 'QUALITY_LEAD',
        reach: 'REACH',
        thruplay: 'THRUPLAY',
        value: 'VALUE',
        visit_instagram_profile: 'VISIT_INSTAGRAM_PROFILE'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        paused: 'PAUSED'
      });
    }
  }, {
    key: 'DatePreset',
    get: function get() {
      return Object.freeze({
        data_maximum: 'data_maximum',
        last_14d: 'last_14d',
        last_28d: 'last_28d',
        last_30d: 'last_30d',
        last_3d: 'last_3d',
        last_7d: 'last_7d',
        last_90d: 'last_90d',
        last_month: 'last_month',
        last_quarter: 'last_quarter',
        last_week_mon_sun: 'last_week_mon_sun',
        last_week_sun_sat: 'last_week_sun_sat',
        last_year: 'last_year',
        maximum: 'maximum',
        this_month: 'this_month',
        this_quarter: 'this_quarter',
        this_week_mon_today: 'this_week_mon_today',
        this_week_sun_today: 'this_week_sun_today',
        this_year: 'this_year',
        today: 'today',
        yesterday: 'yesterday'
      });
    }
  }, {
    key: 'DestinationType',
    get: function get() {
      return Object.freeze({
        app: 'APP',
        applinks_automatic: 'APPLINKS_AUTOMATIC',
        facebook: 'FACEBOOK',
        messenger: 'MESSENGER',
        undefined: 'UNDEFINED',
        website: 'WEBSITE'
      });
    }
  }, {
    key: 'ExecutionOptions',
    get: function get() {
      return Object.freeze({
        include_recommendations: 'include_recommendations',
        validate_only: 'validate_only'
      });
    }
  }, {
    key: 'FullFunnelExplorationMode',
    get: function get() {
      return Object.freeze({
        extended_exploration: 'EXTENDED_EXPLORATION',
        limited_exploration: 'LIMITED_EXPLORATION',
        none_exploration: 'NONE_EXPLORATION'
      });
    }
  }, {
    key: 'MultiOptimizationGoalWeight',
    get: function get() {
      return Object.freeze({
        balanced: 'BALANCED',
        prefer_event: 'PREFER_EVENT',
        prefer_install: 'PREFER_INSTALL',
        undefined: 'UNDEFINED'
      });
    }
  }, {
    key: 'OptimizationSubEvent',
    get: function get() {
      return Object.freeze({
        none: 'NONE',
        travel_intent: 'TRAVEL_INTENT',
        travel_intent_bucket_01: 'TRAVEL_INTENT_BUCKET_01',
        travel_intent_bucket_02: 'TRAVEL_INTENT_BUCKET_02',
        travel_intent_bucket_03: 'TRAVEL_INTENT_BUCKET_03',
        travel_intent_bucket_04: 'TRAVEL_INTENT_BUCKET_04',
        travel_intent_bucket_05: 'TRAVEL_INTENT_BUCKET_05',
        travel_intent_no_destination_intent: 'TRAVEL_INTENT_NO_DESTINATION_INTENT',
        trip_consideration: 'TRIP_CONSIDERATION',
        video_sound_on: 'VIDEO_SOUND_ON'
      });
    }
  }, {
    key: 'TuneForCategory',
    get: function get() {
      return Object.freeze({
        credit: 'CREDIT',
        employment: 'EMPLOYMENT',
        housing: 'HOUSING',
        issues_elections_politics: 'ISSUES_ELECTIONS_POLITICS',
        none: 'NONE',
        online_gambling_and_gaming: 'ONLINE_GAMBLING_AND_GAMING'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        any: 'ANY'
      });
    }
  }, {
    key: 'StatusOption',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        inherited_from_source: 'INHERITED_FROM_SOURCE',
        paused: 'PAUSED'
      });
    }
  }]);
  return AdSet;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Campaign
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Campaign = function (_AbstractCrudObject) {
  inherits(Campaign, _AbstractCrudObject);

  function Campaign() {
    classCallCheck(this, Campaign);
    return possibleConstructorReturn(this, (Campaign.__proto__ || Object.getPrototypeOf(Campaign)).apply(this, arguments));
  }

  createClass(Campaign, [{
    key: 'getAdStudies',
    value: function getAdStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudy, fields, params, fetchFirstPage, '/ad_studies');
    }
  }, {
    key: 'createAdLabel',
    value: function createAdLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adlabels', fields, params, Campaign, pathOverride);
    }
  }, {
    key: 'getAdRulesGoverned',
    value: function getAdRulesGoverned(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdRule, fields, params, fetchFirstPage, '/adrules_governed');
    }
  }, {
    key: 'getAds',
    value: function getAds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/ads');
    }
  }, {
    key: 'getAdSets',
    value: function getAdSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/adsets');
    }
  }, {
    key: 'getCopies',
    value: function getCopies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Campaign, fields, params, fetchFirstPage, '/copies');
    }
  }, {
    key: 'createCopy',
    value: function createCopy(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/copies', fields, params, Campaign, pathOverride);
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsInsights, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getInsightsAsync',
    value: function getInsightsAsync(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/insights', fields, params, AdReportRun, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Campaign.prototype.__proto__ || Object.getPrototypeOf(Campaign.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Campaign.prototype.__proto__ || Object.getPrototypeOf(Campaign.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        ad_strategy_group_id: 'ad_strategy_group_id',
        ad_strategy_id: 'ad_strategy_id',
        adlabels: 'adlabels',
        bid_strategy: 'bid_strategy',
        boosted_object_id: 'boosted_object_id',
        brand_lift_studies: 'brand_lift_studies',
        budget_rebalance_flag: 'budget_rebalance_flag',
        budget_remaining: 'budget_remaining',
        buying_type: 'buying_type',
        can_create_brand_lift_study: 'can_create_brand_lift_study',
        can_use_spend_cap: 'can_use_spend_cap',
        configured_status: 'configured_status',
        created_time: 'created_time',
        daily_budget: 'daily_budget',
        effective_status: 'effective_status',
        has_secondary_skadnetwork_reporting: 'has_secondary_skadnetwork_reporting',
        id: 'id',
        is_skadnetwork_attribution: 'is_skadnetwork_attribution',
        issues_info: 'issues_info',
        last_budget_toggling_time: 'last_budget_toggling_time',
        lifetime_budget: 'lifetime_budget',
        name: 'name',
        objective: 'objective',
        pacing_type: 'pacing_type',
        primary_attribution: 'primary_attribution',
        promoted_object: 'promoted_object',
        recommendations: 'recommendations',
        smart_promotion_type: 'smart_promotion_type',
        source_campaign: 'source_campaign',
        source_campaign_id: 'source_campaign_id',
        special_ad_categories: 'special_ad_categories',
        special_ad_category: 'special_ad_category',
        special_ad_category_country: 'special_ad_category_country',
        spend_cap: 'spend_cap',
        start_time: 'start_time',
        status: 'status',
        stop_time: 'stop_time',
        topline_id: 'topline_id',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'BidStrategy',
    get: function get() {
      return Object.freeze({
        cost_cap: 'COST_CAP',
        lowest_cost_without_cap: 'LOWEST_COST_WITHOUT_CAP',
        lowest_cost_with_bid_cap: 'LOWEST_COST_WITH_BID_CAP'
      });
    }
  }, {
    key: 'ConfiguredStatus',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        paused: 'PAUSED'
      });
    }
  }, {
    key: 'EffectiveStatus',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        in_process: 'IN_PROCESS',
        paused: 'PAUSED',
        with_issues: 'WITH_ISSUES'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        paused: 'PAUSED'
      });
    }
  }, {
    key: 'DatePreset',
    get: function get() {
      return Object.freeze({
        data_maximum: 'data_maximum',
        last_14d: 'last_14d',
        last_28d: 'last_28d',
        last_30d: 'last_30d',
        last_3d: 'last_3d',
        last_7d: 'last_7d',
        last_90d: 'last_90d',
        last_month: 'last_month',
        last_quarter: 'last_quarter',
        last_week_mon_sun: 'last_week_mon_sun',
        last_week_sun_sat: 'last_week_sun_sat',
        last_year: 'last_year',
        maximum: 'maximum',
        this_month: 'this_month',
        this_quarter: 'this_quarter',
        this_week_mon_today: 'this_week_mon_today',
        this_week_sun_today: 'this_week_sun_today',
        this_year: 'this_year',
        today: 'today',
        yesterday: 'yesterday'
      });
    }
  }, {
    key: 'ExecutionOptions',
    get: function get() {
      return Object.freeze({
        include_recommendations: 'include_recommendations',
        validate_only: 'validate_only'
      });
    }
  }, {
    key: 'Objective',
    get: function get() {
      return Object.freeze({
        app_installs: 'APP_INSTALLS',
        brand_awareness: 'BRAND_AWARENESS',
        conversions: 'CONVERSIONS',
        event_responses: 'EVENT_RESPONSES',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        local_awareness: 'LOCAL_AWARENESS',
        messages: 'MESSAGES',
        offer_claims: 'OFFER_CLAIMS',
        outcome_app_promotion: 'OUTCOME_APP_PROMOTION',
        outcome_awareness: 'OUTCOME_AWARENESS',
        outcome_engagement: 'OUTCOME_ENGAGEMENT',
        outcome_leads: 'OUTCOME_LEADS',
        outcome_sales: 'OUTCOME_SALES',
        outcome_traffic: 'OUTCOME_TRAFFIC',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        product_catalog_sales: 'PRODUCT_CATALOG_SALES',
        reach: 'REACH',
        store_visits: 'STORE_VISITS',
        video_views: 'VIDEO_VIEWS'
      });
    }
  }, {
    key: 'SmartPromotionType',
    get: function get() {
      return Object.freeze({
        guided_creation: 'GUIDED_CREATION',
        smart_app_promotion: 'SMART_APP_PROMOTION'
      });
    }
  }, {
    key: 'SpecialAdCategories',
    get: function get() {
      return Object.freeze({
        credit: 'CREDIT',
        employment: 'EMPLOYMENT',
        housing: 'HOUSING',
        issues_elections_politics: 'ISSUES_ELECTIONS_POLITICS',
        none: 'NONE',
        online_gambling_and_gaming: 'ONLINE_GAMBLING_AND_GAMING'
      });
    }
  }, {
    key: 'SpecialAdCategoryCountry',
    get: function get() {
      return Object.freeze({
        ad: 'AD',
        ae: 'AE',
        af: 'AF',
        ag: 'AG',
        ai: 'AI',
        al: 'AL',
        am: 'AM',
        an: 'AN',
        ao: 'AO',
        aq: 'AQ',
        ar: 'AR',
        as: 'AS',
        at: 'AT',
        au: 'AU',
        aw: 'AW',
        ax: 'AX',
        az: 'AZ',
        ba: 'BA',
        bb: 'BB',
        bd: 'BD',
        be: 'BE',
        bf: 'BF',
        bg: 'BG',
        bh: 'BH',
        bi: 'BI',
        bj: 'BJ',
        bl: 'BL',
        bm: 'BM',
        bn: 'BN',
        bo: 'BO',
        bq: 'BQ',
        br: 'BR',
        bs: 'BS',
        bt: 'BT',
        bv: 'BV',
        bw: 'BW',
        by: 'BY',
        bz: 'BZ',
        ca: 'CA',
        cc: 'CC',
        cd: 'CD',
        cf: 'CF',
        cg: 'CG',
        ch: 'CH',
        ci: 'CI',
        ck: 'CK',
        cl: 'CL',
        cm: 'CM',
        cn: 'CN',
        co: 'CO',
        cr: 'CR',
        cu: 'CU',
        cv: 'CV',
        cw: 'CW',
        cx: 'CX',
        cy: 'CY',
        cz: 'CZ',
        de: 'DE',
        dj: 'DJ',
        dk: 'DK',
        dm: 'DM',
        do: 'DO',
        dz: 'DZ',
        ec: 'EC',
        ee: 'EE',
        eg: 'EG',
        eh: 'EH',
        er: 'ER',
        es: 'ES',
        et: 'ET',
        fi: 'FI',
        fj: 'FJ',
        fk: 'FK',
        fm: 'FM',
        fo: 'FO',
        fr: 'FR',
        ga: 'GA',
        gb: 'GB',
        gd: 'GD',
        ge: 'GE',
        gf: 'GF',
        gg: 'GG',
        gh: 'GH',
        gi: 'GI',
        gl: 'GL',
        gm: 'GM',
        gn: 'GN',
        gp: 'GP',
        gq: 'GQ',
        gr: 'GR',
        gs: 'GS',
        gt: 'GT',
        gu: 'GU',
        gw: 'GW',
        gy: 'GY',
        hk: 'HK',
        hm: 'HM',
        hn: 'HN',
        hr: 'HR',
        ht: 'HT',
        hu: 'HU',
        id: 'ID',
        ie: 'IE',
        il: 'IL',
        im: 'IM',
        in: 'IN',
        io: 'IO',
        iq: 'IQ',
        ir: 'IR',
        is: 'IS',
        it: 'IT',
        je: 'JE',
        jm: 'JM',
        jo: 'JO',
        jp: 'JP',
        ke: 'KE',
        kg: 'KG',
        kh: 'KH',
        ki: 'KI',
        km: 'KM',
        kn: 'KN',
        kp: 'KP',
        kr: 'KR',
        kw: 'KW',
        ky: 'KY',
        kz: 'KZ',
        la: 'LA',
        lb: 'LB',
        lc: 'LC',
        li: 'LI',
        lk: 'LK',
        lr: 'LR',
        ls: 'LS',
        lt: 'LT',
        lu: 'LU',
        lv: 'LV',
        ly: 'LY',
        ma: 'MA',
        mc: 'MC',
        md: 'MD',
        me: 'ME',
        mf: 'MF',
        mg: 'MG',
        mh: 'MH',
        mk: 'MK',
        ml: 'ML',
        mm: 'MM',
        mn: 'MN',
        mo: 'MO',
        mp: 'MP',
        mq: 'MQ',
        mr: 'MR',
        ms: 'MS',
        mt: 'MT',
        mu: 'MU',
        mv: 'MV',
        mw: 'MW',
        mx: 'MX',
        my: 'MY',
        mz: 'MZ',
        na: 'NA',
        nc: 'NC',
        ne: 'NE',
        nf: 'NF',
        ng: 'NG',
        ni: 'NI',
        nl: 'NL',
        no: 'NO',
        np: 'NP',
        nr: 'NR',
        nu: 'NU',
        nz: 'NZ',
        om: 'OM',
        pa: 'PA',
        pe: 'PE',
        pf: 'PF',
        pg: 'PG',
        ph: 'PH',
        pk: 'PK',
        pl: 'PL',
        pm: 'PM',
        pn: 'PN',
        pr: 'PR',
        ps: 'PS',
        pt: 'PT',
        pw: 'PW',
        py: 'PY',
        qa: 'QA',
        re: 'RE',
        ro: 'RO',
        rs: 'RS',
        ru: 'RU',
        rw: 'RW',
        sa: 'SA',
        sb: 'SB',
        sc: 'SC',
        sd: 'SD',
        se: 'SE',
        sg: 'SG',
        sh: 'SH',
        si: 'SI',
        sj: 'SJ',
        sk: 'SK',
        sl: 'SL',
        sm: 'SM',
        sn: 'SN',
        so: 'SO',
        sr: 'SR',
        ss: 'SS',
        st: 'ST',
        sv: 'SV',
        sx: 'SX',
        sy: 'SY',
        sz: 'SZ',
        tc: 'TC',
        td: 'TD',
        tf: 'TF',
        tg: 'TG',
        th: 'TH',
        tj: 'TJ',
        tk: 'TK',
        tl: 'TL',
        tm: 'TM',
        tn: 'TN',
        to: 'TO',
        tr: 'TR',
        tt: 'TT',
        tv: 'TV',
        tw: 'TW',
        tz: 'TZ',
        ua: 'UA',
        ug: 'UG',
        um: 'UM',
        us: 'US',
        uy: 'UY',
        uz: 'UZ',
        va: 'VA',
        vc: 'VC',
        ve: 'VE',
        vg: 'VG',
        vi: 'VI',
        vn: 'VN',
        vu: 'VU',
        wf: 'WF',
        ws: 'WS',
        xk: 'XK',
        ye: 'YE',
        yt: 'YT',
        za: 'ZA',
        zm: 'ZM',
        zw: 'ZW'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        any: 'ANY'
      });
    }
  }, {
    key: 'SpecialAdCategory',
    get: function get() {
      return Object.freeze({
        credit: 'CREDIT',
        employment: 'EMPLOYMENT',
        housing: 'HOUSING',
        issues_elections_politics: 'ISSUES_ELECTIONS_POLITICS',
        none: 'NONE',
        online_gambling_and_gaming: 'ONLINE_GAMBLING_AND_GAMING'
      });
    }
  }, {
    key: 'StatusOption',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        inherited_from_source: 'INHERITED_FROM_SOURCE',
        paused: 'PAUSED'
      });
    }
  }]);
  return Campaign;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdStudyCell
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdStudyCell = function (_AbstractCrudObject) {
  inherits(AdStudyCell, _AbstractCrudObject);

  function AdStudyCell() {
    classCallCheck(this, AdStudyCell);
    return possibleConstructorReturn(this, (AdStudyCell.__proto__ || Object.getPrototypeOf(AdStudyCell)).apply(this, arguments));
  }

  createClass(AdStudyCell, [{
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/adaccounts');
    }
  }, {
    key: 'getAdSets',
    value: function getAdSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/adsets');
    }
  }, {
    key: 'getCampaigns',
    value: function getCampaigns(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Campaign, fields, params, fetchFirstPage, '/campaigns');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdStudyCell.prototype.__proto__ || Object.getPrototypeOf(AdStudyCell.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_entities_count: 'ad_entities_count',
        control_percentage: 'control_percentage',
        id: 'id',
        name: 'name',
        treatment_percentage: 'treatment_percentage'
      });
    }
  }, {
    key: 'CreationTemplate',
    get: function get() {
      return Object.freeze({
        automatic_placements: 'AUTOMATIC_PLACEMENTS',
        brand_awareness: 'BRAND_AWARENESS',
        facebook: 'FACEBOOK',
        facebook_audience_network: 'FACEBOOK_AUDIENCE_NETWORK',
        facebook_instagram: 'FACEBOOK_INSTAGRAM',
        facebook_news_feed: 'FACEBOOK_NEWS_FEED',
        facebook_news_feed_in_stream_video: 'FACEBOOK_NEWS_FEED_IN_STREAM_VIDEO',
        high_frequency: 'HIGH_FREQUENCY',
        instagram: 'INSTAGRAM',
        in_stream_video: 'IN_STREAM_VIDEO',
        low_frequency: 'LOW_FREQUENCY',
        medium_frequency: 'MEDIUM_FREQUENCY',
        mobile_optimized_video: 'MOBILE_OPTIMIZED_VIDEO',
        page_post_engagement: 'PAGE_POST_ENGAGEMENT',
        reach: 'REACH',
        tv_commercial: 'TV_COMMERCIAL',
        tv_facebook: 'TV_FACEBOOK',
        video_view_optimization: 'VIDEO_VIEW_OPTIMIZATION'
      });
    }
  }]);
  return AdStudyCell;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PrivateLiftStudyInstance
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PrivateLiftStudyInstance = function (_AbstractCrudObject) {
  inherits(PrivateLiftStudyInstance, _AbstractCrudObject);

  function PrivateLiftStudyInstance() {
    classCallCheck(this, PrivateLiftStudyInstance);
    return possibleConstructorReturn(this, (PrivateLiftStudyInstance.__proto__ || Object.getPrototypeOf(PrivateLiftStudyInstance)).apply(this, arguments));
  }

  createClass(PrivateLiftStudyInstance, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PrivateLiftStudyInstance.prototype.__proto__ || Object.getPrototypeOf(PrivateLiftStudyInstance.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        breakdown_key: 'breakdown_key',
        created_time: 'created_time',
        feature_list: 'feature_list',
        id: 'id',
        issuer_certificate: 'issuer_certificate',
        latest_status_update_time: 'latest_status_update_time',
        run_id: 'run_id',
        server_hostnames: 'server_hostnames',
        server_ips: 'server_ips',
        status: 'status',
        tier: 'tier'
      });
    }
  }, {
    key: 'Operation',
    get: function get() {
      return Object.freeze({
        aggregate: 'AGGREGATE',
        cancel: 'CANCEL',
        compute: 'COMPUTE',
        id_match: 'ID_MATCH',
        next: 'NEXT',
        none: 'NONE'
      });
    }
  }]);
  return PrivateLiftStudyInstance;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdPlacement
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdPlacement = function (_AbstractCrudObject) {
  inherits(AdPlacement, _AbstractCrudObject);

  function AdPlacement() {
    classCallCheck(this, AdPlacement);
    return possibleConstructorReturn(this, (AdPlacement.__proto__ || Object.getPrototypeOf(AdPlacement)).apply(this, arguments));
  }

  createClass(AdPlacement, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        bundle_id: 'bundle_id',
        display_format: 'display_format',
        external_placement_id: 'external_placement_id',
        google_display_format: 'google_display_format',
        id: 'id',
        name: 'name',
        placement_group: 'placement_group',
        platform: 'platform',
        status: 'status'
      });
    }
  }]);
  return AdPlacement;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdNetworkAnalyticsSyncQueryResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdNetworkAnalyticsSyncQueryResult = function (_AbstractCrudObject) {
  inherits(AdNetworkAnalyticsSyncQueryResult, _AbstractCrudObject);

  function AdNetworkAnalyticsSyncQueryResult() {
    classCallCheck(this, AdNetworkAnalyticsSyncQueryResult);
    return possibleConstructorReturn(this, (AdNetworkAnalyticsSyncQueryResult.__proto__ || Object.getPrototypeOf(AdNetworkAnalyticsSyncQueryResult)).apply(this, arguments));
  }

  createClass(AdNetworkAnalyticsSyncQueryResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        omitted_results: 'omitted_results',
        query_id: 'query_id',
        results: 'results'
      });
    }
  }, {
    key: 'AggregationPeriod',
    get: function get() {
      return Object.freeze({
        day: 'DAY',
        total: 'TOTAL'
      });
    }
  }, {
    key: 'Breakdowns',
    get: function get() {
      return Object.freeze({
        ad_server_campaign_id: 'AD_SERVER_CAMPAIGN_ID',
        ad_space: 'AD_SPACE',
        age: 'AGE',
        app: 'APP',
        clicked_view_tag: 'CLICKED_VIEW_TAG',
        country: 'COUNTRY',
        deal: 'DEAL',
        deal_ad: 'DEAL_AD',
        deal_page: 'DEAL_PAGE',
        delivery_method: 'DELIVERY_METHOD',
        display_format: 'DISPLAY_FORMAT',
        fail_reason: 'FAIL_REASON',
        gender: 'GENDER',
        instant_article_id: 'INSTANT_ARTICLE_ID',
        instant_article_page_id: 'INSTANT_ARTICLE_PAGE_ID',
        is_deal_backfill: 'IS_DEAL_BACKFILL',
        placement: 'PLACEMENT',
        placement_name: 'PLACEMENT_NAME',
        platform: 'PLATFORM',
        property: 'PROPERTY',
        sdk_version: 'SDK_VERSION'
      });
    }
  }, {
    key: 'Metrics',
    get: function get() {
      return Object.freeze({
        fb_ad_network_bidding_bid_rate: 'FB_AD_NETWORK_BIDDING_BID_RATE',
        fb_ad_network_bidding_request: 'FB_AD_NETWORK_BIDDING_REQUEST',
        fb_ad_network_bidding_response: 'FB_AD_NETWORK_BIDDING_RESPONSE',
        fb_ad_network_bidding_revenue: 'FB_AD_NETWORK_BIDDING_REVENUE',
        fb_ad_network_bidding_win_rate: 'FB_AD_NETWORK_BIDDING_WIN_RATE',
        fb_ad_network_click: 'FB_AD_NETWORK_CLICK',
        fb_ad_network_cpm: 'FB_AD_NETWORK_CPM',
        fb_ad_network_ctr: 'FB_AD_NETWORK_CTR',
        fb_ad_network_filled_request: 'FB_AD_NETWORK_FILLED_REQUEST',
        fb_ad_network_fill_rate: 'FB_AD_NETWORK_FILL_RATE',
        fb_ad_network_imp: 'FB_AD_NETWORK_IMP',
        fb_ad_network_impression_rate: 'FB_AD_NETWORK_IMPRESSION_RATE',
        fb_ad_network_request: 'FB_AD_NETWORK_REQUEST',
        fb_ad_network_revenue: 'FB_AD_NETWORK_REVENUE',
        fb_ad_network_show_rate: 'FB_AD_NETWORK_SHOW_RATE',
        fb_ad_network_video_guarantee_revenue: 'FB_AD_NETWORK_VIDEO_GUARANTEE_REVENUE',
        fb_ad_network_video_mrc: 'FB_AD_NETWORK_VIDEO_MRC',
        fb_ad_network_video_mrc_rate: 'FB_AD_NETWORK_VIDEO_MRC_RATE',
        fb_ad_network_video_view: 'FB_AD_NETWORK_VIDEO_VIEW',
        fb_ad_network_video_view_rate: 'FB_AD_NETWORK_VIDEO_VIEW_RATE'
      });
    }
  }, {
    key: 'OrderingColumn',
    get: function get() {
      return Object.freeze({
        metric: 'METRIC',
        time: 'TIME',
        value: 'VALUE'
      });
    }
  }, {
    key: 'OrderingType',
    get: function get() {
      return Object.freeze({
        ascending: 'ASCENDING',
        descending: 'DESCENDING'
      });
    }
  }]);
  return AdNetworkAnalyticsSyncQueryResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdNetworkAnalyticsAsyncQueryResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdNetworkAnalyticsAsyncQueryResult = function (_AbstractCrudObject) {
  inherits(AdNetworkAnalyticsAsyncQueryResult, _AbstractCrudObject);

  function AdNetworkAnalyticsAsyncQueryResult() {
    classCallCheck(this, AdNetworkAnalyticsAsyncQueryResult);
    return possibleConstructorReturn(this, (AdNetworkAnalyticsAsyncQueryResult.__proto__ || Object.getPrototypeOf(AdNetworkAnalyticsAsyncQueryResult)).apply(this, arguments));
  }

  createClass(AdNetworkAnalyticsAsyncQueryResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        data: 'data',
        error: 'error',
        omitted_results: 'omitted_results',
        query_id: 'query_id',
        results: 'results',
        status: 'status'
      });
    }
  }]);
  return AdNetworkAnalyticsAsyncQueryResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AssignedUser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AssignedUser = function (_AbstractCrudObject) {
  inherits(AssignedUser, _AbstractCrudObject);

  function AssignedUser() {
    classCallCheck(this, AssignedUser);
    return possibleConstructorReturn(this, (AssignedUser.__proto__ || Object.getPrototypeOf(AssignedUser)).apply(this, arguments));
  }

  createClass(AssignedUser, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business: 'business',
        id: 'id',
        name: 'name',
        user_type: 'user_type'
      });
    }
  }]);
  return AssignedUser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomConversionStatsResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomConversionStatsResult = function (_AbstractCrudObject) {
  inherits(CustomConversionStatsResult, _AbstractCrudObject);

  function CustomConversionStatsResult() {
    classCallCheck(this, CustomConversionStatsResult);
    return possibleConstructorReturn(this, (CustomConversionStatsResult.__proto__ || Object.getPrototypeOf(CustomConversionStatsResult)).apply(this, arguments));
  }

  createClass(CustomConversionStatsResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        aggregation: 'aggregation',
        data: 'data',
        timestamp: 'timestamp'
      });
    }
  }, {
    key: 'Aggregation',
    get: function get() {
      return Object.freeze({
        count: 'count',
        device_type: 'device_type',
        host: 'host',
        pixel_fire: 'pixel_fire',
        unmatched_count: 'unmatched_count',
        unmatched_usd_amount: 'unmatched_usd_amount',
        url: 'url',
        usd_amount: 'usd_amount'
      });
    }
  }]);
  return CustomConversionStatsResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomConversion
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomConversion = function (_AbstractCrudObject) {
  inherits(CustomConversion, _AbstractCrudObject);

  function CustomConversion() {
    classCallCheck(this, CustomConversion);
    return possibleConstructorReturn(this, (CustomConversion.__proto__ || Object.getPrototypeOf(CustomConversion)).apply(this, arguments));
  }

  createClass(CustomConversion, [{
    key: 'getStats',
    value: function getStats(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomConversionStatsResult, fields, params, fetchFirstPage, '/stats');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(CustomConversion.prototype.__proto__ || Object.getPrototypeOf(CustomConversion.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(CustomConversion.prototype.__proto__ || Object.getPrototypeOf(CustomConversion.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        aggregation_rule: 'aggregation_rule',
        business: 'business',
        creation_time: 'creation_time',
        custom_event_type: 'custom_event_type',
        data_sources: 'data_sources',
        default_conversion_value: 'default_conversion_value',
        description: 'description',
        event_source_type: 'event_source_type',
        first_fired_time: 'first_fired_time',
        id: 'id',
        is_archived: 'is_archived',
        is_unavailable: 'is_unavailable',
        last_fired_time: 'last_fired_time',
        name: 'name',
        offline_conversion_data_set: 'offline_conversion_data_set',
        pixel: 'pixel',
        retention_days: 'retention_days',
        rule: 'rule'
      });
    }
  }, {
    key: 'CustomEventType',
    get: function get() {
      return Object.freeze({
        add_payment_info: 'ADD_PAYMENT_INFO',
        add_to_cart: 'ADD_TO_CART',
        add_to_wishlist: 'ADD_TO_WISHLIST',
        complete_registration: 'COMPLETE_REGISTRATION',
        contact: 'CONTACT',
        content_view: 'CONTENT_VIEW',
        customize_product: 'CUSTOMIZE_PRODUCT',
        donate: 'DONATE',
        facebook_selected: 'FACEBOOK_SELECTED',
        find_location: 'FIND_LOCATION',
        initiated_checkout: 'INITIATED_CHECKOUT',
        lead: 'LEAD',
        listing_interaction: 'LISTING_INTERACTION',
        other: 'OTHER',
        purchase: 'PURCHASE',
        schedule: 'SCHEDULE',
        search: 'SEARCH',
        start_trial: 'START_TRIAL',
        submit_application: 'SUBMIT_APPLICATION',
        subscribe: 'SUBSCRIBE'
      });
    }
  }]);
  return CustomConversion;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InstagramUser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InstagramUser = function (_AbstractCrudObject) {
  inherits(InstagramUser, _AbstractCrudObject);

  function InstagramUser() {
    classCallCheck(this, InstagramUser);
    return possibleConstructorReturn(this, (InstagramUser.__proto__ || Object.getPrototypeOf(InstagramUser)).apply(this, arguments));
  }

  createClass(InstagramUser, [{
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'getAuthorizedAdAccounts',
    value: function getAuthorizedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/authorized_adaccounts');
    }
  }, {
    key: 'createAuthorizedAdAccount',
    value: function createAuthorizedAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/authorized_adaccounts', fields, params, InstagramUser, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        follow_count: 'follow_count',
        followed_by_count: 'followed_by_count',
        has_profile_picture: 'has_profile_picture',
        id: 'id',
        is_private: 'is_private',
        is_published: 'is_published',
        media_count: 'media_count',
        mini_shop_storefront: 'mini_shop_storefront',
        owner_business: 'owner_business',
        profile_pic: 'profile_pic',
        username: 'username'
      });
    }
  }]);
  return InstagramUser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudienceSession
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudienceSession = function (_AbstractCrudObject) {
  inherits(CustomAudienceSession, _AbstractCrudObject);

  function CustomAudienceSession() {
    classCallCheck(this, CustomAudienceSession);
    return possibleConstructorReturn(this, (CustomAudienceSession.__proto__ || Object.getPrototypeOf(CustomAudienceSession)).apply(this, arguments));
  }

  createClass(CustomAudienceSession, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        end_time: 'end_time',
        num_invalid_entries: 'num_invalid_entries',
        num_matched: 'num_matched',
        num_received: 'num_received',
        progress: 'progress',
        session_id: 'session_id',
        stage: 'stage',
        start_time: 'start_time'
      });
    }
  }]);
  return CustomAudienceSession;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudiencesharedAccountInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudiencesharedAccountInfo = function (_AbstractCrudObject) {
  inherits(CustomAudiencesharedAccountInfo, _AbstractCrudObject);

  function CustomAudiencesharedAccountInfo() {
    classCallCheck(this, CustomAudiencesharedAccountInfo);
    return possibleConstructorReturn(this, (CustomAudiencesharedAccountInfo.__proto__ || Object.getPrototypeOf(CustomAudiencesharedAccountInfo)).apply(this, arguments));
  }

  createClass(CustomAudiencesharedAccountInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        account_name: 'account_name',
        business_id: 'business_id',
        business_name: 'business_name',
        sharing_status: 'sharing_status'
      });
    }
  }]);
  return CustomAudiencesharedAccountInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudience
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudience = function (_AbstractCrudObject) {
  inherits(CustomAudience, _AbstractCrudObject);

  function CustomAudience() {
    classCallCheck(this, CustomAudience);
    return possibleConstructorReturn(this, (CustomAudience.__proto__ || Object.getPrototypeOf(CustomAudience)).apply(this, arguments));
  }

  createClass(CustomAudience, [{
    key: 'deleteAdAccounts',
    value: function deleteAdAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(CustomAudience.prototype.__proto__ || Object.getPrototypeOf(CustomAudience.prototype), 'deleteEdge', this).call(this, '/adaccounts', params);
    }
  }, {
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/adaccounts');
    }
  }, {
    key: 'createAdAccount',
    value: function createAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adaccounts', fields, params, CustomAudience, pathOverride);
    }
  }, {
    key: 'getAds',
    value: function getAds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/ads');
    }
  }, {
    key: 'getSessions',
    value: function getSessions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomAudienceSession, fields, params, fetchFirstPage, '/sessions');
    }
  }, {
    key: 'getSharedAccountInfo',
    value: function getSharedAccountInfo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomAudiencesharedAccountInfo, fields, params, fetchFirstPage, '/shared_account_info');
    }
  }, {
    key: 'deleteUsers',
    value: function deleteUsers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(CustomAudience.prototype.__proto__ || Object.getPrototypeOf(CustomAudience.prototype), 'deleteEdge', this).call(this, '/users', params);
    }
  }, {
    key: 'createUser',
    value: function createUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/users', fields, params, CustomAudience, pathOverride);
    }
  }, {
    key: 'createUsersReplace',
    value: function createUsersReplace(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/usersreplace', fields, params, CustomAudience, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(CustomAudience.prototype.__proto__ || Object.getPrototypeOf(CustomAudience.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(CustomAudience.prototype.__proto__ || Object.getPrototypeOf(CustomAudience.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        approximate_count_lower_bound: 'approximate_count_lower_bound',
        approximate_count_upper_bound: 'approximate_count_upper_bound',
        customer_file_source: 'customer_file_source',
        data_source: 'data_source',
        data_source_types: 'data_source_types',
        datafile_custom_audience_uploading_status: 'datafile_custom_audience_uploading_status',
        delete_time: 'delete_time',
        delivery_status: 'delivery_status',
        description: 'description',
        excluded_custom_audiences: 'excluded_custom_audiences',
        external_event_source: 'external_event_source',
        household_audience: 'household_audience',
        id: 'id',
        included_custom_audiences: 'included_custom_audiences',
        is_household: 'is_household',
        is_snapshot: 'is_snapshot',
        is_value_based: 'is_value_based',
        lookalike_audience_ids: 'lookalike_audience_ids',
        lookalike_spec: 'lookalike_spec',
        name: 'name',
        operation_status: 'operation_status',
        opt_out_link: 'opt_out_link',
        owner_business: 'owner_business',
        page_deletion_marked_delete_time: 'page_deletion_marked_delete_time',
        permission_for_actions: 'permission_for_actions',
        pixel_id: 'pixel_id',
        regulated_audience_spec: 'regulated_audience_spec',
        retention_days: 'retention_days',
        rev_share_policy_id: 'rev_share_policy_id',
        rule: 'rule',
        rule_aggregation: 'rule_aggregation',
        rule_v2: 'rule_v2',
        seed_audience: 'seed_audience',
        sharing_status: 'sharing_status',
        subtype: 'subtype',
        time_content_updated: 'time_content_updated',
        time_created: 'time_created',
        time_updated: 'time_updated'
      });
    }
  }, {
    key: 'ClaimObjective',
    get: function get() {
      return Object.freeze({
        automotive_model: 'AUTOMOTIVE_MODEL',
        collaborative_ads: 'COLLABORATIVE_ADS',
        home_listing: 'HOME_LISTING',
        media_title: 'MEDIA_TITLE',
        product: 'PRODUCT',
        travel: 'TRAVEL',
        vehicle: 'VEHICLE',
        vehicle_offer: 'VEHICLE_OFFER'
      });
    }
  }, {
    key: 'ContentType',
    get: function get() {
      return Object.freeze({
        automotive_model: 'AUTOMOTIVE_MODEL',
        destination: 'DESTINATION',
        flight: 'FLIGHT',
        home_listing: 'HOME_LISTING',
        hotel: 'HOTEL',
        job: 'JOB',
        local_service_business: 'LOCAL_SERVICE_BUSINESS',
        location_based_item: 'LOCATION_BASED_ITEM',
        media_title: 'MEDIA_TITLE',
        offline_product: 'OFFLINE_PRODUCT',
        product: 'PRODUCT',
        vehicle: 'VEHICLE',
        vehicle_offer: 'VEHICLE_OFFER'
      });
    }
  }, {
    key: 'CustomerFileSource',
    get: function get() {
      return Object.freeze({
        both_user_and_partner_provided: 'BOTH_USER_AND_PARTNER_PROVIDED',
        partner_provided_only: 'PARTNER_PROVIDED_ONLY',
        user_provided_only: 'USER_PROVIDED_ONLY'
      });
    }
  }, {
    key: 'Subtype',
    get: function get() {
      return Object.freeze({
        app: 'APP',
        bag_of_accounts: 'BAG_OF_ACCOUNTS',
        claim: 'CLAIM',
        custom: 'CUSTOM',
        engagement: 'ENGAGEMENT',
        fox: 'FOX',
        lookalike: 'LOOKALIKE',
        managed: 'MANAGED',
        measurement: 'MEASUREMENT',
        offline_conversion: 'OFFLINE_CONVERSION',
        partner: 'PARTNER',
        regulated_categories_audience: 'REGULATED_CATEGORIES_AUDIENCE',
        study_rule_audience: 'STUDY_RULE_AUDIENCE',
        video: 'VIDEO',
        website: 'WEBSITE'
      });
    }
  }, {
    key: 'ActionSource',
    get: function get() {
      return Object.freeze({
        physical_store: 'PHYSICAL_STORE',
        website: 'WEBSITE'
      });
    }
  }]);
  return CustomAudience;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OfflineConversionDataSetUpload
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OfflineConversionDataSetUpload = function (_AbstractCrudObject) {
  inherits(OfflineConversionDataSetUpload, _AbstractCrudObject);

  function OfflineConversionDataSetUpload() {
    classCallCheck(this, OfflineConversionDataSetUpload);
    return possibleConstructorReturn(this, (OfflineConversionDataSetUpload.__proto__ || Object.getPrototypeOf(OfflineConversionDataSetUpload)).apply(this, arguments));
  }

  createClass(OfflineConversionDataSetUpload, [{
    key: 'getProgress',
    value: function getProgress(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/progress');
    }
  }, {
    key: 'getPullSessions',
    value: function getPullSessions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/pull_sessions');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        api_calls: 'api_calls',
        creation_time: 'creation_time',
        duplicate_entries: 'duplicate_entries',
        event_stats: 'event_stats',
        event_time_max: 'event_time_max',
        event_time_min: 'event_time_min',
        first_upload_time: 'first_upload_time',
        id: 'id',
        is_excluded_for_lift: 'is_excluded_for_lift',
        last_upload_time: 'last_upload_time',
        match_rate_approx: 'match_rate_approx',
        matched_entries: 'matched_entries',
        upload_tag: 'upload_tag',
        valid_entries: 'valid_entries'
      });
    }
  }, {
    key: 'Order',
    get: function get() {
      return Object.freeze({
        ascending: 'ASCENDING',
        descending: 'DESCENDING'
      });
    }
  }, {
    key: 'SortBy',
    get: function get() {
      return Object.freeze({
        api_calls: 'API_CALLS',
        creation_time: 'CREATION_TIME',
        event_time_max: 'EVENT_TIME_MAX',
        event_time_min: 'EVENT_TIME_MIN',
        first_upload_time: 'FIRST_UPLOAD_TIME',
        is_excluded_for_lift: 'IS_EXCLUDED_FOR_LIFT',
        last_upload_time: 'LAST_UPLOAD_TIME'
      });
    }
  }]);
  return OfflineConversionDataSetUpload;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OfflineConversionDataSet
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OfflineConversionDataSet = function (_AbstractCrudObject) {
  inherits(OfflineConversionDataSet, _AbstractCrudObject);

  function OfflineConversionDataSet() {
    classCallCheck(this, OfflineConversionDataSet);
    return possibleConstructorReturn(this, (OfflineConversionDataSet.__proto__ || Object.getPrototypeOf(OfflineConversionDataSet)).apply(this, arguments));
  }

  createClass(OfflineConversionDataSet, [{
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/adaccounts');
    }
  }, {
    key: 'createAdAccount',
    value: function createAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adaccounts', fields, params, OfflineConversionDataSet, pathOverride);
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'createAgency',
    value: function createAgency(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/agencies', fields, params, OfflineConversionDataSet, pathOverride);
    }
  }, {
    key: 'getAudiences',
    value: function getAudiences(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomAudience, fields, params, fetchFirstPage, '/audiences');
    }
  }, {
    key: 'getCustomConversions',
    value: function getCustomConversions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomConversion, fields, params, fetchFirstPage, '/customconversions');
    }
  }, {
    key: 'createEvent',
    value: function createEvent(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/events', fields, params, null, pathOverride);
    }
  }, {
    key: 'getServerEventsPermittedBusiness',
    value: function getServerEventsPermittedBusiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/server_events_permitted_business');
    }
  }, {
    key: 'getSharedAccounts',
    value: function getSharedAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/shared_accounts');
    }
  }, {
    key: 'getSharedAgencies',
    value: function getSharedAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/shared_agencies');
    }
  }, {
    key: 'getStats',
    value: function getStats(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/stats');
    }
  }, {
    key: 'getUploads',
    value: function getUploads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OfflineConversionDataSetUpload, fields, params, fetchFirstPage, '/uploads');
    }
  }, {
    key: 'createUpload',
    value: function createUpload(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/uploads', fields, params, OfflineConversionDataSetUpload, pathOverride);
    }
  }, {
    key: 'createValidate',
    value: function createValidate(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/validate', fields, params, OfflineConversionDataSet, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(OfflineConversionDataSet.prototype.__proto__ || Object.getPrototypeOf(OfflineConversionDataSet.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(OfflineConversionDataSet.prototype.__proto__ || Object.getPrototypeOf(OfflineConversionDataSet.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        automatic_matching_fields: 'automatic_matching_fields',
        business: 'business',
        can_proxy: 'can_proxy',
        config: 'config',
        creation_time: 'creation_time',
        creator: 'creator',
        data_use_setting: 'data_use_setting',
        description: 'description',
        duplicate_entries: 'duplicate_entries',
        enable_auto_assign_to_accounts: 'enable_auto_assign_to_accounts',
        enable_automatic_matching: 'enable_automatic_matching',
        event_stats: 'event_stats',
        event_time_max: 'event_time_max',
        event_time_min: 'event_time_min',
        first_party_cookie_status: 'first_party_cookie_status',
        id: 'id',
        is_consolidated_container: 'is_consolidated_container',
        is_created_by_business: 'is_created_by_business',
        is_crm: 'is_crm',
        is_mta_use: 'is_mta_use',
        is_restricted_use: 'is_restricted_use',
        is_unavailable: 'is_unavailable',
        last_fired_time: 'last_fired_time',
        last_upload_app: 'last_upload_app',
        last_upload_app_changed_time: 'last_upload_app_changed_time',
        match_rate_approx: 'match_rate_approx',
        matched_entries: 'matched_entries',
        name: 'name',
        owner_ad_account: 'owner_ad_account',
        owner_business: 'owner_business',
        usage: 'usage',
        valid_entries: 'valid_entries'
      });
    }
  }, {
    key: 'PermittedRoles',
    get: function get() {
      return Object.freeze({
        admin: 'ADMIN',
        advertiser: 'ADVERTISER',
        uploader: 'UPLOADER'
      });
    }
  }, {
    key: 'RelationshipType',
    get: function get() {
      return Object.freeze({
        ad_manager: 'AD_MANAGER',
        agency: 'AGENCY',
        aggregator: 'AGGREGATOR',
        audience_manager: 'AUDIENCE_MANAGER',
        other: 'OTHER'
      });
    }
  }]);
  return OfflineConversionDataSet;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProfilePictureSource
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProfilePictureSource = function (_AbstractCrudObject) {
  inherits(ProfilePictureSource, _AbstractCrudObject);

  function ProfilePictureSource() {
    classCallCheck(this, ProfilePictureSource);
    return possibleConstructorReturn(this, (ProfilePictureSource.__proto__ || Object.getPrototypeOf(ProfilePictureSource)).apply(this, arguments));
  }

  createClass(ProfilePictureSource, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        bottom: 'bottom',
        cache_key: 'cache_key',
        height: 'height',
        is_silhouette: 'is_silhouette',
        left: 'left',
        right: 'right',
        top: 'top',
        url: 'url',
        width: 'width'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        album: 'album',
        small: 'small',
        thumbnail: 'thumbnail'
      });
    }
  }, {
    key: 'BreakingChange',
    get: function get() {
      return Object.freeze({
        profile_picture: 'PROFILE_PICTURE'
      });
    }
  }]);
  return ProfilePictureSource;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Profile
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Profile = function (_AbstractCrudObject) {
  inherits(Profile, _AbstractCrudObject);

  function Profile() {
    classCallCheck(this, Profile);
    return possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  createClass(Profile, [{
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProfilePictureSource, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        can_post: 'can_post',
        id: 'id',
        link: 'link',
        name: 'name',
        pic: 'pic',
        pic_crop: 'pic_crop',
        pic_large: 'pic_large',
        pic_small: 'pic_small',
        pic_square: 'pic_square',
        profile_type: 'profile_type',
        username: 'username'
      });
    }
  }, {
    key: 'ProfileType',
    get: function get() {
      return Object.freeze({
        application: 'application',
        event: 'event',
        group: 'group',
        page: 'page',
        user: 'user'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        angry: 'ANGRY',
        care: 'CARE',
        fire: 'FIRE',
        haha: 'HAHA',
        hundred: 'HUNDRED',
        like: 'LIKE',
        love: 'LOVE',
        none: 'NONE',
        pride: 'PRIDE',
        sad: 'SAD',
        thankful: 'THANKFUL',
        wow: 'WOW'
      });
    }
  }]);
  return Profile;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Comment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Comment = function (_AbstractCrudObject) {
  inherits(Comment, _AbstractCrudObject);

  function Comment() {
    classCallCheck(this, Comment);
    return possibleConstructorReturn(this, (Comment.__proto__ || Object.getPrototypeOf(Comment)).apply(this, arguments));
  }

  createClass(Comment, [{
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'deleteLikes',
    value: function deleteLikes() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Comment.prototype.__proto__ || Object.getPrototypeOf(Comment.prototype), 'deleteEdge', this).call(this, '/likes', params);
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'createLike',
    value: function createLike(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/likes', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'getReactions',
    value: function getReactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/reactions');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Comment.prototype.__proto__ || Object.getPrototypeOf(Comment.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Comment.prototype.__proto__ || Object.getPrototypeOf(Comment.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        admin_creator: 'admin_creator',
        application: 'application',
        attachment: 'attachment',
        can_comment: 'can_comment',
        can_hide: 'can_hide',
        can_like: 'can_like',
        can_remove: 'can_remove',
        can_reply_privately: 'can_reply_privately',
        comment_count: 'comment_count',
        created_time: 'created_time',
        from: 'from',
        id: 'id',
        is_hidden: 'is_hidden',
        is_private: 'is_private',
        like_count: 'like_count',
        live_broadcast_timestamp: 'live_broadcast_timestamp',
        message: 'message',
        message_tags: 'message_tags',
        object: 'object',
        parent: 'parent',
        permalink_url: 'permalink_url',
        private_reply_conversation: 'private_reply_conversation',
        user_likes: 'user_likes'
      });
    }
  }, {
    key: 'CommentPrivacyValue',
    get: function get() {
      return Object.freeze({
        declined_by_admin_assistant: 'DECLINED_BY_ADMIN_ASSISTANT',
        default_privacy: 'DEFAULT_PRIVACY',
        friends_and_post_owner: 'FRIENDS_AND_POST_OWNER',
        friends_only: 'FRIENDS_ONLY',
        graphql_multiple_value_hack_do_not_use: 'GRAPHQL_MULTIPLE_VALUE_HACK_DO_NOT_USE',
        owner_or_commenter: 'OWNER_OR_COMMENTER',
        pending_approval: 'PENDING_APPROVAL',
        removed_by_admin_assistant: 'REMOVED_BY_ADMIN_ASSISTANT',
        side_conversation: 'SIDE_CONVERSATION',
        side_conversation_and_post_owner: 'SIDE_CONVERSATION_AND_POST_OWNER',
        spotlight_tab: 'SPOTLIGHT_TAB'
      });
    }
  }, {
    key: 'Filter',
    get: function get() {
      return Object.freeze({
        stream: 'stream',
        toplevel: 'toplevel'
      });
    }
  }, {
    key: 'LiveFilter',
    get: function get() {
      return Object.freeze({
        filter_low_quality: 'filter_low_quality',
        no_filter: 'no_filter'
      });
    }
  }, {
    key: 'Order',
    get: function get() {
      return Object.freeze({
        chronological: 'chronological',
        reverse_chronological: 'reverse_chronological'
      });
    }
  }]);
  return Comment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * RTBDynamicPost
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var RTBDynamicPost = function (_AbstractCrudObject) {
  inherits(RTBDynamicPost, _AbstractCrudObject);

  function RTBDynamicPost() {
    classCallCheck(this, RTBDynamicPost);
    return possibleConstructorReturn(this, (RTBDynamicPost.__proto__ || Object.getPrototypeOf(RTBDynamicPost)).apply(this, arguments));
  }

  createClass(RTBDynamicPost, [{
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        child_attachments: 'child_attachments',
        created: 'created',
        description: 'description',
        id: 'id',
        image_url: 'image_url',
        link: 'link',
        message: 'message',
        owner_id: 'owner_id',
        place_id: 'place_id',
        product_id: 'product_id',
        title: 'title'
      });
    }
  }]);
  return RTBDynamicPost;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InsightsResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InsightsResult = function (_AbstractCrudObject) {
  inherits(InsightsResult, _AbstractCrudObject);

  function InsightsResult() {
    classCallCheck(this, InsightsResult);
    return possibleConstructorReturn(this, (InsightsResult.__proto__ || Object.getPrototypeOf(InsightsResult)).apply(this, arguments));
  }

  createClass(InsightsResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        description: 'description',
        description_from_api_doc: 'description_from_api_doc',
        id: 'id',
        name: 'name',
        period: 'period',
        title: 'title',
        values: 'values'
      });
    }
  }, {
    key: 'DatePreset',
    get: function get() {
      return Object.freeze({
        data_maximum: 'data_maximum',
        last_14d: 'last_14d',
        last_28d: 'last_28d',
        last_30d: 'last_30d',
        last_3d: 'last_3d',
        last_7d: 'last_7d',
        last_90d: 'last_90d',
        last_month: 'last_month',
        last_quarter: 'last_quarter',
        last_week_mon_sun: 'last_week_mon_sun',
        last_week_sun_sat: 'last_week_sun_sat',
        last_year: 'last_year',
        maximum: 'maximum',
        this_month: 'this_month',
        this_quarter: 'this_quarter',
        this_week_mon_today: 'this_week_mon_today',
        this_week_sun_today: 'this_week_sun_today',
        this_year: 'this_year',
        today: 'today',
        yesterday: 'yesterday'
      });
    }
  }, {
    key: 'Period',
    get: function get() {
      return Object.freeze({
        day: 'day',
        days_28: 'days_28',
        lifetime: 'lifetime',
        month: 'month',
        total_over_range: 'total_over_range',
        week: 'week'
      });
    }
  }]);
  return InsightsResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Post
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Post = function (_AbstractCrudObject) {
  inherits(Post, _AbstractCrudObject);

  function Post() {
    classCallCheck(this, Post);
    return possibleConstructorReturn(this, (Post.__proto__ || Object.getPrototypeOf(Post)).apply(this, arguments));
  }

  createClass(Post, [{
    key: 'getAttachments',
    value: function getAttachments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/attachments');
    }
  }, {
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'getDynamicPosts',
    value: function getDynamicPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(RTBDynamicPost, fields, params, fetchFirstPage, '/dynamic_posts');
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InsightsResult, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'deleteLikes',
    value: function deleteLikes() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Post.prototype.__proto__ || Object.getPrototypeOf(Post.prototype), 'deleteEdge', this).call(this, '/likes', params);
    }
  }, {
    key: 'createLike',
    value: function createLike(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/likes', fields, params, Post, pathOverride);
    }
  }, {
    key: 'getReactions',
    value: function getReactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/reactions');
    }
  }, {
    key: 'getSharedPosts',
    value: function getSharedPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Post, fields, params, fetchFirstPage, '/sharedposts');
    }
  }, {
    key: 'getSponsorTags',
    value: function getSponsorTags(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/sponsor_tags');
    }
  }, {
    key: 'getTo',
    value: function getTo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/to');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Post.prototype.__proto__ || Object.getPrototypeOf(Post.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Post.prototype.__proto__ || Object.getPrototypeOf(Post.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actions: 'actions',
        admin_creator: 'admin_creator',
        allowed_advertising_objectives: 'allowed_advertising_objectives',
        application: 'application',
        backdated_time: 'backdated_time',
        call_to_action: 'call_to_action',
        can_reply_privately: 'can_reply_privately',
        caption: 'caption',
        child_attachments: 'child_attachments',
        comments_mirroring_domain: 'comments_mirroring_domain',
        coordinates: 'coordinates',
        created_time: 'created_time',
        description: 'description',
        event: 'event',
        expanded_height: 'expanded_height',
        expanded_width: 'expanded_width',
        feed_targeting: 'feed_targeting',
        from: 'from',
        full_picture: 'full_picture',
        height: 'height',
        icon: 'icon',
        id: 'id',
        instagram_eligibility: 'instagram_eligibility',
        is_app_share: 'is_app_share',
        is_eligible_for_promotion: 'is_eligible_for_promotion',
        is_expired: 'is_expired',
        is_hidden: 'is_hidden',
        is_inline_created: 'is_inline_created',
        is_instagram_eligible: 'is_instagram_eligible',
        is_popular: 'is_popular',
        is_published: 'is_published',
        is_spherical: 'is_spherical',
        link: 'link',
        message: 'message',
        message_tags: 'message_tags',
        multi_share_end_card: 'multi_share_end_card',
        multi_share_optimized: 'multi_share_optimized',
        name: 'name',
        object_id: 'object_id',
        parent_id: 'parent_id',
        permalink_url: 'permalink_url',
        picture: 'picture',
        place: 'place',
        privacy: 'privacy',
        promotable_id: 'promotable_id',
        promotion_status: 'promotion_status',
        properties: 'properties',
        scheduled_publish_time: 'scheduled_publish_time',
        shares: 'shares',
        source: 'source',
        status_type: 'status_type',
        story: 'story',
        story_tags: 'story_tags',
        subscribed: 'subscribed',
        target: 'target',
        targeting: 'targeting',
        timeline_visibility: 'timeline_visibility',
        type: 'type',
        updated_time: 'updated_time',
        via: 'via',
        video_buying_eligibility: 'video_buying_eligibility',
        width: 'width'
      });
    }
  }, {
    key: 'BackdatedTimeGranularity',
    get: function get() {
      return Object.freeze({
        day: 'day',
        hour: 'hour',
        min: 'min',
        month: 'month',
        none: 'none',
        year: 'year'
      });
    }
  }, {
    key: 'CheckinEntryPoint',
    get: function get() {
      return Object.freeze({
        branding_checkin: 'BRANDING_CHECKIN',
        branding_other: 'BRANDING_OTHER',
        branding_photo: 'BRANDING_PHOTO',
        branding_status: 'BRANDING_STATUS'
      });
    }
  }, {
    key: 'Formatting',
    get: function get() {
      return Object.freeze({
        markdown: 'MARKDOWN',
        plaintext: 'PLAINTEXT'
      });
    }
  }, {
    key: 'PlaceAttachmentSetting',
    get: function get() {
      return Object.freeze({
        value_1: '1',
        value_2: '2'
      });
    }
  }, {
    key: 'PostSurfacesBlacklist',
    get: function get() {
      return Object.freeze({
        value_1: '1',
        value_2: '2',
        value_3: '3',
        value_4: '4',
        value_5: '5'
      });
    }
  }, {
    key: 'PostingToRedspace',
    get: function get() {
      return Object.freeze({
        disabled: 'disabled',
        enabled: 'enabled'
      });
    }
  }, {
    key: 'TargetSurface',
    get: function get() {
      return Object.freeze({
        story: 'STORY',
        timeline: 'TIMELINE'
      });
    }
  }, {
    key: 'UnpublishedContentType',
    get: function get() {
      return Object.freeze({
        ads_post: 'ADS_POST',
        draft: 'DRAFT',
        inline_created: 'INLINE_CREATED',
        published: 'PUBLISHED',
        reviewable_branded_content: 'REVIEWABLE_BRANDED_CONTENT',
        scheduled: 'SCHEDULED',
        scheduled_recurring: 'SCHEDULED_RECURRING'
      });
    }
  }, {
    key: 'FeedStoryVisibility',
    get: function get() {
      return Object.freeze({
        hidden: 'hidden',
        visible: 'visible'
      });
    }
  }, {
    key: 'TimelineVisibility',
    get: function get() {
      return Object.freeze({
        forced_allow: 'forced_allow',
        hidden: 'hidden',
        normal: 'normal'
      });
    }
  }]);
  return Post;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PagePost
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PagePost = function (_AbstractCrudObject) {
  inherits(PagePost, _AbstractCrudObject);

  function PagePost() {
    classCallCheck(this, PagePost);
    return possibleConstructorReturn(this, (PagePost.__proto__ || Object.getPrototypeOf(PagePost)).apply(this, arguments));
  }

  createClass(PagePost, [{
    key: 'getAttachments',
    value: function getAttachments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/attachments');
    }
  }, {
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'getDynamicPosts',
    value: function getDynamicPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(RTBDynamicPost, fields, params, fetchFirstPage, '/dynamic_posts');
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InsightsResult, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'deleteLikes',
    value: function deleteLikes() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(PagePost.prototype.__proto__ || Object.getPrototypeOf(PagePost.prototype), 'deleteEdge', this).call(this, '/likes', params);
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'createLike',
    value: function createLike(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/likes', fields, params, PagePost, pathOverride);
    }
  }, {
    key: 'getReactions',
    value: function getReactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/reactions');
    }
  }, {
    key: 'getSharedPosts',
    value: function getSharedPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Post, fields, params, fetchFirstPage, '/sharedposts');
    }
  }, {
    key: 'getSponsorTags',
    value: function getSponsorTags(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/sponsor_tags');
    }
  }, {
    key: 'getTo',
    value: function getTo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/to');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PagePost.prototype.__proto__ || Object.getPrototypeOf(PagePost.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PagePost.prototype.__proto__ || Object.getPrototypeOf(PagePost.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actions: 'actions',
        admin_creator: 'admin_creator',
        allowed_advertising_objectives: 'allowed_advertising_objectives',
        application: 'application',
        backdated_time: 'backdated_time',
        call_to_action: 'call_to_action',
        can_reply_privately: 'can_reply_privately',
        child_attachments: 'child_attachments',
        comments_mirroring_domain: 'comments_mirroring_domain',
        coordinates: 'coordinates',
        created_time: 'created_time',
        event: 'event',
        expanded_height: 'expanded_height',
        expanded_width: 'expanded_width',
        feed_targeting: 'feed_targeting',
        from: 'from',
        full_picture: 'full_picture',
        height: 'height',
        icon: 'icon',
        id: 'id',
        instagram_eligibility: 'instagram_eligibility',
        is_app_share: 'is_app_share',
        is_eligible_for_promotion: 'is_eligible_for_promotion',
        is_expired: 'is_expired',
        is_hidden: 'is_hidden',
        is_inline_created: 'is_inline_created',
        is_instagram_eligible: 'is_instagram_eligible',
        is_popular: 'is_popular',
        is_published: 'is_published',
        is_spherical: 'is_spherical',
        message: 'message',
        message_tags: 'message_tags',
        multi_share_end_card: 'multi_share_end_card',
        multi_share_optimized: 'multi_share_optimized',
        parent_id: 'parent_id',
        permalink_url: 'permalink_url',
        picture: 'picture',
        place: 'place',
        privacy: 'privacy',
        promotable_id: 'promotable_id',
        promotion_status: 'promotion_status',
        properties: 'properties',
        scheduled_publish_time: 'scheduled_publish_time',
        shares: 'shares',
        status_type: 'status_type',
        story: 'story',
        story_tags: 'story_tags',
        subscribed: 'subscribed',
        target: 'target',
        targeting: 'targeting',
        timeline_visibility: 'timeline_visibility',
        updated_time: 'updated_time',
        via: 'via',
        video_buying_eligibility: 'video_buying_eligibility',
        width: 'width'
      });
    }
  }, {
    key: 'With',
    get: function get() {
      return Object.freeze({
        location: 'LOCATION'
      });
    }
  }, {
    key: 'BackdatedTimeGranularity',
    get: function get() {
      return Object.freeze({
        day: 'day',
        hour: 'hour',
        min: 'min',
        month: 'month',
        none: 'none',
        year: 'year'
      });
    }
  }, {
    key: 'FeedStoryVisibility',
    get: function get() {
      return Object.freeze({
        hidden: 'hidden',
        visible: 'visible'
      });
    }
  }, {
    key: 'TimelineVisibility',
    get: function get() {
      return Object.freeze({
        forced_allow: 'forced_allow',
        hidden: 'hidden',
        normal: 'normal'
      });
    }
  }]);
  return PagePost;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Photo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Photo = function (_AbstractCrudObject) {
  inherits(Photo, _AbstractCrudObject);

  function Photo() {
    classCallCheck(this, Photo);
    return possibleConstructorReturn(this, (Photo.__proto__ || Object.getPrototypeOf(Photo)).apply(this, arguments));
  }

  createClass(Photo, [{
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InsightsResult, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'createLike',
    value: function createLike(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/likes', fields, params, Photo, pathOverride);
    }
  }, {
    key: 'getSponsorTags',
    value: function getSponsorTags(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/sponsor_tags');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Photo.prototype.__proto__ || Object.getPrototypeOf(Photo.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        album: 'album',
        alt_text: 'alt_text',
        alt_text_custom: 'alt_text_custom',
        backdated_time: 'backdated_time',
        backdated_time_granularity: 'backdated_time_granularity',
        can_backdate: 'can_backdate',
        can_delete: 'can_delete',
        can_tag: 'can_tag',
        created_time: 'created_time',
        event: 'event',
        from: 'from',
        height: 'height',
        icon: 'icon',
        id: 'id',
        images: 'images',
        link: 'link',
        name: 'name',
        name_tags: 'name_tags',
        page_story_id: 'page_story_id',
        picture: 'picture',
        place: 'place',
        position: 'position',
        source: 'source',
        target: 'target',
        updated_time: 'updated_time',
        webp_images: 'webp_images',
        width: 'width'
      });
    }
  }, {
    key: 'BackdatedTimeGranularity',
    get: function get() {
      return Object.freeze({
        day: 'day',
        hour: 'hour',
        min: 'min',
        month: 'month',
        none: 'none',
        year: 'year'
      });
    }
  }, {
    key: 'UnpublishedContentType',
    get: function get() {
      return Object.freeze({
        ads_post: 'ADS_POST',
        draft: 'DRAFT',
        inline_created: 'INLINE_CREATED',
        published: 'PUBLISHED',
        reviewable_branded_content: 'REVIEWABLE_BRANDED_CONTENT',
        scheduled: 'SCHEDULED',
        scheduled_recurring: 'SCHEDULED_RECURRING'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        profile: 'profile',
        tagged: 'tagged',
        uploaded: 'uploaded'
      });
    }
  }]);
  return Photo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Album
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Album = function (_AbstractCrudObject) {
  inherits(Album, _AbstractCrudObject);

  function Album() {
    classCallCheck(this, Album);
    return possibleConstructorReturn(this, (Album.__proto__ || Object.getPrototypeOf(Album)).apply(this, arguments));
  }

  createClass(Album, [{
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'createLike',
    value: function createLike(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/likes', fields, params, Album, pathOverride);
    }
  }, {
    key: 'getPhotos',
    value: function getPhotos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Photo, fields, params, fetchFirstPage, '/photos');
    }
  }, {
    key: 'createPhoto',
    value: function createPhoto(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/photos', fields, params, Photo, pathOverride);
    }
  }, {
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProfilePictureSource, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        backdated_time: 'backdated_time',
        backdated_time_granularity: 'backdated_time_granularity',
        can_backdate: 'can_backdate',
        can_upload: 'can_upload',
        count: 'count',
        cover_photo: 'cover_photo',
        created_time: 'created_time',
        description: 'description',
        edit_link: 'edit_link',
        event: 'event',
        from: 'from',
        id: 'id',
        is_user_facing: 'is_user_facing',
        link: 'link',
        location: 'location',
        modified_major: 'modified_major',
        name: 'name',
        photo_count: 'photo_count',
        place: 'place',
        privacy: 'privacy',
        type: 'type',
        updated_time: 'updated_time',
        video_count: 'video_count'
      });
    }
  }]);
  return Album;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageCallToAction
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageCallToAction = function (_AbstractCrudObject) {
  inherits(PageCallToAction, _AbstractCrudObject);

  function PageCallToAction() {
    classCallCheck(this, PageCallToAction);
    return possibleConstructorReturn(this, (PageCallToAction.__proto__ || Object.getPrototypeOf(PageCallToAction)).apply(this, arguments));
  }

  createClass(PageCallToAction, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PageCallToAction.prototype.__proto__ || Object.getPrototypeOf(PageCallToAction.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PageCallToAction.prototype.__proto__ || Object.getPrototypeOf(PageCallToAction.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        android_app: 'android_app',
        android_deeplink: 'android_deeplink',
        android_destination_type: 'android_destination_type',
        android_package_name: 'android_package_name',
        android_url: 'android_url',
        created_time: 'created_time',
        email_address: 'email_address',
        from: 'from',
        id: 'id',
        intl_number_with_plus: 'intl_number_with_plus',
        iphone_app: 'iphone_app',
        iphone_deeplink: 'iphone_deeplink',
        iphone_destination_type: 'iphone_destination_type',
        iphone_url: 'iphone_url',
        status: 'status',
        type: 'type',
        updated_time: 'updated_time',
        web_destination_type: 'web_destination_type',
        web_url: 'web_url'
      });
    }
  }, {
    key: 'AndroidDestinationType',
    get: function get() {
      return Object.freeze({
        app_deeplink: 'APP_DEEPLINK',
        become_a_volunteer: 'BECOME_A_VOLUNTEER',
        email: 'EMAIL',
        facebook_app: 'FACEBOOK_APP',
        follow: 'FOLLOW',
        marketplace_inventory_page: 'MARKETPLACE_INVENTORY_PAGE',
        menu_on_facebook: 'MENU_ON_FACEBOOK',
        messenger: 'MESSENGER',
        mini_shop: 'MINI_SHOP',
        mobile_center: 'MOBILE_CENTER',
        none: 'NONE',
        phone_call: 'PHONE_CALL',
        shop_on_facebook: 'SHOP_ON_FACEBOOK',
        website: 'WEBSITE'
      });
    }
  }, {
    key: 'IphoneDestinationType',
    get: function get() {
      return Object.freeze({
        app_deeplink: 'APP_DEEPLINK',
        become_a_volunteer: 'BECOME_A_VOLUNTEER',
        email: 'EMAIL',
        facebook_app: 'FACEBOOK_APP',
        follow: 'FOLLOW',
        marketplace_inventory_page: 'MARKETPLACE_INVENTORY_PAGE',
        menu_on_facebook: 'MENU_ON_FACEBOOK',
        messenger: 'MESSENGER',
        mini_shop: 'MINI_SHOP',
        none: 'NONE',
        phone_call: 'PHONE_CALL',
        shop_on_facebook: 'SHOP_ON_FACEBOOK',
        website: 'WEBSITE'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        become_a_volunteer: 'BECOME_A_VOLUNTEER',
        book_appointment: 'BOOK_APPOINTMENT',
        book_now: 'BOOK_NOW',
        buy_tickets: 'BUY_TICKETS',
        call_now: 'CALL_NOW',
        charity_donate: 'CHARITY_DONATE',
        contact_us: 'CONTACT_US',
        donate_now: 'DONATE_NOW',
        email: 'EMAIL',
        follow_page: 'FOLLOW_PAGE',
        get_directions: 'GET_DIRECTIONS',
        get_offer: 'GET_OFFER',
        get_offer_view: 'GET_OFFER_VIEW',
        interested: 'INTERESTED',
        learn_more: 'LEARN_MORE',
        listen: 'LISTEN',
        local_dev_platform: 'LOCAL_DEV_PLATFORM',
        message: 'MESSAGE',
        mobile_center: 'MOBILE_CENTER',
        open_app: 'OPEN_APP',
        order_food: 'ORDER_FOOD',
        play_music: 'PLAY_MUSIC',
        play_now: 'PLAY_NOW',
        purchase_gift_cards: 'PURCHASE_GIFT_CARDS',
        request_appointment: 'REQUEST_APPOINTMENT',
        request_quote: 'REQUEST_QUOTE',
        shop_now: 'SHOP_NOW',
        shop_on_facebook: 'SHOP_ON_FACEBOOK',
        sign_up: 'SIGN_UP',
        view_inventory: 'VIEW_INVENTORY',
        view_menu: 'VIEW_MENU',
        view_shop: 'VIEW_SHOP',
        visit_group: 'VISIT_GROUP',
        watch_now: 'WATCH_NOW',
        woodhenge_support: 'WOODHENGE_SUPPORT'
      });
    }
  }, {
    key: 'WebDestinationType',
    get: function get() {
      return Object.freeze({
        become_a_volunteer: 'BECOME_A_VOLUNTEER',
        become_supporter: 'BECOME_SUPPORTER',
        email: 'EMAIL',
        follow: 'FOLLOW',
        messenger: 'MESSENGER',
        mobile_center: 'MOBILE_CENTER',
        none: 'NONE',
        shop_on_facebook: 'SHOP_ON_FACEBOOK',
        website: 'WEBSITE'
      });
    }
  }]);
  return PageCallToAction;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CanvasBodyElement
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CanvasBodyElement = function (_AbstractCrudObject) {
  inherits(CanvasBodyElement, _AbstractCrudObject);

  function CanvasBodyElement() {
    classCallCheck(this, CanvasBodyElement);
    return possibleConstructorReturn(this, (CanvasBodyElement.__proto__ || Object.getPrototypeOf(CanvasBodyElement)).apply(this, arguments));
  }

  createClass(CanvasBodyElement, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        element: 'element'
      });
    }
  }]);
  return CanvasBodyElement;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TextWithEntities
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TextWithEntities = function (_AbstractCrudObject) {
  inherits(TextWithEntities, _AbstractCrudObject);

  function TextWithEntities() {
    classCallCheck(this, TextWithEntities);
    return possibleConstructorReturn(this, (TextWithEntities.__proto__ || Object.getPrototypeOf(TextWithEntities)).apply(this, arguments));
  }

  createClass(TextWithEntities, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        text: 'text'
      });
    }
  }]);
  return TextWithEntities;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Canvas
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Canvas = function (_AbstractCrudObject) {
  inherits(Canvas, _AbstractCrudObject);

  function Canvas() {
    classCallCheck(this, Canvas);
    return possibleConstructorReturn(this, (Canvas.__proto__ || Object.getPrototypeOf(Canvas)).apply(this, arguments));
  }

  createClass(Canvas, [{
    key: 'getPreviews',
    value: function getPreviews(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(TextWithEntities, fields, params, fetchFirstPage, '/previews');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Canvas.prototype.__proto__ || Object.getPrototypeOf(Canvas.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        background_color: 'background_color',
        body_elements: 'body_elements',
        business_id: 'business_id',
        canvas_link: 'canvas_link',
        collection_hero_image: 'collection_hero_image',
        collection_hero_video: 'collection_hero_video',
        collection_thumbnails: 'collection_thumbnails',
        dynamic_setting: 'dynamic_setting',
        element_payload: 'element_payload',
        elements: 'elements',
        fb_body_elements: 'fb_body_elements',
        id: 'id',
        is_hidden: 'is_hidden',
        is_published: 'is_published',
        last_editor: 'last_editor',
        linked_documents: 'linked_documents',
        name: 'name',
        owner: 'owner',
        property_list: 'property_list',
        source_template: 'source_template',
        store_url: 'store_url',
        style_list: 'style_list',
        tags: 'tags',
        ui_property_list: 'ui_property_list',
        unused_body_elements: 'unused_body_elements',
        update_time: 'update_time',
        use_retailer_item_ids: 'use_retailer_item_ids'
      });
    }
  }]);
  return Canvas;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ChatPlugin
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ChatPlugin = function (_AbstractCrudObject) {
  inherits(ChatPlugin, _AbstractCrudObject);

  function ChatPlugin() {
    classCallCheck(this, ChatPlugin);
    return possibleConstructorReturn(this, (ChatPlugin.__proto__ || Object.getPrototypeOf(ChatPlugin)).apply(this, arguments));
  }

  createClass(ChatPlugin, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        alignment: 'alignment',
        desktop_bottom_spacing: 'desktop_bottom_spacing',
        desktop_side_spacing: 'desktop_side_spacing',
        entry_point_icon: 'entry_point_icon',
        entry_point_label: 'entry_point_label',
        greeting_dialog_display: 'greeting_dialog_display',
        guest_chat_mode: 'guest_chat_mode',
        mobile_bottom_spacing: 'mobile_bottom_spacing',
        mobile_chat_display: 'mobile_chat_display',
        mobile_side_spacing: 'mobile_side_spacing',
        theme_color: 'theme_color',
        welcome_screen_greeting: 'welcome_screen_greeting'
      });
    }
  }]);
  return ChatPlugin;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * URL
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var URL = function (_AbstractCrudObject) {
  inherits(URL, _AbstractCrudObject);

  function URL() {
    classCallCheck(this, URL);
    return possibleConstructorReturn(this, (URL.__proto__ || Object.getPrototypeOf(URL)).apply(this, arguments));
  }

  createClass(URL, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(URL.prototype.__proto__ || Object.getPrototypeOf(URL.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        development_instant_article: 'development_instant_article',
        engagement: 'engagement',
        id: 'id',
        instant_article: 'instant_article',
        og_object: 'og_object',
        ownership_permissions: 'ownership_permissions',
        scopes: 'scopes'
      });
    }
  }, {
    key: 'Scopes',
    get: function get() {
      return Object.freeze({
        news_tab: 'NEWS_TAB',
        news_tab_dev_env: 'NEWS_TAB_DEV_ENV'
      });
    }
  }]);
  return URL;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageCommerceEligibility
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageCommerceEligibility = function (_AbstractCrudObject) {
  inherits(PageCommerceEligibility, _AbstractCrudObject);

  function PageCommerceEligibility() {
    classCallCheck(this, PageCommerceEligibility);
    return possibleConstructorReturn(this, (PageCommerceEligibility.__proto__ || Object.getPrototypeOf(PageCommerceEligibility)).apply(this, arguments));
  }

  createClass(PageCommerceEligibility, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        offsite: 'offsite',
        onsite: 'onsite'
      });
    }
  }]);
  return PageCommerceEligibility;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommerceOrder
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommerceOrder = function (_AbstractCrudObject) {
  inherits(CommerceOrder, _AbstractCrudObject);

  function CommerceOrder() {
    classCallCheck(this, CommerceOrder);
    return possibleConstructorReturn(this, (CommerceOrder.__proto__ || Object.getPrototypeOf(CommerceOrder)).apply(this, arguments));
  }

  createClass(CommerceOrder, [{
    key: 'createAcknowledgeOrder',
    value: function createAcknowledgeOrder(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/acknowledge_order', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'getCancellations',
    value: function getCancellations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/cancellations');
    }
  }, {
    key: 'createCancellation',
    value: function createCancellation(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/cancellations', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'createFulfillOrder',
    value: function createFulfillOrder(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/fulfill_order', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'getItems',
    value: function getItems(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/items');
    }
  }, {
    key: 'getPayments',
    value: function getPayments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/payments');
    }
  }, {
    key: 'getPromotionDetails',
    value: function getPromotionDetails(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/promotion_details');
    }
  }, {
    key: 'getPromotions',
    value: function getPromotions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/promotions');
    }
  }, {
    key: 'getRefunds',
    value: function getRefunds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/refunds');
    }
  }, {
    key: 'createRefund',
    value: function createRefund(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/refunds', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'getReturns',
    value: function getReturns(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/returns');
    }
  }, {
    key: 'createReturn',
    value: function createReturn(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/returns', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'getShipments',
    value: function getShipments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/shipments');
    }
  }, {
    key: 'createShipment',
    value: function createShipment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/shipments', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'createUpdateShipment',
    value: function createUpdateShipment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/update_shipment', fields, params, CommerceOrder, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        buyer_details: 'buyer_details',
        channel: 'channel',
        created: 'created',
        estimated_payment_details: 'estimated_payment_details',
        id: 'id',
        is_group_buy: 'is_group_buy',
        is_test_order: 'is_test_order',
        last_updated: 'last_updated',
        merchant_order_id: 'merchant_order_id',
        order_status: 'order_status',
        selected_shipping_option: 'selected_shipping_option',
        ship_by_date: 'ship_by_date',
        shipping_address: 'shipping_address'
      });
    }
  }, {
    key: 'Filters',
    get: function get() {
      return Object.freeze({
        has_cancellations: 'HAS_CANCELLATIONS',
        has_fulfillments: 'HAS_FULFILLMENTS',
        has_refunds: 'HAS_REFUNDS',
        no_cancellations: 'NO_CANCELLATIONS',
        no_refunds: 'NO_REFUNDS',
        no_shipments: 'NO_SHIPMENTS'
      });
    }
  }, {
    key: 'State',
    get: function get() {
      return Object.freeze({
        completed: 'COMPLETED',
        created: 'CREATED',
        fb_processing: 'FB_PROCESSING',
        in_progress: 'IN_PROGRESS'
      });
    }
  }, {
    key: 'ReasonCode',
    get: function get() {
      return Object.freeze({
        buyers_remorse: 'BUYERS_REMORSE',
        damaged_goods: 'DAMAGED_GOODS',
        facebook_initiated: 'FACEBOOK_INITIATED',
        not_as_described: 'NOT_AS_DESCRIBED',
        quality_issue: 'QUALITY_ISSUE',
        refund_compromised: 'REFUND_COMPROMISED',
        refund_for_return: 'REFUND_FOR_RETURN',
        refund_reason_other: 'REFUND_REASON_OTHER',
        refund_sfi_fake: 'REFUND_SFI_FAKE',
        refund_sfi_real: 'REFUND_SFI_REAL',
        wrong_item: 'WRONG_ITEM'
      });
    }
  }]);
  return CommerceOrder;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommercePayout
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommercePayout = function (_AbstractCrudObject) {
  inherits(CommercePayout, _AbstractCrudObject);

  function CommercePayout() {
    classCallCheck(this, CommercePayout);
    return possibleConstructorReturn(this, (CommercePayout.__proto__ || Object.getPrototypeOf(CommercePayout)).apply(this, arguments));
  }

  createClass(CommercePayout, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount: 'amount',
        payout_date: 'payout_date',
        payout_reference_id: 'payout_reference_id',
        status: 'status',
        transfer_id: 'transfer_id'
      });
    }
  }]);
  return CommercePayout;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommerceOrderTransactionDetail
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommerceOrderTransactionDetail = function (_AbstractCrudObject) {
  inherits(CommerceOrderTransactionDetail, _AbstractCrudObject);

  function CommerceOrderTransactionDetail() {
    classCallCheck(this, CommerceOrderTransactionDetail);
    return possibleConstructorReturn(this, (CommerceOrderTransactionDetail.__proto__ || Object.getPrototypeOf(CommerceOrderTransactionDetail)).apply(this, arguments));
  }

  createClass(CommerceOrderTransactionDetail, [{
    key: 'getItems',
    value: function getItems(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/items');
    }
  }, {
    key: 'getTaxDetails',
    value: function getTaxDetails(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/tax_details');
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        net_payment_amount: 'net_payment_amount',
        order_details: 'order_details',
        payout_reference_id: 'payout_reference_id',
        processing_fee: 'processing_fee',
        tax_rate: 'tax_rate',
        transaction_date: 'transaction_date',
        transaction_type: 'transaction_type',
        transfer_id: 'transfer_id',
        id: 'id'
      });
    }
  }]);
  return CommerceOrderTransactionDetail;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AREffectsBatchStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AREffectsBatchStatus = function (_AbstractCrudObject) {
  inherits(AREffectsBatchStatus, _AbstractCrudObject);

  function AREffectsBatchStatus() {
    classCallCheck(this, AREffectsBatchStatus);
    return possibleConstructorReturn(this, (AREffectsBatchStatus.__proto__ || Object.getPrototypeOf(AREffectsBatchStatus)).apply(this, arguments));
  }

  createClass(AREffectsBatchStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        errors: 'errors',
        product_groups: 'product_groups',
        status: 'status'
      });
    }
  }]);
  return AREffectsBatchStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CatalogItemChannelsToIntegrityStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CatalogItemChannelsToIntegrityStatus = function (_AbstractCrudObject) {
  inherits(CatalogItemChannelsToIntegrityStatus, _AbstractCrudObject);

  function CatalogItemChannelsToIntegrityStatus() {
    classCallCheck(this, CatalogItemChannelsToIntegrityStatus);
    return possibleConstructorReturn(this, (CatalogItemChannelsToIntegrityStatus.__proto__ || Object.getPrototypeOf(CatalogItemChannelsToIntegrityStatus)).apply(this, arguments));
  }

  createClass(CatalogItemChannelsToIntegrityStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        channels: 'channels',
        rejection_information: 'rejection_information'
      });
    }
  }]);
  return CatalogItemChannelsToIntegrityStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AutomotiveModel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AutomotiveModel = function (_AbstractCrudObject) {
  inherits(AutomotiveModel, _AbstractCrudObject);

  function AutomotiveModel() {
    classCallCheck(this, AutomotiveModel);
    return possibleConstructorReturn(this, (AutomotiveModel.__proto__ || Object.getPrototypeOf(AutomotiveModel)).apply(this, arguments));
  }

  createClass(AutomotiveModel, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        applinks: 'applinks',
        automotive_model_id: 'automotive_model_id',
        availability: 'availability',
        body_style: 'body_style',
        category_specific_fields: 'category_specific_fields',
        currency: 'currency',
        custom_label_0: 'custom_label_0',
        description: 'description',
        drivetrain: 'drivetrain',
        exterior_color: 'exterior_color',
        finance_description: 'finance_description',
        finance_type: 'finance_type',
        fuel_type: 'fuel_type',
        generation: 'generation',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        interior_color: 'interior_color',
        interior_upholstery: 'interior_upholstery',
        make: 'make',
        model: 'model',
        price: 'price',
        sanitized_images: 'sanitized_images',
        title: 'title',
        transmission: 'transmission',
        trim: 'trim',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility',
        year: 'year'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return AutomotiveModel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * StoreCatalogSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var StoreCatalogSettings = function (_AbstractCrudObject) {
  inherits(StoreCatalogSettings, _AbstractCrudObject);

  function StoreCatalogSettings() {
    classCallCheck(this, StoreCatalogSettings);
    return possibleConstructorReturn(this, (StoreCatalogSettings.__proto__ || Object.getPrototypeOf(StoreCatalogSettings)).apply(this, arguments));
  }

  createClass(StoreCatalogSettings, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(StoreCatalogSettings.prototype.__proto__ || Object.getPrototypeOf(StoreCatalogSettings.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        page: 'page'
      });
    }
  }]);
  return StoreCatalogSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogCategory
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogCategory = function (_AbstractCrudObject) {
  inherits(ProductCatalogCategory, _AbstractCrudObject);

  function ProductCatalogCategory() {
    classCallCheck(this, ProductCatalogCategory);
    return possibleConstructorReturn(this, (ProductCatalogCategory.__proto__ || Object.getPrototypeOf(ProductCatalogCategory)).apply(this, arguments));
  }

  createClass(ProductCatalogCategory, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        criteria_value: 'criteria_value',
        description: 'description',
        destination_uri: 'destination_uri',
        image_url: 'image_url',
        name: 'name',
        num_items: 'num_items',
        tokens: 'tokens'
      });
    }
  }, {
    key: 'CategorizationCriteria',
    get: function get() {
      return Object.freeze({
        brand: 'BRAND',
        category: 'CATEGORY',
        product_type: 'PRODUCT_TYPE'
      });
    }
  }]);
  return ProductCatalogCategory;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CheckBatchRequestStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CheckBatchRequestStatus = function (_AbstractCrudObject) {
  inherits(CheckBatchRequestStatus, _AbstractCrudObject);

  function CheckBatchRequestStatus() {
    classCallCheck(this, CheckBatchRequestStatus);
    return possibleConstructorReturn(this, (CheckBatchRequestStatus.__proto__ || Object.getPrototypeOf(CheckBatchRequestStatus)).apply(this, arguments));
  }

  createClass(CheckBatchRequestStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        errors: 'errors',
        errors_total_count: 'errors_total_count',
        handle: 'handle',
        ids_of_invalid_requests: 'ids_of_invalid_requests',
        status: 'status',
        warnings: 'warnings',
        warnings_total_count: 'warnings_total_count'
      });
    }
  }, {
    key: 'ErrorPriority',
    get: function get() {
      return Object.freeze({
        high: 'HIGH',
        low: 'LOW',
        medium: 'MEDIUM'
      });
    }
  }]);
  return CheckBatchRequestStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CatalogSegmentAllMatchCountLaser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CatalogSegmentAllMatchCountLaser = function (_AbstractCrudObject) {
  inherits(CatalogSegmentAllMatchCountLaser, _AbstractCrudObject);

  function CatalogSegmentAllMatchCountLaser() {
    classCallCheck(this, CatalogSegmentAllMatchCountLaser);
    return possibleConstructorReturn(this, (CatalogSegmentAllMatchCountLaser.__proto__ || Object.getPrototypeOf(CatalogSegmentAllMatchCountLaser)).apply(this, arguments));
  }

  createClass(CatalogSegmentAllMatchCountLaser, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        date_start: 'date_start',
        date_stop: 'date_stop',
        event: 'event',
        source: 'source',
        total_matched_content_ids: 'total_matched_content_ids',
        unique_matched_content_ids: 'unique_matched_content_ids'
      });
    }
  }]);
  return CatalogSegmentAllMatchCountLaser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CollaborativeAdsShareSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CollaborativeAdsShareSettings = function (_AbstractCrudObject) {
  inherits(CollaborativeAdsShareSettings, _AbstractCrudObject);

  function CollaborativeAdsShareSettings() {
    classCallCheck(this, CollaborativeAdsShareSettings);
    return possibleConstructorReturn(this, (CollaborativeAdsShareSettings.__proto__ || Object.getPrototypeOf(CollaborativeAdsShareSettings)).apply(this, arguments));
  }

  createClass(CollaborativeAdsShareSettings, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        agency_business: 'agency_business',
        id: 'id',
        product_catalog_proxy_id: 'product_catalog_proxy_id',
        utm_campaign: 'utm_campaign',
        utm_medium: 'utm_medium',
        utm_source: 'utm_source'
      });
    }
  }]);
  return CollaborativeAdsShareSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogDataSource
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogDataSource = function (_AbstractCrudObject) {
  inherits(ProductCatalogDataSource, _AbstractCrudObject);

  function ProductCatalogDataSource() {
    classCallCheck(this, ProductCatalogDataSource);
    return possibleConstructorReturn(this, (ProductCatalogDataSource.__proto__ || Object.getPrototypeOf(ProductCatalogDataSource)).apply(this, arguments));
  }

  createClass(ProductCatalogDataSource, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_id: 'app_id',
        id: 'id',
        ingestion_source_type: 'ingestion_source_type',
        name: 'name',
        upload_type: 'upload_type'
      });
    }
  }, {
    key: 'IngestionSourceType',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        primary: 'PRIMARY',
        supplementary: 'SUPPLEMENTARY'
      });
    }
  }]);
  return ProductCatalogDataSource;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Destination
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Destination = function (_AbstractCrudObject) {
  inherits(Destination, _AbstractCrudObject);

  function Destination() {
    classCallCheck(this, Destination);
    return possibleConstructorReturn(this, (Destination.__proto__ || Object.getPrototypeOf(Destination)).apply(this, arguments));
  }

  createClass(Destination, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address: 'address',
        applinks: 'applinks',
        category_specific_fields: 'category_specific_fields',
        currency: 'currency',
        description: 'description',
        destination_id: 'destination_id',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        name: 'name',
        price: 'price',
        price_change: 'price_change',
        sanitized_images: 'sanitized_images',
        types: 'types',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return Destination;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogDiagnosticGroup
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogDiagnosticGroup = function (_AbstractCrudObject) {
  inherits(ProductCatalogDiagnosticGroup, _AbstractCrudObject);

  function ProductCatalogDiagnosticGroup() {
    classCallCheck(this, ProductCatalogDiagnosticGroup);
    return possibleConstructorReturn(this, (ProductCatalogDiagnosticGroup.__proto__ || Object.getPrototypeOf(ProductCatalogDiagnosticGroup)).apply(this, arguments));
  }

  createClass(ProductCatalogDiagnosticGroup, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        affected_channels: 'affected_channels',
        affected_entity: 'affected_entity',
        affected_features: 'affected_features',
        diagnostics: 'diagnostics',
        error_code: 'error_code',
        number_of_affected_entities: 'number_of_affected_entities',
        number_of_affected_items: 'number_of_affected_items',
        severity: 'severity',
        subtitle: 'subtitle',
        title: 'title',
        type: 'type'
      });
    }
  }, {
    key: 'AffectedChannels',
    get: function get() {
      return Object.freeze({
        business_inbox_in_messenger: 'business_inbox_in_messenger',
        shops: 'shops',
        test_capability: 'test_capability',
        universal_checkout: 'universal_checkout',
        us_marketplace: 'us_marketplace'
      });
    }
  }, {
    key: 'AffectedEntity',
    get: function get() {
      return Object.freeze({
        product_catalog: 'product_catalog',
        product_item: 'product_item',
        product_set: 'product_set'
      });
    }
  }, {
    key: 'AffectedFeatures',
    get: function get() {
      return Object.freeze({
        augmented_reality: 'augmented_reality',
        checkout: 'checkout'
      });
    }
  }, {
    key: 'Severity',
    get: function get() {
      return Object.freeze({
        must_fix: 'MUST_FIX',
        opportunity: 'OPPORTUNITY'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        ar_visibility_issues: 'AR_VISIBILITY_ISSUES',
        attributes_invalid: 'ATTRIBUTES_INVALID',
        attributes_missing: 'ATTRIBUTES_MISSING',
        category: 'CATEGORY',
        checkout: 'CHECKOUT',
        image_quality: 'IMAGE_QUALITY',
        low_quality_title_and_description: 'LOW_QUALITY_TITLE_AND_DESCRIPTION',
        policy_violation: 'POLICY_VIOLATION',
        shops_visibility_issues: 'SHOPS_VISIBILITY_ISSUES'
      });
    }
  }, {
    key: 'AffectedEntities',
    get: function get() {
      return Object.freeze({
        product_catalog: 'product_catalog',
        product_item: 'product_item',
        product_set: 'product_set'
      });
    }
  }, {
    key: 'Severities',
    get: function get() {
      return Object.freeze({
        must_fix: 'MUST_FIX',
        opportunity: 'OPPORTUNITY'
      });
    }
  }, {
    key: 'Types',
    get: function get() {
      return Object.freeze({
        ar_visibility_issues: 'AR_VISIBILITY_ISSUES',
        attributes_invalid: 'ATTRIBUTES_INVALID',
        attributes_missing: 'ATTRIBUTES_MISSING',
        category: 'CATEGORY',
        checkout: 'CHECKOUT',
        image_quality: 'IMAGE_QUALITY',
        low_quality_title_and_description: 'LOW_QUALITY_TITLE_AND_DESCRIPTION',
        policy_violation: 'POLICY_VIOLATION',
        shops_visibility_issues: 'SHOPS_VISIBILITY_ISSUES'
      });
    }
  }]);
  return ProductCatalogDiagnosticGroup;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductEventStat
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductEventStat = function (_AbstractCrudObject) {
  inherits(ProductEventStat, _AbstractCrudObject);

  function ProductEventStat() {
    classCallCheck(this, ProductEventStat);
    return possibleConstructorReturn(this, (ProductEventStat.__proto__ || Object.getPrototypeOf(ProductEventStat)).apply(this, arguments));
  }

  createClass(ProductEventStat, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        date_start: 'date_start',
        date_stop: 'date_stop',
        device_type: 'device_type',
        event: 'event',
        event_source: 'event_source',
        total_content_ids_matched_other_catalogs: 'total_content_ids_matched_other_catalogs',
        total_matched_content_ids: 'total_matched_content_ids',
        total_unmatched_content_ids: 'total_unmatched_content_ids',
        unique_content_ids_matched_other_catalogs: 'unique_content_ids_matched_other_catalogs',
        unique_matched_content_ids: 'unique_matched_content_ids',
        unique_unmatched_content_ids: 'unique_unmatched_content_ids'
      });
    }
  }, {
    key: 'DeviceType',
    get: function get() {
      return Object.freeze({
        desktop: 'desktop',
        mobile_android_phone: 'mobile_android_phone',
        mobile_android_tablet: 'mobile_android_tablet',
        mobile_ipad: 'mobile_ipad',
        mobile_iphone: 'mobile_iphone',
        mobile_ipod: 'mobile_ipod',
        mobile_phone: 'mobile_phone',
        mobile_tablet: 'mobile_tablet',
        mobile_windows_phone: 'mobile_windows_phone',
        unknown: 'unknown'
      });
    }
  }, {
    key: 'Event',
    get: function get() {
      return Object.freeze({
        addtocart: 'AddToCart',
        addtowishlist: 'AddToWishlist',
        initiatecheckout: 'InitiateCheckout',
        lead: 'Lead',
        purchase: 'Purchase',
        search: 'Search',
        subscribe: 'Subscribe',
        viewcontent: 'ViewContent'
      });
    }
  }, {
    key: 'Breakdowns',
    get: function get() {
      return Object.freeze({
        device_type: 'DEVICE_TYPE'
      });
    }
  }]);
  return ProductEventStat;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ExternalEventSource
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ExternalEventSource = function (_AbstractCrudObject) {
  inherits(ExternalEventSource, _AbstractCrudObject);

  function ExternalEventSource() {
    classCallCheck(this, ExternalEventSource);
    return possibleConstructorReturn(this, (ExternalEventSource.__proto__ || Object.getPrototypeOf(ExternalEventSource)).apply(this, arguments));
  }

  createClass(ExternalEventSource, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name',
        source_type: 'source_type'
      });
    }
  }]);
  return ExternalEventSource;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Flight
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Flight = function (_AbstractCrudObject) {
  inherits(Flight, _AbstractCrudObject);

  function Flight() {
    classCallCheck(this, Flight);
    return possibleConstructorReturn(this, (Flight.__proto__ || Object.getPrototypeOf(Flight)).apply(this, arguments));
  }

  createClass(Flight, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Flight.prototype.__proto__ || Object.getPrototypeOf(Flight.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        applinks: 'applinks',
        category_specific_fields: 'category_specific_fields',
        currency: 'currency',
        description: 'description',
        destination_airport: 'destination_airport',
        destination_city: 'destination_city',
        flight_id: 'flight_id',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        oneway_currency: 'oneway_currency',
        oneway_price: 'oneway_price',
        origin_airport: 'origin_airport',
        origin_city: 'origin_city',
        price: 'price',
        sanitized_images: 'sanitized_images',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return Flight;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * HomeListing
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var HomeListing = function (_AbstractCrudObject) {
  inherits(HomeListing, _AbstractCrudObject);

  function HomeListing() {
    classCallCheck(this, HomeListing);
    return possibleConstructorReturn(this, (HomeListing.__proto__ || Object.getPrototypeOf(HomeListing)).apply(this, arguments));
  }

  createClass(HomeListing, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(HomeListing.prototype.__proto__ || Object.getPrototypeOf(HomeListing.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(HomeListing.prototype.__proto__ || Object.getPrototypeOf(HomeListing.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ac_type: 'ac_type',
        additional_fees_description: 'additional_fees_description',
        address: 'address',
        agent_company: 'agent_company',
        agent_email: 'agent_email',
        agent_fb_page_id: 'agent_fb_page_id',
        agent_name: 'agent_name',
        agent_phone: 'agent_phone',
        applinks: 'applinks',
        area_size: 'area_size',
        area_unit: 'area_unit',
        availability: 'availability',
        category_specific_fields: 'category_specific_fields',
        co_2_emission_rating_eu: 'co_2_emission_rating_eu',
        currency: 'currency',
        days_on_market: 'days_on_market',
        description: 'description',
        energy_rating_eu: 'energy_rating_eu',
        furnish_type: 'furnish_type',
        group_id: 'group_id',
        heating_type: 'heating_type',
        home_listing_id: 'home_listing_id',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        laundry_type: 'laundry_type',
        listing_type: 'listing_type',
        max_currency: 'max_currency',
        max_price: 'max_price',
        min_currency: 'min_currency',
        min_price: 'min_price',
        name: 'name',
        num_baths: 'num_baths',
        num_beds: 'num_beds',
        num_rooms: 'num_rooms',
        num_units: 'num_units',
        parking_type: 'parking_type',
        partner_verification: 'partner_verification',
        pet_policy: 'pet_policy',
        price: 'price',
        property_type: 'property_type',
        sanitized_images: 'sanitized_images',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility',
        year_built: 'year_built'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return HomeListing;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogHotelRoomsBatch
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogHotelRoomsBatch = function (_AbstractCrudObject) {
  inherits(ProductCatalogHotelRoomsBatch, _AbstractCrudObject);

  function ProductCatalogHotelRoomsBatch() {
    classCallCheck(this, ProductCatalogHotelRoomsBatch);
    return possibleConstructorReturn(this, (ProductCatalogHotelRoomsBatch.__proto__ || Object.getPrototypeOf(ProductCatalogHotelRoomsBatch)).apply(this, arguments));
  }

  createClass(ProductCatalogHotelRoomsBatch, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        errors: 'errors',
        errors_total_count: 'errors_total_count',
        handle: 'handle',
        status: 'status'
      });
    }
  }]);
  return ProductCatalogHotelRoomsBatch;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DynamicPriceConfigByDate
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DynamicPriceConfigByDate = function (_AbstractCrudObject) {
  inherits(DynamicPriceConfigByDate, _AbstractCrudObject);

  function DynamicPriceConfigByDate() {
    classCallCheck(this, DynamicPriceConfigByDate);
    return possibleConstructorReturn(this, (DynamicPriceConfigByDate.__proto__ || Object.getPrototypeOf(DynamicPriceConfigByDate)).apply(this, arguments));
  }

  createClass(DynamicPriceConfigByDate, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        checkin_date: 'checkin_date',
        prices: 'prices',
        prices_pretty: 'prices_pretty',
        id: 'id'
      });
    }
  }]);
  return DynamicPriceConfigByDate;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * HotelRoom
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var HotelRoom = function (_AbstractCrudObject) {
  inherits(HotelRoom, _AbstractCrudObject);

  function HotelRoom() {
    classCallCheck(this, HotelRoom);
    return possibleConstructorReturn(this, (HotelRoom.__proto__ || Object.getPrototypeOf(HotelRoom)).apply(this, arguments));
  }

  createClass(HotelRoom, [{
    key: 'getPricingVariables',
    value: function getPricingVariables(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(DynamicPriceConfigByDate, fields, params, fetchFirstPage, '/pricing_variables');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        applinks: 'applinks',
        base_price: 'base_price',
        currency: 'currency',
        description: 'description',
        id: 'id',
        images: 'images',
        margin_level: 'margin_level',
        name: 'name',
        room_id: 'room_id',
        sale_price: 'sale_price',
        url: 'url'
      });
    }
  }]);
  return HotelRoom;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Hotel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Hotel = function (_AbstractCrudObject) {
  inherits(Hotel, _AbstractCrudObject);

  function Hotel() {
    classCallCheck(this, Hotel);
    return possibleConstructorReturn(this, (Hotel.__proto__ || Object.getPrototypeOf(Hotel)).apply(this, arguments));
  }

  createClass(Hotel, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getHotelRooms',
    value: function getHotelRooms(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(HotelRoom, fields, params, fetchFirstPage, '/hotel_rooms');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Hotel.prototype.__proto__ || Object.getPrototypeOf(Hotel.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Hotel.prototype.__proto__ || Object.getPrototypeOf(Hotel.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address: 'address',
        applinks: 'applinks',
        brand: 'brand',
        category: 'category',
        category_specific_fields: 'category_specific_fields',
        currency: 'currency',
        description: 'description',
        guest_ratings: 'guest_ratings',
        hotel_id: 'hotel_id',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        lowest_base_price: 'lowest_base_price',
        loyalty_program: 'loyalty_program',
        margin_level: 'margin_level',
        name: 'name',
        phone: 'phone',
        sale_price: 'sale_price',
        sanitized_images: 'sanitized_images',
        star_rating: 'star_rating',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return Hotel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MediaTitle
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MediaTitle = function (_AbstractCrudObject) {
  inherits(MediaTitle, _AbstractCrudObject);

  function MediaTitle() {
    classCallCheck(this, MediaTitle);
    return possibleConstructorReturn(this, (MediaTitle.__proto__ || Object.getPrototypeOf(MediaTitle)).apply(this, arguments));
  }

  createClass(MediaTitle, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(MediaTitle.prototype.__proto__ || Object.getPrototypeOf(MediaTitle.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(MediaTitle.prototype.__proto__ || Object.getPrototypeOf(MediaTitle.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        applinks: 'applinks',
        category_specific_fields: 'category_specific_fields',
        content_category: 'content_category',
        currency: 'currency',
        description: 'description',
        fb_page_alias: 'fb_page_alias',
        fb_page_id: 'fb_page_id',
        genres: 'genres',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        kg_fb_id: 'kg_fb_id',
        media_title_id: 'media_title_id',
        price: 'price',
        sanitized_images: 'sanitized_images',
        title: 'title',
        title_display_name: 'title_display_name',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility',
        wiki_data_item: 'wiki_data_item'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }, {
    key: 'ContentCategory',
    get: function get() {
      return Object.freeze({
        movie: 'MOVIE',
        music: 'MUSIC',
        tv_show: 'TV_SHOW'
      });
    }
  }]);
  return MediaTitle;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogPricingVariablesBatch
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogPricingVariablesBatch = function (_AbstractCrudObject) {
  inherits(ProductCatalogPricingVariablesBatch, _AbstractCrudObject);

  function ProductCatalogPricingVariablesBatch() {
    classCallCheck(this, ProductCatalogPricingVariablesBatch);
    return possibleConstructorReturn(this, (ProductCatalogPricingVariablesBatch.__proto__ || Object.getPrototypeOf(ProductCatalogPricingVariablesBatch)).apply(this, arguments));
  }

  createClass(ProductCatalogPricingVariablesBatch, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        errors: 'errors',
        errors_total_count: 'errors_total_count',
        handle: 'handle',
        status: 'status'
      });
    }
  }]);
  return ProductCatalogPricingVariablesBatch;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VehicleOffer
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VehicleOffer = function (_AbstractCrudObject) {
  inherits(VehicleOffer, _AbstractCrudObject);

  function VehicleOffer() {
    classCallCheck(this, VehicleOffer);
    return possibleConstructorReturn(this, (VehicleOffer.__proto__ || Object.getPrototypeOf(VehicleOffer)).apply(this, arguments));
  }

  createClass(VehicleOffer, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount_currency: 'amount_currency',
        amount_percentage: 'amount_percentage',
        amount_price: 'amount_price',
        amount_qualifier: 'amount_qualifier',
        applinks: 'applinks',
        body_style: 'body_style',
        cashback_currency: 'cashback_currency',
        cashback_price: 'cashback_price',
        category_specific_fields: 'category_specific_fields',
        currency: 'currency',
        dma_codes: 'dma_codes',
        downpayment_currency: 'downpayment_currency',
        downpayment_price: 'downpayment_price',
        downpayment_qualifier: 'downpayment_qualifier',
        end_date: 'end_date',
        end_time: 'end_time',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        make: 'make',
        model: 'model',
        offer_description: 'offer_description',
        offer_disclaimer: 'offer_disclaimer',
        offer_type: 'offer_type',
        price: 'price',
        sanitized_images: 'sanitized_images',
        start_date: 'start_date',
        start_time: 'start_time',
        term_length: 'term_length',
        term_qualifier: 'term_qualifier',
        title: 'title',
        trim: 'trim',
        unit_price: 'unit_price',
        url: 'url',
        vehicle_offer_id: 'vehicle_offer_id',
        visibility: 'visibility',
        year: 'year'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return VehicleOffer;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Vehicle
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Vehicle = function (_AbstractCrudObject) {
  inherits(Vehicle, _AbstractCrudObject);

  function Vehicle() {
    classCallCheck(this, Vehicle);
    return possibleConstructorReturn(this, (Vehicle.__proto__ || Object.getPrototypeOf(Vehicle)).apply(this, arguments));
  }

  createClass(Vehicle, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Vehicle.prototype.__proto__ || Object.getPrototypeOf(Vehicle.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address: 'address',
        applinks: 'applinks',
        availability: 'availability',
        body_style: 'body_style',
        category_specific_fields: 'category_specific_fields',
        condition: 'condition',
        currency: 'currency',
        custom_label_0: 'custom_label_0',
        date_first_on_lot: 'date_first_on_lot',
        dealer_communication_channel: 'dealer_communication_channel',
        dealer_email: 'dealer_email',
        dealer_id: 'dealer_id',
        dealer_name: 'dealer_name',
        dealer_phone: 'dealer_phone',
        dealer_privacy_policy_url: 'dealer_privacy_policy_url',
        description: 'description',
        drivetrain: 'drivetrain',
        exterior_color: 'exterior_color',
        fb_page_id: 'fb_page_id',
        features: 'features',
        fuel_type: 'fuel_type',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        interior_color: 'interior_color',
        legal_disclosure_impressum_url: 'legal_disclosure_impressum_url',
        make: 'make',
        mileage: 'mileage',
        model: 'model',
        previous_currency: 'previous_currency',
        previous_price: 'previous_price',
        price: 'price',
        sale_currency: 'sale_currency',
        sale_price: 'sale_price',
        sanitized_images: 'sanitized_images',
        state_of_vehicle: 'state_of_vehicle',
        title: 'title',
        transmission: 'transmission',
        trim: 'trim',
        unit_price: 'unit_price',
        url: 'url',
        vehicle_id: 'vehicle_id',
        vehicle_registration_plate: 'vehicle_registration_plate',
        vehicle_specifications: 'vehicle_specifications',
        vehicle_type: 'vehicle_type',
        vin: 'vin',
        visibility: 'visibility',
        year: 'year'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }, {
    key: 'Availability',
    get: function get() {
      return Object.freeze({
        available: 'AVAILABLE',
        not_available: 'NOT_AVAILABLE',
        pending: 'PENDING'
      });
    }
  }, {
    key: 'BodyStyle',
    get: function get() {
      return Object.freeze({
        convertible: 'CONVERTIBLE',
        coupe: 'COUPE',
        crossover: 'CROSSOVER',
        estate: 'ESTATE',
        grandtourer: 'GRANDTOURER',
        hatchback: 'HATCHBACK',
        minibus: 'MINIBUS',
        minivan: 'MINIVAN',
        mpv: 'MPV',
        none: 'NONE',
        other: 'OTHER',
        pickup: 'PICKUP',
        roadster: 'ROADSTER',
        saloon: 'SALOON',
        sedan: 'SEDAN',
        small_car: 'SMALL_CAR',
        sportscar: 'SPORTSCAR',
        supercar: 'SUPERCAR',
        supermini: 'SUPERMINI',
        suv: 'SUV',
        truck: 'TRUCK',
        van: 'VAN',
        wagon: 'WAGON'
      });
    }
  }, {
    key: 'Condition',
    get: function get() {
      return Object.freeze({
        excellent: 'EXCELLENT',
        fair: 'FAIR',
        good: 'GOOD',
        none: 'NONE',
        other: 'OTHER',
        poor: 'POOR',
        very_good: 'VERY_GOOD'
      });
    }
  }, {
    key: 'Drivetrain',
    get: function get() {
      return Object.freeze({
        awd: 'AWD',
        four_wd: 'FOUR_WD',
        fwd: 'FWD',
        none: 'NONE',
        other: 'OTHER',
        rwd: 'RWD',
        two_wd: 'TWO_WD'
      });
    }
  }, {
    key: 'FuelType',
    get: function get() {
      return Object.freeze({
        diesel: 'DIESEL',
        electric: 'ELECTRIC',
        flex: 'FLEX',
        gasoline: 'GASOLINE',
        hybrid: 'HYBRID',
        none: 'NONE',
        other: 'OTHER',
        petrol: 'PETROL',
        plugin_hybrid: 'PLUGIN_HYBRID'
      });
    }
  }, {
    key: 'StateOfVehicle',
    get: function get() {
      return Object.freeze({
        cpo: 'CPO',
        new: 'NEW',
        used: 'USED'
      });
    }
  }, {
    key: 'Transmission',
    get: function get() {
      return Object.freeze({
        automatic: 'AUTOMATIC',
        manual: 'MANUAL',
        none: 'NONE',
        other: 'OTHER'
      });
    }
  }, {
    key: 'VehicleType',
    get: function get() {
      return Object.freeze({
        boat: 'BOAT',
        car_truck: 'CAR_TRUCK',
        commercial: 'COMMERCIAL',
        motorcycle: 'MOTORCYCLE',
        other: 'OTHER',
        powersport: 'POWERSPORT',
        rv_camper: 'RV_CAMPER',
        trailer: 'TRAILER'
      });
    }
  }]);
  return Vehicle;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductSet
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductSet = function (_AbstractCrudObject) {
  inherits(ProductSet, _AbstractCrudObject);

  function ProductSet() {
    classCallCheck(this, ProductSet);
    return possibleConstructorReturn(this, (ProductSet.__proto__ || Object.getPrototypeOf(ProductSet)).apply(this, arguments));
  }

  createClass(ProductSet, [{
    key: 'getAutomotiveModels',
    value: function getAutomotiveModels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AutomotiveModel, fields, params, fetchFirstPage, '/automotive_models');
    }
  }, {
    key: 'getDestinations',
    value: function getDestinations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Destination, fields, params, fetchFirstPage, '/destinations');
    }
  }, {
    key: 'getFlights',
    value: function getFlights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Flight, fields, params, fetchFirstPage, '/flights');
    }
  }, {
    key: 'getHomeListings',
    value: function getHomeListings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(HomeListing, fields, params, fetchFirstPage, '/home_listings');
    }
  }, {
    key: 'getHotels',
    value: function getHotels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Hotel, fields, params, fetchFirstPage, '/hotels');
    }
  }, {
    key: 'getMediaTitles',
    value: function getMediaTitles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MediaTitle, fields, params, fetchFirstPage, '/media_titles');
    }
  }, {
    key: 'getProducts',
    value: function getProducts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductItem, fields, params, fetchFirstPage, '/products');
    }
  }, {
    key: 'getVehicleOffers',
    value: function getVehicleOffers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(VehicleOffer, fields, params, fetchFirstPage, '/vehicle_offers');
    }
  }, {
    key: 'getVehicles',
    value: function getVehicles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Vehicle, fields, params, fetchFirstPage, '/vehicles');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductSet.prototype.__proto__ || Object.getPrototypeOf(ProductSet.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductSet.prototype.__proto__ || Object.getPrototypeOf(ProductSet.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        auto_creation_url: 'auto_creation_url',
        filter: 'filter',
        id: 'id',
        latest_metadata: 'latest_metadata',
        live_metadata: 'live_metadata',
        name: 'name',
        ordering_info: 'ordering_info',
        product_catalog: 'product_catalog',
        product_count: 'product_count',
        retailer_id: 'retailer_id'
      });
    }
  }]);
  return ProductSet;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductItem
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductItem = function (_AbstractCrudObject) {
  inherits(ProductItem, _AbstractCrudObject);

  function ProductItem() {
    classCallCheck(this, ProductItem);
    return possibleConstructorReturn(this, (ProductItem.__proto__ || Object.getPrototypeOf(ProductItem)).apply(this, arguments));
  }

  createClass(ProductItem, [{
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getProductSets',
    value: function getProductSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductSet, fields, params, fetchFirstPage, '/product_sets');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductItem.prototype.__proto__ || Object.getPrototypeOf(ProductItem.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductItem.prototype.__proto__ || Object.getPrototypeOf(ProductItem.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        additional_image_cdn_urls: 'additional_image_cdn_urls',
        additional_image_urls: 'additional_image_urls',
        additional_variant_attributes: 'additional_variant_attributes',
        age_group: 'age_group',
        applinks: 'applinks',
        ar_data: 'ar_data',
        availability: 'availability',
        brand: 'brand',
        capability_to_review_status: 'capability_to_review_status',
        category: 'category',
        category_specific_fields: 'category_specific_fields',
        color: 'color',
        commerce_insights: 'commerce_insights',
        condition: 'condition',
        currency: 'currency',
        custom_data: 'custom_data',
        custom_label_0: 'custom_label_0',
        custom_label_1: 'custom_label_1',
        custom_label_2: 'custom_label_2',
        custom_label_3: 'custom_label_3',
        custom_label_4: 'custom_label_4',
        custom_number_0: 'custom_number_0',
        custom_number_1: 'custom_number_1',
        custom_number_2: 'custom_number_2',
        custom_number_3: 'custom_number_3',
        custom_number_4: 'custom_number_4',
        description: 'description',
        errors: 'errors',
        expiration_date: 'expiration_date',
        fb_product_category: 'fb_product_category',
        gender: 'gender',
        gtin: 'gtin',
        id: 'id',
        image_cdn_urls: 'image_cdn_urls',
        image_fetch_status: 'image_fetch_status',
        image_url: 'image_url',
        images: 'images',
        importer_address: 'importer_address',
        importer_name: 'importer_name',
        invalidation_errors: 'invalidation_errors',
        inventory: 'inventory',
        manufacturer_info: 'manufacturer_info',
        manufacturer_part_number: 'manufacturer_part_number',
        marked_for_product_launch: 'marked_for_product_launch',
        material: 'material',
        mobile_link: 'mobile_link',
        name: 'name',
        ordering_index: 'ordering_index',
        origin_country: 'origin_country',
        parent_product_id: 'parent_product_id',
        pattern: 'pattern',
        post_conversion_signal_based_enforcement_appeal_eligibility: 'post_conversion_signal_based_enforcement_appeal_eligibility',
        price: 'price',
        product_catalog: 'product_catalog',
        product_feed: 'product_feed',
        product_group: 'product_group',
        product_type: 'product_type',
        quantity_to_sell_on_facebook: 'quantity_to_sell_on_facebook',
        retailer_id: 'retailer_id',
        retailer_product_group_id: 'retailer_product_group_id',
        review_rejection_reasons: 'review_rejection_reasons',
        review_status: 'review_status',
        sale_price: 'sale_price',
        sale_price_end_date: 'sale_price_end_date',
        sale_price_start_date: 'sale_price_start_date',
        shipping_weight_unit: 'shipping_weight_unit',
        shipping_weight_value: 'shipping_weight_value',
        short_description: 'short_description',
        size: 'size',
        start_date: 'start_date',
        url: 'url',
        visibility: 'visibility',
        wa_compliance_category: 'wa_compliance_category'
      });
    }
  }, {
    key: 'AgeGroup',
    get: function get() {
      return Object.freeze({
        adult: 'adult',
        all_ages: 'all ages',
        infant: 'infant',
        kids: 'kids',
        newborn: 'newborn',
        teen: 'teen',
        toddler: 'toddler'
      });
    }
  }, {
    key: 'Availability',
    get: function get() {
      return Object.freeze({
        available_for_order: 'available for order',
        discontinued: 'discontinued',
        in_stock: 'in stock',
        out_of_stock: 'out of stock',
        pending: 'pending',
        preorder: 'preorder'
      });
    }
  }, {
    key: 'Condition',
    get: function get() {
      return Object.freeze({
        cpo: 'cpo',
        new: 'new',
        open_box_new: 'open_box_new',
        refurbished: 'refurbished',
        used: 'used',
        used_fair: 'used_fair',
        used_good: 'used_good',
        used_like_new: 'used_like_new'
      });
    }
  }, {
    key: 'Gender',
    get: function get() {
      return Object.freeze({
        female: 'female',
        male: 'male',
        unisex: 'unisex'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'ReviewStatus',
    get: function get() {
      return Object.freeze({
        approved: 'approved',
        outdated: 'outdated',
        pending: 'pending',
        rejected: 'rejected'
      });
    }
  }, {
    key: 'ShippingWeightUnit',
    get: function get() {
      return Object.freeze({
        g: 'g',
        kg: 'kg',
        lb: 'lb',
        oz: 'oz'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'published',
        staging: 'staging'
      });
    }
  }, {
    key: 'CommerceTaxCategory',
    get: function get() {
      return Object.freeze({
        fb_animal: 'FB_ANIMAL',
        fb_animal_supp: 'FB_ANIMAL_SUPP',
        fb_aprl: 'FB_APRL',
        fb_aprl_accessories: 'FB_APRL_ACCESSORIES',
        fb_aprl_athl_unif: 'FB_APRL_ATHL_UNIF',
        fb_aprl_cases: 'FB_APRL_CASES',
        fb_aprl_clothing: 'FB_APRL_CLOTHING',
        fb_aprl_costume: 'FB_APRL_COSTUME',
        fb_aprl_cstm: 'FB_APRL_CSTM',
        fb_aprl_formal: 'FB_APRL_FORMAL',
        fb_aprl_handbag: 'FB_APRL_HANDBAG',
        fb_aprl_jewelry: 'FB_APRL_JEWELRY',
        fb_aprl_shoe: 'FB_APRL_SHOE',
        fb_aprl_shoe_acc: 'FB_APRL_SHOE_ACC',
        fb_aprl_swim: 'FB_APRL_SWIM',
        fb_aprl_swim_chil: 'FB_APRL_SWIM_CHIL',
        fb_aprl_swim_cvr: 'FB_APRL_SWIM_CVR',
        fb_arts: 'FB_ARTS',
        fb_arts_hobby: 'FB_ARTS_HOBBY',
        fb_arts_party: 'FB_ARTS_PARTY',
        fb_arts_party_gift_card: 'FB_ARTS_PARTY_GIFT_CARD',
        fb_arts_ticket: 'FB_ARTS_TICKET',
        fb_baby: 'FB_BABY',
        fb_baby_bath: 'FB_BABY_BATH',
        fb_baby_blanket: 'FB_BABY_BLANKET',
        fb_baby_diaper: 'FB_BABY_DIAPER',
        fb_baby_gift_set: 'FB_BABY_GIFT_SET',
        fb_baby_health: 'FB_BABY_HEALTH',
        fb_baby_nursing: 'FB_BABY_NURSING',
        fb_baby_potty_trn: 'FB_BABY_POTTY_TRN',
        fb_baby_safe: 'FB_BABY_SAFE',
        fb_baby_toys: 'FB_BABY_TOYS',
        fb_baby_transport: 'FB_BABY_TRANSPORT',
        fb_baby_transport_acc: 'FB_BABY_TRANSPORT_ACC',
        fb_bags: 'FB_BAGS',
        fb_bags_bkpk: 'FB_BAGS_BKPK',
        fb_bags_boxes: 'FB_BAGS_BOXES',
        fb_bags_brfcs: 'FB_BAGS_BRFCS',
        fb_bags_csmt_bag: 'FB_BAGS_CSMT_BAG',
        fb_bags_dffl: 'FB_BAGS_DFFL',
        fb_bags_dipr: 'FB_BAGS_DIPR',
        fb_bags_fnny: 'FB_BAGS_FNNY',
        fb_bags_grmt: 'FB_BAGS_GRMT',
        fb_bags_lugg: 'FB_BAGS_LUGG',
        fb_bags_lug_acc: 'FB_BAGS_LUG_ACC',
        fb_bags_msgr: 'FB_BAGS_MSGR',
        fb_bags_tote: 'FB_BAGS_TOTE',
        fb_bags_trn_cas: 'FB_BAGS_TRN_CAS',
        fb_bldg: 'FB_BLDG',
        fb_bldg_acc: 'FB_BLDG_ACC',
        fb_bldg_cnsmb: 'FB_BLDG_CNSMB',
        fb_bldg_fence: 'FB_BLDG_FENCE',
        fb_bldg_fuel_tnk: 'FB_BLDG_FUEL_TNK',
        fb_bldg_ht_vnt: 'FB_BLDG_HT_VNT',
        fb_bldg_lock: 'FB_BLDG_LOCK',
        fb_bldg_matrl: 'FB_BLDG_MATRL',
        fb_bldg_plmb: 'FB_BLDG_PLMB',
        fb_bldg_pump: 'FB_BLDG_PUMP',
        fb_bldg_pwrs: 'FB_BLDG_PWRS',
        fb_bldg_str_tank: 'FB_BLDG_STR_TANK',
        fb_bldg_s_eng: 'FB_BLDG_S_ENG',
        fb_bldg_tl_acc: 'FB_BLDG_TL_ACC',
        fb_bldg_tool: 'FB_BLDG_TOOL',
        fb_busind: 'FB_BUSIND',
        fb_busind_advertising: 'FB_BUSIND_ADVERTISING',
        fb_busind_agriculture: 'FB_BUSIND_AGRICULTURE',
        fb_busind_automation: 'FB_BUSIND_AUTOMATION',
        fb_busind_heavy_mach: 'FB_BUSIND_HEAVY_MACH',
        fb_busind_lab: 'FB_BUSIND_LAB',
        fb_busind_medical: 'FB_BUSIND_MEDICAL',
        fb_busind_retail: 'FB_BUSIND_RETAIL',
        fb_busind_sanitary_ct: 'FB_BUSIND_SANITARY_CT',
        fb_busind_sign: 'FB_BUSIND_SIGN',
        fb_busind_storage: 'FB_BUSIND_STORAGE',
        fb_busind_storage_acc: 'FB_BUSIND_STORAGE_ACC',
        fb_busind_work_gear: 'FB_BUSIND_WORK_GEAR',
        fb_camera_acc: 'FB_CAMERA_ACC',
        fb_camera_camera: 'FB_CAMERA_CAMERA',
        fb_camera_optic: 'FB_CAMERA_OPTIC',
        fb_camera_optics: 'FB_CAMERA_OPTICS',
        fb_camera_photo: 'FB_CAMERA_PHOTO',
        fb_elec: 'FB_ELEC',
        fb_elec_acc: 'FB_ELEC_ACC',
        fb_elec_arcdade: 'FB_ELEC_ARCDADE',
        fb_elec_audio: 'FB_ELEC_AUDIO',
        fb_elec_circuit: 'FB_ELEC_CIRCUIT',
        fb_elec_comm: 'FB_ELEC_COMM',
        fb_elec_computer: 'FB_ELEC_COMPUTER',
        fb_elec_gps_acc: 'FB_ELEC_GPS_ACC',
        fb_elec_gps_nav: 'FB_ELEC_GPS_NAV',
        fb_elec_gps_trk: 'FB_ELEC_GPS_TRK',
        fb_elec_marine: 'FB_ELEC_MARINE',
        fb_elec_network: 'FB_ELEC_NETWORK',
        fb_elec_part: 'FB_ELEC_PART',
        fb_elec_print: 'FB_ELEC_PRINT',
        fb_elec_radar: 'FB_ELEC_RADAR',
        fb_elec_sftwr: 'FB_ELEC_SFTWR',
        fb_elec_speed_rdr: 'FB_ELEC_SPEED_RDR',
        fb_elec_television: 'FB_ELEC_TELEVISION',
        fb_elec_toll: 'FB_ELEC_TOLL',
        fb_elec_video: 'FB_ELEC_VIDEO',
        fb_elec_vid_gm_acc: 'FB_ELEC_VID_GM_ACC',
        fb_elec_vid_gm_cnsl: 'FB_ELEC_VID_GM_CNSL',
        fb_food: 'FB_FOOD',
        fb_furn: 'FB_FURN',
        fb_furn_baby: 'FB_FURN_BABY',
        fb_furn_bench: 'FB_FURN_BENCH',
        fb_furn_cart: 'FB_FURN_CART',
        fb_furn_chair: 'FB_FURN_CHAIR',
        fb_furn_chair_acc: 'FB_FURN_CHAIR_ACC',
        fb_furn_divide: 'FB_FURN_DIVIDE',
        fb_furn_divide_acc: 'FB_FURN_DIVIDE_ACC',
        fb_furn_ent_ctr: 'FB_FURN_ENT_CTR',
        fb_furn_futn: 'FB_FURN_FUTN',
        fb_furn_futn_pad: 'FB_FURN_FUTN_PAD',
        fb_furn_office: 'FB_FURN_OFFICE',
        fb_furn_office_acc: 'FB_FURN_OFFICE_ACC',
        fb_furn_otto: 'FB_FURN_OTTO',
        fb_furn_outdoor: 'FB_FURN_OUTDOOR',
        fb_furn_outdoor_acc: 'FB_FURN_OUTDOOR_ACC',
        fb_furn_sets: 'FB_FURN_SETS',
        fb_furn_shelve_acc: 'FB_FURN_SHELVE_ACC',
        fb_furn_shlf: 'FB_FURN_SHLF',
        fb_furn_sofa: 'FB_FURN_SOFA',
        fb_furn_sofa_acc: 'FB_FURN_SOFA_ACC',
        fb_furn_storage: 'FB_FURN_STORAGE',
        fb_furn_tabl: 'FB_FURN_TABL',
        fb_furn_tabl_acc: 'FB_FURN_TABL_ACC',
        fb_generic_taxable: 'FB_GENERIC_TAXABLE',
        fb_hlth: 'FB_HLTH',
        fb_hlth_hlth: 'FB_HLTH_HLTH',
        fb_hlth_jwl_cr: 'FB_HLTH_JWL_CR',
        fb_hlth_lilp_blm: 'FB_HLTH_LILP_BLM',
        fb_hlth_ltn_spf: 'FB_HLTH_LTN_SPF',
        fb_hlth_prsl_cr: 'FB_HLTH_PRSL_CR',
        fb_hlth_skn_cr: 'FB_HLTH_SKN_CR',
        fb_hmgn: 'FB_HMGN',
        fb_hmgn_bath: 'FB_HMGN_BATH',
        fb_hmgn_dcor: 'FB_HMGN_DCOR',
        fb_hmgn_emgy: 'FB_HMGN_EMGY',
        fb_hmgn_fplc: 'FB_HMGN_FPLC',
        fb_hmgn_fplc_acc: 'FB_HMGN_FPLC_ACC',
        fb_hmgn_gs_sft: 'FB_HMGN_GS_SFT',
        fb_hmgn_hs_acc: 'FB_HMGN_HS_ACC',
        fb_hmgn_hs_app: 'FB_HMGN_HS_APP',
        fb_hmgn_hs_spl: 'FB_HMGN_HS_SPL',
        fb_hmgn_ktcn: 'FB_HMGN_KTCN',
        fb_hmgn_lawn: 'FB_HMGN_LAWN',
        fb_hmgn_lght: 'FB_HMGN_LGHT',
        fb_hmgn_linn: 'FB_HMGN_LINN',
        fb_hmgn_lt_acc: 'FB_HMGN_LT_ACC',
        fb_hmgn_otdr: 'FB_HMGN_OTDR',
        fb_hmgn_pool: 'FB_HMGN_POOL',
        fb_hmgn_scty: 'FB_HMGN_SCTY',
        fb_hmgn_smk_acc: 'FB_HMGN_SMK_ACC',
        fb_hmgn_umbr: 'FB_HMGN_UMBR',
        fb_hmgn_umbr_acc: 'FB_HMGN_UMBR_ACC',
        fb_mdia: 'FB_MDIA',
        fb_mdia_book: 'FB_MDIA_BOOK',
        fb_mdia_dvds: 'FB_MDIA_DVDS',
        fb_mdia_mag: 'FB_MDIA_MAG',
        fb_mdia_manl: 'FB_MDIA_MANL',
        fb_mdia_musc: 'FB_MDIA_MUSC',
        fb_mdia_prj_pln: 'FB_MDIA_PRJ_PLN',
        fb_mdia_sht_mus: 'FB_MDIA_SHT_MUS',
        fb_offc: 'FB_OFFC',
        fb_offc_bkac: 'FB_OFFC_BKAC',
        fb_offc_crts: 'FB_OFFC_CRTS',
        fb_offc_dskp: 'FB_OFFC_DSKP',
        fb_offc_eqip: 'FB_OFFC_EQIP',
        fb_offc_flng: 'FB_OFFC_FLNG',
        fb_offc_gnrl: 'FB_OFFC_GNRL',
        fb_offc_instm: 'FB_OFFC_INSTM',
        fb_offc_lp_dsk: 'FB_OFFC_LP_DSK',
        fb_offc_mats: 'FB_OFFC_MATS',
        fb_offc_nm_plt: 'FB_OFFC_NM_PLT',
        fb_offc_ppr_hndl: 'FB_OFFC_PPR_HNDL',
        fb_offc_prsnt_spl: 'FB_OFFC_PRSNT_SPL',
        fb_offc_sealr: 'FB_OFFC_SEALR',
        fb_offc_ship_spl: 'FB_OFFC_SHIP_SPL',
        fb_rlgn: 'FB_RLGN',
        fb_rlgn_cmny: 'FB_RLGN_CMNY',
        fb_rlgn_item: 'FB_RLGN_ITEM',
        fb_rlgn_wedd: 'FB_RLGN_WEDD',
        fb_sftwr: 'FB_SFTWR',
        fb_sfwr_cmptr: 'FB_SFWR_CMPTR',
        fb_sfwr_dgtl_gd: 'FB_SFWR_DGTL_GD',
        fb_sfwr_game: 'FB_SFWR_GAME',
        fb_shipping: 'FB_SHIPPING',
        fb_spor: 'FB_SPOR',
        fb_sport_athl: 'FB_SPORT_ATHL',
        fb_sport_athl_clth: 'FB_SPORT_ATHL_CLTH',
        fb_sport_athl_shoe: 'FB_SPORT_ATHL_SHOE',
        fb_sport_athl_sprt: 'FB_SPORT_ATHL_SPRT',
        fb_sport_exrcs: 'FB_SPORT_EXRCS',
        fb_sport_indr_gm: 'FB_SPORT_INDR_GM',
        fb_sport_otdr_gm: 'FB_SPORT_OTDR_GM',
        fb_toys: 'FB_TOYS',
        fb_toys_eqip: 'FB_TOYS_EQIP',
        fb_toys_game: 'FB_TOYS_GAME',
        fb_toys_pzzl: 'FB_TOYS_PZZL',
        fb_toys_tmrs: 'FB_TOYS_TMRS',
        fb_toys_toys: 'FB_TOYS_TOYS',
        fb_vehi: 'FB_VEHI',
        fb_vehi_part: 'FB_VEHI_PART'
      });
    }
  }, {
    key: 'ErrorPriority',
    get: function get() {
      return Object.freeze({
        high: 'HIGH',
        low: 'LOW',
        medium: 'MEDIUM'
      });
    }
  }, {
    key: 'ErrorType',
    get: function get() {
      return Object.freeze({
        ar_deleted_due_to_update: 'AR_DELETED_DUE_TO_UPDATE',
        ar_policy_violated: 'AR_POLICY_VIOLATED',
        available: 'AVAILABLE',
        bad_quality_image: 'BAD_QUALITY_IMAGE',
        cannot_edit_subscription_products: 'CANNOT_EDIT_SUBSCRIPTION_PRODUCTS',
        crawled_availability_mismatch: 'CRAWLED_AVAILABILITY_MISMATCH',
        digital_goods_not_available_for_checkout: 'DIGITAL_GOODS_NOT_AVAILABLE_FOR_CHECKOUT',
        duplicate_images: 'DUPLICATE_IMAGES',
        duplicate_title_and_description: 'DUPLICATE_TITLE_AND_DESCRIPTION',
        generic_invalid_field: 'GENERIC_INVALID_FIELD',
        hidden_until_product_launch: 'HIDDEN_UNTIL_PRODUCT_LAUNCH',
        image_fetch_failed: 'IMAGE_FETCH_FAILED',
        image_fetch_failed_bad_gateway: 'IMAGE_FETCH_FAILED_BAD_GATEWAY',
        image_fetch_failed_file_size_exceeded: 'IMAGE_FETCH_FAILED_FILE_SIZE_EXCEEDED',
        image_fetch_failed_forbidden: 'IMAGE_FETCH_FAILED_FORBIDDEN',
        image_fetch_failed_link_broken: 'IMAGE_FETCH_FAILED_LINK_BROKEN',
        image_fetch_failed_timed_out: 'IMAGE_FETCH_FAILED_TIMED_OUT',
        image_resolution_low: 'IMAGE_RESOLUTION_LOW',
        inactive_shopify_product: 'INACTIVE_SHOPIFY_PRODUCT',
        invalid_commerce_tax_category: 'INVALID_COMMERCE_TAX_CATEGORY',
        invalid_images: 'INVALID_IMAGES',
        invalid_monetizer_return_policy: 'INVALID_MONETIZER_RETURN_POLICY',
        invalid_pre_order_params: 'INVALID_PRE_ORDER_PARAMS',
        invalid_shipping_profile_params: 'INVALID_SHIPPING_PROFILE_PARAMS',
        invalid_subscription_disable_params: 'INVALID_SUBSCRIPTION_DISABLE_PARAMS',
        invalid_subscription_enable_params: 'INVALID_SUBSCRIPTION_ENABLE_PARAMS',
        invalid_subscription_params: 'INVALID_SUBSCRIPTION_PARAMS',
        inventory_zero_availability_in_stock: 'INVENTORY_ZERO_AVAILABILITY_IN_STOCK',
        in_another_product_launch: 'IN_ANOTHER_PRODUCT_LAUNCH',
        item_group_not_specified: 'ITEM_GROUP_NOT_SPECIFIED',
        item_not_shippable_for_sca_shop: 'ITEM_NOT_SHIPPABLE_FOR_SCA_SHOP',
        item_override_not_visible: 'ITEM_OVERRIDE_NOT_VISIBLE',
        item_stale_out_of_stock: 'ITEM_STALE_OUT_OF_STOCK',
        mini_shops_disabled_by_user: 'MINI_SHOPS_DISABLED_BY_USER',
        missing_checkout: 'MISSING_CHECKOUT',
        missing_checkout_currency: 'MISSING_CHECKOUT_CURRENCY',
        missing_color: 'MISSING_COLOR',
        missing_country_override_in_shipping_profile: 'MISSING_COUNTRY_OVERRIDE_IN_SHIPPING_PROFILE',
        missing_india_compliance_fields: 'MISSING_INDIA_COMPLIANCE_FIELDS',
        missing_shipping_profile: 'MISSING_SHIPPING_PROFILE',
        missing_size: 'MISSING_SIZE',
        missing_tax_category: 'MISSING_TAX_CATEGORY',
        negative_community_feedback: 'NEGATIVE_COMMUNITY_FEEDBACK',
        not_enough_images: 'NOT_ENOUGH_IMAGES',
        part_of_product_launch: 'PART_OF_PRODUCT_LAUNCH',
        product_expired: 'PRODUCT_EXPIRED',
        product_item_hidden_from_all_shops: 'PRODUCT_ITEM_HIDDEN_FROM_ALL_SHOPS',
        product_item_not_included_in_any_shop: 'PRODUCT_ITEM_NOT_INCLUDED_IN_ANY_SHOP',
        product_item_not_visible: 'PRODUCT_ITEM_NOT_VISIBLE',
        product_not_approved: 'PRODUCT_NOT_APPROVED',
        product_not_dominant_currency: 'PRODUCT_NOT_DOMINANT_CURRENCY',
        product_out_of_stock: 'PRODUCT_OUT_OF_STOCK',
        product_url_equals_domain: 'PRODUCT_URL_EQUALS_DOMAIN',
        property_price_currency_not_supported: 'PROPERTY_PRICE_CURRENCY_NOT_SUPPORTED',
        property_price_too_high: 'PROPERTY_PRICE_TOO_HIGH',
        property_price_too_low: 'PROPERTY_PRICE_TOO_LOW',
        property_value_contains_html_tags: 'PROPERTY_VALUE_CONTAINS_HTML_TAGS',
        property_value_description_contains_off_platform_link: 'PROPERTY_VALUE_DESCRIPTION_CONTAINS_OFF_PLATFORM_LINK',
        property_value_format: 'PROPERTY_VALUE_FORMAT',
        property_value_missing: 'PROPERTY_VALUE_MISSING',
        property_value_missing_warning: 'PROPERTY_VALUE_MISSING_WARNING',
        property_value_non_positive: 'PROPERTY_VALUE_NON_POSITIVE',
        property_value_string_exceeds_length: 'PROPERTY_VALUE_STRING_EXCEEDS_LENGTH',
        property_value_string_too_short: 'PROPERTY_VALUE_STRING_TOO_SHORT',
        property_value_uppercase_warning: 'PROPERTY_VALUE_UPPERCASE_WARNING',
        quality_duplicated_description: 'QUALITY_DUPLICATED_DESCRIPTION',
        quality_item_link_broken: 'QUALITY_ITEM_LINK_BROKEN',
        quality_item_link_redirecting: 'QUALITY_ITEM_LINK_REDIRECTING',
        retailer_id_not_provided: 'RETAILER_ID_NOT_PROVIDED',
        shopify_item_missing_shipping_profile: 'SHOPIFY_ITEM_MISSING_SHIPPING_PROFILE',
        subscription_info_not_enabled_for_feed: 'SUBSCRIPTION_INFO_NOT_ENABLED_FOR_FEED',
        tax_category_not_supported_in_uk: 'TAX_CATEGORY_NOT_SUPPORTED_IN_UK',
        unsupported_product_category: 'UNSUPPORTED_PRODUCT_CATEGORY',
        variant_attribute_issue: 'VARIANT_ATTRIBUTE_ISSUE'
      });
    }
  }, {
    key: 'MarkedForProductLaunch',
    get: function get() {
      return Object.freeze({
        default: 'default',
        marked: 'marked',
        not_marked: 'not_marked'
      });
    }
  }, {
    key: 'OriginCountry',
    get: function get() {
      return Object.freeze({
        ad: 'AD',
        ae: 'AE',
        af: 'AF',
        ag: 'AG',
        ai: 'AI',
        al: 'AL',
        am: 'AM',
        an: 'AN',
        ao: 'AO',
        aq: 'AQ',
        ar: 'AR',
        as: 'AS',
        at: 'AT',
        au: 'AU',
        aw: 'AW',
        ax: 'AX',
        az: 'AZ',
        ba: 'BA',
        bb: 'BB',
        bd: 'BD',
        be: 'BE',
        bf: 'BF',
        bg: 'BG',
        bh: 'BH',
        bi: 'BI',
        bj: 'BJ',
        bl: 'BL',
        bm: 'BM',
        bn: 'BN',
        bo: 'BO',
        bq: 'BQ',
        br: 'BR',
        bs: 'BS',
        bt: 'BT',
        bv: 'BV',
        bw: 'BW',
        by: 'BY',
        bz: 'BZ',
        ca: 'CA',
        cc: 'CC',
        cd: 'CD',
        cf: 'CF',
        cg: 'CG',
        ch: 'CH',
        ci: 'CI',
        ck: 'CK',
        cl: 'CL',
        cm: 'CM',
        cn: 'CN',
        co: 'CO',
        cr: 'CR',
        cu: 'CU',
        cv: 'CV',
        cw: 'CW',
        cx: 'CX',
        cy: 'CY',
        cz: 'CZ',
        de: 'DE',
        dj: 'DJ',
        dk: 'DK',
        dm: 'DM',
        do: 'DO',
        dz: 'DZ',
        ec: 'EC',
        ee: 'EE',
        eg: 'EG',
        eh: 'EH',
        er: 'ER',
        es: 'ES',
        et: 'ET',
        fi: 'FI',
        fj: 'FJ',
        fk: 'FK',
        fm: 'FM',
        fo: 'FO',
        fr: 'FR',
        ga: 'GA',
        gb: 'GB',
        gd: 'GD',
        ge: 'GE',
        gf: 'GF',
        gg: 'GG',
        gh: 'GH',
        gi: 'GI',
        gl: 'GL',
        gm: 'GM',
        gn: 'GN',
        gp: 'GP',
        gq: 'GQ',
        gr: 'GR',
        gs: 'GS',
        gt: 'GT',
        gu: 'GU',
        gw: 'GW',
        gy: 'GY',
        hk: 'HK',
        hm: 'HM',
        hn: 'HN',
        hr: 'HR',
        ht: 'HT',
        hu: 'HU',
        id: 'ID',
        ie: 'IE',
        il: 'IL',
        im: 'IM',
        in: 'IN',
        io: 'IO',
        iq: 'IQ',
        ir: 'IR',
        is: 'IS',
        it: 'IT',
        je: 'JE',
        jm: 'JM',
        jo: 'JO',
        jp: 'JP',
        ke: 'KE',
        kg: 'KG',
        kh: 'KH',
        ki: 'KI',
        km: 'KM',
        kn: 'KN',
        kp: 'KP',
        kr: 'KR',
        kw: 'KW',
        ky: 'KY',
        kz: 'KZ',
        la: 'LA',
        lb: 'LB',
        lc: 'LC',
        li: 'LI',
        lk: 'LK',
        lr: 'LR',
        ls: 'LS',
        lt: 'LT',
        lu: 'LU',
        lv: 'LV',
        ly: 'LY',
        ma: 'MA',
        mc: 'MC',
        md: 'MD',
        me: 'ME',
        mf: 'MF',
        mg: 'MG',
        mh: 'MH',
        mk: 'MK',
        ml: 'ML',
        mm: 'MM',
        mn: 'MN',
        mo: 'MO',
        mp: 'MP',
        mq: 'MQ',
        mr: 'MR',
        ms: 'MS',
        mt: 'MT',
        mu: 'MU',
        mv: 'MV',
        mw: 'MW',
        mx: 'MX',
        my: 'MY',
        mz: 'MZ',
        na: 'NA',
        nc: 'NC',
        ne: 'NE',
        nf: 'NF',
        ng: 'NG',
        ni: 'NI',
        nl: 'NL',
        no: 'NO',
        np: 'NP',
        nr: 'NR',
        nu: 'NU',
        nz: 'NZ',
        om: 'OM',
        pa: 'PA',
        pe: 'PE',
        pf: 'PF',
        pg: 'PG',
        ph: 'PH',
        pk: 'PK',
        pl: 'PL',
        pm: 'PM',
        pn: 'PN',
        pr: 'PR',
        ps: 'PS',
        pt: 'PT',
        pw: 'PW',
        py: 'PY',
        qa: 'QA',
        re: 'RE',
        ro: 'RO',
        rs: 'RS',
        ru: 'RU',
        rw: 'RW',
        sa: 'SA',
        sb: 'SB',
        sc: 'SC',
        sd: 'SD',
        se: 'SE',
        sg: 'SG',
        sh: 'SH',
        si: 'SI',
        sj: 'SJ',
        sk: 'SK',
        sl: 'SL',
        sm: 'SM',
        sn: 'SN',
        so: 'SO',
        sr: 'SR',
        ss: 'SS',
        st: 'ST',
        sv: 'SV',
        sx: 'SX',
        sy: 'SY',
        sz: 'SZ',
        tc: 'TC',
        td: 'TD',
        tf: 'TF',
        tg: 'TG',
        th: 'TH',
        tj: 'TJ',
        tk: 'TK',
        tl: 'TL',
        tm: 'TM',
        tn: 'TN',
        to: 'TO',
        tr: 'TR',
        tt: 'TT',
        tv: 'TV',
        tw: 'TW',
        tz: 'TZ',
        ua: 'UA',
        ug: 'UG',
        um: 'UM',
        us: 'US',
        uy: 'UY',
        uz: 'UZ',
        va: 'VA',
        vc: 'VC',
        ve: 'VE',
        vg: 'VG',
        vi: 'VI',
        vn: 'VN',
        vu: 'VU',
        wf: 'WF',
        ws: 'WS',
        xk: 'XK',
        ye: 'YE',
        yt: 'YT',
        za: 'ZA',
        zm: 'ZM',
        zw: 'ZW'
      });
    }
  }, {
    key: 'WaComplianceCategory',
    get: function get() {
      return Object.freeze({
        country_origin_exempt: 'COUNTRY_ORIGIN_EXEMPT',
        default: 'DEFAULT'
      });
    }
  }]);
  return ProductItem;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedRule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedRule = function (_AbstractCrudObject) {
  inherits(ProductFeedRule, _AbstractCrudObject);

  function ProductFeedRule() {
    classCallCheck(this, ProductFeedRule);
    return possibleConstructorReturn(this, (ProductFeedRule.__proto__ || Object.getPrototypeOf(ProductFeedRule)).apply(this, arguments));
  }

  createClass(ProductFeedRule, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductFeedRule.prototype.__proto__ || Object.getPrototypeOf(ProductFeedRule.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductFeedRule.prototype.__proto__ || Object.getPrototypeOf(ProductFeedRule.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        attribute: 'attribute',
        id: 'id',
        params: 'params',
        rule_type: 'rule_type'
      });
    }
  }, {
    key: 'RuleType',
    get: function get() {
      return Object.freeze({
        fallback_rule: 'fallback_rule',
        letter_case_rule: 'letter_case_rule',
        mapping_rule: 'mapping_rule',
        regex_replace_rule: 'regex_replace_rule',
        value_mapping_rule: 'value_mapping_rule'
      });
    }
  }]);
  return ProductFeedRule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedSchedule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedSchedule = function (_AbstractCrudObject) {
  inherits(ProductFeedSchedule, _AbstractCrudObject);

  function ProductFeedSchedule() {
    classCallCheck(this, ProductFeedSchedule);
    return possibleConstructorReturn(this, (ProductFeedSchedule.__proto__ || Object.getPrototypeOf(ProductFeedSchedule)).apply(this, arguments));
  }

  createClass(ProductFeedSchedule, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        day_of_month: 'day_of_month',
        day_of_week: 'day_of_week',
        hour: 'hour',
        id: 'id',
        interval: 'interval',
        interval_count: 'interval_count',
        minute: 'minute',
        timezone: 'timezone',
        url: 'url',
        username: 'username'
      });
    }
  }, {
    key: 'DayOfWeek',
    get: function get() {
      return Object.freeze({
        friday: 'FRIDAY',
        monday: 'MONDAY',
        saturday: 'SATURDAY',
        sunday: 'SUNDAY',
        thursday: 'THURSDAY',
        tuesday: 'TUESDAY',
        wednesday: 'WEDNESDAY'
      });
    }
  }, {
    key: 'Interval',
    get: function get() {
      return Object.freeze({
        daily: 'DAILY',
        hourly: 'HOURLY',
        monthly: 'MONTHLY',
        weekly: 'WEEKLY'
      });
    }
  }]);
  return ProductFeedSchedule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedUploadErrorSample
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedUploadErrorSample = function (_AbstractCrudObject) {
  inherits(ProductFeedUploadErrorSample, _AbstractCrudObject);

  function ProductFeedUploadErrorSample() {
    classCallCheck(this, ProductFeedUploadErrorSample);
    return possibleConstructorReturn(this, (ProductFeedUploadErrorSample.__proto__ || Object.getPrototypeOf(ProductFeedUploadErrorSample)).apply(this, arguments));
  }

  createClass(ProductFeedUploadErrorSample, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        retailer_id: 'retailer_id',
        row_number: 'row_number'
      });
    }
  }]);
  return ProductFeedUploadErrorSample;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedRuleSuggestion
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedRuleSuggestion = function (_AbstractCrudObject) {
  inherits(ProductFeedRuleSuggestion, _AbstractCrudObject);

  function ProductFeedRuleSuggestion() {
    classCallCheck(this, ProductFeedRuleSuggestion);
    return possibleConstructorReturn(this, (ProductFeedRuleSuggestion.__proto__ || Object.getPrototypeOf(ProductFeedRuleSuggestion)).apply(this, arguments));
  }

  createClass(ProductFeedRuleSuggestion, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        attribute: 'attribute',
        params: 'params',
        type: 'type'
      });
    }
  }]);
  return ProductFeedRuleSuggestion;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedUploadError
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedUploadError = function (_AbstractCrudObject) {
  inherits(ProductFeedUploadError, _AbstractCrudObject);

  function ProductFeedUploadError() {
    classCallCheck(this, ProductFeedUploadError);
    return possibleConstructorReturn(this, (ProductFeedUploadError.__proto__ || Object.getPrototypeOf(ProductFeedUploadError)).apply(this, arguments));
  }

  createClass(ProductFeedUploadError, [{
    key: 'getSamples',
    value: function getSamples(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeedUploadErrorSample, fields, params, fetchFirstPage, '/samples');
    }
  }, {
    key: 'getSuggestedRules',
    value: function getSuggestedRules(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeedRuleSuggestion, fields, params, fetchFirstPage, '/suggested_rules');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        affected_surfaces: 'affected_surfaces',
        description: 'description',
        error_type: 'error_type',
        id: 'id',
        severity: 'severity',
        summary: 'summary',
        total_count: 'total_count'
      });
    }
  }, {
    key: 'AffectedSurfaces',
    get: function get() {
      return Object.freeze({
        dynamic_ads: 'Dynamic Ads',
        marketplace: 'Marketplace',
        us_marketplace: 'US Marketplace'
      });
    }
  }, {
    key: 'Severity',
    get: function get() {
      return Object.freeze({
        fatal: 'fatal',
        warning: 'warning'
      });
    }
  }, {
    key: 'ErrorPriority',
    get: function get() {
      return Object.freeze({
        high: 'HIGH',
        low: 'LOW',
        medium: 'MEDIUM'
      });
    }
  }]);
  return ProductFeedUploadError;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedUpload
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedUpload = function (_AbstractCrudObject) {
  inherits(ProductFeedUpload, _AbstractCrudObject);

  function ProductFeedUpload() {
    classCallCheck(this, ProductFeedUpload);
    return possibleConstructorReturn(this, (ProductFeedUpload.__proto__ || Object.getPrototypeOf(ProductFeedUpload)).apply(this, arguments));
  }

  createClass(ProductFeedUpload, [{
    key: 'createErrorReport',
    value: function createErrorReport(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/error_report', fields, params, ProductFeedUpload, pathOverride);
    }
  }, {
    key: 'getErrors',
    value: function getErrors(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeedUploadError, fields, params, fetchFirstPage, '/errors');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        end_time: 'end_time',
        error_count: 'error_count',
        error_report: 'error_report',
        filename: 'filename',
        id: 'id',
        input_method: 'input_method',
        num_deleted_items: 'num_deleted_items',
        num_detected_items: 'num_detected_items',
        num_invalid_items: 'num_invalid_items',
        num_persisted_items: 'num_persisted_items',
        start_time: 'start_time',
        url: 'url',
        warning_count: 'warning_count'
      });
    }
  }, {
    key: 'InputMethod',
    get: function get() {
      return Object.freeze({
        google_sheets_fetch: 'Google Sheets Fetch',
        manual_upload: 'Manual Upload',
        reupload_last_file: 'Reupload Last File',
        server_fetch: 'Server Fetch',
        user_initiated_server_fetch: 'User initiated server fetch'
      });
    }
  }]);
  return ProductFeedUpload;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeed
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeed = function (_AbstractCrudObject) {
  inherits(ProductFeed, _AbstractCrudObject);

  function ProductFeed() {
    classCallCheck(this, ProductFeed);
    return possibleConstructorReturn(this, (ProductFeed.__proto__ || Object.getPrototypeOf(ProductFeed)).apply(this, arguments));
  }

  createClass(ProductFeed, [{
    key: 'getAutomotiveModels',
    value: function getAutomotiveModels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AutomotiveModel, fields, params, fetchFirstPage, '/automotive_models');
    }
  }, {
    key: 'getDestinations',
    value: function getDestinations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Destination, fields, params, fetchFirstPage, '/destinations');
    }
  }, {
    key: 'getFlights',
    value: function getFlights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Flight, fields, params, fetchFirstPage, '/flights');
    }
  }, {
    key: 'getHomeListings',
    value: function getHomeListings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(HomeListing, fields, params, fetchFirstPage, '/home_listings');
    }
  }, {
    key: 'getHotels',
    value: function getHotels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Hotel, fields, params, fetchFirstPage, '/hotels');
    }
  }, {
    key: 'getMediaTitles',
    value: function getMediaTitles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MediaTitle, fields, params, fetchFirstPage, '/media_titles');
    }
  }, {
    key: 'getProducts',
    value: function getProducts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductItem, fields, params, fetchFirstPage, '/products');
    }
  }, {
    key: 'getRules',
    value: function getRules(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeedRule, fields, params, fetchFirstPage, '/rules');
    }
  }, {
    key: 'createRule',
    value: function createRule(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/rules', fields, params, ProductFeedRule, pathOverride);
    }
  }, {
    key: 'createSupplementaryFeedAssoc',
    value: function createSupplementaryFeedAssoc(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/supplementary_feed_assocs', fields, params, null, pathOverride);
    }
  }, {
    key: 'getUploadSchedules',
    value: function getUploadSchedules(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeedSchedule, fields, params, fetchFirstPage, '/upload_schedules');
    }
  }, {
    key: 'createUploadSchedule',
    value: function createUploadSchedule(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/upload_schedules', fields, params, ProductFeed, pathOverride);
    }
  }, {
    key: 'getUploads',
    value: function getUploads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeedUpload, fields, params, fetchFirstPage, '/uploads');
    }
  }, {
    key: 'createUpload',
    value: function createUpload(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/uploads', fields, params, ProductFeedUpload, pathOverride);
    }
  }, {
    key: 'getVehicleOffers',
    value: function getVehicleOffers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(VehicleOffer, fields, params, fetchFirstPage, '/vehicle_offers');
    }
  }, {
    key: 'getVehicles',
    value: function getVehicles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Vehicle, fields, params, fetchFirstPage, '/vehicles');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductFeed.prototype.__proto__ || Object.getPrototypeOf(ProductFeed.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductFeed.prototype.__proto__ || Object.getPrototypeOf(ProductFeed.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        created_time: 'created_time',
        default_currency: 'default_currency',
        deletion_enabled: 'deletion_enabled',
        delimiter: 'delimiter',
        encoding: 'encoding',
        file_name: 'file_name',
        id: 'id',
        ingestion_source_type: 'ingestion_source_type',
        item_sub_type: 'item_sub_type',
        latest_upload: 'latest_upload',
        migrated_from_feed_id: 'migrated_from_feed_id',
        name: 'name',
        override_type: 'override_type',
        primary_feeds: 'primary_feeds',
        product_count: 'product_count',
        quoted_fields_mode: 'quoted_fields_mode',
        schedule: 'schedule',
        supplementary_feeds: 'supplementary_feeds',
        update_schedule: 'update_schedule'
      });
    }
  }, {
    key: 'Delimiter',
    get: function get() {
      return Object.freeze({
        autodetect: 'AUTODETECT',
        bar: 'BAR',
        comma: 'COMMA',
        semicolon: 'SEMICOLON',
        tab: 'TAB',
        tilde: 'TILDE'
      });
    }
  }, {
    key: 'IngestionSourceType',
    get: function get() {
      return Object.freeze({
        primary_feed: 'primary_feed',
        supplementary_feed: 'supplementary_feed'
      });
    }
  }, {
    key: 'QuotedFieldsMode',
    get: function get() {
      return Object.freeze({
        autodetect: 'AUTODETECT',
        off: 'OFF',
        on: 'ON'
      });
    }
  }, {
    key: 'Encoding',
    get: function get() {
      return Object.freeze({
        autodetect: 'AUTODETECT',
        latin1: 'LATIN1',
        utf16be: 'UTF16BE',
        utf16le: 'UTF16LE',
        utf32be: 'UTF32BE',
        utf32le: 'UTF32LE',
        utf8: 'UTF8'
      });
    }
  }, {
    key: 'FeedType',
    get: function get() {
      return Object.freeze({
        automotive_model: 'AUTOMOTIVE_MODEL',
        destination: 'DESTINATION',
        flight: 'FLIGHT',
        home_listing: 'HOME_LISTING',
        hotel: 'HOTEL',
        hotel_room: 'HOTEL_ROOM',
        local_inventory: 'LOCAL_INVENTORY',
        media_title: 'MEDIA_TITLE',
        offer: 'OFFER',
        products: 'PRODUCTS',
        transactable_items: 'TRANSACTABLE_ITEMS',
        vehicles: 'VEHICLES',
        vehicle_offer: 'VEHICLE_OFFER'
      });
    }
  }, {
    key: 'ItemSubType',
    get: function get() {
      return Object.freeze({
        appliances: 'APPLIANCES',
        baby_feeding: 'BABY_FEEDING',
        baby_transport: 'BABY_TRANSPORT',
        beauty: 'BEAUTY',
        bedding: 'BEDDING',
        cameras: 'CAMERAS',
        cell_phones_and_smart_watches: 'CELL_PHONES_AND_SMART_WATCHES',
        cleaning_supplies: 'CLEANING_SUPPLIES',
        clothing: 'CLOTHING',
        clothing_accessories: 'CLOTHING_ACCESSORIES',
        computers_and_tablets: 'COMPUTERS_AND_TABLETS',
        diapering_and_potty_training: 'DIAPERING_AND_POTTY_TRAINING',
        electronics_accessories: 'ELECTRONICS_ACCESSORIES',
        furniture: 'FURNITURE',
        health: 'HEALTH',
        home_goods: 'HOME_GOODS',
        jewelry: 'JEWELRY',
        nursery: 'NURSERY',
        printers_and_scanners: 'PRINTERS_AND_SCANNERS',
        projectors: 'PROJECTORS',
        shoes_and_footwear: 'SHOES_AND_FOOTWEAR',
        software: 'SOFTWARE',
        toys: 'TOYS',
        tvs_and_monitors: 'TVS_AND_MONITORS',
        video_game_consoles_and_video_games: 'VIDEO_GAME_CONSOLES_AND_VIDEO_GAMES',
        watches: 'WATCHES'
      });
    }
  }, {
    key: 'OverrideType',
    get: function get() {
      return Object.freeze({
        batch_api_language_or_country: 'BATCH_API_LANGUAGE_OR_COUNTRY',
        catalog_segment_customize_default: 'CATALOG_SEGMENT_CUSTOMIZE_DEFAULT',
        country: 'COUNTRY',
        language: 'LANGUAGE',
        language_and_country: 'LANGUAGE_AND_COUNTRY',
        local: 'LOCAL'
      });
    }
  }]);
  return ProductFeed;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductGroup
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductGroup = function (_AbstractCrudObject) {
  inherits(ProductGroup, _AbstractCrudObject);

  function ProductGroup() {
    classCallCheck(this, ProductGroup);
    return possibleConstructorReturn(this, (ProductGroup.__proto__ || Object.getPrototypeOf(ProductGroup)).apply(this, arguments));
  }

  createClass(ProductGroup, [{
    key: 'getProducts',
    value: function getProducts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductItem, fields, params, fetchFirstPage, '/products');
    }
  }, {
    key: 'createProduct',
    value: function createProduct(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/products', fields, params, ProductItem, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductGroup.prototype.__proto__ || Object.getPrototypeOf(ProductGroup.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductGroup.prototype.__proto__ || Object.getPrototypeOf(ProductGroup.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        product_catalog: 'product_catalog',
        retailer_id: 'retailer_id',
        variants: 'variants'
      });
    }
  }]);
  return ProductGroup;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogProductSetsBatch
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogProductSetsBatch = function (_AbstractCrudObject) {
  inherits(ProductCatalogProductSetsBatch, _AbstractCrudObject);

  function ProductCatalogProductSetsBatch() {
    classCallCheck(this, ProductCatalogProductSetsBatch);
    return possibleConstructorReturn(this, (ProductCatalogProductSetsBatch.__proto__ || Object.getPrototypeOf(ProductCatalogProductSetsBatch)).apply(this, arguments));
  }

  createClass(ProductCatalogProductSetsBatch, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        errors: 'errors',
        errors_total_count: 'errors_total_count',
        handle: 'handle',
        status: 'status'
      });
    }
  }]);
  return ProductCatalogProductSetsBatch;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalog
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalog = function (_AbstractCrudObject) {
  inherits(ProductCatalog, _AbstractCrudObject);

  function ProductCatalog() {
    classCallCheck(this, ProductCatalog);
    return possibleConstructorReturn(this, (ProductCatalog.__proto__ || Object.getPrototypeOf(ProductCatalog)).apply(this, arguments));
  }

  createClass(ProductCatalog, [{
    key: 'deleteAgencies',
    value: function deleteAgencies() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(ProductCatalog.prototype.__proto__ || Object.getPrototypeOf(ProductCatalog.prototype), 'deleteEdge', this).call(this, '/agencies', params);
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'createAgency',
    value: function createAgency(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/agencies', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getArEffectsBatchStatus',
    value: function getArEffectsBatchStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AREffectsBatchStatus, fields, params, fetchFirstPage, '/ar_effects_batch_status');
    }
  }, {
    key: 'deleteAssignedUsers',
    value: function deleteAssignedUsers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(ProductCatalog.prototype.__proto__ || Object.getPrototypeOf(ProductCatalog.prototype), 'deleteEdge', this).call(this, '/assigned_users', params);
    }
  }, {
    key: 'getAssignedUsers',
    value: function getAssignedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AssignedUser, fields, params, fetchFirstPage, '/assigned_users');
    }
  }, {
    key: 'createAssignedUser',
    value: function createAssignedUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assigned_users', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getAutomotiveModels',
    value: function getAutomotiveModels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AutomotiveModel, fields, params, fetchFirstPage, '/automotive_models');
    }
  }, {
    key: 'createBatch',
    value: function createBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/batch', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'createCatalogStore',
    value: function createCatalogStore(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/catalog_store', fields, params, StoreCatalogSettings, pathOverride);
    }
  }, {
    key: 'getCategories',
    value: function getCategories(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalogCategory, fields, params, fetchFirstPage, '/categories');
    }
  }, {
    key: 'createCategory',
    value: function createCategory(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/categories', fields, params, ProductCatalogCategory, pathOverride);
    }
  }, {
    key: 'getCheckBatchRequestStatus',
    value: function getCheckBatchRequestStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CheckBatchRequestStatus, fields, params, fetchFirstPage, '/check_batch_request_status');
    }
  }, {
    key: 'getCollaborativeAdsEventStats',
    value: function getCollaborativeAdsEventStats(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogSegmentAllMatchCountLaser, fields, params, fetchFirstPage, '/collaborative_ads_event_stats');
    }
  }, {
    key: 'getCollaborativeAdsLsbImageBank',
    value: function getCollaborativeAdsLsbImageBank(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/collaborative_ads_lsb_image_bank');
    }
  }, {
    key: 'getCollaborativeAdsShareSettings',
    value: function getCollaborativeAdsShareSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CollaborativeAdsShareSettings, fields, params, fetchFirstPage, '/collaborative_ads_share_settings');
    }
  }, {
    key: 'createCpasLsbImageBank',
    value: function createCpasLsbImageBank(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/cpas_lsb_image_bank', fields, params, null, pathOverride);
    }
  }, {
    key: 'getDataSources',
    value: function getDataSources(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalogDataSource, fields, params, fetchFirstPage, '/data_sources');
    }
  }, {
    key: 'getDestinations',
    value: function getDestinations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Destination, fields, params, fetchFirstPage, '/destinations');
    }
  }, {
    key: 'getDiagnostics',
    value: function getDiagnostics(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalogDiagnosticGroup, fields, params, fetchFirstPage, '/diagnostics');
    }
  }, {
    key: 'getEventStats',
    value: function getEventStats(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductEventStat, fields, params, fetchFirstPage, '/event_stats');
    }
  }, {
    key: 'deleteExternalEventSources',
    value: function deleteExternalEventSources() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(ProductCatalog.prototype.__proto__ || Object.getPrototypeOf(ProductCatalog.prototype), 'deleteEdge', this).call(this, '/external_event_sources', params);
    }
  }, {
    key: 'getExternalEventSources',
    value: function getExternalEventSources(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ExternalEventSource, fields, params, fetchFirstPage, '/external_event_sources');
    }
  }, {
    key: 'createExternalEventSource',
    value: function createExternalEventSource(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/external_event_sources', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getFlights',
    value: function getFlights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Flight, fields, params, fetchFirstPage, '/flights');
    }
  }, {
    key: 'getHomeListings',
    value: function getHomeListings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(HomeListing, fields, params, fetchFirstPage, '/home_listings');
    }
  }, {
    key: 'createHomeListing',
    value: function createHomeListing(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/home_listings', fields, params, HomeListing, pathOverride);
    }
  }, {
    key: 'getHotelRoomsBatch',
    value: function getHotelRoomsBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalogHotelRoomsBatch, fields, params, fetchFirstPage, '/hotel_rooms_batch');
    }
  }, {
    key: 'createHotelRoomsBatch',
    value: function createHotelRoomsBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/hotel_rooms_batch', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getHotels',
    value: function getHotels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Hotel, fields, params, fetchFirstPage, '/hotels');
    }
  }, {
    key: 'createHotel',
    value: function createHotel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/hotels', fields, params, Hotel, pathOverride);
    }
  }, {
    key: 'createItemsBatch',
    value: function createItemsBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/items_batch', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'createLocalizedItemsBatch',
    value: function createLocalizedItemsBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/localized_items_batch', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getMediaTitles',
    value: function getMediaTitles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MediaTitle, fields, params, fetchFirstPage, '/media_titles');
    }
  }, {
    key: 'createMediaTitle',
    value: function createMediaTitle(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/media_titles', fields, params, MediaTitle, pathOverride);
    }
  }, {
    key: 'getPricingVariablesBatch',
    value: function getPricingVariablesBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalogPricingVariablesBatch, fields, params, fetchFirstPage, '/pricing_variables_batch');
    }
  }, {
    key: 'createPricingVariablesBatch',
    value: function createPricingVariablesBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/pricing_variables_batch', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getProductFeeds',
    value: function getProductFeeds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductFeed, fields, params, fetchFirstPage, '/product_feeds');
    }
  }, {
    key: 'createProductFeed',
    value: function createProductFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_feeds', fields, params, ProductFeed, pathOverride);
    }
  }, {
    key: 'getProductGroups',
    value: function getProductGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductGroup, fields, params, fetchFirstPage, '/product_groups');
    }
  }, {
    key: 'createProductGroup',
    value: function createProductGroup(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_groups', fields, params, ProductGroup, pathOverride);
    }
  }, {
    key: 'getProductSets',
    value: function getProductSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductSet, fields, params, fetchFirstPage, '/product_sets');
    }
  }, {
    key: 'createProductSet',
    value: function createProductSet(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_sets', fields, params, ProductSet, pathOverride);
    }
  }, {
    key: 'getProductSetsBatch',
    value: function getProductSetsBatch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalogProductSetsBatch, fields, params, fetchFirstPage, '/product_sets_batch');
    }
  }, {
    key: 'getProducts',
    value: function getProducts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductItem, fields, params, fetchFirstPage, '/products');
    }
  }, {
    key: 'createProduct',
    value: function createProduct(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/products', fields, params, ProductItem, pathOverride);
    }
  }, {
    key: 'getVehicleOffers',
    value: function getVehicleOffers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(VehicleOffer, fields, params, fetchFirstPage, '/vehicle_offers');
    }
  }, {
    key: 'getVehicles',
    value: function getVehicles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Vehicle, fields, params, fetchFirstPage, '/vehicles');
    }
  }, {
    key: 'createVehicle',
    value: function createVehicle(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/vehicles', fields, params, Vehicle, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductCatalog.prototype.__proto__ || Object.getPrototypeOf(ProductCatalog.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ProductCatalog.prototype.__proto__ || Object.getPrototypeOf(ProductCatalog.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_account_to_collaborative_ads_share_settings: 'ad_account_to_collaborative_ads_share_settings',
        agency_collaborative_ads_share_settings: 'agency_collaborative_ads_share_settings',
        business: 'business',
        catalog_store: 'catalog_store',
        commerce_merchant_settings: 'commerce_merchant_settings',
        creator_user: 'creator_user',
        da_display_settings: 'da_display_settings',
        default_image_url: 'default_image_url',
        fallback_image_url: 'fallback_image_url',
        feed_count: 'feed_count',
        id: 'id',
        is_catalog_segment: 'is_catalog_segment',
        name: 'name',
        owner_business: 'owner_business',
        product_count: 'product_count',
        store_catalog_settings: 'store_catalog_settings',
        vertical: 'vertical'
      });
    }
  }, {
    key: 'Vertical',
    get: function get() {
      return Object.freeze({
        adoptable_pets: 'adoptable_pets',
        bookable: 'bookable',
        commerce: 'commerce',
        destinations: 'destinations',
        flights: 'flights',
        home_listings: 'home_listings',
        hotels: 'hotels',
        jobs: 'jobs',
        local_delivery_shipping_profiles: 'local_delivery_shipping_profiles',
        local_service_businesses: 'local_service_businesses',
        offer_items: 'offer_items',
        offline_commerce: 'offline_commerce',
        ticketed_experiences: 'ticketed_experiences',
        transactable_items: 'transactable_items',
        vehicles: 'vehicles'
      });
    }
  }, {
    key: 'PermittedRoles',
    get: function get() {
      return Object.freeze({
        admin: 'ADMIN',
        advertiser: 'ADVERTISER'
      });
    }
  }, {
    key: 'PermittedTasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        manage: 'MANAGE',
        manage_ar: 'MANAGE_AR'
      });
    }
  }, {
    key: 'Tasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        manage: 'MANAGE',
        manage_ar: 'MANAGE_AR'
      });
    }
  }, {
    key: 'Standard',
    get: function get() {
      return Object.freeze({
        google: 'google'
      });
    }
  }, {
    key: 'ItemSubType',
    get: function get() {
      return Object.freeze({
        appliances: 'APPLIANCES',
        baby_feeding: 'BABY_FEEDING',
        baby_transport: 'BABY_TRANSPORT',
        beauty: 'BEAUTY',
        bedding: 'BEDDING',
        cameras: 'CAMERAS',
        cell_phones_and_smart_watches: 'CELL_PHONES_AND_SMART_WATCHES',
        cleaning_supplies: 'CLEANING_SUPPLIES',
        clothing: 'CLOTHING',
        clothing_accessories: 'CLOTHING_ACCESSORIES',
        computers_and_tablets: 'COMPUTERS_AND_TABLETS',
        diapering_and_potty_training: 'DIAPERING_AND_POTTY_TRAINING',
        electronics_accessories: 'ELECTRONICS_ACCESSORIES',
        furniture: 'FURNITURE',
        health: 'HEALTH',
        home_goods: 'HOME_GOODS',
        jewelry: 'JEWELRY',
        nursery: 'NURSERY',
        printers_and_scanners: 'PRINTERS_AND_SCANNERS',
        projectors: 'PROJECTORS',
        shoes_and_footwear: 'SHOES_AND_FOOTWEAR',
        software: 'SOFTWARE',
        toys: 'TOYS',
        tvs_and_monitors: 'TVS_AND_MONITORS',
        video_game_consoles_and_video_games: 'VIDEO_GAME_CONSOLES_AND_VIDEO_GAMES',
        watches: 'WATCHES'
      });
    }
  }]);
  return ProductCatalog;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommerceMerchantSettingsSetupStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommerceMerchantSettingsSetupStatus = function (_AbstractCrudObject) {
  inherits(CommerceMerchantSettingsSetupStatus, _AbstractCrudObject);

  function CommerceMerchantSettingsSetupStatus() {
    classCallCheck(this, CommerceMerchantSettingsSetupStatus);
    return possibleConstructorReturn(this, (CommerceMerchantSettingsSetupStatus.__proto__ || Object.getPrototypeOf(CommerceMerchantSettingsSetupStatus)).apply(this, arguments));
  }

  createClass(CommerceMerchantSettingsSetupStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        deals_setup: 'deals_setup',
        marketplace_approval_status: 'marketplace_approval_status',
        marketplace_approval_status_details: 'marketplace_approval_status_details',
        payment_setup: 'payment_setup',
        review_status: 'review_status',
        shop_setup: 'shop_setup'
      });
    }
  }]);
  return CommerceMerchantSettingsSetupStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Shop
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Shop = function (_AbstractCrudObject) {
  inherits(Shop, _AbstractCrudObject);

  function Shop() {
    classCallCheck(this, Shop);
    return possibleConstructorReturn(this, (Shop.__proto__ || Object.getPrototypeOf(Shop)).apply(this, arguments));
  }

  createClass(Shop, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        fb_sales_channel: 'fb_sales_channel',
        id: 'id',
        ig_sales_channel: 'ig_sales_channel',
        workspace: 'workspace'
      });
    }
  }]);
  return Shop;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommerceMerchantSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommerceMerchantSettings = function (_AbstractCrudObject) {
  inherits(CommerceMerchantSettings, _AbstractCrudObject);

  function CommerceMerchantSettings() {
    classCallCheck(this, CommerceMerchantSettings);
    return possibleConstructorReturn(this, (CommerceMerchantSettings.__proto__ || Object.getPrototypeOf(CommerceMerchantSettings)).apply(this, arguments));
  }

  createClass(CommerceMerchantSettings, [{
    key: 'createAcknowledgeOrder',
    value: function createAcknowledgeOrder(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/acknowledge_orders', fields, params, CommerceMerchantSettings, pathOverride);
    }
  }, {
    key: 'getCommerceOrders',
    value: function getCommerceOrders(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceOrder, fields, params, fetchFirstPage, '/commerce_orders');
    }
  }, {
    key: 'getCommercePayouts',
    value: function getCommercePayouts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommercePayout, fields, params, fetchFirstPage, '/commerce_payouts');
    }
  }, {
    key: 'getCommerceTransactions',
    value: function getCommerceTransactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceOrderTransactionDetail, fields, params, fetchFirstPage, '/commerce_transactions');
    }
  }, {
    key: 'getOnsiteConversionEvents',
    value: function getOnsiteConversionEvents(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/onsite_conversion_events');
    }
  }, {
    key: 'getOrderManagementApps',
    value: function getOrderManagementApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/order_management_apps');
    }
  }, {
    key: 'createOrderManagementApp',
    value: function createOrderManagementApp(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/order_management_apps', fields, params, CommerceMerchantSettings, pathOverride);
    }
  }, {
    key: 'getProductCatalogs',
    value: function getProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/product_catalogs');
    }
  }, {
    key: 'getReturns',
    value: function getReturns(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/returns');
    }
  }, {
    key: 'getSellerIssues',
    value: function getSellerIssues(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/seller_issues');
    }
  }, {
    key: 'getSetupStatus',
    value: function getSetupStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceMerchantSettingsSetupStatus, fields, params, fetchFirstPage, '/setup_status');
    }
  }, {
    key: 'getShippingProfiles',
    value: function getShippingProfiles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/shipping_profiles');
    }
  }, {
    key: 'createShippingProfile',
    value: function createShippingProfile(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/shipping_profiles', fields, params, null, pathOverride);
    }
  }, {
    key: 'getShops',
    value: function getShops(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Shop, fields, params, fetchFirstPage, '/shops');
    }
  }, {
    key: 'getTaxSettings',
    value: function getTaxSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/tax_settings');
    }
  }, {
    key: 'createWhatsappChannel',
    value: function createWhatsappChannel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/whatsapp_channel', fields, params, null, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        braintree_merchant_id: 'braintree_merchant_id',
        checkout_message: 'checkout_message',
        commerce_store: 'commerce_store',
        contact_email: 'contact_email',
        cta: 'cta',
        disable_checkout_urls: 'disable_checkout_urls',
        display_name: 'display_name',
        external_merchant_id: 'external_merchant_id',
        facebook_channel: 'facebook_channel',
        feature_eligibility: 'feature_eligibility',
        has_discount_code: 'has_discount_code',
        has_onsite_intent: 'has_onsite_intent',
        id: 'id',
        instagram_channel: 'instagram_channel',
        merchant_alert_email: 'merchant_alert_email',
        merchant_page: 'merchant_page',
        merchant_status: 'merchant_status',
        onsite_commerce_merchant: 'onsite_commerce_merchant',
        payment_provider: 'payment_provider',
        privacy_url_by_locale: 'privacy_url_by_locale',
        review_rejection_messages: 'review_rejection_messages',
        review_rejection_reasons: 'review_rejection_reasons',
        supported_card_types: 'supported_card_types',
        terms: 'terms',
        terms_url_by_locale: 'terms_url_by_locale',
        whatsapp_channel: 'whatsapp_channel'
      });
    }
  }]);
  return CommerceMerchantSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UnifiedThread
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UnifiedThread = function (_AbstractCrudObject) {
  inherits(UnifiedThread, _AbstractCrudObject);

  function UnifiedThread() {
    classCallCheck(this, UnifiedThread);
    return possibleConstructorReturn(this, (UnifiedThread.__proto__ || Object.getPrototypeOf(UnifiedThread)).apply(this, arguments));
  }

  createClass(UnifiedThread, [{
    key: 'getMessages',
    value: function getMessages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/messages');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        can_reply: 'can_reply',
        folder: 'folder',
        former_participants: 'former_participants',
        id: 'id',
        is_subscribed: 'is_subscribed',
        link: 'link',
        message_count: 'message_count',
        name: 'name',
        participants: 'participants',
        scoped_thread_key: 'scoped_thread_key',
        senders: 'senders',
        snippet: 'snippet',
        subject: 'subject',
        unread_count: 'unread_count',
        updated_time: 'updated_time',
        wallpaper: 'wallpaper'
      });
    }
  }, {
    key: 'Platform',
    get: function get() {
      return Object.freeze({
        instagram: 'INSTAGRAM',
        messenger: 'MESSENGER'
      });
    }
  }]);
  return UnifiedThread;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageUserMessageThreadLabel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageUserMessageThreadLabel = function (_AbstractCrudObject) {
  inherits(PageUserMessageThreadLabel, _AbstractCrudObject);

  function PageUserMessageThreadLabel() {
    classCallCheck(this, PageUserMessageThreadLabel);
    return possibleConstructorReturn(this, (PageUserMessageThreadLabel.__proto__ || Object.getPrototypeOf(PageUserMessageThreadLabel)).apply(this, arguments));
  }

  createClass(PageUserMessageThreadLabel, [{
    key: 'deleteLabel',
    value: function deleteLabel() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(PageUserMessageThreadLabel.prototype.__proto__ || Object.getPrototypeOf(PageUserMessageThreadLabel.prototype), 'deleteEdge', this).call(this, '/label', params);
    }
  }, {
    key: 'createLabel',
    value: function createLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/label', fields, params, PageUserMessageThreadLabel, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PageUserMessageThreadLabel.prototype.__proto__ || Object.getPrototypeOf(PageUserMessageThreadLabel.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        page_label_name: 'page_label_name'
      });
    }
  }]);
  return PageUserMessageThreadLabel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomUserSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomUserSettings = function (_AbstractCrudObject) {
  inherits(CustomUserSettings, _AbstractCrudObject);

  function CustomUserSettings() {
    classCallCheck(this, CustomUserSettings);
    return possibleConstructorReturn(this, (CustomUserSettings.__proto__ || Object.getPrototypeOf(CustomUserSettings)).apply(this, arguments));
  }

  createClass(CustomUserSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        page_level_persistent_menu: 'page_level_persistent_menu',
        user_level_persistent_menu: 'user_level_persistent_menu'
      });
    }
  }]);
  return CustomUserSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * NullNode
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var NullNode = function (_AbstractCrudObject) {
  inherits(NullNode, _AbstractCrudObject);

  function NullNode() {
    classCallCheck(this, NullNode);
    return possibleConstructorReturn(this, (NullNode.__proto__ || Object.getPrototypeOf(NullNode)).apply(this, arguments));
  }

  createClass(NullNode, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({});
    }
  }]);
  return NullNode;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AppRequestFormerRecipient
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AppRequestFormerRecipient = function (_AbstractCrudObject) {
  inherits(AppRequestFormerRecipient, _AbstractCrudObject);

  function AppRequestFormerRecipient() {
    classCallCheck(this, AppRequestFormerRecipient);
    return possibleConstructorReturn(this, (AppRequestFormerRecipient.__proto__ || Object.getPrototypeOf(AppRequestFormerRecipient)).apply(this, arguments));
  }

  createClass(AppRequestFormerRecipient, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        recipient_id: 'recipient_id'
      });
    }
  }]);
  return AppRequestFormerRecipient;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AppRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AppRequest = function (_AbstractCrudObject) {
  inherits(AppRequest, _AbstractCrudObject);

  function AppRequest() {
    classCallCheck(this, AppRequest);
    return possibleConstructorReturn(this, (AppRequest.__proto__ || Object.getPrototypeOf(AppRequest)).apply(this, arguments));
  }

  createClass(AppRequest, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AppRequest.prototype.__proto__ || Object.getPrototypeOf(AppRequest.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        action_type: 'action_type',
        application: 'application',
        created_time: 'created_time',
        data: 'data',
        from: 'from',
        id: 'id',
        message: 'message',
        object: 'object',
        to: 'to'
      });
    }
  }]);
  return AppRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessUser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessUser = function (_AbstractCrudObject) {
  inherits(BusinessUser, _AbstractCrudObject);

  function BusinessUser() {
    classCallCheck(this, BusinessUser);
    return possibleConstructorReturn(this, (BusinessUser.__proto__ || Object.getPrototypeOf(BusinessUser)).apply(this, arguments));
  }

  createClass(BusinessUser, [{
    key: 'getAssignedAdAccounts',
    value: function getAssignedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/assigned_ad_accounts');
    }
  }, {
    key: 'getAssignedBusinessAssetGroups',
    value: function getAssignedBusinessAssetGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAssetGroup, fields, params, fetchFirstPage, '/assigned_business_asset_groups');
    }
  }, {
    key: 'getAssignedPages',
    value: function getAssignedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/assigned_pages');
    }
  }, {
    key: 'getAssignedProductCatalogs',
    value: function getAssignedProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/assigned_product_catalogs');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(BusinessUser.prototype.__proto__ || Object.getPrototypeOf(BusinessUser.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(BusinessUser.prototype.__proto__ || Object.getPrototypeOf(BusinessUser.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business: 'business',
        business_role_request: 'business_role_request',
        email: 'email',
        finance_permission: 'finance_permission',
        first_name: 'first_name',
        id: 'id',
        ip_permission: 'ip_permission',
        last_name: 'last_name',
        marked_for_removal: 'marked_for_removal',
        name: 'name',
        pending_email: 'pending_email',
        role: 'role',
        title: 'title',
        two_fac_status: 'two_fac_status'
      });
    }
  }, {
    key: 'Role',
    get: function get() {
      return Object.freeze({
        admin: 'ADMIN',
        ads_rights_reviewer: 'ADS_RIGHTS_REVIEWER',
        default: 'DEFAULT',
        developer: 'DEVELOPER',
        employee: 'EMPLOYEE',
        finance_analyst: 'FINANCE_ANALYST',
        finance_edit: 'FINANCE_EDIT',
        finance_editor: 'FINANCE_EDITOR',
        finance_view: 'FINANCE_VIEW',
        manage: 'MANAGE',
        partner_center_admin: 'PARTNER_CENTER_ADMIN',
        partner_center_analyst: 'PARTNER_CENTER_ANALYST',
        partner_center_education: 'PARTNER_CENTER_EDUCATION',
        partner_center_marketing: 'PARTNER_CENTER_MARKETING',
        partner_center_operations: 'PARTNER_CENTER_OPERATIONS'
      });
    }
  }]);
  return BusinessUser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * FundraiserPersonToCharity
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var FundraiserPersonToCharity = function (_AbstractCrudObject) {
  inherits(FundraiserPersonToCharity, _AbstractCrudObject);

  function FundraiserPersonToCharity() {
    classCallCheck(this, FundraiserPersonToCharity);
    return possibleConstructorReturn(this, (FundraiserPersonToCharity.__proto__ || Object.getPrototypeOf(FundraiserPersonToCharity)).apply(this, arguments));
  }

  createClass(FundraiserPersonToCharity, [{
    key: 'getDonations',
    value: function getDonations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/donations');
    }
  }, {
    key: 'createEndFundraiser',
    value: function createEndFundraiser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/end_fundraiser', fields, params, null, pathOverride);
    }
  }, {
    key: 'getExternalDonations',
    value: function getExternalDonations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/external_donations');
    }
  }, {
    key: 'createExternalDonation',
    value: function createExternalDonation(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/external_donations', fields, params, null, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(FundraiserPersonToCharity.prototype.__proto__ || Object.getPrototypeOf(FundraiserPersonToCharity.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount_raised: 'amount_raised',
        charity_id: 'charity_id',
        currency: 'currency',
        description: 'description',
        donations_count: 'donations_count',
        donors_count: 'donors_count',
        end_time: 'end_time',
        external_amount_raised: 'external_amount_raised',
        external_donations_count: 'external_donations_count',
        external_donors_count: 'external_donors_count',
        external_event_name: 'external_event_name',
        external_event_start_time: 'external_event_start_time',
        external_event_uri: 'external_event_uri',
        external_fundraiser_uri: 'external_fundraiser_uri',
        external_id: 'external_id',
        goal_amount: 'goal_amount',
        id: 'id',
        internal_amount_raised: 'internal_amount_raised',
        internal_donations_count: 'internal_donations_count',
        internal_donors_count: 'internal_donors_count',
        name: 'name',
        uri: 'uri'
      });
    }
  }, {
    key: 'FundraiserType',
    get: function get() {
      return Object.freeze({
        person_for_charity: 'person_for_charity'
      });
    }
  }]);
  return FundraiserPersonToCharity;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * GameItem
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var GameItem = function (_AbstractCrudObject) {
  inherits(GameItem, _AbstractCrudObject);

  function GameItem() {
    classCallCheck(this, GameItem);
    return possibleConstructorReturn(this, (GameItem.__proto__ || Object.getPrototypeOf(GameItem)).apply(this, arguments));
  }

  createClass(GameItem, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        count: 'count',
        created: 'created',
        ext_id: 'ext_id',
        id: 'id',
        item_def: 'item_def',
        owner: 'owner',
        status: 'status',
        updated: 'updated'
      });
    }
  }, {
    key: 'Action',
    get: function get() {
      return Object.freeze({
        consume: 'CONSUME',
        drop: 'DROP',
        mark: 'MARK'
      });
    }
  }]);
  return GameItem;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoThumbnail
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoThumbnail = function (_AbstractCrudObject) {
  inherits(VideoThumbnail, _AbstractCrudObject);

  function VideoThumbnail() {
    classCallCheck(this, VideoThumbnail);
    return possibleConstructorReturn(this, (VideoThumbnail.__proto__ || Object.getPrototypeOf(VideoThumbnail)).apply(this, arguments));
  }

  createClass(VideoThumbnail, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        height: 'height',
        id: 'id',
        is_preferred: 'is_preferred',
        name: 'name',
        scale: 'scale',
        uri: 'uri',
        width: 'width'
      });
    }
  }]);
  return VideoThumbnail;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * @format
 * 
 */
/**
 * Video uploader that can upload videos to adaccount
 **/

var VideoUploader = function () {
  function VideoUploader() {
    classCallCheck(this, VideoUploader);

    this._session = null;
  }

  /**
   * Upload the given video file.
   * @param {AdVideo} video The AdVideo object that will be uploaded
   * @param {Boolean} [waitForEncoding] Whether to wait until encoding
   *   is finished
   **/


  createClass(VideoUploader, [{
    key: 'upload',
    value: function upload(video, waitForEncoding) {
      // Check there is no existing session
      if (this._session) {
        throw Error('There is already an upload session for this video uploader');
      }

      // Initate an upload session
      this._session = new VideoUploadSession(video, waitForEncoding);
      var result = this._session.start();
      this._session = null;
      return result;
    }
  }]);
  return VideoUploader;
}();

var VideoUploadSession = function () {
  function VideoUploadSession(video) {
    var waitForEncoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, VideoUploadSession);

    this._video = video;
    this._api = video.getApi();

    if (video.filepath) {
      this._filePath = video.filepath;
      this._slideshowSpec = null;
    } else if (video.slideshow_spec) {
      this._slideshowSpec = video.slideshow_spec;
      this._filePath = null;
    }

    this._accountId = video.getParentId();
    this._waitForEncoding = waitForEncoding;
    // Setup start request manager
    this._startRequestManager = new VideoUploadStartRequestManager(this._api);
    // Setup transfer request manager
    this._transferRequestManager = new VideoUploadTransferRequestManager(this._api);
    // Setup finish request manager
    this._finishRequestManager = new VideoUploadFinishRequestManager(this._api);
  }

  createClass(VideoUploadSession, [{
    key: 'start',
    value: function () {
      var _ref = asyncToGenerator(function* () {
        var videoId = void 0;

        // Run start request manager
        var startResponse = yield this._startRequestManager.sendRequest(this.getStartRequestContext());
        this._startOffset = parseInt(startResponse['start_offset']);
        this._endOffset = parseInt(startResponse['end_offset']);
        this._sessionId = startResponse['upload_session_id'];
        videoId = startResponse['video_id'];
        // Run transfer request manager
        yield this._transferRequestManager.sendRequest(this.getTransferRequestContext());
        // Run finish request manager
        var finishResponse = yield this._finishRequestManager.sendRequest(this.getFinishRequestContext());
        // Populate the video info
        var body = finishResponse;
        body.id = videoId;
        delete body.success;

        return body;
      });

      function start() {
        return _ref.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: 'getStartRequestContext',
    value: function getStartRequestContext() {
      var context = new VideoUploadRequestContext();

      if (this._filePath) {
        // Read file size
        context.fileSize = fs.statSync(this._filePath).size;
      }
      context.accountId = this._accountId;

      return context;
    }
  }, {
    key: 'getTransferRequestContext',
    value: function getTransferRequestContext() {
      var context = new VideoUploadRequestContext();

      context.sessionId = this._sessionId;
      context.startOffset = this._startOffset;
      context.endOffset = this._endOffset;

      if (this._filePath) {
        context.filePath = this._filePath;
      }
      if (this._slideshowSpec) {
        context.slideshowSpec = this._slideshowSpec;
      }
      context.accountId = this._accountId;

      return context;
    }
  }, {
    key: 'getFinishRequestContext',
    value: function getFinishRequestContext() {
      var context = new VideoUploadRequestContext();

      context.sessionId = this._sessionId;
      context.accountId = this._accountId;

      if (this._filePath) {
        context.fileName = path.basename(this._filePath);
      }

      return context;
    }
  }]);
  return VideoUploadSession;
}();

/**
 * Abstract class for request managers
 **/


var VideoUploadRequestManager = function () {
  function VideoUploadRequestManager(api) {
    classCallCheck(this, VideoUploadRequestManager);

    this._api = api;
  }

  createClass(VideoUploadRequestManager, [{
    key: 'sendRequest',
    value: function sendRequest(context) {
      throw new TypeError('Class extending VideoUploadRequestManager must implement ' + 'sendRequest method');
    }
  }, {
    key: 'getParamsFromContext',
    value: function getParamsFromContext(context) {
      throw new TypeError('Class extending VideoUploadRequestManager must implement ' + 'getParamsFromContext method');
    }
  }]);
  return VideoUploadRequestManager;
}();

var VideoUploadStartRequestManager = function (_VideoUploadRequestMa) {
  inherits(VideoUploadStartRequestManager, _VideoUploadRequestMa);

  function VideoUploadStartRequestManager() {
    classCallCheck(this, VideoUploadStartRequestManager);
    return possibleConstructorReturn(this, (VideoUploadStartRequestManager.__proto__ || Object.getPrototypeOf(VideoUploadStartRequestManager)).apply(this, arguments));
  }

  createClass(VideoUploadStartRequestManager, [{
    key: 'sendRequest',

    /**
     * Send start request with the given context
     **/
    value: function () {
      var _ref2 = asyncToGenerator(function* (context) {
        // Init a VideoUploadRequest and send the request
        var request = new VideoUploadRequest(this._api);
        request.setParams(this.getParamsFromContext(context));

        var response = yield request.send([context.accountId, 'advideos']);

        return response;
      });

      function sendRequest(_x2) {
        return _ref2.apply(this, arguments);
      }

      return sendRequest;
    }()
  }, {
    key: 'getParamsFromContext',
    value: function getParamsFromContext(context) {
      return {
        file_size: context.fileSize,
        upload_phase: 'start'
      };
    }
  }]);
  return VideoUploadStartRequestManager;
}(VideoUploadRequestManager);

var VideoUploadTransferRequestManager = function (_VideoUploadRequestMa2) {
  inherits(VideoUploadTransferRequestManager, _VideoUploadRequestMa2);

  function VideoUploadTransferRequestManager() {
    classCallCheck(this, VideoUploadTransferRequestManager);
    return possibleConstructorReturn(this, (VideoUploadTransferRequestManager.__proto__ || Object.getPrototypeOf(VideoUploadTransferRequestManager)).apply(this, arguments));
  }

  createClass(VideoUploadTransferRequestManager, [{
    key: 'sendRequest',


    /**
     * Send transfer request with the given context
     **/
    value: function () {
      var _ref3 = asyncToGenerator(function* (context) {
        // Init a VideoUploadRequest
        var request = new VideoUploadRequest(this._api);
        var start_offset = context.startOffset;
        var end_offset = context.endOffset;
        var filePath = context.filePath;
        var fileSize = fs.statSync(filePath).size;

        // Give a chance to retry every 10M, or at least twice
        var numRetry = Math.max(fileSize / (1024 * 1024 * 10), 2);
        var response = null;
        // While there are still more chunks to send
        var videoFileDescriptor = fs.openSync(filePath, 'r');
        while (start_offset !== end_offset) {
          context.startOffset = start_offset;
          context.endOffset = end_offset;
          var params = {
            upload_phase: 'transfer',
            start_offset: context.startOffset,
            upload_session_id: context.sessionId,
            video_file_chunk: context.videoFileChunk
          };
          request.setParams(params, {
            video_file_chunk: fs.createReadStream(context.filePath, {
              start: context.startOffset,
              end: context.endOffset - 1
            })
          });
          // Send the request
          try {
            response = yield request.send([context.accountId, 'advideos']);
            start_offset = parseInt(response['start_offset']);
            end_offset = parseInt(response['end_offset']);
          } catch (error) {
            if (numRetry > 0) {
              numRetry = Math.max(numRetry - 1, 0);
              continue;
            }
            fs.close(videoFileDescriptor, function (err) {});
            throw error;
          }
        }

        this._startOffset = start_offset;
        this._endOffset = end_offset;
        fs.close(videoFileDescriptor, function (err) {});

        return response;
      });

      function sendRequest(_x3) {
        return _ref3.apply(this, arguments);
      }

      return sendRequest;
    }()
  }]);
  return VideoUploadTransferRequestManager;
}(VideoUploadRequestManager);

var VideoUploadFinishRequestManager = function (_VideoUploadRequestMa3) {
  inherits(VideoUploadFinishRequestManager, _VideoUploadRequestMa3);

  function VideoUploadFinishRequestManager() {
    classCallCheck(this, VideoUploadFinishRequestManager);
    return possibleConstructorReturn(this, (VideoUploadFinishRequestManager.__proto__ || Object.getPrototypeOf(VideoUploadFinishRequestManager)).apply(this, arguments));
  }

  createClass(VideoUploadFinishRequestManager, [{
    key: 'sendRequest',

    /**
     * Send transfer request with the given context
     **/
    value: function () {
      var _ref4 = asyncToGenerator(function* (context) {
        // Init a VideoUploadRequest
        var request = new VideoUploadRequest(this._api);

        // Parse the context
        request.setParams(this.getParamsFromContext(context));

        // Sent the request
        var response = yield request.send([context.accountId, 'advideos']);

        return response;
      });

      function sendRequest(_x4) {
        return _ref4.apply(this, arguments);
      }

      return sendRequest;
    }()
  }, {
    key: 'getParamsFromContext',
    value: function getParamsFromContext(context) {
      return {
        upload_phase: 'finish',
        upload_session_id: context.sessionId,
        title: context.fileName
      };
    }
  }]);
  return VideoUploadFinishRequestManager;
}(VideoUploadRequestManager);

/**
 * Upload request context that contains the param data
 **/


var VideoUploadRequestContext = function () {
  function VideoUploadRequestContext() {
    classCallCheck(this, VideoUploadRequestContext);
  }

  createClass(VideoUploadRequestContext, [{
    key: 'accountId',
    get: function get() {
      return this._accountId;
    },
    set: function set(accountId) {
      this._accountId = accountId;
    }
  }, {
    key: 'fileName',
    get: function get() {
      return this._fileName;
    },
    set: function set(fileName) {
      this._fileName = fileName;
    }
  }, {
    key: 'filePath',
    get: function get() {
      return this._filePath;
    },
    set: function set(filePath) {
      this._filePath = filePath;
    }
  }, {
    key: 'fileSize',
    get: function get() {
      return this._fileSize;
    },
    set: function set(fileSize) {
      this._fileSize = fileSize;
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    },
    set: function set(name) {
      this._name = name;
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this._sessionId;
    },
    set: function set(sessionId) {
      this._sessionId = sessionId;
    }
  }, {
    key: 'startOffset',
    get: function get() {
      return this._startOffset;
    },
    set: function set(startOffset) {
      this._startOffset = startOffset;
    }
  }, {
    key: 'endOffset',
    get: function get() {
      return this._endOffset;
    },
    set: function set(endOffset) {
      this._endOffset = endOffset;
    }
  }, {
    key: 'slideshowSpec',
    get: function get() {
      return this._slideshowSpec;
    },
    set: function set(slideshowSpec) {
      this._slideshowSpec = slideshowSpec;
    }
  }, {
    key: 'videoFileChunk',
    get: function get() {
      return this._videoFileChunk;
    },
    set: function set(videoFileChunk) {
      this._videoFileChunk = videoFileChunk;
    }
  }]);
  return VideoUploadRequestContext;
}();

var VideoUploadRequest = function () {
  function VideoUploadRequest(api) {
    classCallCheck(this, VideoUploadRequest);

    this._params = null;
    this._files = null;
    this._api = api;
  }

  /**
   * Send the current request
   **/


  createClass(VideoUploadRequest, [{
    key: 'send',
    value: function send(path$$1) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4._api.call('POST', path$$1, _this4._params, _this4._files, true, // use multipart/form-data
        FacebookAdsApi.GRAPH_VIDEO // override graph.facebook.com
        ).then(function (response) {
          return resolve(JSON.parse(response));
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'setParams',
    value: function setParams(params) {
      var files = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this._params = params;
      this._files = files;
    }
  }]);
  return VideoUploadRequest;
}();

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

var VideoEncodingStatusChecker = function () {
  function VideoEncodingStatusChecker() {
    classCallCheck(this, VideoEncodingStatusChecker);
  }

  createClass(VideoEncodingStatusChecker, null, [{
    key: 'waitUntilReady',
    value: function () {
      var _ref5 = asyncToGenerator(function* (api, videoId, interval, timeout) {
        var startTime = new Date().getTime();
        var status = null;

        while (true) {
          status = VideoEncodingStatusChecker.getStatus(api, videoId);
          status = status['video_status'];

          if (status !== 'processing') {
            break;
          }

          if (startTime + timeout <= new Date().getTime()) {
            throw Error('Video encoding timeout: ' + timeout);
          }

          yield sleep(interval);
        }

        if (status !== 'ready') {
          status = status == null ? '' : status;
          throw Error('Video encoding status ' + status);
        }
      });

      function waitUntilReady(_x6, _x7, _x8, _x9) {
        return _ref5.apply(this, arguments);
      }

      return waitUntilReady;
    }()
  }, {
    key: 'getStatus',
    value: function getStatus(api, videoId) {
      var result = api.call('GET', [videoId.toString()], { fields: 'status' });
      // $FlowFixMe
      return result['status'];
    }
  }]);
  return VideoEncodingStatusChecker;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */

/**
 * AdVideo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
var AdVideo = function (_AbstractCrudObject) {
  inherits(AdVideo, _AbstractCrudObject);

  function AdVideo() {
    classCallCheck(this, AdVideo);
    return possibleConstructorReturn(this, (AdVideo.__proto__ || Object.getPrototypeOf(AdVideo)).apply(this, arguments));
  }

  createClass(AdVideo, [{
    key: 'create',


    /**
     * Uploads filepath and creates the AdVideo object from it.
     * It requires 'filepath' property to be defined.
     **/
    value: function create(batch, failureHandler, successHandler) {
      var response = null;
      var spec = this.slideshow_spec;
      if (spec) {
        var request = new VideoUploadRequest(this.getApi());

        request.setParams({
          'slideshow_spec[images_urls]': JSON.stringify(spec['images_urls']),
          'slideshow_spec[duration_ms]': spec['duration_ms'],
          'slideshow_spec[transition_ms]': spec['transition_ms']
        });
        response = request.send([this.getParentId(), 'advideos']);
      } else if (this.filepath) {
        var videoUploader = new VideoUploader();

        response = videoUploader.upload(this, true);
      } else {
        throw Error('AdVideo requires a filepath or slideshow_spec to be defined.');
      }

      this.setData(response);

      return response;
    }
  }, {
    key: 'waitUntilEncodingReady',
    value: function waitUntilEncodingReady() {
      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;

      if (!this.id) {
        throw Error('Invalid Video ID');
      }

      VideoEncodingStatusChecker.waitUntilReady(this.getApi(), parseInt(this.id), interval, timeout);
    }

    /**
     *  Returns all the thumbnails associated with the ad video
     */

  }, {
    key: 'getThumbnails',
    value: function getThumbnails(fields, params) {
      return this.getEdge(VideoThumbnail, fields, params, true, 'thumbnails');
    }
  }, {
    key: 'filepath',
    get: function get() {
      return this.filepath;
    }
  }, {
    key: 'slideshow_spec',
    get: function get() {
      return this.slideshow_spec;
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        filepath: 'filepath',
        id: 'id',
        slideshow_spec: 'slideshow_spec'
      });
    }
  }]);
  return AdVideo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Group
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Group = function (_AbstractCrudObject) {
  inherits(Group, _AbstractCrudObject);

  function Group() {
    classCallCheck(this, Group);
    return possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
  }

  createClass(Group, [{
    key: 'deleteAdmins',
    value: function deleteAdmins() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Group.prototype.__proto__ || Object.getPrototypeOf(Group.prototype), 'deleteEdge', this).call(this, '/admins', params);
    }
  }, {
    key: 'createAdmin',
    value: function createAdmin(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/admins', fields, params, Group, pathOverride);
    }
  }, {
    key: 'getAlbums',
    value: function getAlbums(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Album, fields, params, fetchFirstPage, '/albums');
    }
  }, {
    key: 'createAlbum',
    value: function createAlbum(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/albums', fields, params, Album, pathOverride);
    }
  }, {
    key: 'getAttachmentSurfaces',
    value: function getAttachmentSurfaces(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/attachment_surfaces');
    }
  }, {
    key: 'createAttachmentSurface',
    value: function createAttachmentSurface(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/attachment_surfaces', fields, params, null, pathOverride);
    }
  }, {
    key: 'getDocs',
    value: function getDocs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/docs');
    }
  }, {
    key: 'getEvents',
    value: function getEvents(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Event, fields, params, fetchFirstPage, '/events');
    }
  }, {
    key: 'getFeed',
    value: function getFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Post, fields, params, fetchFirstPage, '/feed');
    }
  }, {
    key: 'createFeed',
    value: function createFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/feed', fields, params, Post, pathOverride);
    }
  }, {
    key: 'getFiles',
    value: function getFiles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/files');
    }
  }, {
    key: 'getGroups',
    value: function getGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Group, fields, params, fetchFirstPage, '/groups');
    }
  }, {
    key: 'createGroup',
    value: function createGroup(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/groups', fields, params, Group, pathOverride);
    }
  }, {
    key: 'getLiveVideos',
    value: function getLiveVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(LiveVideo, fields, params, fetchFirstPage, '/live_videos');
    }
  }, {
    key: 'createLiveVideo',
    value: function createLiveVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/live_videos', fields, params, LiveVideo, pathOverride);
    }
  }, {
    key: 'deleteMembers',
    value: function deleteMembers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Group.prototype.__proto__ || Object.getPrototypeOf(Group.prototype), 'deleteEdge', this).call(this, '/members', params);
    }
  }, {
    key: 'createMember',
    value: function createMember(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/members', fields, params, Group, pathOverride);
    }
  }, {
    key: 'getOptedInMembers',
    value: function getOptedInMembers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(User, fields, params, fetchFirstPage, '/opted_in_members');
    }
  }, {
    key: 'createPhoto',
    value: function createPhoto(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/photos', fields, params, Photo, pathOverride);
    }
  }, {
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProfilePictureSource, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'createShiftSetting',
    value: function createShiftSetting(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/shift_settings', fields, params, null, pathOverride);
    }
  }, {
    key: 'getVideos',
    value: function getVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/videos');
    }
  }, {
    key: 'createVideo',
    value: function createVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/videos', fields, params, AdVideo, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Group.prototype.__proto__ || Object.getPrototypeOf(Group.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        archived: 'archived',
        cover: 'cover',
        created_time: 'created_time',
        description: 'description',
        email: 'email',
        icon: 'icon',
        id: 'id',
        install: 'install',
        link: 'link',
        member_count: 'member_count',
        member_request_count: 'member_request_count',
        name: 'name',
        parent: 'parent',
        permissions: 'permissions',
        privacy: 'privacy',
        purpose: 'purpose',
        subdomain: 'subdomain',
        updated_time: 'updated_time',
        venue: 'venue'
      });
    }
  }, {
    key: 'JoinSetting',
    get: function get() {
      return Object.freeze({
        admin_only: 'ADMIN_ONLY',
        anyone: 'ANYONE',
        none: 'NONE'
      });
    }
  }, {
    key: 'PostPermissions',
    get: function get() {
      return Object.freeze({
        value_0: '0',
        value_1: '1',
        value_2: '2'
      });
    }
  }, {
    key: 'Purpose',
    get: function get() {
      return Object.freeze({
        casual: 'CASUAL',
        coworkers: 'COWORKERS',
        custom: 'CUSTOM',
        for_sale: 'FOR_SALE',
        for_work: 'FOR_WORK',
        game: 'GAME',
        health_support: 'HEALTH_SUPPORT',
        jobs: 'JOBS',
        learning: 'LEARNING',
        none: 'NONE',
        parenting: 'PARENTING',
        streamer: 'STREAMER',
        work_announcement: 'WORK_ANNOUNCEMENT',
        work_demo_group: 'WORK_DEMO_GROUP',
        work_discussion: 'WORK_DISCUSSION',
        work_ephemeral: 'WORK_EPHEMERAL',
        work_feedback: 'WORK_FEEDBACK',
        work_for_sale: 'WORK_FOR_SALE',
        work_garden: 'WORK_GARDEN',
        work_integrity: 'WORK_INTEGRITY',
        work_learning: 'WORK_LEARNING',
        work_mentorship: 'WORK_MENTORSHIP',
        work_multi_company: 'WORK_MULTI_COMPANY',
        work_recruiting: 'WORK_RECRUITING',
        work_social: 'WORK_SOCIAL',
        work_stages: 'WORK_STAGES',
        work_team: 'WORK_TEAM',
        work_teamwork: 'WORK_TEAMWORK'
      });
    }
  }, {
    key: 'GroupType',
    get: function get() {
      return Object.freeze({
        casual: 'CASUAL',
        coworkers: 'COWORKERS',
        custom: 'CUSTOM',
        for_sale: 'FOR_SALE',
        for_work: 'FOR_WORK',
        game: 'GAME',
        health_support: 'HEALTH_SUPPORT',
        jobs: 'JOBS',
        learning: 'LEARNING',
        none: 'NONE',
        parenting: 'PARENTING',
        streamer: 'STREAMER',
        work_announcement: 'WORK_ANNOUNCEMENT',
        work_demo_group: 'WORK_DEMO_GROUP',
        work_discussion: 'WORK_DISCUSSION',
        work_ephemeral: 'WORK_EPHEMERAL',
        work_feedback: 'WORK_FEEDBACK',
        work_for_sale: 'WORK_FOR_SALE',
        work_garden: 'WORK_GARDEN',
        work_integrity: 'WORK_INTEGRITY',
        work_learning: 'WORK_LEARNING',
        work_mentorship: 'WORK_MENTORSHIP',
        work_multi_company: 'WORK_MULTI_COMPANY',
        work_recruiting: 'WORK_RECRUITING',
        work_social: 'WORK_SOCIAL',
        work_stages: 'WORK_STAGES',
        work_team: 'WORK_TEAM',
        work_teamwork: 'WORK_TEAMWORK'
      });
    }
  }]);
  return Group;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserIDForApp
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserIDForApp = function (_AbstractCrudObject) {
  inherits(UserIDForApp, _AbstractCrudObject);

  function UserIDForApp() {
    classCallCheck(this, UserIDForApp);
    return possibleConstructorReturn(this, (UserIDForApp.__proto__ || Object.getPrototypeOf(UserIDForApp)).apply(this, arguments));
  }

  createClass(UserIDForApp, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app: 'app',
        id: 'id'
      });
    }
  }]);
  return UserIDForApp;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserIDForPage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserIDForPage = function (_AbstractCrudObject) {
  inherits(UserIDForPage, _AbstractCrudObject);

  function UserIDForPage() {
    classCallCheck(this, UserIDForPage);
    return possibleConstructorReturn(this, (UserIDForPage.__proto__ || Object.getPrototypeOf(UserIDForPage)).apply(this, arguments));
  }

  createClass(UserIDForPage, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        page: 'page'
      });
    }
  }]);
  return UserIDForPage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PaymentEnginePayment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PaymentEnginePayment = function (_AbstractCrudObject) {
  inherits(PaymentEnginePayment, _AbstractCrudObject);

  function PaymentEnginePayment() {
    classCallCheck(this, PaymentEnginePayment);
    return possibleConstructorReturn(this, (PaymentEnginePayment.__proto__ || Object.getPrototypeOf(PaymentEnginePayment)).apply(this, arguments));
  }

  createClass(PaymentEnginePayment, [{
    key: 'createDispute',
    value: function createDispute(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/dispute', fields, params, PaymentEnginePayment, pathOverride);
    }
  }, {
    key: 'createRefund',
    value: function createRefund(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/refunds', fields, params, PaymentEnginePayment, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actions: 'actions',
        application: 'application',
        country: 'country',
        created_time: 'created_time',
        disputes: 'disputes',
        fraud_status: 'fraud_status',
        fulfillment_status: 'fulfillment_status',
        id: 'id',
        is_from_ad: 'is_from_ad',
        is_from_page_post: 'is_from_page_post',
        items: 'items',
        payout_foreign_exchange_rate: 'payout_foreign_exchange_rate',
        phone_support_eligible: 'phone_support_eligible',
        platform: 'platform',
        refundable_amount: 'refundable_amount',
        request_id: 'request_id',
        tax: 'tax',
        tax_country: 'tax_country',
        test: 'test',
        user: 'user'
      });
    }
  }, {
    key: 'Reason',
    get: function get() {
      return Object.freeze({
        banned_user: 'BANNED_USER',
        denied_refund: 'DENIED_REFUND',
        granted_replacement_item: 'GRANTED_REPLACEMENT_ITEM'
      });
    }
  }]);
  return PaymentEnginePayment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Permission
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Permission = function (_AbstractCrudObject) {
  inherits(Permission, _AbstractCrudObject);

  function Permission() {
    classCallCheck(this, Permission);
    return possibleConstructorReturn(this, (Permission.__proto__ || Object.getPrototypeOf(Permission)).apply(this, arguments));
  }

  createClass(Permission, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        permission: 'permission',
        status: 'status'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        declined: 'declined',
        expired: 'expired',
        granted: 'granted'
      });
    }
  }]);
  return Permission;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * User
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var User = function (_AbstractCrudObject) {
  inherits(User, _AbstractCrudObject);

  function User() {
    classCallCheck(this, User);
    return possibleConstructorReturn(this, (User.__proto__ || Object.getPrototypeOf(User)).apply(this, arguments));
  }

  createClass(User, [{
    key: 'deleteAccessTokens',
    value: function deleteAccessTokens() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), 'deleteEdge', this).call(this, '/access_tokens', params);
    }
  }, {
    key: 'createAccessToken',
    value: function createAccessToken(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/access_tokens', fields, params, User, pathOverride);
    }
  }, {
    key: 'getAccounts',
    value: function getAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/accounts');
    }
  }, {
    key: 'createAccount',
    value: function createAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/accounts', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getAdStudies',
    value: function getAdStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudy, fields, params, fetchFirstPage, '/ad_studies');
    }
  }, {
    key: 'createAdStudy',
    value: function createAdStudy(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/ad_studies', fields, params, AdStudy, pathOverride);
    }
  }, {
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/adaccounts');
    }
  }, {
    key: 'getAlbums',
    value: function getAlbums(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Album, fields, params, fetchFirstPage, '/albums');
    }
  }, {
    key: 'createApplication',
    value: function createApplication(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/applications', fields, params, User, pathOverride);
    }
  }, {
    key: 'getAppRequestFormerRecipients',
    value: function getAppRequestFormerRecipients(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AppRequestFormerRecipient, fields, params, fetchFirstPage, '/apprequestformerrecipients');
    }
  }, {
    key: 'getAppRequests',
    value: function getAppRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AppRequest, fields, params, fetchFirstPage, '/apprequests');
    }
  }, {
    key: 'getAssignedAdAccounts',
    value: function getAssignedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/assigned_ad_accounts');
    }
  }, {
    key: 'getAssignedBusinessAssetGroups',
    value: function getAssignedBusinessAssetGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAssetGroup, fields, params, fetchFirstPage, '/assigned_business_asset_groups');
    }
  }, {
    key: 'getAssignedPages',
    value: function getAssignedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/assigned_pages');
    }
  }, {
    key: 'getAssignedProductCatalogs',
    value: function getAssignedProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/assigned_product_catalogs');
    }
  }, {
    key: 'getAvatars',
    value: function getAvatars(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/avatars');
    }
  }, {
    key: 'getBusinessUsers',
    value: function getBusinessUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessUser, fields, params, fetchFirstPage, '/business_users');
    }
  }, {
    key: 'deleteBusinesses',
    value: function deleteBusinesses() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), 'deleteEdge', this).call(this, '/businesses', params);
    }
  }, {
    key: 'getBusinesses',
    value: function getBusinesses(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/businesses');
    }
  }, {
    key: 'createBusiness',
    value: function createBusiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/businesses', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getConversations',
    value: function getConversations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UnifiedThread, fields, params, fetchFirstPage, '/conversations');
    }
  }, {
    key: 'getCustomLabels',
    value: function getCustomLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PageUserMessageThreadLabel, fields, params, fetchFirstPage, '/custom_labels');
    }
  }, {
    key: 'getEvents',
    value: function getEvents(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Event, fields, params, fetchFirstPage, '/events');
    }
  }, {
    key: 'getFeed',
    value: function getFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Post, fields, params, fetchFirstPage, '/feed');
    }
  }, {
    key: 'createFeed',
    value: function createFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/feed', fields, params, Post, pathOverride);
    }
  }, {
    key: 'getFriends',
    value: function getFriends(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(User, fields, params, fetchFirstPage, '/friends');
    }
  }, {
    key: 'getFundraisers',
    value: function getFundraisers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(FundraiserPersonToCharity, fields, params, fetchFirstPage, '/fundraisers');
    }
  }, {
    key: 'createFundraiser',
    value: function createFundraiser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/fundraisers', fields, params, FundraiserPersonToCharity, pathOverride);
    }
  }, {
    key: 'createGameItem',
    value: function createGameItem(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/game_items', fields, params, GameItem, pathOverride);
    }
  }, {
    key: 'createGameTime',
    value: function createGameTime(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/game_times', fields, params, null, pathOverride);
    }
  }, {
    key: 'getGroups',
    value: function getGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Group, fields, params, fetchFirstPage, '/groups');
    }
  }, {
    key: 'getIdsForApps',
    value: function getIdsForApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UserIDForApp, fields, params, fetchFirstPage, '/ids_for_apps');
    }
  }, {
    key: 'getIdsForBusiness',
    value: function getIdsForBusiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UserIDForApp, fields, params, fetchFirstPage, '/ids_for_business');
    }
  }, {
    key: 'getIdsForPages',
    value: function getIdsForPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UserIDForPage, fields, params, fetchFirstPage, '/ids_for_pages');
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'getLiveVideos',
    value: function getLiveVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(LiveVideo, fields, params, fetchFirstPage, '/live_videos');
    }
  }, {
    key: 'createLiveVideo',
    value: function createLiveVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/live_videos', fields, params, LiveVideo, pathOverride);
    }
  }, {
    key: 'createMessengerDesktopPerformanceTrace',
    value: function createMessengerDesktopPerformanceTrace(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/messenger_desktop_performance_traces', fields, params, User, pathOverride);
    }
  }, {
    key: 'getMusic',
    value: function getMusic(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/music');
    }
  }, {
    key: 'createNotification',
    value: function createNotification(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/notifications', fields, params, User, pathOverride);
    }
  }, {
    key: 'getPaymentTransactions',
    value: function getPaymentTransactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PaymentEnginePayment, fields, params, fetchFirstPage, '/payment_transactions');
    }
  }, {
    key: 'deletePermissions',
    value: function deletePermissions() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), 'deleteEdge', this).call(this, '/permissions', params);
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Permission, fields, params, fetchFirstPage, '/permissions');
    }
  }, {
    key: 'getPersonalAdAccounts',
    value: function getPersonalAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/personal_ad_accounts');
    }
  }, {
    key: 'getPhotos',
    value: function getPhotos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Photo, fields, params, fetchFirstPage, '/photos');
    }
  }, {
    key: 'createPhoto',
    value: function createPhoto(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/photos', fields, params, Photo, pathOverride);
    }
  }, {
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProfilePictureSource, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'getPosts',
    value: function getPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Post, fields, params, fetchFirstPage, '/posts');
    }
  }, {
    key: 'getRichMediaDocuments',
    value: function getRichMediaDocuments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Canvas, fields, params, fetchFirstPage, '/rich_media_documents');
    }
  }, {
    key: 'createStagingResource',
    value: function createStagingResource(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/staging_resources', fields, params, User, pathOverride);
    }
  }, {
    key: 'getVideos',
    value: function getVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/videos');
    }
  }, {
    key: 'createVideo',
    value: function createVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/videos', fields, params, AdVideo, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(User.prototype.__proto__ || Object.getPrototypeOf(User.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        about: 'about',
        age_range: 'age_range',
        birthday: 'birthday',
        cover: 'cover',
        currency: 'currency',
        education: 'education',
        email: 'email',
        favorite_athletes: 'favorite_athletes',
        favorite_teams: 'favorite_teams',
        first_name: 'first_name',
        gender: 'gender',
        hometown: 'hometown',
        id: 'id',
        id_for_avatars: 'id_for_avatars',
        inspirational_people: 'inspirational_people',
        install_type: 'install_type',
        installed: 'installed',
        is_guest_user: 'is_guest_user',
        languages: 'languages',
        last_name: 'last_name',
        link: 'link',
        local_news_megaphone_dismiss_status: 'local_news_megaphone_dismiss_status',
        local_news_subscription_status: 'local_news_subscription_status',
        locale: 'locale',
        location: 'location',
        meeting_for: 'meeting_for',
        middle_name: 'middle_name',
        name: 'name',
        name_format: 'name_format',
        payment_pricepoints: 'payment_pricepoints',
        political: 'political',
        profile_pic: 'profile_pic',
        quotes: 'quotes',
        relationship_status: 'relationship_status',
        shared_login_upgrade_required_by: 'shared_login_upgrade_required_by',
        short_name: 'short_name',
        significant_other: 'significant_other',
        sports: 'sports',
        supports_donate_button_in_live_video: 'supports_donate_button_in_live_video',
        third_party_id: 'third_party_id',
        timezone: 'timezone',
        token_for_business: 'token_for_business',
        updated_time: 'updated_time',
        verified: 'verified',
        video_upload_limits: 'video_upload_limits',
        website: 'website'
      });
    }
  }, {
    key: 'LocalNewsMegaphoneDismissStatus',
    get: function get() {
      return Object.freeze({
        no: 'NO',
        yes: 'YES'
      });
    }
  }, {
    key: 'LocalNewsSubscriptionStatus',
    get: function get() {
      return Object.freeze({
        status_off: 'STATUS_OFF',
        status_on: 'STATUS_ON'
      });
    }
  }, {
    key: 'Filtering',
    get: function get() {
      return Object.freeze({
        ema: 'ema',
        groups: 'groups',
        groups_social: 'groups_social'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        content_update: 'content_update',
        generic: 'generic'
      });
    }
  }]);
  return User;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LiveVideoError
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LiveVideoError = function (_AbstractCrudObject) {
  inherits(LiveVideoError, _AbstractCrudObject);

  function LiveVideoError() {
    classCallCheck(this, LiveVideoError);
    return possibleConstructorReturn(this, (LiveVideoError.__proto__ || Object.getPrototypeOf(LiveVideoError)).apply(this, arguments));
  }

  createClass(LiveVideoError, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_time: 'creation_time',
        error_code: 'error_code',
        error_message: 'error_message',
        error_type: 'error_type',
        id: 'id'
      });
    }
  }]);
  return LiveVideoError;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LiveVideoInputStream
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LiveVideoInputStream = function (_AbstractCrudObject) {
  inherits(LiveVideoInputStream, _AbstractCrudObject);

  function LiveVideoInputStream() {
    classCallCheck(this, LiveVideoInputStream);
    return possibleConstructorReturn(this, (LiveVideoInputStream.__proto__ || Object.getPrototypeOf(LiveVideoInputStream)).apply(this, arguments));
  }

  createClass(LiveVideoInputStream, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        dash_ingest_url: 'dash_ingest_url',
        dash_preview_url: 'dash_preview_url',
        id: 'id',
        is_master: 'is_master',
        secure_stream_url: 'secure_stream_url',
        stream_health: 'stream_health',
        stream_id: 'stream_id',
        stream_url: 'stream_url'
      });
    }
  }]);
  return LiveVideoInputStream;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoPoll
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoPoll = function (_AbstractCrudObject) {
  inherits(VideoPoll, _AbstractCrudObject);

  function VideoPoll() {
    classCallCheck(this, VideoPoll);
    return possibleConstructorReturn(this, (VideoPoll.__proto__ || Object.getPrototypeOf(VideoPoll)).apply(this, arguments));
  }

  createClass(VideoPoll, [{
    key: 'getPollOptions',
    value: function getPollOptions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/poll_options');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(VideoPoll.prototype.__proto__ || Object.getPrototypeOf(VideoPoll.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        close_after_voting: 'close_after_voting',
        default_open: 'default_open',
        id: 'id',
        question: 'question',
        show_gradient: 'show_gradient',
        show_results: 'show_results',
        status: 'status'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        closed: 'closed',
        results_open: 'results_open',
        voting_open: 'voting_open'
      });
    }
  }, {
    key: 'Action',
    get: function get() {
      return Object.freeze({
        attach_to_video: 'ATTACH_TO_VIDEO',
        close: 'CLOSE',
        delete_poll: 'DELETE_POLL',
        show_results: 'SHOW_RESULTS',
        show_voting: 'SHOW_VOTING'
      });
    }
  }]);
  return VideoPoll;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LiveVideo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LiveVideo = function (_AbstractCrudObject) {
  inherits(LiveVideo, _AbstractCrudObject);

  function LiveVideo() {
    classCallCheck(this, LiveVideo);
    return possibleConstructorReturn(this, (LiveVideo.__proto__ || Object.getPrototypeOf(LiveVideo)).apply(this, arguments));
  }

  createClass(LiveVideo, [{
    key: 'getBlockedUsers',
    value: function getBlockedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(User, fields, params, fetchFirstPage, '/blocked_users');
    }
  }, {
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Comment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'getCrosspostSharedPages',
    value: function getCrosspostSharedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/crosspost_shared_pages');
    }
  }, {
    key: 'getCrosspostedBroadcasts',
    value: function getCrosspostedBroadcasts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(LiveVideo, fields, params, fetchFirstPage, '/crossposted_broadcasts');
    }
  }, {
    key: 'getErrors',
    value: function getErrors(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(LiveVideoError, fields, params, fetchFirstPage, '/errors');
    }
  }, {
    key: 'createInputStream',
    value: function createInputStream(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/input_streams', fields, params, LiveVideoInputStream, pathOverride);
    }
  }, {
    key: 'getPolls',
    value: function getPolls(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(VideoPoll, fields, params, fetchFirstPage, '/polls');
    }
  }, {
    key: 'createPoll',
    value: function createPoll(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/polls', fields, params, VideoPoll, pathOverride);
    }
  }, {
    key: 'getReactions',
    value: function getReactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/reactions');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(LiveVideo.prototype.__proto__ || Object.getPrototypeOf(LiveVideo.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(LiveVideo.prototype.__proto__ || Object.getPrototypeOf(LiveVideo.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_break_config: 'ad_break_config',
        ad_break_failure_reason: 'ad_break_failure_reason',
        broadcast_start_time: 'broadcast_start_time',
        copyright: 'copyright',
        creation_time: 'creation_time',
        dash_ingest_url: 'dash_ingest_url',
        dash_preview_url: 'dash_preview_url',
        description: 'description',
        embed_html: 'embed_html',
        from: 'from',
        id: 'id',
        ingest_streams: 'ingest_streams',
        is_manual_mode: 'is_manual_mode',
        is_reference_only: 'is_reference_only',
        live_views: 'live_views',
        overlay_url: 'overlay_url',
        permalink_url: 'permalink_url',
        planned_start_time: 'planned_start_time',
        recommended_encoder_settings: 'recommended_encoder_settings',
        seconds_left: 'seconds_left',
        secure_stream_url: 'secure_stream_url',
        status: 'status',
        stream_url: 'stream_url',
        targeting: 'targeting',
        title: 'title',
        total_views: 'total_views',
        video: 'video'
      });
    }
  }, {
    key: 'Projection',
    get: function get() {
      return Object.freeze({
        cubemap: 'CUBEMAP',
        equirectangular: 'EQUIRECTANGULAR',
        half_equirectangular: 'HALF_EQUIRECTANGULAR'
      });
    }
  }, {
    key: 'SpatialAudioFormat',
    get: function get() {
      return Object.freeze({
        ambix_4: 'ambiX_4'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        live_now: 'LIVE_NOW',
        scheduled_canceled: 'SCHEDULED_CANCELED',
        scheduled_live: 'SCHEDULED_LIVE',
        scheduled_unpublished: 'SCHEDULED_UNPUBLISHED',
        unpublished: 'UNPUBLISHED'
      });
    }
  }, {
    key: 'StereoscopicMode',
    get: function get() {
      return Object.freeze({
        left_right: 'LEFT_RIGHT',
        mono: 'MONO',
        top_bottom: 'TOP_BOTTOM'
      });
    }
  }, {
    key: 'StreamType',
    get: function get() {
      return Object.freeze({
        ambient: 'AMBIENT',
        regular: 'REGULAR'
      });
    }
  }, {
    key: 'BroadcastStatus',
    get: function get() {
      return Object.freeze({
        live: 'LIVE',
        live_stopped: 'LIVE_STOPPED',
        processing: 'PROCESSING',
        scheduled_canceled: 'SCHEDULED_CANCELED',
        scheduled_expired: 'SCHEDULED_EXPIRED',
        scheduled_live: 'SCHEDULED_LIVE',
        scheduled_unpublished: 'SCHEDULED_UNPUBLISHED',
        unpublished: 'UNPUBLISHED',
        vod: 'VOD'
      });
    }
  }, {
    key: 'Source',
    get: function get() {
      return Object.freeze({
        owner: 'owner',
        target: 'target'
      });
    }
  }, {
    key: 'LiveCommentModerationSetting',
    get: function get() {
      return Object.freeze({
        default: 'DEFAULT',
        discussion: 'DISCUSSION',
        followed: 'FOLLOWED',
        follower: 'FOLLOWER',
        no_hyperlink: 'NO_HYPERLINK',
        protected_mode: 'PROTECTED_MODE',
        restricted: 'RESTRICTED',
        slow: 'SLOW',
        supporter: 'SUPPORTER',
        tagged: 'TAGGED'
      });
    }
  }, {
    key: 'PersistentStreamKeyStatus',
    get: function get() {
      return Object.freeze({
        disable: 'DISABLE',
        enable: 'ENABLE',
        regenerate: 'REGENERATE'
      });
    }
  }]);
  return LiveVideo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Event
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Event = function (_AbstractCrudObject) {
  inherits(Event, _AbstractCrudObject);

  function Event() {
    classCallCheck(this, Event);
    return possibleConstructorReturn(this, (Event.__proto__ || Object.getPrototypeOf(Event)).apply(this, arguments));
  }

  createClass(Event, [{
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'getFeed',
    value: function getFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/feed');
    }
  }, {
    key: 'getLiveVideos',
    value: function getLiveVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/live_videos');
    }
  }, {
    key: 'createLiveVideo',
    value: function createLiveVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/live_videos', fields, params, LiveVideo, pathOverride);
    }
  }, {
    key: 'getPhotos',
    value: function getPhotos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/photos');
    }
  }, {
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'getPosts',
    value: function getPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/posts');
    }
  }, {
    key: 'getRoles',
    value: function getRoles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/roles');
    }
  }, {
    key: 'getTicketTiers',
    value: function getTicketTiers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ticket_tiers');
    }
  }, {
    key: 'getVideos',
    value: function getVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/videos');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        attending_count: 'attending_count',
        can_guests_invite: 'can_guests_invite',
        category: 'category',
        cover: 'cover',
        created_time: 'created_time',
        declined_count: 'declined_count',
        description: 'description',
        discount_code_enabled: 'discount_code_enabled',
        end_time: 'end_time',
        event_times: 'event_times',
        guest_list_enabled: 'guest_list_enabled',
        id: 'id',
        interested_count: 'interested_count',
        is_canceled: 'is_canceled',
        is_draft: 'is_draft',
        is_online: 'is_online',
        is_page_owned: 'is_page_owned',
        maybe_count: 'maybe_count',
        name: 'name',
        noreply_count: 'noreply_count',
        online_event_format: 'online_event_format',
        online_event_third_party_url: 'online_event_third_party_url',
        owner: 'owner',
        parent_group: 'parent_group',
        place: 'place',
        registration_setting: 'registration_setting',
        scheduled_publish_time: 'scheduled_publish_time',
        start_time: 'start_time',
        ticket_setting: 'ticket_setting',
        ticket_uri: 'ticket_uri',
        ticket_uri_start_sales_time: 'ticket_uri_start_sales_time',
        ticketing_privacy_uri: 'ticketing_privacy_uri',
        ticketing_terms_uri: 'ticketing_terms_uri',
        timezone: 'timezone',
        type: 'type',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'Category',
    get: function get() {
      return Object.freeze({
        classic_literature: 'CLASSIC_LITERATURE',
        comedy: 'COMEDY',
        crafts: 'CRAFTS',
        dance: 'DANCE',
        drinks: 'DRINKS',
        fitness_and_workouts: 'FITNESS_AND_WORKOUTS',
        foods: 'FOODS',
        games: 'GAMES',
        gardening: 'GARDENING',
        healthy_living_and_self_care: 'HEALTHY_LIVING_AND_SELF_CARE',
        health_and_medical: 'HEALTH_AND_MEDICAL',
        home_and_garden: 'HOME_AND_GARDEN',
        music_and_audio: 'MUSIC_AND_AUDIO',
        parties: 'PARTIES',
        professional_networking: 'PROFESSIONAL_NETWORKING',
        religions: 'RELIGIONS',
        shopping_event: 'SHOPPING_EVENT',
        social_issues: 'SOCIAL_ISSUES',
        sports: 'SPORTS',
        theater: 'THEATER',
        tv_and_movies: 'TV_AND_MOVIES',
        visual_arts: 'VISUAL_ARTS'
      });
    }
  }, {
    key: 'OnlineEventFormat',
    get: function get() {
      return Object.freeze({
        fb_live: 'fb_live',
        messenger_room: 'messenger_room',
        none: 'none',
        other: 'other',
        third_party: 'third_party'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        community: 'community',
        friends: 'friends',
        group: 'group',
        private: 'private',
        public: 'public',
        work_company: 'work_company'
      });
    }
  }, {
    key: 'EventStateFilter',
    get: function get() {
      return Object.freeze({
        canceled: 'canceled',
        draft: 'draft',
        published: 'published',
        scheduled_draft_for_publication: 'scheduled_draft_for_publication'
      });
    }
  }, {
    key: 'TimeFilter',
    get: function get() {
      return Object.freeze({
        past: 'past',
        upcoming: 'upcoming'
      });
    }
  }]);
  return Event;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ImageCopyright
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ImageCopyright = function (_AbstractCrudObject) {
  inherits(ImageCopyright, _AbstractCrudObject);

  function ImageCopyright() {
    classCallCheck(this, ImageCopyright);
    return possibleConstructorReturn(this, (ImageCopyright.__proto__ || Object.getPrototypeOf(ImageCopyright)).apply(this, arguments));
  }

  createClass(ImageCopyright, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ImageCopyright.prototype.__proto__ || Object.getPrototypeOf(ImageCopyright.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        artist: 'artist',
        copyright_monitoring_status: 'copyright_monitoring_status',
        creation_time: 'creation_time',
        creator: 'creator',
        custom_id: 'custom_id',
        description: 'description',
        filename: 'filename',
        id: 'id',
        image: 'image',
        matches_count: 'matches_count',
        original_content_creation_date: 'original_content_creation_date',
        ownership_countries: 'ownership_countries',
        tags: 'tags',
        title: 'title',
        update_time: 'update_time'
      });
    }
  }, {
    key: 'GeoOwnership',
    get: function get() {
      return Object.freeze({
        ad: 'AD',
        ae: 'AE',
        af: 'AF',
        ag: 'AG',
        ai: 'AI',
        al: 'AL',
        am: 'AM',
        an: 'AN',
        ao: 'AO',
        aq: 'AQ',
        ar: 'AR',
        as: 'AS',
        at: 'AT',
        au: 'AU',
        aw: 'AW',
        ax: 'AX',
        az: 'AZ',
        ba: 'BA',
        bb: 'BB',
        bd: 'BD',
        be: 'BE',
        bf: 'BF',
        bg: 'BG',
        bh: 'BH',
        bi: 'BI',
        bj: 'BJ',
        bl: 'BL',
        bm: 'BM',
        bn: 'BN',
        bo: 'BO',
        bq: 'BQ',
        br: 'BR',
        bs: 'BS',
        bt: 'BT',
        bv: 'BV',
        bw: 'BW',
        by: 'BY',
        bz: 'BZ',
        ca: 'CA',
        cc: 'CC',
        cd: 'CD',
        cf: 'CF',
        cg: 'CG',
        ch: 'CH',
        ci: 'CI',
        ck: 'CK',
        cl: 'CL',
        cm: 'CM',
        cn: 'CN',
        co: 'CO',
        cr: 'CR',
        cu: 'CU',
        cv: 'CV',
        cw: 'CW',
        cx: 'CX',
        cy: 'CY',
        cz: 'CZ',
        de: 'DE',
        dj: 'DJ',
        dk: 'DK',
        dm: 'DM',
        do: 'DO',
        dz: 'DZ',
        ec: 'EC',
        ee: 'EE',
        eg: 'EG',
        eh: 'EH',
        er: 'ER',
        es: 'ES',
        et: 'ET',
        fi: 'FI',
        fj: 'FJ',
        fk: 'FK',
        fm: 'FM',
        fo: 'FO',
        fr: 'FR',
        ga: 'GA',
        gb: 'GB',
        gd: 'GD',
        ge: 'GE',
        gf: 'GF',
        gg: 'GG',
        gh: 'GH',
        gi: 'GI',
        gl: 'GL',
        gm: 'GM',
        gn: 'GN',
        gp: 'GP',
        gq: 'GQ',
        gr: 'GR',
        gs: 'GS',
        gt: 'GT',
        gu: 'GU',
        gw: 'GW',
        gy: 'GY',
        hk: 'HK',
        hm: 'HM',
        hn: 'HN',
        hr: 'HR',
        ht: 'HT',
        hu: 'HU',
        id: 'ID',
        ie: 'IE',
        il: 'IL',
        im: 'IM',
        in: 'IN',
        io: 'IO',
        iq: 'IQ',
        ir: 'IR',
        is: 'IS',
        it: 'IT',
        je: 'JE',
        jm: 'JM',
        jo: 'JO',
        jp: 'JP',
        ke: 'KE',
        kg: 'KG',
        kh: 'KH',
        ki: 'KI',
        km: 'KM',
        kn: 'KN',
        kp: 'KP',
        kr: 'KR',
        kw: 'KW',
        ky: 'KY',
        kz: 'KZ',
        la: 'LA',
        lb: 'LB',
        lc: 'LC',
        li: 'LI',
        lk: 'LK',
        lr: 'LR',
        ls: 'LS',
        lt: 'LT',
        lu: 'LU',
        lv: 'LV',
        ly: 'LY',
        ma: 'MA',
        mc: 'MC',
        md: 'MD',
        me: 'ME',
        mf: 'MF',
        mg: 'MG',
        mh: 'MH',
        mk: 'MK',
        ml: 'ML',
        mm: 'MM',
        mn: 'MN',
        mo: 'MO',
        mp: 'MP',
        mq: 'MQ',
        mr: 'MR',
        ms: 'MS',
        mt: 'MT',
        mu: 'MU',
        mv: 'MV',
        mw: 'MW',
        mx: 'MX',
        my: 'MY',
        mz: 'MZ',
        na: 'NA',
        nc: 'NC',
        ne: 'NE',
        nf: 'NF',
        ng: 'NG',
        ni: 'NI',
        nl: 'NL',
        no: 'NO',
        np: 'NP',
        nr: 'NR',
        nu: 'NU',
        nz: 'NZ',
        om: 'OM',
        pa: 'PA',
        pe: 'PE',
        pf: 'PF',
        pg: 'PG',
        ph: 'PH',
        pk: 'PK',
        pl: 'PL',
        pm: 'PM',
        pn: 'PN',
        pr: 'PR',
        ps: 'PS',
        pt: 'PT',
        pw: 'PW',
        py: 'PY',
        qa: 'QA',
        re: 'RE',
        ro: 'RO',
        rs: 'RS',
        ru: 'RU',
        rw: 'RW',
        sa: 'SA',
        sb: 'SB',
        sc: 'SC',
        sd: 'SD',
        se: 'SE',
        sg: 'SG',
        sh: 'SH',
        si: 'SI',
        sj: 'SJ',
        sk: 'SK',
        sl: 'SL',
        sm: 'SM',
        sn: 'SN',
        so: 'SO',
        sr: 'SR',
        ss: 'SS',
        st: 'ST',
        sv: 'SV',
        sx: 'SX',
        sy: 'SY',
        sz: 'SZ',
        tc: 'TC',
        td: 'TD',
        tf: 'TF',
        tg: 'TG',
        th: 'TH',
        tj: 'TJ',
        tk: 'TK',
        tl: 'TL',
        tm: 'TM',
        tn: 'TN',
        to: 'TO',
        tp: 'TP',
        tr: 'TR',
        tt: 'TT',
        tv: 'TV',
        tw: 'TW',
        tz: 'TZ',
        ua: 'UA',
        ug: 'UG',
        um: 'UM',
        us: 'US',
        uy: 'UY',
        uz: 'UZ',
        va: 'VA',
        vc: 'VC',
        ve: 'VE',
        vg: 'VG',
        vi: 'VI',
        vn: 'VN',
        vu: 'VU',
        wf: 'WF',
        ws: 'WS',
        xk: 'XK',
        ye: 'YE',
        yt: 'YT',
        za: 'ZA',
        zm: 'ZM',
        zw: 'ZW'
      });
    }
  }]);
  return ImageCopyright;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InstantArticleInsightsQueryResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InstantArticleInsightsQueryResult = function (_AbstractCrudObject) {
  inherits(InstantArticleInsightsQueryResult, _AbstractCrudObject);

  function InstantArticleInsightsQueryResult() {
    classCallCheck(this, InstantArticleInsightsQueryResult);
    return possibleConstructorReturn(this, (InstantArticleInsightsQueryResult.__proto__ || Object.getPrototypeOf(InstantArticleInsightsQueryResult)).apply(this, arguments));
  }

  createClass(InstantArticleInsightsQueryResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        breakdowns: 'breakdowns',
        name: 'name',
        time: 'time',
        value: 'value'
      });
    }
  }, {
    key: 'Breakdown',
    get: function get() {
      return Object.freeze({
        age: 'age',
        country: 'country',
        gender: 'gender',
        gender_and_age: 'gender_and_age',
        is_organic: 'is_organic',
        is_shared_by_ia_owner: 'is_shared_by_ia_owner',
        no_breakdown: 'no_breakdown',
        platform: 'platform',
        region: 'region'
      });
    }
  }, {
    key: 'Period',
    get: function get() {
      return Object.freeze({
        day: 'day',
        days_28: 'days_28',
        lifetime: 'lifetime',
        month: 'month',
        total_over_range: 'total_over_range',
        week: 'week'
      });
    }
  }]);
  return InstantArticleInsightsQueryResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InstantArticle
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InstantArticle = function (_AbstractCrudObject) {
  inherits(InstantArticle, _AbstractCrudObject);

  function InstantArticle() {
    classCallCheck(this, InstantArticle);
    return possibleConstructorReturn(this, (InstantArticle.__proto__ || Object.getPrototypeOf(InstantArticle)).apply(this, arguments));
  }

  createClass(InstantArticle, [{
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstantArticleInsightsQueryResult, fields, params, fetchFirstPage, '/insights');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(InstantArticle.prototype.__proto__ || Object.getPrototypeOf(InstantArticle.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        canonical_url: 'canonical_url',
        development_mode: 'development_mode',
        html_source: 'html_source',
        id: 'id',
        most_recent_import_status: 'most_recent_import_status',
        photos: 'photos',
        publish_status: 'publish_status',
        published: 'published',
        videos: 'videos'
      });
    }
  }]);
  return InstantArticle;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InstantArticlesStats
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InstantArticlesStats = function (_AbstractCrudObject) {
  inherits(InstantArticlesStats, _AbstractCrudObject);

  function InstantArticlesStats() {
    classCallCheck(this, InstantArticlesStats);
    return possibleConstructorReturn(this, (InstantArticlesStats.__proto__ || Object.getPrototypeOf(InstantArticlesStats)).apply(this, arguments));
  }

  createClass(InstantArticlesStats, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        error: 'error',
        metadata: 'metadata',
        metric: 'metric',
        totals: 'totals',
        x_axis_breakdown: 'x_axis_breakdown'
      });
    }
  }]);
  return InstantArticlesStats;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadgenForm
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadgenForm = function (_AbstractCrudObject) {
  inherits(LeadgenForm, _AbstractCrudObject);

  function LeadgenForm() {
    classCallCheck(this, LeadgenForm);
    return possibleConstructorReturn(this, (LeadgenForm.__proto__ || Object.getPrototypeOf(LeadgenForm)).apply(this, arguments));
  }

  createClass(LeadgenForm, [{
    key: 'getLeads',
    value: function getLeads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Lead, fields, params, fetchFirstPage, '/leads');
    }
  }, {
    key: 'getTestLeads',
    value: function getTestLeads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Lead, fields, params, fetchFirstPage, '/test_leads');
    }
  }, {
    key: 'createTestLead',
    value: function createTestLead(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/test_leads', fields, params, Lead, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(LeadgenForm.prototype.__proto__ || Object.getPrototypeOf(LeadgenForm.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        allow_organic_lead: 'allow_organic_lead',
        block_display_for_non_targeted_viewer: 'block_display_for_non_targeted_viewer',
        context_card: 'context_card',
        created_time: 'created_time',
        creator: 'creator',
        expired_leads_count: 'expired_leads_count',
        follow_up_action_text: 'follow_up_action_text',
        follow_up_action_url: 'follow_up_action_url',
        id: 'id',
        is_optimized_for_quality: 'is_optimized_for_quality',
        leads_count: 'leads_count',
        legal_content: 'legal_content',
        locale: 'locale',
        name: 'name',
        organic_leads_count: 'organic_leads_count',
        page: 'page',
        page_id: 'page_id',
        privacy_policy_url: 'privacy_policy_url',
        question_page_custom_headline: 'question_page_custom_headline',
        questions: 'questions',
        status: 'status',
        thank_you_page: 'thank_you_page',
        tracking_parameters: 'tracking_parameters'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        archived: 'ARCHIVED',
        deleted: 'DELETED',
        draft: 'DRAFT'
      });
    }
  }, {
    key: 'Locale',
    get: function get() {
      return Object.freeze({
        ar_ar: 'AR_AR',
        cs_cz: 'CS_CZ',
        da_dk: 'DA_DK',
        de_de: 'DE_DE',
        el_gr: 'EL_GR',
        en_gb: 'EN_GB',
        en_us: 'EN_US',
        es_es: 'ES_ES',
        es_la: 'ES_LA',
        fi_fi: 'FI_FI',
        fr_fr: 'FR_FR',
        he_il: 'HE_IL',
        hi_in: 'HI_IN',
        hu_hu: 'HU_HU',
        id_id: 'ID_ID',
        it_it: 'IT_IT',
        ja_jp: 'JA_JP',
        ko_kr: 'KO_KR',
        nb_no: 'NB_NO',
        nl_nl: 'NL_NL',
        pl_pl: 'PL_PL',
        pt_br: 'PT_BR',
        pt_pt: 'PT_PT',
        ro_ro: 'RO_RO',
        ru_ru: 'RU_RU',
        sv_se: 'SV_SE',
        th_th: 'TH_TH',
        tr_tr: 'TR_TR',
        vi_vn: 'VI_VN',
        zh_cn: 'ZH_CN',
        zh_hk: 'ZH_HK',
        zh_tw: 'ZH_TW'
      });
    }
  }]);
  return LeadgenForm;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MediaFingerprint
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MediaFingerprint = function (_AbstractCrudObject) {
  inherits(MediaFingerprint, _AbstractCrudObject);

  function MediaFingerprint() {
    classCallCheck(this, MediaFingerprint);
    return possibleConstructorReturn(this, (MediaFingerprint.__proto__ || Object.getPrototypeOf(MediaFingerprint)).apply(this, arguments));
  }

  createClass(MediaFingerprint, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(MediaFingerprint.prototype.__proto__ || Object.getPrototypeOf(MediaFingerprint.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        duration_in_sec: 'duration_in_sec',
        fingerprint_content_type: 'fingerprint_content_type',
        fingerprint_type: 'fingerprint_type',
        id: 'id',
        metadata: 'metadata',
        title: 'title',
        universal_content_id: 'universal_content_id'
      });
    }
  }, {
    key: 'FingerprintContentType',
    get: function get() {
      return Object.freeze({
        am_songtrack: 'AM_SONGTRACK',
        episode: 'EPISODE',
        movie: 'MOVIE',
        other: 'OTHER',
        songtrack: 'SONGTRACK'
      });
    }
  }]);
  return MediaFingerprint;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MessagingFeatureReview
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MessagingFeatureReview = function (_AbstractCrudObject) {
  inherits(MessagingFeatureReview, _AbstractCrudObject);

  function MessagingFeatureReview() {
    classCallCheck(this, MessagingFeatureReview);
    return possibleConstructorReturn(this, (MessagingFeatureReview.__proto__ || Object.getPrototypeOf(MessagingFeatureReview)).apply(this, arguments));
  }

  createClass(MessagingFeatureReview, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        feature: 'feature',
        status: 'status'
      });
    }
  }]);
  return MessagingFeatureReview;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MessengerProfile
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MessengerProfile = function (_AbstractCrudObject) {
  inherits(MessengerProfile, _AbstractCrudObject);

  function MessengerProfile() {
    classCallCheck(this, MessengerProfile);
    return possibleConstructorReturn(this, (MessengerProfile.__proto__ || Object.getPrototypeOf(MessengerProfile)).apply(this, arguments));
  }

  createClass(MessengerProfile, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_linking_url: 'account_linking_url',
        get_started: 'get_started',
        greeting: 'greeting',
        ice_breakers: 'ice_breakers',
        payment_settings: 'payment_settings',
        persistent_menu: 'persistent_menu',
        subject_to_new_eu_privacy_rules: 'subject_to_new_eu_privacy_rules',
        target_audience: 'target_audience',
        whitelisted_domains: 'whitelisted_domains'
      });
    }
  }]);
  return MessengerProfile;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserPageOneTimeOptInTokenSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserPageOneTimeOptInTokenSettings = function (_AbstractCrudObject) {
  inherits(UserPageOneTimeOptInTokenSettings, _AbstractCrudObject);

  function UserPageOneTimeOptInTokenSettings() {
    classCallCheck(this, UserPageOneTimeOptInTokenSettings);
    return possibleConstructorReturn(this, (UserPageOneTimeOptInTokenSettings.__proto__ || Object.getPrototypeOf(UserPageOneTimeOptInTokenSettings)).apply(this, arguments));
  }

  createClass(UserPageOneTimeOptInTokenSettings, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_timestamp: 'creation_timestamp',
        next_eligible_time: 'next_eligible_time',
        notification_messages_frequency: 'notification_messages_frequency',
        notification_messages_reoptin: 'notification_messages_reoptin',
        notification_messages_timezone: 'notification_messages_timezone',
        notification_messages_token: 'notification_messages_token',
        recipient_id: 'recipient_id',
        token_expiry_timestamp: 'token_expiry_timestamp',
        topic_title: 'topic_title',
        user_token_status: 'user_token_status',
        id: 'id'
      });
    }
  }]);
  return UserPageOneTimeOptInTokenSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Persona
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Persona = function (_AbstractCrudObject) {
  inherits(Persona, _AbstractCrudObject);

  function Persona() {
    classCallCheck(this, Persona);
    return possibleConstructorReturn(this, (Persona.__proto__ || Object.getPrototypeOf(Persona)).apply(this, arguments));
  }

  createClass(Persona, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Persona.prototype.__proto__ || Object.getPrototypeOf(Persona.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name',
        profile_picture_url: 'profile_picture_url'
      });
    }
  }]);
  return Persona;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Recommendation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Recommendation = function (_AbstractCrudObject) {
  inherits(Recommendation, _AbstractCrudObject);

  function Recommendation() {
    classCallCheck(this, Recommendation);
    return possibleConstructorReturn(this, (Recommendation.__proto__ || Object.getPrototypeOf(Recommendation)).apply(this, arguments));
  }

  createClass(Recommendation, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        created_time: 'created_time',
        has_rating: 'has_rating',
        has_review: 'has_review',
        open_graph_story: 'open_graph_story',
        rating: 'rating',
        recommendation_type: 'recommendation_type',
        review_text: 'review_text',
        reviewer: 'reviewer'
      });
    }
  }]);
  return Recommendation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageSettings = function (_AbstractCrudObject) {
  inherits(PageSettings, _AbstractCrudObject);

  function PageSettings() {
    classCallCheck(this, PageSettings);
    return possibleConstructorReturn(this, (PageSettings.__proto__ || Object.getPrototypeOf(PageSettings)).apply(this, arguments));
  }

  createClass(PageSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        setting: 'setting',
        value: 'value'
      });
    }
  }]);
  return PageSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Tab
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Tab = function (_AbstractCrudObject) {
  inherits(Tab, _AbstractCrudObject);

  function Tab() {
    classCallCheck(this, Tab);
    return possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
  }

  createClass(Tab, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        application: 'application',
        custom_image_url: 'custom_image_url',
        custom_name: 'custom_name',
        id: 'id',
        image_url: 'image_url',
        is_non_connection_landing_tab: 'is_non_connection_landing_tab',
        is_permanent: 'is_permanent',
        link: 'link',
        name: 'name',
        position: 'position'
      });
    }
  }]);
  return Tab;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageThreadOwner
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageThreadOwner = function (_AbstractCrudObject) {
  inherits(PageThreadOwner, _AbstractCrudObject);

  function PageThreadOwner() {
    classCallCheck(this, PageThreadOwner);
    return possibleConstructorReturn(this, (PageThreadOwner.__proto__ || Object.getPrototypeOf(PageThreadOwner)).apply(this, arguments));
  }

  createClass(PageThreadOwner, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        thread_owner: 'thread_owner'
      });
    }
  }]);
  return PageThreadOwner;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoCopyrightRule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoCopyrightRule = function (_AbstractCrudObject) {
  inherits(VideoCopyrightRule, _AbstractCrudObject);

  function VideoCopyrightRule() {
    classCallCheck(this, VideoCopyrightRule);
    return possibleConstructorReturn(this, (VideoCopyrightRule.__proto__ || Object.getPrototypeOf(VideoCopyrightRule)).apply(this, arguments));
  }

  createClass(VideoCopyrightRule, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        condition_groups: 'condition_groups',
        copyrights: 'copyrights',
        created_date: 'created_date',
        creator: 'creator',
        id: 'id',
        is_in_migration: 'is_in_migration',
        name: 'name'
      });
    }
  }, {
    key: 'Source',
    get: function get() {
      return Object.freeze({
        match_settings_dialog: 'MATCH_SETTINGS_DIALOG',
        rules_selector: 'RULES_SELECTOR',
        rules_tab: 'RULES_TAB'
      });
    }
  }]);
  return VideoCopyrightRule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoCopyright
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoCopyright = function (_AbstractCrudObject) {
  inherits(VideoCopyright, _AbstractCrudObject);

  function VideoCopyright() {
    classCallCheck(this, VideoCopyright);
    return possibleConstructorReturn(this, (VideoCopyright.__proto__ || Object.getPrototypeOf(VideoCopyright)).apply(this, arguments));
  }

  createClass(VideoCopyright, [{
    key: 'getUpdateRecords',
    value: function getUpdateRecords(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/update_records');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(VideoCopyright.prototype.__proto__ || Object.getPrototypeOf(VideoCopyright.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        content_category: 'content_category',
        copyright_content_id: 'copyright_content_id',
        creator: 'creator',
        excluded_ownership_segments: 'excluded_ownership_segments',
        id: 'id',
        in_conflict: 'in_conflict',
        monitoring_status: 'monitoring_status',
        monitoring_type: 'monitoring_type',
        ownership_countries: 'ownership_countries',
        reference_file: 'reference_file',
        reference_file_disabled: 'reference_file_disabled',
        reference_file_disabled_by_ops: 'reference_file_disabled_by_ops',
        reference_owner_id: 'reference_owner_id',
        rule_ids: 'rule_ids',
        tags: 'tags',
        whitelisted_ids: 'whitelisted_ids'
      });
    }
  }, {
    key: 'ContentCategory',
    get: function get() {
      return Object.freeze({
        episode: 'episode',
        movie: 'movie',
        web: 'web'
      });
    }
  }, {
    key: 'MonitoringType',
    get: function get() {
      return Object.freeze({
        audio_only: 'AUDIO_ONLY',
        video_and_audio: 'VIDEO_AND_AUDIO',
        video_only: 'VIDEO_ONLY'
      });
    }
  }]);
  return VideoCopyright;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoList
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoList = function (_AbstractCrudObject) {
  inherits(VideoList, _AbstractCrudObject);

  function VideoList() {
    classCallCheck(this, VideoList);
    return possibleConstructorReturn(this, (VideoList.__proto__ || Object.getPrototypeOf(VideoList)).apply(this, arguments));
  }

  createClass(VideoList, [{
    key: 'getVideos',
    value: function getVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/videos');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_time: 'creation_time',
        description: 'description',
        id: 'id',
        last_modified: 'last_modified',
        owner: 'owner',
        season_number: 'season_number',
        thumbnail: 'thumbnail',
        title: 'title',
        videos_count: 'videos_count'
      });
    }
  }]);
  return VideoList;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Page
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Page = function (_AbstractCrudObject) {
  inherits(Page, _AbstractCrudObject);

  function Page() {
    classCallCheck(this, Page);
    return possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
  }

  createClass(Page, [{
    key: 'createAcknowledgeOrder',
    value: function createAcknowledgeOrder(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/acknowledge_orders', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getAdsPosts',
    value: function getAdsPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/ads_posts');
    }
  }, {
    key: 'deleteAgencies',
    value: function deleteAgencies() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/agencies', params);
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'createAgency',
    value: function createAgency(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/agencies', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getAlbums',
    value: function getAlbums(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Album, fields, params, fetchFirstPage, '/albums');
    }
  }, {
    key: 'getArExperience',
    value: function getArExperience(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ar_experience');
    }
  }, {
    key: 'deleteAssignedUsers',
    value: function deleteAssignedUsers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/assigned_users', params);
    }
  }, {
    key: 'getAssignedUsers',
    value: function getAssignedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AssignedUser, fields, params, fetchFirstPage, '/assigned_users');
    }
  }, {
    key: 'createAssignedUser',
    value: function createAssignedUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assigned_users', fields, params, Page, pathOverride);
    }
  }, {
    key: 'deleteBlocked',
    value: function deleteBlocked() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/blocked', params);
    }
  }, {
    key: 'getBlocked',
    value: function getBlocked(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/blocked');
    }
  }, {
    key: 'createBlocked',
    value: function createBlocked(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/blocked', fields, params, null, pathOverride);
    }
  }, {
    key: 'createBusinessDatum',
    value: function createBusinessDatum(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/business_data', fields, params, null, pathOverride);
    }
  }, {
    key: 'getBusinessProjects',
    value: function getBusinessProjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/businessprojects');
    }
  }, {
    key: 'getCallToActions',
    value: function getCallToActions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PageCallToAction, fields, params, fetchFirstPage, '/call_to_actions');
    }
  }, {
    key: 'getCanvasElements',
    value: function getCanvasElements(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CanvasBodyElement, fields, params, fetchFirstPage, '/canvas_elements');
    }
  }, {
    key: 'createCanvasElement',
    value: function createCanvasElement(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/canvas_elements', fields, params, CanvasBodyElement, pathOverride);
    }
  }, {
    key: 'getCanvases',
    value: function getCanvases(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Canvas, fields, params, fetchFirstPage, '/canvases');
    }
  }, {
    key: 'createCanvase',
    value: function createCanvase(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/canvases', fields, params, Canvas, pathOverride);
    }
  }, {
    key: 'getChatPlugin',
    value: function getChatPlugin(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ChatPlugin, fields, params, fetchFirstPage, '/chat_plugin');
    }
  }, {
    key: 'createChatPlugin',
    value: function createChatPlugin(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/chat_plugin', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getClaimedUrls',
    value: function getClaimedUrls(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(URL, fields, params, fetchFirstPage, '/claimed_urls');
    }
  }, {
    key: 'getCommerceEligibility',
    value: function getCommerceEligibility(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PageCommerceEligibility, fields, params, fetchFirstPage, '/commerce_eligibility');
    }
  }, {
    key: 'getCommerceMerchantSettings',
    value: function getCommerceMerchantSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceMerchantSettings, fields, params, fetchFirstPage, '/commerce_merchant_settings');
    }
  }, {
    key: 'getCommerceOrders',
    value: function getCommerceOrders(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceOrder, fields, params, fetchFirstPage, '/commerce_orders');
    }
  }, {
    key: 'getCommercePayouts',
    value: function getCommercePayouts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommercePayout, fields, params, fetchFirstPage, '/commerce_payouts');
    }
  }, {
    key: 'getCommerceTransactions',
    value: function getCommerceTransactions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceOrderTransactionDetail, fields, params, fetchFirstPage, '/commerce_transactions');
    }
  }, {
    key: 'getConversations',
    value: function getConversations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UnifiedThread, fields, params, fetchFirstPage, '/conversations');
    }
  }, {
    key: 'createCopyrightManualClaim',
    value: function createCopyrightManualClaim(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/copyright_manual_claims', fields, params, null, pathOverride);
    }
  }, {
    key: 'getCrosspostWhitelistedPages',
    value: function getCrosspostWhitelistedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/crosspost_whitelisted_pages');
    }
  }, {
    key: 'getCustomLabels',
    value: function getCustomLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PageUserMessageThreadLabel, fields, params, fetchFirstPage, '/custom_labels');
    }
  }, {
    key: 'createCustomLabel',
    value: function createCustomLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/custom_labels', fields, params, PageUserMessageThreadLabel, pathOverride);
    }
  }, {
    key: 'deleteCustomUserSettings',
    value: function deleteCustomUserSettings() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/custom_user_settings', params);
    }
  }, {
    key: 'getCustomUserSettings',
    value: function getCustomUserSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomUserSettings, fields, params, fetchFirstPage, '/custom_user_settings');
    }
  }, {
    key: 'createCustomUserSetting',
    value: function createCustomUserSetting(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/custom_user_settings', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getEvents',
    value: function getEvents(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Event, fields, params, fetchFirstPage, '/events');
    }
  }, {
    key: 'createExtendThreadControl',
    value: function createExtendThreadControl(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/extend_thread_control', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getFantasyGames',
    value: function getFantasyGames(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/fantasy_games');
    }
  }, {
    key: 'getFeed',
    value: function getFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/feed');
    }
  }, {
    key: 'createFeed',
    value: function createFeed(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/feed', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getGlobalBrandChildren',
    value: function getGlobalBrandChildren(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/global_brand_children');
    }
  }, {
    key: 'getGroups',
    value: function getGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Group, fields, params, fetchFirstPage, '/groups');
    }
  }, {
    key: 'getImageCopyrights',
    value: function getImageCopyrights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ImageCopyright, fields, params, fetchFirstPage, '/image_copyrights');
    }
  }, {
    key: 'createImageCopyright',
    value: function createImageCopyright(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/image_copyrights', fields, params, ImageCopyright, pathOverride);
    }
  }, {
    key: 'getIndexedVideos',
    value: function getIndexedVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/indexed_videos');
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InsightsResult, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getInstagramAccounts',
    value: function getInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramUser, fields, params, fetchFirstPage, '/instagram_accounts');
    }
  }, {
    key: 'getInstantArticles',
    value: function getInstantArticles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstantArticle, fields, params, fetchFirstPage, '/instant_articles');
    }
  }, {
    key: 'createInstantArticle',
    value: function createInstantArticle(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/instant_articles', fields, params, InstantArticle, pathOverride);
    }
  }, {
    key: 'getInstantArticlesInsights',
    value: function getInstantArticlesInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstantArticleInsightsQueryResult, fields, params, fetchFirstPage, '/instant_articles_insights');
    }
  }, {
    key: 'createInstantArticlesPublish',
    value: function createInstantArticlesPublish(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/instant_articles_publish', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getInstantArticlesStats',
    value: function getInstantArticlesStats(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstantArticlesStats, fields, params, fetchFirstPage, '/instant_articles_stats');
    }
  }, {
    key: 'getInvoiceAccessBankAccount',
    value: function getInvoiceAccessBankAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/invoice_access_bank_account');
    }
  }, {
    key: 'getLeadGenForms',
    value: function getLeadGenForms(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(LeadgenForm, fields, params, fetchFirstPage, '/leadgen_forms');
    }
  }, {
    key: 'createLeadGenForm',
    value: function createLeadGenForm(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/leadgen_forms', fields, params, LeadgenForm, pathOverride);
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'getLiveVideos',
    value: function getLiveVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(LiveVideo, fields, params, fetchFirstPage, '/live_videos');
    }
  }, {
    key: 'createLiveVideo',
    value: function createLiveVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/live_videos', fields, params, LiveVideo, pathOverride);
    }
  }, {
    key: 'deleteLocations',
    value: function deleteLocations() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/locations', params);
    }
  }, {
    key: 'getLocations',
    value: function getLocations(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/locations');
    }
  }, {
    key: 'createLocation',
    value: function createLocation(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/locations', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getMediaFingerprints',
    value: function getMediaFingerprints(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MediaFingerprint, fields, params, fetchFirstPage, '/media_fingerprints');
    }
  }, {
    key: 'createMediaFingerprint',
    value: function createMediaFingerprint(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/media_fingerprints', fields, params, MediaFingerprint, pathOverride);
    }
  }, {
    key: 'createMessageAttachment',
    value: function createMessageAttachment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/message_attachments', fields, params, null, pathOverride);
    }
  }, {
    key: 'createMessage',
    value: function createMessage(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/messages', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getMessagingFeatureReview',
    value: function getMessagingFeatureReview(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MessagingFeatureReview, fields, params, fetchFirstPage, '/messaging_feature_review');
    }
  }, {
    key: 'deleteMessengerProfile',
    value: function deleteMessengerProfile() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/messenger_profile', params);
    }
  }, {
    key: 'getMessengerProfile',
    value: function getMessengerProfile(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MessengerProfile, fields, params, fetchFirstPage, '/messenger_profile');
    }
  }, {
    key: 'createMessengerProfile',
    value: function createMessengerProfile(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/messenger_profile', fields, params, Page, pathOverride);
    }
  }, {
    key: 'createNlpConfig',
    value: function createNlpConfig(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/nlp_configs', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getNotificationMessageTokens',
    value: function getNotificationMessageTokens(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UserPageOneTimeOptInTokenSettings, fields, params, fetchFirstPage, '/notification_message_tokens');
    }
  }, {
    key: 'createNotificationMessagesDevSupport',
    value: function createNotificationMessagesDevSupport(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/notification_messages_dev_support', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getPageBackedInstagramAccounts',
    value: function getPageBackedInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramUser, fields, params, fetchFirstPage, '/page_backed_instagram_accounts');
    }
  }, {
    key: 'createPageBackedInstagramAccount',
    value: function createPageBackedInstagramAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/page_backed_instagram_accounts', fields, params, InstagramUser, pathOverride);
    }
  }, {
    key: 'createPageWhatsappNumberVerification',
    value: function createPageWhatsappNumberVerification(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/page_whatsapp_number_verification', fields, params, Page, pathOverride);
    }
  }, {
    key: 'createPassThreadControl',
    value: function createPassThreadControl(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/pass_thread_control', fields, params, Page, pathOverride);
    }
  }, {
    key: 'createPassThreadMetadatum',
    value: function createPassThreadMetadatum(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/pass_thread_metadata', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getPersonas',
    value: function getPersonas(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Persona, fields, params, fetchFirstPage, '/personas');
    }
  }, {
    key: 'createPersona',
    value: function createPersona(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/personas', fields, params, Persona, pathOverride);
    }
  }, {
    key: 'getPhotos',
    value: function getPhotos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Photo, fields, params, fetchFirstPage, '/photos');
    }
  }, {
    key: 'createPhoto',
    value: function createPhoto(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/photos', fields, params, Photo, pathOverride);
    }
  }, {
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProfilePictureSource, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'createPicture',
    value: function createPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/picture', fields, params, ProfilePictureSource, pathOverride);
    }
  }, {
    key: 'getPosts',
    value: function getPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/posts');
    }
  }, {
    key: 'getProductCatalogs',
    value: function getProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/product_catalogs');
    }
  }, {
    key: 'getPublishedPosts',
    value: function getPublishedPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/published_posts');
    }
  }, {
    key: 'getRatings',
    value: function getRatings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Recommendation, fields, params, fetchFirstPage, '/ratings');
    }
  }, {
    key: 'createReleaseThreadControl',
    value: function createReleaseThreadControl(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/release_thread_control', fields, params, Page, pathOverride);
    }
  }, {
    key: 'createRequestThreadControl',
    value: function createRequestThreadControl(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/request_thread_control', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getRoles',
    value: function getRoles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(User, fields, params, fetchFirstPage, '/roles');
    }
  }, {
    key: 'getRtbDynamicPosts',
    value: function getRtbDynamicPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(RTBDynamicPost, fields, params, fetchFirstPage, '/rtb_dynamic_posts');
    }
  }, {
    key: 'getScheduledPosts',
    value: function getScheduledPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/scheduled_posts');
    }
  }, {
    key: 'getSecondaryReceivers',
    value: function getSecondaryReceivers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/secondary_receivers');
    }
  }, {
    key: 'getSettings',
    value: function getSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PageSettings, fields, params, fetchFirstPage, '/settings');
    }
  }, {
    key: 'createSetting',
    value: function createSetting(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/settings', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getShopSetupStatus',
    value: function getShopSetupStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceMerchantSettingsSetupStatus, fields, params, fetchFirstPage, '/shop_setup_status');
    }
  }, {
    key: 'deleteSubscribedApps',
    value: function deleteSubscribedApps() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'deleteEdge', this).call(this, '/subscribed_apps', params);
    }
  }, {
    key: 'getSubscribedApps',
    value: function getSubscribedApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/subscribed_apps');
    }
  }, {
    key: 'createSubscribedApp',
    value: function createSubscribedApp(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/subscribed_apps', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getTabs',
    value: function getTabs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Tab, fields, params, fetchFirstPage, '/tabs');
    }
  }, {
    key: 'getTagged',
    value: function getTagged(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/tagged');
    }
  }, {
    key: 'createTakeThreadControl',
    value: function createTakeThreadControl(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/take_thread_control', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getThreadOwner',
    value: function getThreadOwner(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PageThreadOwner, fields, params, fetchFirstPage, '/thread_owner');
    }
  }, {
    key: 'getThreads',
    value: function getThreads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UnifiedThread, fields, params, fetchFirstPage, '/threads');
    }
  }, {
    key: 'createUnlinkAccount',
    value: function createUnlinkAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/unlink_accounts', fields, params, Page, pathOverride);
    }
  }, {
    key: 'getVideoCopyrightRules',
    value: function getVideoCopyrightRules(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(VideoCopyrightRule, fields, params, fetchFirstPage, '/video_copyright_rules');
    }
  }, {
    key: 'createVideoCopyrightRule',
    value: function createVideoCopyrightRule(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/video_copyright_rules', fields, params, VideoCopyrightRule, pathOverride);
    }
  }, {
    key: 'createVideoCopyright',
    value: function createVideoCopyright(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/video_copyrights', fields, params, VideoCopyright, pathOverride);
    }
  }, {
    key: 'getVideoLists',
    value: function getVideoLists(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(VideoList, fields, params, fetchFirstPage, '/video_lists');
    }
  }, {
    key: 'getVideoReels',
    value: function getVideoReels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/video_reels');
    }
  }, {
    key: 'createVideoReel',
    value: function createVideoReel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/video_reels', fields, params, AdVideo, pathOverride);
    }
  }, {
    key: 'getVideos',
    value: function getVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/videos');
    }
  }, {
    key: 'createVideo',
    value: function createVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/videos', fields, params, AdVideo, pathOverride);
    }
  }, {
    key: 'getVisitorPosts',
    value: function getVisitorPosts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PagePost, fields, params, fetchFirstPage, '/visitor_posts');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Page.prototype.__proto__ || Object.getPrototypeOf(Page.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        about: 'about',
        access_token: 'access_token',
        ad_campaign: 'ad_campaign',
        affiliation: 'affiliation',
        app_id: 'app_id',
        artists_we_like: 'artists_we_like',
        attire: 'attire',
        awards: 'awards',
        band_interests: 'band_interests',
        band_members: 'band_members',
        best_page: 'best_page',
        bio: 'bio',
        birthday: 'birthday',
        booking_agent: 'booking_agent',
        built: 'built',
        business: 'business',
        can_checkin: 'can_checkin',
        can_post: 'can_post',
        category: 'category',
        category_list: 'category_list',
        checkins: 'checkins',
        company_overview: 'company_overview',
        connected_instagram_account: 'connected_instagram_account',
        connected_page_backed_instagram_account: 'connected_page_backed_instagram_account',
        contact_address: 'contact_address',
        copyright_whitelisted_ig_partners: 'copyright_whitelisted_ig_partners',
        country_page_likes: 'country_page_likes',
        cover: 'cover',
        culinary_team: 'culinary_team',
        current_location: 'current_location',
        delivery_and_pickup_option_info: 'delivery_and_pickup_option_info',
        description: 'description',
        description_html: 'description_html',
        differently_open_offerings: 'differently_open_offerings',
        directed_by: 'directed_by',
        display_subtext: 'display_subtext',
        displayed_message_response_time: 'displayed_message_response_time',
        emails: 'emails',
        engagement: 'engagement',
        fan_count: 'fan_count',
        featured_video: 'featured_video',
        features: 'features',
        followers_count: 'followers_count',
        food_styles: 'food_styles',
        founded: 'founded',
        general_info: 'general_info',
        general_manager: 'general_manager',
        genre: 'genre',
        global_brand_page_name: 'global_brand_page_name',
        global_brand_root_id: 'global_brand_root_id',
        has_added_app: 'has_added_app',
        has_transitioned_to_new_page_experience: 'has_transitioned_to_new_page_experience',
        has_whatsapp_business_number: 'has_whatsapp_business_number',
        has_whatsapp_number: 'has_whatsapp_number',
        hometown: 'hometown',
        hours: 'hours',
        id: 'id',
        impressum: 'impressum',
        influences: 'influences',
        instagram_business_account: 'instagram_business_account',
        instant_articles_review_status: 'instant_articles_review_status',
        is_always_open: 'is_always_open',
        is_chain: 'is_chain',
        is_community_page: 'is_community_page',
        is_eligible_for_branded_content: 'is_eligible_for_branded_content',
        is_messenger_bot_get_started_enabled: 'is_messenger_bot_get_started_enabled',
        is_messenger_platform_bot: 'is_messenger_platform_bot',
        is_owned: 'is_owned',
        is_permanently_closed: 'is_permanently_closed',
        is_published: 'is_published',
        is_unclaimed: 'is_unclaimed',
        is_verified: 'is_verified',
        is_webhooks_subscribed: 'is_webhooks_subscribed',
        keywords: 'keywords',
        leadgen_tos_acceptance_time: 'leadgen_tos_acceptance_time',
        leadgen_tos_accepted: 'leadgen_tos_accepted',
        leadgen_tos_accepting_user: 'leadgen_tos_accepting_user',
        link: 'link',
        location: 'location',
        members: 'members',
        merchant_id: 'merchant_id',
        merchant_review_status: 'merchant_review_status',
        messaging_feature_status: 'messaging_feature_status',
        messenger_ads_default_icebreakers: 'messenger_ads_default_icebreakers',
        messenger_ads_default_page_welcome_message: 'messenger_ads_default_page_welcome_message',
        messenger_ads_default_quick_replies: 'messenger_ads_default_quick_replies',
        messenger_ads_quick_replies_type: 'messenger_ads_quick_replies_type',
        mini_shop_storefront: 'mini_shop_storefront',
        mission: 'mission',
        mpg: 'mpg',
        name: 'name',
        name_with_location_descriptor: 'name_with_location_descriptor',
        network: 'network',
        new_like_count: 'new_like_count',
        offer_eligible: 'offer_eligible',
        overall_star_rating: 'overall_star_rating',
        owner_business: 'owner_business',
        page_token: 'page_token',
        parent_page: 'parent_page',
        parking: 'parking',
        payment_options: 'payment_options',
        personal_info: 'personal_info',
        personal_interests: 'personal_interests',
        pharma_safety_info: 'pharma_safety_info',
        phone: 'phone',
        pickup_options: 'pickup_options',
        place_type: 'place_type',
        plot_outline: 'plot_outline',
        preferred_audience: 'preferred_audience',
        press_contact: 'press_contact',
        price_range: 'price_range',
        privacy_info_url: 'privacy_info_url',
        produced_by: 'produced_by',
        products: 'products',
        promotion_eligible: 'promotion_eligible',
        promotion_ineligible_reason: 'promotion_ineligible_reason',
        public_transit: 'public_transit',
        rating_count: 'rating_count',
        recipient: 'recipient',
        record_label: 'record_label',
        release_date: 'release_date',
        restaurant_services: 'restaurant_services',
        restaurant_specialties: 'restaurant_specialties',
        schedule: 'schedule',
        screenplay_by: 'screenplay_by',
        season: 'season',
        single_line_address: 'single_line_address',
        starring: 'starring',
        start_info: 'start_info',
        store_code: 'store_code',
        store_location_descriptor: 'store_location_descriptor',
        store_number: 'store_number',
        studio: 'studio',
        supports_donate_button_in_live_video: 'supports_donate_button_in_live_video',
        supports_instant_articles: 'supports_instant_articles',
        talking_about_count: 'talking_about_count',
        temporary_status: 'temporary_status',
        unread_message_count: 'unread_message_count',
        unread_notif_count: 'unread_notif_count',
        unseen_message_count: 'unseen_message_count',
        username: 'username',
        verification_status: 'verification_status',
        voip_info: 'voip_info',
        website: 'website',
        were_here_count: 'were_here_count',
        whatsapp_number: 'whatsapp_number',
        written_by: 'written_by'
      });
    }
  }, {
    key: 'Attire',
    get: function get() {
      return Object.freeze({
        casual: 'Casual',
        dressy: 'Dressy',
        unspecified: 'Unspecified'
      });
    }
  }, {
    key: 'FoodStyles',
    get: function get() {
      return Object.freeze({
        afghani: 'Afghani',
        american_new_: 'American (New)',
        american_traditional_: 'American (Traditional)',
        asian_fusion: 'Asian Fusion',
        barbeque: 'Barbeque',
        brazilian: 'Brazilian',
        breakfast: 'Breakfast',
        british: 'British',
        brunch: 'Brunch',
        buffets: 'Buffets',
        burgers: 'Burgers',
        burmese: 'Burmese',
        cajun_creole: 'Cajun/Creole',
        caribbean: 'Caribbean',
        chinese: 'Chinese',
        creperies: 'Creperies',
        cuban: 'Cuban',
        delis: 'Delis',
        diners: 'Diners',
        ethiopian: 'Ethiopian',
        fast_food: 'Fast Food',
        filipino: 'Filipino',
        fondue: 'Fondue',
        food_stands: 'Food Stands',
        french: 'French',
        german: 'German',
        greek_and_mediterranean: 'Greek and Mediterranean',
        hawaiian: 'Hawaiian',
        himalayan_nepalese: 'Himalayan/Nepalese',
        hot_dogs: 'Hot Dogs',
        indian_pakistani: 'Indian/Pakistani',
        irish: 'Irish',
        italian: 'Italian',
        japanese: 'Japanese',
        korean: 'Korean',
        latin_american: 'Latin American',
        mexican: 'Mexican',
        middle_eastern: 'Middle Eastern',
        moroccan: 'Moroccan',
        pizza: 'Pizza',
        russian: 'Russian',
        sandwiches: 'Sandwiches',
        seafood: 'Seafood',
        singaporean: 'Singaporean',
        soul_food: 'Soul Food',
        southern: 'Southern',
        spanish_basque: 'Spanish/Basque',
        steakhouses: 'Steakhouses',
        sushi_bars: 'Sushi Bars',
        taiwanese: 'Taiwanese',
        tapas_bars: 'Tapas Bars',
        tex_mex: 'Tex-Mex',
        thai: 'Thai',
        turkish: 'Turkish',
        vegan: 'Vegan',
        vegetarian: 'Vegetarian',
        vietnamese: 'Vietnamese'
      });
    }
  }, {
    key: 'PickupOptions',
    get: function get() {
      return Object.freeze({
        curbside: 'CURBSIDE',
        in_store: 'IN_STORE',
        other: 'OTHER'
      });
    }
  }, {
    key: 'TemporaryStatus',
    get: function get() {
      return Object.freeze({
        differently_open: 'DIFFERENTLY_OPEN',
        no_data: 'NO_DATA',
        operating_as_usual: 'OPERATING_AS_USUAL',
        temporarily_closed: 'TEMPORARILY_CLOSED'
      });
    }
  }, {
    key: 'PermittedTasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        cashier_role: 'CASHIER_ROLE',
        create_content: 'CREATE_CONTENT',
        manage: 'MANAGE',
        manage_jobs: 'MANAGE_JOBS',
        manage_leads: 'MANAGE_LEADS',
        messaging: 'MESSAGING',
        moderate: 'MODERATE',
        moderate_community: 'MODERATE_COMMUNITY',
        pages_messaging: 'PAGES_MESSAGING',
        pages_messaging_subscriptions: 'PAGES_MESSAGING_SUBSCRIPTIONS',
        profile_plus_advertise: 'PROFILE_PLUS_ADVERTISE',
        profile_plus_analyze: 'PROFILE_PLUS_ANALYZE',
        profile_plus_create_content: 'PROFILE_PLUS_CREATE_CONTENT',
        profile_plus_facebook_access: 'PROFILE_PLUS_FACEBOOK_ACCESS',
        profile_plus_full_control: 'PROFILE_PLUS_FULL_CONTROL',
        profile_plus_manage: 'PROFILE_PLUS_MANAGE',
        profile_plus_manage_leads: 'PROFILE_PLUS_MANAGE_LEADS',
        profile_plus_messaging: 'PROFILE_PLUS_MESSAGING',
        profile_plus_moderate: 'PROFILE_PLUS_MODERATE',
        profile_plus_moderate_delegate_community: 'PROFILE_PLUS_MODERATE_DELEGATE_COMMUNITY',
        profile_plus_revenue: 'PROFILE_PLUS_REVENUE',
        read_page_mailboxes: 'READ_PAGE_MAILBOXES',
        view_monetization_insights: 'VIEW_MONETIZATION_INSIGHTS'
      });
    }
  }, {
    key: 'Tasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        cashier_role: 'CASHIER_ROLE',
        create_content: 'CREATE_CONTENT',
        manage: 'MANAGE',
        manage_jobs: 'MANAGE_JOBS',
        manage_leads: 'MANAGE_LEADS',
        messaging: 'MESSAGING',
        moderate: 'MODERATE',
        moderate_community: 'MODERATE_COMMUNITY',
        pages_messaging: 'PAGES_MESSAGING',
        pages_messaging_subscriptions: 'PAGES_MESSAGING_SUBSCRIPTIONS',
        profile_plus_advertise: 'PROFILE_PLUS_ADVERTISE',
        profile_plus_analyze: 'PROFILE_PLUS_ANALYZE',
        profile_plus_create_content: 'PROFILE_PLUS_CREATE_CONTENT',
        profile_plus_facebook_access: 'PROFILE_PLUS_FACEBOOK_ACCESS',
        profile_plus_full_control: 'PROFILE_PLUS_FULL_CONTROL',
        profile_plus_manage: 'PROFILE_PLUS_MANAGE',
        profile_plus_manage_leads: 'PROFILE_PLUS_MANAGE_LEADS',
        profile_plus_messaging: 'PROFILE_PLUS_MESSAGING',
        profile_plus_moderate: 'PROFILE_PLUS_MODERATE',
        profile_plus_moderate_delegate_community: 'PROFILE_PLUS_MODERATE_DELEGATE_COMMUNITY',
        profile_plus_revenue: 'PROFILE_PLUS_REVENUE',
        read_page_mailboxes: 'READ_PAGE_MAILBOXES',
        view_monetization_insights: 'VIEW_MONETIZATION_INSIGHTS'
      });
    }
  }, {
    key: 'Alignment',
    get: function get() {
      return Object.freeze({
        left: 'LEFT',
        right: 'RIGHT'
      });
    }
  }, {
    key: 'EntryPointIcon',
    get: function get() {
      return Object.freeze({
        chat_angular_icon: 'CHAT_ANGULAR_ICON',
        chat_round_icon: 'CHAT_ROUND_ICON',
        messenger_icon: 'MESSENGER_ICON',
        none: 'NONE'
      });
    }
  }, {
    key: 'EntryPointLabel',
    get: function get() {
      return Object.freeze({
        ask_us: 'ASK_US',
        chat: 'CHAT',
        help: 'HELP',
        none: 'NONE'
      });
    }
  }, {
    key: 'GreetingDialogDisplay',
    get: function get() {
      return Object.freeze({
        hide: 'HIDE',
        show: 'SHOW',
        welcome_message: 'WELCOME_MESSAGE'
      });
    }
  }, {
    key: 'GuestChatMode',
    get: function get() {
      return Object.freeze({
        disabled: 'DISABLED',
        enabled: 'ENABLED'
      });
    }
  }, {
    key: 'MobileChatDisplay',
    get: function get() {
      return Object.freeze({
        app_switch: 'APP_SWITCH',
        chat_tab: 'CHAT_TAB'
      });
    }
  }, {
    key: 'BackdatedTimeGranularity',
    get: function get() {
      return Object.freeze({
        day: 'day',
        hour: 'hour',
        min: 'min',
        month: 'month',
        none: 'none',
        year: 'year'
      });
    }
  }, {
    key: 'CheckinEntryPoint',
    get: function get() {
      return Object.freeze({
        branding_checkin: 'BRANDING_CHECKIN',
        branding_other: 'BRANDING_OTHER',
        branding_photo: 'BRANDING_PHOTO',
        branding_status: 'BRANDING_STATUS'
      });
    }
  }, {
    key: 'Formatting',
    get: function get() {
      return Object.freeze({
        markdown: 'MARKDOWN',
        plaintext: 'PLAINTEXT'
      });
    }
  }, {
    key: 'PlaceAttachmentSetting',
    get: function get() {
      return Object.freeze({
        value_1: '1',
        value_2: '2'
      });
    }
  }, {
    key: 'PostSurfacesBlacklist',
    get: function get() {
      return Object.freeze({
        value_1: '1',
        value_2: '2',
        value_3: '3',
        value_4: '4',
        value_5: '5'
      });
    }
  }, {
    key: 'PostingToRedspace',
    get: function get() {
      return Object.freeze({
        disabled: 'disabled',
        enabled: 'enabled'
      });
    }
  }, {
    key: 'TargetSurface',
    get: function get() {
      return Object.freeze({
        story: 'STORY',
        timeline: 'TIMELINE'
      });
    }
  }, {
    key: 'UnpublishedContentType',
    get: function get() {
      return Object.freeze({
        ads_post: 'ADS_POST',
        draft: 'DRAFT',
        inline_created: 'INLINE_CREATED',
        published: 'PUBLISHED',
        reviewable_branded_content: 'REVIEWABLE_BRANDED_CONTENT',
        scheduled: 'SCHEDULED',
        scheduled_recurring: 'SCHEDULED_RECURRING'
      });
    }
  }, {
    key: 'PublishStatus',
    get: function get() {
      return Object.freeze({
        draft: 'DRAFT',
        live: 'LIVE'
      });
    }
  }, {
    key: 'MessagingType',
    get: function get() {
      return Object.freeze({
        message_tag: 'MESSAGE_TAG',
        response: 'RESPONSE',
        update: 'UPDATE'
      });
    }
  }, {
    key: 'NotificationType',
    get: function get() {
      return Object.freeze({
        no_push: 'NO_PUSH',
        regular: 'REGULAR',
        silent_push: 'SILENT_PUSH'
      });
    }
  }, {
    key: 'SenderAction',
    get: function get() {
      return Object.freeze({
        mark_seen: 'MARK_SEEN',
        react: 'REACT',
        typing_off: 'TYPING_OFF',
        typing_on: 'TYPING_ON',
        unreact: 'UNREACT'
      });
    }
  }, {
    key: 'Platform',
    get: function get() {
      return Object.freeze({
        instagram: 'INSTAGRAM',
        messenger: 'MESSENGER'
      });
    }
  }, {
    key: 'Model',
    get: function get() {
      return Object.freeze({
        arabic: 'ARABIC',
        chinese: 'CHINESE',
        croatian: 'CROATIAN',
        custom: 'CUSTOM',
        danish: 'DANISH',
        dutch: 'DUTCH',
        english: 'ENGLISH',
        french_standard: 'FRENCH_STANDARD',
        georgian: 'GEORGIAN',
        german_standard: 'GERMAN_STANDARD',
        greek: 'GREEK',
        hebrew: 'HEBREW',
        hungarian: 'HUNGARIAN',
        irish: 'IRISH',
        italian_standard: 'ITALIAN_STANDARD',
        korean: 'KOREAN',
        norwegian_bokmal: 'NORWEGIAN_BOKMAL',
        polish: 'POLISH',
        portuguese: 'PORTUGUESE',
        romanian: 'ROMANIAN',
        spanish: 'SPANISH',
        swedish: 'SWEDISH',
        vietnamese: 'VIETNAMESE'
      });
    }
  }, {
    key: 'DeveloperAction',
    get: function get() {
      return Object.freeze({
        enable_followup_message: 'ENABLE_FOLLOWUP_MESSAGE',
        send_re_optin: 'SEND_RE_OPTIN'
      });
    }
  }, {
    key: 'SubscribedFields',
    get: function get() {
      return Object.freeze({
        affiliation: 'affiliation',
        attire: 'attire',
        awards: 'awards',
        bio: 'bio',
        birthday: 'birthday',
        category: 'category',
        checkins: 'checkins',
        company_overview: 'company_overview',
        conversations: 'conversations',
        culinary_team: 'culinary_team',
        current_location: 'current_location',
        description: 'description',
        email: 'email',
        feature_access_list: 'feature_access_list',
        feed: 'feed',
        founded: 'founded',
        general_info: 'general_info',
        general_manager: 'general_manager',
        hometown: 'hometown',
        hours: 'hours',
        inbox_labels: 'inbox_labels',
        invoice_access_invoice_change: 'invoice_access_invoice_change',
        invoice_access_invoice_draft_change: 'invoice_access_invoice_draft_change',
        invoice_access_onboarding_status_active: 'invoice_access_onboarding_status_active',
        leadgen: 'leadgen',
        leadgen_fat: 'leadgen_fat',
        live_videos: 'live_videos',
        local_delivery: 'local_delivery',
        location: 'location',
        mcom_invoice_change: 'mcom_invoice_change',
        members: 'members',
        mention: 'mention',
        merchant_review: 'merchant_review',
        message_deliveries: 'message_deliveries',
        message_echoes: 'message_echoes',
        message_mention: 'message_mention',
        message_reactions: 'message_reactions',
        message_reads: 'message_reads',
        messages: 'messages',
        messaging_account_linking: 'messaging_account_linking',
        messaging_appointments: 'messaging_appointments',
        messaging_checkout_updates: 'messaging_checkout_updates',
        messaging_customer_information: 'messaging_customer_information',
        messaging_direct_sends: 'messaging_direct_sends',
        messaging_fblogin_account_linking: 'messaging_fblogin_account_linking',
        messaging_feedback: 'messaging_feedback',
        messaging_game_plays: 'messaging_game_plays',
        messaging_handovers: 'messaging_handovers',
        messaging_optins: 'messaging_optins',
        messaging_optouts: 'messaging_optouts',
        messaging_payments: 'messaging_payments',
        messaging_policy_enforcement: 'messaging_policy_enforcement',
        messaging_postbacks: 'messaging_postbacks',
        messaging_pre_checkouts: 'messaging_pre_checkouts',
        messaging_referrals: 'messaging_referrals',
        mission: 'mission',
        name: 'name',
        page_about_story: 'page_about_story',
        page_change_proposal: 'page_change_proposal',
        page_upcoming_change: 'page_upcoming_change',
        parking: 'parking',
        payment_options: 'payment_options',
        personal_info: 'personal_info',
        personal_interests: 'personal_interests',
        phone: 'phone',
        picture: 'picture',
        price_range: 'price_range',
        product_review: 'product_review',
        products: 'products',
        public_transit: 'public_transit',
        publisher_subscriptions: 'publisher_subscriptions',
        ratings: 'ratings',
        registration: 'registration',
        standby: 'standby',
        user_action: 'user_action',
        video_text_question_responses: 'video_text_question_responses',
        videos: 'videos',
        website: 'website'
      });
    }
  }]);
  return Page;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessAssetGroup
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessAssetGroup = function (_AbstractCrudObject) {
  inherits(BusinessAssetGroup, _AbstractCrudObject);

  function BusinessAssetGroup() {
    classCallCheck(this, BusinessAssetGroup);
    return possibleConstructorReturn(this, (BusinessAssetGroup.__proto__ || Object.getPrototypeOf(BusinessAssetGroup)).apply(this, arguments));
  }

  createClass(BusinessAssetGroup, [{
    key: 'deleteAssignedUsers',
    value: function deleteAssignedUsers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/assigned_users', params);
    }
  }, {
    key: 'getAssignedUsers',
    value: function getAssignedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AssignedUser, fields, params, fetchFirstPage, '/assigned_users');
    }
  }, {
    key: 'createAssignedUser',
    value: function createAssignedUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assigned_users', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedAdAccounts',
    value: function deleteContainedAdAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_adaccounts', params);
    }
  }, {
    key: 'getContainedAdAccounts',
    value: function getContainedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/contained_adaccounts');
    }
  }, {
    key: 'createContainedAdAccount',
    value: function createContainedAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_adaccounts', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedApplications',
    value: function deleteContainedApplications() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_applications', params);
    }
  }, {
    key: 'getContainedApplications',
    value: function getContainedApplications(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/contained_applications');
    }
  }, {
    key: 'createContainedApplication',
    value: function createContainedApplication(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_applications', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedCustomConversions',
    value: function deleteContainedCustomConversions() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_custom_conversions', params);
    }
  }, {
    key: 'getContainedCustomConversions',
    value: function getContainedCustomConversions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomConversion, fields, params, fetchFirstPage, '/contained_custom_conversions');
    }
  }, {
    key: 'createContainedCustomConversion',
    value: function createContainedCustomConversion(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_custom_conversions', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedInstagramAccounts',
    value: function deleteContainedInstagramAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_instagram_accounts', params);
    }
  }, {
    key: 'getContainedInstagramAccounts',
    value: function getContainedInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramUser, fields, params, fetchFirstPage, '/contained_instagram_accounts');
    }
  }, {
    key: 'createContainedInstagramAccount',
    value: function createContainedInstagramAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_instagram_accounts', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedOfflineConversionDataSets',
    value: function deleteContainedOfflineConversionDataSets() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_offline_conversion_data_sets', params);
    }
  }, {
    key: 'getContainedOfflineConversionDataSets',
    value: function getContainedOfflineConversionDataSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OfflineConversionDataSet, fields, params, fetchFirstPage, '/contained_offline_conversion_data_sets');
    }
  }, {
    key: 'createContainedOfflineConversionDataSet',
    value: function createContainedOfflineConversionDataSet(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_offline_conversion_data_sets', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedPages',
    value: function deleteContainedPages() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_pages', params);
    }
  }, {
    key: 'getContainedPages',
    value: function getContainedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/contained_pages');
    }
  }, {
    key: 'createContainedPage',
    value: function createContainedPage(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_pages', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedPixels',
    value: function deleteContainedPixels() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_pixels', params);
    }
  }, {
    key: 'getContainedPixels',
    value: function getContainedPixels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixel, fields, params, fetchFirstPage, '/contained_pixels');
    }
  }, {
    key: 'createContainedPixel',
    value: function createContainedPixel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_pixels', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'deleteContainedProductCatalogs',
    value: function deleteContainedProductCatalogs() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'deleteEdge', this).call(this, '/contained_product_catalogs', params);
    }
  }, {
    key: 'getContainedProductCatalogs',
    value: function getContainedProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/contained_product_catalogs');
    }
  }, {
    key: 'createContainedProductCatalog',
    value: function createContainedProductCatalog(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/contained_product_catalogs', fields, params, BusinessAssetGroup, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(BusinessAssetGroup.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetGroup.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name',
        owner_business: 'owner_business'
      });
    }
  }, {
    key: 'AdaccountTasks',
    get: function get() {
      return Object.freeze({
        aa_analyze: 'AA_ANALYZE',
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        draft: 'DRAFT',
        manage: 'MANAGE'
      });
    }
  }, {
    key: 'OfflineConversionDataSetTasks',
    get: function get() {
      return Object.freeze({
        aa_analyze: 'AA_ANALYZE',
        advertise: 'ADVERTISE',
        manage: 'MANAGE',
        upload: 'UPLOAD',
        view: 'VIEW'
      });
    }
  }, {
    key: 'PageTasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        cashier_role: 'CASHIER_ROLE',
        create_content: 'CREATE_CONTENT',
        manage: 'MANAGE',
        manage_jobs: 'MANAGE_JOBS',
        manage_leads: 'MANAGE_LEADS',
        messaging: 'MESSAGING',
        moderate: 'MODERATE',
        moderate_community: 'MODERATE_COMMUNITY',
        pages_messaging: 'PAGES_MESSAGING',
        pages_messaging_subscriptions: 'PAGES_MESSAGING_SUBSCRIPTIONS',
        profile_plus_advertise: 'PROFILE_PLUS_ADVERTISE',
        profile_plus_analyze: 'PROFILE_PLUS_ANALYZE',
        profile_plus_create_content: 'PROFILE_PLUS_CREATE_CONTENT',
        profile_plus_facebook_access: 'PROFILE_PLUS_FACEBOOK_ACCESS',
        profile_plus_full_control: 'PROFILE_PLUS_FULL_CONTROL',
        profile_plus_manage: 'PROFILE_PLUS_MANAGE',
        profile_plus_manage_leads: 'PROFILE_PLUS_MANAGE_LEADS',
        profile_plus_messaging: 'PROFILE_PLUS_MESSAGING',
        profile_plus_moderate: 'PROFILE_PLUS_MODERATE',
        profile_plus_moderate_delegate_community: 'PROFILE_PLUS_MODERATE_DELEGATE_COMMUNITY',
        profile_plus_revenue: 'PROFILE_PLUS_REVENUE',
        read_page_mailboxes: 'READ_PAGE_MAILBOXES',
        view_monetization_insights: 'VIEW_MONETIZATION_INSIGHTS'
      });
    }
  }, {
    key: 'PixelTasks',
    get: function get() {
      return Object.freeze({
        aa_analyze: 'AA_ANALYZE',
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        edit: 'EDIT',
        upload: 'UPLOAD'
      });
    }
  }]);
  return BusinessAssetGroup;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OmegaCustomerTrx
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OmegaCustomerTrx = function (_AbstractCrudObject) {
  inherits(OmegaCustomerTrx, _AbstractCrudObject);

  function OmegaCustomerTrx() {
    classCallCheck(this, OmegaCustomerTrx);
    return possibleConstructorReturn(this, (OmegaCustomerTrx.__proto__ || Object.getPrototypeOf(OmegaCustomerTrx)).apply(this, arguments));
  }

  createClass(OmegaCustomerTrx, [{
    key: 'getCampaigns',
    value: function getCampaigns(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/campaigns');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_account_ids: 'ad_account_ids',
        advertiser_name: 'advertiser_name',
        amount: 'amount',
        amount_due: 'amount_due',
        billed_amount_details: 'billed_amount_details',
        billing_period: 'billing_period',
        cdn_download_uri: 'cdn_download_uri',
        currency: 'currency',
        download_uri: 'download_uri',
        due_date: 'due_date',
        entity: 'entity',
        id: 'id',
        invoice_date: 'invoice_date',
        invoice_id: 'invoice_id',
        invoice_type: 'invoice_type',
        liability_type: 'liability_type',
        payment_status: 'payment_status',
        payment_term: 'payment_term',
        type: 'type'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        cm: 'CM',
        dm: 'DM',
        inv: 'INV',
        pro_forma: 'PRO_FORMA'
      });
    }
  }]);
  return OmegaCustomerTrx;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WhatsAppBusinessAccount
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WhatsAppBusinessAccount = function (_AbstractCrudObject) {
  inherits(WhatsAppBusinessAccount, _AbstractCrudObject);

  function WhatsAppBusinessAccount() {
    classCallCheck(this, WhatsAppBusinessAccount);
    return possibleConstructorReturn(this, (WhatsAppBusinessAccount.__proto__ || Object.getPrototypeOf(WhatsAppBusinessAccount)).apply(this, arguments));
  }

  createClass(WhatsAppBusinessAccount, [{
    key: 'deleteAssignedUsers',
    value: function deleteAssignedUsers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(WhatsAppBusinessAccount.prototype.__proto__ || Object.getPrototypeOf(WhatsAppBusinessAccount.prototype), 'deleteEdge', this).call(this, '/assigned_users', params);
    }
  }, {
    key: 'getAssignedUsers',
    value: function getAssignedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AssignedUser, fields, params, fetchFirstPage, '/assigned_users');
    }
  }, {
    key: 'createAssignedUser',
    value: function createAssignedUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assigned_users', fields, params, WhatsAppBusinessAccount, pathOverride);
    }
  }, {
    key: 'getAudiences',
    value: function getAudiences(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/audiences');
    }
  }, {
    key: 'getConversationAnalytics',
    value: function getConversationAnalytics(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/conversation_analytics');
    }
  }, {
    key: 'getExtensions',
    value: function getExtensions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/extensions');
    }
  }, {
    key: 'deleteMessageTemplates',
    value: function deleteMessageTemplates() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(WhatsAppBusinessAccount.prototype.__proto__ || Object.getPrototypeOf(WhatsAppBusinessAccount.prototype), 'deleteEdge', this).call(this, '/message_templates', params);
    }
  }, {
    key: 'getMessageTemplates',
    value: function getMessageTemplates(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/message_templates');
    }
  }, {
    key: 'createMessageTemplate',
    value: function createMessageTemplate(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/message_templates', fields, params, WhatsAppBusinessAccount, pathOverride);
    }
  }, {
    key: 'getPhoneNumbers',
    value: function getPhoneNumbers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/phone_numbers');
    }
  }, {
    key: 'createPhoneNumber',
    value: function createPhoneNumber(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/phone_numbers', fields, params, null, pathOverride);
    }
  }, {
    key: 'deleteProductCatalogs',
    value: function deleteProductCatalogs() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(WhatsAppBusinessAccount.prototype.__proto__ || Object.getPrototypeOf(WhatsAppBusinessAccount.prototype), 'deleteEdge', this).call(this, '/product_catalogs', params);
    }
  }, {
    key: 'getProductCatalogs',
    value: function getProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/product_catalogs');
    }
  }, {
    key: 'createProductCatalog',
    value: function createProductCatalog(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_catalogs', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getSchedules',
    value: function getSchedules(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/schedules');
    }
  }, {
    key: 'deleteSubscribedApps',
    value: function deleteSubscribedApps() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(WhatsAppBusinessAccount.prototype.__proto__ || Object.getPrototypeOf(WhatsAppBusinessAccount.prototype), 'deleteEdge', this).call(this, '/subscribed_apps', params);
    }
  }, {
    key: 'getSubscribedApps',
    value: function getSubscribedApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/subscribed_apps');
    }
  }, {
    key: 'createSubscribedApp',
    value: function createSubscribedApp(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/subscribed_apps', fields, params, WhatsAppBusinessAccount, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_review_status: 'account_review_status',
        analytics: 'analytics',
        business_verification_status: 'business_verification_status',
        country: 'country',
        creation_time: 'creation_time',
        currency: 'currency',
        id: 'id',
        message_template_namespace: 'message_template_namespace',
        name: 'name',
        on_behalf_of_business_info: 'on_behalf_of_business_info',
        owner_business: 'owner_business',
        owner_business_info: 'owner_business_info',
        ownership_type: 'ownership_type',
        primary_funding_id: 'primary_funding_id',
        purchase_order_number: 'purchase_order_number',
        status: 'status',
        timezone_id: 'timezone_id'
      });
    }
  }, {
    key: 'Tasks',
    get: function get() {
      return Object.freeze({
        develop: 'DEVELOP',
        full_control: 'FULL_CONTROL',
        manage: 'MANAGE',
        manage_extensions: 'MANAGE_EXTENSIONS',
        manage_phone: 'MANAGE_PHONE',
        manage_templates: 'MANAGE_TEMPLATES',
        messaging: 'MESSAGING',
        view_cost: 'VIEW_COST'
      });
    }
  }, {
    key: 'Category',
    get: function get() {
      return Object.freeze({
        authentication: 'AUTHENTICATION',
        marketing: 'MARKETING',
        utility: 'UTILITY'
      });
    }
  }]);
  return WhatsAppBusinessAccount;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CPASCollaborationRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CPASCollaborationRequest = function (_AbstractCrudObject) {
  inherits(CPASCollaborationRequest, _AbstractCrudObject);

  function CPASCollaborationRequest() {
    classCallCheck(this, CPASCollaborationRequest);
    return possibleConstructorReturn(this, (CPASCollaborationRequest.__proto__ || Object.getPrototypeOf(CPASCollaborationRequest)).apply(this, arguments));
  }

  createClass(CPASCollaborationRequest, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        brands: 'brands',
        contact_email: 'contact_email',
        contact_first_name: 'contact_first_name',
        contact_last_name: 'contact_last_name',
        id: 'id',
        phone_number: 'phone_number',
        receiver_business: 'receiver_business',
        requester_agency_or_brand: 'requester_agency_or_brand',
        sender_client_business: 'sender_client_business',
        status: 'status'
      });
    }
  }, {
    key: 'RequesterAgencyOrBrand',
    get: function get() {
      return Object.freeze({
        agency: 'AGENCY',
        brand: 'BRAND',
        merchant: 'MERCHANT'
      });
    }
  }]);
  return CPASCollaborationRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CPASAdvertiserPartnershipRecommendation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CPASAdvertiserPartnershipRecommendation = function (_AbstractCrudObject) {
  inherits(CPASAdvertiserPartnershipRecommendation, _AbstractCrudObject);

  function CPASAdvertiserPartnershipRecommendation() {
    classCallCheck(this, CPASAdvertiserPartnershipRecommendation);
    return possibleConstructorReturn(this, (CPASAdvertiserPartnershipRecommendation.__proto__ || Object.getPrototypeOf(CPASAdvertiserPartnershipRecommendation)).apply(this, arguments));
  }

  createClass(CPASAdvertiserPartnershipRecommendation, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        advertiser_business_id: 'advertiser_business_id',
        brand_business_id: 'brand_business_id',
        brands: 'brands',
        countries: 'countries',
        id: 'id',
        merchant_business_id: 'merchant_business_id',
        merchant_categories: 'merchant_categories',
        status: 'status',
        status_reason: 'status_reason'
      });
    }
  }]);
  return CPASAdvertiserPartnershipRecommendation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CPASBusinessSetupConfig
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CPASBusinessSetupConfig = function (_AbstractCrudObject) {
  inherits(CPASBusinessSetupConfig, _AbstractCrudObject);

  function CPASBusinessSetupConfig() {
    classCallCheck(this, CPASBusinessSetupConfig);
    return possibleConstructorReturn(this, (CPASBusinessSetupConfig.__proto__ || Object.getPrototypeOf(CPASBusinessSetupConfig)).apply(this, arguments));
  }

  createClass(CPASBusinessSetupConfig, [{
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/ad_accounts');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        accepted_collab_ads_tos: 'accepted_collab_ads_tos',
        business: 'business',
        business_capabilities_status: 'business_capabilities_status',
        capabilities_compliance_status: 'capabilities_compliance_status',
        id: 'id'
      });
    }
  }]);
  return CPASBusinessSetupConfig;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CPASMerchantConfig
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CPASMerchantConfig = function (_AbstractCrudObject) {
  inherits(CPASMerchantConfig, _AbstractCrudObject);

  function CPASMerchantConfig() {
    classCallCheck(this, CPASMerchantConfig);
    return possibleConstructorReturn(this, (CPASMerchantConfig.__proto__ || Object.getPrototypeOf(CPASMerchantConfig)).apply(this, arguments));
  }

  createClass(CPASMerchantConfig, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        accepted_tos: 'accepted_tos',
        beta_features: 'beta_features',
        business_outcomes_status: 'business_outcomes_status',
        id: 'id',
        is_test_merchant: 'is_test_merchant',
        outcomes_compliance_status: 'outcomes_compliance_status',
        qualified_to_onboard: 'qualified_to_onboard'
      });
    }
  }]);
  return CPASMerchantConfig;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CreditCard
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CreditCard = function (_AbstractCrudObject) {
  inherits(CreditCard, _AbstractCrudObject);

  function CreditCard() {
    classCallCheck(this, CreditCard);
    return possibleConstructorReturn(this, (CreditCard.__proto__ || Object.getPrototypeOf(CreditCard)).apply(this, arguments));
  }

  createClass(CreditCard, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        billing_address: 'billing_address',
        card_cobadging: 'card_cobadging',
        card_holder_name: 'card_holder_name',
        card_type: 'card_type',
        credential_id: 'credential_id',
        default_receiving_method_products: 'default_receiving_method_products',
        expiry_month: 'expiry_month',
        expiry_year: 'expiry_year',
        id: 'id',
        is_cvv_tricky_bin: 'is_cvv_tricky_bin',
        is_enabled: 'is_enabled',
        is_last_used: 'is_last_used',
        is_network_tokenized_in_india: 'is_network_tokenized_in_india',
        is_soft_disabled: 'is_soft_disabled',
        is_user_verified: 'is_user_verified',
        is_zip_verified: 'is_zip_verified',
        last4: 'last4',
        readable_card_type: 'readable_card_type',
        time_created: 'time_created',
        time_created_ts: 'time_created_ts',
        type: 'type'
      });
    }
  }]);
  return CreditCard;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * EventSourceGroup
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var EventSourceGroup = function (_AbstractCrudObject) {
  inherits(EventSourceGroup, _AbstractCrudObject);

  function EventSourceGroup() {
    classCallCheck(this, EventSourceGroup);
    return possibleConstructorReturn(this, (EventSourceGroup.__proto__ || Object.getPrototypeOf(EventSourceGroup)).apply(this, arguments));
  }

  createClass(EventSourceGroup, [{
    key: 'getSharedAccounts',
    value: function getSharedAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/shared_accounts');
    }
  }, {
    key: 'createSharedAccount',
    value: function createSharedAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/shared_accounts', fields, params, EventSourceGroup, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(EventSourceGroup.prototype.__proto__ || Object.getPrototypeOf(EventSourceGroup.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business: 'business',
        event_sources: 'event_sources',
        id: 'id',
        name: 'name',
        owner_business: 'owner_business'
      });
    }
  }]);
  return EventSourceGroup;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ExtendedCreditInvoiceGroup
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ExtendedCreditInvoiceGroup = function (_AbstractCrudObject) {
  inherits(ExtendedCreditInvoiceGroup, _AbstractCrudObject);

  function ExtendedCreditInvoiceGroup() {
    classCallCheck(this, ExtendedCreditInvoiceGroup);
    return possibleConstructorReturn(this, (ExtendedCreditInvoiceGroup.__proto__ || Object.getPrototypeOf(ExtendedCreditInvoiceGroup)).apply(this, arguments));
  }

  createClass(ExtendedCreditInvoiceGroup, [{
    key: 'deleteAdAccounts',
    value: function deleteAdAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(ExtendedCreditInvoiceGroup.prototype.__proto__ || Object.getPrototypeOf(ExtendedCreditInvoiceGroup.prototype), 'deleteEdge', this).call(this, '/ad_accounts', params);
    }
  }, {
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/ad_accounts');
    }
  }, {
    key: 'createAdAccount',
    value: function createAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/ad_accounts', fields, params, AdAccount, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ExtendedCreditInvoiceGroup.prototype.__proto__ || Object.getPrototypeOf(ExtendedCreditInvoiceGroup.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        auto_enroll: 'auto_enroll',
        bill_to_address: 'bill_to_address',
        customer_po_number: 'customer_po_number',
        email: 'email',
        emails: 'emails',
        id: 'id',
        liable_address: 'liable_address',
        name: 'name',
        sold_to_address: 'sold_to_address'
      });
    }
  }]);
  return ExtendedCreditInvoiceGroup;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ExtendedCreditAllocationConfig
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ExtendedCreditAllocationConfig = function (_AbstractCrudObject) {
  inherits(ExtendedCreditAllocationConfig, _AbstractCrudObject);

  function ExtendedCreditAllocationConfig() {
    classCallCheck(this, ExtendedCreditAllocationConfig);
    return possibleConstructorReturn(this, (ExtendedCreditAllocationConfig.__proto__ || Object.getPrototypeOf(ExtendedCreditAllocationConfig)).apply(this, arguments));
  }

  createClass(ExtendedCreditAllocationConfig, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ExtendedCreditAllocationConfig.prototype.__proto__ || Object.getPrototypeOf(ExtendedCreditAllocationConfig.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(ExtendedCreditAllocationConfig.prototype.__proto__ || Object.getPrototypeOf(ExtendedCreditAllocationConfig.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        currency_amount: 'currency_amount',
        id: 'id',
        liability_type: 'liability_type',
        owning_business: 'owning_business',
        owning_credential: 'owning_credential',
        partition_type: 'partition_type',
        receiving_business: 'receiving_business',
        receiving_credential: 'receiving_credential',
        request_status: 'request_status',
        send_bill_to: 'send_bill_to'
      });
    }
  }, {
    key: 'LiabilityType',
    get: function get() {
      return Object.freeze({
        msa: 'MSA',
        normal: 'Normal',
        sequential: 'Sequential'
      });
    }
  }, {
    key: 'PartitionType',
    get: function get() {
      return Object.freeze({
        auth: 'AUTH',
        fixed: 'FIXED'
      });
    }
  }, {
    key: 'SendBillTo',
    get: function get() {
      return Object.freeze({
        advertiser: 'Advertiser',
        agency: 'Agency'
      });
    }
  }]);
  return ExtendedCreditAllocationConfig;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ExtendedCredit
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ExtendedCredit = function (_AbstractCrudObject) {
  inherits(ExtendedCredit, _AbstractCrudObject);

  function ExtendedCredit() {
    classCallCheck(this, ExtendedCredit);
    return possibleConstructorReturn(this, (ExtendedCredit.__proto__ || Object.getPrototypeOf(ExtendedCredit)).apply(this, arguments));
  }

  createClass(ExtendedCredit, [{
    key: 'getExtendedCreditInvoiceGroups',
    value: function getExtendedCreditInvoiceGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ExtendedCreditInvoiceGroup, fields, params, fetchFirstPage, '/extended_credit_invoice_groups');
    }
  }, {
    key: 'createExtendedCreditInvoiceGroup',
    value: function createExtendedCreditInvoiceGroup(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/extended_credit_invoice_groups', fields, params, ExtendedCreditInvoiceGroup, pathOverride);
    }
  }, {
    key: 'getOwningCreditAllocationConfigs',
    value: function getOwningCreditAllocationConfigs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ExtendedCreditAllocationConfig, fields, params, fetchFirstPage, '/owning_credit_allocation_configs');
    }
  }, {
    key: 'createOwningCreditAllocationConfig',
    value: function createOwningCreditAllocationConfig(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/owning_credit_allocation_configs', fields, params, ExtendedCreditAllocationConfig, pathOverride);
    }
  }, {
    key: 'createWhatsappCreditSharingAndAttach',
    value: function createWhatsappCreditSharingAndAttach(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/whatsapp_credit_sharing_and_attach', fields, params, null, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        allocated_amount: 'allocated_amount',
        balance: 'balance',
        credit_available: 'credit_available',
        credit_type: 'credit_type',
        id: 'id',
        is_access_revoked: 'is_access_revoked',
        is_automated_experience: 'is_automated_experience',
        legal_entity_name: 'legal_entity_name',
        liable_address: 'liable_address',
        liable_biz_name: 'liable_biz_name',
        max_balance: 'max_balance',
        online_max_balance: 'online_max_balance',
        owner_business: 'owner_business',
        owner_business_name: 'owner_business_name',
        partition_from: 'partition_from',
        receiving_credit_allocation_config: 'receiving_credit_allocation_config',
        send_bill_to_address: 'send_bill_to_address',
        send_bill_to_biz_name: 'send_bill_to_biz_name',
        sold_to_address: 'sold_to_address'
      });
    }
  }]);
  return ExtendedCredit;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessAssetSharingAgreement
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessAssetSharingAgreement = function (_AbstractCrudObject) {
  inherits(BusinessAssetSharingAgreement, _AbstractCrudObject);

  function BusinessAssetSharingAgreement() {
    classCallCheck(this, BusinessAssetSharingAgreement);
    return possibleConstructorReturn(this, (BusinessAssetSharingAgreement.__proto__ || Object.getPrototypeOf(BusinessAssetSharingAgreement)).apply(this, arguments));
  }

  createClass(BusinessAssetSharingAgreement, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(BusinessAssetSharingAgreement.prototype.__proto__ || Object.getPrototypeOf(BusinessAssetSharingAgreement.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        initiator: 'initiator',
        recipient: 'recipient',
        relationship_type: 'relationship_type',
        request_status: 'request_status',
        request_type: 'request_type'
      });
    }
  }, {
    key: 'RequestStatus',
    get: function get() {
      return Object.freeze({
        approve: 'APPROVE',
        decline: 'DECLINE',
        expired: 'EXPIRED',
        in_progress: 'IN_PROGRESS',
        pending: 'PENDING',
        pending_email_verification: 'PENDING_EMAIL_VERIFICATION',
        pending_integrity_review: 'PENDING_INTEGRITY_REVIEW'
      });
    }
  }]);
  return BusinessAssetSharingAgreement;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InstagramInsightsResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InstagramInsightsResult = function (_AbstractCrudObject) {
  inherits(InstagramInsightsResult, _AbstractCrudObject);

  function InstagramInsightsResult() {
    classCallCheck(this, InstagramInsightsResult);
    return possibleConstructorReturn(this, (InstagramInsightsResult.__proto__ || Object.getPrototypeOf(InstagramInsightsResult)).apply(this, arguments));
  }

  createClass(InstagramInsightsResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        description: 'description',
        id: 'id',
        name: 'name',
        period: 'period',
        title: 'title',
        total_value: 'total_value',
        values: 'values'
      });
    }
  }, {
    key: 'Breakdown',
    get: function get() {
      return Object.freeze({
        action_type: 'action_type',
        follow_type: 'follow_type',
        story_navigation_action_type: 'story_navigation_action_type',
        surface_type: 'surface_type'
      });
    }
  }, {
    key: 'Metric',
    get: function get() {
      return Object.freeze({
        carousel_album_engagement: 'carousel_album_engagement',
        carousel_album_impressions: 'carousel_album_impressions',
        carousel_album_reach: 'carousel_album_reach',
        carousel_album_saved: 'carousel_album_saved',
        carousel_album_video_views: 'carousel_album_video_views',
        comments: 'comments',
        engagement: 'engagement',
        exits: 'exits',
        follows: 'follows',
        impressions: 'impressions',
        likes: 'likes',
        navigation: 'navigation',
        plays: 'plays',
        profile_activity: 'profile_activity',
        profile_visits: 'profile_visits',
        reach: 'reach',
        replies: 'replies',
        saved: 'saved',
        shares: 'shares',
        taps_back: 'taps_back',
        taps_forward: 'taps_forward',
        total_interactions: 'total_interactions',
        video_views: 'video_views'
      });
    }
  }, {
    key: 'Period',
    get: function get() {
      return Object.freeze({
        day: 'day',
        days_28: 'days_28',
        lifetime: 'lifetime',
        month: 'month',
        total_over_range: 'total_over_range',
        week: 'week'
      });
    }
  }, {
    key: 'MetricType',
    get: function get() {
      return Object.freeze({
        default: 'default',
        time_series: 'time_series',
        total_value: 'total_value'
      });
    }
  }, {
    key: 'Timeframe',
    get: function get() {
      return Object.freeze({
        last_14_days: 'last_14_days',
        last_30_days: 'last_30_days',
        last_90_days: 'last_90_days',
        prev_month: 'prev_month',
        this_month: 'this_month',
        this_week: 'this_week'
      });
    }
  }]);
  return InstagramInsightsResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * IGComment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var IGComment = function (_AbstractCrudObject) {
  inherits(IGComment, _AbstractCrudObject);

  function IGComment() {
    classCallCheck(this, IGComment);
    return possibleConstructorReturn(this, (IGComment.__proto__ || Object.getPrototypeOf(IGComment)).apply(this, arguments));
  }

  createClass(IGComment, [{
    key: 'getReplies',
    value: function getReplies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGComment, fields, params, fetchFirstPage, '/replies');
    }
  }, {
    key: 'createReply',
    value: function createReply(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/replies', fields, params, IGComment, pathOverride);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(IGComment.prototype.__proto__ || Object.getPrototypeOf(IGComment.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(IGComment.prototype.__proto__ || Object.getPrototypeOf(IGComment.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        from: 'from',
        hidden: 'hidden',
        id: 'id',
        like_count: 'like_count',
        media: 'media',
        parent_id: 'parent_id',
        text: 'text',
        timestamp: 'timestamp',
        user: 'user',
        username: 'username'
      });
    }
  }]);
  return IGComment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ShadowIGMediaProductTags
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ShadowIGMediaProductTags = function (_AbstractCrudObject) {
  inherits(ShadowIGMediaProductTags, _AbstractCrudObject);

  function ShadowIGMediaProductTags() {
    classCallCheck(this, ShadowIGMediaProductTags);
    return possibleConstructorReturn(this, (ShadowIGMediaProductTags.__proto__ || Object.getPrototypeOf(ShadowIGMediaProductTags)).apply(this, arguments));
  }

  createClass(ShadowIGMediaProductTags, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        image_url: 'image_url',
        is_checkout: 'is_checkout',
        merchant_id: 'merchant_id',
        name: 'name',
        price_string: 'price_string',
        product_id: 'product_id',
        review_status: 'review_status',
        stripped_price_string: 'stripped_price_string',
        stripped_sale_price_string: 'stripped_sale_price_string',
        x: 'x',
        y: 'y'
      });
    }
  }]);
  return ShadowIGMediaProductTags;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * IGMedia
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var IGMedia = function (_AbstractCrudObject) {
  inherits(IGMedia, _AbstractCrudObject);

  function IGMedia() {
    classCallCheck(this, IGMedia);
    return possibleConstructorReturn(this, (IGMedia.__proto__ || Object.getPrototypeOf(IGMedia)).apply(this, arguments));
  }

  createClass(IGMedia, [{
    key: 'getChildren',
    value: function getChildren(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGMedia, fields, params, fetchFirstPage, '/children');
    }
  }, {
    key: 'getComments',
    value: function getComments(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGComment, fields, params, fetchFirstPage, '/comments');
    }
  }, {
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, IGComment, pathOverride);
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramInsightsResult, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'deleteProductTags',
    value: function deleteProductTags() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(IGMedia.prototype.__proto__ || Object.getPrototypeOf(IGMedia.prototype), 'deleteEdge', this).call(this, '/product_tags', params);
    }
  }, {
    key: 'getProductTags',
    value: function getProductTags(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ShadowIGMediaProductTags, fields, params, fetchFirstPage, '/product_tags');
    }
  }, {
    key: 'createProductTag',
    value: function createProductTag(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_tags', fields, params, ShadowIGMediaProductTags, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(IGMedia.prototype.__proto__ || Object.getPrototypeOf(IGMedia.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        caption: 'caption',
        comments_count: 'comments_count',
        id: 'id',
        ig_id: 'ig_id',
        is_comment_enabled: 'is_comment_enabled',
        is_shared_to_feed: 'is_shared_to_feed',
        like_count: 'like_count',
        media_product_type: 'media_product_type',
        media_type: 'media_type',
        media_url: 'media_url',
        owner: 'owner',
        permalink: 'permalink',
        shortcode: 'shortcode',
        thumbnail_url: 'thumbnail_url',
        timestamp: 'timestamp',
        username: 'username'
      });
    }
  }]);
  return IGMedia;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * IGUser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var IGUser = function (_AbstractCrudObject) {
  inherits(IGUser, _AbstractCrudObject);

  function IGUser() {
    classCallCheck(this, IGUser);
    return possibleConstructorReturn(this, (IGUser.__proto__ || Object.getPrototypeOf(IGUser)).apply(this, arguments));
  }

  createClass(IGUser, [{
    key: 'getAvailableCatalogs',
    value: function getAvailableCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/available_catalogs');
    }
  }, {
    key: 'getCatalogProductSearch',
    value: function getCatalogProductSearch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/catalog_product_search');
    }
  }, {
    key: 'getContentPublishingLimit',
    value: function getContentPublishingLimit(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/content_publishing_limit');
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramInsightsResult, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getLiveMedia',
    value: function getLiveMedia(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGMedia, fields, params, fetchFirstPage, '/live_media');
    }
  }, {
    key: 'getMedia',
    value: function getMedia(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGMedia, fields, params, fetchFirstPage, '/media');
    }
  }, {
    key: 'createMedia',
    value: function createMedia(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/media', fields, params, IGMedia, pathOverride);
    }
  }, {
    key: 'createMediaPublish',
    value: function createMediaPublish(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/media_publish', fields, params, IGMedia, pathOverride);
    }
  }, {
    key: 'createMention',
    value: function createMention(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/mentions', fields, params, null, pathOverride);
    }
  }, {
    key: 'getNotificationMessageTokens',
    value: function getNotificationMessageTokens(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(UserPageOneTimeOptInTokenSettings, fields, params, fetchFirstPage, '/notification_message_tokens');
    }
  }, {
    key: 'getProductAppeal',
    value: function getProductAppeal(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/product_appeal');
    }
  }, {
    key: 'createProductAppeal',
    value: function createProductAppeal(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_appeal', fields, params, null, pathOverride);
    }
  }, {
    key: 'getRecentlySearchedHashtags',
    value: function getRecentlySearchedHashtags(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/recently_searched_hashtags');
    }
  }, {
    key: 'getStories',
    value: function getStories(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGMedia, fields, params, fetchFirstPage, '/stories');
    }
  }, {
    key: 'getTags',
    value: function getTags(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGMedia, fields, params, fetchFirstPage, '/tags');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        biography: 'biography',
        business_discovery: 'business_discovery',
        followers_count: 'followers_count',
        follows_count: 'follows_count',
        id: 'id',
        ig_id: 'ig_id',
        media_count: 'media_count',
        mentioned_comment: 'mentioned_comment',
        mentioned_media: 'mentioned_media',
        name: 'name',
        owner_business: 'owner_business',
        profile_picture_url: 'profile_picture_url',
        shopping_product_tag_eligibility: 'shopping_product_tag_eligibility',
        shopping_review_status: 'shopping_review_status',
        username: 'username',
        website: 'website'
      });
    }
  }]);
  return IGUser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessAdAccountRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessAdAccountRequest = function (_AbstractCrudObject) {
  inherits(BusinessAdAccountRequest, _AbstractCrudObject);

  function BusinessAdAccountRequest() {
    classCallCheck(this, BusinessAdAccountRequest);
    return possibleConstructorReturn(this, (BusinessAdAccountRequest.__proto__ || Object.getPrototypeOf(BusinessAdAccountRequest)).apply(this, arguments));
  }

  createClass(BusinessAdAccountRequest, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_account: 'ad_account',
        id: 'id'
      });
    }
  }]);
  return BusinessAdAccountRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessApplicationRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessApplicationRequest = function (_AbstractCrudObject) {
  inherits(BusinessApplicationRequest, _AbstractCrudObject);

  function BusinessApplicationRequest() {
    classCallCheck(this, BusinessApplicationRequest);
    return possibleConstructorReturn(this, (BusinessApplicationRequest.__proto__ || Object.getPrototypeOf(BusinessApplicationRequest)).apply(this, arguments));
  }

  createClass(BusinessApplicationRequest, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        application: 'application',
        id: 'id'
      });
    }
  }]);
  return BusinessApplicationRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessPageRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessPageRequest = function (_AbstractCrudObject) {
  inherits(BusinessPageRequest, _AbstractCrudObject);

  function BusinessPageRequest() {
    classCallCheck(this, BusinessPageRequest);
    return possibleConstructorReturn(this, (BusinessPageRequest.__proto__ || Object.getPrototypeOf(BusinessPageRequest)).apply(this, arguments));
  }

  createClass(BusinessPageRequest, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        page: 'page'
      });
    }
  }]);
  return BusinessPageRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessRoleRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessRoleRequest = function (_AbstractCrudObject) {
  inherits(BusinessRoleRequest, _AbstractCrudObject);

  function BusinessRoleRequest() {
    classCallCheck(this, BusinessRoleRequest);
    return possibleConstructorReturn(this, (BusinessRoleRequest.__proto__ || Object.getPrototypeOf(BusinessRoleRequest)).apply(this, arguments));
  }

  createClass(BusinessRoleRequest, [{
    key: 'delete',


    // $FlowFixMe : Support Generic Types
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(BusinessRoleRequest.prototype.__proto__ || Object.getPrototypeOf(BusinessRoleRequest.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(BusinessRoleRequest.prototype.__proto__ || Object.getPrototypeOf(BusinessRoleRequest.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        created_by: 'created_by',
        created_time: 'created_time',
        email: 'email',
        expiration_time: 'expiration_time',
        expiry_time: 'expiry_time',
        finance_role: 'finance_role',
        id: 'id',
        invite_link: 'invite_link',
        ip_role: 'ip_role',
        owner: 'owner',
        role: 'role',
        status: 'status',
        updated_by: 'updated_by',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'Role',
    get: function get() {
      return Object.freeze({
        admin: 'ADMIN',
        ads_rights_reviewer: 'ADS_RIGHTS_REVIEWER',
        default: 'DEFAULT',
        developer: 'DEVELOPER',
        employee: 'EMPLOYEE',
        finance_analyst: 'FINANCE_ANALYST',
        finance_edit: 'FINANCE_EDIT',
        finance_editor: 'FINANCE_EDITOR',
        finance_view: 'FINANCE_VIEW',
        manage: 'MANAGE',
        partner_center_admin: 'PARTNER_CENTER_ADMIN',
        partner_center_analyst: 'PARTNER_CENTER_ANALYST',
        partner_center_education: 'PARTNER_CENTER_EDUCATION',
        partner_center_marketing: 'PARTNER_CENTER_MARKETING',
        partner_center_operations: 'PARTNER_CENTER_OPERATIONS'
      });
    }
  }]);
  return BusinessRoleRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * SystemUser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var SystemUser = function (_AbstractCrudObject) {
  inherits(SystemUser, _AbstractCrudObject);

  function SystemUser() {
    classCallCheck(this, SystemUser);
    return possibleConstructorReturn(this, (SystemUser.__proto__ || Object.getPrototypeOf(SystemUser)).apply(this, arguments));
  }

  createClass(SystemUser, [{
    key: 'getAssignedAdAccounts',
    value: function getAssignedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/assigned_ad_accounts');
    }
  }, {
    key: 'getAssignedBusinessAssetGroups',
    value: function getAssignedBusinessAssetGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAssetGroup, fields, params, fetchFirstPage, '/assigned_business_asset_groups');
    }
  }, {
    key: 'getAssignedPages',
    value: function getAssignedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/assigned_pages');
    }
  }, {
    key: 'getAssignedProductCatalogs',
    value: function getAssignedProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/assigned_product_catalogs');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        created_by: 'created_by',
        created_time: 'created_time',
        finance_permission: 'finance_permission',
        id: 'id',
        ip_permission: 'ip_permission',
        name: 'name'
      });
    }
  }, {
    key: 'Role',
    get: function get() {
      return Object.freeze({
        admin: 'ADMIN',
        ads_rights_reviewer: 'ADS_RIGHTS_REVIEWER',
        default: 'DEFAULT',
        developer: 'DEVELOPER',
        employee: 'EMPLOYEE',
        finance_analyst: 'FINANCE_ANALYST',
        finance_edit: 'FINANCE_EDIT',
        finance_editor: 'FINANCE_EDITOR',
        finance_view: 'FINANCE_VIEW',
        manage: 'MANAGE',
        partner_center_admin: 'PARTNER_CENTER_ADMIN',
        partner_center_analyst: 'PARTNER_CENTER_ANALYST',
        partner_center_education: 'PARTNER_CENTER_EDUCATION',
        partner_center_marketing: 'PARTNER_CENTER_MARKETING',
        partner_center_operations: 'PARTNER_CENTER_OPERATIONS'
      });
    }
  }]);
  return SystemUser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Business
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Business = function (_AbstractCrudObject) {
  inherits(Business, _AbstractCrudObject);

  function Business() {
    classCallCheck(this, Business);
    return possibleConstructorReturn(this, (Business.__proto__ || Object.getPrototypeOf(Business)).apply(this, arguments));
  }

  createClass(Business, [{
    key: 'createAccessToken',
    value: function createAccessToken(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/access_token', fields, params, Business, pathOverride);
    }
  }, {
    key: 'deleteAdAccounts',
    value: function deleteAdAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/ad_accounts', params);
    }
  }, {
    key: 'getAdStudies',
    value: function getAdStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudy, fields, params, fetchFirstPage, '/ad_studies');
    }
  }, {
    key: 'createAdStudy',
    value: function createAdStudy(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/ad_studies', fields, params, AdStudy, pathOverride);
    }
  }, {
    key: 'createAdAccount',
    value: function createAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adaccount', fields, params, AdAccount, pathOverride);
    }
  }, {
    key: 'createAdNetworkApplication',
    value: function createAdNetworkApplication(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adnetwork_applications', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getAdNetworkAnalytics',
    value: function getAdNetworkAnalytics(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdNetworkAnalyticsSyncQueryResult, fields, params, fetchFirstPage, '/adnetworkanalytics');
    }
  }, {
    key: 'createAdNetworkAnalytic',
    value: function createAdNetworkAnalytic(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adnetworkanalytics', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getAdNetworkAnalyticsResults',
    value: function getAdNetworkAnalyticsResults(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdNetworkAnalyticsAsyncQueryResult, fields, params, fetchFirstPage, '/adnetworkanalytics_results');
    }
  }, {
    key: 'getAdsReportingMmmReports',
    value: function getAdsReportingMmmReports(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ads_reporting_mmm_reports');
    }
  }, {
    key: 'getAdsReportingMmmSchedulers',
    value: function getAdsReportingMmmSchedulers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ads_reporting_mmm_schedulers');
    }
  }, {
    key: 'getAdsPixels',
    value: function getAdsPixels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixel, fields, params, fetchFirstPage, '/adspixels');
    }
  }, {
    key: 'createAdsPixel',
    value: function createAdsPixel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adspixels', fields, params, AdsPixel, pathOverride);
    }
  }, {
    key: 'deleteAgencies',
    value: function deleteAgencies() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/agencies', params);
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'getAnPlacements',
    value: function getAnPlacements(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdPlacement, fields, params, fetchFirstPage, '/an_placements');
    }
  }, {
    key: 'createBlockListDraft',
    value: function createBlockListDraft(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/block_list_drafts', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getBusinessAssetGroups',
    value: function getBusinessAssetGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAssetGroup, fields, params, fetchFirstPage, '/business_asset_groups');
    }
  }, {
    key: 'getBusinessInvoices',
    value: function getBusinessInvoices(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OmegaCustomerTrx, fields, params, fetchFirstPage, '/business_invoices');
    }
  }, {
    key: 'getBusinessUsers',
    value: function getBusinessUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessUser, fields, params, fetchFirstPage, '/business_users');
    }
  }, {
    key: 'createBusinessUser',
    value: function createBusinessUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/business_users', fields, params, BusinessUser, pathOverride);
    }
  }, {
    key: 'getBusinessProjects',
    value: function getBusinessProjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/businessprojects');
    }
  }, {
    key: 'createClaimCustomConversion',
    value: function createClaimCustomConversion(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/claim_custom_conversions', fields, params, CustomConversion, pathOverride);
    }
  }, {
    key: 'getClientAdAccounts',
    value: function getClientAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/client_ad_accounts');
    }
  }, {
    key: 'getClientApps',
    value: function getClientApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/client_apps');
    }
  }, {
    key: 'createClientApp',
    value: function createClientApp(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/client_apps', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getClientOffsiteSignalContainerBusinessObjects',
    value: function getClientOffsiteSignalContainerBusinessObjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/client_offsite_signal_container_business_objects');
    }
  }, {
    key: 'getClientPages',
    value: function getClientPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/client_pages');
    }
  }, {
    key: 'createClientPage',
    value: function createClientPage(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/client_pages', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getClientPixels',
    value: function getClientPixels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixel, fields, params, fetchFirstPage, '/client_pixels');
    }
  }, {
    key: 'getClientProductCatalogs',
    value: function getClientProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/client_product_catalogs');
    }
  }, {
    key: 'getClientWhatsAppBusinessAccounts',
    value: function getClientWhatsAppBusinessAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(WhatsAppBusinessAccount, fields, params, fetchFirstPage, '/client_whatsapp_business_accounts');
    }
  }, {
    key: 'deleteClients',
    value: function deleteClients() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/clients', params);
    }
  }, {
    key: 'getClients',
    value: function getClients(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/clients');
    }
  }, {
    key: 'getCollaborativeAdsCollaborationRequests',
    value: function getCollaborativeAdsCollaborationRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CPASCollaborationRequest, fields, params, fetchFirstPage, '/collaborative_ads_collaboration_requests');
    }
  }, {
    key: 'createCollaborativeAdsCollaborationRequest',
    value: function createCollaborativeAdsCollaborationRequest(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/collaborative_ads_collaboration_requests', fields, params, CPASCollaborationRequest, pathOverride);
    }
  }, {
    key: 'getCollaborativeAdsSuggestedPartners',
    value: function getCollaborativeAdsSuggestedPartners(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CPASAdvertiserPartnershipRecommendation, fields, params, fetchFirstPage, '/collaborative_ads_suggested_partners');
    }
  }, {
    key: 'getCommerceMerchantSettings',
    value: function getCommerceMerchantSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CommerceMerchantSettings, fields, params, fetchFirstPage, '/commerce_merchant_settings');
    }
  }, {
    key: 'getCpasBusinessSetupConfig',
    value: function getCpasBusinessSetupConfig(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CPASBusinessSetupConfig, fields, params, fetchFirstPage, '/cpas_business_setup_config');
    }
  }, {
    key: 'createCpasBusinessSetupConfig',
    value: function createCpasBusinessSetupConfig(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/cpas_business_setup_config', fields, params, CPASBusinessSetupConfig, pathOverride);
    }
  }, {
    key: 'getCpasMerchantConfig',
    value: function getCpasMerchantConfig(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CPASMerchantConfig, fields, params, fetchFirstPage, '/cpas_merchant_config');
    }
  }, {
    key: 'getCreditCards',
    value: function getCreditCards(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CreditCard, fields, params, fetchFirstPage, '/creditcards');
    }
  }, {
    key: 'createCustomConversion',
    value: function createCustomConversion(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/customconversions', fields, params, CustomConversion, pathOverride);
    }
  }, {
    key: 'createDraftNegativeKeywordList',
    value: function createDraftNegativeKeywordList(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/draft_negative_keyword_lists', fields, params, null, pathOverride);
    }
  }, {
    key: 'getEventSourceGroups',
    value: function getEventSourceGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(EventSourceGroup, fields, params, fetchFirstPage, '/event_source_groups');
    }
  }, {
    key: 'createEventSourceGroup',
    value: function createEventSourceGroup(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/event_source_groups', fields, params, EventSourceGroup, pathOverride);
    }
  }, {
    key: 'getExtendedCreditApplications',
    value: function getExtendedCreditApplications(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/extendedcreditapplications');
    }
  }, {
    key: 'getExtendedCredits',
    value: function getExtendedCredits(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ExtendedCredit, fields, params, fetchFirstPage, '/extendedcredits');
    }
  }, {
    key: 'getInitiatedAudienceSharingRequests',
    value: function getInitiatedAudienceSharingRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAssetSharingAgreement, fields, params, fetchFirstPage, '/initiated_audience_sharing_requests');
    }
  }, {
    key: 'deleteInstagramAccounts',
    value: function deleteInstagramAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/instagram_accounts', params);
    }
  }, {
    key: 'getInstagramAccounts',
    value: function getInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramUser, fields, params, fetchFirstPage, '/instagram_accounts');
    }
  }, {
    key: 'getInstagramBusinessAccounts',
    value: function getInstagramBusinessAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGUser, fields, params, fetchFirstPage, '/instagram_business_accounts');
    }
  }, {
    key: 'deleteManagedBusinesses',
    value: function deleteManagedBusinesses() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/managed_businesses', params);
    }
  }, {
    key: 'createManagedBusiness',
    value: function createManagedBusiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/managed_businesses', fields, params, Business, pathOverride);
    }
  }, {
    key: 'createManagedPartnerBusinessSetup',
    value: function createManagedPartnerBusinessSetup(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/managed_partner_business_setup', fields, params, Business, pathOverride);
    }
  }, {
    key: 'deleteManagedPartnerBusinesses',
    value: function deleteManagedPartnerBusinesses() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/managed_partner_businesses', params);
    }
  }, {
    key: 'createManagedPartnerBusiness',
    value: function createManagedPartnerBusiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/managed_partner_businesses', fields, params, null, pathOverride);
    }
  }, {
    key: 'getNegativeKeywordLists',
    value: function getNegativeKeywordLists(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/negative_keyword_lists');
    }
  }, {
    key: 'getOfflineConversionDataSets',
    value: function getOfflineConversionDataSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OfflineConversionDataSet, fields, params, fetchFirstPage, '/offline_conversion_data_sets');
    }
  }, {
    key: 'createOfflineConversionDataSet',
    value: function createOfflineConversionDataSet(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/offline_conversion_data_sets', fields, params, OfflineConversionDataSet, pathOverride);
    }
  }, {
    key: 'getOwnedAdAccounts',
    value: function getOwnedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/owned_ad_accounts');
    }
  }, {
    key: 'createOwnedAdAccount',
    value: function createOwnedAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/owned_ad_accounts', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getOwnedApps',
    value: function getOwnedApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/owned_apps');
    }
  }, {
    key: 'createOwnedApp',
    value: function createOwnedApp(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/owned_apps', fields, params, Business, pathOverride);
    }
  }, {
    key: 'deleteOwnedBusinesses',
    value: function deleteOwnedBusinesses() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/owned_businesses', params);
    }
  }, {
    key: 'getOwnedBusinesses',
    value: function getOwnedBusinesses(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/owned_businesses');
    }
  }, {
    key: 'createOwnedBusiness',
    value: function createOwnedBusiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/owned_businesses', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getOwnedInstagramAccounts',
    value: function getOwnedInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramUser, fields, params, fetchFirstPage, '/owned_instagram_accounts');
    }
  }, {
    key: 'getOwnedOffsiteSignalContainerBusinessObjects',
    value: function getOwnedOffsiteSignalContainerBusinessObjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/owned_offsite_signal_container_business_objects');
    }
  }, {
    key: 'getOwnedPages',
    value: function getOwnedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/owned_pages');
    }
  }, {
    key: 'createOwnedPage',
    value: function createOwnedPage(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/owned_pages', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getOwnedPixels',
    value: function getOwnedPixels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixel, fields, params, fetchFirstPage, '/owned_pixels');
    }
  }, {
    key: 'getOwnedProductCatalogs',
    value: function getOwnedProductCatalogs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProductCatalog, fields, params, fetchFirstPage, '/owned_product_catalogs');
    }
  }, {
    key: 'createOwnedProductCatalog',
    value: function createOwnedProductCatalog(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/owned_product_catalogs', fields, params, ProductCatalog, pathOverride);
    }
  }, {
    key: 'getOwnedWhatsAppBusinessAccounts',
    value: function getOwnedWhatsAppBusinessAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(WhatsAppBusinessAccount, fields, params, fetchFirstPage, '/owned_whatsapp_business_accounts');
    }
  }, {
    key: 'deletePages',
    value: function deletePages() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'deleteEdge', this).call(this, '/pages', params);
    }
  }, {
    key: 'createPartnerPremiumOption',
    value: function createPartnerPremiumOption(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/partner_premium_options', fields, params, null, pathOverride);
    }
  }, {
    key: 'getPendingClientAdAccounts',
    value: function getPendingClientAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAdAccountRequest, fields, params, fetchFirstPage, '/pending_client_ad_accounts');
    }
  }, {
    key: 'getPendingClientApps',
    value: function getPendingClientApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessApplicationRequest, fields, params, fetchFirstPage, '/pending_client_apps');
    }
  }, {
    key: 'getPendingClientPages',
    value: function getPendingClientPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessPageRequest, fields, params, fetchFirstPage, '/pending_client_pages');
    }
  }, {
    key: 'getPendingOwnedAdAccounts',
    value: function getPendingOwnedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAdAccountRequest, fields, params, fetchFirstPage, '/pending_owned_ad_accounts');
    }
  }, {
    key: 'getPendingOwnedPages',
    value: function getPendingOwnedPages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessPageRequest, fields, params, fetchFirstPage, '/pending_owned_pages');
    }
  }, {
    key: 'getPendingSharedOffsiteSignalContainerBusinessObjects',
    value: function getPendingSharedOffsiteSignalContainerBusinessObjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/pending_shared_offsite_signal_container_business_objects');
    }
  }, {
    key: 'getPendingUsers',
    value: function getPendingUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessRoleRequest, fields, params, fetchFirstPage, '/pending_users');
    }
  }, {
    key: 'getPicture',
    value: function getPicture(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ProfilePictureSource, fields, params, fetchFirstPage, '/picture');
    }
  }, {
    key: 'createPixelTo',
    value: function createPixelTo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/pixel_tos', fields, params, null, pathOverride);
    }
  }, {
    key: 'getReceivedAudienceSharingRequests',
    value: function getReceivedAudienceSharingRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessAssetSharingAgreement, fields, params, fetchFirstPage, '/received_audience_sharing_requests');
    }
  }, {
    key: 'createSetupManagedPartnerAdAccount',
    value: function createSetupManagedPartnerAdAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/setup_managed_partner_adaccounts', fields, params, Business, pathOverride);
    }
  }, {
    key: 'getSystemUsers',
    value: function getSystemUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(SystemUser, fields, params, fetchFirstPage, '/system_users');
    }
  }, {
    key: 'createSystemUser',
    value: function createSystemUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/system_users', fields, params, SystemUser, pathOverride);
    }
  }, {
    key: 'getThirdPartyMeasurementReportDataset',
    value: function getThirdPartyMeasurementReportDataset(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/third_party_measurement_report_dataset');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Business.prototype.__proto__ || Object.getPrototypeOf(Business.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        block_offline_analytics: 'block_offline_analytics',
        collaborative_ads_managed_partner_business_info: 'collaborative_ads_managed_partner_business_info',
        collaborative_ads_managed_partner_eligibility: 'collaborative_ads_managed_partner_eligibility',
        collaborative_ads_partner_premium_options: 'collaborative_ads_partner_premium_options',
        created_by: 'created_by',
        created_time: 'created_time',
        extended_updated_time: 'extended_updated_time',
        id: 'id',
        is_hidden: 'is_hidden',
        link: 'link',
        name: 'name',
        payment_account_id: 'payment_account_id',
        primary_page: 'primary_page',
        profile_picture_uri: 'profile_picture_uri',
        timezone_id: 'timezone_id',
        two_factor_type: 'two_factor_type',
        updated_by: 'updated_by',
        updated_time: 'updated_time',
        verification_status: 'verification_status',
        vertical: 'vertical',
        vertical_id: 'vertical_id'
      });
    }
  }, {
    key: 'TwoFactorType',
    get: function get() {
      return Object.freeze({
        admin_required: 'admin_required',
        all_required: 'all_required',
        none: 'none'
      });
    }
  }, {
    key: 'Vertical',
    get: function get() {
      return Object.freeze({
        advertising: 'ADVERTISING',
        automotive: 'AUTOMOTIVE',
        consumer_packaged_goods: 'CONSUMER_PACKAGED_GOODS',
        ecommerce: 'ECOMMERCE',
        education: 'EDUCATION',
        energy_and_utilities: 'ENERGY_AND_UTILITIES',
        entertainment_and_media: 'ENTERTAINMENT_AND_MEDIA',
        financial_services: 'FINANCIAL_SERVICES',
        gaming: 'GAMING',
        government_and_politics: 'GOVERNMENT_AND_POLITICS',
        health: 'HEALTH',
        luxury: 'LUXURY',
        marketing: 'MARKETING',
        non_profit: 'NON_PROFIT',
        organizations_and_associations: 'ORGANIZATIONS_AND_ASSOCIATIONS',
        other: 'OTHER',
        professional_services: 'PROFESSIONAL_SERVICES',
        restaurant: 'RESTAURANT',
        retail: 'RETAIL',
        technology: 'TECHNOLOGY',
        telecom: 'TELECOM',
        travel: 'TRAVEL'
      });
    }
  }, {
    key: 'PermittedTasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        cashier_role: 'CASHIER_ROLE',
        create_content: 'CREATE_CONTENT',
        manage: 'MANAGE',
        manage_jobs: 'MANAGE_JOBS',
        manage_leads: 'MANAGE_LEADS',
        messaging: 'MESSAGING',
        moderate: 'MODERATE',
        moderate_community: 'MODERATE_COMMUNITY',
        pages_messaging: 'PAGES_MESSAGING',
        pages_messaging_subscriptions: 'PAGES_MESSAGING_SUBSCRIPTIONS',
        profile_plus_advertise: 'PROFILE_PLUS_ADVERTISE',
        profile_plus_analyze: 'PROFILE_PLUS_ANALYZE',
        profile_plus_create_content: 'PROFILE_PLUS_CREATE_CONTENT',
        profile_plus_facebook_access: 'PROFILE_PLUS_FACEBOOK_ACCESS',
        profile_plus_full_control: 'PROFILE_PLUS_FULL_CONTROL',
        profile_plus_manage: 'PROFILE_PLUS_MANAGE',
        profile_plus_manage_leads: 'PROFILE_PLUS_MANAGE_LEADS',
        profile_plus_messaging: 'PROFILE_PLUS_MESSAGING',
        profile_plus_moderate: 'PROFILE_PLUS_MODERATE',
        profile_plus_moderate_delegate_community: 'PROFILE_PLUS_MODERATE_DELEGATE_COMMUNITY',
        profile_plus_revenue: 'PROFILE_PLUS_REVENUE',
        read_page_mailboxes: 'READ_PAGE_MAILBOXES',
        view_monetization_insights: 'VIEW_MONETIZATION_INSIGHTS'
      });
    }
  }, {
    key: 'SurveyBusinessType',
    get: function get() {
      return Object.freeze({
        advertiser: 'ADVERTISER',
        agency: 'AGENCY',
        app_developer: 'APP_DEVELOPER',
        publisher: 'PUBLISHER'
      });
    }
  }, {
    key: 'PagePermittedTasks',
    get: function get() {
      return Object.freeze({
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        cashier_role: 'CASHIER_ROLE',
        create_content: 'CREATE_CONTENT',
        manage: 'MANAGE',
        manage_jobs: 'MANAGE_JOBS',
        manage_leads: 'MANAGE_LEADS',
        messaging: 'MESSAGING',
        moderate: 'MODERATE',
        moderate_community: 'MODERATE_COMMUNITY',
        pages_messaging: 'PAGES_MESSAGING',
        pages_messaging_subscriptions: 'PAGES_MESSAGING_SUBSCRIPTIONS',
        profile_plus_advertise: 'PROFILE_PLUS_ADVERTISE',
        profile_plus_analyze: 'PROFILE_PLUS_ANALYZE',
        profile_plus_create_content: 'PROFILE_PLUS_CREATE_CONTENT',
        profile_plus_facebook_access: 'PROFILE_PLUS_FACEBOOK_ACCESS',
        profile_plus_full_control: 'PROFILE_PLUS_FULL_CONTROL',
        profile_plus_manage: 'PROFILE_PLUS_MANAGE',
        profile_plus_manage_leads: 'PROFILE_PLUS_MANAGE_LEADS',
        profile_plus_messaging: 'PROFILE_PLUS_MESSAGING',
        profile_plus_moderate: 'PROFILE_PLUS_MODERATE',
        profile_plus_moderate_delegate_community: 'PROFILE_PLUS_MODERATE_DELEGATE_COMMUNITY',
        profile_plus_revenue: 'PROFILE_PLUS_REVENUE',
        read_page_mailboxes: 'READ_PAGE_MAILBOXES',
        view_monetization_insights: 'VIEW_MONETIZATION_INSIGHTS'
      });
    }
  }, {
    key: 'SubverticalV2',
    get: function get() {
      return Object.freeze({
        accounting_and_tax: 'ACCOUNTING_AND_TAX',
        activities_and_leisure: 'ACTIVITIES_AND_LEISURE',
        air: 'AIR',
        apparel_and_accessories: 'APPAREL_AND_ACCESSORIES',
        arts_and_heritage_and_education: 'ARTS_AND_HERITAGE_AND_EDUCATION',
        ar_or_vr_gaming: 'AR_OR_VR_GAMING',
        audio_streaming: 'AUDIO_STREAMING',
        auto: 'AUTO',
        auto_insurance: 'AUTO_INSURANCE',
        auto_rental: 'AUTO_RENTAL',
        baby: 'BABY',
        ballot_initiative_or_referendum: 'BALLOT_INITIATIVE_OR_REFERENDUM',
        beauty: 'BEAUTY',
        beauty_and_fashion: 'BEAUTY_AND_FASHION',
        beer_and_wine_and_liquor_and_malt_beverages: 'BEER_AND_WINE_AND_LIQUOR_AND_MALT_BEVERAGES',
        bookstores: 'BOOKSTORES',
        broadcast_television: 'BROADCAST_TELEVISION',
        business_consultants: 'BUSINESS_CONSULTANTS',
        buying_agency: 'BUYING_AGENCY',
        cable_and_satellite: 'CABLE_AND_SATELLITE',
        cable_television: 'CABLE_TELEVISION',
        call_center_and_messaging_services: 'CALL_CENTER_AND_MESSAGING_SERVICES',
        candidate_or_politician: 'CANDIDATE_OR_POLITICIAN',
        career: 'CAREER',
        career_and_tech: 'CAREER_AND_TECH',
        casual_dining: 'CASUAL_DINING',
        chronic_conditions_and_medical_causes: 'CHRONIC_CONDITIONS_AND_MEDICAL_CAUSES',
        civic_influencers: 'CIVIC_INFLUENCERS',
        clinical_trials: 'CLINICAL_TRIALS',
        coffee: 'COFFEE',
        computer_and_software_and_hardware: 'COMPUTER_AND_SOFTWARE_AND_HARDWARE',
        console_and_cross_platform_gaming: 'CONSOLE_AND_CROSS_PLATFORM_GAMING',
        consulting: 'CONSULTING',
        consumer_electronics: 'CONSUMER_ELECTRONICS',
        counseling_and_psychotherapy: 'COUNSELING_AND_PSYCHOTHERAPY',
        creative_agency: 'CREATIVE_AGENCY',
        credit_and_financing_and_mortages: 'CREDIT_AND_FINANCING_AND_MORTAGES',
        cruises_and_marine: 'CRUISES_AND_MARINE',
        culture_and_lifestyle: 'CULTURE_AND_LIFESTYLE',
        data_analytics_and_data_management: 'DATA_ANALYTICS_AND_DATA_MANAGEMENT',
        dating_and_technology_apps: 'DATING_AND_TECHNOLOGY_APPS',
        department_store: 'DEPARTMENT_STORE',
        desktop_software: 'DESKTOP_SOFTWARE',
        dieting_and_fitness_programs: 'DIETING_AND_FITNESS_PROGRAMS',
        digital_native_education_or_training: 'DIGITAL_NATIVE_EDUCATION_OR_TRAINING',
        drinking_places: 'DRINKING_PLACES',
        education_resources: 'EDUCATION_RESOURCES',
        ed_tech: 'ED_TECH',
        elearning_and_massive_online_open_courses: 'ELEARNING_AND_MASSIVE_ONLINE_OPEN_COURSES',
        election_commission: 'ELECTION_COMMISSION',
        electronics_and_appliances: 'ELECTRONICS_AND_APPLIANCES',
        engineering_and_design: 'ENGINEERING_AND_DESIGN',
        environment_and_animal_welfare: 'ENVIRONMENT_AND_ANIMAL_WELFARE',
        esports: 'ESPORTS',
        events: 'EVENTS',
        farming_and_ranching: 'FARMING_AND_RANCHING',
        file_storage_and_cloud_and_data_services: 'FILE_STORAGE_AND_CLOUD_AND_DATA_SERVICES',
        finance: 'FINANCE',
        fin_tech: 'FIN_TECH',
        fishing_and_hunting_and_forestry_and_logging: 'FISHING_AND_HUNTING_AND_FORESTRY_AND_LOGGING',
        fitness: 'FITNESS',
        food: 'FOOD',
        footwear: 'FOOTWEAR',
        for_profit_colleges_and_universities: 'FOR_PROFIT_COLLEGES_AND_UNIVERSITIES',
        full_service_agency: 'FULL_SERVICE_AGENCY',
        government_controlled_entity: 'GOVERNMENT_CONTROLLED_ENTITY',
        government_department_or_agency: 'GOVERNMENT_DEPARTMENT_OR_AGENCY',
        government_official: 'GOVERNMENT_OFFICIAL',
        government_owned_media: 'GOVERNMENT_OWNED_MEDIA',
        grocery_and_drug_and_convenience: 'GROCERY_AND_DRUG_AND_CONVENIENCE',
        head_of_state: 'HEAD_OF_STATE',
        health_insurance: 'HEALTH_INSURANCE',
        health_systems_and_practitioners: 'HEALTH_SYSTEMS_AND_PRACTITIONERS',
        health_tech: 'HEALTH_TECH',
        home_and_furniture_and_office: 'HOME_AND_FURNITURE_AND_OFFICE',
        home_improvement: 'HOME_IMPROVEMENT',
        home_insurance: 'HOME_INSURANCE',
        home_tech: 'HOME_TECH',
        hotel_and_accomodation: 'HOTEL_AND_ACCOMODATION',
        household_goods_durable: 'HOUSEHOLD_GOODS_DURABLE',
        household_goods_non_durable: 'HOUSEHOLD_GOODS_NON_DURABLE',
        hr_and_financial_management: 'HR_AND_FINANCIAL_MANAGEMENT',
        humanitarian_or_disaster_relief: 'HUMANITARIAN_OR_DISASTER_RELIEF',
        independent_expenditure_group: 'INDEPENDENT_EXPENDITURE_GROUP',
        insurance_tech: 'INSURANCE_TECH',
        international_organizaton: 'INTERNATIONAL_ORGANIZATON',
        investment_bank_and_brokerage: 'INVESTMENT_BANK_AND_BROKERAGE',
        issue_advocacy: 'ISSUE_ADVOCACY',
        legal: 'LEGAL',
        life_insurance: 'LIFE_INSURANCE',
        logistics_and_transportation_and_fleet_management: 'LOGISTICS_AND_TRANSPORTATION_AND_FLEET_MANAGEMENT',
        manufacturing: 'MANUFACTURING',
        medical_devices_and_supplies_and_equipment: 'MEDICAL_DEVICES_AND_SUPPLIES_AND_EQUIPMENT',
        medspa_and_elective_surgeries_and_alternative_medicine: 'MEDSPA_AND_ELECTIVE_SURGERIES_AND_ALTERNATIVE_MEDICINE',
        mining_and_quarrying: 'MINING_AND_QUARRYING',
        mobile_gaming: 'MOBILE_GAMING',
        movies: 'MOVIES',
        museums_and_parks_and_libraries: 'MUSEUMS_AND_PARKS_AND_LIBRARIES',
        music: 'MUSIC',
        network_security_products: 'NETWORK_SECURITY_PRODUCTS',
        news_and_current_events: 'NEWS_AND_CURRENT_EVENTS',
        non_prescription: 'NON_PRESCRIPTION',
        not_for_profit_colleges_and_universities: 'NOT_FOR_PROFIT_COLLEGES_AND_UNIVERSITIES',
        office: 'OFFICE',
        office_or_business_supplies: 'OFFICE_OR_BUSINESS_SUPPLIES',
        oil_and_gas_and_consumable_fuel: 'OIL_AND_GAS_AND_CONSUMABLE_FUEL',
        online_only_publications: 'ONLINE_ONLY_PUBLICATIONS',
        package_or_freight_delivery: 'PACKAGE_OR_FREIGHT_DELIVERY',
        party_independent_expenditure_group_us: 'PARTY_INDEPENDENT_EXPENDITURE_GROUP_US',
        payment_processing_and_gateway_solutions: 'PAYMENT_PROCESSING_AND_GATEWAY_SOLUTIONS',
        pc_gaming: 'PC_GAMING',
        people: 'PEOPLE',
        personal_care: 'PERSONAL_CARE',
        pet: 'PET',
        photography_and_filming_services: 'PHOTOGRAPHY_AND_FILMING_SERVICES',
        pizza: 'PIZZA',
        planning_agency: 'PLANNING_AGENCY',
        political_party_or_committee: 'POLITICAL_PARTY_OR_COMMITTEE',
        prescription: 'PRESCRIPTION',
        professional_associations: 'PROFESSIONAL_ASSOCIATIONS',
        property_and_casualty: 'PROPERTY_AND_CASUALTY',
        quick_service: 'QUICK_SERVICE',
        radio: 'RADIO',
        railroads: 'RAILROADS',
        real_estate: 'REAL_ESTATE',
        real_money_gaming: 'REAL_MONEY_GAMING',
        recreational: 'RECREATIONAL',
        religious: 'RELIGIOUS',
        reseller: 'RESELLER',
        residential_and_long_term_care_facilities_and_outpatient_care_centers: 'RESIDENTIAL_AND_LONG_TERM_CARE_FACILITIES_AND_OUTPATIENT_CARE_CENTERS',
        retail_and_credit_union_and_commercial_bank: 'RETAIL_AND_CREDIT_UNION_AND_COMMERCIAL_BANK',
        ride_sharing_or_taxi_services: 'RIDE_SHARING_OR_TAXI_SERVICES',
        safety_services: 'SAFETY_SERVICES',
        scholarly: 'SCHOLARLY',
        school_and_early_children_edcation: 'SCHOOL_AND_EARLY_CHILDREN_EDCATION',
        social_media: 'SOCIAL_MEDIA',
        software_as_a_service: 'SOFTWARE_AS_A_SERVICE',
        sporting: 'SPORTING',
        sporting_and_outdoor: 'SPORTING_AND_OUTDOOR',
        sports: 'SPORTS',
        superstores: 'SUPERSTORES',
        t1_automotive_manufacturer: 'T1_AUTOMOTIVE_MANUFACTURER',
        t1_motorcycle: 'T1_MOTORCYCLE',
        t2_dealer_associations: 'T2_DEALER_ASSOCIATIONS',
        t3_auto_agency: 'T3_AUTO_AGENCY',
        t3_auto_resellers: 'T3_AUTO_RESELLERS',
        t3_dealer_groups: 'T3_DEALER_GROUPS',
        t3_franchise_dealer: 'T3_FRANCHISE_DEALER',
        t3_independent_dealer: 'T3_INDEPENDENT_DEALER',
        t3_parts_and_services: 'T3_PARTS_AND_SERVICES',
        t3_portals: 'T3_PORTALS',
        telecommunications_equipment_and_accessories: 'TELECOMMUNICATIONS_EQUIPMENT_AND_ACCESSORIES',
        telephone_service_providers_and_carriers: 'TELEPHONE_SERVICE_PROVIDERS_AND_CARRIERS',
        ticketing: 'TICKETING',
        tobacco: 'TOBACCO',
        tourism_and_travel_services: 'TOURISM_AND_TRAVEL_SERVICES',
        tourism_board: 'TOURISM_BOARD',
        toy_and_hobby: 'TOY_AND_HOBBY',
        trade_school: 'TRADE_SCHOOL',
        travel_agencies_and_guides_and_otas: 'TRAVEL_AGENCIES_AND_GUIDES_AND_OTAS',
        utilities_and_energy_equipment_and_services: 'UTILITIES_AND_ENERGY_EQUIPMENT_AND_SERVICES',
        veterinary_clinics_and_services: 'VETERINARY_CLINICS_AND_SERVICES',
        video_streaming: 'VIDEO_STREAMING',
        virtual_services: 'VIRTUAL_SERVICES',
        vitamins_or_wellness: 'VITAMINS_OR_WELLNESS',
        warehousing_and_storage: 'WAREHOUSING_AND_STORAGE',
        water_and_soft_drink_and_baverage: 'WATER_AND_SOFT_DRINK_AND_BAVERAGE',
        website_designers_or_graphic_designers: 'WEBSITE_DESIGNERS_OR_GRAPHIC_DESIGNERS',
        wholesale: 'WHOLESALE',
        wireless_services: 'WIRELESS_SERVICES'
      });
    }
  }, {
    key: 'VerticalV2',
    get: function get() {
      return Object.freeze({
        advertising_and_marketing: 'ADVERTISING_AND_MARKETING',
        agriculture: 'AGRICULTURE',
        automotive: 'AUTOMOTIVE',
        banking_and_credit_cards: 'BANKING_AND_CREDIT_CARDS',
        business_to_business: 'BUSINESS_TO_BUSINESS',
        consumer_packaged_goods: 'CONSUMER_PACKAGED_GOODS',
        ecommerce: 'ECOMMERCE',
        education: 'EDUCATION',
        energy_and_natural_resources_and_utilities: 'ENERGY_AND_NATURAL_RESOURCES_AND_UTILITIES',
        entertainment_and_media: 'ENTERTAINMENT_AND_MEDIA',
        gaming: 'GAMING',
        government: 'GOVERNMENT',
        healthcare_and_pharmaceuticals_and_biotech: 'HEALTHCARE_AND_PHARMACEUTICALS_AND_BIOTECH',
        insurance: 'INSURANCE',
        non_profit: 'NON_PROFIT',
        organizations_and_associations: 'ORGANIZATIONS_AND_ASSOCIATIONS',
        politics: 'POLITICS',
        professional_services: 'PROFESSIONAL_SERVICES',
        publishing: 'PUBLISHING',
        restaurants: 'RESTAURANTS',
        retail: 'RETAIL',
        technology: 'TECHNOLOGY',
        telecom: 'TELECOM',
        travel: 'TRAVEL'
      });
    }
  }, {
    key: 'ActionSource',
    get: function get() {
      return Object.freeze({
        physical_store: 'PHYSICAL_STORE',
        website: 'WEBSITE'
      });
    }
  }]);
  return Business;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DACheck
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DACheck = function (_AbstractCrudObject) {
  inherits(DACheck, _AbstractCrudObject);

  function DACheck() {
    classCallCheck(this, DACheck);
    return possibleConstructorReturn(this, (DACheck.__proto__ || Object.getPrototypeOf(DACheck)).apply(this, arguments));
  }

  createClass(DACheck, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        action_uri: 'action_uri',
        description: 'description',
        key: 'key',
        result: 'result',
        title: 'title',
        user_message: 'user_message'
      });
    }
  }, {
    key: 'ConnectionMethod',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        app: 'APP',
        browser: 'BROWSER',
        server: 'SERVER'
      });
    }
  }]);
  return DACheck;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Application
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Application = function (_AbstractCrudObject) {
  inherits(Application, _AbstractCrudObject);

  function Application() {
    classCallCheck(this, Application);
    return possibleConstructorReturn(this, (Application.__proto__ || Object.getPrototypeOf(Application)).apply(this, arguments));
  }

  createClass(Application, [{
    key: 'deleteAccounts',
    value: function deleteAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Application.prototype.__proto__ || Object.getPrototypeOf(Application.prototype), 'deleteEdge', this).call(this, '/accounts', params);
    }
  }, {
    key: 'getAccounts',
    value: function getAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/accounts');
    }
  }, {
    key: 'createAccount',
    value: function createAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/accounts', fields, params, null, pathOverride);
    }
  }, {
    key: 'createActivity',
    value: function createActivity(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/activities', fields, params, null, pathOverride);
    }
  }, {
    key: 'getAdPlacementGroups',
    value: function getAdPlacementGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ad_placement_groups');
    }
  }, {
    key: 'getAdNetworkPlacements',
    value: function getAdNetworkPlacements(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdPlacement, fields, params, fetchFirstPage, '/adnetwork_placements');
    }
  }, {
    key: 'getAdNetworkAnalytics',
    value: function getAdNetworkAnalytics(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdNetworkAnalyticsSyncQueryResult, fields, params, fetchFirstPage, '/adnetworkanalytics');
    }
  }, {
    key: 'createAdNetworkAnalytic',
    value: function createAdNetworkAnalytic(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adnetworkanalytics', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getAdNetworkAnalyticsResults',
    value: function getAdNetworkAnalyticsResults(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdNetworkAnalyticsAsyncQueryResult, fields, params, fetchFirstPage, '/adnetworkanalytics_results');
    }
  }, {
    key: 'getAemAttribution',
    value: function getAemAttribution(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/aem_attribution');
    }
  }, {
    key: 'getAemConversionConfigs',
    value: function getAemConversionConfigs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/aem_conversion_configs');
    }
  }, {
    key: 'getAemConversionFilter',
    value: function getAemConversionFilter(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/aem_conversion_filter');
    }
  }, {
    key: 'createAemConversion',
    value: function createAemConversion(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/aem_conversions', fields, params, null, pathOverride);
    }
  }, {
    key: 'createAemSkanReadiness',
    value: function createAemSkanReadiness(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/aem_skan_readiness', fields, params, null, pathOverride);
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'createAggregateRevenue',
    value: function createAggregateRevenue(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/aggregate_revenue', fields, params, null, pathOverride);
    }
  }, {
    key: 'getAndroidDialogConfigs',
    value: function getAndroidDialogConfigs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/android_dialog_configs');
    }
  }, {
    key: 'getAppCapiSettings',
    value: function getAppCapiSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/app_capi_settings');
    }
  }, {
    key: 'getAppEventTypes',
    value: function getAppEventTypes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/app_event_types');
    }
  }, {
    key: 'createAppIndexing',
    value: function createAppIndexing(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/app_indexing', fields, params, Application, pathOverride);
    }
  }, {
    key: 'createAppIndexingSession',
    value: function createAppIndexingSession(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/app_indexing_session', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getAppInstalledGroups',
    value: function getAppInstalledGroups(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Group, fields, params, fetchFirstPage, '/app_installed_groups');
    }
  }, {
    key: 'createAppPushDeviceToken',
    value: function createAppPushDeviceToken(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/app_push_device_token', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getAppAssets',
    value: function getAppAssets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/appassets');
    }
  }, {
    key: 'createAsset',
    value: function createAsset(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assets', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getAuthorizedAdAccounts',
    value: function getAuthorizedAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/authorized_adaccounts');
    }
  }, {
    key: 'getButtonAutoDetectionDeviceSelection',
    value: function getButtonAutoDetectionDeviceSelection(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/button_auto_detection_device_selection');
    }
  }, {
    key: 'getCloudbridgeSettings',
    value: function getCloudbridgeSettings(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/cloudbridge_settings');
    }
  }, {
    key: 'createCodelessEventMapping',
    value: function createCodelessEventMapping(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/codeless_event_mappings', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getDaChecks',
    value: function getDaChecks(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(DACheck, fields, params, fetchFirstPage, '/da_checks');
    }
  }, {
    key: 'getEvents',
    value: function getEvents(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Event, fields, params, fetchFirstPage, '/events');
    }
  }, {
    key: 'getInsightsPushSchedule',
    value: function getInsightsPushSchedule(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/insights_push_schedule');
    }
  }, {
    key: 'getIosDialogConfigs',
    value: function getIosDialogConfigs(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ios_dialog_configs');
    }
  }, {
    key: 'createMmpAuditing',
    value: function createMmpAuditing(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/mmp_auditing', fields, params, null, pathOverride);
    }
  }, {
    key: 'getMobileSdkGk',
    value: function getMobileSdkGk(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/mobile_sdk_gk');
    }
  }, {
    key: 'getMonetizedDigitalStoreObjects',
    value: function getMonetizedDigitalStoreObjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/monetized_digital_store_objects');
    }
  }, {
    key: 'createMonetizedDigitalStoreObject',
    value: function createMonetizedDigitalStoreObject(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/monetized_digital_store_objects', fields, params, null, pathOverride);
    }
  }, {
    key: 'getObjectTypes',
    value: function getObjectTypes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(NullNode, fields, params, fetchFirstPage, '/object_types');
    }
  }, {
    key: 'createOccludesPopup',
    value: function createOccludesPopup(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/occludespopups', fields, params, null, pathOverride);
    }
  }, {
    key: 'createPageActivity',
    value: function createPageActivity(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/page_activities', fields, params, Application, pathOverride);
    }
  }, {
    key: 'createPaymentCurrency',
    value: function createPaymentCurrency(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/payment_currencies', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getPermissions',
    value: function getPermissions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/permissions');
    }
  }, {
    key: 'getProducts',
    value: function getProducts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/products');
    }
  }, {
    key: 'getPurchases',
    value: function getPurchases(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/purchases');
    }
  }, {
    key: 'getRoles',
    value: function getRoles(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/roles');
    }
  }, {
    key: 'getSubscribedDomains',
    value: function getSubscribedDomains(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/subscribed_domains');
    }
  }, {
    key: 'createSubscribedDomain',
    value: function createSubscribedDomain(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/subscribed_domains', fields, params, Application, pathOverride);
    }
  }, {
    key: 'getSubscribedDomainsPhishing',
    value: function getSubscribedDomainsPhishing(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/subscribed_domains_phishing');
    }
  }, {
    key: 'createSubscribedDomainsPhishing',
    value: function createSubscribedDomainsPhishing(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/subscribed_domains_phishing', fields, params, Application, pathOverride);
    }
  }, {
    key: 'deleteSubscriptions',
    value: function deleteSubscriptions() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(Application.prototype.__proto__ || Object.getPrototypeOf(Application.prototype), 'deleteEdge', this).call(this, '/subscriptions', params);
    }
  }, {
    key: 'createSubscription',
    value: function createSubscription(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/subscriptions', fields, params, null, pathOverride);
    }
  }, {
    key: 'createUpload',
    value: function createUpload(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/uploads', fields, params, null, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(Application.prototype.__proto__ || Object.getPrototypeOf(Application.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        aam_rules: 'aam_rules',
        an_ad_space_limit: 'an_ad_space_limit',
        an_platforms: 'an_platforms',
        android_key_hash: 'android_key_hash',
        android_sdk_error_categories: 'android_sdk_error_categories',
        app_domains: 'app_domains',
        app_events_config: 'app_events_config',
        app_events_feature_bitmask: 'app_events_feature_bitmask',
        app_events_session_timeout: 'app_events_session_timeout',
        app_install_tracked: 'app_install_tracked',
        app_name: 'app_name',
        app_signals_binding_ios: 'app_signals_binding_ios',
        app_type: 'app_type',
        auth_dialog_data_help_url: 'auth_dialog_data_help_url',
        auth_dialog_headline: 'auth_dialog_headline',
        auth_dialog_perms_explanation: 'auth_dialog_perms_explanation',
        auth_referral_default_activity_privacy: 'auth_referral_default_activity_privacy',
        auth_referral_enabled: 'auth_referral_enabled',
        auth_referral_extended_perms: 'auth_referral_extended_perms',
        auth_referral_friend_perms: 'auth_referral_friend_perms',
        auth_referral_response_type: 'auth_referral_response_type',
        auth_referral_user_perms: 'auth_referral_user_perms',
        auto_event_mapping_android: 'auto_event_mapping_android',
        auto_event_mapping_ios: 'auto_event_mapping_ios',
        auto_event_setup_enabled: 'auto_event_setup_enabled',
        business: 'business',
        canvas_fluid_height: 'canvas_fluid_height',
        canvas_fluid_width: 'canvas_fluid_width',
        canvas_url: 'canvas_url',
        category: 'category',
        client_config: 'client_config',
        company: 'company',
        configured_ios_sso: 'configured_ios_sso',
        contact_email: 'contact_email',
        created_time: 'created_time',
        creator_uid: 'creator_uid',
        daily_active_users: 'daily_active_users',
        daily_active_users_rank: 'daily_active_users_rank',
        deauth_callback_url: 'deauth_callback_url',
        default_share_mode: 'default_share_mode',
        description: 'description',
        financial_id: 'financial_id',
        gdpv4_chrome_custom_tabs_enabled: 'gdpv4_chrome_custom_tabs_enabled',
        gdpv4_enabled: 'gdpv4_enabled',
        gdpv4_nux_content: 'gdpv4_nux_content',
        gdpv4_nux_enabled: 'gdpv4_nux_enabled',
        has_messenger_product: 'has_messenger_product',
        hosting_url: 'hosting_url',
        icon_url: 'icon_url',
        id: 'id',
        ios_bundle_id: 'ios_bundle_id',
        ios_sdk_dialog_flows: 'ios_sdk_dialog_flows',
        ios_sdk_error_categories: 'ios_sdk_error_categories',
        ios_sfvc_attr: 'ios_sfvc_attr',
        ios_supports_native_proxy_auth_flow: 'ios_supports_native_proxy_auth_flow',
        ios_supports_system_auth: 'ios_supports_system_auth',
        ipad_app_store_id: 'ipad_app_store_id',
        iphone_app_store_id: 'iphone_app_store_id',
        latest_sdk_version: 'latest_sdk_version',
        link: 'link',
        logging_token: 'logging_token',
        logo_url: 'logo_url',
        migrations: 'migrations',
        mobile_profile_section_url: 'mobile_profile_section_url',
        mobile_web_url: 'mobile_web_url',
        monthly_active_users: 'monthly_active_users',
        monthly_active_users_rank: 'monthly_active_users_rank',
        name: 'name',
        namespace: 'namespace',
        object_store_urls: 'object_store_urls',
        owner_business: 'owner_business',
        page_tab_default_name: 'page_tab_default_name',
        page_tab_url: 'page_tab_url',
        photo_url: 'photo_url',
        privacy_policy_url: 'privacy_policy_url',
        profile_section_url: 'profile_section_url',
        property_id: 'property_id',
        real_time_mode_devices: 'real_time_mode_devices',
        restrictions: 'restrictions',
        restrictive_data_filter_params: 'restrictive_data_filter_params',
        restrictive_data_filter_rules: 'restrictive_data_filter_rules',
        sdk_update_message: 'sdk_update_message',
        seamless_login: 'seamless_login',
        secure_canvas_url: 'secure_canvas_url',
        secure_page_tab_url: 'secure_page_tab_url',
        server_ip_whitelist: 'server_ip_whitelist',
        smart_login_bookmark_icon_url: 'smart_login_bookmark_icon_url',
        smart_login_menu_icon_url: 'smart_login_menu_icon_url',
        social_discovery: 'social_discovery',
        subcategory: 'subcategory',
        suggested_events_setting: 'suggested_events_setting',
        supported_platforms: 'supported_platforms',
        supports_apprequests_fast_app_switch: 'supports_apprequests_fast_app_switch',
        supports_attribution: 'supports_attribution',
        supports_implicit_sdk_logging: 'supports_implicit_sdk_logging',
        suppress_native_ios_gdp: 'suppress_native_ios_gdp',
        terms_of_service_url: 'terms_of_service_url',
        url_scheme_suffix: 'url_scheme_suffix',
        user_support_email: 'user_support_email',
        user_support_url: 'user_support_url',
        website_url: 'website_url',
        weekly_active_users: 'weekly_active_users'
      });
    }
  }, {
    key: 'SupportedPlatforms',
    get: function get() {
      return Object.freeze({
        amazon: 'AMAZON',
        android: 'ANDROID',
        canvas: 'CANVAS',
        gameroom: 'GAMEROOM',
        instant_game: 'INSTANT_GAME',
        ipad: 'IPAD',
        iphone: 'IPHONE',
        mobile_web: 'MOBILE_WEB',
        oculus: 'OCULUS',
        samsung: 'SAMSUNG',
        supplementary_images: 'SUPPLEMENTARY_IMAGES',
        web: 'WEB',
        windows: 'WINDOWS',
        xiaomi: 'XIAOMI'
      });
    }
  }, {
    key: 'AnPlatforms',
    get: function get() {
      return Object.freeze({
        android: 'ANDROID',
        desktop: 'DESKTOP',
        galaxy: 'GALAXY',
        instant_articles: 'INSTANT_ARTICLES',
        ios: 'IOS',
        mobile_web: 'MOBILE_WEB',
        oculus: 'OCULUS',
        unknown: 'UNKNOWN',
        xiaomi: 'XIAOMI'
      });
    }
  }, {
    key: 'Platform',
    get: function get() {
      return Object.freeze({
        android: 'ANDROID',
        ios: 'IOS'
      });
    }
  }, {
    key: 'RequestType',
    get: function get() {
      return Object.freeze({
        app_indexing: 'APP_INDEXING',
        button_sampling: 'BUTTON_SAMPLING',
        plugin: 'PLUGIN'
      });
    }
  }, {
    key: 'MutationMethod',
    get: function get() {
      return Object.freeze({
        add: 'ADD',
        delete: 'DELETE',
        replace: 'REPLACE'
      });
    }
  }, {
    key: 'PostMethod',
    get: function get() {
      return Object.freeze({
        codeless: 'CODELESS',
        eymt: 'EYMT'
      });
    }
  }, {
    key: 'LoggingSource',
    get: function get() {
      return Object.freeze({
        messenger_bot: 'MESSENGER_BOT'
      });
    }
  }, {
    key: 'LoggingTarget',
    get: function get() {
      return Object.freeze({
        app: 'APP',
        app_and_page: 'APP_AND_PAGE',
        page: 'PAGE'
      });
    }
  }]);
  return Application;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PartnerStudy
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PartnerStudy = function (_AbstractCrudObject) {
  inherits(PartnerStudy, _AbstractCrudObject);

  function PartnerStudy() {
    classCallCheck(this, PartnerStudy);
    return possibleConstructorReturn(this, (PartnerStudy.__proto__ || Object.getPrototypeOf(PartnerStudy)).apply(this, arguments));
  }

  createClass(PartnerStudy, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        additional_info: 'additional_info',
        brand: 'brand',
        client_name: 'client_name',
        emails: 'emails',
        id: 'id',
        input_ids: 'input_ids',
        is_export: 'is_export',
        lift_study: 'lift_study',
        location: 'location',
        match_file_ds: 'match_file_ds',
        name: 'name',
        partner_defined_id: 'partner_defined_id',
        partner_household_graph_dataset_id: 'partner_household_graph_dataset_id',
        status: 'status',
        study_end_date: 'study_end_date',
        study_start_date: 'study_start_date',
        study_type: 'study_type',
        submit_date: 'submit_date'
      });
    }
  }]);
  return PartnerStudy;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdStudyObjective
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdStudyObjective = function (_AbstractCrudObject) {
  inherits(AdStudyObjective, _AbstractCrudObject);

  function AdStudyObjective() {
    classCallCheck(this, AdStudyObjective);
    return possibleConstructorReturn(this, (AdStudyObjective.__proto__ || Object.getPrototypeOf(AdStudyObjective)).apply(this, arguments));
  }

  createClass(AdStudyObjective, [{
    key: 'getAdsPixels',
    value: function getAdsPixels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixel, fields, params, fetchFirstPage, '/adspixels');
    }
  }, {
    key: 'getApplications',
    value: function getApplications(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/applications');
    }
  }, {
    key: 'getCustomConversions',
    value: function getCustomConversions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomConversion, fields, params, fetchFirstPage, '/customconversions');
    }
  }, {
    key: 'getOfflineConversionDataSets',
    value: function getOfflineConversionDataSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OfflineConversionDataSet, fields, params, fetchFirstPage, '/offline_conversion_data_sets');
    }
  }, {
    key: 'getPartnerStudies',
    value: function getPartnerStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PartnerStudy, fields, params, fetchFirstPage, '/partnerstudies');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdStudyObjective.prototype.__proto__ || Object.getPrototypeOf(AdStudyObjective.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        is_primary: 'is_primary',
        last_updated_results: 'last_updated_results',
        name: 'name',
        results: 'results',
        type: 'type'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        brand: 'BRAND',
        brandlift: 'BRANDLIFT',
        conversions: 'CONVERSIONS',
        ftl: 'FTL',
        mae: 'MAE',
        mai: 'MAI',
        mpc_conversion: 'MPC_CONVERSION',
        nonsales: 'NONSALES',
        partner: 'PARTNER',
        sales: 'SALES',
        telco: 'TELCO'
      });
    }
  }]);
  return AdStudyObjective;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdStudy
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdStudy = function (_AbstractCrudObject) {
  inherits(AdStudy, _AbstractCrudObject);

  function AdStudy() {
    classCallCheck(this, AdStudy);
    return possibleConstructorReturn(this, (AdStudy.__proto__ || Object.getPrototypeOf(AdStudy)).apply(this, arguments));
  }

  createClass(AdStudy, [{
    key: 'getCells',
    value: function getCells(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudyCell, fields, params, fetchFirstPage, '/cells');
    }
  }, {
    key: 'createCheckPoint',
    value: function createCheckPoint(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/checkpoint', fields, params, AdStudy, pathOverride);
    }
  }, {
    key: 'getInstances',
    value: function getInstances(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PrivateLiftStudyInstance, fields, params, fetchFirstPage, '/instances');
    }
  }, {
    key: 'createInstance',
    value: function createInstance(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/instances', fields, params, PrivateLiftStudyInstance, pathOverride);
    }
  }, {
    key: 'getObjectives',
    value: function getObjectives(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudyObjective, fields, params, fetchFirstPage, '/objectives');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdStudy.prototype.__proto__ || Object.getPrototypeOf(AdStudy.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdStudy.prototype.__proto__ || Object.getPrototypeOf(AdStudy.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business: 'business',
        canceled_time: 'canceled_time',
        client_business: 'client_business',
        cooldown_start_time: 'cooldown_start_time',
        created_by: 'created_by',
        created_time: 'created_time',
        description: 'description',
        end_time: 'end_time',
        id: 'id',
        measurement_contact: 'measurement_contact',
        name: 'name',
        observation_end_time: 'observation_end_time',
        results_first_available_date: 'results_first_available_date',
        sales_contact: 'sales_contact',
        start_time: 'start_time',
        type: 'type',
        updated_by: 'updated_by',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        continuous_lift_config: 'CONTINUOUS_LIFT_CONFIG',
        geo_lift: 'GEO_LIFT',
        lift: 'LIFT',
        split_test: 'SPLIT_TEST'
      });
    }
  }]);
  return AdStudy;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CloudGame
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CloudGame = function (_AbstractCrudObject) {
  inherits(CloudGame, _AbstractCrudObject);

  function CloudGame() {
    classCallCheck(this, CloudGame);
    return possibleConstructorReturn(this, (CloudGame.__proto__ || Object.getPrototypeOf(CloudGame)).apply(this, arguments));
  }

  createClass(CloudGame, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name',
        owner: 'owner',
        playable_ad_file_size: 'playable_ad_file_size',
        playable_ad_orientation: 'playable_ad_orientation',
        playable_ad_package_name: 'playable_ad_package_name',
        playable_ad_reject_reason: 'playable_ad_reject_reason',
        playable_ad_status: 'playable_ad_status',
        playable_ad_upload_time: 'playable_ad_upload_time'
      });
    }
  }]);
  return CloudGame;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdImage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdImage = function (_AbstractCrudObject) {
  inherits(AdImage, _AbstractCrudObject);

  function AdImage() {
    classCallCheck(this, AdImage);
    return possibleConstructorReturn(this, (AdImage.__proto__ || Object.getPrototypeOf(AdImage)).apply(this, arguments));
  }

  createClass(AdImage, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        created_time: 'created_time',
        creatives: 'creatives',
        hash: 'hash',
        height: 'height',
        id: 'id',
        is_associated_creatives_in_adgroups: 'is_associated_creatives_in_adgroups',
        name: 'name',
        original_height: 'original_height',
        original_width: 'original_width',
        owner_business: 'owner_business',
        permalink_url: 'permalink_url',
        status: 'status',
        updated_time: 'updated_time',
        url: 'url',
        url_128: 'url_128',
        width: 'width'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        active: 'ACTIVE',
        deleted: 'DELETED',
        internal: 'INTERNAL'
      });
    }
  }]);
  return AdImage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdLabel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdLabel = function (_AbstractCrudObject) {
  inherits(AdLabel, _AbstractCrudObject);

  function AdLabel() {
    classCallCheck(this, AdLabel);
    return possibleConstructorReturn(this, (AdLabel.__proto__ || Object.getPrototypeOf(AdLabel)).apply(this, arguments));
  }

  createClass(AdLabel, [{
    key: 'getAdCreatives',
    value: function getAdCreatives(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCreative, fields, params, fetchFirstPage, '/adcreatives');
    }
  }, {
    key: 'getAds',
    value: function getAds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/ads');
    }
  }, {
    key: 'getAdSets',
    value: function getAdSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/adsets');
    }
  }, {
    key: 'getCampaigns',
    value: function getCampaigns(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Campaign, fields, params, fetchFirstPage, '/campaigns');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdLabel.prototype.__proto__ || Object.getPrototypeOf(AdLabel.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdLabel.prototype.__proto__ || Object.getPrototypeOf(AdLabel.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account: 'account',
        created_time: 'created_time',
        id: 'id',
        name: 'name',
        updated_time: 'updated_time'
      });
    }
  }]);
  return AdLabel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PlayableContent
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PlayableContent = function (_AbstractCrudObject) {
  inherits(PlayableContent, _AbstractCrudObject);

  function PlayableContent() {
    classCallCheck(this, PlayableContent);
    return possibleConstructorReturn(this, (PlayableContent.__proto__ || Object.getPrototypeOf(PlayableContent)).apply(this, arguments));
  }

  createClass(PlayableContent, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name',
        owner: 'owner'
      });
    }
  }]);
  return PlayableContent;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountAdRulesHistory
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountAdRulesHistory = function (_AbstractCrudObject) {
  inherits(AdAccountAdRulesHistory, _AbstractCrudObject);

  function AdAccountAdRulesHistory() {
    classCallCheck(this, AdAccountAdRulesHistory);
    return possibleConstructorReturn(this, (AdAccountAdRulesHistory.__proto__ || Object.getPrototypeOf(AdAccountAdRulesHistory)).apply(this, arguments));
  }

  createClass(AdAccountAdRulesHistory, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        evaluation_spec: 'evaluation_spec',
        exception_code: 'exception_code',
        exception_message: 'exception_message',
        execution_spec: 'execution_spec',
        is_manual: 'is_manual',
        results: 'results',
        rule_id: 'rule_id',
        schedule_spec: 'schedule_spec',
        timestamp: 'timestamp'
      });
    }
  }, {
    key: 'Action',
    get: function get() {
      return Object.freeze({
        budget_not_redistributed: 'BUDGET_NOT_REDISTRIBUTED',
        changed_bid: 'CHANGED_BID',
        changed_budget: 'CHANGED_BUDGET',
        email: 'EMAIL',
        enable_autoflow: 'ENABLE_AUTOFLOW',
        endpoint_pinged: 'ENDPOINT_PINGED',
        error: 'ERROR',
        facebook_notification_sent: 'FACEBOOK_NOTIFICATION_SENT',
        message_sent: 'MESSAGE_SENT',
        not_changed: 'NOT_CHANGED',
        paused: 'PAUSED',
        unpaused: 'UNPAUSED'
      });
    }
  }, {
    key: 'EvaluationType',
    get: function get() {
      return Object.freeze({
        schedule: 'SCHEDULE',
        trigger: 'TRIGGER'
      });
    }
  }]);
  return AdAccountAdRulesHistory;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountAdVolume
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountAdVolume = function (_AbstractCrudObject) {
  inherits(AdAccountAdVolume, _AbstractCrudObject);

  function AdAccountAdVolume() {
    classCallCheck(this, AdAccountAdVolume);
    return possibleConstructorReturn(this, (AdAccountAdVolume.__proto__ || Object.getPrototypeOf(AdAccountAdVolume)).apply(this, arguments));
  }

  createClass(AdAccountAdVolume, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actor_id: 'actor_id',
        actor_name: 'actor_name',
        ad_limit_scope_business: 'ad_limit_scope_business',
        ad_limit_scope_business_manager_id: 'ad_limit_scope_business_manager_id',
        ad_limit_set_by_page_admin: 'ad_limit_set_by_page_admin',
        ads_running_or_in_review_count: 'ads_running_or_in_review_count',
        ads_running_or_in_review_count_subject_to_limit_set_by_page: 'ads_running_or_in_review_count_subject_to_limit_set_by_page',
        current_account_ads_running_or_in_review_count: 'current_account_ads_running_or_in_review_count',
        future_limit_activation_date: 'future_limit_activation_date',
        future_limit_on_ads_running_or_in_review: 'future_limit_on_ads_running_or_in_review',
        limit_on_ads_running_or_in_review: 'limit_on_ads_running_or_in_review',
        recommendations: 'recommendations'
      });
    }
  }, {
    key: 'RecommendationType',
    get: function get() {
      return Object.freeze({
        aco_toggle: 'ACO_TOGGLE',
        aggregated_bid_limited: 'AGGREGATED_BID_LIMITED',
        aggregated_budget_limited: 'AGGREGATED_BUDGET_LIMITED',
        aggregated_cost_limited: 'AGGREGATED_COST_LIMITED',
        auction_overlap: 'AUCTION_OVERLAP',
        auction_overlap_consolidation: 'AUCTION_OVERLAP_CONSOLIDATION',
        audience_expansion: 'AUDIENCE_EXPANSION',
        autoflow_opt_in: 'AUTOFLOW_OPT_IN',
        automatic_placements: 'AUTOMATIC_PLACEMENTS',
        capi: 'CAPI',
        cost_goal: 'COST_GOAL',
        cost_goal_budget_limited: 'COST_GOAL_BUDGET_LIMITED',
        cost_goal_cpa_limited: 'COST_GOAL_CPA_LIMITED',
        creative_badge: 'CREATIVE_BADGE',
        creative_fatigue: 'CREATIVE_FATIGUE',
        creative_limited: 'CREATIVE_LIMITED',
        dead_link: 'DEAD_LINK',
        ecosystem_bid_reduce_l1_cardinality: 'ECOSYSTEM_BID_REDUCE_L1_CARDINALITY',
        fragmentation: 'FRAGMENTATION',
        learning_limited: 'LEARNING_LIMITED',
        low_outcome: 'LOW_OUTCOME',
        mmt_carousel_to_video: 'MMT_CAROUSEL_TO_VIDEO',
        multi_text: 'MULTI_TEXT',
        music: 'MUSIC',
        predictive_creative_limited: 'PREDICTIVE_CREATIVE_LIMITED',
        revert: 'REVERT',
        semantic_based_audience_expansion: 'SEMANTIC_BASED_AUDIENCE_EXPANSION',
        signals_growth_capi: 'SIGNALS_GROWTH_CAPI',
        syd_test_mode: 'SYD_TEST_MODE',
        top_adsets_with_ads_under_cap: 'TOP_ADSETS_WITH_ADS_UNDER_CAP',
        top_campaigns_with_ads_under_cap: 'TOP_CAMPAIGNS_WITH_ADS_UNDER_CAP',
        uneconomical_ads_throttling: 'UNECONOMICAL_ADS_THROTTLING',
        unused_budget: 'UNUSED_BUDGET',
        zero_impression: 'ZERO_IMPRESSION'
      });
    }
  }]);
  return AdAccountAdVolume;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AsyncRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AsyncRequest = function (_AbstractCrudObject) {
  inherits(AsyncRequest, _AbstractCrudObject);

  function AsyncRequest() {
    classCallCheck(this, AsyncRequest);
    return possibleConstructorReturn(this, (AsyncRequest.__proto__ || Object.getPrototypeOf(AsyncRequest)).apply(this, arguments));
  }

  createClass(AsyncRequest, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        result: 'result',
        status: 'status',
        type: 'type'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        error: 'ERROR',
        executing: 'EXECUTING',
        finished: 'FINISHED',
        initialized: 'INITIALIZED'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        async_adgroup_creation: 'ASYNC_ADGROUP_CREATION',
        batch_api: 'BATCH_API',
        drafts: 'DRAFTS'
      });
    }
  }]);
  return AsyncRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAsyncRequestSet
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAsyncRequestSet = function (_AbstractCrudObject) {
  inherits(AdAsyncRequestSet, _AbstractCrudObject);

  function AdAsyncRequestSet() {
    classCallCheck(this, AdAsyncRequestSet);
    return possibleConstructorReturn(this, (AdAsyncRequestSet.__proto__ || Object.getPrototypeOf(AdAsyncRequestSet)).apply(this, arguments));
  }

  createClass(AdAsyncRequestSet, [{
    key: 'getRequests',
    value: function getRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAsyncRequest, fields, params, fetchFirstPage, '/requests');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdAsyncRequestSet.prototype.__proto__ || Object.getPrototypeOf(AdAsyncRequestSet.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdAsyncRequestSet.prototype.__proto__ || Object.getPrototypeOf(AdAsyncRequestSet.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        canceled_count: 'canceled_count',
        created_time: 'created_time',
        error_count: 'error_count',
        id: 'id',
        in_progress_count: 'in_progress_count',
        initial_count: 'initial_count',
        is_completed: 'is_completed',
        name: 'name',
        notification_mode: 'notification_mode',
        notification_result: 'notification_result',
        notification_status: 'notification_status',
        notification_uri: 'notification_uri',
        owner_id: 'owner_id',
        success_count: 'success_count',
        total_count: 'total_count',
        updated_time: 'updated_time'
      });
    }
  }, {
    key: 'NotificationMode',
    get: function get() {
      return Object.freeze({
        off: 'OFF',
        on_complete: 'ON_COMPLETE'
      });
    }
  }]);
  return AdAsyncRequestSet;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BroadTargetingCategories
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BroadTargetingCategories = function (_AbstractCrudObject) {
  inherits(BroadTargetingCategories, _AbstractCrudObject);

  function BroadTargetingCategories() {
    classCallCheck(this, BroadTargetingCategories);
    return possibleConstructorReturn(this, (BroadTargetingCategories.__proto__ || Object.getPrototypeOf(BroadTargetingCategories)).apply(this, arguments));
  }

  createClass(BroadTargetingCategories, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        category_description: 'category_description',
        id: 'id',
        name: 'name',
        parent_category: 'parent_category',
        path: 'path',
        size_lower_bound: 'size_lower_bound',
        size_upper_bound: 'size_upper_bound',
        source: 'source',
        type: 'type',
        type_name: 'type_name',
        untranslated_name: 'untranslated_name',
        untranslated_parent_name: 'untranslated_parent_name'
      });
    }
  }]);
  return BroadTargetingCategories;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudiencesTOS
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudiencesTOS = function (_AbstractCrudObject) {
  inherits(CustomAudiencesTOS, _AbstractCrudObject);

  function CustomAudiencesTOS() {
    classCallCheck(this, CustomAudiencesTOS);
    return possibleConstructorReturn(this, (CustomAudiencesTOS.__proto__ || Object.getPrototypeOf(CustomAudiencesTOS)).apply(this, arguments));
  }

  createClass(CustomAudiencesTOS, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        content: 'content',
        id: 'id',
        type: 'type'
      });
    }
  }]);
  return CustomAudiencesTOS;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountDeliveryEstimate
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountDeliveryEstimate = function (_AbstractCrudObject) {
  inherits(AdAccountDeliveryEstimate, _AbstractCrudObject);

  function AdAccountDeliveryEstimate() {
    classCallCheck(this, AdAccountDeliveryEstimate);
    return possibleConstructorReturn(this, (AdAccountDeliveryEstimate.__proto__ || Object.getPrototypeOf(AdAccountDeliveryEstimate)).apply(this, arguments));
  }

  createClass(AdAccountDeliveryEstimate, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        daily_outcomes_curve: 'daily_outcomes_curve',
        estimate_dau: 'estimate_dau',
        estimate_mau_lower_bound: 'estimate_mau_lower_bound',
        estimate_mau_upper_bound: 'estimate_mau_upper_bound',
        estimate_ready: 'estimate_ready',
        targeting_optimization_types: 'targeting_optimization_types'
      });
    }
  }, {
    key: 'OptimizationGoal',
    get: function get() {
      return Object.freeze({
        ad_recall_lift: 'AD_RECALL_LIFT',
        app_installs: 'APP_INSTALLS',
        app_installs_and_offsite_conversions: 'APP_INSTALLS_AND_OFFSITE_CONVERSIONS',
        conversations: 'CONVERSATIONS',
        derived_events: 'DERIVED_EVENTS',
        engaged_users: 'ENGAGED_USERS',
        event_responses: 'EVENT_RESPONSES',
        impressions: 'IMPRESSIONS',
        in_app_value: 'IN_APP_VALUE',
        landing_page_views: 'LANDING_PAGE_VIEWS',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        messaging_appointment_conversion: 'MESSAGING_APPOINTMENT_CONVERSION',
        messaging_purchase_conversion: 'MESSAGING_PURCHASE_CONVERSION',
        none: 'NONE',
        offsite_conversions: 'OFFSITE_CONVERSIONS',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        quality_call: 'QUALITY_CALL',
        quality_lead: 'QUALITY_LEAD',
        reach: 'REACH',
        thruplay: 'THRUPLAY',
        value: 'VALUE',
        visit_instagram_profile: 'VISIT_INSTAGRAM_PROFILE'
      });
    }
  }]);
  return AdAccountDeliveryEstimate;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountIosFourteenCampaignLimits
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountIosFourteenCampaignLimits = function (_AbstractCrudObject) {
  inherits(AdAccountIosFourteenCampaignLimits, _AbstractCrudObject);

  function AdAccountIosFourteenCampaignLimits() {
    classCallCheck(this, AdAccountIosFourteenCampaignLimits);
    return possibleConstructorReturn(this, (AdAccountIosFourteenCampaignLimits.__proto__ || Object.getPrototypeOf(AdAccountIosFourteenCampaignLimits)).apply(this, arguments));
  }

  createClass(AdAccountIosFourteenCampaignLimits, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        campaign_group_limit: 'campaign_group_limit',
        campaign_group_limits_details: 'campaign_group_limits_details',
        campaign_limit: 'campaign_limit'
      });
    }
  }]);
  return AdAccountIosFourteenCampaignLimits;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountMatchedSearchApplicationsEdgeData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountMatchedSearchApplicationsEdgeData = function (_AbstractCrudObject) {
  inherits(AdAccountMatchedSearchApplicationsEdgeData, _AbstractCrudObject);

  function AdAccountMatchedSearchApplicationsEdgeData() {
    classCallCheck(this, AdAccountMatchedSearchApplicationsEdgeData);
    return possibleConstructorReturn(this, (AdAccountMatchedSearchApplicationsEdgeData.__proto__ || Object.getPrototypeOf(AdAccountMatchedSearchApplicationsEdgeData)).apply(this, arguments));
  }

  createClass(AdAccountMatchedSearchApplicationsEdgeData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_id: 'app_id',
        are_app_events_unavailable: 'are_app_events_unavailable',
        icon_url: 'icon_url',
        name: 'name',
        search_source_store: 'search_source_store',
        store: 'store',
        unique_id: 'unique_id',
        url: 'url'
      });
    }
  }, {
    key: 'AppStore',
    get: function get() {
      return Object.freeze({
        amazon_app_store: 'AMAZON_APP_STORE',
        apk_mirror: 'APK_MIRROR',
        apk_monk: 'APK_MONK',
        apk_pure: 'APK_PURE',
        aptoide_a1_store: 'APTOIDE_A1_STORE',
        bemobi_mobile_store: 'BEMOBI_MOBILE_STORE',
        does_not_exist: 'DOES_NOT_EXIST',
        fb_android_store: 'FB_ANDROID_STORE',
        fb_canvas: 'FB_CANVAS',
        fb_gameroom: 'FB_GAMEROOM',
        galaxy_store: 'GALAXY_STORE',
        google_play: 'GOOGLE_PLAY',
        instant_game: 'INSTANT_GAME',
        itunes: 'ITUNES',
        itunes_ipad: 'ITUNES_IPAD',
        oculus_app_store: 'OCULUS_APP_STORE',
        oppo: 'OPPO',
        roku_store: 'ROKU_STORE',
        uptodown: 'UPTODOWN',
        vivo: 'VIVO',
        windows_10_store: 'WINDOWS_10_STORE',
        windows_store: 'WINDOWS_STORE',
        xiaomi: 'XIAOMI'
      });
    }
  }]);
  return AdAccountMatchedSearchApplicationsEdgeData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountMaxBid
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountMaxBid = function (_AbstractCrudObject) {
  inherits(AdAccountMaxBid, _AbstractCrudObject);

  function AdAccountMaxBid() {
    classCallCheck(this, AdAccountMaxBid);
    return possibleConstructorReturn(this, (AdAccountMaxBid.__proto__ || Object.getPrototypeOf(AdAccountMaxBid)).apply(this, arguments));
  }

  createClass(AdAccountMaxBid, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        max_bid: 'max_bid'
      });
    }
  }]);
  return AdAccountMaxBid;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MinimumBudget
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MinimumBudget = function (_AbstractCrudObject) {
  inherits(MinimumBudget, _AbstractCrudObject);

  function MinimumBudget() {
    classCallCheck(this, MinimumBudget);
    return possibleConstructorReturn(this, (MinimumBudget.__proto__ || Object.getPrototypeOf(MinimumBudget)).apply(this, arguments));
  }

  createClass(MinimumBudget, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        currency: 'currency',
        min_daily_budget_high_freq: 'min_daily_budget_high_freq',
        min_daily_budget_imp: 'min_daily_budget_imp',
        min_daily_budget_low_freq: 'min_daily_budget_low_freq',
        min_daily_budget_video_views: 'min_daily_budget_video_views'
      });
    }
  }]);
  return MinimumBudget;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessOwnedObjectOnBehalfOfRequest
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessOwnedObjectOnBehalfOfRequest = function (_AbstractCrudObject) {
  inherits(BusinessOwnedObjectOnBehalfOfRequest, _AbstractCrudObject);

  function BusinessOwnedObjectOnBehalfOfRequest() {
    classCallCheck(this, BusinessOwnedObjectOnBehalfOfRequest);
    return possibleConstructorReturn(this, (BusinessOwnedObjectOnBehalfOfRequest.__proto__ || Object.getPrototypeOf(BusinessOwnedObjectOnBehalfOfRequest)).apply(this, arguments));
  }

  createClass(BusinessOwnedObjectOnBehalfOfRequest, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business_owned_object: 'business_owned_object',
        id: 'id',
        receiving_business: 'receiving_business',
        requesting_business: 'requesting_business',
        status: 'status'
      });
    }
  }, {
    key: 'Status',
    get: function get() {
      return Object.freeze({
        approve: 'APPROVE',
        decline: 'DECLINE',
        expired: 'EXPIRED',
        in_progress: 'IN_PROGRESS',
        pending: 'PENDING',
        pending_email_verification: 'PENDING_EMAIL_VERIFICATION',
        pending_integrity_review: 'PENDING_INTEGRITY_REVIEW'
      });
    }
  }]);
  return BusinessOwnedObjectOnBehalfOfRequest;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PublisherBlockList
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PublisherBlockList = function (_AbstractCrudObject) {
  inherits(PublisherBlockList, _AbstractCrudObject);

  function PublisherBlockList() {
    classCallCheck(this, PublisherBlockList);
    return possibleConstructorReturn(this, (PublisherBlockList.__proto__ || Object.getPrototypeOf(PublisherBlockList)).apply(this, arguments));
  }

  createClass(PublisherBlockList, [{
    key: 'createAppEndPublisherUrl',
    value: function createAppEndPublisherUrl(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/append_publisher_urls', fields, params, null, pathOverride);
    }
  }, {
    key: 'getPagedWebPublishers',
    value: function getPagedWebPublishers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/paged_web_publishers');
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'delete',
    value: function _delete(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PublisherBlockList.prototype.__proto__ || Object.getPrototypeOf(PublisherBlockList.prototype), 'delete', this).call(this, params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(PublisherBlockList.prototype.__proto__ || Object.getPrototypeOf(PublisherBlockList.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_publishers: 'app_publishers',
        business_owner_id: 'business_owner_id',
        id: 'id',
        is_auto_blocking_on: 'is_auto_blocking_on',
        is_eligible_at_campaign_level: 'is_eligible_at_campaign_level',
        last_update_time: 'last_update_time',
        last_update_user: 'last_update_user',
        name: 'name',
        owner_ad_account_id: 'owner_ad_account_id',
        web_publishers: 'web_publishers'
      });
    }
  }]);
  return PublisherBlockList;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountReachEstimate
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountReachEstimate = function (_AbstractCrudObject) {
  inherits(AdAccountReachEstimate, _AbstractCrudObject);

  function AdAccountReachEstimate() {
    classCallCheck(this, AdAccountReachEstimate);
    return possibleConstructorReturn(this, (AdAccountReachEstimate.__proto__ || Object.getPrototypeOf(AdAccountReachEstimate)).apply(this, arguments));
  }

  createClass(AdAccountReachEstimate, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        estimate_ready: 'estimate_ready',
        users_lower_bound: 'users_lower_bound',
        users_upper_bound: 'users_upper_bound'
      });
    }
  }]);
  return AdAccountReachEstimate;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyPrediction
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyPrediction = function (_AbstractCrudObject) {
  inherits(ReachFrequencyPrediction, _AbstractCrudObject);

  function ReachFrequencyPrediction() {
    classCallCheck(this, ReachFrequencyPrediction);
    return possibleConstructorReturn(this, (ReachFrequencyPrediction.__proto__ || Object.getPrototypeOf(ReachFrequencyPrediction)).apply(this, arguments));
  }

  createClass(ReachFrequencyPrediction, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        activity_status: 'activity_status',
        ad_formats: 'ad_formats',
        auction_entry_option_index: 'auction_entry_option_index',
        audience_size_lower_bound: 'audience_size_lower_bound',
        audience_size_upper_bound: 'audience_size_upper_bound',
        business_id: 'business_id',
        buying_type: 'buying_type',
        campaign_group_id: 'campaign_group_id',
        campaign_id: 'campaign_id',
        campaign_time_start: 'campaign_time_start',
        campaign_time_stop: 'campaign_time_stop',
        currency: 'currency',
        curve_budget_reach: 'curve_budget_reach',
        curve_reach: 'curve_reach',
        daily_grp_curve: 'daily_grp_curve',
        daily_impression_curve: 'daily_impression_curve',
        daily_impression_curve_map: 'daily_impression_curve_map',
        day_parting_schedule: 'day_parting_schedule',
        destination_id: 'destination_id',
        end_time: 'end_time',
        expiration_time: 'expiration_time',
        external_budget: 'external_budget',
        external_impression: 'external_impression',
        external_maximum_budget: 'external_maximum_budget',
        external_maximum_impression: 'external_maximum_impression',
        external_maximum_reach: 'external_maximum_reach',
        external_minimum_budget: 'external_minimum_budget',
        external_minimum_impression: 'external_minimum_impression',
        external_minimum_reach: 'external_minimum_reach',
        external_reach: 'external_reach',
        feed_ratio_0000: 'feed_ratio_0000',
        frequency_cap: 'frequency_cap',
        frequency_distribution_map: 'frequency_distribution_map',
        frequency_distribution_map_agg: 'frequency_distribution_map_agg',
        grp_audience_size: 'grp_audience_size',
        grp_avg_probability_map: 'grp_avg_probability_map',
        grp_country_audience_size: 'grp_country_audience_size',
        grp_curve: 'grp_curve',
        grp_dmas_audience_size: 'grp_dmas_audience_size',
        grp_filtering_threshold_00: 'grp_filtering_threshold_00',
        grp_points: 'grp_points',
        grp_ratio: 'grp_ratio',
        grp_reach_ratio: 'grp_reach_ratio',
        grp_status: 'grp_status',
        holdout_percentage: 'holdout_percentage',
        id: 'id',
        impression_curve: 'impression_curve',
        instagram_destination_id: 'instagram_destination_id',
        instream_packages: 'instream_packages',
        interval_frequency_cap: 'interval_frequency_cap',
        interval_frequency_cap_reset_period: 'interval_frequency_cap_reset_period',
        is_bonus_media: 'is_bonus_media',
        is_conversion_goal: 'is_conversion_goal',
        is_higher_average_frequency: 'is_higher_average_frequency',
        is_io: 'is_io',
        is_reserved_buying: 'is_reserved_buying',
        is_trp: 'is_trp',
        name: 'name',
        objective: 'objective',
        objective_name: 'objective_name',
        odax_objective: 'odax_objective',
        odax_objective_name: 'odax_objective_name',
        optimization_goal: 'optimization_goal',
        optimization_goal_name: 'optimization_goal_name',
        pause_periods: 'pause_periods',
        placement_breakdown: 'placement_breakdown',
        placement_breakdown_map: 'placement_breakdown_map',
        plan_name: 'plan_name',
        plan_type: 'plan_type',
        prediction_mode: 'prediction_mode',
        prediction_progress: 'prediction_progress',
        reference_id: 'reference_id',
        reservation_status: 'reservation_status',
        start_time: 'start_time',
        status: 'status',
        story_event_type: 'story_event_type',
        target_cpm: 'target_cpm',
        target_spec: 'target_spec',
        time_created: 'time_created',
        time_updated: 'time_updated',
        timezone_id: 'timezone_id',
        timezone_name: 'timezone_name',
        topline_id: 'topline_id',
        video_view_length_constraint: 'video_view_length_constraint',
        viewtag: 'viewtag'
      });
    }
  }, {
    key: 'Action',
    get: function get() {
      return Object.freeze({
        cancel: 'cancel',
        quote: 'quote',
        reserve: 'reserve'
      });
    }
  }, {
    key: 'BuyingType',
    get: function get() {
      return Object.freeze({
        auction: 'AUCTION',
        deprecated_reach_block: 'DEPRECATED_REACH_BLOCK',
        fixed_cpm: 'FIXED_CPM',
        mixed: 'MIXED',
        reachblock: 'REACHBLOCK',
        research_poll: 'RESEARCH_POLL',
        reserved: 'RESERVED'
      });
    }
  }, {
    key: 'InstreamPackages',
    get: function get() {
      return Object.freeze({
        beauty: 'BEAUTY',
        entertainment: 'ENTERTAINMENT',
        food: 'FOOD',
        normal: 'NORMAL',
        premium: 'PREMIUM',
        regular_animals_pets: 'REGULAR_ANIMALS_PETS',
        regular_food: 'REGULAR_FOOD',
        regular_games: 'REGULAR_GAMES',
        regular_politics: 'REGULAR_POLITICS',
        regular_sports: 'REGULAR_SPORTS',
        regular_style: 'REGULAR_STYLE',
        regular_tv_movies: 'REGULAR_TV_MOVIES',
        spanish: 'SPANISH',
        sports: 'SPORTS'
      });
    }
  }]);
  return ReachFrequencyPrediction;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * SavedAudience
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var SavedAudience = function (_AbstractCrudObject) {
  inherits(SavedAudience, _AbstractCrudObject);

  function SavedAudience() {
    classCallCheck(this, SavedAudience);
    return possibleConstructorReturn(this, (SavedAudience.__proto__ || Object.getPrototypeOf(SavedAudience)).apply(this, arguments));
  }

  createClass(SavedAudience, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account: 'account',
        approximate_count_lower_bound: 'approximate_count_lower_bound',
        approximate_count_upper_bound: 'approximate_count_upper_bound',
        delete_time: 'delete_time',
        description: 'description',
        extra_info: 'extra_info',
        id: 'id',
        name: 'name',
        operation_status: 'operation_status',
        owner_business: 'owner_business',
        page_deletion_marked_delete_time: 'page_deletion_marked_delete_time',
        permission_for_actions: 'permission_for_actions',
        run_status: 'run_status',
        sentence_lines: 'sentence_lines',
        targeting: 'targeting',
        time_created: 'time_created',
        time_updated: 'time_updated'
      });
    }
  }]);
  return SavedAudience;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountSubscribedApps
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountSubscribedApps = function (_AbstractCrudObject) {
  inherits(AdAccountSubscribedApps, _AbstractCrudObject);

  function AdAccountSubscribedApps() {
    classCallCheck(this, AdAccountSubscribedApps);
    return possibleConstructorReturn(this, (AdAccountSubscribedApps.__proto__ || Object.getPrototypeOf(AdAccountSubscribedApps)).apply(this, arguments));
  }

  createClass(AdAccountSubscribedApps, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_id: 'app_id',
        app_name: 'app_name'
      });
    }
  }]);
  return AdAccountSubscribedApps;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountTargetingUnified
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountTargetingUnified = function (_AbstractCrudObject) {
  inherits(AdAccountTargetingUnified, _AbstractCrudObject);

  function AdAccountTargetingUnified() {
    classCallCheck(this, AdAccountTargetingUnified);
    return possibleConstructorReturn(this, (AdAccountTargetingUnified.__proto__ || Object.getPrototypeOf(AdAccountTargetingUnified)).apply(this, arguments));
  }

  createClass(AdAccountTargetingUnified, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        audience_size_lower_bound: 'audience_size_lower_bound',
        audience_size_upper_bound: 'audience_size_upper_bound',
        conversion_lift: 'conversion_lift',
        description: 'description',
        id: 'id',
        img: 'img',
        info: 'info',
        info_title: 'info_title',
        is_recommendation: 'is_recommendation',
        key: 'key',
        link: 'link',
        name: 'name',
        parent: 'parent',
        partner: 'partner',
        path: 'path',
        performance_rating: 'performance_rating',
        raw_name: 'raw_name',
        recommendation_model: 'recommendation_model',
        search_interest_id: 'search_interest_id',
        source: 'source',
        spend: 'spend',
        type: 'type',
        valid: 'valid'
      });
    }
  }, {
    key: 'LimitType',
    get: function get() {
      return Object.freeze({
        behaviors: 'behaviors',
        college_years: 'college_years',
        education_majors: 'education_majors',
        education_schools: 'education_schools',
        education_statuses: 'education_statuses',
        ethnic_affinity: 'ethnic_affinity',
        family_statuses: 'family_statuses',
        generation: 'generation',
        home_ownership: 'home_ownership',
        home_type: 'home_type',
        home_value: 'home_value',
        household_composition: 'household_composition',
        income: 'income',
        industries: 'industries',
        interested_in: 'interested_in',
        interests: 'interests',
        life_events: 'life_events',
        location_categories: 'location_categories',
        moms: 'moms',
        net_worth: 'net_worth',
        office_type: 'office_type',
        politics: 'politics',
        relationship_statuses: 'relationship_statuses',
        user_adclusters: 'user_adclusters',
        work_employers: 'work_employers',
        work_positions: 'work_positions'
      });
    }
  }, {
    key: 'RegulatedCategories',
    get: function get() {
      return Object.freeze({
        credit: 'CREDIT',
        employment: 'EMPLOYMENT',
        housing: 'HOUSING',
        issues_elections_politics: 'ISSUES_ELECTIONS_POLITICS',
        none: 'NONE',
        online_gambling_and_gaming: 'ONLINE_GAMBLING_AND_GAMING'
      });
    }
  }, {
    key: 'WhitelistedTypes',
    get: function get() {
      return Object.freeze({
        adgroup_id: 'adgroup_id',
        age_max: 'age_max',
        age_min: 'age_min',
        alternate_auto_targeting_option: 'alternate_auto_targeting_option',
        app_install_state: 'app_install_state',
        audience_network_positions: 'audience_network_positions',
        behaviors: 'behaviors',
        brand_safety_content_filter_levels: 'brand_safety_content_filter_levels',
        brand_safety_content_severity_levels: 'brand_safety_content_severity_levels',
        catalog_based_targeting: 'catalog_based_targeting',
        cities: 'cities',
        city_keys: 'city_keys',
        college_years: 'college_years',
        conjunctive_user_adclusters: 'conjunctive_user_adclusters',
        connections: 'connections',
        contextual_targeting_categories: 'contextual_targeting_categories',
        countries: 'countries',
        country: 'country',
        country_groups: 'country_groups',
        custom_audiences: 'custom_audiences',
        device_platforms: 'device_platforms',
        direct_install_devices: 'direct_install_devices',
        dynamic_audience_ids: 'dynamic_audience_ids',
        education_majors: 'education_majors',
        education_schools: 'education_schools',
        education_statuses: 'education_statuses',
        effective_audience_network_positions: 'effective_audience_network_positions',
        effective_device_platforms: 'effective_device_platforms',
        effective_facebook_positions: 'effective_facebook_positions',
        effective_instagram_positions: 'effective_instagram_positions',
        effective_messenger_positions: 'effective_messenger_positions',
        effective_oculus_positions: 'effective_oculus_positions',
        effective_publisher_platforms: 'effective_publisher_platforms',
        effective_whatsapp_positions: 'effective_whatsapp_positions',
        engagement_specs: 'engagement_specs',
        ethnic_affinity: 'ethnic_affinity',
        exclude_previous_days: 'exclude_previous_days',
        exclude_reached_since: 'exclude_reached_since',
        excluded_brand_safety_content_types: 'excluded_brand_safety_content_types',
        excluded_connections: 'excluded_connections',
        excluded_custom_audiences: 'excluded_custom_audiences',
        excluded_dynamic_audience_ids: 'excluded_dynamic_audience_ids',
        excluded_engagement_specs: 'excluded_engagement_specs',
        excluded_geo_locations: 'excluded_geo_locations',
        excluded_mobile_device_model: 'excluded_mobile_device_model',
        excluded_product_audience_specs: 'excluded_product_audience_specs',
        excluded_publisher_categories: 'excluded_publisher_categories',
        excluded_publisher_list_ids: 'excluded_publisher_list_ids',
        excluded_user_adclusters: 'excluded_user_adclusters',
        excluded_user_device: 'excluded_user_device',
        exclusions: 'exclusions',
        facebook_positions: 'facebook_positions',
        family_statuses: 'family_statuses',
        fb_deal_id: 'fb_deal_id',
        flexible_spec: 'flexible_spec',
        follow_profiles: 'follow_profiles',
        follow_profiles_negative: 'follow_profiles_negative',
        format: 'format',
        friends_of_connections: 'friends_of_connections',
        gatekeepers: 'gatekeepers',
        genders: 'genders',
        generation: 'generation',
        geo_locations: 'geo_locations',
        home_ownership: 'home_ownership',
        home_type: 'home_type',
        home_value: 'home_value',
        household_composition: 'household_composition',
        id: 'id',
        income: 'income',
        industries: 'industries',
        instagram_hashtags: 'instagram_hashtags',
        instagram_positions: 'instagram_positions',
        instream_video_skippable_excluded: 'instream_video_skippable_excluded',
        instream_video_sponsorship_placements: 'instream_video_sponsorship_placements',
        interest_defaults_source: 'interest_defaults_source',
        interested_in: 'interested_in',
        interests: 'interests',
        is_instagram_destination_ad: 'is_instagram_destination_ad',
        is_whatsapp_destination_ad: 'is_whatsapp_destination_ad',
        keywords: 'keywords',
        life_events: 'life_events',
        locales: 'locales',
        location_categories: 'location_categories',
        location_cluster_ids: 'location_cluster_ids',
        location_expansion: 'location_expansion',
        marketplace_product_categories: 'marketplace_product_categories',
        messenger_positions: 'messenger_positions',
        mobile_device_model: 'mobile_device_model',
        moms: 'moms',
        net_worth: 'net_worth',
        oculus_positions: 'oculus_positions',
        office_type: 'office_type',
        page_types: 'page_types',
        place_page_set_ids: 'place_page_set_ids',
        political_views: 'political_views',
        politics: 'politics',
        product_audience_specs: 'product_audience_specs',
        prospecting_audience: 'prospecting_audience',
        publisher_platforms: 'publisher_platforms',
        radius: 'radius',
        region_keys: 'region_keys',
        regions: 'regions',
        relationship_statuses: 'relationship_statuses',
        rtb_flag: 'rtb_flag',
        site_category: 'site_category',
        targeting_automation: 'targeting_automation',
        targeting_optimization: 'targeting_optimization',
        targeting_relaxation_types: 'targeting_relaxation_types',
        timezones: 'timezones',
        topic: 'topic',
        trending: 'trending',
        user_adclusters: 'user_adclusters',
        user_device: 'user_device',
        user_event: 'user_event',
        user_os: 'user_os',
        user_page_threads: 'user_page_threads',
        user_page_threads_excluded: 'user_page_threads_excluded',
        whatsapp_positions: 'whatsapp_positions',
        wireless_carrier: 'wireless_carrier',
        work_employers: 'work_employers',
        work_positions: 'work_positions',
        zips: 'zips'
      });
    }
  }, {
    key: 'AppStore',
    get: function get() {
      return Object.freeze({
        amazon_app_store: 'amazon_app_store',
        apk_mirror: 'apk_mirror',
        apk_monk: 'apk_monk',
        apk_pure: 'apk_pure',
        aptoide_a1_store: 'aptoide_a1_store',
        bemobi_mobile_store: 'bemobi_mobile_store',
        does_not_exist: 'does_not_exist',
        fb_android_store: 'fb_android_store',
        fb_canvas: 'fb_canvas',
        fb_gameroom: 'fb_gameroom',
        galaxy_store: 'galaxy_store',
        google_play: 'google_play',
        instant_game: 'instant_game',
        itunes: 'itunes',
        itunes_ipad: 'itunes_ipad',
        oculus_app_store: 'oculus_app_store',
        oppo: 'oppo',
        roku_channel_store: 'roku_channel_store',
        uptodown: 'uptodown',
        vivo: 'vivo',
        windows_10_store: 'windows_10_store',
        windows_store: 'windows_store',
        xiaomi: 'xiaomi'
      });
    }
  }, {
    key: 'Objective',
    get: function get() {
      return Object.freeze({
        app_installs: 'APP_INSTALLS',
        brand_awareness: 'BRAND_AWARENESS',
        conversions: 'CONVERSIONS',
        event_responses: 'EVENT_RESPONSES',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        local_awareness: 'LOCAL_AWARENESS',
        messages: 'MESSAGES',
        offer_claims: 'OFFER_CLAIMS',
        outcome_app_promotion: 'OUTCOME_APP_PROMOTION',
        outcome_awareness: 'OUTCOME_AWARENESS',
        outcome_engagement: 'OUTCOME_ENGAGEMENT',
        outcome_leads: 'OUTCOME_LEADS',
        outcome_sales: 'OUTCOME_SALES',
        outcome_traffic: 'OUTCOME_TRAFFIC',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        product_catalog_sales: 'PRODUCT_CATALOG_SALES',
        reach: 'REACH',
        store_visits: 'STORE_VISITS',
        video_views: 'VIDEO_VIEWS'
      });
    }
  }, {
    key: 'Mode',
    get: function get() {
      return Object.freeze({
        best_performing: 'best_performing',
        recently_used: 'recently_used',
        related: 'related',
        suggestions: 'suggestions'
      });
    }
  }]);
  return AdAccountTargetingUnified;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountTrackingData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountTrackingData = function (_AbstractCrudObject) {
  inherits(AdAccountTrackingData, _AbstractCrudObject);

  function AdAccountTrackingData() {
    classCallCheck(this, AdAccountTrackingData);
    return possibleConstructorReturn(this, (AdAccountTrackingData.__proto__ || Object.getPrototypeOf(AdAccountTrackingData)).apply(this, arguments));
  }

  createClass(AdAccountTrackingData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        tracking_specs: 'tracking_specs'
      });
    }
  }]);
  return AdAccountTrackingData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountUser
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountUser = function (_AbstractCrudObject) {
  inherits(AdAccountUser, _AbstractCrudObject);

  function AdAccountUser() {
    classCallCheck(this, AdAccountUser);
    return possibleConstructorReturn(this, (AdAccountUser.__proto__ || Object.getPrototypeOf(AdAccountUser)).apply(this, arguments));
  }

  createClass(AdAccountUser, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name',
        tasks: 'tasks'
      });
    }
  }]);
  return AdAccountUser;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccount
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccount = function (_AbstractCrudObject) {
  inherits(AdAccount, _AbstractCrudObject);

  function AdAccount() {
    classCallCheck(this, AdAccount);
    return possibleConstructorReturn(this, (AdAccount.__proto__ || Object.getPrototypeOf(AdAccount)).apply(this, arguments));
  }

  createClass(AdAccount, [{
    key: 'getActivities',
    value: function getActivities(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdActivity, fields, params, fetchFirstPage, '/activities');
    }
  }, {
    key: 'getAdPlacePageSets',
    value: function getAdPlacePageSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdPlacePageSet, fields, params, fetchFirstPage, '/ad_place_page_sets');
    }
  }, {
    key: 'createAdPlacePageSet',
    value: function createAdPlacePageSet(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/ad_place_page_sets', fields, params, AdPlacePageSet, pathOverride);
    }
  }, {
    key: 'createAdPlacePageSetsAsync',
    value: function createAdPlacePageSetsAsync(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/ad_place_page_sets_async', fields, params, AdPlacePageSet, pathOverride);
    }
  }, {
    key: 'getAdSavedKeywords',
    value: function getAdSavedKeywords(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ad_saved_keywords');
    }
  }, {
    key: 'getAdStudies',
    value: function getAdStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudy, fields, params, fetchFirstPage, '/ad_studies');
    }
  }, {
    key: 'getAdCloudPlayables',
    value: function getAdCloudPlayables(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CloudGame, fields, params, fetchFirstPage, '/adcloudplayables');
    }
  }, {
    key: 'getAdCreatives',
    value: function getAdCreatives(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCreative, fields, params, fetchFirstPage, '/adcreatives');
    }
  }, {
    key: 'createAdCreative',
    value: function createAdCreative(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adcreatives', fields, params, AdCreative, pathOverride);
    }
  }, {
    key: 'getAdCreativesByLabels',
    value: function getAdCreativesByLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdCreative, fields, params, fetchFirstPage, '/adcreativesbylabels');
    }
  }, {
    key: 'deleteAdImages',
    value: function deleteAdImages() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/adimages', params);
    }
  }, {
    key: 'getAdImages',
    value: function getAdImages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdImage, fields, params, fetchFirstPage, '/adimages');
    }
  }, {
    key: 'createAdImage',
    value: function createAdImage(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adimages', fields, params, AdImage, pathOverride);
    }
  }, {
    key: 'getAdLabels',
    value: function getAdLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdLabel, fields, params, fetchFirstPage, '/adlabels');
    }
  }, {
    key: 'createAdLabel',
    value: function createAdLabel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adlabels', fields, params, AdLabel, pathOverride);
    }
  }, {
    key: 'getAdPlayables',
    value: function getAdPlayables(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PlayableContent, fields, params, fetchFirstPage, '/adplayables');
    }
  }, {
    key: 'createAdPlayable',
    value: function createAdPlayable(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adplayables', fields, params, PlayableContent, pathOverride);
    }
  }, {
    key: 'getAdRulesHistory',
    value: function getAdRulesHistory(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountAdRulesHistory, fields, params, fetchFirstPage, '/adrules_history');
    }
  }, {
    key: 'getAdRulesLibrary',
    value: function getAdRulesLibrary(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdRule, fields, params, fetchFirstPage, '/adrules_library');
    }
  }, {
    key: 'createAdRulesLibrary',
    value: function createAdRulesLibrary(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adrules_library', fields, params, AdRule, pathOverride);
    }
  }, {
    key: 'getAds',
    value: function getAds(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/ads');
    }
  }, {
    key: 'createAd',
    value: function createAd(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/ads', fields, params, Ad, pathOverride);
    }
  }, {
    key: 'getAdsReportingMmmReports',
    value: function getAdsReportingMmmReports(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ads_reporting_mmm_reports');
    }
  }, {
    key: 'getAdsReportingMmmSchedulers',
    value: function getAdsReportingMmmSchedulers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/ads_reporting_mmm_schedulers');
    }
  }, {
    key: 'getAdsVolume',
    value: function getAdsVolume(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountAdVolume, fields, params, fetchFirstPage, '/ads_volume');
    }
  }, {
    key: 'getAdsByLabels',
    value: function getAdsByLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Ad, fields, params, fetchFirstPage, '/adsbylabels');
    }
  }, {
    key: 'getAdSets',
    value: function getAdSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/adsets');
    }
  }, {
    key: 'createAdSet',
    value: function createAdSet(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adsets', fields, params, AdSet, pathOverride);
    }
  }, {
    key: 'getAdSetsByLabels',
    value: function getAdSetsByLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/adsetsbylabels');
    }
  }, {
    key: 'getAdsPixels',
    value: function getAdsPixels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixel, fields, params, fetchFirstPage, '/adspixels');
    }
  }, {
    key: 'createAdsPixel',
    value: function createAdsPixel(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adspixels', fields, params, AdsPixel, pathOverride);
    }
  }, {
    key: 'getAdvertisableApplications',
    value: function getAdvertisableApplications(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/advertisable_applications');
    }
  }, {
    key: 'deleteAdVideos',
    value: function deleteAdVideos() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/advideos', params);
    }
  }, {
    key: 'getAdVideos',
    value: function getAdVideos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdVideo, fields, params, fetchFirstPage, '/advideos');
    }
  }, {
    key: 'createAdVideo',
    value: function createAdVideo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/advideos', fields, params, AdVideo, pathOverride);
    }
  }, {
    key: 'getAffectedAdSets',
    value: function getAffectedAdSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/affectedadsets');
    }
  }, {
    key: 'deleteAgencies',
    value: function deleteAgencies() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/agencies', params);
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'getApplications',
    value: function getApplications(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Application, fields, params, fetchFirstPage, '/applications');
    }
  }, {
    key: 'deleteAssignedUsers',
    value: function deleteAssignedUsers() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/assigned_users', params);
    }
  }, {
    key: 'getAssignedUsers',
    value: function getAssignedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AssignedUser, fields, params, fetchFirstPage, '/assigned_users');
    }
  }, {
    key: 'createAssignedUser',
    value: function createAssignedUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assigned_users', fields, params, AdAccount, pathOverride);
    }
  }, {
    key: 'createAsyncBatchRequest',
    value: function createAsyncBatchRequest(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/async_batch_requests', fields, params, Campaign, pathOverride);
    }
  }, {
    key: 'getAsyncRequests',
    value: function getAsyncRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AsyncRequest, fields, params, fetchFirstPage, '/async_requests');
    }
  }, {
    key: 'getAsyncAdRequestSets',
    value: function getAsyncAdRequestSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAsyncRequestSet, fields, params, fetchFirstPage, '/asyncadrequestsets');
    }
  }, {
    key: 'createAsyncAdRequestSet',
    value: function createAsyncAdRequestSet(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/asyncadrequestsets', fields, params, AdAsyncRequestSet, pathOverride);
    }
  }, {
    key: 'createBlockListDraft',
    value: function createBlockListDraft(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/block_list_drafts', fields, params, AdAccount, pathOverride);
    }
  }, {
    key: 'getBroadTargetingCategories',
    value: function getBroadTargetingCategories(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BroadTargetingCategories, fields, params, fetchFirstPage, '/broadtargetingcategories');
    }
  }, {
    key: 'getBusinessProjects',
    value: function getBusinessProjects(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/businessprojects');
    }
  }, {
    key: 'deleteCampaigns',
    value: function deleteCampaigns() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/campaigns', params);
    }
  }, {
    key: 'getCampaigns',
    value: function getCampaigns(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Campaign, fields, params, fetchFirstPage, '/campaigns');
    }
  }, {
    key: 'createCampaign',
    value: function createCampaign(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/campaigns', fields, params, Campaign, pathOverride);
    }
  }, {
    key: 'getCampaignsByLabels',
    value: function getCampaignsByLabels(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Campaign, fields, params, fetchFirstPage, '/campaignsbylabels');
    }
  }, {
    key: 'getConnectedInstagramAccounts',
    value: function getConnectedInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(IGUser, fields, params, fetchFirstPage, '/connected_instagram_accounts');
    }
  }, {
    key: 'getCustomAudiences',
    value: function getCustomAudiences(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomAudience, fields, params, fetchFirstPage, '/customaudiences');
    }
  }, {
    key: 'createCustomAudience',
    value: function createCustomAudience(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/customaudiences', fields, params, CustomAudience, pathOverride);
    }
  }, {
    key: 'getCustomAudiencesTos',
    value: function getCustomAudiencesTos(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomAudiencesTOS, fields, params, fetchFirstPage, '/customaudiencestos');
    }
  }, {
    key: 'createCustomAudiencesTo',
    value: function createCustomAudiencesTo(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/customaudiencestos', fields, params, AdAccount, pathOverride);
    }
  }, {
    key: 'getCustomConversions',
    value: function getCustomConversions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CustomConversion, fields, params, fetchFirstPage, '/customconversions');
    }
  }, {
    key: 'createCustomConversion',
    value: function createCustomConversion(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/customconversions', fields, params, CustomConversion, pathOverride);
    }
  }, {
    key: 'getDeliveryEstimate',
    value: function getDeliveryEstimate(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountDeliveryEstimate, fields, params, fetchFirstPage, '/delivery_estimate');
    }
  }, {
    key: 'getDeprecatedTargetingAdSets',
    value: function getDeprecatedTargetingAdSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdSet, fields, params, fetchFirstPage, '/deprecatedtargetingadsets');
    }
  }, {
    key: 'getGeneratePreviews',
    value: function getGeneratePreviews(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdPreview, fields, params, fetchFirstPage, '/generatepreviews');
    }
  }, {
    key: 'getImpactingAdStudies',
    value: function getImpactingAdStudies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdStudy, fields, params, fetchFirstPage, '/impacting_ad_studies');
    }
  }, {
    key: 'getInsights',
    value: function getInsights(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsInsights, fields, params, fetchFirstPage, '/insights');
    }
  }, {
    key: 'getInsightsAsync',
    value: function getInsightsAsync(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/insights', fields, params, AdReportRun, pathOverride);
    }
  }, {
    key: 'getInstagramAccounts',
    value: function getInstagramAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(InstagramUser, fields, params, fetchFirstPage, '/instagram_accounts');
    }
  }, {
    key: 'getIosFourteenCampaignLimits',
    value: function getIosFourteenCampaignLimits(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountIosFourteenCampaignLimits, fields, params, fetchFirstPage, '/ios_fourteen_campaign_limits');
    }
  }, {
    key: 'createManagedPartnerAd',
    value: function createManagedPartnerAd(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/managed_partner_ads', fields, params, null, pathOverride);
    }
  }, {
    key: 'getMatchedSearchApplications',
    value: function getMatchedSearchApplications(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountMatchedSearchApplicationsEdgeData, fields, params, fetchFirstPage, '/matched_search_applications');
    }
  }, {
    key: 'getMaxBid',
    value: function getMaxBid(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountMaxBid, fields, params, fetchFirstPage, '/max_bid');
    }
  }, {
    key: 'getMinimumBudgets',
    value: function getMinimumBudgets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(MinimumBudget, fields, params, fetchFirstPage, '/minimum_budgets');
    }
  }, {
    key: 'getOfflineConversionDataSets',
    value: function getOfflineConversionDataSets(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OfflineConversionDataSet, fields, params, fetchFirstPage, '/offline_conversion_data_sets');
    }
  }, {
    key: 'getOnBehalfRequests',
    value: function getOnBehalfRequests(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(BusinessOwnedObjectOnBehalfOfRequest, fields, params, fetchFirstPage, '/onbehalf_requests');
    }
  }, {
    key: 'createProductAudience',
    value: function createProductAudience(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/product_audiences', fields, params, CustomAudience, pathOverride);
    }
  }, {
    key: 'getPromotePages',
    value: function getPromotePages(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Page, fields, params, fetchFirstPage, '/promote_pages');
    }
  }, {
    key: 'getPublisherBlockLists',
    value: function getPublisherBlockLists(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(PublisherBlockList, fields, params, fetchFirstPage, '/publisher_block_lists');
    }
  }, {
    key: 'createPublisherBlockList',
    value: function createPublisherBlockList(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/publisher_block_lists', fields, params, PublisherBlockList, pathOverride);
    }
  }, {
    key: 'getReachEstimate',
    value: function getReachEstimate(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountReachEstimate, fields, params, fetchFirstPage, '/reachestimate');
    }
  }, {
    key: 'getReachFrequencyPredictions',
    value: function getReachFrequencyPredictions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(ReachFrequencyPrediction, fields, params, fetchFirstPage, '/reachfrequencypredictions');
    }
  }, {
    key: 'createReachFrequencyPrediction',
    value: function createReachFrequencyPrediction(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/reachfrequencypredictions', fields, params, ReachFrequencyPrediction, pathOverride);
    }
  }, {
    key: 'getSavedAudiences',
    value: function getSavedAudiences(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(SavedAudience, fields, params, fetchFirstPage, '/saved_audiences');
    }
  }, {
    key: 'deleteSubscribedApps',
    value: function deleteSubscribedApps() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/subscribed_apps', params);
    }
  }, {
    key: 'getSubscribedApps',
    value: function getSubscribedApps(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountSubscribedApps, fields, params, fetchFirstPage, '/subscribed_apps');
    }
  }, {
    key: 'createSubscribedApp',
    value: function createSubscribedApp(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/subscribed_apps', fields, params, AdAccountSubscribedApps, pathOverride);
    }
  }, {
    key: 'getTargetingBrowse',
    value: function getTargetingBrowse(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountTargetingUnified, fields, params, fetchFirstPage, '/targetingbrowse');
    }
  }, {
    key: 'getTargetingSearch',
    value: function getTargetingSearch(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountTargetingUnified, fields, params, fetchFirstPage, '/targetingsearch');
    }
  }, {
    key: 'getTargetingSentenceLines',
    value: function getTargetingSentenceLines(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(TargetingSentenceLine, fields, params, fetchFirstPage, '/targetingsentencelines');
    }
  }, {
    key: 'getTargetingSuggestions',
    value: function getTargetingSuggestions(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountTargetingUnified, fields, params, fetchFirstPage, '/targetingsuggestions');
    }
  }, {
    key: 'getTargetingValidation',
    value: function getTargetingValidation(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountTargetingUnified, fields, params, fetchFirstPage, '/targetingvalidation');
    }
  }, {
    key: 'getTracking',
    value: function getTracking(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountTrackingData, fields, params, fetchFirstPage, '/tracking');
    }
  }, {
    key: 'createTracking',
    value: function createTracking(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/tracking', fields, params, AdAccount, pathOverride);
    }
  }, {
    key: 'getUsers',
    value: function getUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccountUser, fields, params, fetchFirstPage, '/users');
    }
  }, {
    key: 'deleteUsersOfAnyAudience',
    value: function deleteUsersOfAnyAudience() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'deleteEdge', this).call(this, '/usersofanyaudience', params);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdAccount.prototype.__proto__ || Object.getPrototypeOf(AdAccount.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        account_status: 'account_status',
        ad_account_promotable_objects: 'ad_account_promotable_objects',
        age: 'age',
        agency_client_declaration: 'agency_client_declaration',
        amount_spent: 'amount_spent',
        attribution_spec: 'attribution_spec',
        balance: 'balance',
        business: 'business',
        business_city: 'business_city',
        business_country_code: 'business_country_code',
        business_name: 'business_name',
        business_state: 'business_state',
        business_street: 'business_street',
        business_street2: 'business_street2',
        business_zip: 'business_zip',
        can_create_brand_lift_study: 'can_create_brand_lift_study',
        capabilities: 'capabilities',
        created_time: 'created_time',
        currency: 'currency',
        custom_audience_info: 'custom_audience_info',
        disable_reason: 'disable_reason',
        end_advertiser: 'end_advertiser',
        end_advertiser_name: 'end_advertiser_name',
        existing_customers: 'existing_customers',
        extended_credit_invoice_group: 'extended_credit_invoice_group',
        failed_delivery_checks: 'failed_delivery_checks',
        fb_entity: 'fb_entity',
        funding_source: 'funding_source',
        funding_source_details: 'funding_source_details',
        has_advertiser_opted_in_odax: 'has_advertiser_opted_in_odax',
        has_migrated_permissions: 'has_migrated_permissions',
        has_page_authorized_adaccount: 'has_page_authorized_adaccount',
        id: 'id',
        io_number: 'io_number',
        is_attribution_spec_system_default: 'is_attribution_spec_system_default',
        is_direct_deals_enabled: 'is_direct_deals_enabled',
        is_in_3ds_authorization_enabled_market: 'is_in_3ds_authorization_enabled_market',
        is_notifications_enabled: 'is_notifications_enabled',
        is_personal: 'is_personal',
        is_prepay_account: 'is_prepay_account',
        is_tax_id_required: 'is_tax_id_required',
        liable_address: 'liable_address',
        line_numbers: 'line_numbers',
        media_agency: 'media_agency',
        min_campaign_group_spend_cap: 'min_campaign_group_spend_cap',
        min_daily_budget: 'min_daily_budget',
        name: 'name',
        offsite_pixels_tos_accepted: 'offsite_pixels_tos_accepted',
        owner: 'owner',
        owner_business: 'owner_business',
        partner: 'partner',
        rf_spec: 'rf_spec',
        send_bill_to_address: 'send_bill_to_address',
        show_checkout_experience: 'show_checkout_experience',
        sold_to_address: 'sold_to_address',
        spend_cap: 'spend_cap',
        tax_id: 'tax_id',
        tax_id_status: 'tax_id_status',
        tax_id_type: 'tax_id_type',
        timezone_id: 'timezone_id',
        timezone_name: 'timezone_name',
        timezone_offset_hours_utc: 'timezone_offset_hours_utc',
        tos_accepted: 'tos_accepted',
        user_tasks: 'user_tasks',
        user_tos_accepted: 'user_tos_accepted',
        viewable_business: 'viewable_business'
      });
    }
  }, {
    key: 'Currency',
    get: function get() {
      return Object.freeze({
        aed: 'AED',
        ars: 'ARS',
        aud: 'AUD',
        bdt: 'BDT',
        bob: 'BOB',
        brl: 'BRL',
        cad: 'CAD',
        chf: 'CHF',
        clp: 'CLP',
        cny: 'CNY',
        cop: 'COP',
        crc: 'CRC',
        czk: 'CZK',
        dkk: 'DKK',
        dzd: 'DZD',
        egp: 'EGP',
        eur: 'EUR',
        gbp: 'GBP',
        gtq: 'GTQ',
        hkd: 'HKD',
        hnl: 'HNL',
        huf: 'HUF',
        idr: 'IDR',
        ils: 'ILS',
        inr: 'INR',
        isk: 'ISK',
        jpy: 'JPY',
        kes: 'KES',
        krw: 'KRW',
        lkr: 'LKR',
        mop: 'MOP',
        mxn: 'MXN',
        myr: 'MYR',
        ngn: 'NGN',
        nio: 'NIO',
        nok: 'NOK',
        nzd: 'NZD',
        pen: 'PEN',
        php: 'PHP',
        pkr: 'PKR',
        pln: 'PLN',
        pyg: 'PYG',
        qar: 'QAR',
        ron: 'RON',
        sar: 'SAR',
        sek: 'SEK',
        sgd: 'SGD',
        thb: 'THB',
        try: 'TRY',
        twd: 'TWD',
        uah: 'UAH',
        usd: 'USD',
        uyu: 'UYU',
        vnd: 'VND',
        zar: 'ZAR'
      });
    }
  }, {
    key: 'Tasks',
    get: function get() {
      return Object.freeze({
        aa_analyze: 'AA_ANALYZE',
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        draft: 'DRAFT',
        manage: 'MANAGE'
      });
    }
  }, {
    key: 'ClaimObjective',
    get: function get() {
      return Object.freeze({
        automotive_model: 'AUTOMOTIVE_MODEL',
        collaborative_ads: 'COLLABORATIVE_ADS',
        home_listing: 'HOME_LISTING',
        media_title: 'MEDIA_TITLE',
        product: 'PRODUCT',
        travel: 'TRAVEL',
        vehicle: 'VEHICLE',
        vehicle_offer: 'VEHICLE_OFFER'
      });
    }
  }, {
    key: 'ContentType',
    get: function get() {
      return Object.freeze({
        automotive_model: 'AUTOMOTIVE_MODEL',
        destination: 'DESTINATION',
        flight: 'FLIGHT',
        home_listing: 'HOME_LISTING',
        hotel: 'HOTEL',
        job: 'JOB',
        local_service_business: 'LOCAL_SERVICE_BUSINESS',
        location_based_item: 'LOCATION_BASED_ITEM',
        media_title: 'MEDIA_TITLE',
        offline_product: 'OFFLINE_PRODUCT',
        product: 'PRODUCT',
        vehicle: 'VEHICLE',
        vehicle_offer: 'VEHICLE_OFFER'
      });
    }
  }, {
    key: 'Subtype',
    get: function get() {
      return Object.freeze({
        app: 'APP',
        bag_of_accounts: 'BAG_OF_ACCOUNTS',
        claim: 'CLAIM',
        custom: 'CUSTOM',
        engagement: 'ENGAGEMENT',
        fox: 'FOX',
        lookalike: 'LOOKALIKE',
        managed: 'MANAGED',
        measurement: 'MEASUREMENT',
        offline_conversion: 'OFFLINE_CONVERSION',
        partner: 'PARTNER',
        regulated_categories_audience: 'REGULATED_CATEGORIES_AUDIENCE',
        study_rule_audience: 'STUDY_RULE_AUDIENCE',
        video: 'VIDEO',
        website: 'WEBSITE'
      });
    }
  }, {
    key: 'ActionSource',
    get: function get() {
      return Object.freeze({
        physical_store: 'PHYSICAL_STORE',
        website: 'WEBSITE'
      });
    }
  }]);
  return AdAccount;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsPixelStatsResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsPixelStatsResult = function (_AbstractCrudObject) {
  inherits(AdsPixelStatsResult, _AbstractCrudObject);

  function AdsPixelStatsResult() {
    classCallCheck(this, AdsPixelStatsResult);
    return possibleConstructorReturn(this, (AdsPixelStatsResult.__proto__ || Object.getPrototypeOf(AdsPixelStatsResult)).apply(this, arguments));
  }

  createClass(AdsPixelStatsResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        aggregation: 'aggregation',
        data: 'data',
        start_time: 'start_time'
      });
    }
  }, {
    key: 'Aggregation',
    get: function get() {
      return Object.freeze({
        browser_type: 'browser_type',
        custom_data_field: 'custom_data_field',
        device_os: 'device_os',
        device_type: 'device_type',
        event: 'event',
        event_detection_method: 'event_detection_method',
        event_processing_results: 'event_processing_results',
        event_source: 'event_source',
        event_total_counts: 'event_total_counts',
        event_value_count: 'event_value_count',
        had_pii: 'had_pii',
        host: 'host',
        match_keys: 'match_keys',
        pixel_fire: 'pixel_fire',
        url: 'url',
        url_by_rule: 'url_by_rule'
      });
    }
  }]);
  return AdsPixelStatsResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsPixel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsPixel = function (_AbstractCrudObject) {
  inherits(AdsPixel, _AbstractCrudObject);

  function AdsPixel() {
    classCallCheck(this, AdsPixel);
    return possibleConstructorReturn(this, (AdsPixel.__proto__ || Object.getPrototypeOf(AdsPixel)).apply(this, arguments));
  }

  createClass(AdsPixel, [{
    key: 'getAdAccounts',
    value: function getAdAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/adaccounts');
    }
  }, {
    key: 'getAgencies',
    value: function getAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/agencies');
    }
  }, {
    key: 'getAssignedUsers',
    value: function getAssignedUsers(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AssignedUser, fields, params, fetchFirstPage, '/assigned_users');
    }
  }, {
    key: 'createAssignedUser',
    value: function createAssignedUser(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/assigned_users', fields, params, AdsPixel, pathOverride);
    }
  }, {
    key: 'getDaChecks',
    value: function getDaChecks(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(DACheck, fields, params, fetchFirstPage, '/da_checks');
    }
  }, {
    key: 'createEvent',
    value: function createEvent(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/events', fields, params, null, pathOverride);
    }
  }, {
    key: 'createMeapitocapiconsolidationhelper',
    value: function createMeapitocapiconsolidationhelper(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/meapitocapiconsolidationhelper', fields, params, null, pathOverride);
    }
  }, {
    key: 'getOfflineEventUploads',
    value: function getOfflineEventUploads(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(OfflineConversionDataSetUpload, fields, params, fetchFirstPage, '/offline_event_uploads');
    }
  }, {
    key: 'createShadowTrafficHelper',
    value: function createShadowTrafficHelper(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/shadowtraffichelper', fields, params, null, pathOverride);
    }
  }, {
    key: 'deleteSharedAccounts',
    value: function deleteSharedAccounts() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get$1(AdsPixel.prototype.__proto__ || Object.getPrototypeOf(AdsPixel.prototype), 'deleteEdge', this).call(this, '/shared_accounts', params);
    }
  }, {
    key: 'getSharedAccounts',
    value: function getSharedAccounts(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdAccount, fields, params, fetchFirstPage, '/shared_accounts');
    }
  }, {
    key: 'createSharedAccount',
    value: function createSharedAccount(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/shared_accounts', fields, params, AdsPixel, pathOverride);
    }
  }, {
    key: 'getSharedAgencies',
    value: function getSharedAgencies(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Business, fields, params, fetchFirstPage, '/shared_agencies');
    }
  }, {
    key: 'getStats',
    value: function getStats(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdsPixelStatsResult, fields, params, fetchFirstPage, '/stats');
    }
  }, {
    key: 'createTelemetry',
    value: function createTelemetry(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/telemetry', fields, params, null, pathOverride);
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(AdsPixel.prototype.__proto__ || Object.getPrototypeOf(AdsPixel.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        automatic_matching_fields: 'automatic_matching_fields',
        can_proxy: 'can_proxy',
        code: 'code',
        config: 'config',
        creation_time: 'creation_time',
        creator: 'creator',
        data_use_setting: 'data_use_setting',
        description: 'description',
        duplicate_entries: 'duplicate_entries',
        enable_auto_assign_to_accounts: 'enable_auto_assign_to_accounts',
        enable_automatic_matching: 'enable_automatic_matching',
        event_stats: 'event_stats',
        event_time_max: 'event_time_max',
        event_time_min: 'event_time_min',
        first_party_cookie_status: 'first_party_cookie_status',
        id: 'id',
        is_consolidated_container: 'is_consolidated_container',
        is_created_by_business: 'is_created_by_business',
        is_crm: 'is_crm',
        is_mta_use: 'is_mta_use',
        is_restricted_use: 'is_restricted_use',
        is_unavailable: 'is_unavailable',
        last_fired_time: 'last_fired_time',
        last_upload_app: 'last_upload_app',
        last_upload_app_changed_time: 'last_upload_app_changed_time',
        match_rate_approx: 'match_rate_approx',
        matched_entries: 'matched_entries',
        name: 'name',
        owner_ad_account: 'owner_ad_account',
        owner_business: 'owner_business',
        usage: 'usage',
        valid_entries: 'valid_entries'
      });
    }
  }, {
    key: 'SortBy',
    get: function get() {
      return Object.freeze({
        last_fired_time: 'LAST_FIRED_TIME',
        name: 'NAME'
      });
    }
  }, {
    key: 'AutomaticMatchingFields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        ct: 'ct',
        db: 'db',
        em: 'em',
        external_id: 'external_id',
        fn: 'fn',
        ge: 'ge',
        ln: 'ln',
        ph: 'ph',
        st: 'st',
        zp: 'zp'
      });
    }
  }, {
    key: 'DataUseSetting',
    get: function get() {
      return Object.freeze({
        advertising_and_analytics: 'ADVERTISING_AND_ANALYTICS',
        analytics_only: 'ANALYTICS_ONLY',
        empty: 'EMPTY'
      });
    }
  }, {
    key: 'FirstPartyCookieStatus',
    get: function get() {
      return Object.freeze({
        empty: 'EMPTY',
        first_party_cookie_disabled: 'FIRST_PARTY_COOKIE_DISABLED',
        first_party_cookie_enabled: 'FIRST_PARTY_COOKIE_ENABLED'
      });
    }
  }, {
    key: 'Tasks',
    get: function get() {
      return Object.freeze({
        aa_analyze: 'AA_ANALYZE',
        advertise: 'ADVERTISE',
        analyze: 'ANALYZE',
        edit: 'EDIT',
        upload: 'UPLOAD'
      });
    }
  }]);
  return AdsPixel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * EventResponse
 * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters}
 */

var EventResponse = function () {

	/**
  * @param {Number} events_received
  * @param {Array<string>} messages
  * @param {String} fbtrace_id
  * @param {String} id
  * @param {Number} num_processed_entries
  */
	function EventResponse(events_received, messages, fbtrace_id, id, num_processed_entries) {
		classCallCheck(this, EventResponse);


		this._events_received = events_received;
		this._messages = messages;
		this._fbtrace_id = fbtrace_id;
		this._id = id;
		this._num_processed_entries = num_processed_entries;
	}

	/**
  * Sets the events received for the response received from Graph API.
  * events_received is represented by integer.
  * @return events_received representing the number of events received for the event Request
  */


	createClass(EventResponse, [{
		key: "setEventsReceived",


		/**
  * Sets the events received for the response received from Graph API.
  * events_received is represented by integer.
  * @param {Number} events_received representing the number of events received for the event Request
  */
		value: function setEventsReceived(events_received) {
			this._events_received = events_received;
			return this;
		}

		/**
   * Sets the messages as array for the response received from Graph API.
   * @return messages in the event Response
   */

	}, {
		key: "setMessages",


		/**
  * Sets the messages as array for the response received from Graph API.
  * @param {Array} messages in the event Response
  */
		value: function setMessages(messages) {
			this._messages = messages;
			return this;
		}

		/**
   * Gets the fbtrace_id for the response received from Graph API.
   * @return fbtrace_id in the event Response that can used for debugging purposes
   */

	}, {
		key: "setFbtraceId",


		/**
  * Sets the fbtrace_id for the response received from Graph API.
  * @param {String} fbtrace_id in the event Response that can used for debugging purposes
  */
		value: function setFbtraceId(fbtrace_id) {
			this._fbtrace_id = fbtrace_id;
			return this;
		}

		/**
   * Gets the id of container to which the event request was successfully posted to.
   * @return id of the dataset
   */

	}, {
		key: "setId",


		/**
  * Sets the id of container to which the event request was successfully posted to.
  * @param {String} id in the event Response that can used for debugging purposes
  */
		value: function setId(id) {
			this._id = id;
			return this;
		}

		/**
   * Gets the number of events that got posted as part of the original request.
   * @return num_processed_entries number of events posted to the dataset.
   */

	}, {
		key: "setId",


		/**
  * Sets the number of events that got succesfully posted as part of the original request.
  * @param {Number} num_processed_entries number of events posted to the dataset.
  */
		value: function setId(num_processed_entries) {
			this._num_processed_entries = num_processed_entries;
			return this;
		}
	}, {
		key: "events_received",
		get: function get() {
			return this._events_received;
		}

		/**
   * Sets the events received for the response received from Graph API.
   * events_received is represented by integer.
   * @param events_received representing the number of events received for the event Request
   */
		,
		set: function set(events_received) {
			this._events_received = events_received;
		}
	}, {
		key: "messages",
		get: function get() {
			return this._messages;
		}

		/**
   * Sets the messages as array for the response received from Graph API.
   * @param messages in the event Response
   */
		,
		set: function set(messages) {
			this._messages = messages;
		}
	}, {
		key: "fbtrace_id",
		get: function get() {
			return this._fbtrace_id;
		}

		/**
   * Sets the fbtrace_id for the response received from Graph API.
   * @param fbtrace_id in the event Response that can used for debugging purposes
   */
		,
		set: function set(fbtrace_id) {
			this._fbtrace_id = fbtrace_id;
		}
	}, {
		key: "id",
		get: function get() {
			return this._id;
		}

		/**
   * Sets the id of container to which the event request was successfully posted to.
   * @param  id of the dataset
   */
		,
		set: function set(id) {
			this._id = id;
		}
	}, {
		key: "num_processed_entries",
		get: function get() {
			return this._num_processed_entries;
		}

		/**
   * Sets the number of events that got posted as part of the original request.
   * @param num_processed_entries number of events posted to the dataset.
   */
		,
		set: function set(num_processed_entries) {
			this._num_processed_entries = num_processed_entries;
		}
	}]);
	return EventResponse;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

var HttpMethod = Object.freeze({
  POST: 'POST',
  PUT: 'PUT',
  GET: 'GET',
  DELETE: 'DELETE'
});

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

var HttpServiceInterface = function () {
    function HttpServiceInterface() {
        classCallCheck(this, HttpServiceInterface);
    }

    createClass(HttpServiceInterface, [{
        key: 'executeRequest',

        /**
        * @param {String} $url The graph API endpoint that will be requested
        * @param {HttpMethod} $method The HTTP request method
        * @param {Object} $headers Contains HTTP request headers including User-Agent and Accept-Encoding
        * @param {Object} $params Contains request parameters including access_token, data, test_event_code, etc.
        * @return {Promise<Object>}
        */
        value: function executeRequest(url, method, headers, params) {
            return new Promise(function (resolve, reject) {
                return null;
            });
        }
    }]);
    return HttpServiceInterface;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 * @format
 */

var HttpServiceClientConfig = function () {
    function HttpServiceClientConfig() {
        classCallCheck(this, HttpServiceClientConfig);
    }

    createClass(HttpServiceClientConfig, null, [{
        key: 'setClient',
        value: function setClient(client) {
            this._client = client;
        }
    }, {
        key: 'getClient',
        value: function getClient() {
            return this._client;
        }
    }]);
    return HttpServiceClientConfig;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * UserData represents the User Data Parameters(user_data) of a Conversions API Event Request.
 * 'user_data' is a set of identifiers Facebook can use for targeted attribution. See Custom Audiences from CRM Data for details on how to normalize and hash the data you send.
 * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters}
 */

var UserData = function () {

	/**
  * @param {String} email An email address, in lowercase.
  * @param {String} phone A phone number. Include only digits with country code, area code, and number.
  * @param {String} gender Gender, in lowercase. Either f or m.
  * @param {String} first_name A first name in lowercase.
  * @param {String} last_name A last name in lowercase.
  * @param {String} date_of_birth A date of birth given as year, month, and day in YYYYMMDD format.
  * @param {String} city A city in lower-case without spaces or punctuation.
  * @param {String} state A two-letter state code in lowercase.
  * @param {String} zip Postal code of the city in your country standard
  * @param {String} country A two-letter country code in lowercase.
  * @param {String} external_id Any unique ID from the advertiser,
  * @param {String} client_ip_address The IP address of the browser corresponding to the event.
  * @param {String} client_user_agent The user agent for the browser corresponding to the event.
  * @param {String} fbp The Facebook click ID value stored in the _fbc browser cookie under your domain.
  * @param {String} fbc The Facebook browser ID value stored in the _fbp browser cookie under your domain.
  * @param {String} subscription_id The subscription ID for the user in this transaction.
  * @param {String} fb_login_id The FB login ID for the user.
  * @param {String} lead_id The Id associated with a lead generated by Facebook's Lead Ads.
  * @param {String} dobd The date of birth day in DD format.
  * @param {String} dobm The date of birth month in MM format.
  * @param {String} doby The date of birth year in YYYY format.
  * @param {String} madid
  * @param {String} anon_id
  * @param {String} app_user_id
  */
	function UserData(email, phone, gender, first_name, last_name, date_of_birth, city, state, zip, country, external_id, client_ip_address, client_user_agent, fbp, fbc, subscription_id, fb_login_id, lead_id, dobd, dobm, doby, madid, anon_id, app_user_id) {
		classCallCheck(this, UserData);

		if (email != null) {
			this._emails = new Array(email);
		}
		if (phone != null) {
			this._phones = new Array(phone);
		}
		if (gender != null) {
			this._genders = new Array(gender);
		}
		if (first_name != null) {
			this._first_names = new Array(first_name);
		}
		if (last_name != null) {
			this._last_names = new Array(last_name);
		}
		if (date_of_birth != null) {
			this._dates_of_birth = new Array(date_of_birth);
		}
		if (city != null) {
			this._cities = new Array(city);
		}
		if (state != null) {
			this._states = new Array(state);
		}
		if (country != null) {
			this._countries = new Array(country);
		}
		if (zip != null) {
			this._zips = new Array(zip);
		}
		if (external_id != null) {
			this._external_ids = new Array(external_id);
		}
		this._client_ip_address = client_ip_address;
		this._client_user_agent = client_user_agent;
		this._fbp = fbp;
		this._fbc = fbc;
		this._subscription_id = subscription_id;
		this._fb_login_id = fb_login_id;
		this._lead_id = lead_id;
		this._dobd = dobd;
		this._dobm = dobm;
		this._doby = doby;
		this._madid = madid;
		this._anon_id = anon_id;
		this._app_user_id = app_user_id;
	}

	createClass(UserData, [{
		key: 'setEmail',


		/**
   * Sets the email address for the user data field.
   * @param {String} email An email address, in lowercase.
   * Example: joe@eg.com
   */
		value: function setEmail(email) {
			this._emails = new Array(email);
			return this;
		}

		/**
   * Sets email addresses for the user data field.
   * @param emails Email addresses, in lowercase.
   * Example: ['joe@eg.com', 'smith@test.com']
   */

	}, {
		key: 'setEmails',
		value: function setEmails(emails) {
			this._emails = emails;
			return this;
		}

		/**
   * Gets the phone number for the user data.
   * A phone number. Include only digits with country code, area code, and number.
   * Example: 16505551212
   */

	}, {
		key: 'setPhone',


		/**
   * Sets the phone number for the user data.
   * @param {String} phone A phone number. Include only digits with country code, area code, and number.
   * Example: 16505551212
   */
		value: function setPhone(phone) {
			this._phones = new Array(phone);
			return this;
		}

		/**
   * Sets the phone numbers for the user data.
   * @param phones Phone numbers. Include only digits with country code, area code, and number.
   * Example: ['16505551212', '12062072008']
   */

	}, {
		key: 'setPhones',
		value: function setPhones(phones) {
			this._phones = phones;
			return this;
		}

		/**
   * Gets the gender value for the user data.
   * Gender in lowercase. Either f for FEMALE or m for MALE.
   * Example: f
   */

	}, {
		key: 'setGender',


		/**
   * Sets the gender value for the user data.
   * @param {String} gender Gender in lowercase. Either f for FEMALE or m for MALE.
   * Example: f
   */
		value: function setGender(gender) {
			this._genders = new Array(gender);
			return this;
		}

		/**
   * Sets the gender values for the user data.
   * @param genders Genders in lowercase. Either f for FEMALE or m for MALE.
   * Example: [f, m]
   */

	}, {
		key: 'setGenders',
		value: function setGenders(genders) {
			this._genders = genders;
			return this;
		}

		/**
   * Gets the date of birth for the user data.
   * A date of birth given as year, month, and day in the Format YYYYMMDD
   * Example: 19971226 for December 26, 1997.
   */

	}, {
		key: 'setDateOfBirth',


		/**
   * Sets the date of birth for the user data.
   * @param {String} date_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
   * Example: 19971226 for December 26, 1997.
   */
		value: function setDateOfBirth(date_of_birth) {
			this._dates_of_birth = new Array(date_of_birth);
			return this;
		}

		/**
   * Sets the dates of birth for the user data.
   * @param {String} dates_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
   * Example: 19971226 for December 26, 1997.
   */

	}, {
		key: 'setDatesOfBirth',
		value: function setDatesOfBirth(dates_of_birth) {
			this._dates_of_birth = dates_of_birth;
			return this;
		}

		/**
   * Gets the last name for the user data.
   * last_name is the last name in lowercase.
   * Example: smith
   */

	}, {
		key: 'setLastName',


		/**
   * Sets the last name for the user data.
   * @param {String} last_name is last name in lowercase.
   * Example: smith
   */
		value: function setLastName(last_name) {
			this._last_names = new Array(last_name);
			return this;
		}

		/**
   * Sets the last name for the user data.
   * @param last_names is last name in lowercase.
   * Example: ['smith', 'wilson']
   */

	}, {
		key: 'setLastNames',
		value: function setLastNames(last_names) {
			this._last_names = last_names;
			return this;
		}

		/**
   * Gets the first name for the user data.
   * first_name is first name in lowercase.
   * Example: joe
   */

	}, {
		key: 'setFirstName',


		/**
   * Sets the first name for the user data.
   * @param {String} first_name is first name in lowercase.
   * Example: joe
   */
		value: function setFirstName(first_name) {
			this._first_names = new Array(first_name);
			return this;
		}

		/**
   * Sets the first names for the user data.
   * @param {String} first_names is first name in lowercase.
   * Example: joe
   */

	}, {
		key: 'setFirstNames',
		value: function setFirstNames(first_names) {
			this._first_names = first_names;
			return this;
		}

		/**
   * Gets the city for the user data.
   * city is city in lower-case without spaces or punctuation.
   * Example: menlopark
   */

	}, {
		key: 'setCity',


		/**
   * Sets the city for the user data.
   * @param {String} city is city in lower-case without spaces or punctuation.
   * Example: menlopark
   */
		value: function setCity(city) {
			this._cities = new Array(city);
			return this;
		}

		/**
   * Sets the cities for the user data.
   * @param cities is city in lower-case without spaces or punctuation.
   * Example: ['menlopark', 'seattle']
   */

	}, {
		key: 'setCities',
		value: function setCities(cities) {
			this._cities = cities;
			return this;
		}

		/**
   * Gets the zip/postal code for the user data.
   * zip is a five-digit zip code for United States.For other locations, follow each country's standards.
   * Example: 98121 (for United States zip code)
   */

	}, {
		key: 'setZip',


		/**
   * Sets the zip/postal code for the user data.
   * @param {String} zip is a five-digit zip code for United States.For other locations, follow each country's standards.
   * Example: 98121 (for United States zip code)
   */
		value: function setZip(zip) {
			this._zips = new Array(zip);
			return this;
		}

		/**
   * Sets the zip/postal codes for the user data.
   * @param zips is a five-digit zip code for United States.For other locations, follow each country's standards.
   * Example: 98121 (for United States zip code)
   */

	}, {
		key: 'setZips',
		value: function setZips(zips) {
			this._zips = zips;
			return this;
		}

		/**
   * Gets the state for the user data.
   * state is state in lower-case without spaces or punctuation.
   * Example: ca
   */

	}, {
		key: 'setState',


		/**
   * Sets the state for the user data.
   * @param {String} state is state in lower-case without spaces or punctuation.
   * Example: ca
   */
		value: function setState(state) {
			this._states = new Array(state);
			return this;
		}

		/**
   * Sets the states for the user data.
   * @param states is state in lower-case without spaces or punctuation.
   * Example: ca
   */

	}, {
		key: 'setStates',
		value: function setStates(states) {
			this._states = states;
			return this;
		}

		/**
   * Gets the country for the user data.
   * country is A two-letter country code in lowercase.
   * Example: usa
   */

	}, {
		key: 'setCountry',


		/**
   * Sets the country for the user data.
   * @param {String} country is A two-letter country code in lowercase.
   * Example: usa
   */
		value: function setCountry(country) {
			this._countries = new Array(country);
			return this;
		}

		/**
   * Sets the countries for the user data.
   * @param countries is A two-letter country code in lowercase.
   * Example: usa
   */

	}, {
		key: 'setCountries',
		value: function setCountries(countries) {
			this._countries = countries;
			return this;
		}

		/**
   * Gets the external id for the user data.
   * external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
   * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
   * If External ID is being sent via other channels, then it should be sent in the same format via the Conversions API
   * @see {@link https://www.facebook.com/business/help/104039186799009}
   */

	}, {
		key: 'setExternalId',


		/**
   * Sets the external id for the user data.
   * @param {String} external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
   * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
   * If External ID is being sent via other channels, then it should be sent in the same format via the Conversions API
   * @see {@link https://www.facebook.com/business/help/104039186799009}
   */
		value: function setExternalId(external_id) {
			this._external_ids = new Array(external_id);
			return this;
		}

		/**
   * Sets the external ids for the user data.
   * @param external_ids is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
   * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
   * If External ID is being sent via other channels, then it should be sent in the same format via the Conversions API
   * @see {@link https://www.facebook.com/business/help/104039186799009}
   */

	}, {
		key: 'setExternalIds',
		value: function setExternalIds(external_ids) {
			this._external_ids = external_ids;
			return this;
		}

		/**
   * Gets the client ip address for the user data.
   * client_ip_address is the IP address of the browser corresponding to the event.
   */

	}, {
		key: 'setClientIpAddress',


		/**
   * Sets the client ip address for the user data.
   * @param {String} client_ip_address is the IP address of the browser corresponding to the event.
   */
		value: function setClientIpAddress(client_ip_address) {
			this._client_ip_address = client_ip_address;
			return this;
		}

		/**
   * Gets the client user agent for the user data.
   * client_user_agent is the user agent for the browser corresponding to the event.
   */

	}, {
		key: 'setClientUserAgent',


		/**
   * Sets the client user agent for the user data.
   * @param {String} client_user_agent is the user agent for the browser corresponding to the event.
   */
		value: function setClientUserAgent(client_user_agent) {
			this._client_user_agent = client_user_agent;
			return this;
		}

		/**
   * Gets the fbc for the user data.
   * fbc is the Facebook click ID value stored in the _fbc browser cookie under your domain.
   * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters#fbc},
   * You can also generate this value from a fbclid query parameter.
   */

	}, {
		key: 'setFbc',


		/**
   * Sets the fbc for the user data.
   * @param {String} fbc is the Facebook click ID value stored in the _fbc browser cookie under your domain.
   * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters#fbc},
   * You can also generate this value from a fbclid query parameter.
   */
		value: function setFbc(fbc) {
			this._fbc = fbc;
			return this;
		}

		/**
   * Gets the fbp for the user data.
   * fbp is Facebook browser ID value stored in the _fbp browser cookie under your domain.
   * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters#fbp},
   */

	}, {
		key: 'setFbp',


		/**
   * Sets the fbp for the user data.
   * @param {String} fbp is Facebook browser ID value stored in the _fbp browser cookie under your domain.
   * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters#fbp},
   */
		value: function setFbp(fbp) {
			this._fbp = fbp;
			return this;
		}

		/**
   * Gets the subscription id for the user data.
   * @return subscription_id is the subscription ID for the user in this transaction. This is similar to the order ID for an individual product.
   * Example: anid1234.
   */

	}, {
		key: 'setSubscriptionId',


		/**
   * Sets the subscription id for the user data.
   * @param {String} subscription_id is the subscription ID for the user in this transaction. This is similar to the order ID for an individual product.
   * Example: anid1234.
   */
		value: function setSubscriptionId(subscription_id) {
			this._subscription_id = subscription_id;
			return this;
		}

		/**
   *
   * Gets the fb_login_id for the user data.
   */

	}, {
		key: 'setFbLoginId',


		/**
   * Sets the fb_login_id for the user data.
   */
		value: function setFbLoginId(fb_login_id) {
			this._fb_login_id = fb_login_id;
			return this;
		}

		/**
   *
   * Gets the lead_id for the user data. Lead ID is associated with a lead generated by Facebook's Lead Ads.
   */

	}, {
		key: 'setLeadId',


		/**
   * Sets the lead_id for the user data. Lead ID is associated with a lead generated by Facebook's Lead Ads.
   */
		value: function setLeadId(lead_id) {
			this._lead_id = lead_id;
			return this;
		}

		/**
   *
   * Gets the first 5 characters of the FirstName.
   */

	}, {
		key: 'setF5First',


		/**
   * Sets the first 5 characters of the FirstName.
   */
		value: function setF5First(f5first) {
			this._f5first = f5first;
			return this;
		}

		/**
   *
   * Gets the first 5 characters of the LastName.
   */

	}, {
		key: 'setF5Last',


		/**
   * Sets the first 5 characters of the LastName.
   */
		value: function setF5Last(f5last) {
			this._f5last = f5last;
			return this;
		}

		/**
   *
   * Gets the first Name Initial.
   */

	}, {
		key: 'setFi',


		/**
   * Sets the first Name Initial.
   */
		value: function setFi(fi) {
			this._fi = fi;
			return this;
		}

		/**
   *
   * Gets the date of birth day.
   */

	}, {
		key: 'setDobd',


		/**
   * Sets the date of birth day.
   */
		value: function setDobd(dobd) {
			this._dobd = dobd;
			return this;
		}

		/**
   *
   * Gets the date of birth month.
   */

	}, {
		key: 'setDobm',


		/**
   * Sets the date of birth month.
   */
		value: function setDobm(dobm) {
			this._dobm = dobm;
			return this;
		}

		/**
   *
   * Gets the date of birth year.
   */

	}, {
		key: 'setDoby',


		/**
   * Sets the date of birth year.
   */
		value: function setDoby(doby) {
			this._doby = doby;
			return this;
		}
		/**
   *
   */

	}, {
		key: 'setMadid',


		/**
   *
   */
		value: function setMadid(madid) {
			this._madid = madid;
			return this;
		}

		/**
   *
   */

	}, {
		key: 'setAnonId',


		/**
   *
   */
		value: function setAnonId(anon_id) {
			this._anon_id = anon_id;
			return this;
		}

		/**
   *
   */

	}, {
		key: 'setAppUserId',


		/**
   *
   */
		value: function setAppUserId(app_user_id) {
			this._app_user_id = app_user_id;
			return this;
		}

		/**
   * Returns the normalized payload for the user_data parameter.
   * @returns {Object} normalized user data payload.
   */

	}, {
		key: 'normalize',
		value: function normalize() {
			var userData = {};

			if (this.emails) {
				userData['em'] = this.normalizeAndHashMultiValues(this.emails, 'em');
			}

			if (this.phones) {
				userData['ph'] = this.normalizeAndHashMultiValues(this.phones, 'ph');
			}

			if (this.genders) {
				userData['ge'] = this.normalizeAndHashMultiValues(this.genders, 'ge');
			}

			if (this.dates_of_birth) {
				userData['db'] = this.normalizeAndHashMultiValues(this.dates_of_birth, 'db');
			}

			if (this.last_names) {
				userData['ln'] = this.normalizeAndHashMultiValues(this.last_names, 'ln');
			}

			if (this.first_names) {
				userData['fn'] = this.normalizeAndHashMultiValues(this.first_names, 'fn');
			}

			if (this.cities) {
				userData['ct'] = this.normalizeAndHashMultiValues(this.cities, 'ct');
			}

			if (this.states) {
				userData['st'] = this.normalizeAndHashMultiValues(this.states, 'st');
			}

			if (this.zips) {
				userData['zp'] = this.normalizeAndHashMultiValues(this.zips, 'zp');
			}

			if (this.countries) {
				userData['country'] = this.normalizeAndHashMultiValues(this.countries, 'country');
			}

			if (this.external_ids) {
				userData['external_id'] = this.dedupArray(this.external_ids);
			}

			if (this.client_ip_address) {
				userData['client_ip_address'] = this.client_ip_address;
			}

			if (this.client_user_agent) {
				userData['client_user_agent'] = this.client_user_agent;
			}

			if (this.fbc) {
				userData['fbc'] = this.fbc;
			}

			if (this.fbp) {
				userData['fbp'] = this.fbp;
			}

			if (this.subscription_id) {
				userData['subscription_id'] = this.subscription_id;
			}

			if (this.fb_login_id) {
				userData['fb_login_id'] = this.fb_login_id;
			}

			if (this.lead_id) {
				userData['lead_id'] = this.lead_id;
			}

			if (this.f5first) {
				userData['f5first'] = ServerSideUtils.normalizeAndHash(this.f5first, 'f5first');
			}

			if (this.f5last) {
				userData['f5last'] = ServerSideUtils.normalizeAndHash(this.f5last, 'f5last');
			}

			if (this.fi) {
				userData['fi'] = ServerSideUtils.normalizeAndHash(this.fi, 'fi');
			}

			if (this.dobd) {
				userData['dobd'] = ServerSideUtils.normalizeAndHash(this.dobd, 'dobd');
			}

			if (this.dobm) {
				userData['dobm'] = ServerSideUtils.normalizeAndHash(this.dobm, 'dobm');
			}

			if (this.doby) {
				userData['doby'] = ServerSideUtils.normalizeAndHash(this.doby, 'doby');
			}

			if (this.madid) {
				userData['madid'] = this.madid;
			}

			if (this.anon_id) {
				userData['anon_id'] = this.anon_id;
			}

			if (this.app_user_id) {
				userData['app_user_id'] = ServerSideUtils.normalizeAndHash(this.app_user_id, 'app_user_id');
			}

			return userData;
		}

		/**
  * Returns the deduped and normalized payload for the given array of values and the field.
  * @returns {string[]} dedupped and normalized values.
  */

	}, {
		key: 'normalizeAndHashMultiValues',
		value: function normalizeAndHashMultiValues(arr, fieldName) {
			var normalizedArray = arr.map(function (value) {
				return ServerSideUtils.normalizeAndHash(value, fieldName);
			});
			return this.dedupArray(normalizedArray);
		}

		/**
   * Returns the deduped payload for the given array of values.
   * This can be applied to fields that do not require normalization or hashing.
   * @returns {string[]} deduped values.
   */

	}, {
		key: 'dedupArray',
		value: function dedupArray(arr) {
			var dedupSet = new Set(arr);
			return Array.from(dedupSet);
		}
	}, {
		key: 'email',


		/**
   * Gets the email address for the user data field.
   * An email address, in lowercase.
   * Example: joe@eg.com
   */
		get: function get() {
			return this._emails == null ? null : this._emails[0];
		}

		/**
   * Gets email addresses for the user data field.
   * Email addresses, in lowercase.
   * Example: ['joe@eg.com', 'smith@test.com']
   */
		,


		/**
   * Sets the email address for the user data field.
   * @param email An email address, in lowercase.
   * Example: joe@eg.com
   */
		set: function set(email) {
			this._emails = new Array(email);
		}

		/**
   * Sets email addresses for the user data field.
   * @param emails Email addresses, in lowercase.
   * Example: ['joe@eg.com', 'smith@test.com']
   */

	}, {
		key: 'emails',
		get: function get() {
			return this._emails;
		},
		set: function set(emails) {
			this._emails = emails;
		}
	}, {
		key: 'phone',
		get: function get() {
			return this._phones == null ? null : this._phones[0];
		}

		/**
   * Gets the phone numbers for the user data.
   * Phone numbers. Include only digits with country code, area code, and number.
   * Example: ['16505551212', '12062072008']
   */
		,


		/**
   * Sets the phone number for the user data.
   * @param phone A phone number. Include only digits with country code, area code, and number.
   * Example: 16505551212
   */
		set: function set(phone) {
			this._phones = new Array(phone);
		}

		/**
   * Sets the phone numbers for the user data.
   * @param phones Phone numbers. Include only digits with country code, area code, and number.
   * Example: ['16505551212', '12062072008']
   */

	}, {
		key: 'phones',
		get: function get() {
			return this._phones;
		},
		set: function set(phones) {
			this._phones = phones;
		}
	}, {
		key: 'gender',
		get: function get() {
			return this._genders == null ? null : this.genders[0];
		}

		/**
   * Gets the gender values for the user data.
   * Genders in lowercase. Either f for FEMALE or m for MALE.
   * Example: [f, m]
   */
		,


		/**
   * Sets the gender value for the user data.
   * @param gender Gender in lowercase. Either f for FEMALE or m for MALE.
   * Example: f
   */
		set: function set(gender) {
			this._genders = new Array(gender);
		}

		/**
   * Sets the gender values for the user data.
   * @param genders Genders in lowercase. Either f for FEMALE or m for MALE.
   * Example: [f, m]
   */

	}, {
		key: 'genders',
		get: function get() {
			return this._genders;
		},
		set: function set(genders) {
			this._genders = genders;
		}
	}, {
		key: 'date_of_birth',
		get: function get() {
			return this._dates_of_birth == null ? null : this._dates_of_birth[0];
		}

		/**
   * Gets the dates of birth for the user data.
   * A date of birth given as year, month, and day in the Format YYYYMMDD
   * Example: 19971226 for December 26, 1997.
   */
		,


		/**
   * Sets the date of birth for the user data.
   * @param date_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
   * Example: 19971226 for December 26, 1997.
   */
		set: function set(date_of_birth) {
			this._dates_of_birth = new Array(date_of_birth);
		}

		/**
   * Sets the dates of birth for the user data.
   * @param dates_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
   * Example: 19971226 for December 26, 1997.
   */

	}, {
		key: 'dates_of_birth',
		get: function get() {
			return this._dates_of_birth;
		},
		set: function set(dates_of_birth) {
			this._dates_of_birth = dates_of_birth;
		}
	}, {
		key: 'last_name',
		get: function get() {
			return this._last_names == null ? null : this._last_names[0];
		}

		/**
   * Gets the last names for the user data.
   * last_name is the last name in lowercase.
   * Example: ['smith', 'wilson']
   */
		,


		/**
   * Sets the last name for the user data.
   * @param last_name is last name in lowercase.
   * Example: smith
   */
		set: function set(last_name) {
			this._last_names = new Array(last_name);
		}

		/**
   * Sets the last names for the user data.
   * @param last_names is last name in lowercase.
   * Example: ['smith', 'wilson']
   */

	}, {
		key: 'last_names',
		get: function get() {
			return this._last_names;
		},
		set: function set(last_names) {
			this._last_names = last_names;
		}
	}, {
		key: 'first_name',
		get: function get() {
			return this._first_names == null ? null : this._first_names[0];
		}

		/**
  * Gets the first names for the user data.
  * first_name is first name in lowercase.
  * Example: ['joe', 'mary']
  */
		,


		/**
   * Sets the first name for the user data.
   * @param first_name is first name in lowercase.
   * Example: joe
   */
		set: function set(first_name) {
			this._first_names = new Array(first_name);
		}

		/**
  * Sets the first names for the user data.
  * @param first_names is first name in lowercase.
  * Example: ['joe', 'mary']
  */

	}, {
		key: 'first_names',
		get: function get() {
			return this._first_names;
		},
		set: function set(first_names) {
			this._first_names = first_names;
		}
	}, {
		key: 'city',
		get: function get() {
			return this._cities == null ? null : this._cities[0];
		}

		/**
   * Gets the cities for the user data.
   * city is city in lower-case without spaces or punctuation.
   * Example:['menlopark', 'seattle']
   */
		,


		/**
   * Sets the city for the user data.
   * @param city is city in lower-case without spaces or punctuation.
   * Example: menlopark
   */
		set: function set(city) {
			this._cities = new Array(city);
		}

		/**
   * Sets the cities for the user data.
   * @param cities is city in lower-case without spaces or punctuation.
   * Example: ['menlopark', 'seattle']
   */

	}, {
		key: 'cities',
		get: function get() {
			return this._cities;
		},
		set: function set(cities) {
			this._cities = cities;
		}
	}, {
		key: 'zip',
		get: function get() {
			return this._zips == null ? null : this._zips[0];
		}

		/**
   * Gets the zip/postal codes for the user data.
   * zip is a five-digit zip code for United States.For other locations, follow each country's standards.
   * Example: 98121 (for United States zip code)
   */
		,


		/**
   * Sets the zip/postal code for the user data.
   * @param zip is a five-digit zip code for United States.For other locations, follow each country's standards.
   * Example: 98121 (for United States zip code)
   */
		set: function set(zip) {
			this._zips = new Array(zip);
		}

		/**
   * Sets the zip/postal codes for the user data.
   * @param zips is a five-digit zip code for United States.For other locations, follow each country's standards.
   * Example: 98121 (for United States zip code)
   */

	}, {
		key: 'zips',
		get: function get() {
			return this._zips;
		},
		set: function set(zips) {
			this._zips = zips;
		}
	}, {
		key: 'state',
		get: function get() {
			return this._states == null ? null : this._states[0];
		}

		/**
   * Gets the states for the user data.
   * state is state in lower-case without spaces or punctuation.
   * Example: ca
   */
		,


		/**
   * Sets the state for the user data.
   * @param state is state in lower-case without spaces or punctuation.
   * Example: ca
   */
		set: function set(state) {
			this._states = new Array(state);
		}

		/**
   * Sets the states for the user data.
   * @param states is state in lower-case without spaces or punctuation.
   * Example: ca
   */

	}, {
		key: 'states',
		get: function get() {
			return this._states;
		},
		set: function set(states) {
			this._states = states;
		}
	}, {
		key: 'country',
		get: function get() {
			return this._countries == null ? null : this._countries[0];
		}

		/**
   * Gets the countries for the user data.
   * country is A two-letter country code in lowercase.
   * Example: usa
   */
		,


		/**
   * Sets the country for the user data.
   * @param country is A two-letter country code in lowercase.
   * Example: usa
   */
		set: function set(country) {
			this._countries = new Array(country);
		}

		/**
   * Sets the countries for the user data.
   * @param countries is A two-letter country code in lowercase.
   * Example: usa
   */

	}, {
		key: 'countries',
		get: function get() {
			return this._countries;
		},
		set: function set(countries) {
			this._countries = countries;
		}
	}, {
		key: 'external_id',
		get: function get() {
			return this._external_ids == null ? null : this._external_ids[0];
		}

		/**
   * Gets the external ids for the user data.
   * external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
   * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
   * If External ID is being sent via other channels, then it should be sent in the same format via the Conversions API
   * @see {@link https://www.facebook.com/business/help/104039186799009}
   */
		,


		/**
   * Sets the external id for the user data.
   * @param external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
   * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
   * If External ID is being sent via other channels, then it should be sent in the same format via the Conversions API
   * @see {@link https://www.facebook.com/business/help/104039186799009}
   */
		set: function set(external_id) {
			this._external_ids = new Array(external_id);
		}

		/**
   * Sets the external id for the user data.
   * @param external_ids is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
   * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
   * If External ID is being sent via other channels, then it should be sent in the same format via the Conversions API
   * @see {@link https://www.facebook.com/business/help/104039186799009}
   */

	}, {
		key: 'external_ids',
		get: function get() {
			return this._external_ids;
		},
		set: function set(external_ids) {
			this._external_ids = external_ids;
		}
	}, {
		key: 'client_ip_address',
		get: function get() {
			return this._client_ip_address;
		}

		/**
   * Sets the client ip address for the user data.
   * @param client_ip_address is the IP address of the browser corresponding to the event.
   */
		,
		set: function set(client_ip_address) {
			this._client_ip_address = client_ip_address;
		}
	}, {
		key: 'client_user_agent',
		get: function get() {
			return this._client_user_agent;
		}

		/**
   * Sets the client user agent for the user data.
   * @param client_user_agent is the user agent for the browser corresponding to the event.
   */
		,
		set: function set(client_user_agent) {
			this._client_user_agent = client_user_agent;
		}
	}, {
		key: 'fbc',
		get: function get() {
			return this._fbc;
		}

		/**
   * Sets the fbc for the user data.
   * @param fbc is the Facebook click ID value stored in the _fbc browser cookie under your domain.
   * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters#fbc},
   * You can also generate this value from a fbclid query parameter.
   */
		,
		set: function set(fbc) {
			this._fbc = fbc;
		}
	}, {
		key: 'fbp',
		get: function get() {
			return this._fbp;
		}

		/**
   * Sets the fbp for the user data.
   * @param fbp is Facebook browser ID value stored in the _fbp browser cookie under your domain.
   * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/customer-information-parameters#fbp},
   */
		,
		set: function set(fbp) {
			this._fbp = fbp;
		}
	}, {
		key: 'subscription_id',
		get: function get() {
			return this._subscription_id;
		}

		/**
   * Sets the subscription id for the user data.
   * @param {String} subscription_id is the subscription ID for the user in this transaction. This is similar to the order ID for an individual product.
   * Example: anid1234.
   */
		,
		set: function set(subscription_id) {
			this._subscription_id = subscription_id;
		}
	}, {
		key: 'fb_login_id',
		get: function get() {
			return this._fb_login_id;
		}

		/**
   * Sets the fb_login_id for the user data.
   */
		,
		set: function set(fb_login_id) {
			this._fb_login_id = fb_login_id;
		}
	}, {
		key: 'lead_id',
		get: function get() {
			return this._lead_id;
		}

		/**
   * Sets the lead_id for the user data. Lead ID is associated with a lead generated by Facebook's Lead Ads.
   */
		,
		set: function set(lead_id) {
			this._lead_id = lead_id;
		}
	}, {
		key: 'f5first',
		get: function get() {
			return this._f5first;
		}

		/**
   * Sets the Gets the first 5 characters of the FirstName.
   */
		,
		set: function set(f5first) {
			this._f5first = f5first;
		}
	}, {
		key: 'f5last',
		get: function get() {
			return this._f5last;
		}

		/**
   * Sets the first 5 characters of the LastName.
   */
		,
		set: function set(f5last) {
			this._f5last = f5last;
		}
	}, {
		key: 'fi',
		get: function get() {
			return this._fi;
		}

		/**
   * Sets the first Name Initial.
   */
		,
		set: function set(fi) {
			this._fi = fi;
		}
	}, {
		key: 'dobd',
		get: function get() {
			return this._dobd;
		}

		/**
   * Sets the date of birth day.
   */
		,
		set: function set(dobd) {
			this._dobd = dobd;
		}
	}, {
		key: 'dobm',
		get: function get() {
			return this._dobm;
		}

		/**
   * Sets the date of birth month.
   */
		,
		set: function set(dobm) {
			this._dobm = dobm;
		}
	}, {
		key: 'doby',
		get: function get() {
			return this._doby;
		}

		/**
   * Sets the date of birth year.
   */
		,
		set: function set(doby) {
			this._doby = doby;
		}
	}, {
		key: 'madid',
		get: function get() {
			return this._madid;
		}

		/**
   *
   */
		,
		set: function set(madid) {
			this._madid = madid;
		}
	}, {
		key: 'anon_id',
		get: function get() {
			return this._anon_id;
		}

		/**
   *
   */
		,
		set: function set(anon_id) {
			this._anon_id = anon_id;
		}
	}, {
		key: 'app_user_id',
		get: function get() {
			return this._app_user_id;
		}

		/**
   *
   */
		,
		set: function set(app_user_id) {
			this._app_user_id = app_user_id;
		}
	}], [{
		key: 'Gender',
		get: function get() {
			return Object.freeze({
				MALE: 'm',
				FEMALE: 'f'
			});
		}
	}]);
	return UserData;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

var ExtendedDeviceInfo = function () {
    function ExtendedDeviceInfo(ext_info_version, app_package_name, short_version, long_version, os_version, device_model_name, locale, timezone_abbreviation, carrier, screen_width, screen_height, screen_density, cpu_core_count, total_disk_space_gb, free_disk_space_gb, device_time_zone) {
        classCallCheck(this, ExtendedDeviceInfo);


        this._ext_info_version = ext_info_version;
        this._app_package_name = app_package_name;
        this._short_version = short_version;
        this._long_version = long_version;
        this._os_version = os_version;
        this._device_model_name = device_model_name;
        this._locale = locale;
        this._timezone_abbreviation = timezone_abbreviation;
        this._carrier = carrier;
        this._screen_width = screen_width;
        this._screen_height = screen_height;
        this._screen_density = screen_density;
        this._cpu_core_count = cpu_core_count;
        this._total_disk_space_gb = total_disk_space_gb;
        this._free_disk_space_gb = free_disk_space_gb;
        this._device_time_zone = device_time_zone;
    }

    createClass(ExtendedDeviceInfo, [{
        key: 'setExtInfoVersion',
        value: function setExtInfoVersion(ext_info_version) {
            this._ext_info_version = ext_info_version;
            return this;
        }
    }, {
        key: 'setAppPackageName',
        value: function setAppPackageName(app_package_name) {
            this._app_package_name = app_package_name;
            return this;
        }
    }, {
        key: 'setShortVersion',
        value: function setShortVersion(short_version) {
            this._short_version = short_version;
            return this;
        }
    }, {
        key: 'setLongVersion',
        value: function setLongVersion(long_version) {
            this._long_version = long_version;
            return this;
        }
    }, {
        key: 'setOsVersion',
        value: function setOsVersion(os_version) {
            this._os_version = os_version;
            return this;
        }
    }, {
        key: 'setDeviceModelName',
        value: function setDeviceModelName(device_model_name) {
            this._device_model_name = device_model_name;
            return this;
        }
    }, {
        key: 'setLocale',
        value: function setLocale(locale) {
            this._locale = locale;
            return this;
        }
    }, {
        key: 'setTimezoneAbbreviation',
        value: function setTimezoneAbbreviation(timezone_abbreviation) {
            this._timezone_abbreviation = timezone_abbreviation;
            return this;
        }
    }, {
        key: 'setCarrier',
        value: function setCarrier(carrier) {
            this._carrier = carrier;
            return this;
        }
    }, {
        key: 'setScreenWidth',
        value: function setScreenWidth(screen_width) {
            this._screen_width = screen_width;
            return this;
        }
    }, {
        key: 'setScreenHeight',
        value: function setScreenHeight(screen_height) {
            this._screen_height = screen_height;
            return this;
        }
    }, {
        key: 'setScreenDensity',
        value: function setScreenDensity(screen_density) {
            this._screen_density = screen_density;
            return this;
        }
    }, {
        key: 'setCpuCoreCount',
        value: function setCpuCoreCount(cpu_core_count) {
            this._cpu_core_count = cpu_core_count;
            return this;
        }
    }, {
        key: 'setTotalDiskSpaceGb',
        value: function setTotalDiskSpaceGb(total_disk_space_gb) {
            this._total_disk_space_gb = total_disk_space_gb;
            return this;
        }
    }, {
        key: 'setFreeDiskSpaceGb',
        value: function setFreeDiskSpaceGb(free_disk_space_gb) {
            this._free_disk_space_gb = free_disk_space_gb;
            return this;
        }
    }, {
        key: 'setDeviceTimeZone',
        value: function setDeviceTimeZone(device_time_zone) {
            this._device_time_zone = device_time_zone;
            return this;
        }
    }, {
        key: 'normalize',
        value: function normalize() {
            var EXT_INFO_VERSION = 0;
            var APP_PACKAGE_NAME = 1;
            var SHORT_VERSION = 2;
            var LONG_VERSION = 3;
            var OS_VERSION = 4;
            var DEVICE_MODEL_NAME = 5;
            var LOCALE = 6;
            var TIMEZONE_ABBREVIATION = 7;
            var CARRIER = 8;
            var SCREEN_WIDTH = 9;
            var SCREEN_HEIGHT = 10;
            var SCREEN_DENSITY = 11;
            var CPU_CORE_COUNT = 12;
            var TOTAL_DISK_SPACE_GB = 13;
            var FREE_DISK_SPACE_GB = 14;
            var DEVICE_TIME_ZONE = 15;

            var extDeviceInfo = {};

            extDeviceInfo[EXT_INFO_VERSION] = this._ext_info_version;
            extDeviceInfo[APP_PACKAGE_NAME] = this._app_package_name;
            extDeviceInfo[SHORT_VERSION] = this._short_version;
            extDeviceInfo[LONG_VERSION] = this._long_version;
            extDeviceInfo[OS_VERSION] = this._os_version;
            extDeviceInfo[DEVICE_MODEL_NAME] = this._device_model_name;
            extDeviceInfo[LOCALE] = this._locale;
            extDeviceInfo[TIMEZONE_ABBREVIATION] = this._timezone_abbreviation;
            extDeviceInfo[CARRIER] = this._carrier;
            extDeviceInfo[SCREEN_WIDTH] = this._screen_width;
            extDeviceInfo[SCREEN_HEIGHT] = this._screen_height;
            extDeviceInfo[SCREEN_DENSITY] = this._screen_density;
            extDeviceInfo[CPU_CORE_COUNT] = this._cpu_core_count;
            extDeviceInfo[TOTAL_DISK_SPACE_GB] = this._total_disk_space_gb;
            extDeviceInfo[FREE_DISK_SPACE_GB] = this._free_disk_space_gb;
            extDeviceInfo[DEVICE_TIME_ZONE] = this._device_time_zone;

            return extDeviceInfo;
        }
    }, {
        key: 'toJson',
        value: function toJson() {
            return {
                'ext_info_version': this._ext_info_version,
                'app_package_name': this._app_package_name,
                'short_version': this._short_version,
                'long_version': this._long_version,
                'os_version': this._os_version,
                'device_model_name': this._device_model_name,
                'locale': this._locale,
                'timezone_abbreviation': this._timezone_abbreviation,
                'carrier': this._carrier,
                'screen_width': this._screen_width,
                'screen_height': this._screen_height,
                'screen_density': this._screen_density,
                'cpu_core_count': this._cpu_core_count,
                'total_disk_space_gb': this._total_disk_space_gb,
                'free_disk_space_gb': this._free_disk_space_gb,
                'device_time_zone': this._device_time_zone
            };
        }
    }, {
        key: 'ext_info_version',
        get: function get() {
            return this._ext_info_version;
        },
        set: function set(ext_info_version) {
            this._ext_info_version = ext_info_version;
        }
    }, {
        key: 'app_package_name',
        get: function get() {
            return this._app_package_name;
        },
        set: function set(app_package_name) {
            this._app_package_name = app_package_name;
        }
    }, {
        key: 'short_version',
        get: function get() {
            return this._short_version;
        },
        set: function set(short_version) {
            this._short_version = short_version;
        }
    }, {
        key: 'long_version',
        get: function get() {
            return this._long_version;
        },
        set: function set(long_version) {
            this._long_version = long_version;
        }
    }, {
        key: 'os_version',
        get: function get() {
            return this._os_version;
        },
        set: function set(os_version) {
            this._os_version = os_version;
        }
    }, {
        key: 'device_model_name',
        get: function get() {
            return this._device_model_name;
        },
        set: function set(device_model_name) {
            this._device_model_name = device_model_name;
        }
    }, {
        key: 'locale',
        get: function get() {
            return this._locale;
        },
        set: function set(locale) {
            this._locale = locale;
        }
    }, {
        key: 'timezone_abbreviation',
        get: function get() {
            return this._timezone_abbreviation;
        },
        set: function set(timezone_abbreviation) {
            this._timezone_abbreviation = timezone_abbreviation;
        }
    }, {
        key: 'carrier',
        get: function get() {
            return this._carrier;
        },
        set: function set(carrier) {
            this._carrier = carrier;
        }
    }, {
        key: 'screen_width',
        get: function get() {
            return this._screen_width;
        },
        set: function set(screen_width) {
            this._screen_width = screen_width;
        }
    }, {
        key: 'screen_height',
        get: function get() {
            return this._screen_height;
        },
        set: function set(screen_height) {
            this._screen_height = screen_height;
        }
    }, {
        key: 'screen_density',
        get: function get() {
            return this._screen_density;
        },
        set: function set(screen_density) {
            this._screen_density = screen_density;
        }
    }, {
        key: 'cpu_core_count',
        get: function get() {
            return this._cpu_core_count;
        },
        set: function set(cpu_core_count) {
            this._cpu_core_count = cpu_core_count;
        }
    }, {
        key: 'total_disk_space_gb',
        get: function get() {
            return this._total_disk_space_gb;
        },
        set: function set(total_disk_space_gb) {
            this._total_disk_space_gb = total_disk_space_gb;
        }
    }, {
        key: 'free_disk_space_gb',
        get: function get() {
            return this._free_disk_space_gb;
        },
        set: function set(free_disk_space_gb) {
            this._free_disk_space_gb = free_disk_space_gb;
        }
    }, {
        key: 'device_time_zone',
        get: function get() {
            return this._device_time_zone;
        },
        set: function set(device_time_zone) {
            this._device_time_zone = device_time_zone;
        }
    }]);
    return ExtendedDeviceInfo;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

var AppData = function () {
    function AppData(application_tracking_enabled, advertiser_tracking_enabled, campaign_ids, consider_views, extinfo, include_dwell_data, include_video_data, install_referrer, installer_package, receipt_data, url_schemes, windows_attribution_id) {
        classCallCheck(this, AppData);


        this._application_tracking_enabled = application_tracking_enabled;
        this._advertiser_tracking_enabled = advertiser_tracking_enabled;
        this._campaign_ids = campaign_ids;
        this._consider_views = consider_views;
        this._extinfo = extinfo;
        this._include_dwell_data = include_dwell_data;
        this._include_video_data = include_video_data;
        this._install_referrer = install_referrer;
        this._installer_package = installer_package;
        this._receipt_data = receipt_data;
        this._url_schemes = url_schemes;
        this._windows_attribution_id = windows_attribution_id;
    }

    createClass(AppData, [{
        key: 'setApplicationTrackingEnabled',
        value: function setApplicationTrackingEnabled(application_tracking_enabled) {
            this._application_tracking_enabled = application_tracking_enabled;
            return this;
        }
    }, {
        key: 'setAdvertiserTrackingEnabled',
        value: function setAdvertiserTrackingEnabled(advertiser_tracking_enabled) {
            this._advertiser_tracking_enabled = advertiser_tracking_enabled;
            return this;
        }
    }, {
        key: 'setCampaignIds',
        value: function setCampaignIds(campaign_ids) {
            this._campaign_ids = campaign_ids;
            return this;
        }
    }, {
        key: 'setConsiderViews',
        value: function setConsiderViews(consider_views) {
            this._consider_views = consider_views;
            return this;
        }
    }, {
        key: 'setExtinfo',
        value: function setExtinfo(extinfo) {
            this._extinfo = extinfo;
            return this;
        }
    }, {
        key: 'setIncludeDwellData',
        value: function setIncludeDwellData(include_dwell_data) {
            this._include_dwell_data = include_dwell_data;
            return this;
        }
    }, {
        key: 'setIncludeVideoData',
        value: function setIncludeVideoData(include_video_data) {
            this._include_video_data = include_video_data;
            return this;
        }
    }, {
        key: 'setInstallReferrer',
        value: function setInstallReferrer(install_referrer) {
            this._install_referrer = install_referrer;
            return this;
        }
    }, {
        key: 'setInstallerPackage',
        value: function setInstallerPackage(installer_package) {
            this._installer_package = installer_package;
            return this;
        }
    }, {
        key: 'setReceiptData',
        value: function setReceiptData(receipt_data) {
            this._receipt_data = receipt_data;
            return this;
        }
    }, {
        key: 'setUrlSchemes',
        value: function setUrlSchemes(url_schemes) {
            this._url_schemes = url_schemes;
            return this;
        }
    }, {
        key: 'setWindowsAttributionId',
        value: function setWindowsAttributionId(windows_attribution_id) {
            this._windows_attribution_id = windows_attribution_id;
            return this;
        }
    }, {
        key: 'normalize',
        value: function normalize() {
            var appData = {};

            appData.application_tracking_enabled = this.application_tracking_enabled;
            appData.advertiser_tracking_enabled = this.advertiser_tracking_enabled;
            appData.campaign_ids = this.campaign_ids;
            appData.consider_views = this.consider_views;
            appData.extinfo = this.extinfo.normalize();
            appData.include_dwell_data = this.include_dwell_data;
            appData.include_video_data = this.include_video_data;
            appData.install_referrer = this.install_referrer;
            appData.installer_package = this.installer_package;
            appData.receipt_data = this.receipt_data;
            appData.url_schemes = this.url_schemes;
            appData.windows_attribution_id = this.windows_attribution_id;

            return appData;
        }
    }, {
        key: 'toJson',
        value: function toJson() {
            return {
                'application_tracking_enabled': this._application_tracking_enabled,
                'advertiser_tracking_enabled': this._advertiser_tracking_enabled,
                'campaign_ids': this._campaign_ids,
                'consider_views': this._consider_views,
                'extinfo': this._extinfo.normalize(),
                'include_dwell_data': this._include_dwell_data,
                'include_video_data': this._include_video_data,
                'install_referrer': this._install_referrer,
                'installer_package': this._installer_package,
                'receipt_data': this._receipt_data,
                'url_schemes': this._url_schemes,
                'windows_attribution_id': this._windows_attribution_id
            };
        }
    }, {
        key: 'application_tracking_enabled',
        get: function get() {
            return this._application_tracking_enabled;
        },
        set: function set(application_tracking_enabled) {
            this._application_tracking_enabled = application_tracking_enabled;
        }
    }, {
        key: 'advertiser_tracking_enabled',
        get: function get() {
            return this._advertiser_tracking_enabled;
        },
        set: function set(advertiser_tracking_enabled) {
            this._advertiser_tracking_enabled = advertiser_tracking_enabled;
        }
    }, {
        key: 'campaign_ids',
        get: function get() {
            return this._campaign_ids;
        },
        set: function set(campaign_ids) {
            this._campaign_ids = campaign_ids;
        }
    }, {
        key: 'consider_views',
        get: function get() {
            return this._consider_views;
        },
        set: function set(consider_views) {
            this._consider_views = consider_views;
        }
    }, {
        key: 'extinfo',
        get: function get() {
            return this._extinfo;
        },
        set: function set(extinfo) {
            this._extinfo = extinfo;
        }
    }, {
        key: 'include_dwell_data',
        get: function get() {
            return this._include_dwell_data;
        },
        set: function set(include_dwell_data) {
            this._include_dwell_data = include_dwell_data;
        }
    }, {
        key: 'include_video_data',
        get: function get() {
            return this._include_video_data;
        },
        set: function set(include_video_data) {
            this._include_video_data = include_video_data;
        }
    }, {
        key: 'install_referrer',
        get: function get() {
            return this._install_referrer;
        },
        set: function set(install_referrer) {
            this._install_referrer = install_referrer;
        }
    }, {
        key: 'installer_package',
        get: function get() {
            return this._installer_package;
        },
        set: function set(installer_package) {
            this._installer_package = installer_package;
        }
    }, {
        key: 'receipt_data',
        get: function get() {
            return this._receipt_data;
        },
        set: function set(receipt_data) {
            this._receipt_data = receipt_data;
        }
    }, {
        key: 'url_schemes',
        get: function get() {
            return this._url_schemes;
        },
        set: function set(url_schemes) {
            this._url_schemes = url_schemes;
        }
    }, {
        key: 'windows_attribution_id',
        get: function get() {
            return this._windows_attribution_id;
        },
        set: function set(windows_attribution_id) {
            this._windows_attribution_id = windows_attribution_id;
        }
    }]);
    return AppData;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * ServerEvent
 * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event}
 */

var ServerEvent = function () {

	/**
  * @param {String} event_name A Facebook pixel Standard Event or Custom Event name.
  * @param {Number} event_time A Unix timestamp in seconds indicating when the actual event occurred.
  * @param {String} event_source_url The browser URL where the event happened.
  * @param {String} event_id This ID can be any string chosen by the advertiser.
  * @param {String} action_source A string that indicates where the event took place.
  * @param {Boolean} opt_out A flag that indicates we should not use this event for ads delivery optimization.
  * @param {UserData} user_data A map that contains user data. See UserData Class for options.
  * @param {CustomData} custom_data A map that contains user data. See CustomData Class for options.
  * @param {Array<string>} data_processing_options Processing options you would like to enable for a specific event.
  * @param {Number} data_processing_options_country A country that you want to associate to this data processing option.
  * @param {Number} data_processing_options_state A state that you want to associate with this data processing option.
  */
	function ServerEvent(event_name, event_time, event_source_url, user_data, custom_data, app_data, event_id, opt_out, action_source, data_processing_options, data_processing_options_country, data_processing_options_state) {
		classCallCheck(this, ServerEvent);


		this._event_name = event_name;
		this._event_time = event_time;
		this._user_data = user_data;
		this._custom_data = custom_data;
		this._app_data = app_data;
		this._event_source_url = event_source_url;
		this.event_id = event_id;
		this._opt_out = opt_out;
		this._action_source = action_source;
		this._data_processing_options = data_processing_options;
		this._data_processing_options_country = data_processing_options_country;
		this._data_processing_options_state = data_processing_options_state;
	}

	/**
  * Gets the Event Name for the current Event.
  */


	createClass(ServerEvent, [{
		key: 'setEventName',


		/**
   * Sets the Event Name for the current Event.
   * @param {String} event_name Facebook pixel Standard Event or Custom Event name.
   */
		value: function setEventName(event_name) {
			this._event_name = event_name;
			return this;
		}

		/**
   * Gets the Event Time when the current Event happened.
   */

	}, {
		key: 'setEventTime',


		/**
   * Sets the Event Time when the current Event happened.
   * @param {Number} event_time is a Unix timestamp in seconds indicating when the actual event occurred.
   */
		value: function setEventTime(event_time) {
			this._event_time = event_time;
			return this;
		}

		/**
   * Gets the browser url source for the current event.
   */

	}, {
		key: 'setEventSourceUrl',


		/**
   * Sets the browser url source for the current event.
   * @param {String} event_source_url The browser URL where the event happened.
   */
		value: function setEventSourceUrl(event_source_url) {
			this._event_source_url = event_source_url;
			return this;
		}

		/**
   * Gets the event_id for the current Event.
   */

	}, {
		key: 'setEventId',


		/**
   * Sets the event Id for the current Event.
   * @param {String} event_id can be any string chosen by the advertiser. This is used with event_name to determine if events are identical.
   * Learn about Deduplicate Pixel and Conversions API Events: {@link https://developers.facebook.com/docs/marketing-api/conversions-api/deduplicate-pixel-and-server-events}
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#event-id}
   */
		value: function setEventId(event_id) {
			this._event_id = event_id;
			return this;
		}

		/**
   * Gets the action_source for the current event. The Action Source represents where the action took place.
   */

	}, {
		key: 'setActionSource',


		/**
   * Sets the action_source for the current event.
   * @param {String} action_source represents where the action took place. One of {'physical_store','app','chat','email','other','phone_call','system_generated','website'}
   */
		value: function setActionSource(action_source) {
			this._action_source = action_source;
			return this;
		}

		/**
   * Gets the opt_out feature for the current event.opt_out is a boolean flag that indicates we should not use this event for ads delivery optimization. If set to true, we only use the event for attribution.
   */

	}, {
		key: 'setOptOut',


		/**
   * Sets the opt_out feature for the current event.
   * @param {Boolean} opt_out is a boolean flag that indicates we should not use this event for ads delivery optimization. If set to true, we only use the event for attribution.
   */
		value: function setOptOut(opt_out) {
			this._opt_out = opt_out;
			return this;
		}

		/**
   * Gets the user data object for the current Server Event.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#user-data}
   */

	}, {
		key: 'setUserData',


		/**
   * Sets the user data object for the current Server Event.
   * @param {UserData} user_data user_data is a map that contains user data. See User Data Parameter Table for options. Also see Advanced Matching with the Pixel to see comparable options available for data sent via Facebook pixel.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#user-data}
   */
		value: function setUserData(user_data) {
			this._user_data = user_data;
			return this;
		}

		/**
   * Gets the custom data object for the current Server Event.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#custom-data}
   */

	}, {
		key: 'setCustomData',


		/**
   * Sets the custom data object for the current Server Event.
   * @param {CustomData} custom_data is a map that includes additional business data about the event.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#custom-data}
   */
		value: function setCustomData(custom_data) {
			this._custom_data = custom_data;
			return this;
		}

		/**
   *
   */

	}, {
		key: 'setAppData',


		/**
   *
   */
		value: function setAppData(app_data) {
			this._app_data = app_data;
			return this;
		}

		/**
   * Gets the data_processing_options for the current event.
   * Processing options you would like to enable for a specific event.
   */

	}, {
		key: 'setDataProcessingOptions',


		/**
   * Sets the data_processing_options for the current event.
   * @param {Array<string>} data_processing_options represents Data processing options you would like to enable for a specific event, e.g. [] or ['LDU']
   * @see {@link https://developers.facebook.com/docs/marketing-apis/data-processing-options}
   */
		value: function setDataProcessingOptions(data_processing_options) {
			this._data_processing_options = data_processing_options;
			return this;
		}

		/**
   * Gets the data_processing_options_country for the current event.
   * A country that you want to associate to this data processing option.
   * @see {@link https://developers.facebook.com/docs/marketing-apis/data-processing-options}
   */

	}, {
		key: 'setDataProcessingOptionsCountry',


		/**
   * Sets the data_processing_options_country for the current event.
   * @param {number} data_processing_options_country represents country that you want to associate to this data processing option.
   */
		value: function setDataProcessingOptionsCountry(data_processing_options_country) {
			this._data_processing_options_country = data_processing_options_country;
			return this;
		}

		/**
   * Gets the data_processing_options_state for the current event.
   * A state that you want to associate with this data processing option.
   * @see {@link https://developers.facebook.com/docs/marketing-apis/data-processing-options}
   */

	}, {
		key: 'setDataProcessingOptionsState',


		/**
   * Sets the data_processing_options_state for the current event.
   * @param {number} data_processing_options_state represents state that you want to associate with this data processing option.
   */
		value: function setDataProcessingOptionsState(data_processing_options_state) {
			this._data_processing_options_state = data_processing_options_state;
			return this;
		}

		/**
   * Returns the normalized payload for the event.
   * @returns {Object} normalized event payload.
   */

	}, {
		key: 'normalize',
		value: function normalize() {

			var serverEvent = {};

			if (this.event_name) {
				serverEvent.event_name = this.event_name;
			}

			if (this.event_time) {
				serverEvent.event_time = this.event_time;
			}

			if (this.user_data) {
				serverEvent.user_data = this.user_data.normalize();
			}

			if (this.custom_data) {
				serverEvent.custom_data = this.custom_data.normalize();
			}

			if (this.app_data) {
				serverEvent.app_data = this.app_data.normalize();
			}

			if (this.action_source) {
				serverEvent.action_source = this.action_source.toLowerCase();
			}

			if (this.opt_out) {
				serverEvent.opt_out = this.opt_out;
			}

			if (this.event_id) {
				serverEvent.event_id = this.event_id;
			}

			if (this.event_source_url) {
				serverEvent.event_source_url = this.event_source_url;
			}

			if (this.data_processing_options) {
				serverEvent.data_processing_options = this.data_processing_options;
			}

			if (this.data_processing_options_country) {
				serverEvent.data_processing_options_country = this.data_processing_options_country;
			}

			if (this.data_processing_options_state) {
				serverEvent.data_processing_options_state = this.data_processing_options_state;
			}

			return serverEvent;
		}
	}, {
		key: 'event_name',
		get: function get() {
			return this._event_name;
		}

		/**
   * Sets the Event Name for the current Event.
   * @param {String} event_name a Facebook pixel Standard Event or Custom Event name.
   */
		,
		set: function set(event_name) {
			this._event_name = event_name;
		}
	}, {
		key: 'event_time',
		get: function get() {
			return this._event_time;
		}

		/**
   * Sets the Event Time when the current Event happened.
   * @param {Number} event_time is a Unix timestamp in seconds indicating when the actual event occurred.
   */
		,
		set: function set(event_time) {
			this._event_time = event_time;
		}
	}, {
		key: 'event_source_url',
		get: function get() {
			return this._event_source_url;
		}

		/**
   * Sets the browser url source for the current event.
   * @param {String} event_source_url The browser URL where the event happened.
   */
		,
		set: function set(event_source_url) {
			this._event_source_url = event_source_url;
		}
	}, {
		key: 'event_id',
		get: function get() {
			return this._event_id;
		}

		/**
   * Sets the event Id for the current Event.
   * @param {String} event_id can be any string chosen by the advertiser. This is used with event_name to determine if events are identical.
   * Learn about Deduplicate Pixel and Conversions API Events: {@link https://developers.facebook.com/docs/marketing-api/conversions-api/deduplicate-pixel-and-server-events}
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#event-id}
   */
		,
		set: function set(event_id) {
			this._event_id = event_id;
		}
	}, {
		key: 'action_source',
		get: function get() {
			return this._action_source;
		}

		/**
   * Sets the action_source for the current event.
   * @param {String} action_source represents where the action took place. One of {'physical_store','app','chat','email','other','phone_call','system_generated','website'}
   */
		,
		set: function set(action_source) {
			this._action_source = action_source;
		}
	}, {
		key: 'opt_out',
		get: function get() {
			return this._opt_out;
		}

		/**
   * Sets the opt_out feature for the current event.
   * @param {Boolean} opt_out is a boolean flag that indicates we should not use this event for ads delivery optimization. If set to true, we only use the event for attribution.
   */
		,
		set: function set(opt_out) {
			this._opt_out = opt_out;
		}
	}, {
		key: 'user_data',
		get: function get() {
			return this._user_data;
		}

		/**
   * Sets the user data object for the current Server Event.
   * @param {UserData} user_data user_data is a map that contains user data. See User Data Parameter Table for options. Also see Advanced Matching with the Pixel to see comparable options available for data sent via Facebook pixel.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#user-data}
   */
		,
		set: function set(user_data) {
			this._user_data = user_data;
		}
	}, {
		key: 'custom_data',
		get: function get() {
			return this._custom_data;
		}

		/**
   * Sets the custom data object for the current Server Event.
   * @param {CustomData} custom_data is a map that includes additional business data about the event.
   * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/server-event#custom-data}
   */
		,
		set: function set(custom_data) {
			this._custom_data = custom_data;
		}
	}, {
		key: 'app_data',
		get: function get() {
			return this._app_data;
		}

		/**
   *
   */
		,
		set: function set(app_data) {
			this._app_data = app_data;
		}
	}, {
		key: 'data_processing_options',
		get: function get() {
			return this._data_processing_options;
		}

		/**
   * Sets the data_processing_options for the current event.
   * @param {Array<string>} data_processing_options represents Data processing options you would like to enable for a specific event, e.g. [] or ['LDU']
   * @see {@link https://developers.facebook.com/docs/marketing-apis/data-processing-options}
   */
		,
		set: function set(data_processing_options) {
			this._data_processing_options = data_processing_options;
		}
	}, {
		key: 'data_processing_options_country',
		get: function get() {
			return this._data_processing_options_country;
		}

		/**
   * Sets the data_processing_options_country for the current event.
   * @param {number} data_processing_options_country represents country that you want to associate to this data processing option.
   */
		,
		set: function set(data_processing_options_country) {
			this._data_processing_options_country = data_processing_options_country;
		}
	}, {
		key: 'data_processing_options_state',
		get: function get() {
			return this._data_processing_options_state;
		}

		/**
   * Sets the data_processing_options_state for the current event.
   * @param {number} data_processing_options_state represents state that you want to associate with this data processing option.
   */
		,
		set: function set(data_processing_options_state) {
			this._data_processing_options_state = data_processing_options_state;
		}
	}]);
	return ServerEvent;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * EventRequest
 * @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters}
 */

var EventRequest = function () {

	/**
  * @param {String} access_token Access Token for the user calling Graph API
  * @param {String} pixel_id Pixel Id to which you are sending the events
  * @param {Array<ServerEvent>} events Data for the request Payload for a Conversions API Event
  * @param {?String} partner_agent Platform from which the event is sent e.g. wordpress
  * @param {?String} test_event_code Test Event Code used to verify that your server events are received correctly by Facebook.
  * @param {?String} namespace_id Scope used to resolve extern_id or Third-party ID. Can be another data set or data partner ID.
  * @param {?String} upload_id Unique id used to denote the current set being uploaded.
  * @param {?String} upload_tag Tag string added to track your Offline event uploads.
  * @param {?String} upload_source The origin/source of data for the dataset to be uploaded.
  * @param {Boolean} debug_mode_flag Set to true if you want to enable more logging in SDK
  * @param {?HttpServiceInterface} http_service Override the default http request method by setting an object that implements HttpServiceInterface
  */
	function EventRequest(access_token, pixel_id) {
		var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
		var partner_agent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
		var test_event_code = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
		var namespace_id = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
		var upload_id = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
		var upload_tag = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
		var upload_source = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
		var debug_mode_flag = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
		var http_service = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : null;
		classCallCheck(this, EventRequest);

		this._access_token = access_token;
		this._pixel_id = pixel_id;
		this._events = events;
		this._partner_agent = partner_agent;
		this._test_event_code = test_event_code;
		this._namespace_id = namespace_id;
		this._upload_id = upload_id;
		this._upload_tag = upload_tag;
		this._upload_source = upload_source;
		this._debug_mode = debug_mode_flag;

		this._http_service = http_service;
		this._api = FacebookAdsApi.init(this._access_token);
	}

	/**
  * Gets the data for the request Payload for a Conversions API Event. events is represented by a list/array of ServerEvent objects.
  */


	createClass(EventRequest, [{
		key: 'setEvents',


		/**
   * Sets the events for the request Payload for a Conversions API Event.
   * events is represented by a list/array of ServerEvent objects.
   * @param events for the current server event
   */
		value: function setEvents(events) {
			this._events = events;
			return this;
		}

		/**
   * Gets the partner_agent for the request
   * Allows you to specify the platform from which the event is sent e.g. wordpress
   */

	}, {
		key: 'setPartnerAgent',


		/**
   * Sets the partner_agent for the request
   * Allows you to specify the platform from which the event is sent e.g. wordpress
   * @param {String} partner_agent String value for the partner agent
   */
		value: function setPartnerAgent(partner_agent) {
			this._partner_agent = partner_agent;
			return this;
		}

		/**
   * Gets the test_event_code for the request
   * Code used to verify that your server events are received correctly by Facebook.
   * Use this code to test your server events in the Test Events feature in Events Manager.
   * See Test Events Tool @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/main-body#test_event_code} for an example.
   */

	}, {
		key: 'setTestEventCode',


		/**
   * Sets the test_event_code for the request
   * Code used to verify that your server events are received correctly by Facebook.
   * Use this code to test your server events in the Test Events feature in Events Manager.
   * See Test Events Tool @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/main-body#test_event_code} for an example.
   */
		value: function setTestEventCode(test_event_code) {
			this._test_event_code = test_event_code;
			return this;
		}

		/**
   * Gets the debug mode flag for the Graph API request
   */

	}, {
		key: 'setDebugMode',


		/**
   * Sets the debug mode flag for the Graph API request
   * @param {Boolean} debug_mode boolean value representing whether you want to send the request in debug mode to get detailed logging.
   */
		value: function setDebugMode(debug_mode) {
			this._debug_mode = debug_mode;
			return this;
		}

		/**
   * Gets the access token for the Graph API request
   */

	}, {
		key: 'setAccessToken',


		/**
   * Sets the access token for the Graph API request
   * @param {String} access_token string representing the access token that is used to make the Graph API.
   */
		value: function setAccessToken(access_token) {
			this._access_token = access_token;
			return this;
		}

		/**
   * Gets the pixel against which we send the events
   */

	}, {
		key: 'setPixelId',


		/**
   * Sets the pixel against which we send the events
   * @param {String} pixel_id String value for the pixel_id against which you want to send the events.
   */
		value: function setPixelId(pixel_id) {
			this._pixel_id = pixel_id;
			return this;
		}

		/* Region Offline Conversion Fields */
		/**
   * Gets the NamespaceId for the events
   */

	}, {
		key: 'setNamespaceId',


		/**
   * Sets the namespace_id for the events
   * @param {String} namespace_id Scope used to resolve extern_id or Third-party ID. Can be another data set or data partner ID.
   */
		value: function setNamespaceId(namespace_id) {
			this._namespace_id = namespace_id;
			return this;
		}

		/**
   * Gets the Upload Tag for the current events upload
   */

	}, {
		key: 'setUploadTag',


		/**
   * Sets the upload_tag for the current events upload
   * @param {String} upload_tag Tag string added to Track your Offline event uploads
   */
		value: function setUploadTag(upload_tag) {
			this._upload_tag = upload_tag;
			return this;
		}

		/**
   * Gets the Upload Tag for the current events upload
   */

	}, {
		key: 'setUploadId',


		/**
   * Sets the upload_id for the current events upload
   * @param {String} upload_id Unique id used to denote the current set being uploaded
   */
		value: function setUploadId(upload_id) {
			this._upload_id = upload_id;
			return this;
		}

		/**
   * Gets the Upload Tag for the current events upload
   */

	}, {
		key: 'setUploadSource',


		/**
   * Sets the upload_source for the current events upload
   * @param {String} upload_source origin/source of data for the dataset to be uploaded.
   */
		value: function setUploadSource(upload_source) {
			this._upload_source = upload_source;
			return this;
		}

		/**
   * Gets the http_service object for making the events request
   */

	}, {
		key: 'setHttpService',


		/**
   * Sets the http_service object for making the events request
   * @param {HttpServiceInterface} http_service
   */
		value: function setHttpService(http_service) {
			this._http_service = http_service;
			return this;
		}

		/**
   * Executes the current event_request data by making a call to the Facebook Graph API.
   */

	}, {
		key: 'execute',
		value: function execute() {
			var fields = void 0,
			    params = void 0;
			fields = [];
			params = {};

			var normalized_events = [];

			for (var i = 0; i < this.events.length; i++) {
				var event = this.events[i];
				var normalized_event = event.normalize.call(event);
				normalized_events.push(normalized_event);
			}

			if (this.debug_mode) {
				this._api.setDebug(true);
			}

			params = {
				'data': normalized_events,
				'partner_agent': this.partner_agent,
				'test_event_code': this.test_event_code,
				'namespace_id': this.namespace_id,
				'upload_id': this.upload_id,
				'upload_tag': this.upload_tag,
				'upload_source': this.upload_source,
				'access_token': this.access_token
			};

			var http_service = void 0;
			if (this._http_service != null) {
				http_service = this._http_service;
			} else {
				http_service = HttpServiceClientConfig.getClient();
			}
			if (http_service != null) {
				var url = [FacebookAdsApi.GRAPH, FacebookAdsApi.VERSION, this._pixel_id, 'events'].join('/');
				var headers = {
					'User-Agent': 'fbbizsdk-nodejs-v' + FacebookAdsApi.SDK_VERSION,
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				};

				return http_service.executeRequest(url, HttpMethod.POST, headers, params);
			}
			var adsPixelPromise = new AdsPixel(this._pixel_id).createEvent(fields, params);

			return adsPixelPromise.then(function (response) {
				return new EventResponse(response._data['events_received'], response._data['messages'], response._data['fbtrace_id'], response._data['id'], response._data['num_processed_entries']);
			});
		}
	}, {
		key: 'cloneWithoutEvents',
		value: function cloneWithoutEvents() {
			return new EventRequest(this._access_token, this._pixel_id, [], this._partner_agent, this._test_event_code, this._namespace_id, this._upload_id, this._upload_tag, this._upload_source, this._debug_mode);
		}
	}, {
		key: 'events',
		get: function get() {
			return this._events;
		}

		/**
   * Sets the events for the request Payload for a Conversions API Event.
   * events is represented by a list/array of ServerEvent objects.
   * @param events for the current server event
   */
		,
		set: function set(events) {
			this._events = events;
		}
	}, {
		key: 'partner_agent',
		get: function get() {
			return this._partner_agent;
		}

		/**
   * Sets the partner_agent for the request
   * Allows you to specify the platform from which the event is sent e.g. wordpress
   * @param {String} partner_agent String value for the partner agent
   */
		,
		set: function set(partner_agent) {
			this._partner_agent = partner_agent;
		}
	}, {
		key: 'test_event_code',
		get: function get() {
			return this._test_event_code;
		}

		/**
   * Sets the test_event_code for the request
   * Code used to verify that your server events are received correctly by Facebook.
   * Use this code to test your server events in the Test Events feature in Events Manager.
   * See Test Events Tool @see {@link https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/main-body#test_event_code} for an example.
   */
		,
		set: function set(test_event_code) {
			this._test_event_code = test_event_code;
		}
	}, {
		key: 'debug_mode',
		get: function get() {
			return this._debug_mode;
		}

		/**
   * Sets the debug mode flag for the Graph API request
   * @param debug_mode boolean value representing whether you want to send the request in debug mode to get detailed logging.
   */
		,
		set: function set(debug_mode) {
			this._debug_mode = debug_mode;
		}
	}, {
		key: 'access_token',
		get: function get() {
			return this._access_token;
		}

		/**
   * Sets the access token for the Graph API request
   * @param access_token string representing the access token that is used to make the Graph API.
   */
		,
		set: function set(access_token) {
			this._access_token = access_token;
		}
	}, {
		key: 'pixel',
		get: function get() {
			return this._pixel_id;
		}

		/**
   * Sets the pixel against which we send the events
   * @param {String} pixel_id string value representing the Pixel's Id to which you are sending the events.
   */

	}, {
		key: 'pixel_id',
		set: function set(pixel_id) {
			this._pixel_id = pixel_id;
		}
	}, {
		key: 'namespace_id',
		get: function get() {
			return this._namespace_id;
		}

		/**
   * Sets the namespace_id for the events
   * @param {String} namespace_id Scope used to resolve extern_id or Third-party ID. Can be another data set or data partner ID.
   */
		,
		set: function set(namespace_id) {
			this._namespace_id = namespace_id;
		}
	}, {
		key: 'upload_tag',
		get: function get() {
			return this._upload_tag;
		}

		/**
   * Sets the upload_tag for the current events upload
   * @param {String} upload_tag Tag string added to Track your Offline event uploads
   */
		,
		set: function set(upload_tag) {
			this._upload_tag = upload_tag;
		}
	}, {
		key: 'upload_id',
		get: function get() {
			return this._upload_id;
		}

		/**
   * Sets the upload_id for the current events upload
   * @param {String} upload_id Unique id used to denote the current set being uploaded
   */
		,
		set: function set(upload_id) {
			this._upload_id = upload_id;
		}
	}, {
		key: 'upload_source',
		get: function get() {
			return this._upload_source;
		}

		/**
   * Sets the upload_source for the current events upload
   * @param {String} upload_source origin/source of data for the dataset to be uploaded.
   */
		,
		set: function set(upload_source) {
			this._upload_source = upload_source;
		}
	}, {
		key: 'http_service',
		get: function get() {
			return this._http_service;
		}

		/**
   * Sets the http_service object for making the events request
   * @param {HttpServiceInterface} http_service
   */
		,
		set: function set(http_service) {
			this._http_service = http_service;
		}
	}]);
	return EventRequest;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

var BatchProcessor = function () {
    function BatchProcessor(batch_size, concurrent_requests) {
        classCallCheck(this, BatchProcessor);

        this._batch_size = batch_size;
        this._concurrent_requests = concurrent_requests;
    }

    createClass(BatchProcessor, [{
        key: 'processEventRequestsGenerator',
        value: function* processEventRequestsGenerator(event_requests) {
            var start = 0;
            var end = this._concurrent_requests;
            var requests = event_requests.slice(start, end);
            while (requests.length > 0) {
                yield requests.map(function (request) {
                    return request.execute();
                });
                start = end;
                end += this._concurrent_requests;
                requests = event_requests.slice(start, end);
            }
            return;
        }
    }, {
        key: 'processEventRequests',
        value: function () {
            var _ref = asyncToGenerator(function* (event_requests) {
                var generator = this.processEventRequestsGenerator(event_requests);
                while (true) {
                    var batch = generator.next().value;
                    if (!batch || batch.length === 0) {
                        generator.return();
                        return;
                    }
                    yield Promise.all(batch);
                }
            });

            function processEventRequests(_x) {
                return _ref.apply(this, arguments);
            }

            return processEventRequests;
        }()
    }, {
        key: 'processEventsGenerator',
        value: function* processEventsGenerator(event_request_to_clone, all_events) {
            var index = 0;
            while (index < all_events.length) {
                var event_requests = [];
                while (index < all_events.length && event_requests.length < this._concurrent_requests) {
                    var event_request = event_request_to_clone.cloneWithoutEvents();
                    var events = all_events.slice(index, index + this._batch_size);
                    event_request.setEvents(events);
                    event_requests.push(event_request);
                    index += this._batch_size;
                }
                yield event_requests.map(function (request) {
                    return request.execute();
                });
            }
            return;
        }
    }, {
        key: 'processEvents',
        value: function () {
            var _ref2 = asyncToGenerator(function* (event_request_to_clone, all_events) {
                var generator = this.processEventsGenerator(event_request_to_clone, all_events);
                while (true) {
                    var batch = generator.next().value;
                    if (!batch || batch.length === 0) {
                        generator.return();
                        return;
                    }
                    yield Promise.all(batch);
                }
            });

            function processEvents(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return processEvents;
        }()
    }]);
    return BatchProcessor;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * UserData represents the User Data Parameters(user_data) of a Business Data Event Request.
 */

var UserData$3 = function () {

  /**
   * @param {String} email An email address, in lowercase.
   * @param {String} phone A phone number. Include only digits with country code, area code, and number.
   * @param {String} first_name A first name in lowercase.
   * @param {String} last_name A last name in lowercase.
   * @param {String} date_of_birth A date of birth given as year, month, and day in YYYYMMDD format.
   * @param {String} city A city in lower-case without spaces or punctuation.
   * @param {String} state A two-letter state code in lowercase.
   * @param {String} country A two-letter country code in lowercase.
   * @param {String} zip Postal code of the city in your country standard.
   * @param {String} external_id Any unique ID from the business.
   * @param {String} address An physical address.
   */
  function UserData(email, phone, first_name, last_name, date_of_birth, city, state, zip, country, external_id, address) {
    classCallCheck(this, UserData);

    this._email = email;
    this._phone = phone;
    this._first_name = first_name;
    this._last_name = last_name;
    this._date_of_birth = date_of_birth;
    this._city = city;
    this._state = state;
    this._country = country;
    this._zip = zip;
    this._external_id = external_id;
    this._address = address;
  }

  /**
   * Gets the email address for the user data field.
   * An email address, in lowercase.
   * Example: joe@eg.com
   */


  createClass(UserData, [{
    key: 'setEmail',


    /**
     * Sets the email address for the user data field.
     * @param {String} email An email address, in lowercase.
     * Example: joe@eg.com
     */
    value: function setEmail(email) {
      this._email = email;
      return this;
    }

    /**
     * Gets the phone number for the user data.
     * A phone number. Include only digits with country code, area code, and number.
     * Example: 16505551212
     */

  }, {
    key: 'setPhone',


    /**
     * Sets the phone number for the user data.
     * @param {String} phone A phone number. Include only digits with country code, area code, and number.
     * Example: 16505551212
     */
    value: function setPhone(phone) {
      this._phone = phone;
      return this;
    }

    /**
     * Gets the date of birth for the user data.
     * A date of birth given as year, month, and day in the Format YYYYMMDD
     * Example: 19971226 for December 26, 1997.
     */

  }, {
    key: 'setDateOfBirth',


    /**
     * Sets the date of birth for the user data.
     * @param {String} date_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
     * Example: 19971226 for December 26, 1997.
     */
    value: function setDateOfBirth(date_of_birth) {
      this._date_of_birth = date_of_birth;
      return this;
    }

    /**
     * Gets the last name for the user data.
     * last_name is the last name in lowercase.
     * Example: smith
     */

  }, {
    key: 'setLastName',


    /**
     * Sets the last name for the user data.
     * @param {String} last_name is last name in lowercase.
     * Example: smith
     */
    value: function setLastName(last_name) {
      this._last_name = last_name;
      return this;
    }

    /**
     * Gets the first name for the user data.
     * first_name is first name in lowercase.
     * Example: joe
     */

  }, {
    key: 'setFirstName',


    /**
     * Sets the first name for the user data.
     * @param {String} first_name is first name in lowercase.
     * Example: joe
     */
    value: function setFirstName(first_name) {
      this._first_name = first_name;
      return this;
    }

    /**
     * Gets the city for the user data.
     * city is city in lower-case without spaces or punctuation.
     * Example: menlopark
     */

  }, {
    key: 'setCity',


    /**
     * Sets the city for the user data.
     * @param {String} city is city in lower-case without spaces or punctuation.
     * Example: menlopark
     */
    value: function setCity(city) {
      this._city = city;
      return this;
    }

    /**
     * Gets the zip/postal code for the user data.
     * zip is a five-digit zip code for United States.For other locations, follow each country's standards.
     * Example: 98121 (for United States zip code)
     */

  }, {
    key: 'setZip',


    /**
     * Sets the zip/postal code for the user data.
     * @param {String} zip is a five-digit zip code for United States.For other locations, follow each country's standards.
     * Example: 98121 (for United States zip code)
     */
    value: function setZip(zip) {
      this._zip = zip;
      return this;
    }

    /**
     * Gets the state for the user data.
     * state is state in lower-case without spaces or punctuation.
     * Example: ca
     */

  }, {
    key: 'setState',


    /**
     * Sets the state for the user data.
     * @param {String} state is state in lower-case without spaces or punctuation.
     * Example: ca
     */
    value: function setState(state) {
      this._state = state;
      return this;
    }

    /**
     * Gets the country for the user data.
     * country is A two-letter country code in lowercase.
     * Example: usa
     */

  }, {
    key: 'setCountry',


    /**
     * Sets the country for the user data.
     * @param {String} country is A two-letter country code in lowercase.
     * Example: usa
     */
    value: function setCountry(country) {
      this._country = country;
      return this;
    }

    /**
     * Gets the external id for the user data.
     * external_id is a unique ID from the business, such as loyalty membership IDs, user IDs, and external cookie IDs.
     */

  }, {
    key: 'setExternalId',


    /**
     * Sets the external id for the user data.
     * @param {String} external_id is a unique ID from the business, such as loyalty membership IDs, user IDs, and external cookie IDs.
     */
    value: function setExternalId(external_id) {
      this._external_id = external_id;
      return this;
    }

    /**
     * Gets the address for the user data.
     * address is a physical address
     */

  }, {
    key: 'setAddress',


    /**
     * Sets the address for the user data.
     * @param {String} address is a physical address
     */
    value: function setAddress(address) {
      this._address = address;
    }

    /**
     * Convert to Json object for api call
     */

  }, {
    key: 'toJson',
    value: function toJson() {
      return {
        'em': this._email,
        'ph': this._phone,
        'fn': this._first_name,
        'ln': this._last_name,
        'db': this._date_of_birth,
        'ct': this._city,
        'st': this._state,
        'country': this._country,
        'zp': this._zip,
        'external_id': this._external_id,
        'addr': this._address
      };
    }
  }, {
    key: 'email',
    get: function get() {
      return this._email;
    }

    /**
     * Sets the email address for the user data field.
     * @param email An email address, in lowercase.
     * Example: joe@eg.com
     */
    ,
    set: function set(email) {
      this._email = email;
    }
  }, {
    key: 'phone',
    get: function get() {
      return this._phone;
    }

    /**
     * Sets the phone number for the user data.
     * @param phone A phone number. Include only digits with country code, area code, and number.
     * Example: 16505551212
     */
    ,
    set: function set(phone) {
      this._phone = phone;
    }
  }, {
    key: 'date_of_birth',
    get: function get() {
      return this._date_of_birth;
    }

    /**
     * Sets the date of birth for the user data.
     * @param date_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
     * Example: 19971226 for December 26, 1997.
     */
    ,
    set: function set(date_of_birth) {
      this._date_of_birth = date_of_birth;
    }
  }, {
    key: 'last_name',
    get: function get() {
      return this._last_name;
    }

    /**
     * Sets the last name for the user data.
     * @param last_name is last name in lowercase.
     * Example: smith
     */
    ,
    set: function set(last_name) {
      this._last_name = last_name;
    }
  }, {
    key: 'first_name',
    get: function get() {
      return this._first_name;
    }

    /**
     * Sets the first name for the user data.
     * @param first_name is first name in lowercase.
     * Example: joe
     */
    ,
    set: function set(first_name) {
      this._first_name = first_name;
    }
  }, {
    key: 'city',
    get: function get() {
      return this._city;
    }

    /**
     * Sets the city for the user data.
     * @param city is city in lower-case without spaces or punctuation.
     * Example: menlopark
     */
    ,
    set: function set(city) {
      this._city = city;
    }
  }, {
    key: 'zip',
    get: function get() {
      return this._zip;
    }

    /**
     * Sets the zip/postal code for the user data.
     * @param zip is a five-digit zip code for United States.For other locations, follow each country's standards.
     * Example: 98121 (for United States zip code)
     */
    ,
    set: function set(zip) {
      this._zip = zip;
    }
  }, {
    key: 'state',
    get: function get() {
      return this._state;
    }

    /**
     * Sets the state for the user data.
     * @param state is state in lower-case without spaces or punctuation.
     * Example: ca
     */
    ,
    set: function set(state) {
      this._state = state;
    }
  }, {
    key: 'country',
    get: function get() {
      return this._country;
    }

    /**
     * Sets the country for the user data.
     * @param country is A two-letter country code in lowercase.
     * Example: usa
     */
    ,
    set: function set(country) {
      this._country = country;
    }
  }, {
    key: 'external_id',
    get: function get() {
      return this._external_id;
    }

    /**
     * Sets the external id for the user data.
     * @param external_id is a unique ID from the business, such as loyalty membership IDs, user IDs, and external cookie IDs.
     */
    ,
    set: function set(external_id) {
      this._external_id = external_id;
    }
  }, {
    key: 'address',
    get: function get() {
      return this._address;
    }

    /**
     * Sets the address for the user data.
     * @param address is a physical address
     */
    ,
    set: function set(address) {
      this._address = address;
    }
  }]);
  return UserData;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * Utils contains the Utility modules used for sending Signal Events
 */

var Utils$2 = function () {
  function Utils() {
    classCallCheck(this, Utils);
  }

  createClass(Utils, null, [{
    key: 'constructResponse',


    /**
     * construct set method return
     * @param any server_return
     * @param any bdapi_return
     * @return {Object} combined server field and business data field return
     */
    value: function constructResponse(server_return, bdapi_return) {
      return {
        'conversion_api': server_return,
        'business_data_api': bdapi_return
      };
    }
  }]);
  return Utils;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * UserData represents the User Data Parameters(user_data) of Business Data API and Conversion API Request.
 */

var UserData$1 = function () {

    /**
     * @param {String} email An email address, in lowercase.
     * @param {String} phone A phone number. Include only digits with country code, area code, and number.
     * @param {String} first_name A first name in lowercase.
     * @param {String} last_name A last name in lowercase.
     * @param {String} date_of_birth A date of birth given as year, month, and day in YYYYMMDD format.
     * @param {String} city A city in lower-case without spaces or punctuation.
     * @param {String} state A two-letter state code in lowercase.
     * @param {String} country A two-letter country code in lowercase.
     * @param {String} zip Postal code of the city in your country standard
     * @param {String} external_id Any unique ID from the advertiser,
     * @param {String} gender Gender, in lowercase. Either f or m.
     * @param {String} client_ip_address The IP address of the browser corresponding to the event.
     * @param {String} client_user_agent The user agent for the browser corresponding to the event.
     * @param {String} fbp The Facebook click ID value stored in the _fbc browser cookie under your domain.
     * @param {String} fbc The Facebook browser ID value stored in the _fbp browser cookie under your domain.
     * @param {String} subscription_id The subscription ID for the user in this transaction.
     * @param {String} fb_login_id The FB login ID for the user.
     * @param {String} lead_id The Id associated with a lead generated by Facebook's Lead Ads.
     * @param {String} dobd The date of birth day in DD format.
     * @param {String} dobm The date of birth month in MM format.
     * @param {String} doby The date of birth year in YYYY format.
     * @param {String} f5first The first 5 characters of the first name.
     * @param {String} f5last The first 5 characters of the last name.
     * @param {String} fi The first Name Initial
     * @param {String} address An physical address.
     */
    function UserData$$1(email, phone, first_name, last_name, date_of_birth, city, state, zip, country, external_id, gender, client_ip_address, client_user_agent, fbp, fbc, subscription_id, fb_login_id, lead_id, dobd, dobm, doby, f5first, f5last, fi, address) {
        classCallCheck(this, UserData$$1);

        this._business_data_user_data = new UserData$3(email, phone, first_name, last_name, date_of_birth, city, state, zip, country, external_id, address);
        this._server_user_data = new UserData(email, phone, gender, first_name, last_name, date_of_birth, city, state, zip, country, external_id, client_ip_address, client_user_agent, fbp, fbc, subscription_id, fb_login_id, lead_id, dobd, dobm, doby);

        // conversion api
        this._server_user_data.f5first = f5first;
        this._server_user_data.f5last = f5last;
        this._server_user_data.fi = fi;
    }

    /**
     * Gets the email address for the user data field.
     * An email address, in lowercase.
     * Example: joe@eg.com
     */


    createClass(UserData$$1, [{
        key: 'setEmail',


        /**
         * Sets the email address for the user data field.
         * @param {String} email An email address, in lowercase.
         * Example: joe@eg.com
         */
        value: function setEmail(email) {
            this._business_data_user_data.email = email;
            this._server_user_data.email = email;
            return this;
        }

        /**
         * Gets the phone number for the user data.
         * A phone number. Include only digits with country code, area code, and number.
         * Example: 16505551212
         */

    }, {
        key: 'setPhone',


        /**
         * Sets the phone number for the user data.
         * @param {String} phone A phone number. Include only digits with country code, area code, and number.
         * Example: 16505551212
         */
        value: function setPhone(phone) {
            this._business_data_user_data.phone = phone;
            this._server_user_data.phone = phone;
            return this;
        }

        /**
         * Gets the date of birth for the user data.
         * A date of birth given as year, month, and day in the Format YYYYMMDD
         * Example: 19971226 for December 26, 1997.
         */

    }, {
        key: 'setDateOfBirth',


        /**
         * Sets the date of birth for the user data.
         * @param {String} date_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
         * Example: 19971226 for December 26, 1997.
         */
        value: function setDateOfBirth(date_of_birth) {
            this._business_data_user_data.date_of_birth = date_of_birth;
            this._server_user_data.date_of_birth = date_of_birth;
            return this;
        }

        /**
         * Gets the last name for the user data.
         * last_name is the last name in lowercase.
         * Example: smith
         */

    }, {
        key: 'setLastName',


        /**
         * Sets the last name for the user data.
         * @param {String} last_name is last name in lowercase.
         * Example: smith
         */
        value: function setLastName(last_name) {
            this._business_data_user_data.last_name = last_name;
            this._server_user_data.last_name = last_name;
            return this;
        }

        /**
         * Gets the first name for the user data.
         * first_name is first name in lowercase.
         * Example: joe
         */

    }, {
        key: 'setFirstName',


        /**
         * Sets the first name for the user data.
         * @param {String} first_name is first name in lowercase.
         * Example: joe
         */
        value: function setFirstName(first_name) {
            this._business_data_user_data.first_name = first_name;
            this._server_user_data.first_name = first_name;
            return this;
        }

        /**
         * Gets the city for the user data.
         * city is city in lower-case without spaces or punctuation.
         * Example: menlopark
         */

    }, {
        key: 'setCity',


        /**
         * Sets the city for the user data.
         * @param {String} city is city in lower-case without spaces or punctuation.
         * Example: menlopark
         */
        value: function setCity(city) {
            this._business_data_user_data.city = city;
            this._server_user_data.city = city;
            return this;
        }

        /**
         * Gets the zip/postal code for the user data.
         * zip is a five-digit zip code for United States.For other locations, follow each country's standards.
         * Example: 98121 (for United States zip code)
         */

    }, {
        key: 'setZip',


        /**
         * Sets the zip/postal code for the user data.
         * @param {String} zip is a five-digit zip code for United States.For other locations, follow each country's standards.
         * Example: 98121 (for United States zip code)
         */
        value: function setZip(zip) {
            this._business_data_user_data.zip = zip;
            this._server_user_data.zip = zip;
            return this;
        }

        /**
         * Gets the state for the user data.
         * state is state in lower-case without spaces or punctuation.
         * Example: ca
         */

    }, {
        key: 'setState',


        /**
         * Sets the state for the user data.
         * @param {String} state is state in lower-case without spaces or punctuation.
         * Example: ca
         */
        value: function setState(state) {
            this._business_data_user_data.state = state;
            this._server_user_data.state = state;
            return this;
        }

        /**
         * Gets the country for the user data.
         * country is A two-letter country code in lowercase.
         * Example: usa
         */

    }, {
        key: 'setCountry',


        /**
         * Sets the country for the user data.
         * @param {String} country is A two-letter country code in lowercase.
         * Example: usa
         */
        value: function setCountry(country) {
            this._business_data_user_data.country = country;
            this._server_user_data.country = country;
            return this;
        }

        /**
         * Gets the external id for the user data.
         * external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
         * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
         * If External ID is being sent via other channels, then it should be sent in the same format via the server-side API
         * @see {@link https://www.facebook.com/business/help/104039186799009}
         */

    }, {
        key: 'setExternalId',


        /**
         * Sets the external id for the user data.
         * @param {String} external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
         * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
         * If External ID is being sent via other channels, then it should be sent in the same format via the server-side API
         * @see {@link https://www.facebook.com/business/help/104039186799009}
         */
        value: function setExternalId(external_id) {
            this._business_data_user_data.external_id = external_id;
            this._server_user_data.external_id = external_id;
            return this;
        }

        /**
         * Gets the gender value for the user data.
         * Gender in lowercase. Either f for FEMALE or m for MALE.
         * Example: f
         */

    }, {
        key: 'setGender',


        /**
         * Sets the gender value for the user data.
         * @param {String} gender Gender in lowercase. Either f for FEMALE or m for MALE.
         * Example: f
         */
        value: function setGender(gender) {
            this._server_user_data.gender = gender;
            return this;
        }

        /**
         * Gets the client ip address for the user data.
         * client_ip_address is the IP address of the browser corresponding to the event.
         */

    }, {
        key: 'setClientIpAddress',


        /**
         * Sets the client ip address for the user data.
         * @param {String} client_ip_address is the IP address of the browser corresponding to the event.
         */
        value: function setClientIpAddress(client_ip_address) {
            this._server_user_data.client_ip_address = client_ip_address;
            return this;
        }

        /**
         * Gets the client user agent for the user data.
         * client_user_agent is the user agent for the browser corresponding to the event.
         */

    }, {
        key: 'setClientUserAgent',


        /**
         * Sets the client user agent for the user data.
         * @param {String} client_user_agent is the user agent for the browser corresponding to the event.
         */
        value: function setClientUserAgent(client_user_agent) {
            this._server_user_data.client_user_agent = client_user_agent;
            return this;
        }

        /**
         * Gets the fbc for the user data.
         * fbc is the Facebook click ID value stored in the _fbc browser cookie under your domain.
         * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc},
         * You can also generate this value from a fbclid query parameter.
         */

    }, {
        key: 'setFbc',


        /**
         * Sets the fbc for the user data.
         * @param {String} fbc is the Facebook click ID value stored in the _fbc browser cookie under your domain.
         * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc},
         * You can also generate this value from a fbclid query parameter.
         */
        value: function setFbc(fbc) {
            this._server_user_data.fbc = fbc;
            return this;
        }

        /**
         * Gets the fbp for the user data.
         * fbp is Facebook browser ID value stored in the _fbp browser cookie under your domain.
         * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc},
         */

    }, {
        key: 'setFbp',


        /**
         * Sets the fbp for the user data.
         * @param {String} fbp is Facebook browser ID value stored in the _fbp browser cookie under your domain.
         * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc},
         */
        value: function setFbp(fbp) {
            this._server_user_data.fbp = fbp;
            return this;
        }

        /**
         * Gets the subscription id for the user data.
         * @return subscription_id is the subscription ID for the user in this transaction. This is similar to the order ID for an individual product.
         * Example: anid1234.
         */

    }, {
        key: 'setSubscriptionId',


        /**
         * Sets the subscription id for the user data.
         * @param {String} subscription_id is the subscription ID for the user in this transaction. This is similar to the order ID for an individual product.
         * Example: anid1234.
         */
        value: function setSubscriptionId(subscription_id) {
            this._server_user_data.subscription_id = subscription_id;
            return this;
        }

        /**
         * Gets the fb_login_id for the user data.
         */

    }, {
        key: 'setFbLoginId',


        /**
         * Sets the fb_login_id for the user data.
         * @param {String} fb_login_id
         */
        value: function setFbLoginId(fb_login_id) {
            this._server_user_data.fb_login_id = fb_login_id;
            return this;
        }

        /**
         * Gets the lead_id for the user data. Lead ID is associated with a lead generated by Facebook's Lead Ads.
         */

    }, {
        key: 'setLeadId',


        /**
         * Sets the lead_id for the user data. Lead ID is associated with a lead generated by Facebook's Lead Ads.
         * @param {String} lead_id
         */
        value: function setLeadId(lead_id) {
            this._server_user_data.lead_id = lead_id;
            return this;
        }

        /**
         * Gets the first 5 characters of the FirstName.
         */

    }, {
        key: 'setF5First',


        /**
         * Sets the first 5 characters of the FirstName.
         * @param {String} f5first
         */
        value: function setF5First(f5first) {
            this._server_user_data.f5first = f5first;
            return this;
        }

        /**
         * Gets the first 5 characters of the LastName.
         */

    }, {
        key: 'setF5Last',


        /**
         * Sets the first 5 characters of the LastName.
         * @param {String} f5last
         */
        value: function setF5Last(f5last) {
            this._server_user_data.f5last = f5last;
            return this;
        }

        /**
         * Gets the first Name Initial.
         */

    }, {
        key: 'setFi',


        /**
         * Sets the first Name Initial.
         * @param {String} fi
         */
        value: function setFi(fi) {
            this._server_user_data.fi = fi;
            return this;
        }

        /**
         * Gets the date of birth day.
         */

    }, {
        key: 'setDobd',


        /**
         * Sets the date of birth day.
         * @param {String} dobd
         */
        value: function setDobd(dobd) {
            this._server_user_data.dobd = dobd;
            return this;
        }

        /**
         * Gets the date of birth month.
         */

    }, {
        key: 'setDobm',


        /**
         * Sets the date of birth month.
         * @param {String} dobm
         */
        value: function setDobm(dobm) {
            this._server_user_data.dobm = dobm;
            return this;
        }

        /**
         * Gets the date of birth year.
         */

    }, {
        key: 'setDoby',


        /**
         * Sets the date of birth year.
         * @param {String} doby
         */
        value: function setDoby(doby) {
            this._server_user_data.doby = doby;
            return this;
        }

        /**
         * Gets the address for the user data.
         * address is a physical address
         */

    }, {
        key: 'setAddress',


        /**
         * Sets the date of birth year.
         * @param {String} address
         */
        value: function setAddress(address) {
            this._business_data_user_data.address = address;
            return this;
        }

        /**
         * Gets the user_data for the Business Data API.
         */

    }, {
        key: 'email',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.email, this._business_data_user_data.email);
        }

        /**
         * Sets the email address for the user data field.
         * @param email An email address, in lowercase.
         * Example: joe@eg.com
         */
        ,
        set: function set(email) {
            this._business_data_user_data._email = email;
            this._server_user_data._email = email;
        }
    }, {
        key: 'phone',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.phone, this._business_data_user_data.phone);
        }

        /**
         * Sets the phone number for the user data.
         * @param phone A phone number. Include only digits with country code, area code, and number.
         * Example: 16505551212
         */
        ,
        set: function set(phone) {
            this._business_data_user_data.phone = phone;
            this._server_user_data.phone = phone;
        }
    }, {
        key: 'date_of_birth',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.date_of_birth, this._business_data_user_data.date_of_birth);
        }

        /**
         * Sets the date of birth for the user data.
         * @param date_of_birth A date of birth given as year, month, and day in the Format YYYYMMDD
         * Example: 19971226 for December 26, 1997.
         */
        ,
        set: function set(date_of_birth) {
            this._business_data_user_data.date_of_birth = date_of_birth;
            this._server_user_data.date_of_birth = date_of_birth;
        }
    }, {
        key: 'last_name',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.last_name, this._business_data_user_data.last_name);
        }

        /**
         * Sets the last name for the user data.
         * @param last_name is last name in lowercase.
         * Example: smith
         */
        ,
        set: function set(last_name) {
            this._business_data_user_data.last_name = last_name;
            this._server_user_data.last_name = last_name;
        }
    }, {
        key: 'first_name',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.first_name, this._business_data_user_data.first_name);
        }

        /**
         * Sets the first name for the user data.
         * @param first_name is first name in lowercase.
         * Example: joe
         */
        ,
        set: function set(first_name) {
            this._business_data_user_data.first_name = first_name;
            this._server_user_data.first_name = first_name;
        }
    }, {
        key: 'city',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.city, this._business_data_user_data.city);
        }

        /**
         * Sets the city for the user data.
         * @param city is city in lower-case without spaces or punctuation.
         * Example: menlopark
         */
        ,
        set: function set(city) {
            this._business_data_user_data.city = city;
            this._server_user_data.city = city;
        }
    }, {
        key: 'zip',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.zip, this._business_data_user_data.zip);
        }

        /**
         * Sets the zip/postal code for the user data.
         * @param zip is a five-digit zip code for United States.For other locations, follow each country's standards.
         * Example: 98121 (for United States zip code)
         */
        ,
        set: function set(zip) {
            this._business_data_user_data.zip = zip;
            this._server_user_data.zip = zip;
        }
    }, {
        key: 'state',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.state, this._business_data_user_data.state);
        }

        /**
         * Sets the state for the user data.
         * @param state is state in lower-case without spaces or punctuation.
         * Example: ca
         */
        ,
        set: function set(state) {
            this._business_data_user_data.state = state;
            this._server_user_data.state = state;
        }
    }, {
        key: 'country',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.country, this._business_data_user_data.country);
        }

        /**
         * Sets the country for the user data.
         * @param country is A two-letter country code in lowercase.
         * Example: usa
         */
        ,
        set: function set(country) {
            this._business_data_user_data.country = country;
            this._server_user_data.country = country;
        }
    }, {
        key: 'external_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.external_id, this._business_data_user_data.external_id);
        }

        /**
         * Sets the external id for the user data.
         * @param external_id is a unique ID from the advertiser, such as loyalty membership IDs, user IDs, and external cookie IDs.
         * In the Offline Conversions API this is known as extern_id. For more information, see Offline Conversions.
         * If External ID is being sent via other channels, then it should be sent in the same format via the server-side API
         * @see {@link https://www.facebook.com/business/help/104039186799009}
         */
        ,
        set: function set(external_id) {
            this._business_data_user_data.external_id = external_id;
            this._server_user_data.external_id = external_id;
        }
    }, {
        key: 'gender',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.gender, null);
        }

        /**
         * Sets the gender value for the user data.
         * @param gender Gender in lowercase. Either f for FEMALE or m for MALE.
         * Example: f
         */
        ,
        set: function set(gender) {
            this._server_user_data.gender = gender;
        }
    }, {
        key: 'client_ip_address',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.client_ip_address, null);
        }

        /**
         * Sets the client ip address for the user data.
         * @param client_ip_address is the IP address of the browser corresponding to the event.
         */
        ,
        set: function set(client_ip_address) {
            this._server_user_data.client_ip_address = client_ip_address;
        }
    }, {
        key: 'client_user_agent',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.client_user_agent, null);
        }

        /**
         * Sets the client user agent for the user data.
         * @param client_user_agent is the user agent for the browser corresponding to the event.
         */
        ,
        set: function set(client_user_agent) {
            this._server_user_data.client_user_agent = client_user_agent;
        }
    }, {
        key: 'fbc',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.fbc, null);
        }

        /**
         * Sets the fbc for the user data.
         * @param fbc is the Facebook click ID value stored in the _fbc browser cookie under your domain.
         * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc},
         * You can also generate this value from a fbclid query parameter.
         */
        ,
        set: function set(fbc) {
            this._server_user_data.fbc = fbc;
        }
    }, {
        key: 'fbp',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.fbp, null);
        }

        /**
         * Sets the fbp for the user data.
         * @param fbp is Facebook browser ID value stored in the _fbp browser cookie under your domain.
         * See Managing fbc and fbp Parameters for how to get this value @see {@link https://developers.facebook.com/docs/marketing-api/facebook-pixel/server-side-api/parameters#fbc},
         */
        ,
        set: function set(fbp) {
            this._server_user_data.fbp = fbp;
        }
    }, {
        key: 'subscription_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.subscription_id, null);
        }

        /**
         * Sets the subscription id for the user data.
         * @param {String} subscription_id is the subscription ID for the user in this transaction. This is similar to the order ID for an individual product.
         * Example: anid1234.
         */
        ,
        set: function set(subscription_id) {
            this._server_user_data.subscription_id = subscription_id;
        }
    }, {
        key: 'fb_login_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.fb_login_id, null);
        }

        /**
         * Sets the fb_login_id for the user data.
         * @param fb_login_id
         */
        ,
        set: function set(fb_login_id) {
            this._server_user_data.fb_login_id = fb_login_id;
        }
    }, {
        key: 'lead_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.lead_id, null);
        }

        /**
         * Sets the lead_id for the user data. Lead ID is associated with a lead generated by Facebook's Lead Ads.
         * @param lead_id
         */
        ,
        set: function set(lead_id) {
            this._server_user_data.lead_id = lead_id;
        }
    }, {
        key: 'f5first',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.f5first, null);
        }

        /**
         * Sets the Gets the first 5 characters of the FirstName.
         * @param f5first
         */
        ,
        set: function set(f5first) {
            this._server_user_data.f5first = f5first;
        }
    }, {
        key: 'f5last',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.f5last, null);
        }

        /**
         * Sets the first 5 characters of the LastName.
         * @param f5last
         */
        ,
        set: function set(f5last) {
            this._server_user_data.f5last = f5last;
        }
    }, {
        key: 'fi',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.fi, null);
        }

        /**
         * Sets the first Name Initial.
         * @param fi
         */
        ,
        set: function set(fi) {
            this._server_user_data.fi = fi;
        }
    }, {
        key: 'dobd',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.dobd, null);
        }

        /**
         * Sets the date of birth day.
         * @param dobd
         */
        ,
        set: function set(dobd) {
            this._server_user_data.dobd = dobd;
        }
    }, {
        key: 'dobm',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.dobm, null);
        }

        /**
         * Sets the date of birth month.
         * @param dobm
         */
        ,
        set: function set(dobm) {
            this._server_user_data.dobm = dobm;
        }
    }, {
        key: 'doby',
        get: function get() {
            return Utils$2.constructResponse(this._server_user_data.doby, null);
        }

        /**
         * Sets the date of birth year.
         * @param {String} doby
         */
        ,
        set: function set(doby) {
            this._server_user_data.doby = doby;
        }
    }, {
        key: 'address',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_user_data.address);
        }

        /**
         * Sets the address for the user data.
         * @param address is a physical address
         */
        ,
        set: function set(address) {
            this._business_data_user_data.address = address;
        }
    }, {
        key: 'business_data_user_data',
        get: function get() {
            return this._business_data_user_data;
        }

        /**
         * Gets the user_data for the Conversion API.
         */

    }, {
        key: 'server_user_data',
        get: function get() {
            return this._server_user_data;
        }
    }]);
    return UserData$$1;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * Content is part of the Custom Data Parameters of a Business Data Event Request. Content can be used to set the item/product details added in the Custom Data.
 */

var Content$3 = function () {

  /**
   * @param {String} id Product Id of the Item.
   * @param {Number} quantity Quantity of the Item.
   * @param {Number} price Subtotal for the content/product.
   * @param {String} title Title of the listed Item.
   * @param {Number} tax Subtotal tax for the content/product.
   * @param {String} external_content_id Unique ID for the contents/products that are being involved in the customer interaction.
   */
  function Content(id, quantity, price, title, tax, external_content_id) {
    classCallCheck(this, Content);


    this._id = id;
    this._quantity = quantity;
    this._price = price;
    this._title = title;
    this._external_content_id = external_content_id;
    this._tax = tax;
  }

  /**
   * Gets the Product Id of the Item.
   * A string representing the unique Id for the product.
   * Example: XYZ.
   */


  createClass(Content, [{
    key: 'setId',


    /**
     * Sets the Product Id of the Item.
     * @param {String} id is a string representing the unique id for the product.
     * Example: XYZ.
     */
    value: function setId(id) {
      this._id = id;
      return this;
    }

    /**
     * Gets the quantity of the Item.
     * The number/quantity of the content that is being involved in the customer interaction.
     * Example: 5
     */

  }, {
    key: 'setQuantity',


    /**
     * Sets the quantity of the Content/Item.
     * @param {Number} quantity The number/quantity of the product that is being involved in the customer interaction.
     * Example: 5
     */
    value: function setQuantity(quantity) {
      this._quantity = quantity;
      return this;
    }

    /**
     * Gets the total price of the Item.
     * The total price for the products that are being involved in the customer interaction.
     * Example: '123.45'
     */

  }, {
    key: 'setPrice',


    /**
     * Sets the total price of the Item.
     * @param {Number} price The total price for the products that are being involved in the customer interaction.
     * Example: '123.45'
     */
    value: function setPrice(price) {
      this._price = price;
      return this;
    }

    /**
     * Gets the Title of the listed Item.
     * A string representing the Title for the product.
     */

  }, {
    key: 'setTitle',


    /**
     * Sets the Title of the Item.
     * @param {String} title is a string representing listed title for the product.
     */
    value: function setTitle(title) {
      this._title = title;
      return this;
    }

    /**
     * Gets the total tax of the Item.
     * The total tax for the products that are being involved in the customer interaction.
     * Example: 45.5
     */

  }, {
    key: 'setTax',


    /**
     * Sets the total tax of the Item.
     * @param {Number} tax The total tax for the products that are being involved in the customer interaction.
     * Example: 45.5
     */
    value: function setTax(tax) {
      this._tax = tax;
      return this;
    }

    /**
     * Gets the external id for this order item
     * The external id for the products that are being involved in the customer interaction.
     */

  }, {
    key: 'setExternalContentID',


    /**
     * Sets the external id for this order item
     * @param {String} external_content_id The external id for the products that are being involved in the customer interaction.
     */
    value: function setExternalContentID(external_content_id) {
      this._external_content_id = external_content_id;
      return this;
    }

    /**
     * Convert to Json object for api call
     */

  }, {
    key: 'toJson',
    value: function toJson() {
      return {
        'id': this._id,
        'quantity': this._quantity,
        'price': this._price,
        'title': this._title,
        'tax': this._tax,
        'external_content_id': this._external_content_id
      };
    }
  }, {
    key: 'id',
    get: function get() {
      return this._id;
    }

    /**
     * Sets the Product Id of the Item.
     * @param id A string representing the unique Id for the product.
     * Example: XYZ.
     */
    ,
    set: function set(id) {
      this._id = id;
    }
  }, {
    key: 'quantity',
    get: function get() {
      return this._quantity;
    }

    /**
     * Sets the quantity of the Item.
     * @param quantity The number/quantity of the product that is being involved in the customer interaction.
     * Example: 5
     */
    ,
    set: function set(quantity) {
      this._quantity = quantity;
    }
  }, {
    key: 'price',
    get: function get() {
      return this._price;
    }

    /**
     * Sets the total price of the Item.
     * @param price The total price for the products that are being involved in the customer interaction.
     * Example: '123.45'
     */
    ,
    set: function set(price) {
      this._price = price;
    }
  }, {
    key: 'title',
    get: function get() {
      return this._title;
    }

    /**
     * Sets the Title of the listed Item.
     * @param title A string representing the Title for the product.
     */
    ,
    set: function set(title) {
      this._title = title;
    }
  }, {
    key: 'tax',
    get: function get() {
      return this._tax;
    }

    /**
     * Sets the total tax of the Item.
     * @param tax The total tax for the products that are being involved in the customer interaction.
     * Example: 45.5
     */
    ,
    set: function set(tax) {
      this._tax = tax;
    }
  }, {
    key: 'external_content_id',
    get: function get() {
      return this._external_content_id;
    }

    /**
     * Sets the external id for this order item
     * @param external_content_id The external id for the products that are being involved in the customer interaction.
     */
    ,
    set: function set(external_content_id) {
      this._external_content_id = external_content_id;
    }
  }]);
  return Content;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * UserData represents the User Data Parameters(user_data) of Business Data API and Conversion API Request.
 */

var Content$1 = function () {

    /**
     * @param {String} id Product Id of the Item.
     * @param {Number} quantity Quantity of the Item.
     * @param {Number} price Subtotal for the content/product.
     * @param {Number} item_price Price per unit of the content/product.
     * @param {String} title Title of the listed Item.
     * @param {String} description Product description used for the item.
     * @param {String} brand Brand of the item.
     * @param {String} category Category of the Item.
     * @param {String} delivery_category The type of delivery for a purchase event
     * @param {Number} tax Subtotal tax for the content/product.
     * @param {String} external_content_id Unique ID for the contents/products that are being involved in the customer interaction.
     */
    function Content$$1(id, quantity, price, item_price, title, description, brand, category, delivery_category, tax, external_content_id) {
        classCallCheck(this, Content$$1);

        this._business_data_content = new Content$3(id, quantity, price, title, tax, external_content_id);
        this._server_content = new Content(id, quantity, item_price, title, description, brand, category, delivery_category);
    }

    /**
     * Gets the Product Id of the Item.
     * A string representing the unique Id for the product.
     * Example: XYZ.
     */


    createClass(Content$$1, [{
        key: 'setId',


        /**
         * Sets the Product Id of the Item.
         * @param id is a string representing the unique id for the product.
         * Example: XYZ.
         */
        value: function setId(id) {
            this._server_content.id = id;
            this._business_data_content.id = id;
            return this;
        }

        /**
         * Gets the quantity of the Item.
         * The number/quantity of the content that is being involved in the customer interaction.
         * Example: 5
         */

    }, {
        key: 'setQuantity',


        /**
         * Sets the quantity of the Content/Item.
         * @param {Number} quantity The number/quantity of the product that is being involved in the customer interaction.
         * Example: 5
         */
        value: function setQuantity(quantity) {
            this._server_content.quantity = quantity;
            this._business_data_content.quantity = quantity;
            return this;
        }

        /**
         * Gets the item price for the Product.
         * The item_price or price per unit of the product.
         * Example: '123.45'
         */

    }, {
        key: 'setItemPrice',


        /**
         * Sets the item price for the Content.
         * @param {Number} item_price The item_price or price per unit of the product.
         * Example: '123.45'
         */
        value: function setItemPrice(item_price) {
            this._server_content.item_price = item_price;
            return this;
        }

        /**
         * Gets the Title of the listed Item.
         * A string representing the Title for the product.
         */

    }, {
        key: 'setTitle',


        /**
         * Sets the Title of the Item.
         * @param title is a string representing listed title for the product.
         */
        value: function setTitle(title) {
            this._server_content.title = title;
            this._business_data_content.title = title;
            return this;
        }

        /**
         * Gets the Description of the listed Item.
         * A string representing the Description for the product.
         */

    }, {
        key: 'setDescription',


        /**
         * Sets the Product Description of the Item.
         * @param description is a string representing the description for the product.
         */
        value: function setDescription(description) {
            this._server_content.description = description;
            return this;
        }

        /**
         * Gets the Brand of the listed Item.
         * A string representing the Brand for the product.
         */

    }, {
        key: 'setBrand',


        /**
         * Sets the Brand of the Product.
         * @param brand is a string representing the Brand for the product.
         */
        value: function setBrand(brand) {
            this._server_content.brand = brand;
            return this;
        }

        /**
         * Gets the Category of the listed Item.
         * A string representing the Category for the product.
         */

    }, {
        key: 'setCategory',


        /**
         * Sets the Category of the Product.
         * @param category is a string representing the Category for the product.
         */
        value: function setCategory(category) {
            this._server_content.category = category;
            return this;
        }

        /**
         * Gets the delivery category.
         */

    }, {
        key: 'setDeliveryCategory',


        /**
         * Sets the type of delivery for a purchase event.
         * @param {String} delivery_category The delivery category.
         */
        value: function setDeliveryCategory(delivery_category) {
            this._server_content.delivery_category = delivery_category;
            return this;
        }

        /**
         * Gets the total tax of the Item.
         * The total tax for the products that are being involved in the customer interaction.
         * Example: 45.5
         */

    }, {
        key: 'setTax',


        /**
         * Sets the total tax of the Item.
         * @param {Number} tax The total tax for the products that are being involved in the customer interaction.
         * Example: 45.5
         */
        value: function setTax(tax) {
            this._business_data_content.tax = tax;
            return this;
        }

        /**
         * Gets the external id for this order item
         * The external id for the products that are being involved in the customer interaction.
         */

    }, {
        key: 'setExternalContentId',


        /**
         * Sets the total tax of the Item.
         * @param {String} external_content_id The total tax for the products that are being involved in the customer interaction.
         */
        value: function setExternalContentId(external_content_id) {
            this._business_data_content.external_content_id = external_content_id;
            return this;
        }

        /**
         * Gets the total price of the Item.
         * The total price for the products that are being involved in the customer interaction.
         * Example: '123.45'
         */

    }, {
        key: 'setPrice',


        /**
         * Sets the total price of the Item.
         * @param {Number} price The total price for the products that are being involved in the customer interaction.
         * Example: '123.45'
         */
        value: function setPrice(price) {
            this._business_data_content.price = price;
            return this;
        }

        /**
         * Gets the constructed content for Business Data API
         */

    }, {
        key: 'id',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.id, this._business_data_content.id);
        }

        /**
         * Sets the Product Id of the Item.
         * @param id A string representing the unique Id for the product.
         * Example: XYZ.
         */
        ,
        set: function set(id) {
            this._server_content.id = id;
            this._business_data_content.id = id;
        }
    }, {
        key: 'quantity',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.quantity, this._business_data_content.quantity);
        }

        /**
         * Sets the quantity of the Item.
         * @param quantity The number/quantity of the product that is being involved in the customer interaction.
         * Example: 5
         */
        ,
        set: function set(quantity) {
            this._server_content.quantity = quantity;
            this._business_data_content.quantity = quantity;
        }
    }, {
        key: 'item_price',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.item_price, null);
        }

        /**
         * Sets the item price for the Content.
         * @param item_price The item_price or price per unit of the product.
         * Example: '123.45'
         */
        ,
        set: function set(item_price) {
            this._server_content.item_price = item_price;
        }
    }, {
        key: 'title',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.title, this._business_data_content.title);
        }

        /**
         * Sets the Title of the listed Item.
         * @param title A string representing the Title for the product.
         */
        ,
        set: function set(title) {
            this._server_content.title = title;
            this._business_data_content.title = title;
        }
    }, {
        key: 'description',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.description, null);
        }

        /**
         * Sets the Description of the listed Item.
         * @param description A string representing the Description for the product.
         */
        ,
        set: function set(description) {
            this._server_content.description = description;
        }
    }, {
        key: 'brand',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.brand, null);
        }

        /**
         * Sets the Brand of the listed Item.
         * @param brand A string representing the Brand for the product.
         */
        ,
        set: function set(brand) {
            this._server_content.brand = brand;
        }
    }, {
        key: 'category',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.category, null);
        }

        /**
         * Sets the Category of the listed Item.
         * @param category A string representing the Category for the product.
         */
        ,
        set: function set(category) {
            this._server_content.category = category;
        }
    }, {
        key: 'delivery_category',
        get: function get() {
            return Utils$2.constructResponse(this._server_content.delivery_category, null);
        }

        /**
         * Sets the type of delivery for a purchase event.
         * @param delivery_category The delivery category.
         */
        ,
        set: function set(delivery_category) {
            this._server_content.delivery_category = delivery_category;
        }
    }, {
        key: 'tax',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_content.tax);
        }

        /**
         * Sets the total tax of the Item.
         * @param tax The total tax for the products that are being involved in the customer interaction.
         * Example: 45.5
         */
        ,
        set: function set(tax) {
            this._business_data_content.tax = tax;
        }
    }, {
        key: 'external_content_id',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_content.external_content_id);
        }

        /**
         * Sets the external id for this order item
         * @param external_content_id The external id for the products that are being involved in the customer interaction.
         */
        ,
        set: function set(external_content_id) {
            this._business_data_content.external_content_id = external_content_id;
        }
    }, {
        key: 'price',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_content.price);
        }

        /**
         * Sets the total price of the Item.
         * @param price The total price for the products that are being involved in the customer interaction.
         * Example: '123.45'
         */
        ,
        set: function set(price) {
            this._business_data_content.price = price;
        }
    }, {
        key: 'business_data_content',
        get: function get() {
            return this._business_data_content;
        }

        /**
         * Gets the constructed content for Conversion API
         */

    }, {
        key: 'server_content',
        get: function get() {
            return this._server_content;
        }
    }]);
    return Content$$1;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * CustomData represents the Custom Data Parameters of a Business Data Event Request.
 */

var CustomData$3 = function () {

  /**
   * @param {Number} value value of the order Eg: 123.45
   * @param {String} currency currency involved in the transaction Eg: usd
   * @param {Array<Content>} contents Array of Content Objects. Use {Content} class to define a content.
   * @param {String} order_id Unique id representing the order
   * @param {String} status Status of order
   * @param {String} shipping_contact Shipping contact information. User {UserData} class to define a contact.
   * @param {String} billing_contact Billing contact information. User {UserData} class to define a contact.
   * @param {String} external_order_id Unique ID representing the order, universal across multiple categories from the business
   * @param {String} original_order_id Original order id for refund. For Refund event only.
   * @param {String} message Reason for refund. For Refund event only.
   */
  function CustomData(value, currency, contents, order_id, status, shipping_contact, billing_contact, external_order_id, original_order_id, message) {
    classCallCheck(this, CustomData);

    this._value = value;
    this._currency = currency;
    this._contents = contents;
    this._order_id = order_id;
    this._status = status;
    this._shipping_contact = shipping_contact;
    this._billing_contact = billing_contact;
    this._external_order_id = external_order_id;
    this._original_order_id = original_order_id;
    this._message = message;
  }

  /**
   * Gets the total value of the order.
   * A numeric value associated with this event. This could be a monetary value or a value in some other metric.
   * Example: 142.54.
   */


  createClass(CustomData, [{
    key: 'setValue',


    /**
     * Sets the value of the custom data.
     * @param {Number} value A numeric value associated with this event. This could be a monetary value or a value in some other metric.
     * Example: 142.54.
     */
    value: function setValue(value) {
      this._value = value;
      return this;
    }

    /**
     * Gets the currency for the custom data.
     * The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
     * Example: 'usd'
     */

  }, {
    key: 'setCurrency',


    /**
     * Sets the currency for the custom data.
     * @param {String} currency The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
     * Example: 'usd'
     */
    value: function setCurrency(currency) {
      this._currency = currency;
      return this;
    }

    /**
     * Gets the contents for the custom data.
     * An array of Content objects that contain the product IDs associated with the event plus information about the products.
     * Example: [{'id':'ABC123','quantity' :2,'price':5.99}, {'id':'XYZ789','quantity':2, 'price':9.99}]
     */

  }, {
    key: 'setContents',


    /**
     * Sets the contents for the custom data.
     * @param { Array< Content >} contents An array of Content objects that contain the product IDs associated with the event plus information about the products.
     * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
     */
    value: function setContents(contents) {
      this._contents = contents;
      return this;
    }

    /**
     * Gets the order id for the custom data.
     * order_id is the order ID for this transaction as a String.
     * Example: 'order1234'
     */

  }, {
    key: 'setOrderId',


    /**
     * Sets the order_id for the custom data.
     * @param {String} order_id The order ID for this transaction as a String.
     * Example: 'order1234'
     */
    value: function setOrderId(order_id) {
      this._order_id = order_id;
      return this;
    }

    /**
     * Gets the status of order.
     * Status of the order, as a String.
     */

  }, {
    key: 'setStatus',


    /**
     * Sets the status of the registration event.
     * @param {String} status Status of the registration event, as a String.
     */
    value: function setStatus(status) {
      this._status = status;
      return this;
    }

    /**
     * Gets the shipping contact of the order.
     * An Object contains the user data of shipping contact. Use {UserData} to construct the object.
     */

  }, {
    key: 'setShippingContact',


    /**
     * Sets the shipping contact of the order.
     * @param {UserData} shipping_contact An Object contains the user data of shipping contact. Use {UserData} to construct the object.
     */
    value: function setShippingContact(shipping_contact) {
      this._shipping_contact = shipping_contact;
      return this;
    }

    /**
     * Gets the billing contact of the order.
     * An Object contains the user data of billing contact. Use {UserData} to construct the object.
     */

  }, {
    key: 'setBillingContact',


    /**
     * Sets the billing contact of the order.
     * @param {UserData} billing_contact An Object contains the user data of billing contact. Use {UserData} to construct the object.
     */
    value: function setBillingContact(billing_contact) {
      this._billing_contact = billing_contact;
      return this;
    }

    /**
     * Gets the unique id of the order.
     * Unique ID representing the order, universal across multiple categories from the business.
     */

  }, {
    key: 'setExternalOrderId',


    /**
     * Sets the unique id of the order.
     * @param {String} external_order_id Unique ID representing the order, universal across multiple categories from the business.
     */
    value: function setExternalOrderId(external_order_id) {
      this._external_order_id = external_order_id;
      return this;
    }

    /**
     * Gets the unique id of the original order.
     * Original order id for refund. For Refund event only.
     */

  }, {
    key: 'setOriginalOrderId',


    /**
     * Sets the unique id of the original order.
     * @param {String} original_order_id Original order id for refund. For Refund event only.
     */
    value: function setOriginalOrderId(original_order_id) {
      this._original_order_id = original_order_id;
      return this;
    }

    /**
     * Gets the unique id of the original order.
     * Reason for refund. For Refund event only.
     */

  }, {
    key: 'setMessage',


    /**
     * Sets the unique id of the original order.
     * @param {String} message Reason for refund. For Refund event only.
     */
    value: function setMessage(message) {
      this._message = message;
      return this;
    }

    /**
     * Convert to Json object for api call
     */

  }, {
    key: 'toJson',
    value: function toJson() {
      var contents = this._contents ? this._contents.map(function (content) {
        return content.toJson();
      }) : [];
      return {
        'value': this._value,
        'currency': this._currency,
        'contents': contents,
        'order_id': this._order_id,
        'status': this._status,
        'shipping_contact': this._shipping_contact.toJson(),
        'billing_contact': this._billing_contact.toJson(),
        'external_order_id': this._external_order_id,
        'original_order_id': this._original_order_id,
        'message': this._message
      };
    }
  }, {
    key: 'value',
    get: function get() {
      return this._value;
    }

    /**
     * Sets the value of the custom data.
     * @param value A numeric value associated with this event. This could be a monetary value or a value in some other metric.
     * Example: 142.54.
     */
    ,
    set: function set(value) {
      this._value = value;
    }
  }, {
    key: 'currency',
    get: function get() {
      return this._currency;
    }

    /**
     * Sets the currency for the custom data.
     * @param currency The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
     * Example: 'usd'
     */
    ,
    set: function set(currency) {
      this._currency = currency;
    }
  }, {
    key: 'contents',
    get: function get() {
      return this._contents;
    }

    /**
     * Sets the contents for the custom data.
     * @param contents An array of Content objects that contain the product IDs associated with the event plus information about the products.
     * Example: [{'id':'ABC123','quantity' :2,'price':5.99}, {'id':'XYZ789','quantity':2, 'price':9.99}]
     */
    ,
    set: function set(contents) {
      this._contents = contents;
    }
  }, {
    key: 'order_id',
    get: function get() {
      return this._order_id;
    }

    /**
     * Sets the order_id for the custom data.
     * @param order_id The order ID for this transaction as a String.
     * Example: 'order1234'
     */
    ,
    set: function set(order_id) {
      this._order_id = order_id;
    }
  }, {
    key: 'status',
    get: function get() {
      return this._status;
    }

    /**
     * Gets the status of order.
     * @param status Status of the order, as a String.
     */
    ,
    set: function set(status) {
      this._status = status;
    }
  }, {
    key: 'shipping_contact',
    get: function get() {
      return this._shipping_contact;
    }

    /**
     * Sets the shipping contact of the order.
     * @param shipping_contact An Object contains the user data of shipping contact. Use {UserData} to construct the object.
     */
    ,
    set: function set(shipping_contact) {
      this._shipping_contact = shipping_contact;
    }
  }, {
    key: 'billing_contact',
    get: function get() {
      return this._billing_contact;
    }

    /**
     * Sets the billing contact of the order.
     * @param billing_contact An Object contains the user data of billing contact. Use {UserData} to construct the object.
     */
    ,
    set: function set(billing_contact) {
      this._billing_contact = billing_contact;
    }
  }, {
    key: 'external_order_id',
    get: function get() {
      return this._external_order_id;
    }

    /**
     * Sets the unique id of the order.
     * @param external_order_id Unique ID representing the order, universal across multiple categories from the business.
     */
    ,
    set: function set(external_order_id) {
      this._external_order_id = external_order_id;
    }
  }, {
    key: 'original_order_id',
    get: function get() {
      return this._original_order_id;
    }

    /**
     * Sets the unique id of the original order.
     * @param original_order_id Original order id for refund. For Refund event only.
     */
    ,
    set: function set(original_order_id) {
      this._original_order_id = original_order_id;
    }
  }, {
    key: 'message',
    get: function get() {
      return this._message;
    }

    /**
     * Sets the unique id of the original order.
     * @param message Reason for refund. For Refund event only.
     */
    ,
    set: function set(message) {
      this._message = message;
    }
  }]);
  return CustomData;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * CustomData represents the Custom Data Parameters for both Conversion API and Business Data API.
 */

var CustomData$1 = function () {

    /**
     * params both Business Data API & Conversion API consume
     * @param {Number} value value of the item Eg: 123.45
     * @param {String} currency currency involved in the transaction Eg: usd
     * @param {Array<SignalContent>} contents Array of Content Objects. Use {Content} class to define a content.
     * @param {String} order_id Unique id representing the order
     * @param {String} status Status of the registration in Registration event.
     *                        Use only with CompleteRegistration events for Conversion API.
     *                        Use only with Purchase or UpdateOrder events for Business Data API
     * params only Conversion API consumes
     * @param {String} content_name name of the Content Eg: lettuce
     * @param {String} content_category category of the content Eg: grocery
     * @param {Array<String>} content_ids list of content unique ids involved in the event
     * @param {String} content_type Type of the Content group or Product SKU
     * @param {Number} predicted_ltv Predicted LifeTime Value for the customer involved in the event
     * @param {Number} num_items Number of items involved
     * @param {String} search_string query string used for the Search event
     * @param {String} item_number The item number
     * @param {String} delivery_category The type of delivery for a purchase event
     * @param {Object} custom_properties Custom Properties to be added to the Custom Data
     * params only Business Data API consumes
     * @param {SignalUserData} shipping_contact Shipping contact information. User {UserData} class to define a contact.
     * @param {SignalUserData} billing_contact Billing contact information. User {UserData} class to define a contact.
     * @param {String} external_order_id Unique ID representing the order, universal across multiple categories from the business
     * @param {String} original_order_id Original order id for refund. For Refund event only.
     * @param {String} message Reason for refund. For Refund event only.
     */
    function CustomData$$1(value, currency, content_name, content_category, content_ids, contents, content_type, order_id, predicted_ltv, num_items, search_string, status, item_number, delivery_category, custom_properties, shipping_contact, billing_contact, external_order_id, original_order_id, message) {
        classCallCheck(this, CustomData$$1);


        var business_data_contents = contents != undefined ? contents.map(function (content) {
            return content.business_data_content;
        }) : [];
        var server_contents = contents != undefined ? contents.map(function (content) {
            return content.server_content;
        }) : [];
        var business_data_shipping_contact = shipping_contact != undefined ? shipping_contact.business_data_user_data : shipping_contact;
        var business_data_billing_contact = billing_contact != undefined ? billing_contact.business_data_user_data : billing_contact;

        this._business_data_custom_data = new CustomData$3(value, currency, business_data_contents, order_id, status, business_data_shipping_contact, business_data_billing_contact, external_order_id, original_order_id, message);
        this._server_custom_data = new CustomData(value, currency, content_name, content_category, content_ids, server_contents, content_type, order_id, predicted_ltv, num_items, search_string, status, item_number, delivery_category, custom_properties);
    }

    /**
     * Gets the value of the custom data.
     * A numeric value associated with this event. This could be a monetary value or a value in some other metric.
     * Example: 142.54.
     */


    createClass(CustomData$$1, [{
        key: 'setValue',


        /**
         * Sets the value of the custom data.
         * @param {Number} value A numeric value associated with this event. This could be a monetary value or a value in some other metric.
         * Example: 142.54.
         */
        value: function setValue(value) {
            this._business_data_custom_data.value = value;
            this._server_custom_data.value = value;
            return this;
        }

        /**
         * Gets the currency for the custom data.
         * The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
         * Example: 'usd'
         */

    }, {
        key: 'setCurrency',


        /**
         * Sets the currency for the custom data.
         * @param {String} currency The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
         * Example: 'usd'
         */
        value: function setCurrency(currency) {
            this._business_data_custom_data.currency = currency;
            this._server_custom_data.currency = currency;
            return this;
        }

        /**
         * Gets the contents for the custom data.
         * An array of Content objects that contain the product IDs associated with the event plus information about the products. id, quantity, and item_price are available fields.
         * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
         */

    }, {
        key: 'setContents',


        /**
         * Sets the contents for the custom data.
         * @param {Array<Content>} contents An array of Content objects that contain the product IDs associated with the event plus information about the products. id, quantity, and item_price are available fields.
         * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
         */
        value: function setContents(contents) {
            var business_data_contents = contents.map(function (content) {
                return content.business_data_content;
            });
            var server_contents = contents.map(function (content) {
                return content.server_content;
            });
            this._business_data_custom_data.contents = business_data_contents;
            this._server_custom_data.contents = server_contents;
            return this;
        }

        /**
         * Gets the order id for the custom data.
         * order_id is the order ID for this transaction as a String.
         * Example: 'order1234'
         */

    }, {
        key: 'setOrderId',


        /**
         * Sets the order_id for the custom data.
         * @param {String} order_id The order ID for this transaction as a String.
         * Example: 'order1234'
         */
        value: function setOrderId(order_id) {
            this._business_data_custom_data.order_id = order_id;
            this._server_custom_data.order_id = order_id;
            return this;
        }

        /**
         * Status of the registration in Registration event or Status of the order in Purchase/UpdateOrder event.
         * - Used only with CompleteRegistration events for Conversion API.
         * - Used only with Purchase or UpdateOrder events for Business Data API
         */

    }, {
        key: 'setStatus',


        /**
         * Sets status of the registration in Registration event or status of the order in Purchase/UpdateOrder event.
         * - Used only with CompleteRegistration events for Conversion API.
         * - Used only with Purchase or UpdateOrder events for Business Data API
         * @param {String} status status, as a String.
         */
        value: function setStatus(status) {
            this._server_custom_data.status = status;
            this._business_data_custom_data.status = status;
            return this;
        }

        /**
         * Gets the content name for the custom data. The name of the page or product associated with the event.
         * The name of the page or product associated with the event.
         * Example: 'lettuce'
         */

    }, {
        key: 'setContentName',


        /**
         * Sets the content name for the custom data.
         * @param content_name The name of the page or product associated with the event.
         * Example: 'lettuce'
         */
        value: function setContentName(content_name) {
            this._server_custom_data.content_name = content_name;
            return this;
        }

        /**
         * Gets the content category for the custom data.
         * The category of the content associated with the event.
         * Example: 'grocery'
         */

    }, {
        key: 'setContentCategory',


        /**
         * Sets the content_category for the custom data.
         * @param content_category The category of the content associated with the event.
         * Example: 'grocery'
         */
        value: function setContentCategory(content_category) {
            this._server_custom_data.content_category = content_category;
            return this;
        }

        /**
         * Gets the content_ids for the custom data.
         * The content IDs associated with the event, such as product SKUs for items in an AddToCart, represented as Array of string.
         * If content_type is a product, then your content IDs must be an array with a single string value. Otherwise, this array can contain any number of string values.
         * Example: ['ABC123', 'XYZ789']
         */

    }, {
        key: 'setContentIds',


        /**
         * Sets the content_ids for the custom data.
         * @param {Array} content_ids The content IDs associated with the event, such as product SKUs for items in an AddToCart, represented as Array of string.
         * If content_type is a product, then your content IDs must be an array with a single string value. Otherwise, this array can contain any number of string values.
         * Example: ['ABC123', 'XYZ789']
         */
        value: function setContentIds(content_ids) {
            this._server_custom_data.content_ids = content_ids;
            return this;
        }

        /**
         * Gets the content type for the custom data.
         * A String equal to either product or product_group. Set to product if the keys you send content_ids or contents represent products.
         * Set to product_group if the keys you send in content_ids represent product groups.
         */

    }, {
        key: 'setContentType',


        /**
         * Sets the content type for the custom data.
         * @param {String} content_type A string equal to either product or product_group. Set to product if the keys you send content_ids or contents represent products.
         * Set to product_group if the keys you send in content_ids represent product groups.
         */
        value: function setContentType(content_type) {
            this._server_custom_data.content_type = content_type;
            return this;
        }

        /**
         * Gets the predicted LifeTimeValue for the (user) in custom data.
         * The predicted lifetime value of a conversion event, as a String.
         * Example: '432.12'
         */

    }, {
        key: 'setPredictedLtv',


        /**
         * Sets the predicted LifeTimeValue for the custom data.
         * @param {Number} predicted_ltv The predicted lifetime value of a conversion event, as a String.
         * Example: '432.12'
         */
        value: function setPredictedLtv(predicted_ltv) {
            this._server_custom_data.predicted_ltv = predicted_ltv;
            return this;
        }

        /**
         * Gets the number of items for the custom data.
         * The number of items that a user tries to buy during checkout. Use only with InitiateCheckout type events.
         * Example: 5
         */

    }, {
        key: 'setNumItems',


        /**
         * Sets the number of items for the custom data.
         * @param {Number} num_items The number of items that a user tries to buy during checkout. Use only with InitiateCheckout type events.
         * Example: 5
         */
        value: function setNumItems(num_items) {
            this._server_custom_data.num_items = num_items;
            return this;
        }

        /**
         * Gets the search string for the custom data.
         * A search query made by a user.Use only with Search events.
         * Eg: 'lettuce'
         */

    }, {
        key: 'setSearchString',


        /**
         * Sets the search string for the custom data.
         * @param search_string A search query made by a user.Use only with Search events.
         * Eg: 'lettuce'
         */
        value: function setSearchString(search_string) {
            this._server_custom_data.search_string = search_string;
            return this;
        }

        /**
         * Gets the item number.
         */

    }, {
        key: 'setItemNumber',


        /**
         * Sets the item number.
         * @param {String} item_number The item number.
         */
        value: function setItemNumber(item_number) {
            this._server_custom_data.item_number = item_number;
            return this;
        }

        /**
         * Gets the delivery category.
         */

    }, {
        key: 'setDeliveryCategory',


        /**
         * Sets the type of delivery for a purchase event.
         * @param {String} delivery_category The delivery category.
         */
        value: function setDeliveryCategory(delivery_category) {
            this._server_custom_data.delivery_category = delivery_category;
            return this;
        }

        /**
         * Gets the custom properties to be included in the Custom Data.
         * If our predefined object properties don't suit your needs, you can include your own, custom properties. Custom properties can be used with both standard and custom events, and can help you further define custom audiences.
         * This behavior is the same for Server-Side API and Facebook Pixel.
         * @see {@link https://developers.facebook.com/docs/marketing-api/server-side-api/parameters/custom-data#custom-properties}
         * Eg: '{ 'warehouse_location' : 'washington', 'package_size' : 'L'}'
         */

    }, {
        key: 'setCustomProperties',


        /**
         * Sets the search string for the custom data.
         * @param custom_properties A custom properties property bag to be included in the Custom Data.
         * If our predefined object properties don't suit your needs, you can include your own, custom properties. Custom properties can be used with both standard and custom events, and can help you further define custom audiences.
         * This behavior is the same for Server-Side API and Facebook Pixel.
         * @see {@link https://developers.facebook.com/docs/marketing-api/server-side-api/parameters/custom-data#custom-properties}
         * Eg: '{ 'warehouse_location' : 'washington', 'package_size' : 'L'}'
         * * @returns {Object} custom_properties property bag.
         */
        value: function setCustomProperties(custom_properties) {
            this._server_custom_data.custom_properties = custom_properties;
            return this;
        }

        /**
         * Adds the custom property (key, value) to the custom property bag.
         * @param {string} key The Key for the property to be added.
         * @param {string} value The Value for the property to be added.
         */

    }, {
        key: 'add_custom_property',
        value: function add_custom_property(key, value) {

            if (this._server_custom_data.custom_properties == null) {
                this._server_custom_data.custom_properties = {};
            }

            this._server_custom_data.custom_properties[key] = value;
        }

        /**
         * Gets the shipping_contact for Purchase/Update Order event.
         * shipping_contact of an order
         */

    }, {
        key: 'setShippingContact',


        /**
         * Sets the shipping_contact for Purchase/Update Order event.
         * @param {SignalUserData} shipping_contact shipping contact of an order, use {SignalUserData} to build
         */
        value: function setShippingContact(shipping_contact) {
            this._business_data_custom_data.shipping_contact = shipping_contact.business_data_user_data;
            return this;
        }

        /**
         * Gets the billing_contact for Purchase/Update Order event.
         * billing_contact of an order
         */

    }, {
        key: 'setBillingContact',


        /**
         * Sets the billing_contact for Purchase/Update Order event.
         * @param {SignalUserData} billing_contact billing contact of an order, use {SignalUserData} to build
         */
        value: function setBillingContact(billing_contact) {
            this._business_data_custom_data.billing_contact = billing_contact.business_data_user_data;
            return this;
        }

        /**
         * Gets the unique id of the order.
         * Unique ID representing the order, universal across multiple categories from the business.
         */

    }, {
        key: 'setExternalOrderId',


        /**
         * Sets the unique id of the order.
         * @param {String} external_order_id Unique ID representing the order, universal across multiple categories from the business.
         */
        value: function setExternalOrderId(external_order_id) {
            this._business_data_custom_data.external_order_id = external_order_id;
            return this;
        }

        /**
         * Gets the unique id of the original order.
         * Original order id for refund. For Refund event only.
         */

    }, {
        key: 'setOriginalOrderId',


        /**
         * Sets the unique id of the original order.
         * @param {String} original_order_id Original order id for refund. For Refund event only.
         */
        value: function setOriginalOrderId(original_order_id) {
            this._business_data_custom_data.original_order_id = original_order_id;
            return this;
        }

        /**
         * Gets the unique id of the original order.
         * Reason for refund. For Refund event only.
         */

    }, {
        key: 'setMessage',


        /**
         * Sets the unique id of the original order.
         * @param {String} message Reason for refund. For Refund event only.
         */
        value: function setMessage(message) {
            this._business_data_custom_data.message = message;
            return this;
        }

        /**
         * Gets the constructed custom data for Business Data API
         */

    }, {
        key: 'value',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.value, this._business_data_custom_data.value);
        }

        /**
         * Sets the value of the custom data.
         * @param value A numeric value associated with this event. This could be a monetary value or a value in some other metric.
         * Example: 142.54.
         */
        ,
        set: function set(value) {
            this._business_data_custom_data.value = value;
            this._server_custom_data.value = value;
        }
    }, {
        key: 'currency',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.currency, this._business_data_custom_data.currency);
        }

        /**
         * Sets the currency for the custom data.
         * @param currency The currency for the value specified, if applicable. Currency must be a valid ISO 4217 three digit currency code.
         * Example: 'usd'
         */
        ,
        set: function set(currency) {
            this._business_data_custom_data.currency = currency;
            this._server_custom_data.currency = currency;
        }
    }, {
        key: 'contents',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.contents, this._business_data_custom_data.contents);
        }

        /**
         * Sets the contents for the custom data.
         * @param contents An array of Content objects that contain the product IDs associated with the event plus information about the products. id, quantity, and item_price are available fields.
         * Example: [{'id':'ABC123','quantity' :2,'item_price':5.99}, {'id':'XYZ789','quantity':2, 'item_price':9.99}]
         */
        ,
        set: function set(contents) {
            var business_data_contents = contents.map(function (content) {
                return content.business_data_content;
            });
            var server_contents = contents.map(function (content) {
                return content.server_content;
            });
            this._business_data_custom_data.contents = business_data_contents;
            this._server_custom_data.contents = server_contents;
        }
    }, {
        key: 'order_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.order_id, this._business_data_custom_data.order_id);
        }

        /**
         * Sets the order_id for the custom data.
         * @param order_id The order ID for this transaction as a String.
         * Example: 'order1234'
         */
        ,
        set: function set(order_id) {
            this._business_data_custom_data.order_id = order_id;
            this._server_custom_data.order_id = order_id;
        }
    }, {
        key: 'status',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.status, this._business_data_custom_data.status);
        }

        /**
         * Sets status of the registration in Registration event or status of the order in Purchase/UpdateOrder event.
         * - Used only with CompleteRegistration events for Conversion API.
         * - Used only with Purchase or UpdateOrder events for Business Data API
         * @param status status, as a String.
         */
        ,
        set: function set(status) {
            this._server_custom_data.status = status;
            this._business_data_custom_data.status = status;
        }
    }, {
        key: 'content_name',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.content_name, null);
        }

        /**
         * Sets the content name for the custom data.
         * @param content_name The name of the page or product associated with the event.
         * Example: 'lettuce'
         */
        ,
        set: function set(content_name) {
            this._server_custom_data.content_name = content_name;
        }
    }, {
        key: 'content_category',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.content_category, null);
        }

        /**
         * Sets the content_category for the custom data.
         * @param content_category The category of the content associated with the event.
         * Example: 'grocery'
         */
        ,
        set: function set(content_category) {
            this._server_custom_data.content_category = content_category;
        }
    }, {
        key: 'content_ids',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.content_ids, null);
        }

        /**
         * Sets the content_ids for the custom data.
         * @param content_ids The content IDs associated with the event, such as product SKUs for items in an AddToCart, represented as Array of string.
         * If content_type is a product, then your content IDs must be an array with a single string value. Otherwise, this array can contain any number of string values.
         * Example: ['ABC123', 'XYZ789']
         */
        ,
        set: function set(content_ids) {
            this._server_custom_data.content_ids = content_ids;
        }
    }, {
        key: 'content_type',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.content_type, null);
        }

        /**
         * Sets the content type for the custom data.
         * A String equal to either product or product_group. Set to product if the keys you send content_ids or contents represent products.
         * Set to product_group if the keys you send in content_ids represent product groups.
         */
        ,
        set: function set(content_type) {
            this._server_custom_data.content_type = content_type;
        }
    }, {
        key: 'predicted_ltv',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.predicted_ltv, null);
        }

        /**
         * Sets the predicted LifeTimeValue for the custom data.
         * @param predicted_ltv The predicted lifetime value of a conversion event, as a String.
         * Example: '432.12'
         */
        ,
        set: function set(predicted_ltv) {
            this._server_custom_data.predicted_ltv = predicted_ltv;
        }
    }, {
        key: 'num_items',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.num_items, null);
        }

        /**
         * Sets the number of items for the custom data.
         * @param num_items The number of items that a user tries to buy during checkout. Use only with InitiateCheckout type events.
         * Example: 5
         */
        ,
        set: function set(num_items) {
            this._server_custom_data.num_items = num_items;
        }
    }, {
        key: 'search_string',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.search_string, null);
        }

        /**
         * Sets the search string for the custom data.
         * @param {Number} search_string A search query made by a user.Use only with Search events.
         * Eg: 'lettuce'
         */
        ,
        set: function set(search_string) {
            this._server_custom_data.search_string = search_string;
        }
    }, {
        key: 'item_number',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.item_number, null);
        }

        /**
         * Sets the item number.
         * @param item_number The item number.
         */
        ,
        set: function set(item_number) {
            this._server_custom_data.item_number = item_number;
        }
    }, {
        key: 'delivery_category',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.delivery_category, null);
        }

        /**
         * Sets the type of delivery for a purchase event.
         * @param delivery_category The delivery category.
         */
        ,
        set: function set(delivery_category) {
            this._server_custom_data.delivery_category = delivery_category;
        }
    }, {
        key: 'custom_properties',
        get: function get() {
            return Utils$2.constructResponse(this._server_custom_data.custom_properties, null);
        }

        /**
         * Sets the custom properties to be included in the Custom Data.
         * If our predefined object properties don't suit your needs, you can include your own, custom properties. Custom properties can be used with both standard and custom events, and can help you further define custom audiences.
         * This behavior is the same for Server-Side API and Facebook Pixel.
         * @see {@link https://developers.facebook.com/docs/marketing-api/server-side-api/parameters/custom-data#custom-properties}
         * @param {Object} custom_properties custom properties property bag to be included in the Custom Data. Eg: '{ 'warehouse_location' : 'washington', 'package_size' : 'L'}'
         */
        ,
        set: function set(custom_properties) {
            this._server_custom_data.custom_properties = custom_properties;
        }
    }, {
        key: 'shipping_contact',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_custom_data.shipping_contact);
        }

        /**
         * Sets the shipping_contact for Purchase/Update Order event.
         * @param shipping_contact shipping contact of an order, use {SignalUserData} to build
         */
        ,
        set: function set(shipping_contact) {
            this._business_data_custom_data.shipping_contact = shipping_contact.business_data_user_data;
        }
    }, {
        key: 'billing_contact',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_custom_data.billing_contact);
        }

        /**
         * Sets the billing_contact for Purchase/Update Order event.
         * @param billing_contact billing contact of an order, use {SignalUserData} to build
         */
        ,
        set: function set(billing_contact) {
            this._business_data_custom_data.billing_contact = billing_contact.business_data_user_data;
        }
    }, {
        key: 'external_order_id',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_custom_data.external_order_id);
        }

        /**
         * Sets the unique id of the order.
         * @param external_order_id Unique ID representing the order, universal across multiple categories from the business.
         */
        ,
        set: function set(external_order_id) {
            this._business_data_custom_data.external_order_id = external_order_id;
        }
    }, {
        key: 'original_order_id',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_custom_data.original_order_id);
        }

        /**
         * Sets the unique id of the original order.
         * @param original_order_id Original order id for refund. For Refund event only.
         */
        ,
        set: function set(original_order_id) {
            this._business_data_custom_data.original_order_id = original_order_id;
        }
    }, {
        key: 'message',
        get: function get() {
            return Utils$2.constructResponse(null, this._business_data_custom_data.message);
        }

        /**
         * Sets the unique id of the original order.
         * @param message Reason for refund. For Refund event only.
         */
        ,
        set: function set(message) {
            this._business_data_custom_data.message = message;
        }
    }, {
        key: 'business_data_custom_data',
        get: function get() {
            return this._business_data_custom_data;
        }

        /**
         * Gets the constructed custom data for Business Data API
         */

    }, {
        key: 'server_custom_data',
        get: function get() {
            return this._server_custom_data;
        }
    }]);
    return CustomData$$1;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * Event for Business Data API
 */

var Event$4 = function () {

  /**
   * @param {String} event_name A Facebook pixel Standard Event or Custom Event name.
   * @param {Number} event_time A Unix timestamp in seconds indicating when the actual event occurred.
   * @param {String} event_id This ID can be any string chosen by the advertiser.
   * @param {UserData} user_data A map that contains user data. See UserData Class for options.
   * @param {CustomData} custom_data A map that contains user data. See CustomData Class for options.
   * @param {Array<string>} data_processing_options Processing options you would like to enable for a specific event.
   * @param {Number} data_processing_options_country A country that you want to associate to this data processing option.
   * @param {Number} data_processing_options_state A state that you want to associate with this data processing option.
   */
  function Event(event_name, event_time, user_data, custom_data, event_id, data_processing_options, data_processing_options_country, data_processing_options_state) {
    classCallCheck(this, Event);


    this._event_name = event_name;
    this._event_time = event_time;
    this._user_data = user_data;
    this._custom_data = custom_data;
    this.event_id = event_id;
    this._data_processing_options = data_processing_options;
    this._data_processing_options_country = data_processing_options_country;
    this._data_processing_options_state = data_processing_options_state;
  }

  /**
   * Gets the Event Name for the current Event.
   */


  createClass(Event, [{
    key: 'toJson',


    /**
     * Convert to Json object for api call
     */
    value: function toJson() {
      return {
        'event_name': this._event_name,
        'event_time': this._event_time,
        'event_id': this._event_id,
        'user_data': this._user_data.toJson(),
        'custom_data': this._custom_data.toJson(),
        'data_processing_options': this._data_processing_options,
        'data_processing_options_country': this._data_processing_options_country,
        'data_processing_options_state': this._data_processing_options_state
      };
    }
  }, {
    key: 'event_name',
    get: function get() {
      return this._event_name;
    }

    /**
     * Sets the Event Name for the current Event.
     * @param {String} event_name a Facebook pixel Standard Event or Custom Event name.
     */
    ,
    set: function set(event_name) {
      this._event_name = event_name;
    }

    /**
     * Gets the Event Time when the current Event happened.
     */

  }, {
    key: 'event_time',
    get: function get() {
      return this._event_time;
    }

    /**
     * Sets the Event Time when the current Event happened.
     * @param {Number} event_time is a Unix timestamp in seconds indicating when the actual event occurred.
     */
    ,
    set: function set(event_time) {
      this._event_time = event_time;
    }

    /**
     * Gets the event_id for the current Event.
     */

  }, {
    key: 'event_id',
    get: function get() {
      return this._event_id;
    }

    /**
     * Sets the event Id for the current Event.
     * @param {String} event_id Unique id for the event.
     */
    ,
    set: function set(event_id) {
      this._event_id = event_id;
    }

    /**
     * Gets the user data object for the current Event.
     */

  }, {
    key: 'user_data',
    get: function get() {
      return this._user_data;
    }

    /**
     * Sets the user data object for the current Event.
     * @param {UserData} user_data user_data is an object that contains user data.
     */
    ,
    set: function set(user_data) {
      this._user_data = user_data;
    }

    /**
     * Gets the custom data object for the current Event.
     */

  }, {
    key: 'custom_data',
    get: function get() {
      return this._custom_data;
    }

    /**
     * Sets the custom data object for the current Event.
     * @param {CustomData} custom_data is an object that includes additional business data about the event.
     */
    ,
    set: function set(custom_data) {
      this._custom_data = custom_data;
    }

    /**
     * Gets the data_processing_options for the current event.
     * Processing options you would like to enable for a specific event.
     */

  }, {
    key: 'data_processing_options',
    get: function get() {
      return this._data_processing_options;
    }

    /**
     * Sets the data_processing_options for the current event.
     * @param {Array<string>} data_processing_options represents Data processing options you would like to enable for a specific event, e.g. [] or ['LDU']
     * @see {@link https://developers.facebook.com/docs/marketing-apis/data-processing-options}
     */
    ,
    set: function set(data_processing_options) {
      this._data_processing_options = data_processing_options;
    }

    /**
     * Gets the data_processing_options_country for the current event.
     * A country that you want to associate to this data processing option.
     * @see {@link https://developers.facebook.com/docs/marketing-apis/data-processing-options}
     */

  }, {
    key: 'data_processing_options_country',
    get: function get() {
      return this._data_processing_options_country;
    }

    /**
     * Sets the data_processing_options_country for the current event.
     * @param {number} data_processing_options_country represents country that you want to associate to this data processing option.
     */
    ,
    set: function set(data_processing_options_country) {
      this._data_processing_options_country = data_processing_options_country;
    }

    /**
     * Gets the data_processing_options_state for the current event.
     * A state that you want to associate with this data processing option.
     */

  }, {
    key: 'data_processing_options_state',
    get: function get() {
      return this._data_processing_options_state;
    }

    /**
     * Sets the data_processing_options_state for the current event.
     * @param {number} data_processing_options_state represents state that you want to associate with this data processing option.
     */
    ,
    set: function set(data_processing_options_state) {
      this._data_processing_options_state = data_processing_options_state;
    }
  }]);
  return Event;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * SignalEvent, event data for both Conversion API and Business Data API
 */

var Event$2 = function () {

    /**
     * @param {String} event_name A Facebook pixel Standard Event or Custom Event name.
     * @param {Number} event_time A Unix timestamp in seconds indicating when the actual event occurred.
     * @param {String} event_source_url The browser URL where the event happened.
     * @param {String} event_id This ID can be any string chosen by the advertiser.
     * @param {String} action_source A string that indicates where the event took place.
     * @param {Boolean} opt_out A flag that indicates we should not use this event for ads delivery optimization.
     * @param {SignalUserData} user_data SignalUserData contains user data for both Business Data API and Conversion API
     * @param {SignalCustomData} custom_data SignalCustomData contains custom data for both Business Data API and Conversion API
     * @param {Array<string>} data_processing_options Processing options you would like to enable for a specific event.
     * @param {Number} data_processing_options_country A country that you want to associate to this data processing option.
     * @param {Number} data_processing_options_state A state that you want to associate with this data processing option.
     */
    function Event(event_name, event_time, event_source_url, user_data, custom_data, event_id, opt_out, action_source, data_processing_options, data_processing_options_country, data_processing_options_state) {
        classCallCheck(this, Event);

        var business_data_user_data = user_data != undefined ? user_data.business_data_user_data : user_data;
        var server_user_data = user_data != undefined ? user_data.server_user_data : user_data;
        var business_data_custom_data = custom_data != undefined ? custom_data.business_data_custom_data : custom_data;
        var server_custom_data = custom_data != undefined ? custom_data.server_custom_data : custom_data;
        this._business_data_event = new Event$4(event_name, event_time, business_data_user_data, business_data_custom_data, event_id, data_processing_options, data_processing_options_country, data_processing_options_state);

        this._server_event = new ServerEvent(event_name, event_time, event_source_url, server_user_data, server_custom_data, event_id, opt_out, action_source, data_processing_options, data_processing_options_country, data_processing_options_state);
    }

    /**
     * Gets the Event Name for the current Event.
     */


    createClass(Event, [{
        key: 'setEventName',


        /**
         * Sets the Event Name for the current Event.
         * @param {String} event_name Facebook pixel Standard Event or Custom Event name.
         */
        value: function setEventName(event_name) {
            this._server_event.event_name = event_name;
            this._business_data_event.event_name = event_name;
            return this;
        }

        /**
         * Gets the Event Time when the current Event happened.
         */

    }, {
        key: 'setEventTime',


        /**
         * Sets the Event Time when the current Event happened.
         * @param {Number} event_time is a Unix timestamp in seconds indicating when the actual event occurred.
         */
        value: function setEventTime(event_time) {
            this._server_event.event_time = event_time;
            this._business_data_event.event_time = event_time;
            return this;
        }

        /**
         * Gets the browser url source for the current event.
         */

    }, {
        key: 'setEventSourceUrl',


        /**
         * Sets the browser url source for the current event.
         * @param {String} event_source_url The browser URL where the event happened.
         */
        value: function setEventSourceUrl(event_source_url) {
            this._server_event.event_source_url = event_source_url;
            return this;
        }

        /**
         * Gets the event_id for the current Event.
         */

    }, {
        key: 'setEventId',


        /**
         * Sets the event Id for the current Event.
         * @param {String} event_id can be any string chosen by the advertiser. This is used with event_name to determine if events are identical for Conversion API.
         */
        value: function setEventId(event_id) {
            this._server_event.event_id = event_id;
            this._business_data_event.event_id = event_id;
            return this;
        }

        /**
         * Gets the action_source for the current event. The Action Source represents where the action took place.
         */

    }, {
        key: 'setActionSource',


        /**
         * Sets the action_source for the current event.
         * @param {String} action_source represents where the action took place. One of {'physical_store','app','chat','email','other','phone_call','system_generated','website'}
         */
        value: function setActionSource(action_source) {
            this._server_event.action_source = action_source;
            return this;
        }

        /**
         * Gets the opt_out feature for the current event.opt_out is a boolean flag that indicates we should not use this event for ads delivery optimization. If set to true, we only use the event for attribution.
         */

    }, {
        key: 'setOptOut',


        /**
         * Sets the opt_out feature for the current event.
         * @param {Boolean} opt_out is a boolean flag that indicates we should not use this event for ads delivery optimization. If set to true, we only use the event for attribution.
         */
        value: function setOptOut(opt_out) {
            this._server_event.opt_out = opt_out;
            return this;
        }

        /**
         * Gets the user data objects for Business Data API and Conversion API.
         * @param user_data contains user data, use SignalUserData to construct
         */

    }, {
        key: 'setUserData',


        /**
         * Sets the user data objects for Business Data API and Conversion API.
         * @param {SignalUserData} user_data contains user data, use SignalUserData to construct
         */
        value: function setUserData(user_data) {
            this._server_event.user_data = user_data.server_user_data;
            this._business_data_event.user_data = user_data.business_data_user_data;
            return this;
        }

        /**
         * Gets the custom data objects for Business Data API and Conversion API.
         */

    }, {
        key: 'setCustomData',


        /**
         * Sets the custom data objects for Business Data API and Conversion API.
         * @param {SignalCustomData} custom_data contains custom data, use SignalCustomData to construct
         */
        value: function setCustomData(custom_data) {
            this._server_event.custom_data = custom_data.server_custom_data;
            this._business_data_event.custom_data = custom_data.business_data_custom_data;
            return this;
        }

        /**
         * Gets the data_processing_options for the current event.
         * Processing options you would like to enable for a specific event.
         */

    }, {
        key: 'setDataProcessingOptions',


        /**
         * Sets the data_processing_options for the current event.
         * @param {Array<string>} data_processing_options represents Data processing options you would like to enable for a specific event, e.g. [] or ['LDU']
         */
        value: function setDataProcessingOptions(data_processing_options) {
            this._server_event.data_processing_options = data_processing_options;
            this._business_data_event.data_processing_options = data_processing_options;
            return this;
        }

        /**
         * Gets the data_processing_options_country for the current event.
         * A country that you want to associate to this data processing option.
         */

    }, {
        key: 'setDataProcessingOptionsCountry',


        /**
         * Sets the data_processing_options_country for the current event.
         * @param {number} data_processing_options_country represents country that you want to associate to this data processing option.
         */
        value: function setDataProcessingOptionsCountry(data_processing_options_country) {
            this._server_event.data_processing_options_country = data_processing_options_country;
            this._business_data_event.data_processing_options_country = data_processing_options_country;
            return this;
        }

        /**
         * Gets the data_processing_options_state for the current event.
         * A state that you want to associate with this data processing option.
         */

    }, {
        key: 'setDataProcessingOptionsState',


        /**
         * Sets the data_processing_options_state for the current event.
         * @param {number} data_processing_options_state represents state that you want to associate with this data processing option.
         */
        value: function setDataProcessingOptionsState(data_processing_options_state) {
            this._server_event.data_processing_options_state = data_processing_options_state;
            this._business_data_event.data_processing_options_state = data_processing_options_state;
            return this;
        }

        /**
         * Gets the constructed custom data for Business Data API
         */

    }, {
        key: 'toJson',


        /**
         * Convert to Json object for api call
         */
        value: function toJson() {
            var business_data_event = this._business_data_event.toJson();
            var server_event = this._server_event.normalize();

            return Utils$2.constructResponse(server_event, business_data_event);
        }
    }, {
        key: 'event_name',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.event_name, this._business_data_event.event_name);
        }

        /**
         * Sets the Event Name for the current Event.
         * @param {String} event_name a Facebook pixel Standard Event or Custom Event name.
         */
        ,
        set: function set(event_name) {
            this._server_event.event_name = event_name;
            this._business_data_event.event_name = event_name;
        }
    }, {
        key: 'event_time',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.event_time, this._business_data_event.event_time);
        }

        /**
         * Sets the Event Time when the current Event happened.
         * @param {Number} event_time is a Unix timestamp in seconds indicating when the actual event occurred.
         */
        ,
        set: function set(event_time) {
            this._server_event.event_time = event_time;
            this._business_data_event.event_time = event_time;
        }
    }, {
        key: 'event_source_url',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.event_source_url, null);
        }

        /**
         * Sets the browser url source for the current event.
         * @param {String} event_source_url The browser URL where the event happened.
         */
        ,
        set: function set(event_source_url) {
            this._server_event.event_source_url = event_source_url;
        }
    }, {
        key: 'event_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.event_id, this._business_data_event.event_id);
        }

        /**
         * Sets the event Id for the current Event.
         * @param {String} event_id can be any string chosen by the advertiser. This is used with event_name to determine if events are identical for Conversion API.
         */
        ,
        set: function set(event_id) {
            this._server_event.event_id = event_id;
            this._business_data_event.event_id = event_id;
        }
    }, {
        key: 'action_source',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.action_source, null);
        }

        /**
         * Sets the action_source for the current event.
         * @param {String} action_source represents where the action took place. One of {'physical_store','app','chat','email','other','phone_call','system_generated','website'}
         */
        ,
        set: function set(action_source) {
            this._server_event.action_source = action_source;
        }
    }, {
        key: 'opt_out',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.opt_out, null);
        }

        /**
         * Sets the opt_out feature for the current event.
         * @param {Boolean} opt_out is a boolean flag that indicates we should not use this event for ads delivery optimization. If set to true, we only use the event for attribution.
         */
        ,
        set: function set(opt_out) {
            this._server_event.opt_out = opt_out;
        }
    }, {
        key: 'user_data',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.user_data, this._business_data_event.user_data);
        }

        /**
         * Sets the user data objects for Business Data API and Conversion API.
         * @param user_data contains user data, use SignalUserData to construct
         */
        ,
        set: function set(user_data) {
            this._server_event.user_data = user_data.server_user_data;
            this._business_data_event.user_data = user_data.business_data_user_data;
        }
    }, {
        key: 'custom_data',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.custom_data, this._business_data_event.custom_data);
        }

        /**
         * Sets the custom data objects for Business Data API and Conversion API.
         * @param custom_data contains custom data, use SignalCustomData to construct
         */
        ,
        set: function set(custom_data) {
            this._server_event.custom_data = custom_data.server_custom_data;
            this._business_data_event.custom_data = custom_data.business_data_custom_data;
        }
    }, {
        key: 'data_processing_options',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.data_processing_options, this._business_data_event.data_processing_options);
        }

        /**
         * Sets the data_processing_options for the current event.
         * @param {Array<string>} data_processing_options represents Data processing options you would like to enable for a specific event, e.g. [] or ['LDU']
         */
        ,
        set: function set(data_processing_options) {
            this._server_event.data_processing_options = data_processing_options;
            this._business_data_event.data_processing_options = data_processing_options;
        }
    }, {
        key: 'data_processing_options_country',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.data_processing_options_country, this._business_data_event.data_processing_options_country);
        }

        /**
         * Sets the data_processing_options_country for the current event.
         * @param {number} data_processing_options_country represents country that you want to associate to this data processing option.
         */
        ,
        set: function set(data_processing_options_country) {
            this._server_event.data_processing_options_country = data_processing_options_country;
            this._business_data_event.data_processing_options_country = data_processing_options_country;
        }
    }, {
        key: 'data_processing_options_state',
        get: function get() {
            return Utils$2.constructResponse(this._server_event.data_processing_options_state, this._business_data_event.data_processing_options_state);
        }

        /**
         * Sets the data_processing_options_state for the current event.
         * @param {number} data_processing_options_state represents state that you want to associate with this data processing option.
         */
        ,
        set: function set(data_processing_options_state) {
            this._server_event.data_processing_options_state = data_processing_options_state;
            this._business_data_event.data_processing_options_state = data_processing_options_state;
        }
    }, {
        key: 'business_data_event',
        get: function get() {
            return this._business_data_event;
        }

        /**
         * Gets the constructed custom data for Business Data API
         */

    }, {
        key: 'server_event',
        get: function get() {
            return this._server_event;
        }
    }]);
    return Event;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * EventResponse
 */

var EventResponse$2 = function () {

  /**
   * @param {Number} events_received
   * @param {Number} events_dropped
   * @param {Array<Object>} message
   */
  function EventResponse(events_received, events_dropped) {
    var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    classCallCheck(this, EventResponse);

    this._events_received = events_received;
    this._events_dropped = events_dropped;
    this._message = message;
  }

  /**
   * Gets the events received number from the Graph API Response.
   */


  createClass(EventResponse, [{
    key: "setEventsReceived",


    /**
     * Sets the events received number for the Graph API Response.
     * events_received is represented by integer.
     * @param {Number} events_received representing the number of events received for the event Request
     */
    value: function setEventsReceived(events_received) {
      this._events_received = events_received;
      return this;
    }

    /**
     * Gets the events dropped number from the Graph API Response.
     */

  }, {
    key: "setEventsDropped",


    /**
     * Sets the events dropped number for the Graph API Response.
     * events_dropped is represented by integer.
     * @param {Number} events_dropped representing the number of events dropped during events processing
     */
    value: function setEventsDropped(events_dropped) {
      this._events_dropped = events_dropped;
      return this;
    }

    /**
     * Gets the messages from the response received from Graph API.
     * @return messages in the event Response
     */

  }, {
    key: "setMessage",


    /**
     * Sets the messages as array for the response received from Graph API.
     * @param {Array} message in the event Response
     */
    value: function setMessage(message) {
      this._message = message;
      return this;
    }
  }, {
    key: "events_received",
    get: function get() {
      return this._events_received;
    }

    /**
     * Sets the events received number for the Graph API Response.
     * events_received is represented by integer.
     * @param events_received representing the number of events received for the event Request
     */
    ,
    set: function set(events_received) {
      this._events_received = events_received;
    }
  }, {
    key: "events_dropped",
    get: function get() {
      return this._events_dropped;
    }

    /**
     * Sets the events dropped number for the Graph API Response.
     * events_dropped is represented by integer.
     * @param events_dropped representing the number of events dropped during events processing
     */
    ,
    set: function set(events_dropped) {
      this._events_dropped = events_dropped;
    }
  }, {
    key: "message",
    get: function get() {
      return this._message;
    }

    /**
     * Sets the messages as array for the response received from Graph API.
     * @param message in the event Response
     */
    ,
    set: function set(message) {
      this._message = message;
    }
  }]);
  return EventResponse;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * EventRequest for Business Data API
 */

var EventRequest$3 = function () {

    /**
     * @param {String} access_token Access Token for the user calling Graph API
     * @param {String} page_id Page Id to which you are sending the events
     * @param {Array<Event>} events Data for the request Payload for a Business Data Event
     * @param {String} partner_agent Platform from which the event is sent e.g. Zapier
     */
    function EventRequest(access_token, page_id) {
        var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var partner_agent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        classCallCheck(this, EventRequest);

        this._access_token = access_token;
        this._page_id = page_id;
        this._events = events;
        this._partner_agent = partner_agent;

        this._api = FacebookAdsApi.init(this._access_token);
    }

    /**
     * Gets the data for the request Payload for a Business Data Event.
     */


    createClass(EventRequest, [{
        key: 'setEvents',


        /**
         * Sets the events for the request Payload for a Business Data Event.
         * @param events for the current event
         */
        value: function setEvents(events) {
            this._events = events;
            return this;
        }

        /**
         * Gets the partner_agent for the request
         * Allows you to specify the platform from which the event is sent e.g. Zapier
         */

    }, {
        key: 'setPartnerAgent',


        /**
         * Sets the partner_agent for the request
         * Allows you to specify the platform from which the event is sent e.g. Zapier
         * @param {String} partner_agent String value for the partner agent
         */
        value: function setPartnerAgent(partner_agent) {
            this._partner_agent = partner_agent;
            return this;
        }

        /**
         * Gets the access token for the Graph API request
         */

    }, {
        key: 'setAccessToken',


        /**
         * Sets the access token for the Graph API request
         * @param {String} access_token string representing the access token that is used to make the Graph API.
         */
        value: function setAccessToken(access_token) {
            this._access_token = access_token;
            return this;
        }

        /**
         * Gets the page id against which we send the events
         */

    }, {
        key: 'setPageId',


        /**
         * Sets the page id against which we send the events
         * @param {String} page_id string value representing the page id to which you are sending the events.
         */
        value: function setPageId(page_id) {
            this._page_id = page_id;
            return this;
        }

        /**
         * Executes the current event_request data by making a call to the Facebook Graph API.
         */

    }, {
        key: 'execute',
        value: function execute() {
            var events_json = this._events.map(function (event) {
                return event.toJson();
            });
            var params = {
                'data': events_json,
                'partner_agent': this._partner_agent,
                'access_token': this._access_token
            };

            var pagePromise = new Page(this._page_id).createBusinessDatum([], params);

            return pagePromise.then(function (response) {
                return new EventResponse$2(response._data['events_received'], response._data['events_dropped'], response._data['message']);
            });
        }
    }, {
        key: 'events',
        get: function get() {
            return this._events;
        }

        /**
         * Sets the events for the request Payload for a Business Data Event.
         * @param events for the current event
         */
        ,
        set: function set(events) {
            this._events = events;
        }
    }, {
        key: 'partner_agent',
        get: function get() {
            return this._partner_agent;
        }

        /**
         * Sets the partner_agent for the request
         * Allows you to specify the platform from which the event is sent e.g. Zapier
         * @param {String} partner_agent String value for the partner agent
         */
        ,
        set: function set(partner_agent) {
            this._partner_agent = partner_agent;
        }
    }, {
        key: 'access_token',
        get: function get() {
            return this._access_token;
        }

        /**
         * Sets the access token for the Graph API request
         * @param access_token string representing the access token that is used to make the Graph API.
         */
        ,
        set: function set(access_token) {
            this._access_token = access_token;
        }
    }, {
        key: 'page_id',
        get: function get() {
            return this._page_id;
        }

        /**
         * Sets the page id against which we send the events
         * @param {String} page_id string value representing the page id to which you are sending the events.
         */
        ,
        set: function set(page_id) {
            this._page_id = page_id;
        }
    }]);
    return EventRequest;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */

/**
 * EventRequest
 */

var EventRequest$1 = function () {

    /**
     * @param {String} access_token Access Token for the user calling Graph API
     * @param {String} pixel_id Pixel Id to which you are sending the events
     * @param {String} page_id Page Id to which you are sending the events
     * @param {Array<SignalEvent>} events Data for the request Payload for a Server Side Event
     * @param {?String} partner_agent Platform from which the event is sent e.g. wordpress
     * @param {?String} test_event_code Test Event Code used to verify that your server events are received correctly by Facebook.
     * @param {?String} namespace_id Scope used to resolve extern_id or Third-party ID. Can be another data set or data partner ID.
     * @param {?String} upload_id Unique id used to denote the current set being uploaded.
     * @param {?String} upload_tag Tag string added to track your Offline event uploads.
     * @param {?String} upload_source The origin/source of data for the dataset to be uploaded.
     * @param {Boolean} debug_mode_flag Set to true if you want to enable more logging in SDK
     * @param {?HttpServiceInterface} http_service Override the default http request method by setting an object that implements HttpServiceInterface
     */
    function EventRequest$$1(access_token, pixel_id, page_id) {
        var events = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var partner_agent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var test_event_code = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
        var namespace_id = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        var upload_id = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
        var upload_tag = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
        var upload_source = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
        var debug_mode_flag = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;
        var http_service = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : null;
        classCallCheck(this, EventRequest$$1);

        var business_data_events = events.map(function (event) {
            return event.business_data_event;
        });
        this._business_data_event_request = new EventRequest$3(access_token, page_id, business_data_events, partner_agent);

        var server_events = events.map(function (event) {
            return event.server_event;
        });
        this._server_event_request = new EventRequest(access_token, pixel_id, server_events, partner_agent, test_event_code, namespace_id, upload_id, upload_tag, upload_source, debug_mode_flag, http_service);
    }

    /**
     * Gets the data for the request Payload for a Server Side Event and Business Data Event.
     */


    createClass(EventRequest$$1, [{
        key: 'setEvents',


        /**
         * Sets the events for the request Payload for a Server Side Event and Business Data Event.
         * @param {Array<SignalEvent>} events for the current event
         */
        value: function setEvents(events) {
            var business_data_events = events.map(function (event) {
                return event.business_data_event;
            });
            var server_events = events.map(function (event) {
                return event.server_event;
            });
            this._server_event_request.events = server_events;
            this._business_data_event_request.events = business_data_events;
            return this;
        }

        /**
         * Gets the partner_agent for the request
         * Allows you to specify the platform from which the event is sent e.g. wordpress, Zapier
         */

    }, {
        key: 'setPartnerAgent',


        /**
         * Sets the partner_agent for the request
         * Allows you to specify the platform from which the event is sent e.g. wordpress
         * @param {String} partner_agent String value for the partner agent
         */
        value: function setPartnerAgent(partner_agent) {
            this._server_event_request.partner_agent = partner_agent;
            this._business_data_event_request.partner_agent = partner_agent;
            return this;
        }

        /**
         * Gets the test_event_code for the request
         */

    }, {
        key: 'setTestEventCode',


        /**
         * Sets the test_event_code for the request
         */
        value: function setTestEventCode(test_event_code) {
            this._server_event_request.test_event_code = test_event_code;
            return this;
        }

        /**
         * Gets the debug mode flag for the Graph API request
         */

    }, {
        key: 'setDebugMode',


        /**
         * Sets the debug mode flag for the Graph API request
         * @param {Boolean} debug_mode boolean value representing whether you want to send the request in debug mode to get detailed logging.
         */
        value: function setDebugMode(debug_mode) {
            this._server_event_request.debug_mode = debug_mode;
            return this;
        }

        /**
         * Gets the access token for the Graph API request
         */

    }, {
        key: 'setAccessToken',


        /**
         * Sets the access token for the Graph API request
         * @param {String} access_token string representing the access token that is used to make the Graph API.
         */
        value: function setAccessToken(access_token) {
            this._server_event_request.access_token = access_token;
            this._business_data_event_request.access_token = access_token;
            return this;
        }

        /**
         * Gets the pixel against which we send the events
         */

    }, {
        key: 'setPixelId',


        /**
         * Sets the pixel against which we send the events
         * @param {String} pixel_id String value for the pixel_id against which you want to send the events.
         */
        value: function setPixelId(pixel_id) {
            this._server_event_request.pixel_id = pixel_id;
            return this;
        }

        /* Region Offline Conversion Fields */
        /**
         * Gets the NamespaceId for the events
         */

    }, {
        key: 'setNamespaceId',


        /**
         * Sets the namespace_id for the events
         * @param {String} namespace_id Scope used to resolve extern_id or Third-party ID. Can be another data set or data partner ID.
         */
        value: function setNamespaceId(namespace_id) {
            this._server_event_request.namespace_id = namespace_id;
            return this;
        }

        /**
         * Gets the Upload Tag for the current events upload
         */

    }, {
        key: 'setUploadTag',


        /**
         * Sets the upload_tag for the current events upload
         * @param {String} upload_tag Tag string added to Track your Offline event uploads
         */
        value: function setUploadTag(upload_tag) {
            this._server_event_request.upload_tag = upload_tag;
            return this;
        }

        /**
         * Gets the Upload Tag for the current events upload
         */

    }, {
        key: 'setUploadId',


        /**
         * Sets the upload_id for the current events upload
         * @param {String} upload_id Unique id used to denote the current set being uploaded
         */
        value: function setUploadId(upload_id) {
            this._server_event_request.upload_id = upload_id;
            return this;
        }

        /**
         * Gets the Upload Tag for the current events upload
         */

    }, {
        key: 'setUploadSource',


        /**
         * Sets the upload_source for the current events upload
         * @param {String} upload_source origin/source of data for the dataset to be uploaded.
         */
        value: function setUploadSource(upload_source) {
            this._server_event_request.upload_source = upload_source;
            return this;
        }

        /**
         * Gets the http_service object for making the events request
         */

    }, {
        key: 'setHttpService',


        /**
         * Sets the http_service object for making the events request
         * @param {HttpServiceInterface} http_service
         */
        value: function setHttpService(http_service) {
            this._server_event_request.http_service = http_service;
            return this;
        }

        /**
         * Executes the current event_request data by making a call to the Facebook Graph API.
         */

    }, {
        key: 'execute',
        value: function execute() {
            return Promise.all([this._server_event_request.execute().catch(Error), this._business_data_event_request.execute().catch(Error)]).then(function (response) {
                return Utils$2.constructResponse(response[0], response[1]);
            });
        }
    }, {
        key: 'events',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.events, this._business_data_event_request.events);
        }

        /**
         * Sets the events for the request Payload for a Server Side Event and Business Data Event.
         * @param events for the current event
         */
        ,
        set: function set(events) {
            var business_data_events = events.map(function (event) {
                return event.business_data_event;
            });
            var server_events = events.map(function (event) {
                return event.server_event;
            });
            this._server_event_request.events = server_events;
            this._business_data_event_request.events = business_data_events;
        }
    }, {
        key: 'partner_agent',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.partner_agent, this._business_data_event_request.partner_agent);
        }

        /**
         * Sets the partner_agent for the request
         * Allows you to specify the platform from which the event is sent e.g. wordpress, Zapier
         * @param {String} partner_agent String value for the partner agent
         */
        ,
        set: function set(partner_agent) {
            this._server_event_request.partner_agent = partner_agent;
            this._business_data_event_request.partner_agent = partner_agent;
        }
    }, {
        key: 'test_event_code',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.partner_agent, null);
        }

        /**
         * Sets the test_event_code for the request
         */
        ,
        set: function set(test_event_code) {
            this._server_event_request.test_event_code = test_event_code;
        }
    }, {
        key: 'debug_mode',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.debug_mode, null);
        }

        /**
         * Sets the debug mode flag for the Graph API request
         * @param debug_mode boolean value representing whether you want to send the request in debug mode to get detailed logging.
         */
        ,
        set: function set(debug_mode) {
            this._server_event_request.debug_mode = debug_mode;
        }
    }, {
        key: 'access_token',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.access_token, this._business_data_event_request.access_token);
        }

        /**
         * Sets the access token for the Graph API request
         * @param access_token string representing the access token that is used to make the Graph API.
         */
        ,
        set: function set(access_token) {
            this._server_event_request.access_token = access_token;
            this._business_data_event_request.access_token = access_token;
        }
    }, {
        key: 'pixel_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.pixel, null);
        }

        /**
         * Sets the pixel against which we send the events
         * @param {String} pixel_id string value representing the Pixel's Id to which you are sending the events.
         */
        ,
        set: function set(pixel_id) {
            this._server_event_request.pixel_id = pixel_id;
        }
    }, {
        key: 'namespace_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.namespace_id, null);
        }

        /**
         * Sets the namespace_id for the events
         * @param {String} namespace_id Scope used to resolve extern_id or Third-party ID. Can be another data set or data partner ID.
         */
        ,
        set: function set(namespace_id) {
            this._server_event_request.namespace_id = namespace_id;
        }
    }, {
        key: 'upload_tag',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.upload_tag, null);
        }

        /**
         * Sets the upload_tag for the current events upload
         * @param {String} upload_tag Tag string added to Track your Offline event uploads
         */
        ,
        set: function set(upload_tag) {
            this._server_event_request.upload_tag = upload_tag;
        }
    }, {
        key: 'upload_id',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.upload_id, null);
        }

        /**
         * Sets the upload_id for the current events upload
         * @param {String} upload_id Unique id used to denote the current set being uploaded
         */
        ,
        set: function set(upload_id) {
            this._server_event_request.upload_id = upload_id;
        }
    }, {
        key: 'upload_source',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.upload_source, null);
        }

        /**
         * Sets the upload_source for the current events upload
         * @param {String} upload_source origin/source of data for the dataset to be uploaded.
         */
        ,
        set: function set(upload_source) {
            this._server_event_request.upload_source = upload_source;
        }
    }, {
        key: 'http_service',
        get: function get() {
            return Utils$2.constructResponse(this._server_event_request.http_service, null);
        }

        /**
         * Sets the http_service object for making the events request
         * @param {HttpServiceInterface} http_service
         */
        ,
        set: function set(http_service) {
            this._server_event_request.http_service = http_service;
        }
    }]);
    return EventRequest$$1;
}();

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountCustomAudience
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountCustomAudience = function (_AbstractCrudObject) {
  inherits(AdAccountCustomAudience, _AbstractCrudObject);

  function AdAccountCustomAudience() {
    classCallCheck(this, AdAccountCustomAudience);
    return possibleConstructorReturn(this, (AdAccountCustomAudience.__proto__ || Object.getPrototypeOf(AdAccountCustomAudience)).apply(this, arguments));
  }

  createClass(AdAccountCustomAudience, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        audience_type_param_name: 'audience_type_param_name',
        existing_customer_tag: 'existing_customer_tag',
        new_customer_tag: 'new_customer_tag'
      });
    }
  }]);
  return AdAccountCustomAudience;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountDefaultDestination
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountDefaultDestination = function (_AbstractCrudObject) {
  inherits(AdAccountDefaultDestination, _AbstractCrudObject);

  function AdAccountDefaultDestination() {
    classCallCheck(this, AdAccountDefaultDestination);
    return possibleConstructorReturn(this, (AdAccountDefaultDestination.__proto__ || Object.getPrototypeOf(AdAccountDefaultDestination)).apply(this, arguments));
  }

  createClass(AdAccountDefaultDestination, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        destination_id: 'destination_id',
        destination_url: 'destination_url'
      });
    }
  }]);
  return AdAccountDefaultDestination;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountDefaultObjective
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountDefaultObjective = function (_AbstractCrudObject) {
  inherits(AdAccountDefaultObjective, _AbstractCrudObject);

  function AdAccountDefaultObjective() {
    classCallCheck(this, AdAccountDefaultObjective);
    return possibleConstructorReturn(this, (AdAccountDefaultObjective.__proto__ || Object.getPrototypeOf(AdAccountDefaultObjective)).apply(this, arguments));
  }

  createClass(AdAccountDefaultObjective, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        default_objective_for_user: 'default_objective_for_user',
        objective_for_level: 'objective_for_level'
      });
    }
  }, {
    key: 'DefaultObjectiveForUser',
    get: function get() {
      return Object.freeze({
        app_installs: 'APP_INSTALLS',
        brand_awareness: 'BRAND_AWARENESS',
        event_responses: 'EVENT_RESPONSES',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        local_awareness: 'LOCAL_AWARENESS',
        messages: 'MESSAGES',
        offer_claims: 'OFFER_CLAIMS',
        outcome_app_promotion: 'OUTCOME_APP_PROMOTION',
        outcome_awareness: 'OUTCOME_AWARENESS',
        outcome_engagement: 'OUTCOME_ENGAGEMENT',
        outcome_leads: 'OUTCOME_LEADS',
        outcome_sales: 'OUTCOME_SALES',
        outcome_traffic: 'OUTCOME_TRAFFIC',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        product_catalog_sales: 'PRODUCT_CATALOG_SALES',
        reach: 'REACH',
        store_visits: 'STORE_VISITS',
        video_views: 'VIDEO_VIEWS',
        website_conversions: 'WEBSITE_CONVERSIONS'
      });
    }
  }, {
    key: 'ObjectiveForLevel',
    get: function get() {
      return Object.freeze({
        app_installs: 'APP_INSTALLS',
        brand_awareness: 'BRAND_AWARENESS',
        event_responses: 'EVENT_RESPONSES',
        lead_generation: 'LEAD_GENERATION',
        link_clicks: 'LINK_CLICKS',
        local_awareness: 'LOCAL_AWARENESS',
        messages: 'MESSAGES',
        offer_claims: 'OFFER_CLAIMS',
        outcome_app_promotion: 'OUTCOME_APP_PROMOTION',
        outcome_awareness: 'OUTCOME_AWARENESS',
        outcome_engagement: 'OUTCOME_ENGAGEMENT',
        outcome_leads: 'OUTCOME_LEADS',
        outcome_sales: 'OUTCOME_SALES',
        outcome_traffic: 'OUTCOME_TRAFFIC',
        page_likes: 'PAGE_LIKES',
        post_engagement: 'POST_ENGAGEMENT',
        product_catalog_sales: 'PRODUCT_CATALOG_SALES',
        reach: 'REACH',
        store_visits: 'STORE_VISITS',
        video_views: 'VIDEO_VIEWS',
        website_conversions: 'WEBSITE_CONVERSIONS'
      });
    }
  }]);
  return AdAccountDefaultObjective;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountPromotableObjects
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountPromotableObjects = function (_AbstractCrudObject) {
  inherits(AdAccountPromotableObjects, _AbstractCrudObject);

  function AdAccountPromotableObjects() {
    classCallCheck(this, AdAccountPromotableObjects);
    return possibleConstructorReturn(this, (AdAccountPromotableObjects.__proto__ || Object.getPrototypeOf(AdAccountPromotableObjects)).apply(this, arguments));
  }

  createClass(AdAccountPromotableObjects, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        promotable_app_ids: 'promotable_app_ids',
        promotable_page_ids: 'promotable_page_ids',
        promotable_urls: 'promotable_urls'
      });
    }
  }]);
  return AdAccountPromotableObjects;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAccountRecommendedCamapaignBudget
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAccountRecommendedCamapaignBudget = function (_AbstractCrudObject) {
  inherits(AdAccountRecommendedCamapaignBudget, _AbstractCrudObject);

  function AdAccountRecommendedCamapaignBudget() {
    classCallCheck(this, AdAccountRecommendedCamapaignBudget);
    return possibleConstructorReturn(this, (AdAccountRecommendedCamapaignBudget.__proto__ || Object.getPrototypeOf(AdAccountRecommendedCamapaignBudget)).apply(this, arguments));
  }

  createClass(AdAccountRecommendedCamapaignBudget, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        daily: 'daily',
        lifetime: 'lifetime',
        objective: 'objective'
      });
    }
  }]);
  return AdAccountRecommendedCamapaignBudget;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpec = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpec, _AbstractCrudObject);

  function AdAssetFeedSpec() {
    classCallCheck(this, AdAssetFeedSpec);
    return possibleConstructorReturn(this, (AdAssetFeedSpec.__proto__ || Object.getPrototypeOf(AdAssetFeedSpec)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_formats: 'ad_formats',
        additional_data: 'additional_data',
        asset_customization_rules: 'asset_customization_rules',
        autotranslate: 'autotranslate',
        bodies: 'bodies',
        call_to_action_types: 'call_to_action_types',
        call_to_actions: 'call_to_actions',
        captions: 'captions',
        carousels: 'carousels',
        descriptions: 'descriptions',
        events: 'events',
        groups: 'groups',
        images: 'images',
        link_urls: 'link_urls',
        optimization_type: 'optimization_type',
        titles: 'titles',
        videos: 'videos'
      });
    }
  }, {
    key: 'CallToActionTypes',
    get: function get() {
      return Object.freeze({
        add_to_cart: 'ADD_TO_CART',
        apply_now: 'APPLY_NOW',
        audio_call: 'AUDIO_CALL',
        book_travel: 'BOOK_TRAVEL',
        buy: 'BUY',
        buy_now: 'BUY_NOW',
        buy_tickets: 'BUY_TICKETS',
        call: 'CALL',
        call_me: 'CALL_ME',
        call_now: 'CALL_NOW',
        contact: 'CONTACT',
        contact_us: 'CONTACT_US',
        donate: 'DONATE',
        donate_now: 'DONATE_NOW',
        download: 'DOWNLOAD',
        event_rsvp: 'EVENT_RSVP',
        find_a_group: 'FIND_A_GROUP',
        find_your_groups: 'FIND_YOUR_GROUPS',
        follow_news_storyline: 'FOLLOW_NEWS_STORYLINE',
        follow_page: 'FOLLOW_PAGE',
        follow_user: 'FOLLOW_USER',
        get_directions: 'GET_DIRECTIONS',
        get_offer: 'GET_OFFER',
        get_offer_view: 'GET_OFFER_VIEW',
        get_quote: 'GET_QUOTE',
        get_showtimes: 'GET_SHOWTIMES',
        get_started: 'GET_STARTED',
        install_app: 'INSTALL_APP',
        install_mobile_app: 'INSTALL_MOBILE_APP',
        learn_more: 'LEARN_MORE',
        like_page: 'LIKE_PAGE',
        listen_music: 'LISTEN_MUSIC',
        listen_now: 'LISTEN_NOW',
        message_page: 'MESSAGE_PAGE',
        mobile_download: 'MOBILE_DOWNLOAD',
        moments: 'MOMENTS',
        no_button: 'NO_BUTTON',
        open_instant_app: 'OPEN_INSTANT_APP',
        open_link: 'OPEN_LINK',
        order_now: 'ORDER_NOW',
        pay_to_access: 'PAY_TO_ACCESS',
        play_game: 'PLAY_GAME',
        play_game_on_facebook: 'PLAY_GAME_ON_FACEBOOK',
        purchase_gift_cards: 'PURCHASE_GIFT_CARDS',
        raise_money: 'RAISE_MONEY',
        record_now: 'RECORD_NOW',
        refer_friends: 'REFER_FRIENDS',
        request_time: 'REQUEST_TIME',
        say_thanks: 'SAY_THANKS',
        see_more: 'SEE_MORE',
        sell_now: 'SELL_NOW',
        send_a_gift: 'SEND_A_GIFT',
        send_gift_money: 'SEND_GIFT_MONEY',
        send_updates: 'SEND_UPDATES',
        share: 'SHARE',
        shop_now: 'SHOP_NOW',
        sign_up: 'SIGN_UP',
        sotto_subscribe: 'SOTTO_SUBSCRIBE',
        start_order: 'START_ORDER',
        subscribe: 'SUBSCRIBE',
        swipe_up_product: 'SWIPE_UP_PRODUCT',
        swipe_up_shop: 'SWIPE_UP_SHOP',
        update_app: 'UPDATE_APP',
        use_app: 'USE_APP',
        use_mobile_app: 'USE_MOBILE_APP',
        video_annotation: 'VIDEO_ANNOTATION',
        video_call: 'VIDEO_CALL',
        visit_pages_feed: 'VISIT_PAGES_FEED',
        watch_more: 'WATCH_MORE',
        watch_video: 'WATCH_VIDEO',
        whatsapp_message: 'WHATSAPP_MESSAGE',
        woodhenge_support: 'WOODHENGE_SUPPORT'
      });
    }
  }]);
  return AdAssetFeedSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecAssetLabel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecAssetLabel = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecAssetLabel, _AbstractCrudObject);

  function AdAssetFeedSpecAssetLabel() {
    classCallCheck(this, AdAssetFeedSpecAssetLabel);
    return possibleConstructorReturn(this, (AdAssetFeedSpecAssetLabel.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecAssetLabel)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecAssetLabel, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name'
      });
    }
  }]);
  return AdAssetFeedSpecAssetLabel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecBody
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecBody = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecBody, _AbstractCrudObject);

  function AdAssetFeedSpecBody() {
    classCallCheck(this, AdAssetFeedSpecBody);
    return possibleConstructorReturn(this, (AdAssetFeedSpecBody.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecBody)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecBody, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        text: 'text',
        url_tags: 'url_tags'
      });
    }
  }]);
  return AdAssetFeedSpecBody;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecCaption
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecCaption = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecCaption, _AbstractCrudObject);

  function AdAssetFeedSpecCaption() {
    classCallCheck(this, AdAssetFeedSpecCaption);
    return possibleConstructorReturn(this, (AdAssetFeedSpecCaption.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecCaption)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecCaption, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        text: 'text',
        url_tags: 'url_tags'
      });
    }
  }]);
  return AdAssetFeedSpecCaption;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecDescription
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecDescription = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecDescription, _AbstractCrudObject);

  function AdAssetFeedSpecDescription() {
    classCallCheck(this, AdAssetFeedSpecDescription);
    return possibleConstructorReturn(this, (AdAssetFeedSpecDescription.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecDescription)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecDescription, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        text: 'text',
        url_tags: 'url_tags'
      });
    }
  }]);
  return AdAssetFeedSpecDescription;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecGroupRule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecGroupRule = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecGroupRule, _AbstractCrudObject);

  function AdAssetFeedSpecGroupRule() {
    classCallCheck(this, AdAssetFeedSpecGroupRule);
    return possibleConstructorReturn(this, (AdAssetFeedSpecGroupRule.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecGroupRule)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecGroupRule, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        body_label: 'body_label',
        caption_label: 'caption_label',
        description_label: 'description_label',
        image_label: 'image_label',
        link_url_label: 'link_url_label',
        title_label: 'title_label',
        video_label: 'video_label'
      });
    }
  }]);
  return AdAssetFeedSpecGroupRule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecImage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecImage = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecImage, _AbstractCrudObject);

  function AdAssetFeedSpecImage() {
    classCallCheck(this, AdAssetFeedSpecImage);
    return possibleConstructorReturn(this, (AdAssetFeedSpecImage.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecImage)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecImage, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        hash: 'hash',
        image_crops: 'image_crops',
        url: 'url',
        url_tags: 'url_tags'
      });
    }
  }]);
  return AdAssetFeedSpecImage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecLinkURL
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecLinkURL = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecLinkURL, _AbstractCrudObject);

  function AdAssetFeedSpecLinkURL() {
    classCallCheck(this, AdAssetFeedSpecLinkURL);
    return possibleConstructorReturn(this, (AdAssetFeedSpecLinkURL.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecLinkURL)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecLinkURL, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        carousel_see_more_url: 'carousel_see_more_url',
        deeplink_url: 'deeplink_url',
        display_url: 'display_url',
        url_tags: 'url_tags',
        website_url: 'website_url'
      });
    }
  }]);
  return AdAssetFeedSpecLinkURL;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecTitle
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecTitle = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecTitle, _AbstractCrudObject);

  function AdAssetFeedSpecTitle() {
    classCallCheck(this, AdAssetFeedSpecTitle);
    return possibleConstructorReturn(this, (AdAssetFeedSpecTitle.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecTitle)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecTitle, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        text: 'text',
        url_tags: 'url_tags'
      });
    }
  }]);
  return AdAssetFeedSpecTitle;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAssetFeedSpecVideo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAssetFeedSpecVideo = function (_AbstractCrudObject) {
  inherits(AdAssetFeedSpecVideo, _AbstractCrudObject);

  function AdAssetFeedSpecVideo() {
    classCallCheck(this, AdAssetFeedSpecVideo);
    return possibleConstructorReturn(this, (AdAssetFeedSpecVideo.__proto__ || Object.getPrototypeOf(AdAssetFeedSpecVideo)).apply(this, arguments));
  }

  createClass(AdAssetFeedSpecVideo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adlabels: 'adlabels',
        caption_ids: 'caption_ids',
        thumbnail_hash: 'thumbnail_hash',
        thumbnail_url: 'thumbnail_url',
        url_tags: 'url_tags',
        video_id: 'video_id'
      });
    }
  }]);
  return AdAssetFeedSpecVideo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdAsyncRequestSetNotificationResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdAsyncRequestSetNotificationResult = function (_AbstractCrudObject) {
  inherits(AdAsyncRequestSetNotificationResult, _AbstractCrudObject);

  function AdAsyncRequestSetNotificationResult() {
    classCallCheck(this, AdAsyncRequestSetNotificationResult);
    return possibleConstructorReturn(this, (AdAsyncRequestSetNotificationResult.__proto__ || Object.getPrototypeOf(AdAsyncRequestSetNotificationResult)).apply(this, arguments));
  }

  createClass(AdAsyncRequestSetNotificationResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        response: 'response',
        status: 'status'
      });
    }
  }]);
  return AdAsyncRequestSetNotificationResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdBidAdjustments
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdBidAdjustments = function (_AbstractCrudObject) {
  inherits(AdBidAdjustments, _AbstractCrudObject);

  function AdBidAdjustments() {
    classCallCheck(this, AdBidAdjustments);
    return possibleConstructorReturn(this, (AdBidAdjustments.__proto__ || Object.getPrototypeOf(AdBidAdjustments)).apply(this, arguments));
  }

  createClass(AdBidAdjustments, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        age_range: 'age_range',
        page_types: 'page_types',
        user_groups: 'user_groups'
      });
    }
  }]);
  return AdBidAdjustments;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignBidConstraint
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignBidConstraint = function (_AbstractCrudObject) {
  inherits(AdCampaignBidConstraint, _AbstractCrudObject);

  function AdCampaignBidConstraint() {
    classCallCheck(this, AdCampaignBidConstraint);
    return possibleConstructorReturn(this, (AdCampaignBidConstraint.__proto__ || Object.getPrototypeOf(AdCampaignBidConstraint)).apply(this, arguments));
  }

  createClass(AdCampaignBidConstraint, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        roas_average_floor: 'roas_average_floor'
      });
    }
  }]);
  return AdCampaignBidConstraint;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignDeliveryStatsUnsupportedReasons
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignDeliveryStatsUnsupportedReasons = function (_AbstractCrudObject) {
  inherits(AdCampaignDeliveryStatsUnsupportedReasons, _AbstractCrudObject);

  function AdCampaignDeliveryStatsUnsupportedReasons() {
    classCallCheck(this, AdCampaignDeliveryStatsUnsupportedReasons);
    return possibleConstructorReturn(this, (AdCampaignDeliveryStatsUnsupportedReasons.__proto__ || Object.getPrototypeOf(AdCampaignDeliveryStatsUnsupportedReasons)).apply(this, arguments));
  }

  createClass(AdCampaignDeliveryStatsUnsupportedReasons, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        reason_data: 'reason_data',
        reason_type: 'reason_type'
      });
    }
  }]);
  return AdCampaignDeliveryStatsUnsupportedReasons;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignFrequencyControlSpecs
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignFrequencyControlSpecs = function (_AbstractCrudObject) {
  inherits(AdCampaignFrequencyControlSpecs, _AbstractCrudObject);

  function AdCampaignFrequencyControlSpecs() {
    classCallCheck(this, AdCampaignFrequencyControlSpecs);
    return possibleConstructorReturn(this, (AdCampaignFrequencyControlSpecs.__proto__ || Object.getPrototypeOf(AdCampaignFrequencyControlSpecs)).apply(this, arguments));
  }

  createClass(AdCampaignFrequencyControlSpecs, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        event: 'event',
        interval_days: 'interval_days',
        max_frequency: 'max_frequency'
      });
    }
  }]);
  return AdCampaignFrequencyControlSpecs;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignIssuesInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignIssuesInfo = function (_AbstractCrudObject) {
  inherits(AdCampaignIssuesInfo, _AbstractCrudObject);

  function AdCampaignIssuesInfo() {
    classCallCheck(this, AdCampaignIssuesInfo);
    return possibleConstructorReturn(this, (AdCampaignIssuesInfo.__proto__ || Object.getPrototypeOf(AdCampaignIssuesInfo)).apply(this, arguments));
  }

  createClass(AdCampaignIssuesInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        error_code: 'error_code',
        error_message: 'error_message',
        error_summary: 'error_summary',
        error_type: 'error_type',
        level: 'level'
      });
    }
  }]);
  return AdCampaignIssuesInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignLearningStageInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignLearningStageInfo = function (_AbstractCrudObject) {
  inherits(AdCampaignLearningStageInfo, _AbstractCrudObject);

  function AdCampaignLearningStageInfo() {
    classCallCheck(this, AdCampaignLearningStageInfo);
    return possibleConstructorReturn(this, (AdCampaignLearningStageInfo.__proto__ || Object.getPrototypeOf(AdCampaignLearningStageInfo)).apply(this, arguments));
  }

  createClass(AdCampaignLearningStageInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        attribution_windows: 'attribution_windows',
        conversions: 'conversions',
        last_sig_edit_ts: 'last_sig_edit_ts',
        status: 'status'
      });
    }
  }]);
  return AdCampaignLearningStageInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignOptimizationEvent
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignOptimizationEvent = function (_AbstractCrudObject) {
  inherits(AdCampaignOptimizationEvent, _AbstractCrudObject);

  function AdCampaignOptimizationEvent() {
    classCallCheck(this, AdCampaignOptimizationEvent);
    return possibleConstructorReturn(this, (AdCampaignOptimizationEvent.__proto__ || Object.getPrototypeOf(AdCampaignOptimizationEvent)).apply(this, arguments));
  }

  createClass(AdCampaignOptimizationEvent, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        custom_conversion_id: 'custom_conversion_id',
        event_sequence: 'event_sequence',
        event_type: 'event_type'
      });
    }
  }]);
  return AdCampaignOptimizationEvent;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCampaignPacedBidInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCampaignPacedBidInfo = function (_AbstractCrudObject) {
  inherits(AdCampaignPacedBidInfo, _AbstractCrudObject);

  function AdCampaignPacedBidInfo() {
    classCallCheck(this, AdCampaignPacedBidInfo);
    return possibleConstructorReturn(this, (AdCampaignPacedBidInfo.__proto__ || Object.getPrototypeOf(AdCampaignPacedBidInfo)).apply(this, arguments));
  }

  createClass(AdCampaignPacedBidInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        bidding_status: 'bidding_status'
      });
    }
  }]);
  return AdCampaignPacedBidInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeAdDisclaimer
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeAdDisclaimer = function (_AbstractCrudObject) {
  inherits(AdCreativeAdDisclaimer, _AbstractCrudObject);

  function AdCreativeAdDisclaimer() {
    classCallCheck(this, AdCreativeAdDisclaimer);
    return possibleConstructorReturn(this, (AdCreativeAdDisclaimer.__proto__ || Object.getPrototypeOf(AdCreativeAdDisclaimer)).apply(this, arguments));
  }

  createClass(AdCreativeAdDisclaimer, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        text: 'text',
        title: 'title',
        url: 'url'
      });
    }
  }]);
  return AdCreativeAdDisclaimer;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeCollectionThumbnailInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeCollectionThumbnailInfo = function (_AbstractCrudObject) {
  inherits(AdCreativeCollectionThumbnailInfo, _AbstractCrudObject);

  function AdCreativeCollectionThumbnailInfo() {
    classCallCheck(this, AdCreativeCollectionThumbnailInfo);
    return possibleConstructorReturn(this, (AdCreativeCollectionThumbnailInfo.__proto__ || Object.getPrototypeOf(AdCreativeCollectionThumbnailInfo)).apply(this, arguments));
  }

  createClass(AdCreativeCollectionThumbnailInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        element_child_index: 'element_child_index',
        element_crops: 'element_crops',
        element_id: 'element_id'
      });
    }
  }]);
  return AdCreativeCollectionThumbnailInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeDegreesOfFreedomSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeDegreesOfFreedomSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeDegreesOfFreedomSpec, _AbstractCrudObject);

  function AdCreativeDegreesOfFreedomSpec() {
    classCallCheck(this, AdCreativeDegreesOfFreedomSpec);
    return possibleConstructorReturn(this, (AdCreativeDegreesOfFreedomSpec.__proto__ || Object.getPrototypeOf(AdCreativeDegreesOfFreedomSpec)).apply(this, arguments));
  }

  createClass(AdCreativeDegreesOfFreedomSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_handle_type: 'ad_handle_type',
        creative_features_spec: 'creative_features_spec',
        degrees_of_freedom_type: 'degrees_of_freedom_type',
        image_transformation_types: 'image_transformation_types',
        multi_media_transformation_type: 'multi_media_transformation_type',
        stories_transformation_types: 'stories_transformation_types',
        text_transformation_types: 'text_transformation_types',
        video_transformation_types: 'video_transformation_types'
      });
    }
  }]);
  return AdCreativeDegreesOfFreedomSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeInteractiveComponentsSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeInteractiveComponentsSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeInteractiveComponentsSpec, _AbstractCrudObject);

  function AdCreativeInteractiveComponentsSpec() {
    classCallCheck(this, AdCreativeInteractiveComponentsSpec);
    return possibleConstructorReturn(this, (AdCreativeInteractiveComponentsSpec.__proto__ || Object.getPrototypeOf(AdCreativeInteractiveComponentsSpec)).apply(this, arguments));
  }

  createClass(AdCreativeInteractiveComponentsSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        child_attachments: 'child_attachments',
        components: 'components'
      });
    }
  }]);
  return AdCreativeInteractiveComponentsSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkData = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkData, _AbstractCrudObject);

  function AdCreativeLinkData() {
    classCallCheck(this, AdCreativeLinkData);
    return possibleConstructorReturn(this, (AdCreativeLinkData.__proto__ || Object.getPrototypeOf(AdCreativeLinkData)).apply(this, arguments));
  }

  createClass(AdCreativeLinkData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_context: 'ad_context',
        additional_image_index: 'additional_image_index',
        app_link_spec: 'app_link_spec',
        attachment_style: 'attachment_style',
        branded_content_shared_to_sponsor_status: 'branded_content_shared_to_sponsor_status',
        branded_content_sponsor_page_id: 'branded_content_sponsor_page_id',
        call_to_action: 'call_to_action',
        caption: 'caption',
        child_attachments: 'child_attachments',
        collection_thumbnails: 'collection_thumbnails',
        customization_rules_spec: 'customization_rules_spec',
        description: 'description',
        event_id: 'event_id',
        force_single_link: 'force_single_link',
        format_option: 'format_option',
        image_crops: 'image_crops',
        image_hash: 'image_hash',
        image_layer_specs: 'image_layer_specs',
        image_overlay_spec: 'image_overlay_spec',
        link: 'link',
        message: 'message',
        multi_share_end_card: 'multi_share_end_card',
        multi_share_optimized: 'multi_share_optimized',
        name: 'name',
        offer_id: 'offer_id',
        page_welcome_message: 'page_welcome_message',
        picture: 'picture',
        post_click_configuration: 'post_click_configuration',
        preferred_image_tags: 'preferred_image_tags',
        retailer_item_ids: 'retailer_item_ids',
        show_multiple_images: 'show_multiple_images',
        static_fallback_spec: 'static_fallback_spec',
        use_flexible_image_aspect_ratio: 'use_flexible_image_aspect_ratio'
      });
    }
  }, {
    key: 'AttachmentStyle',
    get: function get() {
      return Object.freeze({
        default: 'default',
        link: 'link'
      });
    }
  }, {
    key: 'FormatOption',
    get: function get() {
      return Object.freeze({
        carousel_ar_effects: 'carousel_ar_effects',
        carousel_images_multi_items: 'carousel_images_multi_items',
        carousel_images_single_item: 'carousel_images_single_item',
        carousel_slideshows: 'carousel_slideshows',
        single_image: 'single_image'
      });
    }
  }]);
  return AdCreativeLinkData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataAppLinkSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataAppLinkSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataAppLinkSpec, _AbstractCrudObject);

  function AdCreativeLinkDataAppLinkSpec() {
    classCallCheck(this, AdCreativeLinkDataAppLinkSpec);
    return possibleConstructorReturn(this, (AdCreativeLinkDataAppLinkSpec.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataAppLinkSpec)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataAppLinkSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        android: 'android',
        ios: 'ios',
        ipad: 'ipad',
        iphone: 'iphone'
      });
    }
  }]);
  return AdCreativeLinkDataAppLinkSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataCallToAction
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataCallToAction = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataCallToAction, _AbstractCrudObject);

  function AdCreativeLinkDataCallToAction() {
    classCallCheck(this, AdCreativeLinkDataCallToAction);
    return possibleConstructorReturn(this, (AdCreativeLinkDataCallToAction.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataCallToAction)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataCallToAction, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        type: 'type',
        value: 'value'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        add_to_cart: 'ADD_TO_CART',
        apply_now: 'APPLY_NOW',
        audio_call: 'AUDIO_CALL',
        book_travel: 'BOOK_TRAVEL',
        buy: 'BUY',
        buy_now: 'BUY_NOW',
        buy_tickets: 'BUY_TICKETS',
        call: 'CALL',
        call_me: 'CALL_ME',
        call_now: 'CALL_NOW',
        contact: 'CONTACT',
        contact_us: 'CONTACT_US',
        donate: 'DONATE',
        donate_now: 'DONATE_NOW',
        download: 'DOWNLOAD',
        event_rsvp: 'EVENT_RSVP',
        find_a_group: 'FIND_A_GROUP',
        find_your_groups: 'FIND_YOUR_GROUPS',
        follow_news_storyline: 'FOLLOW_NEWS_STORYLINE',
        follow_page: 'FOLLOW_PAGE',
        follow_user: 'FOLLOW_USER',
        get_directions: 'GET_DIRECTIONS',
        get_offer: 'GET_OFFER',
        get_offer_view: 'GET_OFFER_VIEW',
        get_quote: 'GET_QUOTE',
        get_showtimes: 'GET_SHOWTIMES',
        get_started: 'GET_STARTED',
        install_app: 'INSTALL_APP',
        install_mobile_app: 'INSTALL_MOBILE_APP',
        learn_more: 'LEARN_MORE',
        like_page: 'LIKE_PAGE',
        listen_music: 'LISTEN_MUSIC',
        listen_now: 'LISTEN_NOW',
        message_page: 'MESSAGE_PAGE',
        mobile_download: 'MOBILE_DOWNLOAD',
        moments: 'MOMENTS',
        no_button: 'NO_BUTTON',
        open_instant_app: 'OPEN_INSTANT_APP',
        open_link: 'OPEN_LINK',
        order_now: 'ORDER_NOW',
        pay_to_access: 'PAY_TO_ACCESS',
        play_game: 'PLAY_GAME',
        play_game_on_facebook: 'PLAY_GAME_ON_FACEBOOK',
        purchase_gift_cards: 'PURCHASE_GIFT_CARDS',
        raise_money: 'RAISE_MONEY',
        record_now: 'RECORD_NOW',
        refer_friends: 'REFER_FRIENDS',
        request_time: 'REQUEST_TIME',
        say_thanks: 'SAY_THANKS',
        see_more: 'SEE_MORE',
        sell_now: 'SELL_NOW',
        send_a_gift: 'SEND_A_GIFT',
        send_gift_money: 'SEND_GIFT_MONEY',
        send_updates: 'SEND_UPDATES',
        share: 'SHARE',
        shop_now: 'SHOP_NOW',
        sign_up: 'SIGN_UP',
        sotto_subscribe: 'SOTTO_SUBSCRIBE',
        start_order: 'START_ORDER',
        subscribe: 'SUBSCRIBE',
        swipe_up_product: 'SWIPE_UP_PRODUCT',
        swipe_up_shop: 'SWIPE_UP_SHOP',
        update_app: 'UPDATE_APP',
        use_app: 'USE_APP',
        use_mobile_app: 'USE_MOBILE_APP',
        video_annotation: 'VIDEO_ANNOTATION',
        video_call: 'VIDEO_CALL',
        visit_pages_feed: 'VISIT_PAGES_FEED',
        watch_more: 'WATCH_MORE',
        watch_video: 'WATCH_VIDEO',
        whatsapp_message: 'WHATSAPP_MESSAGE',
        woodhenge_support: 'WOODHENGE_SUPPORT'
      });
    }
  }]);
  return AdCreativeLinkDataCallToAction;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataCallToActionValue
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataCallToActionValue = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataCallToActionValue, _AbstractCrudObject);

  function AdCreativeLinkDataCallToActionValue() {
    classCallCheck(this, AdCreativeLinkDataCallToActionValue);
    return possibleConstructorReturn(this, (AdCreativeLinkDataCallToActionValue.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataCallToActionValue)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataCallToActionValue, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_destination: 'app_destination',
        app_link: 'app_link',
        application: 'application',
        event_id: 'event_id',
        lead_gen_form_id: 'lead_gen_form_id',
        link: 'link',
        link_caption: 'link_caption',
        link_format: 'link_format',
        page: 'page',
        product_link: 'product_link',
        whatsapp_number: 'whatsapp_number'
      });
    }
  }]);
  return AdCreativeLinkDataCallToActionValue;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataChildAttachment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataChildAttachment = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataChildAttachment, _AbstractCrudObject);

  function AdCreativeLinkDataChildAttachment() {
    classCallCheck(this, AdCreativeLinkDataChildAttachment);
    return possibleConstructorReturn(this, (AdCreativeLinkDataChildAttachment.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataChildAttachment)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataChildAttachment, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        call_to_action: 'call_to_action',
        caption: 'caption',
        description: 'description',
        image_crops: 'image_crops',
        image_hash: 'image_hash',
        link: 'link',
        name: 'name',
        picture: 'picture',
        place_data: 'place_data',
        static_card: 'static_card',
        video_id: 'video_id'
      });
    }
  }]);
  return AdCreativeLinkDataChildAttachment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataImageLayerSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataImageLayerSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataImageLayerSpec, _AbstractCrudObject);

  function AdCreativeLinkDataImageLayerSpec() {
    classCallCheck(this, AdCreativeLinkDataImageLayerSpec);
    return possibleConstructorReturn(this, (AdCreativeLinkDataImageLayerSpec.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataImageLayerSpec)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataImageLayerSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        blending_mode: 'blending_mode',
        content: 'content',
        frame_image_hash: 'frame_image_hash',
        frame_source: 'frame_source',
        image_source: 'image_source',
        layer_type: 'layer_type',
        opacity: 'opacity',
        overlay_position: 'overlay_position',
        overlay_shape: 'overlay_shape',
        scale: 'scale',
        shape_color: 'shape_color',
        text_color: 'text_color',
        text_font: 'text_font'
      });
    }
  }, {
    key: 'BlendingMode',
    get: function get() {
      return Object.freeze({
        lighten: 'lighten',
        multiply: 'multiply',
        normal: 'normal'
      });
    }
  }, {
    key: 'FrameSource',
    get: function get() {
      return Object.freeze({
        custom: 'custom'
      });
    }
  }, {
    key: 'ImageSource',
    get: function get() {
      return Object.freeze({
        catalog: 'catalog'
      });
    }
  }, {
    key: 'LayerType',
    get: function get() {
      return Object.freeze({
        frame_overlay: 'frame_overlay',
        image: 'image',
        text_overlay: 'text_overlay'
      });
    }
  }, {
    key: 'OverlayPosition',
    get: function get() {
      return Object.freeze({
        bottom: 'bottom',
        bottom_left: 'bottom_left',
        bottom_right: 'bottom_right',
        center: 'center',
        left: 'left',
        right: 'right',
        top: 'top',
        top_left: 'top_left',
        top_right: 'top_right'
      });
    }
  }, {
    key: 'OverlayShape',
    get: function get() {
      return Object.freeze({
        circle: 'circle',
        none: 'none',
        pill: 'pill',
        rectangle: 'rectangle',
        triangle: 'triangle'
      });
    }
  }, {
    key: 'TextFont',
    get: function get() {
      return Object.freeze({
        droid_serif_regular: 'droid_serif_regular',
        lato_regular: 'lato_regular',
        noto_sans_regular: 'noto_sans_regular',
        nunito_sans_bold: 'nunito_sans_bold',
        open_sans_bold: 'open_sans_bold',
        open_sans_condensed_bold: 'open_sans_condensed_bold',
        pt_serif_bold: 'pt_serif_bold',
        roboto_condensed_regular: 'roboto_condensed_regular',
        roboto_medium: 'roboto_medium'
      });
    }
  }]);
  return AdCreativeLinkDataImageLayerSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataImageOverlaySpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataImageOverlaySpec = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataImageOverlaySpec, _AbstractCrudObject);

  function AdCreativeLinkDataImageOverlaySpec() {
    classCallCheck(this, AdCreativeLinkDataImageOverlaySpec);
    return possibleConstructorReturn(this, (AdCreativeLinkDataImageOverlaySpec.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataImageOverlaySpec)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataImageOverlaySpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        custom_text_type: 'custom_text_type',
        float_with_margin: 'float_with_margin',
        overlay_template: 'overlay_template',
        position: 'position',
        text_font: 'text_font',
        text_template_tags: 'text_template_tags',
        text_type: 'text_type',
        theme_color: 'theme_color'
      });
    }
  }, {
    key: 'CustomTextType',
    get: function get() {
      return Object.freeze({
        free_shipping: 'free_shipping',
        popular: 'popular'
      });
    }
  }, {
    key: 'OverlayTemplate',
    get: function get() {
      return Object.freeze({
        circle_with_text: 'circle_with_text',
        pill_with_text: 'pill_with_text',
        triangle_with_text: 'triangle_with_text'
      });
    }
  }, {
    key: 'Position',
    get: function get() {
      return Object.freeze({
        bottom_left: 'bottom_left',
        bottom_right: 'bottom_right',
        top_left: 'top_left',
        top_right: 'top_right'
      });
    }
  }, {
    key: 'TextFont',
    get: function get() {
      return Object.freeze({
        droid_serif_regular: 'droid_serif_regular',
        dynads_hybrid_bold: 'dynads_hybrid_bold',
        lato_regular: 'lato_regular',
        noto_sans_regular: 'noto_sans_regular',
        nunito_sans_bold: 'nunito_sans_bold',
        open_sans_bold: 'open_sans_bold',
        open_sans_condensed_bold: 'open_sans_condensed_bold',
        pt_serif_bold: 'pt_serif_bold',
        roboto_condensed_regular: 'roboto_condensed_regular',
        roboto_medium: 'roboto_medium'
      });
    }
  }, {
    key: 'TextType',
    get: function get() {
      return Object.freeze({
        automated_personalize: 'automated_personalize',
        custom: 'custom',
        disclaimer: 'disclaimer',
        from_price: 'from_price',
        guest_rating: 'guest_rating',
        percentage_off: 'percentage_off',
        price: 'price',
        star_rating: 'star_rating',
        strikethrough_price: 'strikethrough_price'
      });
    }
  }, {
    key: 'ThemeColor',
    get: function get() {
      return Object.freeze({
        background_000000_text_ffffff: 'background_000000_text_ffffff',
        background_0090ff_text_ffffff: 'background_0090ff_text_ffffff',
        background_00af4c_text_ffffff: 'background_00af4c_text_ffffff',
        background_595959_text_ffffff: 'background_595959_text_ffffff',
        background_755dde_text_ffffff: 'background_755dde_text_ffffff',
        background_e50900_text_ffffff: 'background_e50900_text_ffffff',
        background_f23474_text_ffffff: 'background_f23474_text_ffffff',
        background_f78400_text_ffffff: 'background_f78400_text_ffffff',
        background_ffffff_text_000000: 'background_ffffff_text_000000',
        background_ffffff_text_007ad0: 'background_ffffff_text_007ad0',
        background_ffffff_text_009c2a: 'background_ffffff_text_009c2a',
        background_ffffff_text_646464: 'background_ffffff_text_646464',
        background_ffffff_text_755dde: 'background_ffffff_text_755dde',
        background_ffffff_text_c91b00: 'background_ffffff_text_c91b00',
        background_ffffff_text_f23474: 'background_ffffff_text_f23474',
        background_ffffff_text_f78400: 'background_ffffff_text_f78400'
      });
    }
  }]);
  return AdCreativeLinkDataImageOverlaySpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataSponsorshipInfoSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataSponsorshipInfoSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataSponsorshipInfoSpec, _AbstractCrudObject);

  function AdCreativeLinkDataSponsorshipInfoSpec() {
    classCallCheck(this, AdCreativeLinkDataSponsorshipInfoSpec);
    return possibleConstructorReturn(this, (AdCreativeLinkDataSponsorshipInfoSpec.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataSponsorshipInfoSpec)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataSponsorshipInfoSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        sponsor_image_url: 'sponsor_image_url',
        sponsor_name: 'sponsor_name'
      });
    }
  }]);
  return AdCreativeLinkDataSponsorshipInfoSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeLinkDataTemplateVideoSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeLinkDataTemplateVideoSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeLinkDataTemplateVideoSpec, _AbstractCrudObject);

  function AdCreativeLinkDataTemplateVideoSpec() {
    classCallCheck(this, AdCreativeLinkDataTemplateVideoSpec);
    return possibleConstructorReturn(this, (AdCreativeLinkDataTemplateVideoSpec.__proto__ || Object.getPrototypeOf(AdCreativeLinkDataTemplateVideoSpec)).apply(this, arguments));
  }

  createClass(AdCreativeLinkDataTemplateVideoSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        categorization_criteria: 'categorization_criteria',
        customization: 'customization',
        template_id: 'template_id'
      });
    }
  }]);
  return AdCreativeLinkDataTemplateVideoSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeObjectStorySpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeObjectStorySpec = function (_AbstractCrudObject) {
  inherits(AdCreativeObjectStorySpec, _AbstractCrudObject);

  function AdCreativeObjectStorySpec() {
    classCallCheck(this, AdCreativeObjectStorySpec);
    return possibleConstructorReturn(this, (AdCreativeObjectStorySpec.__proto__ || Object.getPrototypeOf(AdCreativeObjectStorySpec)).apply(this, arguments));
  }

  createClass(AdCreativeObjectStorySpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        instagram_actor_id: 'instagram_actor_id',
        link_data: 'link_data',
        page_id: 'page_id',
        photo_data: 'photo_data',
        template_data: 'template_data',
        text_data: 'text_data',
        video_data: 'video_data'
      });
    }
  }]);
  return AdCreativeObjectStorySpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeOmnichannelLinkSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeOmnichannelLinkSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeOmnichannelLinkSpec, _AbstractCrudObject);

  function AdCreativeOmnichannelLinkSpec() {
    classCallCheck(this, AdCreativeOmnichannelLinkSpec);
    return possibleConstructorReturn(this, (AdCreativeOmnichannelLinkSpec.__proto__ || Object.getPrototypeOf(AdCreativeOmnichannelLinkSpec)).apply(this, arguments));
  }

  createClass(AdCreativeOmnichannelLinkSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app: 'app',
        web: 'web'
      });
    }
  }]);
  return AdCreativeOmnichannelLinkSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativePhotoData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativePhotoData = function (_AbstractCrudObject) {
  inherits(AdCreativePhotoData, _AbstractCrudObject);

  function AdCreativePhotoData() {
    classCallCheck(this, AdCreativePhotoData);
    return possibleConstructorReturn(this, (AdCreativePhotoData.__proto__ || Object.getPrototypeOf(AdCreativePhotoData)).apply(this, arguments));
  }

  createClass(AdCreativePhotoData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        branded_content_shared_to_sponsor_status: 'branded_content_shared_to_sponsor_status',
        branded_content_sponsor_page_id: 'branded_content_sponsor_page_id',
        caption: 'caption',
        image_hash: 'image_hash',
        page_welcome_message: 'page_welcome_message',
        url: 'url'
      });
    }
  }]);
  return AdCreativePhotoData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativePhotoDataMediaElements
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativePhotoDataMediaElements = function (_AbstractCrudObject) {
  inherits(AdCreativePhotoDataMediaElements, _AbstractCrudObject);

  function AdCreativePhotoDataMediaElements() {
    classCallCheck(this, AdCreativePhotoDataMediaElements);
    return possibleConstructorReturn(this, (AdCreativePhotoDataMediaElements.__proto__ || Object.getPrototypeOf(AdCreativePhotoDataMediaElements)).apply(this, arguments));
  }

  createClass(AdCreativePhotoDataMediaElements, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        element_id: 'element_id',
        element_type: 'element_type',
        x: 'x',
        y: 'y'
      });
    }
  }]);
  return AdCreativePhotoDataMediaElements;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativePlaceData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativePlaceData = function (_AbstractCrudObject) {
  inherits(AdCreativePlaceData, _AbstractCrudObject);

  function AdCreativePlaceData() {
    classCallCheck(this, AdCreativePlaceData);
    return possibleConstructorReturn(this, (AdCreativePlaceData.__proto__ || Object.getPrototypeOf(AdCreativePlaceData)).apply(this, arguments));
  }

  createClass(AdCreativePlaceData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address_string: 'address_string',
        label: 'label',
        latitude: 'latitude',
        location_source_id: 'location_source_id',
        longitude: 'longitude',
        type: 'type'
      });
    }
  }]);
  return AdCreativePlaceData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativePlatformCustomization
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativePlatformCustomization = function (_AbstractCrudObject) {
  inherits(AdCreativePlatformCustomization, _AbstractCrudObject);

  function AdCreativePlatformCustomization() {
    classCallCheck(this, AdCreativePlatformCustomization);
    return possibleConstructorReturn(this, (AdCreativePlatformCustomization.__proto__ || Object.getPrototypeOf(AdCreativePlatformCustomization)).apply(this, arguments));
  }

  createClass(AdCreativePlatformCustomization, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        instagram: 'instagram'
      });
    }
  }]);
  return AdCreativePlatformCustomization;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativePortraitCustomizations
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativePortraitCustomizations = function (_AbstractCrudObject) {
  inherits(AdCreativePortraitCustomizations, _AbstractCrudObject);

  function AdCreativePortraitCustomizations() {
    classCallCheck(this, AdCreativePortraitCustomizations);
    return possibleConstructorReturn(this, (AdCreativePortraitCustomizations.__proto__ || Object.getPrototypeOf(AdCreativePortraitCustomizations)).apply(this, arguments));
  }

  createClass(AdCreativePortraitCustomizations, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        carousel_delivery_mode: 'carousel_delivery_mode',
        specifications: 'specifications'
      });
    }
  }]);
  return AdCreativePortraitCustomizations;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativePostClickConfiguration
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativePostClickConfiguration = function (_AbstractCrudObject) {
  inherits(AdCreativePostClickConfiguration, _AbstractCrudObject);

  function AdCreativePostClickConfiguration() {
    classCallCheck(this, AdCreativePostClickConfiguration);
    return possibleConstructorReturn(this, (AdCreativePostClickConfiguration.__proto__ || Object.getPrototypeOf(AdCreativePostClickConfiguration)).apply(this, arguments));
  }

  createClass(AdCreativePostClickConfiguration, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        post_click_item_description: 'post_click_item_description',
        post_click_item_headline: 'post_click_item_headline'
      });
    }
  }]);
  return AdCreativePostClickConfiguration;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeRecommenderSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeRecommenderSettings = function (_AbstractCrudObject) {
  inherits(AdCreativeRecommenderSettings, _AbstractCrudObject);

  function AdCreativeRecommenderSettings() {
    classCallCheck(this, AdCreativeRecommenderSettings);
    return possibleConstructorReturn(this, (AdCreativeRecommenderSettings.__proto__ || Object.getPrototypeOf(AdCreativeRecommenderSettings)).apply(this, arguments));
  }

  createClass(AdCreativeRecommenderSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        preferred_events: 'preferred_events',
        product_sales_channel: 'product_sales_channel'
      });
    }
  }]);
  return AdCreativeRecommenderSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeStaticFallbackSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeStaticFallbackSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeStaticFallbackSpec, _AbstractCrudObject);

  function AdCreativeStaticFallbackSpec() {
    classCallCheck(this, AdCreativeStaticFallbackSpec);
    return possibleConstructorReturn(this, (AdCreativeStaticFallbackSpec.__proto__ || Object.getPrototypeOf(AdCreativeStaticFallbackSpec)).apply(this, arguments));
  }

  createClass(AdCreativeStaticFallbackSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        call_to_action: 'call_to_action',
        description: 'description',
        image_hash: 'image_hash',
        link: 'link',
        message: 'message',
        name: 'name'
      });
    }
  }]);
  return AdCreativeStaticFallbackSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeTemplateURLSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeTemplateURLSpec = function (_AbstractCrudObject) {
  inherits(AdCreativeTemplateURLSpec, _AbstractCrudObject);

  function AdCreativeTemplateURLSpec() {
    classCallCheck(this, AdCreativeTemplateURLSpec);
    return possibleConstructorReturn(this, (AdCreativeTemplateURLSpec.__proto__ || Object.getPrototypeOf(AdCreativeTemplateURLSpec)).apply(this, arguments));
  }

  createClass(AdCreativeTemplateURLSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        android: 'android',
        config: 'config',
        ios: 'ios',
        ipad: 'ipad',
        iphone: 'iphone',
        web: 'web',
        windows_phone: 'windows_phone'
      });
    }
  }]);
  return AdCreativeTemplateURLSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeTextData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeTextData = function (_AbstractCrudObject) {
  inherits(AdCreativeTextData, _AbstractCrudObject);

  function AdCreativeTextData() {
    classCallCheck(this, AdCreativeTextData);
    return possibleConstructorReturn(this, (AdCreativeTextData.__proto__ || Object.getPrototypeOf(AdCreativeTextData)).apply(this, arguments));
  }

  createClass(AdCreativeTextData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        message: 'message'
      });
    }
  }]);
  return AdCreativeTextData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCreativeVideoData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCreativeVideoData = function (_AbstractCrudObject) {
  inherits(AdCreativeVideoData, _AbstractCrudObject);

  function AdCreativeVideoData() {
    classCallCheck(this, AdCreativeVideoData);
    return possibleConstructorReturn(this, (AdCreativeVideoData.__proto__ || Object.getPrototypeOf(AdCreativeVideoData)).apply(this, arguments));
  }

  createClass(AdCreativeVideoData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        additional_image_index: 'additional_image_index',
        branded_content_shared_to_sponsor_status: 'branded_content_shared_to_sponsor_status',
        branded_content_sponsor_page_id: 'branded_content_sponsor_page_id',
        call_to_action: 'call_to_action',
        collection_thumbnails: 'collection_thumbnails',
        customization_rules_spec: 'customization_rules_spec',
        image_hash: 'image_hash',
        image_url: 'image_url',
        link_description: 'link_description',
        message: 'message',
        offer_id: 'offer_id',
        page_welcome_message: 'page_welcome_message',
        post_click_configuration: 'post_click_configuration',
        retailer_item_ids: 'retailer_item_ids',
        targeting: 'targeting',
        title: 'title',
        video_id: 'video_id'
      });
    }
  }]);
  return AdCreativeVideoData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdCustomizationRuleSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdCustomizationRuleSpec = function (_AbstractCrudObject) {
  inherits(AdCustomizationRuleSpec, _AbstractCrudObject);

  function AdCustomizationRuleSpec() {
    classCallCheck(this, AdCustomizationRuleSpec);
    return possibleConstructorReturn(this, (AdCustomizationRuleSpec.__proto__ || Object.getPrototypeOf(AdCustomizationRuleSpec)).apply(this, arguments));
  }

  createClass(AdCustomizationRuleSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        caption: 'caption',
        customization_spec: 'customization_spec',
        description: 'description',
        image_hash: 'image_hash',
        link: 'link',
        message: 'message',
        name: 'name',
        priority: 'priority',
        template_url_spec: 'template_url_spec',
        video_id: 'video_id'
      });
    }
  }]);
  return AdCustomizationRuleSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdDynamicCreative
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdDynamicCreative = function (_AbstractCrudObject) {
  inherits(AdDynamicCreative, _AbstractCrudObject);

  function AdDynamicCreative() {
    classCallCheck(this, AdDynamicCreative);
    return possibleConstructorReturn(this, (AdDynamicCreative.__proto__ || Object.getPrototypeOf(AdDynamicCreative)).apply(this, arguments));
  }

  createClass(AdDynamicCreative, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        preview_url: 'preview_url'
      });
    }
  }]);
  return AdDynamicCreative;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdEntityTargetSpend
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdEntityTargetSpend = function (_AbstractCrudObject) {
  inherits(AdEntityTargetSpend, _AbstractCrudObject);

  function AdEntityTargetSpend() {
    classCallCheck(this, AdEntityTargetSpend);
    return possibleConstructorReturn(this, (AdEntityTargetSpend.__proto__ || Object.getPrototypeOf(AdEntityTargetSpend)).apply(this, arguments));
  }

  createClass(AdEntityTargetSpend, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount: 'amount',
        has_error: 'has_error',
        is_accurate: 'is_accurate',
        is_prorated: 'is_prorated',
        is_updating: 'is_updating'
      });
    }
  }]);
  return AdEntityTargetSpend;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdKeywords
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdKeywords = function (_AbstractCrudObject) {
  inherits(AdKeywords, _AbstractCrudObject);

  function AdKeywords() {
    classCallCheck(this, AdKeywords);
    return possibleConstructorReturn(this, (AdKeywords.__proto__ || Object.getPrototypeOf(AdKeywords)).apply(this, arguments));
  }

  createClass(AdKeywords, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        brands: 'brands',
        product_categories: 'product_categories',
        product_names: 'product_names',
        search_terms: 'search_terms'
      });
    }
  }]);
  return AdKeywords;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdMonetizationProperty
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdMonetizationProperty = function (_AbstractCrudObject) {
  inherits(AdMonetizationProperty, _AbstractCrudObject);

  function AdMonetizationProperty() {
    classCallCheck(this, AdMonetizationProperty);
    return possibleConstructorReturn(this, (AdMonetizationProperty.__proto__ || Object.getPrototypeOf(AdMonetizationProperty)).apply(this, arguments));
  }

  createClass(AdMonetizationProperty, [{
    key: 'getAdNetworkAnalytics',
    value: function getAdNetworkAnalytics(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdNetworkAnalyticsSyncQueryResult, fields, params, fetchFirstPage, '/adnetworkanalytics');
    }
  }, {
    key: 'createAdNetworkAnalytic',
    value: function createAdNetworkAnalytic(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/adnetworkanalytics', fields, params, AdMonetizationProperty, pathOverride);
    }
  }, {
    key: 'getAdNetworkAnalyticsResults',
    value: function getAdNetworkAnalyticsResults(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AdNetworkAnalyticsAsyncQueryResult, fields, params, fetchFirstPage, '/adnetworkanalytics_results');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        owner_business: 'owner_business',
        id: 'id'
      });
    }
  }]);
  return AdMonetizationProperty;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdPlacePageSetMetadata
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdPlacePageSetMetadata = function (_AbstractCrudObject) {
  inherits(AdPlacePageSetMetadata, _AbstractCrudObject);

  function AdPlacePageSetMetadata() {
    classCallCheck(this, AdPlacePageSetMetadata);
    return possibleConstructorReturn(this, (AdPlacePageSetMetadata.__proto__ || Object.getPrototypeOf(AdPlacePageSetMetadata)).apply(this, arguments));
  }

  createClass(AdPlacePageSetMetadata, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        audience: 'audience',
        custom: 'custom',
        extra_data: 'extra_data',
        fixed_radius: 'fixed_radius'
      });
    }
  }]);
  return AdPlacePageSetMetadata;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdPromotedObject
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdPromotedObject = function (_AbstractCrudObject) {
  inherits(AdPromotedObject, _AbstractCrudObject);

  function AdPromotedObject() {
    classCallCheck(this, AdPromotedObject);
    return possibleConstructorReturn(this, (AdPromotedObject.__proto__ || Object.getPrototypeOf(AdPromotedObject)).apply(this, arguments));
  }

  createClass(AdPromotedObject, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        application_id: 'application_id',
        custom_conversion_id: 'custom_conversion_id',
        custom_event_str: 'custom_event_str',
        custom_event_type: 'custom_event_type',
        event_id: 'event_id',
        fundraiser_campaign_id: 'fundraiser_campaign_id',
        mcme_conversion_id: 'mcme_conversion_id',
        object_store_url: 'object_store_url',
        offer_id: 'offer_id',
        offline_conversion_data_set_id: 'offline_conversion_data_set_id',
        omnichannel_object: 'omnichannel_object',
        page_id: 'page_id',
        pixel_aggregation_rule: 'pixel_aggregation_rule',
        pixel_id: 'pixel_id',
        pixel_rule: 'pixel_rule',
        place_page_set_id: 'place_page_set_id',
        product_catalog_id: 'product_catalog_id',
        product_item_id: 'product_item_id',
        product_set_id: 'product_set_id',
        retention_days: 'retention_days'
      });
    }
  }, {
    key: 'CustomEventType',
    get: function get() {
      return Object.freeze({
        achievement_unlocked: 'ACHIEVEMENT_UNLOCKED',
        add_payment_info: 'ADD_PAYMENT_INFO',
        add_to_cart: 'ADD_TO_CART',
        add_to_wishlist: 'ADD_TO_WISHLIST',
        complete_registration: 'COMPLETE_REGISTRATION',
        contact: 'CONTACT',
        content_view: 'CONTENT_VIEW',
        customize_product: 'CUSTOMIZE_PRODUCT',
        d2_retention: 'D2_RETENTION',
        d7_retention: 'D7_RETENTION',
        donate: 'DONATE',
        find_location: 'FIND_LOCATION',
        initiated_checkout: 'INITIATED_CHECKOUT',
        lead: 'LEAD',
        level_achieved: 'LEVEL_ACHIEVED',
        listing_interaction: 'LISTING_INTERACTION',
        messaging_conversation_started_7d: 'MESSAGING_CONVERSATION_STARTED_7D',
        other: 'OTHER',
        purchase: 'PURCHASE',
        rate: 'RATE',
        schedule: 'SCHEDULE',
        search: 'SEARCH',
        service_booking_request: 'SERVICE_BOOKING_REQUEST',
        spent_credits: 'SPENT_CREDITS',
        start_trial: 'START_TRIAL',
        submit_application: 'SUBMIT_APPLICATION',
        subscribe: 'SUBSCRIBE',
        tutorial_completion: 'TUTORIAL_COMPLETION'
      });
    }
  }]);
  return AdPromotedObject;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRecommendation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRecommendation = function (_AbstractCrudObject) {
  inherits(AdRecommendation, _AbstractCrudObject);

  function AdRecommendation() {
    classCallCheck(this, AdRecommendation);
    return possibleConstructorReturn(this, (AdRecommendation.__proto__ || Object.getPrototypeOf(AdRecommendation)).apply(this, arguments));
  }

  createClass(AdRecommendation, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        blame_field: 'blame_field',
        code: 'code',
        confidence: 'confidence',
        importance: 'importance',
        message: 'message',
        recommendation_data: 'recommendation_data',
        title: 'title'
      });
    }
  }, {
    key: 'Confidence',
    get: function get() {
      return Object.freeze({
        high: 'HIGH',
        low: 'LOW',
        medium: 'MEDIUM'
      });
    }
  }, {
    key: 'Importance',
    get: function get() {
      return Object.freeze({
        high: 'HIGH',
        low: 'LOW',
        medium: 'MEDIUM'
      });
    }
  }]);
  return AdRecommendation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRecommendationData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRecommendationData = function (_AbstractCrudObject) {
  inherits(AdRecommendationData, _AbstractCrudObject);

  function AdRecommendationData() {
    classCallCheck(this, AdRecommendationData);
    return possibleConstructorReturn(this, (AdRecommendationData.__proto__ || Object.getPrototypeOf(AdRecommendationData)).apply(this, arguments));
  }

  createClass(AdRecommendationData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        link: 'link'
      });
    }
  }]);
  return AdRecommendationData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleEvaluationSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleEvaluationSpec = function (_AbstractCrudObject) {
  inherits(AdRuleEvaluationSpec, _AbstractCrudObject);

  function AdRuleEvaluationSpec() {
    classCallCheck(this, AdRuleEvaluationSpec);
    return possibleConstructorReturn(this, (AdRuleEvaluationSpec.__proto__ || Object.getPrototypeOf(AdRuleEvaluationSpec)).apply(this, arguments));
  }

  createClass(AdRuleEvaluationSpec, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        evaluation_type: 'evaluation_type',
        filters: 'filters',
        trigger: 'trigger',
        id: 'id'
      });
    }
  }, {
    key: 'EvaluationType',
    get: function get() {
      return Object.freeze({
        schedule: 'SCHEDULE',
        trigger: 'TRIGGER'
      });
    }
  }]);
  return AdRuleEvaluationSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleExecutionOptions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleExecutionOptions = function (_AbstractCrudObject) {
  inherits(AdRuleExecutionOptions, _AbstractCrudObject);

  function AdRuleExecutionOptions() {
    classCallCheck(this, AdRuleExecutionOptions);
    return possibleConstructorReturn(this, (AdRuleExecutionOptions.__proto__ || Object.getPrototypeOf(AdRuleExecutionOptions)).apply(this, arguments));
  }

  createClass(AdRuleExecutionOptions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        field: 'field',
        operator: 'operator',
        value: 'value'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        equal: 'EQUAL',
        in: 'IN'
      });
    }
  }]);
  return AdRuleExecutionOptions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleExecutionSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleExecutionSpec = function (_AbstractCrudObject) {
  inherits(AdRuleExecutionSpec, _AbstractCrudObject);

  function AdRuleExecutionSpec() {
    classCallCheck(this, AdRuleExecutionSpec);
    return possibleConstructorReturn(this, (AdRuleExecutionSpec.__proto__ || Object.getPrototypeOf(AdRuleExecutionSpec)).apply(this, arguments));
  }

  createClass(AdRuleExecutionSpec, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        execution_options: 'execution_options',
        execution_type: 'execution_type',
        id: 'id'
      });
    }
  }, {
    key: 'ExecutionType',
    get: function get() {
      return Object.freeze({
        add_interest_relaxation: 'ADD_INTEREST_RELAXATION',
        add_questionnaire_interests: 'ADD_QUESTIONNAIRE_INTERESTS',
        audience_consolidation: 'AUDIENCE_CONSOLIDATION',
        audience_consolidation_ask_first: 'AUDIENCE_CONSOLIDATION_ASK_FIRST',
        change_bid: 'CHANGE_BID',
        change_budget: 'CHANGE_BUDGET',
        change_campaign_budget: 'CHANGE_CAMPAIGN_BUDGET',
        increase_radius: 'INCREASE_RADIUS',
        notification: 'NOTIFICATION',
        pause: 'PAUSE',
        ping_endpoint: 'PING_ENDPOINT',
        rebalance_budget: 'REBALANCE_BUDGET',
        rotate: 'ROTATE',
        unpause: 'UNPAUSE',
        update_creative: 'UPDATE_CREATIVE',
        update_lax_budget: 'UPDATE_LAX_BUDGET',
        update_lax_duration: 'UPDATE_LAX_DURATION'
      });
    }
  }]);
  return AdRuleExecutionSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleFilters
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleFilters = function (_AbstractCrudObject) {
  inherits(AdRuleFilters, _AbstractCrudObject);

  function AdRuleFilters() {
    classCallCheck(this, AdRuleFilters);
    return possibleConstructorReturn(this, (AdRuleFilters.__proto__ || Object.getPrototypeOf(AdRuleFilters)).apply(this, arguments));
  }

  createClass(AdRuleFilters, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        field: 'field',
        operator: 'operator',
        value: 'value'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        any: 'ANY',
        contain: 'CONTAIN',
        equal: 'EQUAL',
        greater_than: 'GREATER_THAN',
        in: 'IN',
        in_range: 'IN_RANGE',
        less_than: 'LESS_THAN',
        none: 'NONE',
        not_contain: 'NOT_CONTAIN',
        not_equal: 'NOT_EQUAL',
        not_in: 'NOT_IN',
        not_in_range: 'NOT_IN_RANGE'
      });
    }
  }]);
  return AdRuleFilters;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleHistoryResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleHistoryResult = function (_AbstractCrudObject) {
  inherits(AdRuleHistoryResult, _AbstractCrudObject);

  function AdRuleHistoryResult() {
    classCallCheck(this, AdRuleHistoryResult);
    return possibleConstructorReturn(this, (AdRuleHistoryResult.__proto__ || Object.getPrototypeOf(AdRuleHistoryResult)).apply(this, arguments));
  }

  createClass(AdRuleHistoryResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actions: 'actions',
        object_id: 'object_id',
        object_type: 'object_type'
      });
    }
  }, {
    key: 'ObjectType',
    get: function get() {
      return Object.freeze({
        ad: 'AD',
        adset: 'ADSET',
        campaign: 'CAMPAIGN'
      });
    }
  }]);
  return AdRuleHistoryResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleHistoryResultAction
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleHistoryResultAction = function (_AbstractCrudObject) {
  inherits(AdRuleHistoryResultAction, _AbstractCrudObject);

  function AdRuleHistoryResultAction() {
    classCallCheck(this, AdRuleHistoryResultAction);
    return possibleConstructorReturn(this, (AdRuleHistoryResultAction.__proto__ || Object.getPrototypeOf(AdRuleHistoryResultAction)).apply(this, arguments));
  }

  createClass(AdRuleHistoryResultAction, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        action: 'action',
        field: 'field',
        new_value: 'new_value',
        old_value: 'old_value'
      });
    }
  }]);
  return AdRuleHistoryResultAction;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleSchedule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleSchedule = function (_AbstractCrudObject) {
  inherits(AdRuleSchedule, _AbstractCrudObject);

  function AdRuleSchedule() {
    classCallCheck(this, AdRuleSchedule);
    return possibleConstructorReturn(this, (AdRuleSchedule.__proto__ || Object.getPrototypeOf(AdRuleSchedule)).apply(this, arguments));
  }

  createClass(AdRuleSchedule, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        days: 'days',
        end_minute: 'end_minute',
        start_minute: 'start_minute'
      });
    }
  }]);
  return AdRuleSchedule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleScheduleSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleScheduleSpec = function (_AbstractCrudObject) {
  inherits(AdRuleScheduleSpec, _AbstractCrudObject);

  function AdRuleScheduleSpec() {
    classCallCheck(this, AdRuleScheduleSpec);
    return possibleConstructorReturn(this, (AdRuleScheduleSpec.__proto__ || Object.getPrototypeOf(AdRuleScheduleSpec)).apply(this, arguments));
  }

  createClass(AdRuleScheduleSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        schedule: 'schedule',
        schedule_type: 'schedule_type'
      });
    }
  }]);
  return AdRuleScheduleSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdRuleTrigger
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdRuleTrigger = function (_AbstractCrudObject) {
  inherits(AdRuleTrigger, _AbstractCrudObject);

  function AdRuleTrigger() {
    classCallCheck(this, AdRuleTrigger);
    return possibleConstructorReturn(this, (AdRuleTrigger.__proto__ || Object.getPrototypeOf(AdRuleTrigger)).apply(this, arguments));
  }

  createClass(AdRuleTrigger, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        field: 'field',
        operator: 'operator',
        type: 'type',
        value: 'value'
      });
    }
  }, {
    key: 'Operator',
    get: function get() {
      return Object.freeze({
        all: 'ALL',
        any: 'ANY',
        contain: 'CONTAIN',
        equal: 'EQUAL',
        greater_than: 'GREATER_THAN',
        in: 'IN',
        in_range: 'IN_RANGE',
        less_than: 'LESS_THAN',
        none: 'NONE',
        not_contain: 'NOT_CONTAIN',
        not_equal: 'NOT_EQUAL',
        not_in: 'NOT_IN',
        not_in_range: 'NOT_IN_RANGE'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        delivery_insights_change: 'DELIVERY_INSIGHTS_CHANGE',
        metadata_creation: 'METADATA_CREATION',
        metadata_update: 'METADATA_UPDATE',
        stats_change: 'STATS_CHANGE',
        stats_milestone: 'STATS_MILESTONE'
      });
    }
  }]);
  return AdRuleTrigger;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdStudyObjectiveID
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdStudyObjectiveID = function (_AbstractCrudObject) {
  inherits(AdStudyObjectiveID, _AbstractCrudObject);

  function AdStudyObjectiveID() {
    classCallCheck(this, AdStudyObjectiveID);
    return possibleConstructorReturn(this, (AdStudyObjectiveID.__proto__ || Object.getPrototypeOf(AdStudyObjectiveID)).apply(this, arguments));
  }

  createClass(AdStudyObjectiveID, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        event_names: 'event_names',
        id: 'id',
        type: 'type'
      });
    }
  }]);
  return AdStudyObjectiveID;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdStudyObjectiveOffsiteDatasets
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdStudyObjectiveOffsiteDatasets = function (_AbstractCrudObject) {
  inherits(AdStudyObjectiveOffsiteDatasets, _AbstractCrudObject);

  function AdStudyObjectiveOffsiteDatasets() {
    classCallCheck(this, AdStudyObjectiveOffsiteDatasets);
    return possibleConstructorReturn(this, (AdStudyObjectiveOffsiteDatasets.__proto__ || Object.getPrototypeOf(AdStudyObjectiveOffsiteDatasets)).apply(this, arguments));
  }

  createClass(AdStudyObjectiveOffsiteDatasets, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        event_names: 'event_names',
        id: 'id'
      });
    }
  }]);
  return AdStudyObjectiveOffsiteDatasets;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdgroupIssuesInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdgroupIssuesInfo = function (_AbstractCrudObject) {
  inherits(AdgroupIssuesInfo, _AbstractCrudObject);

  function AdgroupIssuesInfo() {
    classCallCheck(this, AdgroupIssuesInfo);
    return possibleConstructorReturn(this, (AdgroupIssuesInfo.__proto__ || Object.getPrototypeOf(AdgroupIssuesInfo)).apply(this, arguments));
  }

  createClass(AdgroupIssuesInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        error_code: 'error_code',
        error_message: 'error_message',
        error_summary: 'error_summary',
        error_type: 'error_type',
        level: 'level'
      });
    }
  }]);
  return AdgroupIssuesInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdgroupMetadata
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdgroupMetadata = function (_AbstractCrudObject) {
  inherits(AdgroupMetadata, _AbstractCrudObject);

  function AdgroupMetadata() {
    classCallCheck(this, AdgroupMetadata);
    return possibleConstructorReturn(this, (AdgroupMetadata.__proto__ || Object.getPrototypeOf(AdgroupMetadata)).apply(this, arguments));
  }

  createClass(AdgroupMetadata, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_standard_enhancements_edit_source: 'ad_standard_enhancements_edit_source',
        adgroup_creation_source: 'adgroup_creation_source',
        adgroup_edit_source: 'adgroup_edit_source',
        carousel_style: 'carousel_style',
        carousel_with_static_card_style: 'carousel_with_static_card_style'
      });
    }
  }]);
  return AdgroupMetadata;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdgroupPlacementSpecificReviewFeedback
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdgroupPlacementSpecificReviewFeedback = function (_AbstractCrudObject) {
  inherits(AdgroupPlacementSpecificReviewFeedback, _AbstractCrudObject);

  function AdgroupPlacementSpecificReviewFeedback() {
    classCallCheck(this, AdgroupPlacementSpecificReviewFeedback);
    return possibleConstructorReturn(this, (AdgroupPlacementSpecificReviewFeedback.__proto__ || Object.getPrototypeOf(AdgroupPlacementSpecificReviewFeedback)).apply(this, arguments));
  }

  createClass(AdgroupPlacementSpecificReviewFeedback, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_admin: 'account_admin',
        ad: 'ad',
        ads_conversion_experiences: 'ads_conversion_experiences',
        b2c: 'b2c',
        b2c_commerce_unified: 'b2c_commerce_unified',
        bsg: 'bsg',
        city_community: 'city_community',
        commerce: 'commerce',
        daily_deals: 'daily_deals',
        daily_deals_legacy: 'daily_deals_legacy',
        dpa: 'dpa',
        dri_copyright: 'dri_copyright',
        dri_counterfeit: 'dri_counterfeit',
        facebook: 'facebook',
        facebook_pages_live_shopping: 'facebook_pages_live_shopping',
        independent_work: 'independent_work',
        instagram: 'instagram',
        instagram_shop: 'instagram_shop',
        job_search: 'job_search',
        lead_gen_honeypot: 'lead_gen_honeypot',
        marketplace: 'marketplace',
        marketplace_home_rentals: 'marketplace_home_rentals',
        marketplace_home_sales: 'marketplace_home_sales',
        marketplace_motors: 'marketplace_motors',
        marketplace_shops: 'marketplace_shops',
        max_review_placements: 'max_review_placements',
        neighborhoods: 'neighborhoods',
        page_admin: 'page_admin',
        product: 'product',
        product_service: 'product_service',
        profile: 'profile',
        seller: 'seller',
        shops: 'shops',
        traffic_quality: 'traffic_quality',
        unified_commerce_content: 'unified_commerce_content',
        whatsapp: 'whatsapp'
      });
    }
  }]);
  return AdgroupPlacementSpecificReviewFeedback;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdgroupReviewFeedback
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdgroupReviewFeedback = function (_AbstractCrudObject) {
  inherits(AdgroupReviewFeedback, _AbstractCrudObject);

  function AdgroupReviewFeedback() {
    classCallCheck(this, AdgroupReviewFeedback);
    return possibleConstructorReturn(this, (AdgroupReviewFeedback.__proto__ || Object.getPrototypeOf(AdgroupReviewFeedback)).apply(this, arguments));
  }

  createClass(AdgroupReviewFeedback, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        global: 'global',
        placement_specific: 'placement_specific'
      });
    }
  }]);
  return AdgroupReviewFeedback;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsActionStats
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsActionStats = function (_AbstractCrudObject) {
  inherits(AdsActionStats, _AbstractCrudObject);

  function AdsActionStats() {
    classCallCheck(this, AdsActionStats);
    return possibleConstructorReturn(this, (AdsActionStats.__proto__ || Object.getPrototypeOf(AdsActionStats)).apply(this, arguments));
  }

  createClass(AdsActionStats, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        value_1d_click: '1d_click',
        value_1d_view: '1d_view',
        value_28d_click: '28d_click',
        value_28d_view: '28d_view',
        value_7d_click: '7d_click',
        value_7d_view: '7d_view',
        action_brand: 'action_brand',
        action_canvas_component_id: 'action_canvas_component_id',
        action_canvas_component_name: 'action_canvas_component_name',
        action_carousel_card_id: 'action_carousel_card_id',
        action_carousel_card_name: 'action_carousel_card_name',
        action_category: 'action_category',
        action_converted_product_id: 'action_converted_product_id',
        action_destination: 'action_destination',
        action_device: 'action_device',
        action_event_channel: 'action_event_channel',
        action_link_click_destination: 'action_link_click_destination',
        action_location_code: 'action_location_code',
        action_reaction: 'action_reaction',
        action_target_id: 'action_target_id',
        action_type: 'action_type',
        action_video_asset_id: 'action_video_asset_id',
        action_video_sound: 'action_video_sound',
        action_video_type: 'action_video_type',
        dda: 'dda',
        inline: 'inline',
        interactive_component_sticker_id: 'interactive_component_sticker_id',
        interactive_component_sticker_response: 'interactive_component_sticker_response',
        skan_click: 'skan_click',
        skan_view: 'skan_view',
        value: 'value'
      });
    }
  }]);
  return AdsActionStats;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsImageCrops
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsImageCrops = function (_AbstractCrudObject) {
  inherits(AdsImageCrops, _AbstractCrudObject);

  function AdsImageCrops() {
    classCallCheck(this, AdsImageCrops);
    return possibleConstructorReturn(this, (AdsImageCrops.__proto__ || Object.getPrototypeOf(AdsImageCrops)).apply(this, arguments));
  }

  createClass(AdsImageCrops, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        value_100x100: '100x100',
        value_100x72: '100x72',
        value_191x100: '191x100',
        value_400x150: '400x150',
        value_400x500: '400x500',
        value_600x360: '600x360',
        value_90x160: '90x160'
      });
    }
  }]);
  return AdsImageCrops;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsOptimalDeliveryGrowthOpportunity
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsOptimalDeliveryGrowthOpportunity = function (_AbstractCrudObject) {
  inherits(AdsOptimalDeliveryGrowthOpportunity, _AbstractCrudObject);

  function AdsOptimalDeliveryGrowthOpportunity() {
    classCallCheck(this, AdsOptimalDeliveryGrowthOpportunity);
    return possibleConstructorReturn(this, (AdsOptimalDeliveryGrowthOpportunity.__proto__ || Object.getPrototypeOf(AdsOptimalDeliveryGrowthOpportunity)).apply(this, arguments));
  }

  createClass(AdsOptimalDeliveryGrowthOpportunity, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        child_metadata: 'child_metadata',
        metadata: 'metadata',
        optimization_type: 'optimization_type'
      });
    }
  }]);
  return AdsOptimalDeliveryGrowthOpportunity;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AdsPixelStats
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AdsPixelStats = function (_AbstractCrudObject) {
  inherits(AdsPixelStats, _AbstractCrudObject);

  function AdsPixelStats() {
    classCallCheck(this, AdsPixelStats);
    return possibleConstructorReturn(this, (AdsPixelStats.__proto__ || Object.getPrototypeOf(AdsPixelStats)).apply(this, arguments));
  }

  createClass(AdsPixelStats, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        count: 'count',
        diagnostics_hourly_last_timestamp: 'diagnostics_hourly_last_timestamp',
        event: 'event',
        value: 'value'
      });
    }
  }]);
  return AdsPixelStats;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AgeRange
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AgeRange = function (_AbstractCrudObject) {
  inherits(AgeRange, _AbstractCrudObject);

  function AgeRange() {
    classCallCheck(this, AgeRange);
    return possibleConstructorReturn(this, (AgeRange.__proto__ || Object.getPrototypeOf(AgeRange)).apply(this, arguments));
  }

  createClass(AgeRange, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        max: 'max',
        min: 'min'
      });
    }
  }]);
  return AgeRange;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AgencyClientDeclaration
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AgencyClientDeclaration = function (_AbstractCrudObject) {
  inherits(AgencyClientDeclaration, _AbstractCrudObject);

  function AgencyClientDeclaration() {
    classCallCheck(this, AgencyClientDeclaration);
    return possibleConstructorReturn(this, (AgencyClientDeclaration.__proto__ || Object.getPrototypeOf(AgencyClientDeclaration)).apply(this, arguments));
  }

  createClass(AgencyClientDeclaration, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        agency_representing_client: 'agency_representing_client',
        client_based_in_france: 'client_based_in_france',
        client_city: 'client_city',
        client_country_code: 'client_country_code',
        client_email_address: 'client_email_address',
        client_name: 'client_name',
        client_postal_code: 'client_postal_code',
        client_province: 'client_province',
        client_street: 'client_street',
        client_street2: 'client_street2',
        has_written_mandate_from_advertiser: 'has_written_mandate_from_advertiser',
        is_client_paying_invoices: 'is_client_paying_invoices'
      });
    }
  }]);
  return AgencyClientDeclaration;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AndroidAppLink
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AndroidAppLink = function (_AbstractCrudObject) {
  inherits(AndroidAppLink, _AbstractCrudObject);

  function AndroidAppLink() {
    classCallCheck(this, AndroidAppLink);
    return possibleConstructorReturn(this, (AndroidAppLink.__proto__ || Object.getPrototypeOf(AndroidAppLink)).apply(this, arguments));
  }

  createClass(AndroidAppLink, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_name: 'app_name',
        class: 'class',
        package: 'package',
        url: 'url'
      });
    }
  }]);
  return AndroidAppLink;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AsyncSession
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AsyncSession = function (_AbstractCrudObject) {
  inherits(AsyncSession, _AbstractCrudObject);

  function AsyncSession() {
    classCallCheck(this, AsyncSession);
    return possibleConstructorReturn(this, (AsyncSession.__proto__ || Object.getPrototypeOf(AsyncSession)).apply(this, arguments));
  }

  createClass(AsyncSession, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app: 'app',
        complete_time: 'complete_time',
        error_code: 'error_code',
        exception: 'exception',
        id: 'id',
        method: 'method',
        name: 'name',
        page: 'page',
        percent_completed: 'percent_completed',
        platform_version: 'platform_version',
        result: 'result',
        start_time: 'start_time',
        status: 'status',
        uri: 'uri',
        user: 'user'
      });
    }
  }]);
  return AsyncSession;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AttributionSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AttributionSpec = function (_AbstractCrudObject) {
  inherits(AttributionSpec, _AbstractCrudObject);

  function AttributionSpec() {
    classCallCheck(this, AttributionSpec);
    return possibleConstructorReturn(this, (AttributionSpec.__proto__ || Object.getPrototypeOf(AttributionSpec)).apply(this, arguments));
  }

  createClass(AttributionSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        event_type: 'event_type',
        window_days: 'window_days'
      });
    }
  }]);
  return AttributionSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AudiencePermissionForActions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AudiencePermissionForActions = function (_AbstractCrudObject) {
  inherits(AudiencePermissionForActions, _AbstractCrudObject);

  function AudiencePermissionForActions() {
    classCallCheck(this, AudiencePermissionForActions);
    return possibleConstructorReturn(this, (AudiencePermissionForActions.__proto__ || Object.getPrototypeOf(AudiencePermissionForActions)).apply(this, arguments));
  }

  createClass(AudiencePermissionForActions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        can_edit: 'can_edit',
        can_see_insight: 'can_see_insight',
        can_share: 'can_share',
        subtype_supports_lookalike: 'subtype_supports_lookalike',
        supports_recipient_lookalike: 'supports_recipient_lookalike'
      });
    }
  }]);
  return AudiencePermissionForActions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * AudioCopyright
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var AudioCopyright = function (_AbstractCrudObject) {
  inherits(AudioCopyright, _AbstractCrudObject);

  function AudioCopyright() {
    classCallCheck(this, AudioCopyright);
    return possibleConstructorReturn(this, (AudioCopyright.__proto__ || Object.getPrototypeOf(AudioCopyright)).apply(this, arguments));
  }

  createClass(AudioCopyright, [{
    key: 'getUpdateRecords',
    value: function getUpdateRecords(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/update_records');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_time: 'creation_time',
        displayed_matches_count: 'displayed_matches_count',
        id: 'id',
        in_conflict: 'in_conflict',
        isrc: 'isrc',
        match_rule: 'match_rule',
        ownership_countries: 'ownership_countries',
        reference_file_status: 'reference_file_status',
        ridge_monitoring_status: 'ridge_monitoring_status',
        tags: 'tags',
        update_time: 'update_time',
        whitelisted_fb_users: 'whitelisted_fb_users',
        whitelisted_ig_users: 'whitelisted_ig_users'
      });
    }
  }]);
  return AudioCopyright;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BrandSafetyBlockListUsage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BrandSafetyBlockListUsage = function (_AbstractCrudObject) {
  inherits(BrandSafetyBlockListUsage, _AbstractCrudObject);

  function BrandSafetyBlockListUsage() {
    classCallCheck(this, BrandSafetyBlockListUsage);
    return possibleConstructorReturn(this, (BrandSafetyBlockListUsage.__proto__ || Object.getPrototypeOf(BrandSafetyBlockListUsage)).apply(this, arguments));
  }

  createClass(BrandSafetyBlockListUsage, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        current_usage: 'current_usage',
        new_usage: 'new_usage',
        platform: 'platform',
        position: 'position',
        threshold: 'threshold'
      });
    }
  }]);
  return BrandSafetyBlockListUsage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessImage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessImage = function (_AbstractCrudObject) {
  inherits(BusinessImage, _AbstractCrudObject);

  function BusinessImage() {
    classCallCheck(this, BusinessImage);
    return possibleConstructorReturn(this, (BusinessImage.__proto__ || Object.getPrototypeOf(BusinessImage)).apply(this, arguments));
  }

  createClass(BusinessImage, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business: 'business',
        creation_time: 'creation_time',
        hash: 'hash',
        height: 'height',
        id: 'id',
        media_library_url: 'media_library_url',
        name: 'name',
        url: 'url',
        url_128: 'url_128',
        width: 'width'
      });
    }
  }]);
  return BusinessImage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessManagedPartnerEligibility
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessManagedPartnerEligibility = function (_AbstractCrudObject) {
  inherits(BusinessManagedPartnerEligibility, _AbstractCrudObject);

  function BusinessManagedPartnerEligibility() {
    classCallCheck(this, BusinessManagedPartnerEligibility);
    return possibleConstructorReturn(this, (BusinessManagedPartnerEligibility.__proto__ || Object.getPrototypeOf(BusinessManagedPartnerEligibility)).apply(this, arguments));
  }

  createClass(BusinessManagedPartnerEligibility, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        is_eligible: 'is_eligible',
        reason_code: 'reason_code',
        reason_description: 'reason_description'
      });
    }
  }]);
  return BusinessManagedPartnerEligibility;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * BusinessPartnerPremiumOptions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var BusinessPartnerPremiumOptions = function (_AbstractCrudObject) {
  inherits(BusinessPartnerPremiumOptions, _AbstractCrudObject);

  function BusinessPartnerPremiumOptions() {
    classCallCheck(this, BusinessPartnerPremiumOptions);
    return possibleConstructorReturn(this, (BusinessPartnerPremiumOptions.__proto__ || Object.getPrototypeOf(BusinessPartnerPremiumOptions)).apply(this, arguments));
  }

  createClass(BusinessPartnerPremiumOptions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        enable_basket_insight: 'enable_basket_insight',
        enable_extended_audience_retargeting: 'enable_extended_audience_retargeting',
        retailer_custom_audience_config: 'retailer_custom_audience_config'
      });
    }
  }]);
  return BusinessPartnerPremiumOptions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CRMAddress
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CRMAddress = function (_AbstractCrudObject) {
  inherits(CRMAddress, _AbstractCrudObject);

  function CRMAddress() {
    classCallCheck(this, CRMAddress);
    return possibleConstructorReturn(this, (CRMAddress.__proto__ || Object.getPrototypeOf(CRMAddress)).apply(this, arguments));
  }

  createClass(CRMAddress, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        city: 'city',
        cnpj_tax_id: 'cnpj_tax_id',
        country: 'country',
        id: 'id',
        postal_code: 'postal_code',
        registration_label: 'registration_label',
        registration_number: 'registration_number',
        state: 'state',
        street1: 'street1',
        street2: 'street2',
        street3: 'street3',
        street4: 'street4',
        validation_status: 'validation_status',
        vat_tax_id: 'vat_tax_id'
      });
    }
  }]);
  return CRMAddress;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CampaignGroupBrandConfiguration
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CampaignGroupBrandConfiguration = function (_AbstractCrudObject) {
  inherits(CampaignGroupBrandConfiguration, _AbstractCrudObject);

  function CampaignGroupBrandConfiguration() {
    classCallCheck(this, CampaignGroupBrandConfiguration);
    return possibleConstructorReturn(this, (CampaignGroupBrandConfiguration.__proto__ || Object.getPrototypeOf(CampaignGroupBrandConfiguration)).apply(this, arguments));
  }

  createClass(CampaignGroupBrandConfiguration, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        brand_product_name: 'brand_product_name',
        locale: 'locale',
        vertical: 'vertical'
      });
    }
  }]);
  return CampaignGroupBrandConfiguration;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CampaignGroupCollaborativeAdsPartnerInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CampaignGroupCollaborativeAdsPartnerInfo = function (_AbstractCrudObject) {
  inherits(CampaignGroupCollaborativeAdsPartnerInfo, _AbstractCrudObject);

  function CampaignGroupCollaborativeAdsPartnerInfo() {
    classCallCheck(this, CampaignGroupCollaborativeAdsPartnerInfo);
    return possibleConstructorReturn(this, (CampaignGroupCollaborativeAdsPartnerInfo.__proto__ || Object.getPrototypeOf(CampaignGroupCollaborativeAdsPartnerInfo)).apply(this, arguments));
  }

  createClass(CampaignGroupCollaborativeAdsPartnerInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({});
    }
  }]);
  return CampaignGroupCollaborativeAdsPartnerInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CanvasAdSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CanvasAdSettings = function (_AbstractCrudObject) {
  inherits(CanvasAdSettings, _AbstractCrudObject);

  function CanvasAdSettings() {
    classCallCheck(this, CanvasAdSettings);
    return possibleConstructorReturn(this, (CanvasAdSettings.__proto__ || Object.getPrototypeOf(CanvasAdSettings)).apply(this, arguments));
  }

  createClass(CanvasAdSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        is_canvas_collection_eligible: 'is_canvas_collection_eligible',
        lead_form_created_time: 'lead_form_created_time',
        lead_form_name: 'lead_form_name',
        lead_gen_form_id: 'lead_gen_form_id',
        leads_count: 'leads_count',
        product_set_id: 'product_set_id',
        use_retailer_item_ids: 'use_retailer_item_ids'
      });
    }
  }]);
  return CanvasAdSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CanvasCollectionThumbnail
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CanvasCollectionThumbnail = function (_AbstractCrudObject) {
  inherits(CanvasCollectionThumbnail, _AbstractCrudObject);

  function CanvasCollectionThumbnail() {
    classCallCheck(this, CanvasCollectionThumbnail);
    return possibleConstructorReturn(this, (CanvasCollectionThumbnail.__proto__ || Object.getPrototypeOf(CanvasCollectionThumbnail)).apply(this, arguments));
  }

  createClass(CanvasCollectionThumbnail, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        element_child_index: 'element_child_index',
        element_id: 'element_id',
        photo: 'photo'
      });
    }
  }]);
  return CanvasCollectionThumbnail;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CanvasDynamicSetting
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CanvasDynamicSetting = function (_AbstractCrudObject) {
  inherits(CanvasDynamicSetting, _AbstractCrudObject);

  function CanvasDynamicSetting() {
    classCallCheck(this, CanvasDynamicSetting);
    return possibleConstructorReturn(this, (CanvasDynamicSetting.__proto__ || Object.getPrototypeOf(CanvasDynamicSetting)).apply(this, arguments));
  }

  createClass(CanvasDynamicSetting, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        child_documents: 'child_documents',
        product_set_id: 'product_set_id',
        id: 'id'
      });
    }
  }]);
  return CanvasDynamicSetting;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CatalogBasedTargeting
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CatalogBasedTargeting = function (_AbstractCrudObject) {
  inherits(CatalogBasedTargeting, _AbstractCrudObject);

  function CatalogBasedTargeting() {
    classCallCheck(this, CatalogBasedTargeting);
    return possibleConstructorReturn(this, (CatalogBasedTargeting.__proto__ || Object.getPrototypeOf(CatalogBasedTargeting)).apply(this, arguments));
  }

  createClass(CatalogBasedTargeting, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        geo_targeting_type: 'geo_targeting_type'
      });
    }
  }]);
  return CatalogBasedTargeting;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CatalogItemAppLinks
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CatalogItemAppLinks = function (_AbstractCrudObject) {
  inherits(CatalogItemAppLinks, _AbstractCrudObject);

  function CatalogItemAppLinks() {
    classCallCheck(this, CatalogItemAppLinks);
    return possibleConstructorReturn(this, (CatalogItemAppLinks.__proto__ || Object.getPrototypeOf(CatalogItemAppLinks)).apply(this, arguments));
  }

  createClass(CatalogItemAppLinks, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        android: 'android',
        ios: 'ios',
        ipad: 'ipad',
        iphone: 'iphone',
        web: 'web',
        windows: 'windows',
        windows_phone: 'windows_phone',
        windows_universal: 'windows_universal'
      });
    }
  }]);
  return CatalogItemAppLinks;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CatalogItemAppealStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CatalogItemAppealStatus = function (_AbstractCrudObject) {
  inherits(CatalogItemAppealStatus, _AbstractCrudObject);

  function CatalogItemAppealStatus() {
    classCallCheck(this, CatalogItemAppealStatus);
    return possibleConstructorReturn(this, (CatalogItemAppealStatus.__proto__ || Object.getPrototypeOf(CatalogItemAppealStatus)).apply(this, arguments));
  }

  createClass(CatalogItemAppealStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        handle: 'handle',
        item_id: 'item_id',
        status: 'status',
        use_cases: 'use_cases'
      });
    }
  }]);
  return CatalogItemAppealStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CatalogSubVerticalList
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CatalogSubVerticalList = function (_AbstractCrudObject) {
  inherits(CatalogSubVerticalList, _AbstractCrudObject);

  function CatalogSubVerticalList() {
    classCallCheck(this, CatalogSubVerticalList);
    return possibleConstructorReturn(this, (CatalogSubVerticalList.__proto__ || Object.getPrototypeOf(CatalogSubVerticalList)).apply(this, arguments));
  }

  createClass(CatalogSubVerticalList, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        appliances: 'appliances',
        baby_feeding: 'baby_feeding',
        baby_transport: 'baby_transport',
        beauty: 'beauty',
        bedding: 'bedding',
        cameras: 'cameras',
        cameras_and_photos: 'cameras_and_photos',
        cell_phones_and_smart_watches: 'cell_phones_and_smart_watches',
        cleaning_supplies: 'cleaning_supplies',
        clo_offer: 'clo_offer',
        clothing: 'clothing',
        clothing_accessories: 'clothing_accessories',
        computer_components: 'computer_components',
        computers_and_tablets: 'computers_and_tablets',
        computers_laptops_and_tablets: 'computers_laptops_and_tablets',
        diapering_and_potty_training: 'diapering_and_potty_training',
        digital_product_offer: 'digital_product_offer',
        electronic_accessories_and_cables: 'electronic_accessories_and_cables',
        electronics_accessories: 'electronics_accessories',
        furniture: 'furniture',
        health: 'health',
        home: 'home',
        home_goods: 'home_goods',
        household_and_cleaning_supplies: 'household_and_cleaning_supplies',
        jewelry: 'jewelry',
        large_appliances: 'large_appliances',
        local_service_business_item: 'local_service_business_item',
        local_service_business_restaurant: 'local_service_business_restaurant',
        loyalty_offer: 'loyalty_offer',
        meetup_space: 'meetup_space',
        nursery: 'nursery',
        printers_and_scanners: 'printers_and_scanners',
        printers_scanners_and_fax_machines: 'printers_scanners_and_fax_machines',
        product_discount: 'product_discount',
        projectors: 'projectors',
        shoes: 'shoes',
        shoes_and_footwear: 'shoes_and_footwear',
        software: 'software',
        televisions_and_monitors: 'televisions_and_monitors',
        test_child_sub_vertical: 'test_child_sub_vertical',
        test_grand_child_sub_vertical: 'test_grand_child_sub_vertical',
        test_sub_vertical: 'test_sub_vertical',
        test_sub_vertical_alias: 'test_sub_vertical_alias',
        test_sub_vertical_data_object: 'test_sub_vertical_data_object',
        third_party_electronics: 'third_party_electronics',
        third_party_toys_and_games: 'third_party_toys_and_games',
        toys: 'toys',
        toys_and_games: 'toys_and_games',
        tvs_and_monitors: 'tvs_and_monitors',
        vehicle_manufacturer: 'vehicle_manufacturer',
        video_game_consoles_and_video_games: 'video_game_consoles_and_video_games',
        video_games_and_consoles: 'video_games_and_consoles',
        video_projectors: 'video_projectors',
        watches: 'watches'
      });
    }
  }]);
  return CatalogSubVerticalList;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ChildEvent
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ChildEvent = function (_AbstractCrudObject) {
  inherits(ChildEvent, _AbstractCrudObject);

  function ChildEvent() {
    classCallCheck(this, ChildEvent);
    return possibleConstructorReturn(this, (ChildEvent.__proto__ || Object.getPrototypeOf(ChildEvent)).apply(this, arguments));
  }

  createClass(ChildEvent, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        end_time: 'end_time',
        id: 'id',
        start_time: 'start_time',
        ticket_uri: 'ticket_uri'
      });
    }
  }]);
  return ChildEvent;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CollaborativeAdsPartnerInfoListItem
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CollaborativeAdsPartnerInfoListItem = function (_AbstractCrudObject) {
  inherits(CollaborativeAdsPartnerInfoListItem, _AbstractCrudObject);

  function CollaborativeAdsPartnerInfoListItem() {
    classCallCheck(this, CollaborativeAdsPartnerInfoListItem);
    return possibleConstructorReturn(this, (CollaborativeAdsPartnerInfoListItem.__proto__ || Object.getPrototypeOf(CollaborativeAdsPartnerInfoListItem)).apply(this, arguments));
  }

  createClass(CollaborativeAdsPartnerInfoListItem, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({});
    }
  }]);
  return CollaborativeAdsPartnerInfoListItem;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommerceMerchantTOSAcceptance
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommerceMerchantTOSAcceptance = function (_AbstractCrudObject) {
  inherits(CommerceMerchantTOSAcceptance, _AbstractCrudObject);

  function CommerceMerchantTOSAcceptance() {
    classCallCheck(this, CommerceMerchantTOSAcceptance);
    return possibleConstructorReturn(this, (CommerceMerchantTOSAcceptance.__proto__ || Object.getPrototypeOf(CommerceMerchantTOSAcceptance)).apply(this, arguments));
  }

  createClass(CommerceMerchantTOSAcceptance, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        business: 'business',
        id: 'id'
      });
    }
  }]);
  return CommerceMerchantTOSAcceptance;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CommerceSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CommerceSettings = function (_AbstractCrudObject) {
  inherits(CommerceSettings, _AbstractCrudObject);

  function CommerceSettings() {
    classCallCheck(this, CommerceSettings);
    return possibleConstructorReturn(this, (CommerceSettings.__proto__ || Object.getPrototypeOf(CommerceSettings)).apply(this, arguments));
  }

  createClass(CommerceSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        inventory: 'inventory',
        total_inventory: 'total_inventory'
      });
    }
  }]);
  return CommerceSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ConnectionsTargeting
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ConnectionsTargeting = function (_AbstractCrudObject) {
  inherits(ConnectionsTargeting, _AbstractCrudObject);

  function ConnectionsTargeting() {
    classCallCheck(this, ConnectionsTargeting);
    return possibleConstructorReturn(this, (ConnectionsTargeting.__proto__ || Object.getPrototypeOf(ConnectionsTargeting)).apply(this, arguments));
  }

  createClass(ConnectionsTargeting, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name'
      });
    }
  }]);
  return ConnectionsTargeting;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ContextualBundlingSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ContextualBundlingSpec = function (_AbstractCrudObject) {
  inherits(ContextualBundlingSpec, _AbstractCrudObject);

  function ContextualBundlingSpec() {
    classCallCheck(this, ContextualBundlingSpec);
    return possibleConstructorReturn(this, (ContextualBundlingSpec.__proto__ || Object.getPrototypeOf(ContextualBundlingSpec)).apply(this, arguments));
  }

  createClass(ContextualBundlingSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        status: 'status'
      });
    }
  }]);
  return ContextualBundlingSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ConversionActionQuery
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ConversionActionQuery = function (_AbstractCrudObject) {
  inherits(ConversionActionQuery, _AbstractCrudObject);

  function ConversionActionQuery() {
    classCallCheck(this, ConversionActionQuery);
    return possibleConstructorReturn(this, (ConversionActionQuery.__proto__ || Object.getPrototypeOf(ConversionActionQuery)).apply(this, arguments));
  }

  createClass(ConversionActionQuery, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        action_type: 'action.type',
        application: 'application',
        conversion_id: 'conversion_id',
        creative: 'creative',
        dataset: 'dataset',
        event: 'event',
        event_creator: 'event.creator',
        event_type: 'event_type',
        fb_pixel: 'fb_pixel',
        fb_pixel_event: 'fb_pixel_event',
        leadgen: 'leadgen',
        object: 'object',
        object_domain: 'object.domain',
        offer: 'offer',
        offer_creator: 'offer.creator',
        offsite_pixel: 'offsite_pixel',
        page: 'page',
        page_parent: 'page.parent',
        post: 'post',
        post_object: 'post.object',
        post_object_wall: 'post.object.wall',
        post_wall: 'post.wall',
        question: 'question',
        question_creator: 'question.creator',
        response: 'response',
        subtype: 'subtype'
      });
    }
  }]);
  return ConversionActionQuery;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CopyrightReferenceContainer
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CopyrightReferenceContainer = function (_AbstractCrudObject) {
  inherits(CopyrightReferenceContainer, _AbstractCrudObject);

  function CopyrightReferenceContainer() {
    classCallCheck(this, CopyrightReferenceContainer);
    return possibleConstructorReturn(this, (CopyrightReferenceContainer.__proto__ || Object.getPrototypeOf(CopyrightReferenceContainer)).apply(this, arguments));
  }

  createClass(CopyrightReferenceContainer, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        content_type: 'content_type',
        copyright_creation_time: 'copyright_creation_time',
        download_hd_url: 'download_hd_url',
        duration_in_sec: 'duration_in_sec',
        id: 'id',
        iswc: 'iswc',
        metadata: 'metadata',
        published_time: 'published_time',
        thumbnail_url: 'thumbnail_url',
        title: 'title',
        universal_content_id: 'universal_content_id',
        writer_names: 'writer_names'
      });
    }
  }]);
  return CopyrightReferenceContainer;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CoverPhoto
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CoverPhoto = function (_AbstractCrudObject) {
  inherits(CoverPhoto, _AbstractCrudObject);

  function CoverPhoto() {
    classCallCheck(this, CoverPhoto);
    return possibleConstructorReturn(this, (CoverPhoto.__proto__ || Object.getPrototypeOf(CoverPhoto)).apply(this, arguments));
  }

  createClass(CoverPhoto, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        cover_id: 'cover_id',
        id: 'id',
        offset_x: 'offset_x',
        offset_y: 'offset_y',
        source: 'source'
      });
    }
  }]);
  return CoverPhoto;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CreativeHistory
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CreativeHistory = function (_AbstractCrudObject) {
  inherits(CreativeHistory, _AbstractCrudObject);

  function CreativeHistory() {
    classCallCheck(this, CreativeHistory);
    return possibleConstructorReturn(this, (CreativeHistory.__proto__ || Object.getPrototypeOf(CreativeHistory)).apply(this, arguments));
  }

  createClass(CreativeHistory, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creative_fingerprint: 'creative_fingerprint',
        time_ranges: 'time_ranges'
      });
    }
  }]);
  return CreativeHistory;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CreditPartitionActionOptions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CreditPartitionActionOptions = function (_AbstractCrudObject) {
  inherits(CreditPartitionActionOptions, _AbstractCrudObject);

  function CreditPartitionActionOptions() {
    classCallCheck(this, CreditPartitionActionOptions);
    return possibleConstructorReturn(this, (CreditPartitionActionOptions.__proto__ || Object.getPrototypeOf(CreditPartitionActionOptions)).apply(this, arguments));
  }

  createClass(CreditPartitionActionOptions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        liability_type: 'liability_type',
        partition_type: 'partition_type',
        send_bill_to: 'send_bill_to'
      });
    }
  }]);
  return CreditPartitionActionOptions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Currency
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Currency = function (_AbstractCrudObject) {
  inherits(Currency, _AbstractCrudObject);

  function Currency() {
    classCallCheck(this, Currency);
    return possibleConstructorReturn(this, (Currency.__proto__ || Object.getPrototypeOf(Currency)).apply(this, arguments));
  }

  createClass(Currency, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        currency_offset: 'currency_offset',
        usd_exchange: 'usd_exchange',
        usd_exchange_inverse: 'usd_exchange_inverse',
        user_currency: 'user_currency'
      });
    }
  }]);
  return Currency;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CurrencyAmount
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CurrencyAmount = function (_AbstractCrudObject) {
  inherits(CurrencyAmount, _AbstractCrudObject);

  function CurrencyAmount() {
    classCallCheck(this, CurrencyAmount);
    return possibleConstructorReturn(this, (CurrencyAmount.__proto__ || Object.getPrototypeOf(CurrencyAmount)).apply(this, arguments));
  }

  createClass(CurrencyAmount, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount: 'amount',
        amount_in_hundredths: 'amount_in_hundredths',
        currency: 'currency',
        offsetted_amount: 'offsetted_amount'
      });
    }
  }]);
  return CurrencyAmount;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudienceAdAccount
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudienceAdAccount = function (_AbstractCrudObject) {
  inherits(CustomAudienceAdAccount, _AbstractCrudObject);

  function CustomAudienceAdAccount() {
    classCallCheck(this, CustomAudienceAdAccount);
    return possibleConstructorReturn(this, (CustomAudienceAdAccount.__proto__ || Object.getPrototypeOf(CustomAudienceAdAccount)).apply(this, arguments));
  }

  createClass(CustomAudienceAdAccount, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id'
      });
    }
  }]);
  return CustomAudienceAdAccount;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudienceDataSource
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudienceDataSource = function (_AbstractCrudObject) {
  inherits(CustomAudienceDataSource, _AbstractCrudObject);

  function CustomAudienceDataSource() {
    classCallCheck(this, CustomAudienceDataSource);
    return possibleConstructorReturn(this, (CustomAudienceDataSource.__proto__ || Object.getPrototypeOf(CustomAudienceDataSource)).apply(this, arguments));
  }

  createClass(CustomAudienceDataSource, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_params: 'creation_params',
        sub_type: 'sub_type',
        type: 'type'
      });
    }
  }, {
    key: 'SubType',
    get: function get() {
      return Object.freeze({
        anything: 'ANYTHING',
        app_users: 'APP_USERS',
        ar_experience_events: 'AR_EXPERIENCE_EVENTS',
        campaign_conversions: 'CAMPAIGN_CONVERSIONS',
        combination_custom_audience_users: 'COMBINATION_CUSTOM_AUDIENCE_USERS',
        constant_contacts_email_hashes: 'CONSTANT_CONTACTS_EMAIL_HASHES',
        contact_importer: 'CONTACT_IMPORTER',
        conversion_pixel_hits: 'CONVERSION_PIXEL_HITS',
        copy_paste_email_hashes: 'COPY_PASTE_EMAIL_HASHES',
        custom_audience_users: 'CUSTOM_AUDIENCE_USERS',
        custom_data_targeting: 'CUSTOM_DATA_TARGETING',
        data_file: 'DATA_FILE',
        dynamic_rule: 'DYNAMIC_RULE',
        engagement_event_users: 'ENGAGEMENT_EVENT_USERS',
        expanded_audience: 'EXPANDED_AUDIENCE',
        external_ids: 'EXTERNAL_IDS',
        external_ids_mix: 'EXTERNAL_IDS_MIX',
        facebook_wifi_events: 'FACEBOOK_WIFI_EVENTS',
        fb_event_signals: 'FB_EVENT_SIGNALS',
        fb_pixel_hits: 'FB_PIXEL_HITS',
        hashes: 'HASHES',
        hashes_or_user_ids: 'HASHES_OR_USER_IDS',
        household_expansion: 'HOUSEHOLD_EXPANSION',
        ig_business_events: 'IG_BUSINESS_EVENTS',
        ig_promoted_post: 'IG_PROMOTED_POST',
        instant_article_events: 'INSTANT_ARTICLE_EVENTS',
        lookalike_platform: 'LOOKALIKE_PLATFORM',
        mail_chimp_email_hashes: 'MAIL_CHIMP_EMAIL_HASHES',
        mobile_advertiser_ids: 'MOBILE_ADVERTISER_IDS',
        mobile_app_combination_events: 'MOBILE_APP_COMBINATION_EVENTS',
        mobile_app_custom_audience_users: 'MOBILE_APP_CUSTOM_AUDIENCE_USERS',
        mobile_app_events: 'MOBILE_APP_EVENTS',
        multicountry_combination: 'MULTICOUNTRY_COMBINATION',
        multi_data_events: 'MULTI_DATA_EVENTS',
        multi_event_source: 'MULTI_EVENT_SOURCE',
        multi_hashes: 'MULTI_HASHES',
        nothing: 'NOTHING',
        offline_event_users: 'OFFLINE_EVENT_USERS',
        page_fans: 'PAGE_FANS',
        page_smart_audience: 'PAGE_SMART_AUDIENCE',
        partner_category_users: 'PARTNER_CATEGORY_USERS',
        place_visits: 'PLACE_VISITS',
        platform: 'PLATFORM',
        platform_users: 'PLATFORM_USERS',
        seed_list: 'SEED_LIST',
        signal_source: 'SIGNAL_SOURCE',
        smart_audience: 'SMART_AUDIENCE',
        store_visit_events: 'STORE_VISIT_EVENTS',
        s_expr: 'S_EXPR',
        tokens: 'TOKENS',
        user_ids: 'USER_IDS',
        video_events: 'VIDEO_EVENTS',
        video_event_users: 'VIDEO_EVENT_USERS',
        web_pixel_combination_events: 'WEB_PIXEL_COMBINATION_EVENTS',
        web_pixel_hits: 'WEB_PIXEL_HITS',
        web_pixel_hits_custom_audience_users: 'WEB_PIXEL_HITS_CUSTOM_AUDIENCE_USERS'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        contact_importer: 'CONTACT_IMPORTER',
        copy_paste: 'COPY_PASTE',
        event_based: 'EVENT_BASED',
        file_imported: 'FILE_IMPORTED',
        household_audience: 'HOUSEHOLD_AUDIENCE',
        seed_based: 'SEED_BASED',
        third_party_imported: 'THIRD_PARTY_IMPORTED',
        unknown: 'UNKNOWN'
      });
    }
  }]);
  return CustomAudienceDataSource;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudienceSharingStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudienceSharingStatus = function (_AbstractCrudObject) {
  inherits(CustomAudienceSharingStatus, _AbstractCrudObject);

  function CustomAudienceSharingStatus() {
    classCallCheck(this, CustomAudienceSharingStatus);
    return possibleConstructorReturn(this, (CustomAudienceSharingStatus.__proto__ || Object.getPrototypeOf(CustomAudienceSharingStatus)).apply(this, arguments));
  }

  createClass(CustomAudienceSharingStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        sharing_relationship_id: 'sharing_relationship_id',
        status: 'status'
      });
    }
  }]);
  return CustomAudienceSharingStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * CustomAudienceStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var CustomAudienceStatus = function (_AbstractCrudObject) {
  inherits(CustomAudienceStatus, _AbstractCrudObject);

  function CustomAudienceStatus() {
    classCallCheck(this, CustomAudienceStatus);
    return possibleConstructorReturn(this, (CustomAudienceStatus.__proto__ || Object.getPrototypeOf(CustomAudienceStatus)).apply(this, arguments));
  }

  createClass(CustomAudienceStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        code: 'code',
        description: 'description'
      });
    }
  }]);
  return CustomAudienceStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DayPart
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DayPart = function (_AbstractCrudObject) {
  inherits(DayPart, _AbstractCrudObject);

  function DayPart() {
    classCallCheck(this, DayPart);
    return possibleConstructorReturn(this, (DayPart.__proto__ || Object.getPrototypeOf(DayPart)).apply(this, arguments));
  }

  createClass(DayPart, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        days: 'days',
        end_minute: 'end_minute',
        start_minute: 'start_minute',
        timezone_type: 'timezone_type'
      });
    }
  }]);
  return DayPart;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DeliveryCheck
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DeliveryCheck = function (_AbstractCrudObject) {
  inherits(DeliveryCheck, _AbstractCrudObject);

  function DeliveryCheck() {
    classCallCheck(this, DeliveryCheck);
    return possibleConstructorReturn(this, (DeliveryCheck.__proto__ || Object.getPrototypeOf(DeliveryCheck)).apply(this, arguments));
  }

  createClass(DeliveryCheck, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        check_name: 'check_name',
        description: 'description',
        extra_info: 'extra_info',
        summary: 'summary'
      });
    }
  }]);
  return DeliveryCheck;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DeliveryCheckExtraInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DeliveryCheckExtraInfo = function (_AbstractCrudObject) {
  inherits(DeliveryCheckExtraInfo, _AbstractCrudObject);

  function DeliveryCheckExtraInfo() {
    classCallCheck(this, DeliveryCheckExtraInfo);
    return possibleConstructorReturn(this, (DeliveryCheckExtraInfo.__proto__ || Object.getPrototypeOf(DeliveryCheckExtraInfo)).apply(this, arguments));
  }

  createClass(DeliveryCheckExtraInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adgroup_ids: 'adgroup_ids',
        campaign_ids: 'campaign_ids',
        countries: 'countries'
      });
    }
  }]);
  return DeliveryCheckExtraInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DeliveryWindow
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DeliveryWindow = function (_AbstractCrudObject) {
  inherits(DeliveryWindow, _AbstractCrudObject);

  function DeliveryWindow() {
    classCallCheck(this, DeliveryWindow);
    return possibleConstructorReturn(this, (DeliveryWindow.__proto__ || Object.getPrototypeOf(DeliveryWindow)).apply(this, arguments));
  }

  createClass(DeliveryWindow, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad: 'ad',
        ae: 'ae',
        af: 'af',
        ag: 'ag',
        ai: 'ai',
        al: 'al',
        all: 'all',
        am: 'am',
        an: 'an',
        ao: 'ao',
        aq: 'aq',
        ar: 'ar',
        as: 'as',
        at: 'at',
        au: 'au',
        aw: 'aw',
        ax: 'ax',
        az: 'az',
        ba: 'ba',
        bb: 'bb',
        bd: 'bd',
        be: 'be',
        bf: 'bf',
        bg: 'bg',
        bh: 'bh',
        bi: 'bi',
        bj: 'bj',
        bl: 'bl',
        bm: 'bm',
        bn: 'bn',
        bo: 'bo',
        bq: 'bq',
        br: 'br',
        bs: 'bs',
        bt: 'bt',
        bv: 'bv',
        bw: 'bw',
        by: 'by',
        bz: 'bz',
        ca: 'ca',
        cc: 'cc',
        cd: 'cd',
        cf: 'cf',
        cg: 'cg',
        ch: 'ch',
        ci: 'ci',
        ck: 'ck',
        cl: 'cl',
        cm: 'cm',
        cn: 'cn',
        co: 'co',
        cr: 'cr',
        cu: 'cu',
        cv: 'cv',
        cw: 'cw',
        cx: 'cx',
        cy: 'cy',
        cz: 'cz',
        de: 'de',
        dj: 'dj',
        dk: 'dk',
        dm: 'dm',
        do: 'do',
        dz: 'dz',
        ec: 'ec',
        ee: 'ee',
        eg: 'eg',
        eh: 'eh',
        er: 'er',
        es: 'es',
        et: 'et',
        fi: 'fi',
        fj: 'fj',
        fk: 'fk',
        fm: 'fm',
        fo: 'fo',
        fr: 'fr',
        ga: 'ga',
        gb: 'gb',
        gd: 'gd',
        ge: 'ge',
        gf: 'gf',
        gg: 'gg',
        gh: 'gh',
        gi: 'gi',
        gl: 'gl',
        gm: 'gm',
        gn: 'gn',
        gp: 'gp',
        gq: 'gq',
        gr: 'gr',
        gs: 'gs',
        gt: 'gt',
        gu: 'gu',
        gw: 'gw',
        gy: 'gy',
        hk: 'hk',
        hm: 'hm',
        hn: 'hn',
        hr: 'hr',
        ht: 'ht',
        hu: 'hu',
        id: 'id',
        ie: 'ie',
        il: 'il',
        im: 'im',
        in: 'in',
        io: 'io',
        iq: 'iq',
        ir: 'ir',
        is: 'is',
        it: 'it',
        je: 'je',
        jm: 'jm',
        jo: 'jo',
        jp: 'jp',
        ke: 'ke',
        kg: 'kg',
        kh: 'kh',
        ki: 'ki',
        km: 'km',
        kn: 'kn',
        kp: 'kp',
        kr: 'kr',
        kw: 'kw',
        ky: 'ky',
        kz: 'kz',
        la: 'la',
        lb: 'lb',
        lc: 'lc',
        li: 'li',
        lk: 'lk',
        lr: 'lr',
        ls: 'ls',
        lt: 'lt',
        lu: 'lu',
        lv: 'lv',
        ly: 'ly',
        ma: 'ma',
        mc: 'mc',
        md: 'md',
        me: 'me',
        mf: 'mf',
        mg: 'mg',
        mh: 'mh',
        mk: 'mk',
        ml: 'ml',
        mm: 'mm',
        mn: 'mn',
        mo: 'mo',
        mp: 'mp',
        mq: 'mq',
        mr: 'mr',
        ms: 'ms',
        mt: 'mt',
        mu: 'mu',
        mv: 'mv',
        mw: 'mw',
        mx: 'mx',
        my: 'my',
        mz: 'mz',
        na: 'na',
        nc: 'nc',
        ne: 'ne',
        nf: 'nf',
        ng: 'ng',
        ni: 'ni',
        nl: 'nl',
        no: 'no',
        np: 'np',
        nr: 'nr',
        nu: 'nu',
        nz: 'nz',
        om: 'om',
        pa: 'pa',
        pe: 'pe',
        pf: 'pf',
        pg: 'pg',
        ph: 'ph',
        pk: 'pk',
        pl: 'pl',
        pm: 'pm',
        pn: 'pn',
        pr: 'pr',
        ps: 'ps',
        pt: 'pt',
        pw: 'pw',
        py: 'py',
        qa: 'qa',
        re: 're',
        ro: 'ro',
        rs: 'rs',
        ru: 'ru',
        rw: 'rw',
        sa: 'sa',
        sb: 'sb',
        sc: 'sc',
        sd: 'sd',
        se: 'se',
        sg: 'sg',
        sh: 'sh',
        si: 'si',
        sj: 'sj',
        sk: 'sk',
        sl: 'sl',
        sm: 'sm',
        sn: 'sn',
        so: 'so',
        sr: 'sr',
        ss: 'ss',
        st: 'st',
        sv: 'sv',
        sx: 'sx',
        sy: 'sy',
        sz: 'sz',
        tc: 'tc',
        td: 'td',
        tf: 'tf',
        tg: 'tg',
        th: 'th',
        tj: 'tj',
        tk: 'tk',
        tl: 'tl',
        tm: 'tm',
        tn: 'tn',
        to: 'to',
        tr: 'tr',
        tt: 'tt',
        tv: 'tv',
        tw: 'tw',
        tz: 'tz',
        ua: 'ua',
        ug: 'ug',
        um: 'um',
        us: 'us',
        uy: 'uy',
        uz: 'uz',
        va: 'va',
        vc: 'vc',
        ve: 've',
        vg: 'vg',
        vi: 'vi',
        vn: 'vn',
        vu: 'vu',
        wf: 'wf',
        ws: 'ws',
        xk: 'xk',
        ye: 'ye',
        yt: 'yt',
        za: 'za',
        zm: 'zm',
        zw: 'zw'
      });
    }
  }]);
  return DeliveryWindow;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DestinationCatalogSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DestinationCatalogSettings = function (_AbstractCrudObject) {
  inherits(DestinationCatalogSettings, _AbstractCrudObject);

  function DestinationCatalogSettings() {
    classCallCheck(this, DestinationCatalogSettings);
    return possibleConstructorReturn(this, (DestinationCatalogSettings.__proto__ || Object.getPrototypeOf(DestinationCatalogSettings)).apply(this, arguments));
  }

  createClass(DestinationCatalogSettings, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        generate_items_from_pages: 'generate_items_from_pages',
        id: 'id'
      });
    }
  }]);
  return DestinationCatalogSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * DynamicPostChildAttachment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var DynamicPostChildAttachment = function (_AbstractCrudObject) {
  inherits(DynamicPostChildAttachment, _AbstractCrudObject);

  function DynamicPostChildAttachment() {
    classCallCheck(this, DynamicPostChildAttachment);
    return possibleConstructorReturn(this, (DynamicPostChildAttachment.__proto__ || Object.getPrototypeOf(DynamicPostChildAttachment)).apply(this, arguments));
  }

  createClass(DynamicPostChildAttachment, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        description: 'description',
        image_url: 'image_url',
        link: 'link',
        place_id: 'place_id',
        product_id: 'product_id',
        title: 'title'
      });
    }
  }]);
  return DynamicPostChildAttachment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Engagement
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Engagement = function (_AbstractCrudObject) {
  inherits(Engagement, _AbstractCrudObject);

  function Engagement() {
    classCallCheck(this, Engagement);
    return possibleConstructorReturn(this, (Engagement.__proto__ || Object.getPrototypeOf(Engagement)).apply(this, arguments));
  }

  createClass(Engagement, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        count: 'count',
        count_string: 'count_string',
        count_string_with_like: 'count_string_with_like',
        count_string_without_like: 'count_string_without_like',
        social_sentence: 'social_sentence',
        social_sentence_with_like: 'social_sentence_with_like',
        social_sentence_without_like: 'social_sentence_without_like'
      });
    }
  }]);
  return Engagement;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * EntityAtTextRange
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var EntityAtTextRange = function (_AbstractCrudObject) {
  inherits(EntityAtTextRange, _AbstractCrudObject);

  function EntityAtTextRange() {
    classCallCheck(this, EntityAtTextRange);
    return possibleConstructorReturn(this, (EntityAtTextRange.__proto__ || Object.getPrototypeOf(EntityAtTextRange)).apply(this, arguments));
  }

  createClass(EntityAtTextRange, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        length: 'length',
        name: 'name',
        object: 'object',
        offset: 'offset',
        type: 'type'
      });
    }
  }, {
    key: 'Type',
    get: function get() {
      return Object.freeze({
        application: 'application',
        event: 'event',
        group: 'group',
        page: 'page',
        user: 'user'
      });
    }
  }]);
  return EntityAtTextRange;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Experience
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Experience = function (_AbstractCrudObject) {
  inherits(Experience, _AbstractCrudObject);

  function Experience() {
    classCallCheck(this, Experience);
    return possibleConstructorReturn(this, (Experience.__proto__ || Object.getPrototypeOf(Experience)).apply(this, arguments));
  }

  createClass(Experience, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        description: 'description',
        from: 'from',
        id: 'id',
        name: 'name',
        with: 'with'
      });
    }
  }]);
  return Experience;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * FAMEExportConfig
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var FAMEExportConfig = function (_AbstractCrudObject) {
  inherits(FAMEExportConfig, _AbstractCrudObject);

  function FAMEExportConfig() {
    classCallCheck(this, FAMEExportConfig);
    return possibleConstructorReturn(this, (FAMEExportConfig.__proto__ || Object.getPrototypeOf(FAMEExportConfig)).apply(this, arguments));
  }

  createClass(FAMEExportConfig, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        can_edit: 'can_edit',
        column_id: 'column_id',
        display_name: 'display_name',
        format: 'format'
      });
    }
  }]);
  return FAMEExportConfig;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * FlexibleTargeting
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var FlexibleTargeting = function (_AbstractCrudObject) {
  inherits(FlexibleTargeting, _AbstractCrudObject);

  function FlexibleTargeting() {
    classCallCheck(this, FlexibleTargeting);
    return possibleConstructorReturn(this, (FlexibleTargeting.__proto__ || Object.getPrototypeOf(FlexibleTargeting)).apply(this, arguments));
  }

  createClass(FlexibleTargeting, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        behaviors: 'behaviors',
        college_years: 'college_years',
        connections: 'connections',
        custom_audiences: 'custom_audiences',
        education_majors: 'education_majors',
        education_schools: 'education_schools',
        education_statuses: 'education_statuses',
        ethnic_affinity: 'ethnic_affinity',
        family_statuses: 'family_statuses',
        friends_of_connections: 'friends_of_connections',
        generation: 'generation',
        home_ownership: 'home_ownership',
        home_type: 'home_type',
        home_value: 'home_value',
        household_composition: 'household_composition',
        income: 'income',
        industries: 'industries',
        interested_in: 'interested_in',
        interests: 'interests',
        life_events: 'life_events',
        moms: 'moms',
        net_worth: 'net_worth',
        office_type: 'office_type',
        politics: 'politics',
        relationship_statuses: 'relationship_statuses',
        user_adclusters: 'user_adclusters',
        work_employers: 'work_employers',
        work_positions: 'work_positions'
      });
    }
  }]);
  return FlexibleTargeting;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * FundingSourceDetails
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var FundingSourceDetails = function (_AbstractCrudObject) {
  inherits(FundingSourceDetails, _AbstractCrudObject);

  function FundingSourceDetails() {
    classCallCheck(this, FundingSourceDetails);
    return possibleConstructorReturn(this, (FundingSourceDetails.__proto__ || Object.getPrototypeOf(FundingSourceDetails)).apply(this, arguments));
  }

  createClass(FundingSourceDetails, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        coupon: 'coupon',
        display_string: 'display_string',
        id: 'id',
        type: 'type'
      });
    }
  }]);
  return FundingSourceDetails;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * FundingSourceDetailsCoupon
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var FundingSourceDetailsCoupon = function (_AbstractCrudObject) {
  inherits(FundingSourceDetailsCoupon, _AbstractCrudObject);

  function FundingSourceDetailsCoupon() {
    classCallCheck(this, FundingSourceDetailsCoupon);
    return possibleConstructorReturn(this, (FundingSourceDetailsCoupon.__proto__ || Object.getPrototypeOf(FundingSourceDetailsCoupon)).apply(this, arguments));
  }

  createClass(FundingSourceDetailsCoupon, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount: 'amount',
        currency: 'currency',
        display_amount: 'display_amount',
        expiration: 'expiration'
      });
    }
  }]);
  return FundingSourceDetailsCoupon;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * IDName
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var IDName = function (_AbstractCrudObject) {
  inherits(IDName, _AbstractCrudObject);

  function IDName() {
    classCallCheck(this, IDName);
    return possibleConstructorReturn(this, (IDName.__proto__ || Object.getPrototypeOf(IDName)).apply(this, arguments));
  }

  createClass(IDName, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name'
      });
    }
  }]);
  return IDName;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * IGBCAdsPermission
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var IGBCAdsPermission = function (_AbstractCrudObject) {
  inherits(IGBCAdsPermission, _AbstractCrudObject);

  function IGBCAdsPermission() {
    classCallCheck(this, IGBCAdsPermission);
    return possibleConstructorReturn(this, (IGBCAdsPermission.__proto__ || Object.getPrototypeOf(IGBCAdsPermission)).apply(this, arguments));
  }

  createClass(IGBCAdsPermission, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        permission_type: 'permission_type',
        status: 'status'
      });
    }
  }]);
  return IGBCAdsPermission;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * InstagramInsightsValue
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var InstagramInsightsValue = function (_AbstractCrudObject) {
  inherits(InstagramInsightsValue, _AbstractCrudObject);

  function InstagramInsightsValue() {
    classCallCheck(this, InstagramInsightsValue);
    return possibleConstructorReturn(this, (InstagramInsightsValue.__proto__ || Object.getPrototypeOf(InstagramInsightsValue)).apply(this, arguments));
  }

  createClass(InstagramInsightsValue, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        end_time: 'end_time',
        value: 'value'
      });
    }
  }]);
  return InstagramInsightsValue;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * IosAppLink
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var IosAppLink = function (_AbstractCrudObject) {
  inherits(IosAppLink, _AbstractCrudObject);

  function IosAppLink() {
    classCallCheck(this, IosAppLink);
    return possibleConstructorReturn(this, (IosAppLink.__proto__ || Object.getPrototypeOf(IosAppLink)).apply(this, arguments));
  }

  createClass(IosAppLink, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_name: 'app_name',
        app_store_id: 'app_store_id',
        url: 'url'
      });
    }
  }]);
  return IosAppLink;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * JobsJob
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var JobsJob = function (_AbstractCrudObject) {
  inherits(JobsJob, _AbstractCrudObject);

  function JobsJob() {
    classCallCheck(this, JobsJob);
    return possibleConstructorReturn(this, (JobsJob.__proto__ || Object.getPrototypeOf(JobsJob)).apply(this, arguments));
  }

  createClass(JobsJob, [{
    key: 'getAugmentedRealitiesMetadata',
    value: function getAugmentedRealitiesMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/augmented_realities_metadata');
    }
  }, {
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'getVideosMetadata',
    value: function getVideosMetadata(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(AbstractObject, fields, params, fetchFirstPage, '/videos_metadata');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address: 'address',
        applinks: 'applinks',
        category_specific_fields: 'category_specific_fields',
        custom_label_0: 'custom_label_0',
        custom_label_1: 'custom_label_1',
        custom_label_2: 'custom_label_2',
        custom_label_3: 'custom_label_3',
        custom_label_4: 'custom_label_4',
        custom_label_5: 'custom_label_5',
        custom_label_6: 'custom_label_6',
        custom_number_0: 'custom_number_0',
        custom_number_1: 'custom_number_1',
        custom_number_2: 'custom_number_2',
        custom_number_3: 'custom_number_3',
        custom_number_4: 'custom_number_4',
        custom_number_5: 'custom_number_5',
        custom_number_6: 'custom_number_6',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        jobs_job_id: 'jobs_job_id',
        sanitized_images: 'sanitized_images',
        unit_price: 'unit_price',
        url: 'url',
        visibility: 'visibility'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return JobsJob;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * KeyValue
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var KeyValue = function (_AbstractCrudObject) {
  inherits(KeyValue, _AbstractCrudObject);

  function KeyValue() {
    classCallCheck(this, KeyValue);
    return possibleConstructorReturn(this, (KeyValue.__proto__ || Object.getPrototypeOf(KeyValue)).apply(this, arguments));
  }

  createClass(KeyValue, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        key: 'key',
        value: 'value'
      });
    }
  }]);
  return KeyValue;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenAppointmentBookingInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenAppointmentBookingInfo = function (_AbstractCrudObject) {
  inherits(LeadGenAppointmentBookingInfo, _AbstractCrudObject);

  function LeadGenAppointmentBookingInfo() {
    classCallCheck(this, LeadGenAppointmentBookingInfo);
    return possibleConstructorReturn(this, (LeadGenAppointmentBookingInfo.__proto__ || Object.getPrototypeOf(LeadGenAppointmentBookingInfo)).apply(this, arguments));
  }

  createClass(LeadGenAppointmentBookingInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        advertiser_timezone_offset: 'advertiser_timezone_offset',
        appointment_durations: 'appointment_durations',
        appointment_slots_by_day: 'appointment_slots_by_day'
      });
    }
  }]);
  return LeadGenAppointmentBookingInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenConditionalQuestionsGroupChoices
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenConditionalQuestionsGroupChoices = function (_AbstractCrudObject) {
  inherits(LeadGenConditionalQuestionsGroupChoices, _AbstractCrudObject);

  function LeadGenConditionalQuestionsGroupChoices() {
    classCallCheck(this, LeadGenConditionalQuestionsGroupChoices);
    return possibleConstructorReturn(this, (LeadGenConditionalQuestionsGroupChoices.__proto__ || Object.getPrototypeOf(LeadGenConditionalQuestionsGroupChoices)).apply(this, arguments));
  }

  createClass(LeadGenConditionalQuestionsGroupChoices, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        customized_token: 'customized_token',
        next_question_choices: 'next_question_choices',
        value: 'value'
      });
    }
  }]);
  return LeadGenConditionalQuestionsGroupChoices;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenConditionalQuestionsGroupQuestions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenConditionalQuestionsGroupQuestions = function (_AbstractCrudObject) {
  inherits(LeadGenConditionalQuestionsGroupQuestions, _AbstractCrudObject);

  function LeadGenConditionalQuestionsGroupQuestions() {
    classCallCheck(this, LeadGenConditionalQuestionsGroupQuestions);
    return possibleConstructorReturn(this, (LeadGenConditionalQuestionsGroupQuestions.__proto__ || Object.getPrototypeOf(LeadGenConditionalQuestionsGroupQuestions)).apply(this, arguments));
  }

  createClass(LeadGenConditionalQuestionsGroupQuestions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        field_key: 'field_key',
        input_type: 'input_type',
        name: 'name'
      });
    }
  }]);
  return LeadGenConditionalQuestionsGroupQuestions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenDraftQuestion
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenDraftQuestion = function (_AbstractCrudObject) {
  inherits(LeadGenDraftQuestion, _AbstractCrudObject);

  function LeadGenDraftQuestion() {
    classCallCheck(this, LeadGenDraftQuestion);
    return possibleConstructorReturn(this, (LeadGenDraftQuestion.__proto__ || Object.getPrototypeOf(LeadGenDraftQuestion)).apply(this, arguments));
  }

  createClass(LeadGenDraftQuestion, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        conditional_questions_choices: 'conditional_questions_choices',
        conditional_questions_group_id: 'conditional_questions_group_id',
        dependent_conditional_questions: 'dependent_conditional_questions',
        inline_context: 'inline_context',
        key: 'key',
        label: 'label',
        options: 'options',
        type: 'type'
      });
    }
  }]);
  return LeadGenDraftQuestion;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenPostSubmissionCheckResult
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenPostSubmissionCheckResult = function (_AbstractCrudObject) {
  inherits(LeadGenPostSubmissionCheckResult, _AbstractCrudObject);

  function LeadGenPostSubmissionCheckResult() {
    classCallCheck(this, LeadGenPostSubmissionCheckResult);
    return possibleConstructorReturn(this, (LeadGenPostSubmissionCheckResult.__proto__ || Object.getPrototypeOf(LeadGenPostSubmissionCheckResult)).apply(this, arguments));
  }

  createClass(LeadGenPostSubmissionCheckResult, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        api_call_result: 'api_call_result',
        api_error_message: 'api_error_message',
        shown_thank_you_page: 'shown_thank_you_page'
      });
    }
  }]);
  return LeadGenPostSubmissionCheckResult;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenQuestion
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenQuestion = function (_AbstractCrudObject) {
  inherits(LeadGenQuestion, _AbstractCrudObject);

  function LeadGenQuestion() {
    classCallCheck(this, LeadGenQuestion);
    return possibleConstructorReturn(this, (LeadGenQuestion.__proto__ || Object.getPrototypeOf(LeadGenQuestion)).apply(this, arguments));
  }

  createClass(LeadGenQuestion, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        conditional_questions_choices: 'conditional_questions_choices',
        conditional_questions_group_id: 'conditional_questions_group_id',
        dependent_conditional_questions: 'dependent_conditional_questions',
        id: 'id',
        inline_context: 'inline_context',
        key: 'key',
        label: 'label',
        options: 'options',
        type: 'type'
      });
    }
  }]);
  return LeadGenQuestion;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LeadGenQuestionOption
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LeadGenQuestionOption = function (_AbstractCrudObject) {
  inherits(LeadGenQuestionOption, _AbstractCrudObject);

  function LeadGenQuestionOption() {
    classCallCheck(this, LeadGenQuestionOption);
    return possibleConstructorReturn(this, (LeadGenQuestionOption.__proto__ || Object.getPrototypeOf(LeadGenQuestionOption)).apply(this, arguments));
  }

  createClass(LeadGenQuestionOption, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        key: 'key',
        value: 'value'
      });
    }
  }]);
  return LeadGenQuestionOption;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LifeEvent
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LifeEvent = function (_AbstractCrudObject) {
  inherits(LifeEvent, _AbstractCrudObject);

  function LifeEvent() {
    classCallCheck(this, LifeEvent);
    return possibleConstructorReturn(this, (LifeEvent.__proto__ || Object.getPrototypeOf(LifeEvent)).apply(this, arguments));
  }

  createClass(LifeEvent, [{
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        description: 'description',
        end_time: 'end_time',
        from: 'from',
        id: 'id',
        is_hidden: 'is_hidden',
        start_time: 'start_time',
        title: 'title',
        updated_time: 'updated_time'
      });
    }
  }]);
  return LifeEvent;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Link
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Link = function (_AbstractCrudObject) {
  inherits(Link, _AbstractCrudObject);

  function Link() {
    classCallCheck(this, Link);
    return possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  createClass(Link, [{
    key: 'createComment',
    value: function createComment(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pathOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return this.createEdge('/comments', fields, params, Comment, pathOverride);
    }
  }, {
    key: 'getLikes',
    value: function getLikes(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(Profile, fields, params, fetchFirstPage, '/likes');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        caption: 'caption',
        created_time: 'created_time',
        description: 'description',
        from: 'from',
        icon: 'icon',
        id: 'id',
        link: 'link',
        message: 'message',
        multi_share_optimized: 'multi_share_optimized',
        name: 'name',
        privacy: 'privacy',
        via: 'via'
      });
    }
  }]);
  return Link;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LiveVideoAdBreakConfig
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LiveVideoAdBreakConfig = function (_AbstractCrudObject) {
  inherits(LiveVideoAdBreakConfig, _AbstractCrudObject);

  function LiveVideoAdBreakConfig() {
    classCallCheck(this, LiveVideoAdBreakConfig);
    return possibleConstructorReturn(this, (LiveVideoAdBreakConfig.__proto__ || Object.getPrototypeOf(LiveVideoAdBreakConfig)).apply(this, arguments));
  }

  createClass(LiveVideoAdBreakConfig, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        default_ad_break_duration: 'default_ad_break_duration',
        failure_reason_polling_interval: 'failure_reason_polling_interval',
        first_break_eligible_secs: 'first_break_eligible_secs',
        guide_url: 'guide_url',
        is_eligible_to_onboard: 'is_eligible_to_onboard',
        is_enabled: 'is_enabled',
        onboarding_url: 'onboarding_url',
        preparing_duration: 'preparing_duration',
        time_between_ad_breaks_secs: 'time_between_ad_breaks_secs',
        viewer_count_threshold: 'viewer_count_threshold'
      });
    }
  }]);
  return LiveVideoAdBreakConfig;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LiveVideoRecommendedEncoderSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LiveVideoRecommendedEncoderSettings = function (_AbstractCrudObject) {
  inherits(LiveVideoRecommendedEncoderSettings, _AbstractCrudObject);

  function LiveVideoRecommendedEncoderSettings() {
    classCallCheck(this, LiveVideoRecommendedEncoderSettings);
    return possibleConstructorReturn(this, (LiveVideoRecommendedEncoderSettings.__proto__ || Object.getPrototypeOf(LiveVideoRecommendedEncoderSettings)).apply(this, arguments));
  }

  createClass(LiveVideoRecommendedEncoderSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        audio_codec_settings: 'audio_codec_settings',
        streaming_protocol: 'streaming_protocol',
        video_codec_settings: 'video_codec_settings'
      });
    }
  }]);
  return LiveVideoRecommendedEncoderSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LiveVideoTargeting
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LiveVideoTargeting = function (_AbstractCrudObject) {
  inherits(LiveVideoTargeting, _AbstractCrudObject);

  function LiveVideoTargeting() {
    classCallCheck(this, LiveVideoTargeting);
    return possibleConstructorReturn(this, (LiveVideoTargeting.__proto__ || Object.getPrototypeOf(LiveVideoTargeting)).apply(this, arguments));
  }

  createClass(LiveVideoTargeting, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        age_max: 'age_max',
        age_min: 'age_min',
        excluded_countries: 'excluded_countries',
        geo_locations: 'geo_locations'
      });
    }
  }]);
  return LiveVideoTargeting;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LocalServiceBusiness
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LocalServiceBusiness = function (_AbstractCrudObject) {
  inherits(LocalServiceBusiness, _AbstractCrudObject);

  function LocalServiceBusiness() {
    classCallCheck(this, LocalServiceBusiness);
    return possibleConstructorReturn(this, (LocalServiceBusiness.__proto__ || Object.getPrototypeOf(LocalServiceBusiness)).apply(this, arguments));
  }

  createClass(LocalServiceBusiness, [{
    key: 'getChannelsToIntegrityStatus',
    value: function getChannelsToIntegrityStatus(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fetchFirstPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      return this.getEdge(CatalogItemChannelsToIntegrityStatus, fields, params, fetchFirstPage, '/channels_to_integrity_status');
    }
  }, {
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address: 'address',
        applinks: 'applinks',
        availability: 'availability',
        brand: 'brand',
        category: 'category',
        category_specific_fields: 'category_specific_fields',
        condition: 'condition',
        cuisine_type: 'cuisine_type',
        currency: 'currency',
        custom_label_0: 'custom_label_0',
        custom_label_1: 'custom_label_1',
        custom_label_2: 'custom_label_2',
        custom_label_3: 'custom_label_3',
        custom_label_4: 'custom_label_4',
        custom_number_0: 'custom_number_0',
        custom_number_1: 'custom_number_1',
        custom_number_2: 'custom_number_2',
        custom_number_3: 'custom_number_3',
        custom_number_4: 'custom_number_4',
        description: 'description',
        expiration_date: 'expiration_date',
        gtin: 'gtin',
        id: 'id',
        image_fetch_status: 'image_fetch_status',
        images: 'images',
        local_service_business_id: 'local_service_business_id',
        phone: 'phone',
        price: 'price',
        price_range: 'price_range',
        retailer_category: 'retailer_category',
        sanitized_images: 'sanitized_images',
        size: 'size',
        title: 'title',
        unit_price: 'unit_price',
        url: 'url',
        vendor_id: 'vendor_id',
        visibility: 'visibility'
      });
    }
  }, {
    key: 'Availability',
    get: function get() {
      return Object.freeze({
        available_for_order: 'AVAILABLE_FOR_ORDER',
        discontinued: 'DISCONTINUED',
        in_stock: 'IN_STOCK',
        out_of_stock: 'OUT_OF_STOCK',
        pending: 'PENDING',
        preorder: 'PREORDER'
      });
    }
  }, {
    key: 'Condition',
    get: function get() {
      return Object.freeze({
        pc_cpo: 'PC_CPO',
        pc_new: 'PC_NEW',
        pc_open_box_new: 'PC_OPEN_BOX_NEW',
        pc_refurbished: 'PC_REFURBISHED',
        pc_used: 'PC_USED',
        pc_used_fair: 'PC_USED_FAIR',
        pc_used_good: 'PC_USED_GOOD',
        pc_used_like_new: 'PC_USED_LIKE_NEW'
      });
    }
  }, {
    key: 'ImageFetchStatus',
    get: function get() {
      return Object.freeze({
        direct_upload: 'DIRECT_UPLOAD',
        fetched: 'FETCHED',
        fetch_failed: 'FETCH_FAILED',
        no_status: 'NO_STATUS',
        outdated: 'OUTDATED',
        partial_fetch: 'PARTIAL_FETCH'
      });
    }
  }, {
    key: 'Visibility',
    get: function get() {
      return Object.freeze({
        published: 'PUBLISHED',
        staging: 'STAGING'
      });
    }
  }]);
  return LocalServiceBusiness;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Location
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Location = function (_AbstractCrudObject) {
  inherits(Location, _AbstractCrudObject);

  function Location() {
    classCallCheck(this, Location);
    return possibleConstructorReturn(this, (Location.__proto__ || Object.getPrototypeOf(Location)).apply(this, arguments));
  }

  createClass(Location, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        city: 'city',
        city_id: 'city_id',
        country: 'country',
        country_code: 'country_code',
        latitude: 'latitude',
        located_in: 'located_in',
        longitude: 'longitude',
        name: 'name',
        region: 'region',
        region_id: 'region_id',
        state: 'state',
        street: 'street',
        zip: 'zip'
      });
    }
  }]);
  return Location;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * LookalikeSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var LookalikeSpec = function (_AbstractCrudObject) {
  inherits(LookalikeSpec, _AbstractCrudObject);

  function LookalikeSpec() {
    classCallCheck(this, LookalikeSpec);
    return possibleConstructorReturn(this, (LookalikeSpec.__proto__ || Object.getPrototypeOf(LookalikeSpec)).apply(this, arguments));
  }

  createClass(LookalikeSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        is_financial_service: 'is_financial_service',
        origin: 'origin',
        origin_event_name: 'origin_event_name',
        origin_event_source_name: 'origin_event_source_name',
        origin_event_source_type: 'origin_event_source_type',
        product_set_name: 'product_set_name',
        ratio: 'ratio',
        starting_ratio: 'starting_ratio',
        target_countries: 'target_countries',
        target_country_names: 'target_country_names',
        type: 'type'
      });
    }
  }]);
  return LookalikeSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MailingAddress
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MailingAddress = function (_AbstractCrudObject) {
  inherits(MailingAddress, _AbstractCrudObject);

  function MailingAddress() {
    classCallCheck(this, MailingAddress);
    return possibleConstructorReturn(this, (MailingAddress.__proto__ || Object.getPrototypeOf(MailingAddress)).apply(this, arguments));
  }

  createClass(MailingAddress, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        city: 'city',
        city_page: 'city_page',
        country: 'country',
        id: 'id',
        postal_code: 'postal_code',
        region: 'region',
        street1: 'street1',
        street2: 'street2'
      });
    }
  }]);
  return MailingAddress;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ManagedPartnerBusiness
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ManagedPartnerBusiness = function (_AbstractCrudObject) {
  inherits(ManagedPartnerBusiness, _AbstractCrudObject);

  function ManagedPartnerBusiness() {
    classCallCheck(this, ManagedPartnerBusiness);
    return possibleConstructorReturn(this, (ManagedPartnerBusiness.__proto__ || Object.getPrototypeOf(ManagedPartnerBusiness)).apply(this, arguments));
  }

  createClass(ManagedPartnerBusiness, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_account: 'ad_account',
        catalog_segment: 'catalog_segment',
        extended_credit: 'extended_credit',
        page: 'page',
        seller_business_info: 'seller_business_info',
        seller_business_status: 'seller_business_status',
        template: 'template'
      });
    }
  }]);
  return ManagedPartnerBusiness;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MessagingFeatureStatus
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MessagingFeatureStatus = function (_AbstractCrudObject) {
  inherits(MessagingFeatureStatus, _AbstractCrudObject);

  function MessagingFeatureStatus() {
    classCallCheck(this, MessagingFeatureStatus);
    return possibleConstructorReturn(this, (MessagingFeatureStatus.__proto__ || Object.getPrototypeOf(MessagingFeatureStatus)).apply(this, arguments));
  }

  createClass(MessagingFeatureStatus, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        hop_v2: 'hop_v2'
      });
    }
  }]);
  return MessagingFeatureStatus;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MessengerDestinationPageWelcomeMessage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MessengerDestinationPageWelcomeMessage = function (_AbstractCrudObject) {
  inherits(MessengerDestinationPageWelcomeMessage, _AbstractCrudObject);

  function MessengerDestinationPageWelcomeMessage() {
    classCallCheck(this, MessengerDestinationPageWelcomeMessage);
    return possibleConstructorReturn(this, (MessengerDestinationPageWelcomeMessage.__proto__ || Object.getPrototypeOf(MessengerDestinationPageWelcomeMessage)).apply(this, arguments));
  }

  createClass(MessengerDestinationPageWelcomeMessage, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        page_welcome_message_body: 'page_welcome_message_body',
        page_welcome_message_type: 'page_welcome_message_type',
        template_name: 'template_name',
        time_created: 'time_created',
        time_last_used: 'time_last_used'
      });
    }
  }]);
  return MessengerDestinationPageWelcomeMessage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * MusicVideoCopyright
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var MusicVideoCopyright = function (_AbstractCrudObject) {
  inherits(MusicVideoCopyright, _AbstractCrudObject);

  function MusicVideoCopyright() {
    classCallCheck(this, MusicVideoCopyright);
    return possibleConstructorReturn(this, (MusicVideoCopyright.__proto__ || Object.getPrototypeOf(MusicVideoCopyright)).apply(this, arguments));
  }

  createClass(MusicVideoCopyright, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_time: 'creation_time',
        displayed_matches_count: 'displayed_matches_count',
        id: 'id',
        in_conflict: 'in_conflict',
        isrc: 'isrc',
        match_rule: 'match_rule',
        ownership_countries: 'ownership_countries',
        reference_file_status: 'reference_file_status',
        ridge_monitoring_status: 'ridge_monitoring_status',
        tags: 'tags',
        update_time: 'update_time',
        video_asset: 'video_asset',
        whitelisted_fb_users: 'whitelisted_fb_users',
        whitelisted_ig_users: 'whitelisted_ig_users'
      });
    }
  }]);
  return MusicVideoCopyright;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OfflineConversionDataSetPermissions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OfflineConversionDataSetPermissions = function (_AbstractCrudObject) {
  inherits(OfflineConversionDataSetPermissions, _AbstractCrudObject);

  function OfflineConversionDataSetPermissions() {
    classCallCheck(this, OfflineConversionDataSetPermissions);
    return possibleConstructorReturn(this, (OfflineConversionDataSetPermissions.__proto__ || Object.getPrototypeOf(OfflineConversionDataSetPermissions)).apply(this, arguments));
  }

  createClass(OfflineConversionDataSetPermissions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        can_edit: 'can_edit',
        can_edit_or_upload: 'can_edit_or_upload',
        can_upload: 'can_upload',
        should_block_vanilla_business_employee_access: 'should_block_vanilla_business_employee_access'
      });
    }
  }]);
  return OfflineConversionDataSetPermissions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OfflineConversionDataSetUsage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OfflineConversionDataSetUsage = function (_AbstractCrudObject) {
  inherits(OfflineConversionDataSetUsage, _AbstractCrudObject);

  function OfflineConversionDataSetUsage() {
    classCallCheck(this, OfflineConversionDataSetUsage);
    return possibleConstructorReturn(this, (OfflineConversionDataSetUsage.__proto__ || Object.getPrototypeOf(OfflineConversionDataSetUsage)).apply(this, arguments));
  }

  createClass(OfflineConversionDataSetUsage, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        num_lift_studies: 'num_lift_studies'
      });
    }
  }]);
  return OfflineConversionDataSetUsage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OffsitePixel
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OffsitePixel = function (_AbstractCrudObject) {
  inherits(OffsitePixel, _AbstractCrudObject);

  function OffsitePixel() {
    classCallCheck(this, OffsitePixel);
    return possibleConstructorReturn(this, (OffsitePixel.__proto__ || Object.getPrototypeOf(OffsitePixel)).apply(this, arguments));
  }

  createClass(OffsitePixel, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creator: 'creator',
        id: 'id',
        js_pixel: 'js_pixel',
        last_firing_time: 'last_firing_time',
        name: 'name',
        tag: 'tag'
      });
    }
  }]);
  return OffsitePixel;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OpenGraphContext
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OpenGraphContext = function (_AbstractCrudObject) {
  inherits(OpenGraphContext, _AbstractCrudObject);

  function OpenGraphContext() {
    classCallCheck(this, OpenGraphContext);
    return possibleConstructorReturn(this, (OpenGraphContext.__proto__ || Object.getPrototypeOf(OpenGraphContext)).apply(this, arguments));
  }

  createClass(OpenGraphContext, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id'
      });
    }
  }]);
  return OpenGraphContext;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * OutcomePredictionPoint
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var OutcomePredictionPoint = function (_AbstractCrudObject) {
  inherits(OutcomePredictionPoint, _AbstractCrudObject);

  function OutcomePredictionPoint() {
    classCallCheck(this, OutcomePredictionPoint);
    return possibleConstructorReturn(this, (OutcomePredictionPoint.__proto__ || Object.getPrototypeOf(OutcomePredictionPoint)).apply(this, arguments));
  }

  createClass(OutcomePredictionPoint, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        actions: 'actions',
        impressions: 'impressions',
        reach: 'reach',
        spend: 'spend'
      });
    }
  }]);
  return OutcomePredictionPoint;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageCategory
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageCategory = function (_AbstractCrudObject) {
  inherits(PageCategory, _AbstractCrudObject);

  function PageCategory() {
    classCallCheck(this, PageCategory);
    return possibleConstructorReturn(this, (PageCategory.__proto__ || Object.getPrototypeOf(PageCategory)).apply(this, arguments));
  }

  createClass(PageCategory, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        api_enum: 'api_enum',
        fb_page_categories: 'fb_page_categories',
        id: 'id',
        name: 'name'
      });
    }
  }]);
  return PageCategory;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageChangeProposal
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageChangeProposal = function (_AbstractCrudObject) {
  inherits(PageChangeProposal, _AbstractCrudObject);

  function PageChangeProposal() {
    classCallCheck(this, PageChangeProposal);
    return possibleConstructorReturn(this, (PageChangeProposal.__proto__ || Object.getPrototypeOf(PageChangeProposal)).apply(this, arguments));
  }

  createClass(PageChangeProposal, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        acceptance_status: 'acceptance_status',
        category: 'category',
        current_value: 'current_value',
        id: 'id',
        proposed_value: 'proposed_value',
        upcoming_change_info: 'upcoming_change_info'
      });
    }
  }]);
  return PageChangeProposal;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageParking
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageParking = function (_AbstractCrudObject) {
  inherits(PageParking, _AbstractCrudObject);

  function PageParking() {
    classCallCheck(this, PageParking);
    return possibleConstructorReturn(this, (PageParking.__proto__ || Object.getPrototypeOf(PageParking)).apply(this, arguments));
  }

  createClass(PageParking, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        lot: 'lot',
        street: 'street',
        valet: 'valet'
      });
    }
  }]);
  return PageParking;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PagePaymentOptions
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PagePaymentOptions = function (_AbstractCrudObject) {
  inherits(PagePaymentOptions, _AbstractCrudObject);

  function PagePaymentOptions() {
    classCallCheck(this, PagePaymentOptions);
    return possibleConstructorReturn(this, (PagePaymentOptions.__proto__ || Object.getPrototypeOf(PagePaymentOptions)).apply(this, arguments));
  }

  createClass(PagePaymentOptions, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amex: 'amex',
        cash_only: 'cash_only',
        discover: 'discover',
        mastercard: 'mastercard',
        visa: 'visa'
      });
    }
  }]);
  return PagePaymentOptions;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PagePostExperiment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PagePostExperiment = function (_AbstractCrudObject) {
  inherits(PagePostExperiment, _AbstractCrudObject);

  function PagePostExperiment() {
    classCallCheck(this, PagePostExperiment);
    return possibleConstructorReturn(this, (PagePostExperiment.__proto__ || Object.getPrototypeOf(PagePostExperiment)).apply(this, arguments));
  }

  createClass(PagePostExperiment, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        auto_resolve_settings: 'auto_resolve_settings',
        creation_time: 'creation_time',
        creator: 'creator',
        declared_winning_time: 'declared_winning_time',
        description: 'description',
        id: 'id',
        insight_snapshots: 'insight_snapshots',
        name: 'name',
        optimization_goal: 'optimization_goal',
        publish_status: 'publish_status',
        publish_time: 'publish_time',
        scheduled_experiment_timestamp: 'scheduled_experiment_timestamp',
        updated_time: 'updated_time'
      });
    }
  }]);
  return PagePostExperiment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageRestaurantServices
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageRestaurantServices = function (_AbstractCrudObject) {
  inherits(PageRestaurantServices, _AbstractCrudObject);

  function PageRestaurantServices() {
    classCallCheck(this, PageRestaurantServices);
    return possibleConstructorReturn(this, (PageRestaurantServices.__proto__ || Object.getPrototypeOf(PageRestaurantServices)).apply(this, arguments));
  }

  createClass(PageRestaurantServices, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        catering: 'catering',
        delivery: 'delivery',
        groups: 'groups',
        kids: 'kids',
        outdoor: 'outdoor',
        pickup: 'pickup',
        reserve: 'reserve',
        takeout: 'takeout',
        waiter: 'waiter',
        walkins: 'walkins'
      });
    }
  }]);
  return PageRestaurantServices;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageRestaurantSpecialties
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageRestaurantSpecialties = function (_AbstractCrudObject) {
  inherits(PageRestaurantSpecialties, _AbstractCrudObject);

  function PageRestaurantSpecialties() {
    classCallCheck(this, PageRestaurantSpecialties);
    return possibleConstructorReturn(this, (PageRestaurantSpecialties.__proto__ || Object.getPrototypeOf(PageRestaurantSpecialties)).apply(this, arguments));
  }

  createClass(PageRestaurantSpecialties, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        breakfast: 'breakfast',
        coffee: 'coffee',
        dinner: 'dinner',
        drinks: 'drinks',
        lunch: 'lunch'
      });
    }
  }]);
  return PageRestaurantSpecialties;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageSavedFilter
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageSavedFilter = function (_AbstractCrudObject) {
  inherits(PageSavedFilter, _AbstractCrudObject);

  function PageSavedFilter() {
    classCallCheck(this, PageSavedFilter);
    return possibleConstructorReturn(this, (PageSavedFilter.__proto__ || Object.getPrototypeOf(PageSavedFilter)).apply(this, arguments));
  }

  createClass(PageSavedFilter, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        display_name: 'display_name',
        filters: 'filters',
        id: 'id',
        page_id: 'page_id',
        section: 'section',
        time_created: 'time_created',
        time_updated: 'time_updated'
      });
    }
  }]);
  return PageSavedFilter;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageStartInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageStartInfo = function (_AbstractCrudObject) {
  inherits(PageStartInfo, _AbstractCrudObject);

  function PageStartInfo() {
    classCallCheck(this, PageStartInfo);
    return possibleConstructorReturn(this, (PageStartInfo.__proto__ || Object.getPrototypeOf(PageStartInfo)).apply(this, arguments));
  }

  createClass(PageStartInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        date: 'date',
        type: 'type'
      });
    }
  }]);
  return PageStartInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PageUpcomingChange
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PageUpcomingChange = function (_AbstractCrudObject) {
  inherits(PageUpcomingChange, _AbstractCrudObject);

  function PageUpcomingChange() {
    classCallCheck(this, PageUpcomingChange);
    return possibleConstructorReturn(this, (PageUpcomingChange.__proto__ || Object.getPrototypeOf(PageUpcomingChange)).apply(this, arguments));
  }

  createClass(PageUpcomingChange, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        change_type: 'change_type',
        effective_time: 'effective_time',
        id: 'id',
        page: 'page',
        proposal: 'proposal',
        timer_status: 'timer_status'
      });
    }
  }]);
  return PageUpcomingChange;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PaymentPricepoints
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PaymentPricepoints = function (_AbstractCrudObject) {
  inherits(PaymentPricepoints, _AbstractCrudObject);

  function PaymentPricepoints() {
    classCallCheck(this, PaymentPricepoints);
    return possibleConstructorReturn(this, (PaymentPricepoints.__proto__ || Object.getPrototypeOf(PaymentPricepoints)).apply(this, arguments));
  }

  createClass(PaymentPricepoints, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        mobile: 'mobile'
      });
    }
  }]);
  return PaymentPricepoints;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PaymentSubscription
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PaymentSubscription = function (_AbstractCrudObject) {
  inherits(PaymentSubscription, _AbstractCrudObject);

  function PaymentSubscription() {
    classCallCheck(this, PaymentSubscription);
    return possibleConstructorReturn(this, (PaymentSubscription.__proto__ || Object.getPrototypeOf(PaymentSubscription)).apply(this, arguments));
  }

  createClass(PaymentSubscription, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        amount: 'amount',
        app_param_data: 'app_param_data',
        application: 'application',
        billing_period: 'billing_period',
        canceled_reason: 'canceled_reason',
        created_time: 'created_time',
        currency: 'currency',
        id: 'id',
        last_payment: 'last_payment',
        next_bill_time: 'next_bill_time',
        next_period_amount: 'next_period_amount',
        next_period_currency: 'next_period_currency',
        next_period_product: 'next_period_product',
        payment_status: 'payment_status',
        pending_cancel: 'pending_cancel',
        period_start_time: 'period_start_time',
        product: 'product',
        status: 'status',
        test: 'test',
        trial_amount: 'trial_amount',
        trial_currency: 'trial_currency',
        trial_expiry_time: 'trial_expiry_time',
        updated_time: 'updated_time',
        user: 'user'
      });
    }
  }]);
  return PaymentSubscription;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Place
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Place = function (_AbstractCrudObject) {
  inherits(Place, _AbstractCrudObject);

  function Place() {
    classCallCheck(this, Place);
    return possibleConstructorReturn(this, (Place.__proto__ || Object.getPrototypeOf(Place)).apply(this, arguments));
  }

  createClass(Place, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        location: 'location',
        name: 'name',
        overall_rating: 'overall_rating'
      });
    }
  }]);
  return Place;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PlaceTopic
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PlaceTopic = function (_AbstractCrudObject) {
  inherits(PlaceTopic, _AbstractCrudObject);

  function PlaceTopic() {
    classCallCheck(this, PlaceTopic);
    return possibleConstructorReturn(this, (PlaceTopic.__proto__ || Object.getPrototypeOf(PlaceTopic)).apply(this, arguments));
  }

  createClass(PlaceTopic, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        count: 'count',
        has_children: 'has_children',
        icon_url: 'icon_url',
        id: 'id',
        name: 'name',
        parent_ids: 'parent_ids',
        plural_name: 'plural_name',
        top_subtopic_names: 'top_subtopic_names'
      });
    }
  }]);
  return PlaceTopic;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * PlatformImageSource
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var PlatformImageSource = function (_AbstractCrudObject) {
  inherits(PlatformImageSource, _AbstractCrudObject);

  function PlatformImageSource() {
    classCallCheck(this, PlatformImageSource);
    return possibleConstructorReturn(this, (PlatformImageSource.__proto__ || Object.getPrototypeOf(PlatformImageSource)).apply(this, arguments));
  }

  createClass(PlatformImageSource, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        height: 'height',
        source: 'source',
        width: 'width'
      });
    }
  }]);
  return PlatformImageSource;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Privacy
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Privacy = function (_AbstractCrudObject) {
  inherits(Privacy, _AbstractCrudObject);

  function Privacy() {
    classCallCheck(this, Privacy);
    return possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).apply(this, arguments));
  }

  createClass(Privacy, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        allow: 'allow',
        deny: 'deny',
        description: 'description',
        friends: 'friends',
        networks: 'networks',
        value: 'value'
      });
    }
  }]);
  return Privacy;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogImageSettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogImageSettings = function (_AbstractCrudObject) {
  inherits(ProductCatalogImageSettings, _AbstractCrudObject);

  function ProductCatalogImageSettings() {
    classCallCheck(this, ProductCatalogImageSettings);
    return possibleConstructorReturn(this, (ProductCatalogImageSettings.__proto__ || Object.getPrototypeOf(ProductCatalogImageSettings)).apply(this, arguments));
  }

  createClass(ProductCatalogImageSettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        carousel_ad: 'carousel_ad',
        single_ad: 'single_ad'
      });
    }
  }]);
  return ProductCatalogImageSettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductCatalogImageSettingsOperation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductCatalogImageSettingsOperation = function (_AbstractCrudObject) {
  inherits(ProductCatalogImageSettingsOperation, _AbstractCrudObject);

  function ProductCatalogImageSettingsOperation() {
    classCallCheck(this, ProductCatalogImageSettingsOperation);
    return possibleConstructorReturn(this, (ProductCatalogImageSettingsOperation.__proto__ || Object.getPrototypeOf(ProductCatalogImageSettingsOperation)).apply(this, arguments));
  }

  createClass(ProductCatalogImageSettingsOperation, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        transformation_type: 'transformation_type'
      });
    }
  }]);
  return ProductCatalogImageSettingsOperation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedMissingFeedItemReplacement
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedMissingFeedItemReplacement = function (_AbstractCrudObject) {
  inherits(ProductFeedMissingFeedItemReplacement, _AbstractCrudObject);

  function ProductFeedMissingFeedItemReplacement() {
    classCallCheck(this, ProductFeedMissingFeedItemReplacement);
    return possibleConstructorReturn(this, (ProductFeedMissingFeedItemReplacement.__proto__ || Object.getPrototypeOf(ProductFeedMissingFeedItemReplacement)).apply(this, arguments));
  }

  createClass(ProductFeedMissingFeedItemReplacement, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        home_listing: 'home_listing',
        product_item: 'product_item',
        vehicle: 'vehicle'
      });
    }
  }]);
  return ProductFeedMissingFeedItemReplacement;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductFeedUploadErrorReport
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductFeedUploadErrorReport = function (_AbstractCrudObject) {
  inherits(ProductFeedUploadErrorReport, _AbstractCrudObject);

  function ProductFeedUploadErrorReport() {
    classCallCheck(this, ProductFeedUploadErrorReport);
    return possibleConstructorReturn(this, (ProductFeedUploadErrorReport.__proto__ || Object.getPrototypeOf(ProductFeedUploadErrorReport)).apply(this, arguments));
  }

  createClass(ProductFeedUploadErrorReport, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        file_handle: 'file_handle',
        report_status: 'report_status'
      });
    }
  }]);
  return ProductFeedUploadErrorReport;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductImage
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductImage = function (_AbstractCrudObject) {
  inherits(ProductImage, _AbstractCrudObject);

  function ProductImage() {
    classCallCheck(this, ProductImage);
    return possibleConstructorReturn(this, (ProductImage.__proto__ || Object.getPrototypeOf(ProductImage)).apply(this, arguments));
  }

  createClass(ProductImage, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        image_url: 'image_url'
      });
    }
  }]);
  return ProductImage;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductItemARData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductItemARData = function (_AbstractCrudObject) {
  inherits(ProductItemARData, _AbstractCrudObject);

  function ProductItemARData() {
    classCallCheck(this, ProductItemARData);
    return possibleConstructorReturn(this, (ProductItemARData.__proto__ || Object.getPrototypeOf(ProductItemARData)).apply(this, arguments));
  }

  createClass(ProductItemARData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        container_effect: 'container_effect',
        effect_icon: 'effect_icon',
        effect_parameters: 'effect_parameters',
        picker_icon: 'picker_icon',
        product_ar_link: 'product_ar_link',
        state: 'state',
        surfaces: 'surfaces'
      });
    }
  }, {
    key: 'Surfaces',
    get: function get() {
      return Object.freeze({
        b2c_marketplace: 'B2C_MARKETPLACE',
        c2c_marketplace: 'C2C_MARKETPLACE',
        da: 'DA',
        daily_deals: 'DAILY_DEALS',
        daily_deals_legacy: 'DAILY_DEALS_LEGACY',
        ig_product_tagging: 'IG_PRODUCT_TAGGING',
        marketplace: 'MARKETPLACE',
        marketplace_ads_deprecated: 'MARKETPLACE_ADS_DEPRECATED',
        marketplace_shops: 'MARKETPLACE_SHOPS',
        mini_shops: 'MINI_SHOPS',
        offline_conversions: 'OFFLINE_CONVERSIONS',
        shops: 'SHOPS',
        universal_checkout: 'UNIVERSAL_CHECKOUT',
        whatsapp: 'WHATSAPP'
      });
    }
  }]);
  return ProductItemARData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductItemCommerceInsights
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductItemCommerceInsights = function (_AbstractCrudObject) {
  inherits(ProductItemCommerceInsights, _AbstractCrudObject);

  function ProductItemCommerceInsights() {
    classCallCheck(this, ProductItemCommerceInsights);
    return possibleConstructorReturn(this, (ProductItemCommerceInsights.__proto__ || Object.getPrototypeOf(ProductItemCommerceInsights)).apply(this, arguments));
  }

  createClass(ProductItemCommerceInsights, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        message_sends: 'message_sends',
        organic_impressions: 'organic_impressions',
        paid_impressions: 'paid_impressions'
      });
    }
  }]);
  return ProductItemCommerceInsights;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductItemError
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductItemError = function (_AbstractCrudObject) {
  inherits(ProductItemError, _AbstractCrudObject);

  function ProductItemError() {
    classCallCheck(this, ProductItemError);
    return possibleConstructorReturn(this, (ProductItemError.__proto__ || Object.getPrototypeOf(ProductItemError)).apply(this, arguments));
  }

  createClass(ProductItemError, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        description: 'description',
        error_priority: 'error_priority',
        error_type: 'error_type',
        title: 'title'
      });
    }
  }]);
  return ProductItemError;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductItemImporterAddress
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductItemImporterAddress = function (_AbstractCrudObject) {
  inherits(ProductItemImporterAddress, _AbstractCrudObject);

  function ProductItemImporterAddress() {
    classCallCheck(this, ProductItemImporterAddress);
    return possibleConstructorReturn(this, (ProductItemImporterAddress.__proto__ || Object.getPrototypeOf(ProductItemImporterAddress)).apply(this, arguments));
  }

  createClass(ProductItemImporterAddress, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        city: 'city',
        country: 'country',
        postal_code: 'postal_code',
        region: 'region',
        street1: 'street1',
        street2: 'street2'
      });
    }
  }]);
  return ProductItemImporterAddress;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductSetMetadata
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductSetMetadata = function (_AbstractCrudObject) {
  inherits(ProductSetMetadata, _AbstractCrudObject);

  function ProductSetMetadata() {
    classCallCheck(this, ProductSetMetadata);
    return possibleConstructorReturn(this, (ProductSetMetadata.__proto__ || Object.getPrototypeOf(ProductSetMetadata)).apply(this, arguments));
  }

  createClass(ProductSetMetadata, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        cover_image_url: 'cover_image_url',
        description: 'description',
        external_url: 'external_url',
        integrity_review_status: 'integrity_review_status'
      });
    }
  }]);
  return ProductSetMetadata;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ProductVariant
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ProductVariant = function (_AbstractCrudObject) {
  inherits(ProductVariant, _AbstractCrudObject);

  function ProductVariant() {
    classCallCheck(this, ProductVariant);
    return possibleConstructorReturn(this, (ProductVariant.__proto__ || Object.getPrototypeOf(ProductVariant)).apply(this, arguments));
  }

  createClass(ProductVariant, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        label: 'label',
        options: 'options',
        product_field: 'product_field'
      });
    }
  }]);
  return ProductVariant;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * RawCustomAudience
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var RawCustomAudience = function (_AbstractCrudObject) {
  inherits(RawCustomAudience, _AbstractCrudObject);

  function RawCustomAudience() {
    classCallCheck(this, RawCustomAudience);
    return possibleConstructorReturn(this, (RawCustomAudience.__proto__ || Object.getPrototypeOf(RawCustomAudience)).apply(this, arguments));
  }

  createClass(RawCustomAudience, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name: 'name'
      });
    }
  }]);
  return RawCustomAudience;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyActivity
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyActivity = function (_AbstractCrudObject) {
  inherits(ReachFrequencyActivity, _AbstractCrudObject);

  function ReachFrequencyActivity() {
    classCallCheck(this, ReachFrequencyActivity);
    return possibleConstructorReturn(this, (ReachFrequencyActivity.__proto__ || Object.getPrototypeOf(ReachFrequencyActivity)).apply(this, arguments));
  }

  createClass(ReachFrequencyActivity, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        account_id: 'account_id',
        campaign_active: 'campaign_active',
        campaign_started: 'campaign_started',
        creative_uploaded: 'creative_uploaded',
        io_approved: 'io_approved',
        sf_link: 'sf_link'
      });
    }
  }]);
  return ReachFrequencyActivity;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyAdFormat
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyAdFormat = function (_AbstractCrudObject) {
  inherits(ReachFrequencyAdFormat, _AbstractCrudObject);

  function ReachFrequencyAdFormat() {
    classCallCheck(this, ReachFrequencyAdFormat);
    return possibleConstructorReturn(this, (ReachFrequencyAdFormat.__proto__ || Object.getPrototypeOf(ReachFrequencyAdFormat)).apply(this, arguments));
  }

  createClass(ReachFrequencyAdFormat, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        details: 'details',
        type: 'type'
      });
    }
  }]);
  return ReachFrequencyAdFormat;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyCurveLowerConfidenceRange
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyCurveLowerConfidenceRange = function (_AbstractCrudObject) {
  inherits(ReachFrequencyCurveLowerConfidenceRange, _AbstractCrudObject);

  function ReachFrequencyCurveLowerConfidenceRange() {
    classCallCheck(this, ReachFrequencyCurveLowerConfidenceRange);
    return possibleConstructorReturn(this, (ReachFrequencyCurveLowerConfidenceRange.__proto__ || Object.getPrototypeOf(ReachFrequencyCurveLowerConfidenceRange)).apply(this, arguments));
  }

  createClass(ReachFrequencyCurveLowerConfidenceRange, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        impression_lower: 'impression_lower',
        num_points: 'num_points',
        reach: 'reach',
        reach_lower: 'reach_lower',
        uniq_video_views_2s_lower: 'uniq_video_views_2s_lower',
        video_views_2s_lower: 'video_views_2s_lower'
      });
    }
  }]);
  return ReachFrequencyCurveLowerConfidenceRange;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyCurveUpperConfidenceRange
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyCurveUpperConfidenceRange = function (_AbstractCrudObject) {
  inherits(ReachFrequencyCurveUpperConfidenceRange, _AbstractCrudObject);

  function ReachFrequencyCurveUpperConfidenceRange() {
    classCallCheck(this, ReachFrequencyCurveUpperConfidenceRange);
    return possibleConstructorReturn(this, (ReachFrequencyCurveUpperConfidenceRange.__proto__ || Object.getPrototypeOf(ReachFrequencyCurveUpperConfidenceRange)).apply(this, arguments));
  }

  createClass(ReachFrequencyCurveUpperConfidenceRange, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        impression_upper: 'impression_upper',
        num_points: 'num_points',
        reach: 'reach',
        reach_upper: 'reach_upper',
        uniq_video_views_2s_upper: 'uniq_video_views_2s_upper',
        video_views_2s_upper: 'video_views_2s_upper'
      });
    }
  }]);
  return ReachFrequencyCurveUpperConfidenceRange;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyDayPart
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyDayPart = function (_AbstractCrudObject) {
  inherits(ReachFrequencyDayPart, _AbstractCrudObject);

  function ReachFrequencyDayPart() {
    classCallCheck(this, ReachFrequencyDayPart);
    return possibleConstructorReturn(this, (ReachFrequencyDayPart.__proto__ || Object.getPrototypeOf(ReachFrequencyDayPart)).apply(this, arguments));
  }

  createClass(ReachFrequencyDayPart, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        days: 'days',
        end_minute: 'end_minute',
        start_minute: 'start_minute'
      });
    }
  }]);
  return ReachFrequencyDayPart;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyEstimatesCurve
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyEstimatesCurve = function (_AbstractCrudObject) {
  inherits(ReachFrequencyEstimatesCurve, _AbstractCrudObject);

  function ReachFrequencyEstimatesCurve() {
    classCallCheck(this, ReachFrequencyEstimatesCurve);
    return possibleConstructorReturn(this, (ReachFrequencyEstimatesCurve.__proto__ || Object.getPrototypeOf(ReachFrequencyEstimatesCurve)).apply(this, arguments));
  }

  createClass(ReachFrequencyEstimatesCurve, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        budget: 'budget',
        conversion: 'conversion',
        impression: 'impression',
        interpolated_reach: 'interpolated_reach',
        num_points: 'num_points',
        raw_impression: 'raw_impression',
        raw_reach: 'raw_reach',
        reach: 'reach'
      });
    }
  }]);
  return ReachFrequencyEstimatesCurve;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencyEstimatesPlacementBreakdown
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencyEstimatesPlacementBreakdown = function (_AbstractCrudObject) {
  inherits(ReachFrequencyEstimatesPlacementBreakdown, _AbstractCrudObject);

  function ReachFrequencyEstimatesPlacementBreakdown() {
    classCallCheck(this, ReachFrequencyEstimatesPlacementBreakdown);
    return possibleConstructorReturn(this, (ReachFrequencyEstimatesPlacementBreakdown.__proto__ || Object.getPrototypeOf(ReachFrequencyEstimatesPlacementBreakdown)).apply(this, arguments));
  }

  createClass(ReachFrequencyEstimatesPlacementBreakdown, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        android: 'android',
        audience_network: 'audience_network',
        desktop: 'desktop',
        ig_android: 'ig_android',
        ig_ios: 'ig_ios',
        ig_other: 'ig_other',
        ig_reels: 'ig_reels',
        ig_story: 'ig_story',
        instant_articles: 'instant_articles',
        instream_videos: 'instream_videos',
        ios: 'ios',
        msite: 'msite',
        suggested_videos: 'suggested_videos'
      });
    }
  }]);
  return ReachFrequencyEstimatesPlacementBreakdown;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ReachFrequencySpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ReachFrequencySpec = function (_AbstractCrudObject) {
  inherits(ReachFrequencySpec, _AbstractCrudObject);

  function ReachFrequencySpec() {
    classCallCheck(this, ReachFrequencySpec);
    return possibleConstructorReturn(this, (ReachFrequencySpec.__proto__ || Object.getPrototypeOf(ReachFrequencySpec)).apply(this, arguments));
  }

  createClass(ReachFrequencySpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        countries: 'countries',
        default_creation_data: 'default_creation_data',
        global_io_max_campaign_duration: 'global_io_max_campaign_duration',
        max_campaign_duration: 'max_campaign_duration',
        max_days_to_finish: 'max_days_to_finish',
        max_pause_without_prediction_rerun: 'max_pause_without_prediction_rerun',
        min_campaign_duration: 'min_campaign_duration',
        min_reach_limits: 'min_reach_limits'
      });
    }
  }]);
  return ReachFrequencySpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * RevSharePolicy
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var RevSharePolicy = function (_AbstractCrudObject) {
  inherits(RevSharePolicy, _AbstractCrudObject);

  function RevSharePolicy() {
    classCallCheck(this, RevSharePolicy);
    return possibleConstructorReturn(this, (RevSharePolicy.__proto__ || Object.getPrototypeOf(RevSharePolicy)).apply(this, arguments));
  }

  createClass(RevSharePolicy, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        policy_id: 'policy_id',
        policy_name: 'policy_name'
      });
    }
  }]);
  return RevSharePolicy;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * RichMediaElement
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var RichMediaElement = function (_AbstractCrudObject) {
  inherits(RichMediaElement, _AbstractCrudObject);

  function RichMediaElement() {
    classCallCheck(this, RichMediaElement);
    return possibleConstructorReturn(this, (RichMediaElement.__proto__ || Object.getPrototypeOf(RichMediaElement)).apply(this, arguments));
  }

  createClass(RichMediaElement, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        element: 'element',
        element_type: 'element_type',
        name: 'name'
      });
    }
  }]);
  return RichMediaElement;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * SavedMessageResponse
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var SavedMessageResponse = function (_AbstractCrudObject) {
  inherits(SavedMessageResponse, _AbstractCrudObject);

  function SavedMessageResponse() {
    classCallCheck(this, SavedMessageResponse);
    return possibleConstructorReturn(this, (SavedMessageResponse.__proto__ || Object.getPrototypeOf(SavedMessageResponse)).apply(this, arguments));
  }

  createClass(SavedMessageResponse, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        category: 'category',
        id: 'id',
        image: 'image',
        is_enabled: 'is_enabled',
        message: 'message',
        title: 'title'
      });
    }
  }]);
  return SavedMessageResponse;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * SecuritySettings
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var SecuritySettings = function (_AbstractCrudObject) {
  inherits(SecuritySettings, _AbstractCrudObject);

  function SecuritySettings() {
    classCallCheck(this, SecuritySettings);
    return possibleConstructorReturn(this, (SecuritySettings.__proto__ || Object.getPrototypeOf(SecuritySettings)).apply(this, arguments));
  }

  createClass(SecuritySettings, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({});
    }
  }]);
  return SecuritySettings;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ShopOrder
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ShopOrder = function (_AbstractCrudObject) {
  inherits(ShopOrder, _AbstractCrudObject);

  function ShopOrder() {
    classCallCheck(this, ShopOrder);
    return possibleConstructorReturn(this, (ShopOrder.__proto__ || Object.getPrototypeOf(ShopOrder)).apply(this, arguments));
  }

  createClass(ShopOrder, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        creation_time: 'creation_time',
        id: 'id'
      });
    }
  }]);
  return ShopOrder;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * SplitTestWinner
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var SplitTestWinner = function (_AbstractCrudObject) {
  inherits(SplitTestWinner, _AbstractCrudObject);

  function SplitTestWinner() {
    classCallCheck(this, SplitTestWinner);
    return possibleConstructorReturn(this, (SplitTestWinner.__proto__ || Object.getPrototypeOf(SplitTestWinner)).apply(this, arguments));
  }

  createClass(SplitTestWinner, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        ad_object_level: 'ad_object_level',
        confidences: 'confidences',
        winner_ad_object_id: 'winner_ad_object_id'
      });
    }
  }]);
  return SplitTestWinner;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * Targeting
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var Targeting = function (_AbstractCrudObject) {
  inherits(Targeting, _AbstractCrudObject);

  function Targeting() {
    classCallCheck(this, Targeting);
    return possibleConstructorReturn(this, (Targeting.__proto__ || Object.getPrototypeOf(Targeting)).apply(this, arguments));
  }

  createClass(Targeting, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        adgroup_id: 'adgroup_id',
        age_max: 'age_max',
        age_min: 'age_min',
        alternate_auto_targeting_option: 'alternate_auto_targeting_option',
        app_install_state: 'app_install_state',
        audience_network_positions: 'audience_network_positions',
        behaviors: 'behaviors',
        brand_safety_content_filter_levels: 'brand_safety_content_filter_levels',
        catalog_based_targeting: 'catalog_based_targeting',
        cities: 'cities',
        college_years: 'college_years',
        connections: 'connections',
        contextual_targeting_categories: 'contextual_targeting_categories',
        countries: 'countries',
        country: 'country',
        country_groups: 'country_groups',
        custom_audiences: 'custom_audiences',
        device_platforms: 'device_platforms',
        direct_install_devices: 'direct_install_devices',
        dynamic_audience_ids: 'dynamic_audience_ids',
        education_majors: 'education_majors',
        education_schools: 'education_schools',
        education_statuses: 'education_statuses',
        effective_audience_network_positions: 'effective_audience_network_positions',
        effective_device_platforms: 'effective_device_platforms',
        effective_facebook_positions: 'effective_facebook_positions',
        effective_instagram_positions: 'effective_instagram_positions',
        effective_messenger_positions: 'effective_messenger_positions',
        effective_publisher_platforms: 'effective_publisher_platforms',
        engagement_specs: 'engagement_specs',
        ethnic_affinity: 'ethnic_affinity',
        exclude_reached_since: 'exclude_reached_since',
        excluded_brand_safety_content_types: 'excluded_brand_safety_content_types',
        excluded_connections: 'excluded_connections',
        excluded_custom_audiences: 'excluded_custom_audiences',
        excluded_dynamic_audience_ids: 'excluded_dynamic_audience_ids',
        excluded_engagement_specs: 'excluded_engagement_specs',
        excluded_geo_locations: 'excluded_geo_locations',
        excluded_mobile_device_model: 'excluded_mobile_device_model',
        excluded_product_audience_specs: 'excluded_product_audience_specs',
        excluded_publisher_categories: 'excluded_publisher_categories',
        excluded_publisher_list_ids: 'excluded_publisher_list_ids',
        excluded_user_device: 'excluded_user_device',
        exclusions: 'exclusions',
        facebook_positions: 'facebook_positions',
        family_statuses: 'family_statuses',
        fb_deal_id: 'fb_deal_id',
        flexible_spec: 'flexible_spec',
        friends_of_connections: 'friends_of_connections',
        genders: 'genders',
        generation: 'generation',
        geo_locations: 'geo_locations',
        home_ownership: 'home_ownership',
        home_type: 'home_type',
        home_value: 'home_value',
        household_composition: 'household_composition',
        income: 'income',
        industries: 'industries',
        instagram_positions: 'instagram_positions',
        instream_video_skippable_excluded: 'instream_video_skippable_excluded',
        interested_in: 'interested_in',
        interests: 'interests',
        is_whatsapp_destination_ad: 'is_whatsapp_destination_ad',
        keywords: 'keywords',
        life_events: 'life_events',
        locales: 'locales',
        messenger_positions: 'messenger_positions',
        moms: 'moms',
        net_worth: 'net_worth',
        office_type: 'office_type',
        place_page_set_ids: 'place_page_set_ids',
        political_views: 'political_views',
        politics: 'politics',
        product_audience_specs: 'product_audience_specs',
        prospecting_audience: 'prospecting_audience',
        publisher_platforms: 'publisher_platforms',
        radius: 'radius',
        regions: 'regions',
        relationship_statuses: 'relationship_statuses',
        site_category: 'site_category',
        targeting_optimization: 'targeting_optimization',
        targeting_relaxation_types: 'targeting_relaxation_types',
        user_adclusters: 'user_adclusters',
        user_device: 'user_device',
        user_event: 'user_event',
        user_os: 'user_os',
        wireless_carrier: 'wireless_carrier',
        work_employers: 'work_employers',
        work_positions: 'work_positions',
        zips: 'zips'
      });
    }
  }, {
    key: 'DevicePlatforms',
    get: function get() {
      return Object.freeze({
        desktop: 'desktop',
        mobile: 'mobile'
      });
    }
  }, {
    key: 'EffectiveDevicePlatforms',
    get: function get() {
      return Object.freeze({
        desktop: 'desktop',
        mobile: 'mobile'
      });
    }
  }]);
  return Targeting;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingDynamicRule
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingDynamicRule = function (_AbstractCrudObject) {
  inherits(TargetingDynamicRule, _AbstractCrudObject);

  function TargetingDynamicRule() {
    classCallCheck(this, TargetingDynamicRule);
    return possibleConstructorReturn(this, (TargetingDynamicRule.__proto__ || Object.getPrototypeOf(TargetingDynamicRule)).apply(this, arguments));
  }

  createClass(TargetingDynamicRule, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        action_type: 'action.type',
        ad_group_id: 'ad_group_id',
        campaign_group_id: 'campaign_group_id',
        campaign_id: 'campaign_id',
        impression_count: 'impression_count',
        page_id: 'page_id',
        post: 'post',
        retention_seconds: 'retention_seconds'
      });
    }
  }]);
  return TargetingDynamicRule;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocation = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocation, _AbstractCrudObject);

  function TargetingGeoLocation() {
    classCallCheck(this, TargetingGeoLocation);
    return possibleConstructorReturn(this, (TargetingGeoLocation.__proto__ || Object.getPrototypeOf(TargetingGeoLocation)).apply(this, arguments));
  }

  createClass(TargetingGeoLocation, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        cities: 'cities',
        countries: 'countries',
        country_groups: 'country_groups',
        custom_locations: 'custom_locations',
        electoral_districts: 'electoral_districts',
        geo_markets: 'geo_markets',
        large_geo_areas: 'large_geo_areas',
        location_cluster_ids: 'location_cluster_ids',
        location_expansion: 'location_expansion',
        location_types: 'location_types',
        medium_geo_areas: 'medium_geo_areas',
        metro_areas: 'metro_areas',
        neighborhoods: 'neighborhoods',
        places: 'places',
        political_districts: 'political_districts',
        regions: 'regions',
        small_geo_areas: 'small_geo_areas',
        subcities: 'subcities',
        subneighborhoods: 'subneighborhoods',
        zips: 'zips'
      });
    }
  }]);
  return TargetingGeoLocation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationCity
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationCity = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationCity, _AbstractCrudObject);

  function TargetingGeoLocationCity() {
    classCallCheck(this, TargetingGeoLocationCity);
    return possibleConstructorReturn(this, (TargetingGeoLocationCity.__proto__ || Object.getPrototypeOf(TargetingGeoLocationCity)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationCity, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        distance_unit: 'distance_unit',
        key: 'key',
        name: 'name',
        radius: 'radius',
        region: 'region',
        region_id: 'region_id'
      });
    }
  }]);
  return TargetingGeoLocationCity;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationCustomLocation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationCustomLocation = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationCustomLocation, _AbstractCrudObject);

  function TargetingGeoLocationCustomLocation() {
    classCallCheck(this, TargetingGeoLocationCustomLocation);
    return possibleConstructorReturn(this, (TargetingGeoLocationCustomLocation.__proto__ || Object.getPrototypeOf(TargetingGeoLocationCustomLocation)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationCustomLocation, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        address_string: 'address_string',
        country: 'country',
        country_group: 'country_group',
        custom_type: 'custom_type',
        distance_unit: 'distance_unit',
        key: 'key',
        latitude: 'latitude',
        longitude: 'longitude',
        max_population: 'max_population',
        min_population: 'min_population',
        name: 'name',
        primary_city_id: 'primary_city_id',
        radius: 'radius',
        region_id: 'region_id'
      });
    }
  }]);
  return TargetingGeoLocationCustomLocation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationElectoralDistrict
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationElectoralDistrict = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationElectoralDistrict, _AbstractCrudObject);

  function TargetingGeoLocationElectoralDistrict() {
    classCallCheck(this, TargetingGeoLocationElectoralDistrict);
    return possibleConstructorReturn(this, (TargetingGeoLocationElectoralDistrict.__proto__ || Object.getPrototypeOf(TargetingGeoLocationElectoralDistrict)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationElectoralDistrict, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        electoral_district: 'electoral_district',
        key: 'key',
        name: 'name'
      });
    }
  }]);
  return TargetingGeoLocationElectoralDistrict;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationGeoEntities
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationGeoEntities = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationGeoEntities, _AbstractCrudObject);

  function TargetingGeoLocationGeoEntities() {
    classCallCheck(this, TargetingGeoLocationGeoEntities);
    return possibleConstructorReturn(this, (TargetingGeoLocationGeoEntities.__proto__ || Object.getPrototypeOf(TargetingGeoLocationGeoEntities)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationGeoEntities, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        key: 'key',
        name: 'name',
        region: 'region',
        region_id: 'region_id'
      });
    }
  }]);
  return TargetingGeoLocationGeoEntities;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationLocationCluster
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationLocationCluster = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationLocationCluster, _AbstractCrudObject);

  function TargetingGeoLocationLocationCluster() {
    classCallCheck(this, TargetingGeoLocationLocationCluster);
    return possibleConstructorReturn(this, (TargetingGeoLocationLocationCluster.__proto__ || Object.getPrototypeOf(TargetingGeoLocationLocationCluster)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationLocationCluster, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        key: 'key'
      });
    }
  }]);
  return TargetingGeoLocationLocationCluster;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationLocationExpansion
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationLocationExpansion = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationLocationExpansion, _AbstractCrudObject);

  function TargetingGeoLocationLocationExpansion() {
    classCallCheck(this, TargetingGeoLocationLocationExpansion);
    return possibleConstructorReturn(this, (TargetingGeoLocationLocationExpansion.__proto__ || Object.getPrototypeOf(TargetingGeoLocationLocationExpansion)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationLocationExpansion, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        allowed: 'allowed'
      });
    }
  }]);
  return TargetingGeoLocationLocationExpansion;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationMarket
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationMarket = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationMarket, _AbstractCrudObject);

  function TargetingGeoLocationMarket() {
    classCallCheck(this, TargetingGeoLocationMarket);
    return possibleConstructorReturn(this, (TargetingGeoLocationMarket.__proto__ || Object.getPrototypeOf(TargetingGeoLocationMarket)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationMarket, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        key: 'key',
        market_type: 'market_type',
        name: 'name'
      });
    }
  }]);
  return TargetingGeoLocationMarket;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationPlace
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationPlace = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationPlace, _AbstractCrudObject);

  function TargetingGeoLocationPlace() {
    classCallCheck(this, TargetingGeoLocationPlace);
    return possibleConstructorReturn(this, (TargetingGeoLocationPlace.__proto__ || Object.getPrototypeOf(TargetingGeoLocationPlace)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationPlace, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        distance_unit: 'distance_unit',
        key: 'key',
        latitude: 'latitude',
        longitude: 'longitude',
        name: 'name',
        primary_city_id: 'primary_city_id',
        radius: 'radius',
        region_id: 'region_id'
      });
    }
  }]);
  return TargetingGeoLocationPlace;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationPoliticalDistrict
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationPoliticalDistrict = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationPoliticalDistrict, _AbstractCrudObject);

  function TargetingGeoLocationPoliticalDistrict() {
    classCallCheck(this, TargetingGeoLocationPoliticalDistrict);
    return possibleConstructorReturn(this, (TargetingGeoLocationPoliticalDistrict.__proto__ || Object.getPrototypeOf(TargetingGeoLocationPoliticalDistrict)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationPoliticalDistrict, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        key: 'key',
        name: 'name',
        political_district: 'political_district'
      });
    }
  }]);
  return TargetingGeoLocationPoliticalDistrict;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationRegion
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationRegion = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationRegion, _AbstractCrudObject);

  function TargetingGeoLocationRegion() {
    classCallCheck(this, TargetingGeoLocationRegion);
    return possibleConstructorReturn(this, (TargetingGeoLocationRegion.__proto__ || Object.getPrototypeOf(TargetingGeoLocationRegion)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationRegion, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        key: 'key',
        name: 'name'
      });
    }
  }]);
  return TargetingGeoLocationRegion;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingGeoLocationZip
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingGeoLocationZip = function (_AbstractCrudObject) {
  inherits(TargetingGeoLocationZip, _AbstractCrudObject);

  function TargetingGeoLocationZip() {
    classCallCheck(this, TargetingGeoLocationZip);
    return possibleConstructorReturn(this, (TargetingGeoLocationZip.__proto__ || Object.getPrototypeOf(TargetingGeoLocationZip)).apply(this, arguments));
  }

  createClass(TargetingGeoLocationZip, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        country: 'country',
        key: 'key',
        name: 'name',
        primary_city_id: 'primary_city_id',
        region_id: 'region_id'
      });
    }
  }]);
  return TargetingGeoLocationZip;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingProductAudienceSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingProductAudienceSpec = function (_AbstractCrudObject) {
  inherits(TargetingProductAudienceSpec, _AbstractCrudObject);

  function TargetingProductAudienceSpec() {
    classCallCheck(this, TargetingProductAudienceSpec);
    return possibleConstructorReturn(this, (TargetingProductAudienceSpec.__proto__ || Object.getPrototypeOf(TargetingProductAudienceSpec)).apply(this, arguments));
  }

  createClass(TargetingProductAudienceSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        exclusions: 'exclusions',
        inclusions: 'inclusions',
        product_set_id: 'product_set_id'
      });
    }
  }]);
  return TargetingProductAudienceSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingProductAudienceSubSpec
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingProductAudienceSubSpec = function (_AbstractCrudObject) {
  inherits(TargetingProductAudienceSubSpec, _AbstractCrudObject);

  function TargetingProductAudienceSubSpec() {
    classCallCheck(this, TargetingProductAudienceSubSpec);
    return possibleConstructorReturn(this, (TargetingProductAudienceSubSpec.__proto__ || Object.getPrototypeOf(TargetingProductAudienceSubSpec)).apply(this, arguments));
  }

  createClass(TargetingProductAudienceSubSpec, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        retention_seconds: 'retention_seconds',
        rule: 'rule'
      });
    }
  }]);
  return TargetingProductAudienceSubSpec;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingProspectingAudience
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingProspectingAudience = function (_AbstractCrudObject) {
  inherits(TargetingProspectingAudience, _AbstractCrudObject);

  function TargetingProspectingAudience() {
    classCallCheck(this, TargetingProspectingAudience);
    return possibleConstructorReturn(this, (TargetingProspectingAudience.__proto__ || Object.getPrototypeOf(TargetingProspectingAudience)).apply(this, arguments));
  }

  createClass(TargetingProspectingAudience, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        sources: 'sources'
      });
    }
  }]);
  return TargetingProspectingAudience;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TargetingRelaxation
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TargetingRelaxation = function (_AbstractCrudObject) {
  inherits(TargetingRelaxation, _AbstractCrudObject);

  function TargetingRelaxation() {
    classCallCheck(this, TargetingRelaxation);
    return possibleConstructorReturn(this, (TargetingRelaxation.__proto__ || Object.getPrototypeOf(TargetingRelaxation)).apply(this, arguments));
  }

  createClass(TargetingRelaxation, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        custom_audience: 'custom_audience',
        lookalike: 'lookalike'
      });
    }
  }]);
  return TargetingRelaxation;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * TrackingAndConversionWithDefaults
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var TrackingAndConversionWithDefaults = function (_AbstractCrudObject) {
  inherits(TrackingAndConversionWithDefaults, _AbstractCrudObject);

  function TrackingAndConversionWithDefaults() {
    classCallCheck(this, TrackingAndConversionWithDefaults);
    return possibleConstructorReturn(this, (TrackingAndConversionWithDefaults.__proto__ || Object.getPrototypeOf(TrackingAndConversionWithDefaults)).apply(this, arguments));
  }

  createClass(TrackingAndConversionWithDefaults, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        custom_conversion: 'custom_conversion',
        custom_tracking: 'custom_tracking',
        default_conversion: 'default_conversion',
        default_tracking: 'default_tracking'
      });
    }
  }]);
  return TrackingAndConversionWithDefaults;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserCoverPhoto
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserCoverPhoto = function (_AbstractCrudObject) {
  inherits(UserCoverPhoto, _AbstractCrudObject);

  function UserCoverPhoto() {
    classCallCheck(this, UserCoverPhoto);
    return possibleConstructorReturn(this, (UserCoverPhoto.__proto__ || Object.getPrototypeOf(UserCoverPhoto)).apply(this, arguments));
  }

  createClass(UserCoverPhoto, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        offset_x: 'offset_x',
        offset_y: 'offset_y',
        source: 'source'
      });
    }
  }]);
  return UserCoverPhoto;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserDevice
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserDevice = function (_AbstractCrudObject) {
  inherits(UserDevice, _AbstractCrudObject);

  function UserDevice() {
    classCallCheck(this, UserDevice);
    return possibleConstructorReturn(this, (UserDevice.__proto__ || Object.getPrototypeOf(UserDevice)).apply(this, arguments));
  }

  createClass(UserDevice, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        hardware: 'hardware',
        os: 'os'
      });
    }
  }]);
  return UserDevice;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserLeadGenDisclaimerResponse
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserLeadGenDisclaimerResponse = function (_AbstractCrudObject) {
  inherits(UserLeadGenDisclaimerResponse, _AbstractCrudObject);

  function UserLeadGenDisclaimerResponse() {
    classCallCheck(this, UserLeadGenDisclaimerResponse);
    return possibleConstructorReturn(this, (UserLeadGenDisclaimerResponse.__proto__ || Object.getPrototypeOf(UserLeadGenDisclaimerResponse)).apply(this, arguments));
  }

  createClass(UserLeadGenDisclaimerResponse, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        checkbox_key: 'checkbox_key',
        is_checked: 'is_checked'
      });
    }
  }]);
  return UserLeadGenDisclaimerResponse;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserLeadGenFieldData
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserLeadGenFieldData = function (_AbstractCrudObject) {
  inherits(UserLeadGenFieldData, _AbstractCrudObject);

  function UserLeadGenFieldData() {
    classCallCheck(this, UserLeadGenFieldData);
    return possibleConstructorReturn(this, (UserLeadGenFieldData.__proto__ || Object.getPrototypeOf(UserLeadGenFieldData)).apply(this, arguments));
  }

  createClass(UserLeadGenFieldData, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        name: 'name',
        values: 'values'
      });
    }
  }]);
  return UserLeadGenFieldData;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * UserPaymentMobilePricepoints
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var UserPaymentMobilePricepoints = function (_AbstractCrudObject) {
  inherits(UserPaymentMobilePricepoints, _AbstractCrudObject);

  function UserPaymentMobilePricepoints() {
    classCallCheck(this, UserPaymentMobilePricepoints);
    return possibleConstructorReturn(this, (UserPaymentMobilePricepoints.__proto__ || Object.getPrototypeOf(UserPaymentMobilePricepoints)).apply(this, arguments));
  }

  createClass(UserPaymentMobilePricepoints, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        mobile_country: 'mobile_country',
        phone_number_last4: 'phone_number_last4',
        pricepoints: 'pricepoints',
        user_currency: 'user_currency'
      });
    }
  }]);
  return UserPaymentMobilePricepoints;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * ValueBasedEligibleSource
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var ValueBasedEligibleSource = function (_AbstractCrudObject) {
  inherits(ValueBasedEligibleSource, _AbstractCrudObject);

  function ValueBasedEligibleSource() {
    classCallCheck(this, ValueBasedEligibleSource);
    return possibleConstructorReturn(this, (ValueBasedEligibleSource.__proto__ || Object.getPrototypeOf(ValueBasedEligibleSource)).apply(this, arguments));
  }

  createClass(ValueBasedEligibleSource, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        title: 'title',
        type: 'type'
      });
    }
  }]);
  return ValueBasedEligibleSource;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoCopyrightConditionGroup
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoCopyrightConditionGroup = function (_AbstractCrudObject) {
  inherits(VideoCopyrightConditionGroup, _AbstractCrudObject);

  function VideoCopyrightConditionGroup() {
    classCallCheck(this, VideoCopyrightConditionGroup);
    return possibleConstructorReturn(this, (VideoCopyrightConditionGroup.__proto__ || Object.getPrototypeOf(VideoCopyrightConditionGroup)).apply(this, arguments));
  }

  createClass(VideoCopyrightConditionGroup, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        action: 'action',
        conditions: 'conditions',
        validity_status: 'validity_status'
      });
    }
  }]);
  return VideoCopyrightConditionGroup;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoCopyrightGeoGate
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoCopyrightGeoGate = function (_AbstractCrudObject) {
  inherits(VideoCopyrightGeoGate, _AbstractCrudObject);

  function VideoCopyrightGeoGate() {
    classCallCheck(this, VideoCopyrightGeoGate);
    return possibleConstructorReturn(this, (VideoCopyrightGeoGate.__proto__ || Object.getPrototypeOf(VideoCopyrightGeoGate)).apply(this, arguments));
  }

  createClass(VideoCopyrightGeoGate, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        excluded_countries: 'excluded_countries',
        included_countries: 'included_countries'
      });
    }
  }]);
  return VideoCopyrightGeoGate;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoCopyrightSegment
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoCopyrightSegment = function (_AbstractCrudObject) {
  inherits(VideoCopyrightSegment, _AbstractCrudObject);

  function VideoCopyrightSegment() {
    classCallCheck(this, VideoCopyrightSegment);
    return possibleConstructorReturn(this, (VideoCopyrightSegment.__proto__ || Object.getPrototypeOf(VideoCopyrightSegment)).apply(this, arguments));
  }

  createClass(VideoCopyrightSegment, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        duration_in_sec: 'duration_in_sec',
        media_type: 'media_type',
        start_time_in_sec: 'start_time_in_sec'
      });
    }
  }]);
  return VideoCopyrightSegment;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VideoUploadLimits
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VideoUploadLimits = function (_AbstractCrudObject) {
  inherits(VideoUploadLimits, _AbstractCrudObject);

  function VideoUploadLimits() {
    classCallCheck(this, VideoUploadLimits);
    return possibleConstructorReturn(this, (VideoUploadLimits.__proto__ || Object.getPrototypeOf(VideoUploadLimits)).apply(this, arguments));
  }

  createClass(VideoUploadLimits, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        length: 'length',
        size: 'size'
      });
    }
  }]);
  return VideoUploadLimits;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * VoipInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var VoipInfo = function (_AbstractCrudObject) {
  inherits(VoipInfo, _AbstractCrudObject);

  function VoipInfo() {
    classCallCheck(this, VoipInfo);
    return possibleConstructorReturn(this, (VoipInfo.__proto__ || Object.getPrototypeOf(VoipInfo)).apply(this, arguments));
  }

  createClass(VoipInfo, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        has_mobile_app: 'has_mobile_app',
        has_permission: 'has_permission',
        is_callable: 'is_callable',
        is_callable_webrtc: 'is_callable_webrtc',
        is_pushable: 'is_pushable',
        reason_code: 'reason_code',
        reason_description: 'reason_description'
      });
    }
  }]);
  return VoipInfo;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WebAppLink
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WebAppLink = function (_AbstractCrudObject) {
  inherits(WebAppLink, _AbstractCrudObject);

  function WebAppLink() {
    classCallCheck(this, WebAppLink);
    return possibleConstructorReturn(this, (WebAppLink.__proto__ || Object.getPrototypeOf(WebAppLink)).apply(this, arguments));
  }

  createClass(WebAppLink, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        should_fallback: 'should_fallback',
        url: 'url'
      });
    }
  }]);
  return WebAppLink;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WhatsAppBusinessProfile
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WhatsAppBusinessProfile = function (_AbstractCrudObject) {
  inherits(WhatsAppBusinessProfile, _AbstractCrudObject);

  function WhatsAppBusinessProfile() {
    classCallCheck(this, WhatsAppBusinessProfile);
    return possibleConstructorReturn(this, (WhatsAppBusinessProfile.__proto__ || Object.getPrototypeOf(WhatsAppBusinessProfile)).apply(this, arguments));
  }

  createClass(WhatsAppBusinessProfile, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }

    // $FlowFixMe : Support Generic Types

  }, {
    key: 'update',
    value: function update(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return get$1(WhatsAppBusinessProfile.prototype.__proto__ || Object.getPrototypeOf(WhatsAppBusinessProfile.prototype), 'update', this).call(this, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        name_verification: 'name_verification',
        whatsapp_business_api_data: 'whatsapp_business_api_data'
      });
    }
  }]);
  return WhatsAppBusinessProfile;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WindowsAppLink
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WindowsAppLink = function (_AbstractCrudObject) {
  inherits(WindowsAppLink, _AbstractCrudObject);

  function WindowsAppLink() {
    classCallCheck(this, WindowsAppLink);
    return possibleConstructorReturn(this, (WindowsAppLink.__proto__ || Object.getPrototypeOf(WindowsAppLink)).apply(this, arguments));
  }

  createClass(WindowsAppLink, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_id: 'app_id',
        app_name: 'app_name',
        package_family_name: 'package_family_name',
        url: 'url'
      });
    }
  }]);
  return WindowsAppLink;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WindowsPhoneAppLink
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WindowsPhoneAppLink = function (_AbstractCrudObject) {
  inherits(WindowsPhoneAppLink, _AbstractCrudObject);

  function WindowsPhoneAppLink() {
    classCallCheck(this, WindowsPhoneAppLink);
    return possibleConstructorReturn(this, (WindowsPhoneAppLink.__proto__ || Object.getPrototypeOf(WindowsPhoneAppLink)).apply(this, arguments));
  }

  createClass(WindowsPhoneAppLink, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        app_id: 'app_id',
        app_name: 'app_name',
        url: 'url'
      });
    }
  }]);
  return WindowsPhoneAppLink;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WoodhengePurchasedPAYGReceipt
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WoodhengePurchasedPAYGReceipt = function (_AbstractCrudObject) {
  inherits(WoodhengePurchasedPAYGReceipt, _AbstractCrudObject);

  function WoodhengePurchasedPAYGReceipt() {
    classCallCheck(this, WoodhengePurchasedPAYGReceipt);
    return possibleConstructorReturn(this, (WoodhengePurchasedPAYGReceipt.__proto__ || Object.getPrototypeOf(WoodhengePurchasedPAYGReceipt)).apply(this, arguments));
  }

  createClass(WoodhengePurchasedPAYGReceipt, [{
    key: 'get',
    value: function get(fields) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // $FlowFixMe : Support Generic Types
      return this.read(fields, params);
    }
  }], [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        id: 'id',
        number_of_subscriptions_purchased: 'number_of_subscriptions_purchased',
        purchase_time: 'purchase_time',
        user: 'user'
      });
    }
  }]);
  return WoodhengePurchasedPAYGReceipt;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 * 
 */
/**
 * WorkUserFrontline
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */

var WorkUserFrontline = function (_AbstractCrudObject) {
  inherits(WorkUserFrontline, _AbstractCrudObject);

  function WorkUserFrontline() {
    classCallCheck(this, WorkUserFrontline);
    return possibleConstructorReturn(this, (WorkUserFrontline.__proto__ || Object.getPrototypeOf(WorkUserFrontline)).apply(this, arguments));
  }

  createClass(WorkUserFrontline, null, [{
    key: 'Fields',
    get: function get() {
      return Object.freeze({
        has_access: 'has_access',
        is_frontline: 'is_frontline'
      });
    }
  }]);
  return WorkUserFrontline;
}(AbstractCrudObject);

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */

exports.FacebookAdsApi = FacebookAdsApi;
exports.FacebookAdsApiBatch = FacebookAdsApiBatch;
exports.AbstractCrudObject = AbstractCrudObject;
exports.APIRequest = APIRequest;
exports.APIResponse = APIResponse;
exports.CrashReporter = CrashReporter;
exports.Content = Content;
exports.CustomData = CustomData;
exports.EventRequest = EventRequest;
exports.EventResponse = EventResponse;
exports.ServerEvent = ServerEvent;
exports.UserData = UserData;
exports.ExtendedDeviceInfo = ExtendedDeviceInfo;
exports.AppData = AppData;
exports.DeliveryCategory = DeliveryCategory;
exports.HttpMethod = HttpMethod;
exports.HttpServiceClientConfig = HttpServiceClientConfig;
exports.HttpServiceInterface = HttpServiceInterface;
exports.BatchProcessor = BatchProcessor;
exports.ServerSideUtils = ServerSideUtils;
exports.SignalUserData = UserData$1;
exports.SignalContent = Content$1;
exports.SignalCustomData = CustomData$1;
exports.SignalEvent = Event$2;
exports.SignalEventRequest = EventRequest$1;
exports.AREffectsBatchStatus = AREffectsBatchStatus;
exports.Ad = Ad;
exports.AdAccount = AdAccount;
exports.AdAccountAdRulesHistory = AdAccountAdRulesHistory;
exports.AdAccountAdVolume = AdAccountAdVolume;
exports.AdAccountCustomAudience = AdAccountCustomAudience;
exports.AdAccountDefaultDestination = AdAccountDefaultDestination;
exports.AdAccountDefaultObjective = AdAccountDefaultObjective;
exports.AdAccountDeliveryEstimate = AdAccountDeliveryEstimate;
exports.AdAccountIosFourteenCampaignLimits = AdAccountIosFourteenCampaignLimits;
exports.AdAccountMatchedSearchApplicationsEdgeData = AdAccountMatchedSearchApplicationsEdgeData;
exports.AdAccountMaxBid = AdAccountMaxBid;
exports.AdAccountPromotableObjects = AdAccountPromotableObjects;
exports.AdAccountReachEstimate = AdAccountReachEstimate;
exports.AdAccountRecommendedCamapaignBudget = AdAccountRecommendedCamapaignBudget;
exports.AdAccountSubscribedApps = AdAccountSubscribedApps;
exports.AdAccountTargetingUnified = AdAccountTargetingUnified;
exports.AdAccountTrackingData = AdAccountTrackingData;
exports.AdAccountUser = AdAccountUser;
exports.AdActivity = AdActivity;
exports.AdAssetFeedSpec = AdAssetFeedSpec;
exports.AdAssetFeedSpecAssetLabel = AdAssetFeedSpecAssetLabel;
exports.AdAssetFeedSpecBody = AdAssetFeedSpecBody;
exports.AdAssetFeedSpecCaption = AdAssetFeedSpecCaption;
exports.AdAssetFeedSpecDescription = AdAssetFeedSpecDescription;
exports.AdAssetFeedSpecGroupRule = AdAssetFeedSpecGroupRule;
exports.AdAssetFeedSpecImage = AdAssetFeedSpecImage;
exports.AdAssetFeedSpecLinkURL = AdAssetFeedSpecLinkURL;
exports.AdAssetFeedSpecTitle = AdAssetFeedSpecTitle;
exports.AdAssetFeedSpecVideo = AdAssetFeedSpecVideo;
exports.AdAsyncRequest = AdAsyncRequest;
exports.AdAsyncRequestSet = AdAsyncRequestSet;
exports.AdAsyncRequestSetNotificationResult = AdAsyncRequestSetNotificationResult;
exports.AdBidAdjustments = AdBidAdjustments;
exports.AdCampaignBidConstraint = AdCampaignBidConstraint;
exports.AdCampaignDeliveryEstimate = AdCampaignDeliveryEstimate;
exports.AdCampaignDeliveryStatsUnsupportedReasons = AdCampaignDeliveryStatsUnsupportedReasons;
exports.AdCampaignFrequencyControlSpecs = AdCampaignFrequencyControlSpecs;
exports.AdCampaignIssuesInfo = AdCampaignIssuesInfo;
exports.AdCampaignLearningStageInfo = AdCampaignLearningStageInfo;
exports.AdCampaignOptimizationEvent = AdCampaignOptimizationEvent;
exports.AdCampaignPacedBidInfo = AdCampaignPacedBidInfo;
exports.AdCreative = AdCreative;
exports.AdCreativeAdDisclaimer = AdCreativeAdDisclaimer;
exports.AdCreativeCollectionThumbnailInfo = AdCreativeCollectionThumbnailInfo;
exports.AdCreativeDegreesOfFreedomSpec = AdCreativeDegreesOfFreedomSpec;
exports.AdCreativeInsights = AdCreativeInsights;
exports.AdCreativeInteractiveComponentsSpec = AdCreativeInteractiveComponentsSpec;
exports.AdCreativeLinkData = AdCreativeLinkData;
exports.AdCreativeLinkDataAppLinkSpec = AdCreativeLinkDataAppLinkSpec;
exports.AdCreativeLinkDataCallToAction = AdCreativeLinkDataCallToAction;
exports.AdCreativeLinkDataCallToActionValue = AdCreativeLinkDataCallToActionValue;
exports.AdCreativeLinkDataChildAttachment = AdCreativeLinkDataChildAttachment;
exports.AdCreativeLinkDataImageLayerSpec = AdCreativeLinkDataImageLayerSpec;
exports.AdCreativeLinkDataImageOverlaySpec = AdCreativeLinkDataImageOverlaySpec;
exports.AdCreativeLinkDataSponsorshipInfoSpec = AdCreativeLinkDataSponsorshipInfoSpec;
exports.AdCreativeLinkDataTemplateVideoSpec = AdCreativeLinkDataTemplateVideoSpec;
exports.AdCreativeObjectStorySpec = AdCreativeObjectStorySpec;
exports.AdCreativeOmnichannelLinkSpec = AdCreativeOmnichannelLinkSpec;
exports.AdCreativePhotoData = AdCreativePhotoData;
exports.AdCreativePhotoDataMediaElements = AdCreativePhotoDataMediaElements;
exports.AdCreativePlaceData = AdCreativePlaceData;
exports.AdCreativePlatformCustomization = AdCreativePlatformCustomization;
exports.AdCreativePortraitCustomizations = AdCreativePortraitCustomizations;
exports.AdCreativePostClickConfiguration = AdCreativePostClickConfiguration;
exports.AdCreativeRecommenderSettings = AdCreativeRecommenderSettings;
exports.AdCreativeStaticFallbackSpec = AdCreativeStaticFallbackSpec;
exports.AdCreativeTemplateURLSpec = AdCreativeTemplateURLSpec;
exports.AdCreativeTextData = AdCreativeTextData;
exports.AdCreativeVideoData = AdCreativeVideoData;
exports.AdCustomizationRuleSpec = AdCustomizationRuleSpec;
exports.AdDynamicCreative = AdDynamicCreative;
exports.AdEntityTargetSpend = AdEntityTargetSpend;
exports.AdImage = AdImage;
exports.AdKeywords = AdKeywords;
exports.AdLabel = AdLabel;
exports.AdMonetizationProperty = AdMonetizationProperty;
exports.AdNetworkAnalyticsAsyncQueryResult = AdNetworkAnalyticsAsyncQueryResult;
exports.AdNetworkAnalyticsSyncQueryResult = AdNetworkAnalyticsSyncQueryResult;
exports.AdPlacePageSet = AdPlacePageSet;
exports.AdPlacePageSetMetadata = AdPlacePageSetMetadata;
exports.AdPlacement = AdPlacement;
exports.AdPreview = AdPreview;
exports.AdPromotedObject = AdPromotedObject;
exports.AdRecommendation = AdRecommendation;
exports.AdRecommendationData = AdRecommendationData;
exports.AdReportRun = AdReportRun;
exports.AdRule = AdRule;
exports.AdRuleEvaluationSpec = AdRuleEvaluationSpec;
exports.AdRuleExecutionOptions = AdRuleExecutionOptions;
exports.AdRuleExecutionSpec = AdRuleExecutionSpec;
exports.AdRuleFilters = AdRuleFilters;
exports.AdRuleHistory = AdRuleHistory;
exports.AdRuleHistoryResult = AdRuleHistoryResult;
exports.AdRuleHistoryResultAction = AdRuleHistoryResultAction;
exports.AdRuleSchedule = AdRuleSchedule;
exports.AdRuleScheduleSpec = AdRuleScheduleSpec;
exports.AdRuleTrigger = AdRuleTrigger;
exports.AdSet = AdSet;
exports.AdStudy = AdStudy;
exports.AdStudyCell = AdStudyCell;
exports.AdStudyObjective = AdStudyObjective;
exports.AdStudyObjectiveID = AdStudyObjectiveID;
exports.AdStudyObjectiveOffsiteDatasets = AdStudyObjectiveOffsiteDatasets;
exports.AdVideo = AdVideo;
exports.AdgroupIssuesInfo = AdgroupIssuesInfo;
exports.AdgroupMetadata = AdgroupMetadata;
exports.AdgroupPlacementSpecificReviewFeedback = AdgroupPlacementSpecificReviewFeedback;
exports.AdgroupReviewFeedback = AdgroupReviewFeedback;
exports.AdsActionStats = AdsActionStats;
exports.AdsImageCrops = AdsImageCrops;
exports.AdsInsights = AdsInsights;
exports.AdsOptimalDeliveryGrowthOpportunity = AdsOptimalDeliveryGrowthOpportunity;
exports.AdsPixel = AdsPixel;
exports.AdsPixelStats = AdsPixelStats;
exports.AdsPixelStatsResult = AdsPixelStatsResult;
exports.AgeRange = AgeRange;
exports.AgencyClientDeclaration = AgencyClientDeclaration;
exports.Album = Album;
exports.AndroidAppLink = AndroidAppLink;
exports.AppRequest = AppRequest;
exports.AppRequestFormerRecipient = AppRequestFormerRecipient;
exports.Application = Application;
exports.AssignedUser = AssignedUser;
exports.AsyncRequest = AsyncRequest;
exports.AsyncSession = AsyncSession;
exports.AttributionSpec = AttributionSpec;
exports.AudiencePermissionForActions = AudiencePermissionForActions;
exports.AudioCopyright = AudioCopyright;
exports.AutomotiveModel = AutomotiveModel;
exports.BrandSafetyBlockListUsage = BrandSafetyBlockListUsage;
exports.BroadTargetingCategories = BroadTargetingCategories;
exports.Business = Business;
exports.BusinessAdAccountRequest = BusinessAdAccountRequest;
exports.BusinessApplicationRequest = BusinessApplicationRequest;
exports.BusinessAssetGroup = BusinessAssetGroup;
exports.BusinessAssetSharingAgreement = BusinessAssetSharingAgreement;
exports.BusinessImage = BusinessImage;
exports.BusinessManagedPartnerEligibility = BusinessManagedPartnerEligibility;
exports.BusinessOwnedObjectOnBehalfOfRequest = BusinessOwnedObjectOnBehalfOfRequest;
exports.BusinessPageRequest = BusinessPageRequest;
exports.BusinessPartnerPremiumOptions = BusinessPartnerPremiumOptions;
exports.BusinessRoleRequest = BusinessRoleRequest;
exports.BusinessUser = BusinessUser;
exports.CPASAdvertiserPartnershipRecommendation = CPASAdvertiserPartnershipRecommendation;
exports.CPASBusinessSetupConfig = CPASBusinessSetupConfig;
exports.CPASCollaborationRequest = CPASCollaborationRequest;
exports.CPASMerchantConfig = CPASMerchantConfig;
exports.CRMAddress = CRMAddress;
exports.Campaign = Campaign;
exports.CampaignGroupBrandConfiguration = CampaignGroupBrandConfiguration;
exports.CampaignGroupCollaborativeAdsPartnerInfo = CampaignGroupCollaborativeAdsPartnerInfo;
exports.Canvas = Canvas;
exports.CanvasAdSettings = CanvasAdSettings;
exports.CanvasBodyElement = CanvasBodyElement;
exports.CanvasCollectionThumbnail = CanvasCollectionThumbnail;
exports.CanvasDynamicSetting = CanvasDynamicSetting;
exports.CatalogBasedTargeting = CatalogBasedTargeting;
exports.CatalogItemAppLinks = CatalogItemAppLinks;
exports.CatalogItemAppealStatus = CatalogItemAppealStatus;
exports.CatalogItemChannelsToIntegrityStatus = CatalogItemChannelsToIntegrityStatus;
exports.CatalogSegmentAllMatchCountLaser = CatalogSegmentAllMatchCountLaser;
exports.CatalogSubVerticalList = CatalogSubVerticalList;
exports.ChatPlugin = ChatPlugin;
exports.CheckBatchRequestStatus = CheckBatchRequestStatus;
exports.ChildEvent = ChildEvent;
exports.CloudGame = CloudGame;
exports.CollaborativeAdsPartnerInfoListItem = CollaborativeAdsPartnerInfoListItem;
exports.CollaborativeAdsShareSettings = CollaborativeAdsShareSettings;
exports.Comment = Comment;
exports.CommerceMerchantSettings = CommerceMerchantSettings;
exports.CommerceMerchantSettingsSetupStatus = CommerceMerchantSettingsSetupStatus;
exports.CommerceMerchantTOSAcceptance = CommerceMerchantTOSAcceptance;
exports.CommerceOrder = CommerceOrder;
exports.CommerceOrderTransactionDetail = CommerceOrderTransactionDetail;
exports.CommercePayout = CommercePayout;
exports.CommerceSettings = CommerceSettings;
exports.ConnectionsTargeting = ConnectionsTargeting;
exports.ContextualBundlingSpec = ContextualBundlingSpec;
exports.ConversionActionQuery = ConversionActionQuery;
exports.CopyrightReferenceContainer = CopyrightReferenceContainer;
exports.CoverPhoto = CoverPhoto;
exports.CreativeHistory = CreativeHistory;
exports.CreditCard = CreditCard;
exports.CreditPartitionActionOptions = CreditPartitionActionOptions;
exports.Currency = Currency;
exports.CurrencyAmount = CurrencyAmount;
exports.CustomAudience = CustomAudience;
exports.CustomAudienceAdAccount = CustomAudienceAdAccount;
exports.CustomAudienceDataSource = CustomAudienceDataSource;
exports.CustomAudienceSession = CustomAudienceSession;
exports.CustomAudienceSharingStatus = CustomAudienceSharingStatus;
exports.CustomAudienceStatus = CustomAudienceStatus;
exports.CustomAudiencesTOS = CustomAudiencesTOS;
exports.CustomAudiencesharedAccountInfo = CustomAudiencesharedAccountInfo;
exports.CustomConversion = CustomConversion;
exports.CustomConversionStatsResult = CustomConversionStatsResult;
exports.CustomUserSettings = CustomUserSettings;
exports.DACheck = DACheck;
exports.DayPart = DayPart;
exports.DeliveryCheck = DeliveryCheck;
exports.DeliveryCheckExtraInfo = DeliveryCheckExtraInfo;
exports.DeliveryWindow = DeliveryWindow;
exports.Destination = Destination;
exports.DestinationCatalogSettings = DestinationCatalogSettings;
exports.DynamicPostChildAttachment = DynamicPostChildAttachment;
exports.DynamicPriceConfigByDate = DynamicPriceConfigByDate;
exports.Engagement = Engagement;
exports.EntityAtTextRange = EntityAtTextRange;
exports.Event = Event;
exports.EventSourceGroup = EventSourceGroup;
exports.Experience = Experience;
exports.ExtendedCredit = ExtendedCredit;
exports.ExtendedCreditAllocationConfig = ExtendedCreditAllocationConfig;
exports.ExtendedCreditInvoiceGroup = ExtendedCreditInvoiceGroup;
exports.ExternalEventSource = ExternalEventSource;
exports.FAMEExportConfig = FAMEExportConfig;
exports.FlexibleTargeting = FlexibleTargeting;
exports.Flight = Flight;
exports.FundingSourceDetails = FundingSourceDetails;
exports.FundingSourceDetailsCoupon = FundingSourceDetailsCoupon;
exports.FundraiserPersonToCharity = FundraiserPersonToCharity;
exports.GameItem = GameItem;
exports.Group = Group;
exports.HomeListing = HomeListing;
exports.Hotel = Hotel;
exports.HotelRoom = HotelRoom;
exports.IDName = IDName;
exports.IGBCAdsPermission = IGBCAdsPermission;
exports.IGComment = IGComment;
exports.IGMedia = IGMedia;
exports.IGUser = IGUser;
exports.ImageCopyright = ImageCopyright;
exports.InsightsResult = InsightsResult;
exports.InstagramInsightsResult = InstagramInsightsResult;
exports.InstagramInsightsValue = InstagramInsightsValue;
exports.InstagramUser = InstagramUser;
exports.InstantArticle = InstantArticle;
exports.InstantArticleInsightsQueryResult = InstantArticleInsightsQueryResult;
exports.InstantArticlesStats = InstantArticlesStats;
exports.IosAppLink = IosAppLink;
exports.JobsJob = JobsJob;
exports.KeyValue = KeyValue;
exports.Lead = Lead;
exports.LeadGenAppointmentBookingInfo = LeadGenAppointmentBookingInfo;
exports.LeadGenConditionalQuestionsGroupChoices = LeadGenConditionalQuestionsGroupChoices;
exports.LeadGenConditionalQuestionsGroupQuestions = LeadGenConditionalQuestionsGroupQuestions;
exports.LeadGenDraftQuestion = LeadGenDraftQuestion;
exports.LeadGenPostSubmissionCheckResult = LeadGenPostSubmissionCheckResult;
exports.LeadGenQuestion = LeadGenQuestion;
exports.LeadGenQuestionOption = LeadGenQuestionOption;
exports.LeadgenForm = LeadgenForm;
exports.LifeEvent = LifeEvent;
exports.Link = Link;
exports.LiveVideo = LiveVideo;
exports.LiveVideoAdBreakConfig = LiveVideoAdBreakConfig;
exports.LiveVideoError = LiveVideoError;
exports.LiveVideoInputStream = LiveVideoInputStream;
exports.LiveVideoRecommendedEncoderSettings = LiveVideoRecommendedEncoderSettings;
exports.LiveVideoTargeting = LiveVideoTargeting;
exports.LocalServiceBusiness = LocalServiceBusiness;
exports.Location = Location;
exports.LookalikeSpec = LookalikeSpec;
exports.MailingAddress = MailingAddress;
exports.ManagedPartnerBusiness = ManagedPartnerBusiness;
exports.MediaFingerprint = MediaFingerprint;
exports.MediaTitle = MediaTitle;
exports.MessagingFeatureReview = MessagingFeatureReview;
exports.MessagingFeatureStatus = MessagingFeatureStatus;
exports.MessengerDestinationPageWelcomeMessage = MessengerDestinationPageWelcomeMessage;
exports.MessengerProfile = MessengerProfile;
exports.MinimumBudget = MinimumBudget;
exports.MusicVideoCopyright = MusicVideoCopyright;
exports.NullNode = NullNode;
exports.OfflineConversionDataSet = OfflineConversionDataSet;
exports.OfflineConversionDataSetPermissions = OfflineConversionDataSetPermissions;
exports.OfflineConversionDataSetUpload = OfflineConversionDataSetUpload;
exports.OfflineConversionDataSetUsage = OfflineConversionDataSetUsage;
exports.OffsitePixel = OffsitePixel;
exports.OmegaCustomerTrx = OmegaCustomerTrx;
exports.OpenGraphContext = OpenGraphContext;
exports.OutcomePredictionPoint = OutcomePredictionPoint;
exports.Page = Page;
exports.PageCallToAction = PageCallToAction;
exports.PageCategory = PageCategory;
exports.PageChangeProposal = PageChangeProposal;
exports.PageCommerceEligibility = PageCommerceEligibility;
exports.PageParking = PageParking;
exports.PagePaymentOptions = PagePaymentOptions;
exports.PagePost = PagePost;
exports.PagePostExperiment = PagePostExperiment;
exports.PageRestaurantServices = PageRestaurantServices;
exports.PageRestaurantSpecialties = PageRestaurantSpecialties;
exports.PageSavedFilter = PageSavedFilter;
exports.PageSettings = PageSettings;
exports.PageStartInfo = PageStartInfo;
exports.PageThreadOwner = PageThreadOwner;
exports.PageUpcomingChange = PageUpcomingChange;
exports.PageUserMessageThreadLabel = PageUserMessageThreadLabel;
exports.PartnerStudy = PartnerStudy;
exports.PaymentEnginePayment = PaymentEnginePayment;
exports.PaymentPricepoints = PaymentPricepoints;
exports.PaymentSubscription = PaymentSubscription;
exports.Permission = Permission;
exports.Persona = Persona;
exports.Photo = Photo;
exports.Place = Place;
exports.PlaceTopic = PlaceTopic;
exports.PlatformImageSource = PlatformImageSource;
exports.PlayableContent = PlayableContent;
exports.Post = Post;
exports.Privacy = Privacy;
exports.PrivateLiftStudyInstance = PrivateLiftStudyInstance;
exports.ProductCatalog = ProductCatalog;
exports.ProductCatalogCategory = ProductCatalogCategory;
exports.ProductCatalogDataSource = ProductCatalogDataSource;
exports.ProductCatalogDiagnosticGroup = ProductCatalogDiagnosticGroup;
exports.ProductCatalogHotelRoomsBatch = ProductCatalogHotelRoomsBatch;
exports.ProductCatalogImageSettings = ProductCatalogImageSettings;
exports.ProductCatalogImageSettingsOperation = ProductCatalogImageSettingsOperation;
exports.ProductCatalogPricingVariablesBatch = ProductCatalogPricingVariablesBatch;
exports.ProductCatalogProductSetsBatch = ProductCatalogProductSetsBatch;
exports.ProductEventStat = ProductEventStat;
exports.ProductFeed = ProductFeed;
exports.ProductFeedMissingFeedItemReplacement = ProductFeedMissingFeedItemReplacement;
exports.ProductFeedRule = ProductFeedRule;
exports.ProductFeedRuleSuggestion = ProductFeedRuleSuggestion;
exports.ProductFeedSchedule = ProductFeedSchedule;
exports.ProductFeedUpload = ProductFeedUpload;
exports.ProductFeedUploadError = ProductFeedUploadError;
exports.ProductFeedUploadErrorReport = ProductFeedUploadErrorReport;
exports.ProductFeedUploadErrorSample = ProductFeedUploadErrorSample;
exports.ProductGroup = ProductGroup;
exports.ProductImage = ProductImage;
exports.ProductItem = ProductItem;
exports.ProductItemARData = ProductItemARData;
exports.ProductItemCommerceInsights = ProductItemCommerceInsights;
exports.ProductItemError = ProductItemError;
exports.ProductItemImporterAddress = ProductItemImporterAddress;
exports.ProductSet = ProductSet;
exports.ProductSetMetadata = ProductSetMetadata;
exports.ProductVariant = ProductVariant;
exports.Profile = Profile;
exports.ProfilePictureSource = ProfilePictureSource;
exports.PublisherBlockList = PublisherBlockList;
exports.RTBDynamicPost = RTBDynamicPost;
exports.RawCustomAudience = RawCustomAudience;
exports.ReachFrequencyActivity = ReachFrequencyActivity;
exports.ReachFrequencyAdFormat = ReachFrequencyAdFormat;
exports.ReachFrequencyCurveLowerConfidenceRange = ReachFrequencyCurveLowerConfidenceRange;
exports.ReachFrequencyCurveUpperConfidenceRange = ReachFrequencyCurveUpperConfidenceRange;
exports.ReachFrequencyDayPart = ReachFrequencyDayPart;
exports.ReachFrequencyEstimatesCurve = ReachFrequencyEstimatesCurve;
exports.ReachFrequencyEstimatesPlacementBreakdown = ReachFrequencyEstimatesPlacementBreakdown;
exports.ReachFrequencyPrediction = ReachFrequencyPrediction;
exports.ReachFrequencySpec = ReachFrequencySpec;
exports.Recommendation = Recommendation;
exports.RevSharePolicy = RevSharePolicy;
exports.RichMediaElement = RichMediaElement;
exports.SavedAudience = SavedAudience;
exports.SavedMessageResponse = SavedMessageResponse;
exports.SecuritySettings = SecuritySettings;
exports.ShadowIGMediaProductTags = ShadowIGMediaProductTags;
exports.Shop = Shop;
exports.ShopOrder = ShopOrder;
exports.SplitTestWinner = SplitTestWinner;
exports.StoreCatalogSettings = StoreCatalogSettings;
exports.SystemUser = SystemUser;
exports.Tab = Tab;
exports.Targeting = Targeting;
exports.TargetingDynamicRule = TargetingDynamicRule;
exports.TargetingGeoLocation = TargetingGeoLocation;
exports.TargetingGeoLocationCity = TargetingGeoLocationCity;
exports.TargetingGeoLocationCustomLocation = TargetingGeoLocationCustomLocation;
exports.TargetingGeoLocationElectoralDistrict = TargetingGeoLocationElectoralDistrict;
exports.TargetingGeoLocationGeoEntities = TargetingGeoLocationGeoEntities;
exports.TargetingGeoLocationLocationCluster = TargetingGeoLocationLocationCluster;
exports.TargetingGeoLocationLocationExpansion = TargetingGeoLocationLocationExpansion;
exports.TargetingGeoLocationMarket = TargetingGeoLocationMarket;
exports.TargetingGeoLocationPlace = TargetingGeoLocationPlace;
exports.TargetingGeoLocationPoliticalDistrict = TargetingGeoLocationPoliticalDistrict;
exports.TargetingGeoLocationRegion = TargetingGeoLocationRegion;
exports.TargetingGeoLocationZip = TargetingGeoLocationZip;
exports.TargetingProductAudienceSpec = TargetingProductAudienceSpec;
exports.TargetingProductAudienceSubSpec = TargetingProductAudienceSubSpec;
exports.TargetingProspectingAudience = TargetingProspectingAudience;
exports.TargetingRelaxation = TargetingRelaxation;
exports.TargetingSentenceLine = TargetingSentenceLine;
exports.TextWithEntities = TextWithEntities;
exports.TrackingAndConversionWithDefaults = TrackingAndConversionWithDefaults;
exports.URL = URL;
exports.UnifiedThread = UnifiedThread;
exports.User = User;
exports.UserCoverPhoto = UserCoverPhoto;
exports.UserDevice = UserDevice;
exports.UserIDForApp = UserIDForApp;
exports.UserIDForPage = UserIDForPage;
exports.UserLeadGenDisclaimerResponse = UserLeadGenDisclaimerResponse;
exports.UserLeadGenFieldData = UserLeadGenFieldData;
exports.UserPageOneTimeOptInTokenSettings = UserPageOneTimeOptInTokenSettings;
exports.UserPaymentMobilePricepoints = UserPaymentMobilePricepoints;
exports.ValueBasedEligibleSource = ValueBasedEligibleSource;
exports.Vehicle = Vehicle;
exports.VehicleOffer = VehicleOffer;
exports.VideoCopyright = VideoCopyright;
exports.VideoCopyrightConditionGroup = VideoCopyrightConditionGroup;
exports.VideoCopyrightGeoGate = VideoCopyrightGeoGate;
exports.VideoCopyrightRule = VideoCopyrightRule;
exports.VideoCopyrightSegment = VideoCopyrightSegment;
exports.VideoList = VideoList;
exports.VideoPoll = VideoPoll;
exports.VideoThumbnail = VideoThumbnail;
exports.VideoUploadLimits = VideoUploadLimits;
exports.VoipInfo = VoipInfo;
exports.WebAppLink = WebAppLink;
exports.WhatsAppBusinessAccount = WhatsAppBusinessAccount;
exports.WhatsAppBusinessProfile = WhatsAppBusinessProfile;
exports.WindowsAppLink = WindowsAppLink;
exports.WindowsPhoneAppLink = WindowsPhoneAppLink;
exports.WoodhengePurchasedPAYGReceipt = WoodhengePurchasedPAYGReceipt;
exports.WorkUserFrontline = WorkUserFrontline;

//# sourceMappingURL=cjs.js.map
